import type { MessageCatalog } from "./pt-BR";

/** Spanish product copy addresses the operator with formal "usted". */
export const es: MessageCatalog = {
  "calc.form.individualDiagnostic":
    "Sin un método de precio, este modo es un diagnóstico de tributos. El total fiscal no es el costo de caja de la compra ni el precio de publicación. Para calcular un precio de publicación solo con la adquisición, use Planilla y el modelo comercial. Las opciones de precio individual con TR consideran la venta y requieren las reglas de esa operación.",
  "research.resolution.supplierDeclarationCorrection":
    "Revise y corrija IPI e IPI Valor en las columnas N y O de la planilla del proveedor e importe el archivo nuevamente. Internet no puede modificar esta declaración del proveedor; esta corrección no requiere otra investigación de pago.",
  "wb.issue.MISSING_VALUE.required.title": "Falta un valor obligatorio: {field}",
  "wb.issue.MISSING_VALUE.required.hint":
    "Complete la celda obligatoria en la planilla original y vuelva a enviar el archivo. Esta fila no puede calcularse antes de corregirla; no se completa ningún valor por defecto.",
  "lotSim.file.addToQueue": "Agregar planillas a la cola",
  "rulesets.publish.rootImpact":
    "Esta es la primera publicación, sin una versión anterior para comparar. Revise el total de reglas y las propuestas incluidas; no hay recuento de adiciones o cambios respecto de una base anterior.",
  "rulesets.publish.rootBase": "Sin versión anterior",
  "rulesets.publish.comparison": "Comparación de versiones",
  "rulesets.publish.technicalImpact":
    "Entradas de la diferencia técnica (no son totales de reglas)",
  "lotOps.researchCalculated":
    "Los {count} resultados de esta ejecución se calcularon con reglas publicadas de la versión {version}. La revisión de otras evidencias de investigación no bloquea estos resultados guardados.",
  "research.publishedRule.separate":
    "Hay una regla publicada vinculada a esta investigación. El vínculo no certifica automáticamente las evidencias de la búsqueda ni modifica cálculos anteriores.",
  "research.publishedRule.open": "Ver regla publicada · {version}",
  "research.publishedRule.evidence": "Evidencias de esta investigación",
  "rulesets.publish.ruleImpact": "Cambios agrupados por regla",
  "rulesets.publish.unparsedImpact":
    "Hay cambios técnicos que no pudieron agruparse por regla. Los totales anteriores incluyen solo las reglas identificadas; revise también la diferencia técnica completa antes de publicar.",
  "jamerson.title": "Modelo comercial Jamerson",
  "jamerson.download": "Descargar modelo Excel",
  "jamerson.downloadHint":
    "Use este Excel con las 15 columnas en su orden original y los encabezados en la fila 1. El modelo está vacío y listo para sus productos.",
  "jamerson.uploadBody":
    "Envíe el modelo completo. Después confirme el proveedor, el régimen y el take rate de este lote antes de calcular la compra y el precio de publicación.",
  "jamerson.guide": "Cómo completar el precio y los datos fiscales",
  "jamerson.help.price.title": "Preço NF (Produtos) UNITÁRIO: mercancía con tributos incluidos",
  "jamerson.help.price.body":
    "Indique el precio de la mercancía por unidad comercial, antes de los adicionales de IPI y ST. El ICMS propio y PIS/COFINS ya están dentro de ese principal: el cálculo solo los desglosa, sin sumarlos otra vez.",
  "jamerson.help.ipi.title": "IPI y ST: adicionales separados del precio de la mercancía",
  "jamerson.field.supplierIpiRate": "Tasa de IPI declarada por el proveedor",
  "jamerson.field.supplierIpiAmount": "IPI declarado por el proveedor por unidad comercial",
  "jamerson.help.ipi.body":
    "Para industria, complete IPI con la tasa declarada (p. ej., 6,5% o 0,065) e IPI Valor con su importe por unidad comercial. Estos datos se revisan como declaración del proveedor. La ST aplicable se calcula por separado según la operación y su calificación fiscal.",
  "jamerson.help.origin.title": "N/ I es el origen de la mercancía; UF es la ruta",
  "jamerson.help.origin.body":
    "Complete N/ I en cada producto con Nacional, Importada o el código fiscal 0–8. UF ORIGEM y UF DESTINO son los estados de la compra, como MG y SP. Una UF no sustituye el origen fiscal del producto.",
  "jamerson.help.quantity.title": "Caixa y precio deben usar la misma unidad comercial",
  "jamerson.help.quantity.body":
    "Caixa indica cuántas unidades comerciales se compran al Preço NF informado. Declare la unidad abajo, por ejemplo CX o UN. El sistema multiplica precio por cantidad una vez; no convierte cajas en piezas automáticamente.",
  "jamerson.help.takeRate.title": "Take rate por lote, aplicado después del costo de adquisición",
  "jamerson.help.takeRate.body":
    "Indique el TR en pantalla, incluido 0% cuando esa sea su decisión. Precio de publicación = costo de adquisición ÷ (1 − TR). El costo incluye mercancía y adicionales de adquisición; los tributos de la futura venta dependen del comprador y quedan para otra etapa.",
  "jamerson.help.includedPrice.title": "Si su precio ya contiene IPI, ST o take rate",
  "jamerson.help.includedPrice.body":
    "Separe primero la composición con el proveedor y complete Preço NF solo con la mercancía. Registre el IPI en sus columnas y el TR en pantalla. Enviar el total incrementado como Preço NF sumaría los adicionales otra vez; no use ese total como principal.",
  "jamerson.required":
    "Obligatorios por producto: NCM, N/ I, UF ORIGEM, UF DESTINO, Caixa y Preço NF. Para industria, IPI e IPI Valor también son obligatorios, incluido cero cuando se declare.",
  "jamerson.optional":
    "Categoría, marca, familia, SKU, descripción, EAN y peso son metadatos y pueden quedar vacíos. Mantenga las 15 columnas aunque sus celdas estén vacías.",
  "jamerson.mappingLocked":
    "Modelo verificado: encabezados y columnas fijos; la ruta y el origen fiscal se leen de cada fila. Para corregir estos datos, ajuste el Excel y envíelo nuevamente.",
  "jamerson.supplier": "Proveedor de este lote",
  "jamerson.supplierRequired": "Seleccione industria o distribuidor",
  "jamerson.supplierHint":
    "Confirme un perfil válido para todas las filas. Si los productos tienen perfiles distintos, envíe lotes separados. Industria exige ambos campos de IPI por producto.",
  "jamerson.declarationHint":
    "El modelo declara precio por unidad comercial y mercancía antes de los adicionales de IPI/ST, sin ST retenida anteriormente. Confirme la unidad usada en Caixa y en el precio y el régimen de todas las filas. Si el precio contiene ST anterior, separe esa composición antes de usar el modelo.",
  "jamerson.takeRate.title": "Take rate de este lote",
  "jamerson.takeRate.hint":
    "Indique desde 0% hasta menos del 100%. No se presume un TR. El mismo porcentaje se aplica a todos los productos del lote.",
  "jamerson.takeRate.scope":
    "Publicación = costo de adquisición ÷ (1 − TR). Esta etapa calcula la compra para reventa; el destino y los tributos de la venta se tratarán cuando haya un comprador.",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.title":
    "La columna {column} no corresponde al modelo Jamerson",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.hint":
    "Descargue el modelo Excel de arriba y copie los productos sin renombrar, mover, duplicar ni añadir columnas. Mantenga los 15 encabezados en la fila 1. Corrija la columna indicada y envíelo nuevamente.",
  "wb.issue.TEMPLATE_SHEET_COUNT.title": "El modelo exige una única hoja de entrada visible",
  "wb.issue.TEMPLATE_SHEET_COUNT.hint":
    "Use el Excel descargado arriba con una única hoja completa y visible. Las hojas extra deben estar totalmente vacías; ocultar una hoja completa no lo resuelve. Guarde y envíelo nuevamente.",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.title":
    "La configuración no corresponde a las columnas fijas del modelo",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.hint":
    "Envíe nuevamente el modelo Excel descargado arriba. Mantenga los 15 encabezados en su orden original y la ruta de compra en cada fila; el mapeo se aplica automáticamente.",
  "argonAcceptance.title": "Aceptación sintética de Argon",
  "argonAcceptance.summary":
    "Prepare tres casos con datos sintéticos. La ejecución se realiza después mediante el flujo protegido.",
  "argonAcceptance.prepared": "Admisión registrada",
  "argonAcceptance.executionSeparate":
    "Admisión registrada. Consulte la ejecución en el flujo protegido.",
  "argonAcceptance.copyHelp": "Copie el ID para continuar mediante el flujo autorizado.",
  "argonAcceptance.available": "Saldo disponible para la prueba",
  "argonAcceptance.executionLimit": "Límite de esta ejecución",
  "argonAcceptance.campaign": "Campaña",
  "argonAcceptance.acceptanceId": "ID de aceptación",
  "argonAcceptance.unknown": "No disponible",
  "argonAcceptance.prepare": "Preparar aceptación",
  "argonAcceptance.preparing": "Preparando…",
  "argonAcceptance.retry": "Repetir la misma solicitud",
  "argonAcceptance.boundary":
    "Preparar no llama al modelo, cambia límites ni publica reglas fiscales.",
  "argonAcceptance.uncertain":
    "No se confirmó la preparación. Actualice el estado antes de repetir; un reintento manual mantiene la misma solicitud.",
  "argonAcceptance.contextChanged":
    "La campaña cambió mientras la preparación anterior seguía sin confirmar. Revise la solicitud anterior antes de preparar otra.",
  "argonAcceptance.status.CAN_ADMIT": "Disponible para preparar",
  "argonAcceptance.status.ALREADY_ADMITTED": "Admisión registrada",
  "argonAcceptance.status.MAINTENANCE": "En mantenimiento",
  "argonAcceptance.status.RESEARCH_DISABLED": "Investigación sin configurar",
  "argonAcceptance.status.RESEARCH_PAUSED": "Investigación pausada",
  "argonAcceptance.status.NO_VERIFIED_CAMPAIGN": "Espera una campaña verificada",
  "argonAcceptance.status.BUDGET_UNAVAILABLE": "Preparación no disponible",
  "argonAcceptance.reason.CAN_ADMIT":
    "Hay una campaña verificada disponible para preparar la solicitud.",
  "argonAcceptance.reason.ALREADY_ADMITTED":
    "Ya existe una admisión. Consulte la ejecución en el flujo protegido.",
  "argonAcceptance.reason.MAINTENANCE":
    "La preparación está bloqueada durante el mantenimiento. Actualice el estado cuando termine.",
  "argonAcceptance.reason.RESEARCH_DISABLED":
    "La investigación aún no está configurada para este entorno.",
  "argonAcceptance.reason.RESEARCH_PAUSED":
    "La investigación está pausada. La preparación permanece bloqueada.",
  "argonAcceptance.reason.NO_VERIFIED_CAMPAIGN":
    "No hay una campaña verificada disponible para esta solicitud.",
  "argonAcceptance.reason.BUDGET_UNAVAILABLE":
    "No se puede preparar otra solicitud con la campaña actual. Revise su saldo y las reservas existentes.",

  "common.costPending": "Pendiente",
  "research.blocked.ARGON_COST_BOUND_UNAVAILABLE":
    "El costo de búsqueda con IA está pendiente. IOB determinista puede continuar.",
  "research.deferral.ARGON_COST_BOUND_UNAVAILABLE":
    "La investigación automática espera una estimación de costo.",
  "research.lanes.unavailable.UNQUALIFIED": "La búsqueda con IA espera una estimación de costo.",
  "productImages.activation.ARGON_COST_BOUND_UNAVAILABLE":
    "El costo de búsqueda con IA está pendiente. Este plan sigue pausado.",
  "webResearch.preview.costPending":
    "El costo de búsqueda con IA está pendiente. Revise el plan; el trabajo pagado sigue bloqueado.",
  "productImages.candidateStatus.PENDING_REVIEW": "Pendiente de revisión",
  "productImages.candidateStatus.REVIEWED_ACCEPTED_CANDIDATE": "Candidata aceptada en revisión",
  "productImages.candidateStatus.REVIEWED_REJECTED": "Candidata rechazada",
  "productImages.originalGtin": "GTIN original del catálogo",
  "productImages.reviewedGtin": "GTIN revisado",
  "productImages.reviewedVariant": "Variante revisada",
  "productImages.reviewedSize": "Tamaño o contenido revisado",
  "productImages.reviewedPackaging": "Envase revisado",
  "productImages.identityReviewId": "Identificador de revisión de identidad",
  "productImages.openIdentityEvidence": "Abrir evidencia pública de identidad",
  "productImages.identityOriginalPreserved":
    "Esta revisión conserva el GTIN original, no cambia la clasificación fiscal ni publica una imagen.",
  "productImages.reviewIdentity": "Revisar identidad para búsqueda de imagen",
  "productImages.identityReviewHelp":
    "Registre una decisión humana basada en una fuente pública para este producto y revisión. Indique variante, tamaño y envase exactos; el nombre o la marca por sí solos no establecen la identidad.",
  "productImages.gtinCheckHint":
    "Use 8, 12, 13 o 14 dígitos, con dígito de control válido. No se corregirá automáticamente.",
  "productImages.identityEvidenceUrl": "Fuente pública de identidad (HTTPS)",
  "productImages.identityEvidenceConfirmation":
    "Verifiqué el GTIN, la variante, el tamaño y el envase con la fuente pública indicada. Esta decisión es específica de este producto y no representa aprobación fiscal.",
  "productImages.invalidIdentityReview":
    "Revise el GTIN y su dígito de control, la variante, el tamaño, el envase, la URL pública HTTPS y el motivo de al menos 10 caracteres.",
  "productImages.identityReviewRecorded":
    "Revisión de identidad registrada. Selecciónela explícitamente al preparar una nueva búsqueda.",
  "productImages.recordIdentityReview": "Registrar revisión de identidad",
  "productImages.identityReviews": "Identidad pública revisada",
  "productImages.pinnedIdentity": "Identidad fijada en esta búsqueda",
  "productImages.noPinnedIdentity":
    "No hay una revisión de identidad fijada a la búsqueda actual. Los datos originales insuficientes mantienen el producto pendiente.",
  "productImages.identityReviewHistory": "Ver revisiones registradas de este producto",
  "productImages.selectedIdentity": "Identidad usada en la nueva búsqueda",
  "productImages.originalIdentity": "Usar datos originales del catálogo",
  "productImages.selectIdentityHelp":
    "Una revisión registrada solo se usará si se selecciona aquí. Los datos ausentes o en conflicto siguen pendientes; no hay asociación automática.",
  "webResearch.kind.LOCATE_APPLIANCE_PRODUCT": "Localizar identidad pública del producto",
  "webResearch.scope.APPLIANCE_PRODUCTS.short": "Productos sin NCM",
  "webResearch.kind.LOCATE_PRODUCT_IMAGE": "Localizar imagen pública de producto",
  "webResearch.scope.PRODUCT_IMAGES.short":
    "Imágenes públicas de productos · flujo separado de investigación fiscal",

  // Public image research: candidate-only overlay, explicit rights review, no publication.
  "productImages.title": "Imágenes de productos",
  "productImages.currentPreserved":
    "La imagen del catálogo se conserva. Las ilustraciones generadas y los candidatos de búsqueda nunca la reemplazan.",
  "productImages.scope":
    "Genere ilustraciones sintéticas claramente identificadas o consulte candidatos públicos. Ninguna opción cambia la imagen del catálogo ni aprueba datos fiscales.",
  "productImages.generateIllustrations": "Generar ilustraciones de productos",
  "productImages.generateIllustrationsHelp":
    "Crea ilustraciones sintéticas de categoría con Vertex Imagen. No busca en la web ni requiere revisión humana por producto. La imagen original del catálogo no cambia; la ilustración no demuestra la identidad exacta del SKU. Para ejecutarla se necesita una campaña verificada y se mantienen todos los límites de gasto.",
  "productImages.illustrationCount": "Cantidad de ilustraciones",
  "productImages.illustrationCountHelp":
    "Las primeras N filas aptas sin ilustración guardada ni intento pagado pendiente, ordenadas por el ID estable del producto. El valor inicial selecciona las primeras 100.",
  "productImages.illustrationMaximumCost": "Costo máximo del modelo (USD)",
  "productImages.illustrationPrice":
    "Costo del modelo: USD 0,02 por imagen; el almacenamiento y la transferencia se cobran aparte.",
  "productImages.illustrationCostConfirmation":
    "Autorizo un costo máximo de {amount} para este lote.",
  "productImages.invalidIllustrationJob":
    "Ingrese un número entero entre 1 y 50.000 y confirme el costo máximo mostrado.",
  "productImages.illustrationJobRecorded":
    "Trabajo de ilustración registrado. La generación comienza solo cuando la campaña verificada y los límites de gasto lo permitan.",
  "productImages.queueIllustrations": "Encolar ilustraciones",
  "productImages.syntheticIllustrationLabel": "Ilustración de producto generada por IA",
  "productImages.syntheticIllustrationDisclosure":
    "Solo ilustrativa; no es una foto del producto exacto ni demuestra la identidad del SKU. La imagen del catálogo no cambia.",
  "productImages.syntheticIllustrationAlt": "Ilustración sintética de una categoría de producto",
  "productImages.illustrationUnavailable": "No se pudo cargar la ilustración guardada.",
  "productImages.illustrationLoading": "Cargando ilustración generada…",
  "productImages.jobMode": "Tipo de trabajo",
  "productImages.jobMode.SEARCH": "Búsqueda de imágenes públicas",
  "productImages.jobMode.GENERATE_ILLUSTRATION": "Generación de ilustración sintética",
  "productImages.organizationRequired":
    "Esta consulta requiere una única organización autorizada en la sesión. Solicite el contexto correcto al administrador.",
  "productImages.createJob": "Preparar búsqueda de este producto",
  "productImages.createPausedHelp":
    "Preparar registra una búsqueda pausada de esta revisión. La ejecución requiere activación explícita, campaña de presupuesto verificada y servicio habilitado.",
  "productImages.budgetUsd": "Límite de búsqueda (USD)",
  "productImages.budgetHint":
    "Use punto decimal. El límite no representa gasto confirmado ni garantiza una cantidad de imágenes.",
  "productImages.callLimit": "Límite de llamadas de búsqueda",
  "productImages.officialHosts": "Dominios oficiales acreditados (opcional)",
  "productImages.hostsHint":
    "Hasta 20 dominios, separados por línea o coma. Indique solo dominios cuya relación con el fabricante se verificó; la marca no demuestra esa relación.",
  "productImages.identityReviewRef": "Referencia de revisión de la identidad pública",
  "productImages.identityReviewReason": "Justificación de la identidad pública",
  "productImages.publicIdentityConfirmation":
    "He revisado y confirmo que el nombre, la marca, el GTIN y los atributos seleccionados pueden usarse en consultas a fuentes públicas.",
  "productImages.invalidJob":
    "Compruebe el presupuesto positivo, el límite de llamadas, los dominios y la referencia y justificación de revisión (mínimo de 10 caracteres).",
  "productImages.jobRecorded":
    "Búsqueda registrada. Compruebe el estado de activación; este registro no implica ningún resultado de imagen.",
  "productImages.recordPausedJob": "Registrar búsqueda pausada",
  "productImages.saving": "Registrando…",
  "productImages.writeUnconfirmed":
    "La respuesta no fue confirmada. Los datos y la clave de solicitud se conservan; repetir usa la misma acción, sin crear otra solicitud.",
  "productImages.retrySame": "Repetir la misma solicitud",
  "productImages.resumeJob": "Vincular campaña y reanudar",
  "productImages.resumeHelp":
    "Reanudar puede ejecutar consultas pagadas cuando los controles del servidor lo permitan. Requiere una campaña verificada; no aumenta el presupuesto ni libera costes desconocidos.",
  "productImages.costReviewHelp":
    "Un intento de imagen pagado tiene un resultado financiero sin resolver o un recurso que no se guardó. Este producto queda retenido; reintentar no repite el cargo ni libera esa reserva.",
  "productImages.campaignId": "Campaña de presupuesto verificada",
  "productImages.resumeReason": "Justificación para reanudar",
  "productImages.resumeConfirmation":
    "Confirmo que la campaña se verificó y autorizo la reanudación dentro de los límites registrados y controles del servidor.",
  "productImages.invalidResume":
    "Indique el identificador válido de la campaña y una justificación de al menos 10 caracteres.",
  "productImages.resumeRecorded":
    "Solicitud de reanudación registrada. El estado de búsqueda indica si se habilitó la ejecución.",
  "productImages.confirmResume": "Confirmar campaña y reanudar",
  "productImages.newTab": "Abre en una pestaña nueva",
  "productImages.notEstablished": "No establecido",
  "productImages.candidateTitle": "Candidato {number}",
  "productImages.candidateUnpublished":
    "Candidato para revisión; no sustituye ni publica la imagen del producto.",
  "productImages.publicIdentity": "Identidad encontrada en la fuente pública",
  "productImages.confidence": "Confianza indicada por la búsqueda",
  "productImages.confidence.EXACT": "Correspondencia indicada como exacta",
  "productImages.confidence.PARTIAL": "Correspondencia parcial",
  "productImages.confidence.UNCERTAIN": "Correspondencia incierta",
  "productImages.matchField.gtin": "Correspondencia de GTIN",
  "productImages.matchField.variant": "Correspondencia de variante",
  "productImages.matchField.size": "Correspondencia de tamaño",
  "productImages.matchField.packaging": "Correspondencia del embalaje",
  "productImages.match.EXACT": "Exacta (indicada)",
  "productImages.match.MISMATCH": "Diferente",
  "productImages.match.NOT_ESTABLISHED": "No establecida",
  "productImages.sourceKind": "Tipo de fuente declarado",
  "productImages.sourceKind.OFFICIAL_MANUFACTURER": "Indicada como fuente oficial del fabricante",
  "productImages.sourceKind.OTHER_PUBLIC": "Otra fuente pública",
  "productImages.httpVerification": "Verificación de página e imagen",
  "productImages.http.PUBLIC_HTTP_VERIFIED": "Recepciones HTTP públicas registradas",
  "productImages.http.NOT_VERIFIED": "No verificada",
  "productImages.openSource": "Abrir página de la fuente pública",
  "productImages.openPublicImage": "Abrir imagen en la fuente pública",
  "productImages.noQuote": "Sin extracto de evidencia registrado",
  "productImages.sourceRights": "Alegación de uso de la fuente",
  "productImages.rights.UNKNOWN":
    "Derechos de uso desconocidos. Encontrar una imagen públicamente no concede una licencia.",
  "productImages.rights.SOURCE_LICENSE_CLAIM":
    "La fuente declara una licencia; esta alegación aún requiere revisión humana independiente.",
  "productImages.openRightsClaim": "Abrir evidencia de la alegación",
  "productImages.reviewRecorded": "Revisión del candidato registrada",
  "productImages.reviewDecision": "Decisión sobre el candidato",
  "productImages.reviewDecision.ACCEPT_CANDIDATE": "Aceptar como candidato, sin publicar",
  "productImages.reviewDecision.REJECT_CANDIDATE": "Rechazar candidato",
  "productImages.reviewReason": "Justificación de la revisión",
  "productImages.reviewedAt": "Revisado el",
  "productImages.reviewer": "Responsable de la revisión",
  "productImages.license": "Licencia o autorización de uso revisada",
  "productImages.scopeOfUse": "Ámbito de uso autorizado",
  "productImages.rightsEvidenceUrl": "URL de evidencia de revisión de uso",
  "productImages.openReviewedRights": "Abrir evidencia revisada de uso",
  "productImages.reviewNotPublication":
    "La decisión permanece como revisión de candidato. No se publicó ni sustituyó ninguna imagen.",
  "productImages.reviewCandidate": "Revisar candidato y evidencia de uso",
  "productImages.acceptBlocked":
    "Aceptar requiere GTIN único, correspondencia exacta de GTIN, variante, tamaño y embalaje, confianza exacta y verificación HTTP. Las incertidumbres siguen pendientes.",
  "productImages.chooseDecision": "Seleccionar decisión",
  "productImages.reviewConfirmation":
    "Revisé la identidad y la autorización de uso. Esta decisión acepta solo el candidato y no publica la imagen.",
  "productImages.invalidReview":
    "Compruebe la decisión, la justificación (mínimo de 10 caracteres) y, para aceptar, la evidencia pública, licencia y ámbito de uso.",
  "productImages.recordReview": "Registrar revisión del candidato",
  "productImages.candidateAudit": "Procedencia y recibos del candidato",
  "productImages.candidateId": "Identificador del candidato",
  "productImages.identityHash": "SHA-256 de la identidad fijada",
  "productImages.candidateCreatedAt": "Candidato registrado el",
  "productImages.retrievedAt": "Fuentes recuperadas el",
  "productImages.imageHash": "SHA-256 de la imagen",
  "productImages.pageHash": "SHA-256 de la página",
  "productImages.imageBytes": "Bytes de imagen verificada",
  "productImages.imageType": "Formato de imagen verificado",
  "productImages.targetStatus": "Estado de este producto",
  "productImages.targetStatus.PENDING": "Pendiente",
  "productImages.targetStatus.IN_PROGRESS": "En búsqueda",
  "productImages.targetStatus.DONE": "Búsqueda completada; publicación separada",
  "productImages.targetStatus.FAILED": "Búsqueda interrumpida",
  "productImages.targetStatus.BLOCKED_IDENTITY": "Identidad pendiente",
  "productImages.checkpoint": "Resultado de búsqueda conservado",
  "productImages.checkpointRetained": "Recibo duradero disponible",
  "productImages.noCheckpoint": "Sin recibo confirmado",
  "productImages.targetFailed":
    "La búsqueda de este producto se interrumpió. Compruebe el estado y los recibos antes de solicitar otro intento.",
  "productImages.noJob": "No hay búsqueda de imágenes registrada para este producto y revisión.",
  "productImages.candidates": "Candidatos de búsqueda",
  "productImages.noCandidates": "Ningún candidato confirmado",
  "productImages.noCandidatesHelp":
    "Una búsqueda pendiente, bloqueada o sin resultado no significa que la imagen se haya encontrado o calificado.",
  "productImages.overlayAudit": "Identidad y estado conservados",
  "productImages.targetErrorCode": "Código técnico de interrupción",
  "productImages.jobTitle": "Búsqueda registrada",
  "productImages.jobStatus.BLOCKED": "Bloqueada",
  "productImages.jobStatus.PENDING": "Pendiente",
  "productImages.jobStatus.IN_PROGRESS": "En ejecución",
  "productImages.jobStatus.COMPLETED": "Completada, sin publicación",
  "productImages.jobStatus.PARTIAL": "Resultado parcial",
  "productImages.jobCreatedAt": "Búsqueda registrada el",
  "productImages.jobProgress": "Estado de toda la búsqueda",
  "productImages.jobProgressValue":
    "{done} completados · {pending} pendientes · {failed} interrumpidos · {total} productos en total",
  "productImages.jobCountsScope":
    "Los totales corresponden a toda la búsqueda. El estado de este producto se muestra por separado.",
  "productImages.jobAudit": "Identificadores de búsqueda",
  "productImages.jobId": "Identificador de búsqueda",
  "productImages.sweepId": "Identificador de ejecución",
  "productImages.activation.FEATURE_DISABLED":
    "La búsqueda de imágenes está desactivada en este entorno. Los resultados registrados siguen disponibles.",
  "productImages.activation.BUDGET_CAMPAIGN_REQUIRED":
    "Aún debe vincularse una campaña de presupuesto verificada.",
  "productImages.activation.CAMPAIGN_UNAVAILABLE":
    "La campaña vinculada no está disponible o no fue verificada.",
  "productImages.activation.SWEEP_PAUSED": "La ejecución está pausada.",
  "productImages.activation.BUDGET_EXHAUSTED":
    "Se agotó el presupuesto disponible; reanudar no aumenta el límite.",
  "productImages.activation.IDENTITY_REVIEW_REQUIRED":
    "La identidad pública aún requiere revisión explícita.",
  "productImages.activation.IMAGE_MODEL_PRICE_UNQUALIFIED":
    "El precio del modelo Imagen no está calificado para esta campaña.",
  "productImages.activation.PRODUCT_NAME_REQUIRED":
    "Se necesita un nombre de producto para generar una ilustración.",
  "productImages.issue.MISSING_GTIN": "Falta el GTIN; la imagen sigue pendiente.",
  "productImages.issue.GTIN_CONFLICT":
    "GTIN compartido o duplicado; no hay asociación automática de imagen.",
  "productImages.issue.MISSING_PUBLIC_NAME": "Nombre público no establecido para la consulta.",
  "productImages.issue.VARIANT_NOT_ESTABLISHED": "Aún no se estableció la variante exacta.",
  "productImages.issue.SIZE_NOT_ESTABLISHED": "Aún no se estableció el tamaño exacto.",
  "productImages.issue.PACKAGING_NOT_ESTABLISHED": "Aún no se estableció el embalaje exacto.",
  "productImages.issue.NO_PUBLIC_CANDIDATE":
    "No se encontró ningún candidato público en este intento.",
  "productImages.issue.UNSAFE_URL": "Los controles de fuente pública rechazaron una URL.",
  "productImages.issue.HTTP_VERIFICATION_FAILED":
    "No se pudo confirmar la recepción de la página o imagen pública.",
  "productImages.issue.RIGHTS_EVIDENCE_REQUIRED":
    "Aún se necesita evidencia de autorización de uso.",
  "productImages.issue.MANUFACTURER_NOT_ESTABLISHED":
    "No se estableció la relación con el fabricante.",
  "productImages.issue.EXISTING_IMAGE_PRESERVED": "La imagen existente se conserva.",

  // Product catalog: immutable source revisions, declarations and explicit supplier SKU maps.
  "productCatalog.title": "Productos",
  "productCatalog.description":
    "Consulte el catálogo, sus revisiones de origen y las declaraciones de proveedores.",
  "productCatalog.product": "Producto",
  "productCatalog.catalog": "Catálogo",
  "productCatalog.chooseCatalog": "Seleccionar catálogo",
  "productCatalog.internalCode": "Código interno",
  "productCatalog.brand": "Marca declarada",
  "productCatalog.gtin": "GTIN / EAN",
  "productCatalog.classification": "Clasificación",
  "productCatalog.declared": "Datos declarados en origen",
  "productCatalog.reviewed": "Clasificación revisada",
  "productCatalog.unreviewed": "Clasificación aún no revisada",
  "productCatalog.scope":
    "El catálogo conserva datos declarados de productos. Revisar la clasificación no califica reglas fiscales, precios ni condiciones tributarias del proveedor.",
  "productCatalog.classificationScope":
    "Los valores originales se conservan. Una revisión de NCM/CEST es independiente de la calificación de las reglas, la operación y las partes.",
  "productCatalog.searchLabel": "Buscar productos",
  "productCatalog.searchPlaceholder": "Nombre, código interno, GTIN, marca o NCM",
  "productCatalog.manage": "Importar y vincular",
  "productCatalog.pinnedRevision": "Revisión fijada · {version}",
  "productCatalog.noActiveRevision": "Sin revisión activa",
  "productCatalog.openCurrent": "Abrir revisión actual",
  "productCatalog.tableCaption": "Productos de la revisión seleccionada",
  "productCatalog.noResults": "Ningún producto en esta búsqueda",
  "productCatalog.noResultsHelp": "Pruebe otro nombre o identificador en esta revisión.",
  "productCatalog.empty": "Ningún catálogo disponible",
  "productCatalog.emptyHelp":
    "Un operador con permiso de gestión puede importar los archivos preparados y activar una revisión tras verificar su origen.",
  "productCatalog.catalogUnavailable": "El catálogo solicitado no está disponible en esta sesión.",
  "productCatalog.revisionMismatch":
    "Este producto no pertenece a la revisión fijada. Vuelva a la lista y abra una línea de esta revisión.",
  "productCatalog.unnamed": "Producto sin nombre registrado",
  "productCatalog.notRecorded": "No registrado",
  "productCatalog.issues": "Incidencias de importación",
  "productCatalog.noImportIssues": "Sin alertas de importación registradas",
  "productCatalog.noMerge":
    "Las líneas repetidas permanecen separadas. GTIN, nombre o marca no acreditan un vínculo con el SKU del proveedor.",
  "productCatalog.imagesPending": "Imágenes pendientes",
  "productCatalog.imagesHelp": "Esta revisión aún no contiene imágenes calificadas del producto.",
  "productCatalog.provenance": "Origen y auditoría",
  "productCatalog.revisionId": "Revisión exacta",
  "productCatalog.sourceRow": "Hoja y fila de origen",
  "productCatalog.worksheetPart": "Parte de la hoja en el archivo",
  "productCatalog.sourceHash": "SHA-256 del archivo de origen declarado",
  "productCatalog.rowHash": "SHA-256 de la fila de origen",
  "productCatalog.sourceReference": "Referencia de la fuente / documento",
  "productCatalog.reason": "Motivo registrado",
  "productCatalog.reviewedAt": "Revisada el",
  "productCatalog.reviewer": "Responsable de la revisión",
  "productCatalog.validFrom": "Válido desde",
  "productCatalog.validTo": "Válido hasta · opcional",
  "productCatalog.openEnded": "Sin fecha final declarada",
  "productCatalog.retryOriginal": "Repetir la solicitud original",
  "productCatalog.recordAnother": "Registrar otro",
  "productCatalog.writeUnknown":
    "La respuesta no se confirmó. Las entradas están fijadas; repetir envía la misma solicitud para recuperar el resultado.",
  "productCatalog.import.title": "Importar revisión preparada",
  "productCatalog.import.help":
    "Seleccione el manifiesto y las líneas JSONL generados por el preparador local del catálogo. Se conservan los valores declarados y sus identificadores.",
  "productCatalog.import.preparation":
    "La preparación local debe registrar el espacio INTERNAL_PRODUCT_CODE, la hoja, las celdas y los hashes. La activación no convierte estos datos en reglas fiscales aprobadas.",
  "productCatalog.import.target": "Destino de la revisión",
  "productCatalog.import.newCatalog": "Crear nuevo catálogo",
  "productCatalog.import.name": "Nombre del nuevo catálogo",
  "productCatalog.import.manifestFile": "Manifiesto · manifest.json",
  "productCatalog.import.rowsFile": "Líneas preparadas · rows.jsonl",
  "productCatalog.import.validate": "Verificar archivos localmente",
  "productCatalog.import.rows": "Líneas del manifiesto",
  "productCatalog.import.worksheet": "Hoja declarada",
  "productCatalog.import.sourceDigest": "Hash del origen declarado en el manifiesto",
  "productCatalog.import.rowsDigest": "SHA-256 de las líneas preparadas",
  "productCatalog.import.bytes": "Bytes UTF-8 canónicos",
  "productCatalog.import.validated":
    "La estructura, el orden, la cantidad, los bytes y el hash de las líneas coinciden con el manifiesto.",
  "productCatalog.import.upload": "Enviar borrador en bloques de 100 líneas",
  "productCatalog.import.uploading": "Enviando bloques…",
  "productCatalog.import.resume": "Reanudar con las mismas solicitudes",
  "productCatalog.import.progress": "{received} de {total} líneas confirmadas por el servidor",
  "productCatalog.import.resumeHelp":
    "Al cerrar, el envío se pausa después del bloque actual. Para reanudar en esta sesión, seleccione los mismos archivos y vuelva a verificarlos; se reutilizan las solicitudes originales.",
  "productCatalog.import.activationHelp":
    "Revise el origen y registre el motivo. La activación permite consultar esta revisión y conserva las anteriores. Las incidencias y duplicados siguen visibles.",
  "productCatalog.import.activate": "Activar revisión comprobada",
  "productCatalog.import.activated": "Revisión {version} del catálogo activada",
  "productCatalog.import.finished":
    "Revisión activada. Cierre este panel para consultar los productos o vuelva a abrirlo para preparar otra importación.",
  "productCatalog.import.storageWarning":
    "No se pudieron guardar los datos para reanudar en esta sesión. Mantenga este panel abierto hasta terminar el envío y la activación.",
  "productCatalog.import.error.size":
    "Los archivos superan el límite local de 1 MiB para el manifiesto o 128 MiB para las líneas.",
  "productCatalog.import.error.manifest":
    "El manifiesto no corresponde al formato preparado admitido. Revíselo en el preparador local.",
  "productCatalog.import.error.row":
    "JSONL no válido o posición de origen inconsistente en la línea {row}. No se envió ninguna línea durante esta verificación.",
  "productCatalog.import.error.count":
    "La cantidad o secuencia de líneas confirmadas no coincide con el manifiesto. El borrador permanece sin activar.",
  "productCatalog.import.error.digest":
    "Los bytes o el SHA-256 canónico de las líneas difieren del manifiesto. Genere ambos archivos de nuevo desde el mismo origen.",
  "productCatalog.supplier.create": "Registrar proveedor",
  "productCatalog.supplier.name": "Nombre declarado del proveedor",
  "productCatalog.supplier.externalId": "Referencia externa del proveedor · opcional",
  "productCatalog.supplier.scope":
    "El proveedor lo declara el operador. La marca, el fabricante del producto y el código interno no determinan su perfil tributario.",
  "productCatalog.supplier.createdUnknown":
    "Registro creado sin perfil fiscal acreditado. Declare el perfil por separado con fuente y período.",
  "productCatalog.supplier.choose": "Seleccionar proveedor declarado",
  "productCatalog.supplier.declare": "Declarar perfil del proveedor",
  "productCatalog.supplier.profile": "Perfil declarado",
  "productCatalog.supplier.profile.UNKNOWN": "Desconocido / no acreditado",
  "productCatalog.supplier.profile.INDUSTRY": "Industria declarada",
  "productCatalog.supplier.profile.DISTRIBUTOR": "Distribuidor declarado",
  "productCatalog.supplier.currentDeclaration": "Perfil declarado vigente: {profile}",
  "productCatalog.supplier.saveDeclaration": "Registrar declaración y fuente",
  "productCatalog.supplier.declarationSaved":
    "Declaración registrada como DECLARED. No acredita beneficios, IPI ni ST anterior.",
  "productCatalog.binding.title": "Asociar proveedor a la revisión",
  "productCatalog.binding.help":
    "Asociación documental a una revisión exacta. Vincular el SKU del proveedor con un producto requiere un mapeo individual en el detalle del producto.",
  "productCatalog.binding.requiresRevision":
    "Seleccione y cargue una revisión activa para registrar esta asociación.",
  "productCatalog.binding.save": "Registrar asociación a la revisión",
  "productCatalog.binding.saved": "Asociación registrada. No crea automáticamente un mapeo de SKU.",
  "productCatalog.link.title": "Mapear SKU declarado del proveedor",
  "productCatalog.link.help":
    "Registre explícitamente qué SKU de ese proveedor identifica este producto en esta revisión. Requiere fuente y período; no lo deduzca por nombre, GTIN, marca ni código interno.",
  "productCatalog.link.supplierSku": "SKU del proveedor · declarado explícitamente",
  "productCatalog.link.save": "Registrar mapeo con fuente",
  "productCatalog.link.saved": "Mapeo explícito registrado",
  "productCatalog.field.status": "Estado declarado",
  "productCatalog.field.sku": "Código interno",
  "productCatalog.field.name": "Nombre declarado",
  "productCatalog.field.family": "Familia declarada",
  "productCatalog.field.brand": "Marca declarada",
  "productCatalog.field.model": "Modelo declarado",
  "productCatalog.field.gtinRaw": "GTIN original",
  "productCatalog.field.gtin": "GTIN normalizado",
  "productCatalog.field.ncmRaw": "NCM original",
  "productCatalog.field.ncm": "NCM normalizado",
  "productCatalog.field.ncmExtension": "Extensión de NCM declarada",
  "productCatalog.field.cestRaw": "CEST original",
  "productCatalog.field.cest": "CEST normalizado",
  "productCatalog.field.unit": "Unidad comercial declarada",
  "productCatalog.field.unitPriceRaw": "Precio unitario original",
  "productCatalog.field.unitPrice": "Precio unitario normalizado",
  "productCatalog.field.availableStockRaw": "Existencias originales",
  "productCatalog.field.availableStock": "Existencias normalizadas",
  "productCatalog.field.netWeightRaw": "Peso neto original",
  "productCatalog.field.grossWeightRaw": "Peso bruto original",
  "productCatalog.field.heightRaw": "Altura original",
  "productCatalog.field.widthRaw": "Ancho original",
  "productCatalog.field.depthRaw": "Profundidad original",
  "productCatalog.field.goodsOriginRaw": "Origen de la mercancía declarado",
  "productCatalog.field.characteristics": "Características declaradas",
  "productCatalog.field.includedAtRaw": "Alta en origen",
  "productCatalog.field.updatedAtRaw": "Actualización en origen",
  "productCatalog.issue.MISSING_SKU": "Código interno ausente",
  "productCatalog.issue.MISSING_NAME": "Nombre ausente",
  "productCatalog.issue.IDENTIFIER_FORMAT_UNKNOWN": "Formato del identificador desconocido",
  "productCatalog.issue.NUMERIC_IDENTIFIER_UNSAFE":
    "Identificador numérico con riesgo de pérdida de precisión",
  "productCatalog.issue.INVALID_NCM": "NCM no válido en origen",
  "productCatalog.issue.NCM_EXTENSION_PRESENT": "La extensión de NCM requiere revisión",
  "productCatalog.issue.INVALID_CEST": "CEST no válido en origen",
  "productCatalog.issue.INVALID_GTIN": "GTIN no válido en origen",
  "productCatalog.issue.GTIN_SHARED": "GTIN compartido por códigos internos diferentes",
  "productCatalog.issue.SKU_REPEATED": "Código interno repetido en líneas distintas",
  "productCatalog.issue.FORMULA_NOT_EVALUATED": "Fórmula no evaluada",
  "productCatalog.issue.PRICE_UNPARSEABLE": "Precio no interpretable",
  "productCatalog.issue.STOCK_UNPARSEABLE": "Existencias no interpretables",

  "calculationMemory.title": "Memoria del cálculo",
  "calculationMemory.intro":
    "Fórmulas y dependencias reconstruidas de los registros inmutables de este ítem y su versión de reglas.",
  "calculationMemory.qualification":
    "Esta memoria explica el registro guardado. Esta vista no realiza la calificación jurídica ni determina la aplicabilidad fiscal.",
  "calculationMemory.loading": "Cargando la memoria del ítem…",
  "calculationMemory.legacy":
    "La memoria no está disponible para este registro. Faltan los datos originales o la traza inmutable necesarios.",
  "calculationMemory.error": "No se pudo cargar la memoria del ítem.",
  "calculationMemory.retry": "Reintentar",
  "calculationMemory.status.AVAILABLE": "Memoria disponible",
  "calculationMemory.status.PARTIAL": "Memoria parcial",
  "calculationMemory.status.UNAVAILABLE": "Memoria no disponible",
  "calculationMemory.cardStatus.CALCULATED": "Calculado",
  "calculationMemory.cardStatus.DECLARED": "Declarado",
  "calculationMemory.cardStatus.EXEMPT": "Exento según registro",
  "calculationMemory.cardStatus.OUTSIDE_SCOPE": "Fuera del alcance del registro",
  "calculationMemory.cardStatus.PENDING": "Pendiente",
  "calculationMemory.formula": "Fórmula",
  "calculationMemory.substitution": "Sustitución",
  "calculationMemory.raw": "Resultado sin redondeo",
  "calculationMemory.result": "Resultado del paso",
  "calculationMemory.stored": "Valor guardado",
  "calculationMemory.rounding": "Redondeo",
  "calculationMemory.roundingScale": "{scale} decimales · {mode}",
  "calculationMemory.roundingNone": "Sin redondeo en este paso",
  "calculationMemory.dependencies": "Depende de",
  "calculationMemory.none": "Ninguna",
  "calculationMemory.unit": "Unidad",
  "calculationMemory.unit.BRL": "BRL · reales",
  "calculationMemory.unit.RATE": "Fracción decimal (1 = 100%)",
  "calculationMemory.unit.COUNT": "Cantidad",
  "calculationMemory.unavailableValue": "No disponible",
  "calculationMemory.source": "Origen del registro",
  "calculationMemory.source.INPUT": "Entrada original",
  "calculationMemory.source.PINNED_RULE": "Regla de la versión vinculada",
  "calculationMemory.source.STORED_TRACE": "Traza guardada",
  "calculationMemory.source.DECLARED_REGIME": "Régimen declarado",
  "calculationMemory.trace": "Pasos de la traza: {sequences}",
  "calculationMemory.blockers": "Pendientes y límites",
  "calculationMemory.basis": "Base y cantidad",
  "calculationMemory.basisDetail": "{quantity} × {unit} · origen: {source} · importes: {scope}",
  "calculationMemory.inputBasis": "Precio original",
  "calculationMemory.normalizedBasis": "Base normalizada",
  "calculationMemory.extension": "Multiplicador de entrada",
  "calculationMemory.aggregation": "Multiplicador de agregación",
  "calculationMemory.binding": "Versión vinculada",
  "calculationMemory.evidence": "Evidencia guardada",
  "calculationMemory.rule": "Regla guardada",
  "calculationMemory.recordedSource": "Fuente registrada",
  "calculationMemory.provenance": "Reglas y evidencias vinculadas",
  "calculationMemory.provenanceHint":
    "Los enlaces y hashes pertenecen al registro guardado; no representan una nueva verificación de la fuente.",
  "calculationMemory.GOODS": "Mercancía",
  "calculationMemory.OWN_ICMS_DISPLAYED": "ICMS propio mostrado",
  "calculationMemory.FEDERAL_BASE": "Base federal",
  "calculationMemory.PIS": "PIS",
  "calculationMemory.COFINS": "COFINS",
  "calculationMemory.IPI": "IPI",
  "calculationMemory.ST_SEED": "Base inicial de ST",
  "calculationMemory.MVA": "MVA aplicada",
  "calculationMemory.ST_BASE": "Base de ST",
  "calculationMemory.ST_GROSS_DEBIT": "Débito bruto de ST",
  "calculationMemory.ST_OWN_DEDUCTION": "Deducción de ICMS propio",
  "calculationMemory.ST_NET": "ST neta",
  "calculationMemory.ACQUISITION_FISCAL": "Adquisición fiscal",
  "lotMap.field.base_preco": "Composición del precio de compra",
  "wb.field.base_preco": "Composición del precio de compra",
  // Explicit import formats and supplier declarations.
  "importTemplate.title": "Plantillas de importación",
  "lotDeclaration.title": "Declaraciones comerciales para celdas vacías",
  "lotDeclaration.otherInputs": "datos de la operación",
  "lotDeclaration.pendingInputs":
    "{count} filas quedan fuera del cálculo hasta revisar: {fields}. La importación conserva esas filas y sus motivos.",
  "lotDeclaration.preflightPending":
    "Revisando los datos comerciales y fiscales de la planilla. La confirmación estará disponible al terminar la revisión.",
  "lotDeclaration.hint":
    "Declara sólo lo confirmado para todas las filas de esta hoja. Una celda con contenido prevalece, incluido UNKNOWN. El registro de importación conserva el origen de la declaración.",
  "lotDeclaration.amountBasis": "El costo seleccionado es",
  "lotDeclaration.commercialUnit": "Unidad comercial declarada",
  "lotDeclaration.unitPlaceholder": "Ej.: UN, caja de 12 unidades",
  "lotDeclaration.priceBasis": "Composición del costo seleccionado",
  "lotDeclaration.purchaseStStatus": "Situación de ST en la compra",
  "lotDeclaration.pisCofinsRegime": "Régimen PIS/COFINS declarado",
  "lotDeclaration.option.UNKNOWN": "Sin confirmar / requiere revisión",
  "lotDeclaration.option.UNIT": "Precio por unidad comercial",
  "lotDeclaration.option.LINE_TOTAL": "Total de la fila, ya multiplicado",
  "lotDeclaration.option.GOODS_BEFORE_IPI_ST": "Mercancía antes de IPI y ST adicionales",
  "lotDeclaration.option.ACQUISITION_INCLUDES_TAXES": "Adquisición con impuestos incluidos",
  "lotDeclaration.option.NEW": "Sin declaración de ST anterior",
  "lotDeclaration.option.PRIOR_ST_INCLUDED": "ST anterior incluida: compra interna a distribuidor",
  "lotDeclaration.option.INVOICE_RETAINED": "ST destacada en la factura",
  "lotDeclaration.option.CUMULATIVE": "Acumulativo",
  "lotDeclaration.option.NON_CUMULATIVE": "No acumulativo",
  "lotDeclaration.review":
    "El precio con impuestos incluidos y la ST destacada en factura requieren composición y evidencia antes del cálculo. Un porcentaje comercial no es MVA ni alícuota aprobada. No apliques a toda la hoja una condición confirmada sólo para algunos productos.",
  "importTemplate.xlsx": "Descargar Excel",
  "importTemplate.csv": "Descargar CSV",
  "importTemplate.txt": "Descargar TXT",
  "importTemplate.hint":
    "Identificadores como texto, precio y cantidad separados. Excel incluye una guía; CSV y TXT usan UTF-8 y punto y coma. Declare las premisas fiscales antes de calcular.",
  "importTemplate.supplierFallback": "Tipo declarado del proveedor para filas sin esa información",
  "importTemplate.supplierPerRow": "Usar la información de cada fila",
  "importTemplate.industry": "Industria o equiparado",
  "importTemplate.distributor": "Distribuidor / revendedor ordinario",
  "importTemplate.supplierFallbackHint":
    "Solo completa celdas vacías. Los valores desconocidos o contradictorios requieren revisión. La declaración no acredita IPI, retención ni ST anterior.",
  "lotMap.field.situacao_st_compra": "Situación de ST en la compra",
  "lotMap.field.preco_venda": "Precio de venta",
  "lotMap.field.uf_destino_venda": "Estado del comprador",
  "lotMap.field.tipo_comprador": "Perfil ICMS del comprador",
  "lotMap.field.regime_pis_cofins": "Régimen PIS/COFINS declarado",
  "lotMap.field.deposito": "Almacén / línea de stock",
  "lotMap.field.validade": "Vencimiento del stock",
  "wb.field.situacao_st_compra": "Situación de ST en la compra",
  "wb.field.preco_venda": "Precio de venta",
  "wb.field.uf_destino_venda": "Estado del comprador",
  "wb.field.tipo_comprador": "Perfil ICMS del comprador",
  "wb.field.regime_pis_cofins": "Régimen PIS/COFINS declarado",
  "wb.field.deposito": "Almacén / línea de stock",
  "wb.field.validade": "Vencimiento del stock",
  // Supplier snapshot: declarations and engine output remain independent.
  "supplierCard.title": "Proveedor y ST anterior",
  "supplierCard.intro": "Entradas guardadas y respuesta del motor para esta línea.",
  "supplierCard.declarations": "Entradas declaradas",
  "supplierCard.returned": "Devuelto por el motor",
  "supplierCard.type": "Tipo de proveedor declarado",
  "supplierCard.type.INDUSTRY": "Industria",
  "supplierCard.type.DISTRIBUTOR": "Distribuidor ordinario",
  "supplierCard.priorSt": "ST anterior incluida en el precio",
  "supplierCard.priorSt.true": "Declarada como pagada anteriormente",
  "supplierCard.priorSt.false": "Pago anterior no confirmado",
  "supplierCard.unknown": "No registrado · desconocido",
  "supplierCard.stStatus": "Tratamiento de ST devuelto",
  "supplierCard.stStatus.PREVIOUSLY_PAID": "Pagada anteriormente",
  "supplierCard.stStatus.CURRENT_RULE": "Regla seleccionada para este cálculo",
  "supplierCard.stStatus.PENDING": "Pendiente de revisión",
  "supplierCard.returnedProfile": "Perfil de proveedor devuelto",
  "supplierCard.returnedPriorSt": "Indicador de ST anterior del motor: {value}",
  "supplierCard.inputSource.calculation": "Fuente: entrada guardada del cálculo",
  "supplierCard.inputSource.task": "Fuente: entrada guardada de la línea del lote",
  "supplierCard.inputUnavailable": "Entrada original no disponible en este registro",
  "supplierCard.mappedColumn":
    "Columna mapeada: {cell}. No se conservó el texto de la celda; puede aplicar una declaración del archivo.",
  "supplierCard.resultSource": "Fuente: respuesta guardada del motor",
  "supplierCard.legacyUnknown": "No se guardó un perfil de proveedor en este resultado.",
  "supplierCard.qualification":
    "Son declaraciones de la transacción y resultados guardados del cálculo, no un registro verificado del proveedor ni prueba de retención anterior. Los campos ausentes siguen desconocidos; el tipo de proveedor por sí solo no acredita exención ni elegibilidad legal.",

  "operation.research.providerBudgetBlocked":
    "Un límite del proveedor o de la reserva presupuestaria bloqueó esta búsqueda. La evidencia faltante sigue pendiente.",

  "operation.research.optIn": "Investigar y calificar esta operación",
  "operation.research.rollout":
    "Investigación gobernada opcional. La evidencia faltante queda pendiente; la calificación automática completa del producto aún no está disponible.",
  "operation.research.legacyScope":
    "Estimación de la versión publicada seleccionada. La aplicabilidad actual al producto y a las partes no se ha calificado de nuevo. No es una cotización final.",

  "operation.research.billingPending":
    "La investigación pagada espera la verificación de facturación y una campaña activa con un presupuesto total limitado.",

  "operation.research.saved": "Revisión inmutable {revision} guardada",

  "research.family.IPI": "IPI",
  "research.family.FCP": "FCP",
  "research.family.PIS": "PIS",
  "research.family.COFINS": "COFINS",
  "research.origin.OPERATION": "Operación",

  "operation.research.PENDING": "Investigación fiscal pendiente.",
  "operation.research.DISABLED":
    "La investigación no se ha iniciado para todos los datos pendientes.",
  "operation.research.REVIEW_REQUIRED": "Datos fiscales pendientes de revisión.",
  "operation.research.RECALCULABLE": "Hay datos disponibles para recalcular en una nueva revisión.",
  "operation.research.gaps": "Pendientes para revisar: {count}.",
  "operation.research.failed": "Una investigación falló; los datos siguen pendientes.",
  "operation.research.cancelled": "Una investigación fue cancelada; los datos siguen pendientes.",
  "operation.research.notFound":
    "Una investigación no encontró evidencia para esta operación. Esto no significa exención ni impuesto cero.",
  "operation.research.capacityPending":
    "La investigación tiene pendientes por límites de capacidad o coste.",
  "operation.research.costPending": "Aún falta confirmar el coste máximo de la consulta.",
  "operation.research.budgetPending": "La investigación espera presupuesto mensual disponible.",
  "operation.research.activationPending":
    "La investigación está desactivada, pausada o espera autorización.",
  "operation.research.evidencePending":
    "Falta confirmar las fuentes y si corresponden a esta operación.",
  "operation.research.otherBlocker": "Hay un dato pendiente que necesita revisión fiscal.",
  "operation.research.missingDetails": "Ver datos pendientes",
  "operation.research.next.PENDING": "Usa Actualizar investigación para seguir el resultado.",
  "operation.research.next.DISABLED":
    "Pide al responsable fiscal que compruebe qué falta para iniciar.",
  "operation.research.next.REVIEW_REQUIRED":
    "Envía esta referencia al responsable fiscal para revisar los datos.",
  "operation.research.next.RECALCULABLE":
    "Selecciona una nueva versión publicada y usa Emitir nueva revisión.",
  "operation.research.handoff":
    "La revisión fiscal necesita los documentos del producto y de la operación para comprobar las fuentes, las partes y la fecha del negocio.",
  "operation.research.reference": "Referencia de la revisión:",
  "operation.research.details": "Sobre esta investigación",
  "operation.research.immutable":
    "Revisión {revision} · versión {version}. La nueva evidencia no cambia este resultado emitido.",
  "operation.research.scope":
    "La búsqueda actual cubre evidencia de ICMS/ST. IPI, FCP y contribuciones requieren fuentes y condiciones calificadas; NCM y CEST no acreditan el perfil completo del producto.",
  "operation.research.refresh": "Actualizar investigación",
  "operation.research.refreshError":
    "No se pudo confirmar el estado actual. El último resultado permanece sin cambios.",
  "operation.research.version": "Versión publicada para la nueva revisión",
  "operation.research.chooseVersion": "Selecciona una versión",
  "operation.research.recalculate": "Emitir nueva revisión",

  "spCoverage.selectionChanged":
    "La selección cambió o fue rechazada antes de crear trabajo. Actualice la lectura, limpie la selección y elija las brechas actuales. No necesita reenviar con una clave nueva.",

  "spCoverage.workspaceTitle": "Calificar, priorizar e investigar",
  "spCoverage.workspaceHelp":
    "Elija el sentido y la UF. Revise los seis criterios y seleccione brechas reales para una investigación limitada.",

  "spCoverage.title": "Cobertura de rutas de São Paulo",
  "spCoverage.priority": "Prioridad comercial · São Paulo",
  "spCoverage.intro":
    "Vea qué respalda cada ruta, qué falta acreditar y la próxima investigación necesaria.",
  "spCoverage.hub": "Centro de operación",
  "spCoverage.esLater": "Espírito Santo en la próxima fase",
  "spCoverage.direction": "Sentido de la operación",
  "spCoverage.inbound": "Compra · ALL → SP",
  "spCoverage.outbound": "Venta · SP → ALL",
  "spCoverage.asOf": "Fecha fiscal",
  "spCoverage.ncm": "Filtrar por NCM",
  "spCoverage.allProducts": "Todos los productos publicados",
  "spCoverage.ncmHint": "Ingrese 8 dígitos para filtrar.",
  "spCoverage.refresh": "Actualizar lectura",
  "spCoverage.stale":
    "Falló la actualización. Se muestra la última lectura confirmada; se bloquearon nuevos envíos.",
  "spCoverage.published": "Versión publicada",
  "spCoverage.noBase": "Sin base publicada",
  "spCoverage.observed": "Lectura confirmada",
  "spCoverage.scopeWarning":
    "Alcance actual: candidatos de la base publicada. Sin alcance acreditado de productos y perfiles, vigencia de fuentes y comprobantes de pruebas, ninguna ruta puede declararse completa.",
  "spCoverage.shortStatus.COMPLETE": "Completa",
  "spCoverage.shortStatus.PARTIAL": "Parcial",
  "spCoverage.shortStatus.MISSING": "Sin regla",
  "spCoverage.shortStatus.BLOCKED": "Bloqueada",
  "spCoverage.shortStatus.RUNNING": "En curso",
  "spCoverage.status.COMPLETE": "Completa",
  "spCoverage.status.PARTIAL": "Parcial",
  "spCoverage.status.MISSING": "Sin regla candidata",
  "spCoverage.status.BLOCKED": "Bloqueada",
  "spCoverage.status.RUNNING": "En ejecución",
  "spCoverage.routes": "Rutas por UF",
  "spCoverage.chooseRoute": "Seleccione una UF para revisar sus criterios y brechas.",
  "spCoverage.candidateRules": "candidatas",
  "spCoverage.qualification": "Criterios de cobertura",
  "spCoverage.underlying": "Calificación fiscal:",
  "spCoverage.check.DECLARED_PRODUCT_SCOPE": "Productos y perfiles declarados",
  "spCoverage.check.APPLICABLE_RULES": "Reglas candidatas en la fecha",
  "spCoverage.check.SOURCE_PROVENANCE": "Documentos y procedencia",
  "spCoverage.check.SOURCE_CURRENTNESS": "Versión vigente de la fuente",
  "spCoverage.check.SUPPLIER_CASES": "Industria y reventa",
  "spCoverage.check.VALIDATION_RECEIPTS": "Validación y comprobantes de pruebas",
  "spCoverage.reason.PRODUCT_PROFILE_SCOPE_NOT_QUALIFIED":
    "El universo de productos, CEST y perfiles aún no está acreditado para esta ruta.",
  "spCoverage.reason.PUBLISHED_CANDIDATES_FOR_ROUTE_DATE_ONLY":
    "Hay reglas candidatas publicadas. Su cantidad no acredita todos los productos o perfiles.",
  "spCoverage.reason.NO_PUBLISHED_ICMS_CANDIDATE_FOR_ROUTE_DATE":
    "No se encontró una regla candidata de ICMS para esta ruta y fecha en la base publicada.",
  "spCoverage.reason.IMMUTABLE_REFERENCES_REQUIRE_DOCUMENT_VERIFICATION":
    "Hay referencias inmutables con hash. Falta verificar el documento y su aplicabilidad.",
  "spCoverage.reason.NO_BOUND_SOURCE_REFERENCE":
    "No hay una referencia documental inmutable vinculada a los candidatos de esta ruta.",
  "spCoverage.reason.CURRENT_PRIMARY_SOURCE_VERSION_NOT_ATTESTED":
    "La vigencia de la regla no demuestra que se revisó la última versión de la fuente primaria.",
  "spCoverage.reason.INDUSTRY_AND_RESELLER_CASES_NOT_ATTESTED":
    "Faltan comprobantes para industria y distribuidor/revendedor, incluido ST e IPI cuando correspondan.",
  "spCoverage.reason.ROUTE_PRODUCT_PROFILE_TEST_RECEIPTS_NOT_AVAILABLE":
    "No hay comprobantes de validación para el conjunto completo ruta × producto × perfil.",
  "spCoverage.products": "productos candidatos",
  "spCoverage.boundRefs": "referencias vinculadas",
  "spCoverage.sources": "fuentes registradas",
  "spCoverage.degraded": "degradadas",
  "spCoverage.gaps": "Brechas observadas en cálculos",
  "spCoverage.gapHelp":
    "Seleccione hasta 10 brechas reales. Una ruta sin brechas observadas puede seguir incompleta.",
  "spCoverage.noGap":
    "No hay brechas de cálculo registradas en esta lectura. Esto no acredita cobertura.",
  "spCoverage.active": "en cola o en ejecución",
  "spCoverage.gapStatus.OPEN": "Disponible para investigar",
  "spCoverage.gapStatus.RESEARCHING": "En investigación",
  "spCoverage.gapStatus.NO_RULE_FOUND": "Sin regla encontrada · revisar",
  "spCoverage.gapStatus.RULE_FOUND": "Resultado para revisión",
  "spCoverage.gapStatus.RESOLVED": "Resuelta",
  "spCoverage.gapStatus.DISMISSED": "Descartada",
  "spCoverage.bounded":
    "Muestra limitada a 50 registros por ruta. Los totales incluyen los demás. La selección se bloquea si la lista de investigaciones activas está truncada.",
  "spCoverage.batch": "Investigar brechas seleccionadas",
  "spCoverage.selected": "{count} de 10 brechas seleccionadas",
  "spCoverage.batchHelp":
    "Usa el flujo existente de agentes con presupuesto y pausas actuales. Reutiliza solicitudes iguales activas.",
  "spCoverage.permission": "Requiere permiso de ejecución de investigación y lectura de cálculos.",
  "spCoverage.dispatcher":
    "El ejecutor no está configurado en esta instancia. La lectura sigue disponible.",
  "spCoverage.estimating": "Verificando costo y límites…",
  "spCoverage.estimateError": "No se pudo verificar costo y límites. El envío sigue bloqueado.",
  "spCoverage.requests": "solicitudes estimadas",
  "spCoverage.lane.AVAILABLE": "disponible",
  "spCoverage.lane.PAUSED": "pausado",
  "spCoverage.lane.BUDGET": "límite de presupuesto",
  "spCoverage.lane.DAILY_CAP": "límite diario",
  "spCoverage.lane.DISABLED": "desactivado",
  "spCoverage.launch": "Iniciar lote limitado",
  "spCoverage.launching": "Enviando lote…",
  "spCoverage.retryBatch": "Consultar / repetir con la misma clave",
  "spCoverage.clear": "Limpiar selección",
  "spCoverage.finishRetry": "Resuelva el envío pendiente antes de cambiar el alcance.",
  "spCoverage.uncertain":
    "Un envío no fue confirmado. La secuencia se detuvo. Reintente con la misma clave; no inicie otro lote equivalente.",
  "spCoverage.receipt":
    "Confirmado: {created} creadas · {joined} vinculadas · {reused} resultados reutilizados · {deferred} aplazadas.",
  "spCoverage.noAutoPublish":
    "Investigación completada no equivale a cobertura completa. Esta acción no aprueba ni publica reglas.",
  "spCoverage.activity": "Ejecuciones y resultados de la ruta",
  "spCoverage.review": "pendientes de revisión",
  "spCoverage.failed": "fallos o cancelaciones",
  "spCoverage.research.QUEUED": "En cola",
  "spCoverage.research.RUNNING": "En ejecución",
  "spCoverage.research.FOUND": "Encontrada · revisar",
  "spCoverage.research.NOT_FOUND": "Sin resultado",
  "spCoverage.research.NEEDS_REVIEW": "Revisión necesaria",
  "spCoverage.research.FAILED": "Falló",
  "spCoverage.research.CANCELLED": "Cancelada",
  "spCoverage.provenance": "Versión, vigencia y documentos",
  "spCoverage.provenanceHelp":
    "Muestra de candidatos publicados y hashes vinculados. No sustituye la revisión de fuentes primarias.",
  "spCoverage.openDate": "sin fecha final",
  "spCoverage.boundedRules": "Muestra limitada a las primeras 10 reglas y 5 referencias por regla.",
  "spCoverage.referenceTitle": "Referencia de la base publicada",
  "spCoverage.referenceHelp":
    "El mapa cuenta menciones de UF en las reglas. No representa cobertura completa de las rutas de compra o venta.",

  "operation.pricing.strategy": "Precio de venta",
  "operation.pricing.fixed": "Precio cerrado",
  "operation.pricing.tr": "Calcular por TR · SP → SP → SP",
  "operation.pricing.spHub": "Calcular por TR · todos los estados → SP → todos los estados",
  "operation.pricing.spHubScope":
    "El TR vía SP exige el centro BackChannel en SP. Proveedor y cliente pueden estar en cualquier estado brasileño.",
  "operation.pricing.spHubHint":
    "Ingrese de 0 a menos de 100%, con hasta 6 decimales. Cualquier estado de proveedor/cliente, con el centro en SP. Requiere ST de compra, IPI, FCP y reglas fiscales calificados; admitir la ruta no acredita cobertura fiscal.",
  "operation.pricing.stBasis": "Base de ST de compra",
  "operation.pricing.stBasis.RESOLVED_NON_ST": "La regla de adquisición seleccionada no calcula ST",
  "operation.pricing.stBasis.PRIOR_ST_INCLUDED":
    "ST previamente pagado declarado como incluido en el precio de compra",
  "operation.pricing.stBasis.DECLARED_INVOICE_ST":
    "ST retenido positivo declarado de la factura del proveedor",
  "operation.pricing.stBasis.RESOLVED_SENDER_ST":
    "ST calculado con responsabilidad calificada del remitente",
  "operation.pricing.netTarget":
    "Meta de contribución · todos los estados → SP → todos los estados",
  "operation.pricing.targetRate": "Contribución objetivo / venta (%)",
  "operation.pricing.netHint":
    "Contribución del P&L tras los impuestos calificados de la operación, créditos de compra y gastos declarados. No es una meta de caja ni de beneficio final de la empresa. El centro debe estar en SP.",
  "operation.pricing.netExpensesHint":
    "Introduce los tres gastos como totales de línea; declara cero cuando no haya gasto. Editar un gasto elimina la cotización neta anterior.",
  "operation.pricing.expensesRequired":
    "Declara los tres gastos antes de calcular la meta de contribución. Introduce cero expresamente cuando corresponda.",
  "operation.pricing.invalidTargetRate":
    "Introduce una contribución objetivo de 0 a menos de 100%, con hasta 6 decimales.",
  "operation.pricing.netScope": "La meta de contribución exige el centro BackChannel en SP.",
  "operation.pricing.achievedMargin": "Contribución calculada / venta",
  "operation.pricing.targetDifference": "Diferencia frente a la meta · redondeada a centavos",
  "operation.pricing.netFormula":
    "Contribución del P&L al centavo más cercano tras impuestos calificados, créditos de compra y gastos declarados. El crédito pendiente sigue como activo y el ST del cliente es un traslado. No se presumen recuperaciones de ST ni impuestos o gastos sin declarar.",
  "commercial.grossProfitMargin": "Beneficio bruto / GMV · parcial",
  "commercial.purchaseGoodsBase": "Valor de mercancía antes de IPI/ST",
  "commercial.purchaseFederalBase": "Base PIS/COFINS · adquisición",
  "commercial.purchaseIcmsCredit": "Crédito ICMS · adquisición",
  "commercial.purchaseSt": "ST retenido / debido en adquisición",
  "commercial.saleFederalBase": "Base PIS/COFINS · venta",
  "commercial.saleOwnIcms": "Débito de ICMS propio · venta",
  "operation.pricing.rate": "TR sobre la venta (%)",
  "operation.pricing.hint":
    "Introduce desde 0 hasta menos de 100%, con hasta 6 decimales. Disponible para compra y venta internas en SP.",
  "operation.pricing.scope": "El cálculo por TR exige proveedor, establecimiento y cliente en SP.",
  "operation.pricing.invalidRate":
    "Introduce un TR de 0 hasta menos de 100%, con hasta 6 decimales.",
  "operation.pricing.costBasis": "Costo de factura de adquisición",
  "operation.pricing.saleLineValue": "Venta calculada · total de línea",
  "operation.pricing.unitApproximation": "Venta unitaria aproximada · solo referencia",
  "operation.pricing.formula":
    "Venta = costo de factura ÷ (1 − TR), redondeada a centavos. El total de línea es la referencia. TR no es margen neto; los tributos de venta y gastos reducen la contribución.",
  "operation.pricing.review": "Revisa las condiciones fiscales antes de calcular el precio.",
  "errors.OPERATION_PRICING_UNRESOLVED":
    "Precio pendiente. Resuelve las condiciones siguientes y vuelve a calcular.",
  "operation.pricing.blocker.INPUT_INVALID":
    "Comprueba la ruta permitida por el modo TR seleccionado, el tipo de proveedor y el TR.",
  "operation.pricing.blocker.PURCHASE_RULE_PENDING":
    "La regla o el valor de adquisición no está resuelto.",
  "operation.pricing.blocker.PURCHASE_IPI_PENDING":
    "Falta el tratamiento IPI aplicable a la adquisición industrial.",
  "operation.pricing.blocker.PURCHASE_FCP_PENDING":
    "El FCP-ST de adquisición es desconocido o no está incorporado en el costo fiscal.",
  "operation.pricing.blocker.PURCHASE_ST_PENDING":
    "Confirma la situación ST y los importes retenidos en la factura del proveedor.",
  "operation.pricing.blocker.SALE_RULE_PENDING": "La regla fiscal de venta falta o es ambigua.",
  "operation.pricing.blocker.MONETARY_LIMIT":
    "El costo o precio calculado supera el límite monetario.",
  "operation.pricing.blocker.FEDERAL_TAXES_PENDING":
    "Los impuestos federales o créditos de compra están pendientes para la meta neta.",
  "operation.pricing.blocker.SALE_FCP_PENDING":
    "El FCP de destino es desconocido; califica la venta antes de calcular la meta neta.",
  "operation.pricing.blocker.NET_TARGET_UNREACHABLE":
    "La contribución objetivo no tiene una solución positiva verificada al centavo.",
  "operation.pricing.blocker.PRICING_PRECISION_LIMIT":
    "La meta es alcanzable, pero la búsqueda acotada no puede certificar el precio al centavo más cercano. Ajusta la meta o solicita una revisión de precisión.",
  "autonomousResearch.scope.phase": "Fase SP · ALL → SP → ALL",
  "autonomousResearch.scope.planned":
    "{count} rutas planificadas por la política. Cobertura fiscal todavía sin acreditar.",
  "autonomousResearch.scope.control":
    "El corte controla sólo las tareas nuevas del scheduler autónomo. Las búsquedas manuales, otras automatizaciones, leases y colas anteriores e IOB externo conservan sus propios flujos.",
  "autonomousResearch.scope.recorded": "Alcance registrado en la ejecución seleccionada",
  "autonomousResearch.scope.unknown": "Alcance de la ejecución anterior desconocido",
  "autonomousResearch.scope.noRun": "Todavía no hay ejecuciones registradas",
  "autonomousResearch.scope.future":
    "ES requiere un cambio revisado y una nueva aceptación; no hay avance automático cuando las brechas llegan a cero.",
  "workbookDrafts.open": "Revisar extracto fiscal",
  "workbookDrafts.continue": "Revisar filas guardadas",
  "workbookDrafts.title": "Revisión de filas fiscales",
  "workbookDrafts.description":
    "Seleccione filas de un extracto guardado y organice las evidencias para su revisión.",
  "workbookDrafts.extractId": "ID del extracto guardado",
  "workbookDrafts.extractHint": "Use el ID del recibo generado al guardar el JSON fiscal.",
  "workbookDrafts.loadExtract": "Abrir extracto",
  "workbookDrafts.loading": "Cargando la revisión fiscal…",
  "workbookDrafts.working": "Procesando…",
  "workbookDrafts.retry": "Volver a intentar",
  "workbookDrafts.error":
    "No se pudo completar la acción. Compruebe los datos y la conexión y vuelva a intentarlo.",
  "workbookDrafts.denied": "Su acceso no permite consultar esta revisión de filas y evidencias.",
  "workbookDrafts.notFound": "No se encontró el extracto, borrador o documento en este entorno.",
  "workbookDrafts.unavailable":
    "El servicio de revisión no está disponible temporalmente. Vuelva a intentarlo para comprobar el resultado.",
  "workbookDrafts.invalidId": "Introduzca un ID válido para continuar.",
  "workbookDrafts.invalidReceipt":
    "Se necesita un recibo fiscal guardado, válido y sin discrepancias.",
  "workbookDrafts.sourceTitle": "Origen del extracto",
  "workbookDrafts.extractHash": "SHA-256 del extracto",
  "workbookDrafts.parentHash": "SHA-256 declarado de la hoja de cálculo",
  "workbookDrafts.profile": "Perfil fiscal",
  "workbookDrafts.extractorVersion": "Versión del extractor",
  "workbookDrafts.parentVerification": "Verificación de la hoja de cálculo",
  "workbookDrafts.layoutVerification": "Verificación del mapeo",
  "workbookDrafts.legalValidity": "Validez legal",
  "workbookDrafts.effectiveFrom": "Inicio de vigencia",
  "workbookDrafts.effectiveTo": "Fin de vigencia",
  "workbookDrafts.nullDate": "Sin definir",
  "workbookDrafts.origin": "Origen",
  "workbookDrafts.status": "Estado",
  "workbookDrafts.workbook": "Hoja de cálculo",
  "workbookDrafts.nonExecutable": "Fuera de los cálculos",
  "workbookDrafts.noProposal": "Sin propuesta asociada",
  "workbookDrafts.rowsTitle": "Filas para revisar",
  "workbookDrafts.rowsHint":
    "Seleccione individualmente las filas de compra o venta con ST que desea revisar. Las réplicas de una misma fila se agrupan; las referencias y filas sin datos tipados quedan fuera de esta selección.",
  "workbookDrafts.noRows": "Este extracto no contiene filas elegibles para esta revisión.",
  "workbookDrafts.selectionCount": "{count} filas seleccionadas",
  "workbookDrafts.selectRow": "Seleccionar {block}, fila {row}",
  "workbookDrafts.row": "Fila",
  "workbookDrafts.block": "Bloque fiscal",
  "workbookDrafts.observations": "Observaciones de origen",
  "workbookDrafts.locators": "Localizadores de origen",
  "workbookDrafts.recordHash": "SHA-256 de la fila",
  "workbookDrafts.previewDrafts": "Revisar selección",
  "workbookDrafts.previewTitle": "Vista previa de los borradores",
  "workbookDrafts.batchHash": "SHA-256 de la selección revisada",
  "workbookDrafts.batchCounts": "{selected} filas seleccionadas · {blocked} borradores bloqueados",
  "workbookDrafts.previewNoWrites": "Esta vista previa todavía no ha guardado borradores.",
  "workbookDrafts.confirmDrafts":
    "Confirmo estas filas para guardarlas como borradores bloqueados. El origen sigue declarado, la validez legal desconocida y ninguna regla será aprobada ni publicada.",
  "workbookDrafts.commitDrafts": "Guardar borradores bloqueados",
  "workbookDrafts.savedDrafts": "Selección guardada para revisión",
  "workbookDrafts.savedCounts": "{created} borradores nuevos · {reused} ya guardados",
  "workbookDrafts.verificationFailed":
    "No se pudo confirmar que los datos guardados coincidan. Actualice la lectura antes de continuar.",
  "workbookDrafts.retainedTitle": "Borradores guardados",
  "workbookDrafts.noDrafts": "No se ha guardado ningún borrador para este extracto.",
  "workbookDrafts.refresh": "Actualizar lista",
  "workbookDrafts.readOnly":
    "Su acceso permite consultar las filas. Este perfil no puede guardar borradores ni vínculos.",
  "workbookDrafts.openDraft": "Abrir borrador",
  "workbookDrafts.detailTitle": "Detalle del borrador",
  "workbookDrafts.chooseDraft":
    "Abra un borrador guardado para revisar su origen y las evidencias vinculadas.",
  "workbookDrafts.draftId": "ID del borrador",
  "workbookDrafts.createdAt": "Guardado el",
  "workbookDrafts.createdBy": "Guardado por",
  "workbookDrafts.blockers": "Pendientes de revisión fiscal",
  "workbookDrafts.trustNotice":
    "Los borradores permanecen bloqueados y fuera de los cálculos. Guardar filas o vincular evidencias no aprueba ni publica reglas.",
  "workbookDrafts.linksTitle": "Evidencias vinculadas",
  "workbookDrafts.noLinks": "No se ha vinculado ninguna evidencia a este borrador.",
  "workbookDrafts.evidenceTitle": "Vincular evidencia para revisión",
  "workbookDrafts.evidenceId": "ID del documento de evidencia",
  "workbookDrafts.evidenceHint":
    "Abra un documento aprobado, de una fuente registrada en el nivel 1, y seleccione un localizador exacto del contenido verificado.",
  "workbookDrafts.loadEvidence": "Abrir documento",
  "workbookDrafts.evidenceNotApproved":
    "El vínculo requiere un documento aprobado de una fuente registrada en el nivel 1. Revise el documento en el área de evidencias.",
  "workbookDrafts.evidenceHash": "SHA-256 del contenido",
  "workbookDrafts.evidenceSource": "Fuente registrada",
  "workbookDrafts.evidenceReview": "Revisión del documento",
  "workbookDrafts.locator": "Localizador exacto",
  "workbookDrafts.locatorPosition": "Caracteres {start} a {end}",
  "workbookDrafts.locatorCount": "{count} localizadores cargados",
  "workbookDrafts.moreLocators": "Cargar más localizadores",
  "workbookDrafts.noLocators": "No hay localizadores verificables en las páginas cargadas.",
  "workbookDrafts.purpose": "Finalidad de la evidencia",
  "workbookDrafts.choosePurpose": "Seleccione la finalidad",
  "workbookDrafts.previewLink": "Revisar vínculo",
  "workbookDrafts.linkPreviewTitle": "Vista previa del vínculo",
  "workbookDrafts.linkHash": "SHA-256 del vínculo revisado",
  "workbookDrafts.confirmLink":
    "Confirmo este documento, localizador exacto y finalidad para registrar el vínculo para revisión. El borrador sigue bloqueado y la validez legal desconocida.",
  "workbookDrafts.commitLink": "Guardar vínculo para revisión",
  "workbookDrafts.linkSaved": "Vínculo guardado para revisión",
  "workbookDrafts.linkTrust":
    "La aprobación del documento y el nivel registrado de la fuente no confirman su autoridad legal para esta fila. El vínculo mantiene todos los pendientes del borrador.",
  "workbookDrafts.authorityAssessment": "Autoridad legal para esta fila",
  "workbookDrafts.reviewAtLink": "Revisión del documento al vincular",
  "workbookDrafts.sourceTier": "Nivel registrado de la fuente",
  "workbookDrafts.tierOne": "Nivel 1",
  "workbookDrafts.variantHash": "SHA-256 de la variante informada",
  "workbookDrafts.formulaHash": "SHA-256 de la fórmula",
  "workbookDrafts.contentHash": "SHA-256 del texto omitido",
  "workbookDrafts.cacheTitle": "Resultado almacenado de la fórmula",
  "workbookDrafts.block.PURCHASE_ST": "Compra · ST",
  "workbookDrafts.block.SALE_ST": "Venta · ST",
  "workbookDrafts.status.BLOCKED": "Bloqueado para uso fiscal",
  "workbookDrafts.legal.UNKNOWN": "Desconocida",
  "workbookDrafts.provenance.DECLARED_UNVERIFIED": "Declarada; sin verificar",
  "workbookDrafts.provenance.DECLARED_PROFILE_MAPPING": "Mapeo declarado del perfil",
  "workbookDrafts.authority.UNASSESSED": "Sin evaluar",
  "workbookDrafts.linkStatus.RECORDED_FOR_REVIEW": "Registrado para revisión",
  "workbookDrafts.documentReview.APPROVED": "Documento aprobado",
  "workbookDrafts.boolean.true": "Sí",
  "workbookDrafts.boolean.false": "No",
  "workbookDrafts.blocker.SOURCE_PROVENANCE_DECLARED":
    "Origen declarado; hoja de cálculo y mapeo todavía sin verificar",
  "workbookDrafts.blocker.OFFICIAL_EVIDENCE_REQUIRED":
    "Falta corroborar la fila con evidencia oficial",
  "workbookDrafts.blocker.LEGAL_INTERVAL_UNKNOWN": "Período de vigencia legal desconocido",
  "workbookDrafts.blocker.CLASSIFICATION_UNRESOLVED": "Clasificación fiscal pendiente",
  "workbookDrafts.blocker.PRODUCT_SCOPE_UNRESOLVED": "Aplicabilidad al producto pendiente",
  "workbookDrafts.blocker.ROUTE_SCOPE_UNRESOLVED": "Aplicabilidad a la ruta pendiente",
  "workbookDrafts.blocker.SUPPLIER_TAX_CONDITIONS_UNRESOLVED":
    "Condiciones fiscales del proveedor pendientes",
  "workbookDrafts.blocker.COVERAGE_COMPARISON_REQUIRED":
    "Falta comparar con la cobertura fiscal existente",
  "workbookDrafts.blocker.MISSING_VALUE": "Hay valores ausentes en el origen",
  "workbookDrafts.blocker.UNKNOWN_UNIT": "Hay valores decimales con unidad desconocida",
  "workbookDrafts.blocker.FORMULA_NOT_EXECUTED": "Fórmula conservada como huella; sin ejecutar",
  "workbookDrafts.blocker.CACHE_UNAVAILABLE": "Resultado almacenado de la fórmula no disponible",
  "workbookDrafts.purpose.CLASSIFICATION": "Clasificación fiscal",
  "workbookDrafts.purpose.ST_APPLICABILITY": "Aplicabilidad de ST",
  "workbookDrafts.purpose.MVA": "MVA",
  "workbookDrafts.purpose.ROUTE_SCOPE": "Aplicabilidad a la ruta",
  "workbookDrafts.purpose.LEGAL_INTERVAL": "Vigencia legal",
  "workbookDrafts.purpose.OTHER_FISCAL": "Otro tema fiscal",
  "workbookDrafts.field.sourceKey": "Identificador de origen",
  "workbookDrafts.field.originUf": "UF de origen informada",
  "workbookDrafts.field.ncmVariant": "NCM y variante informados",
  "workbookDrafts.field.ncmScope": "NCM o prefijo informado",
  "workbookDrafts.field.cest": "CEST informado",
  "workbookDrafts.field.originalMva": "MVA original informada",
  "workbookDrafts.field.destinationInternalRate": "Alícuota interna de destino informada",
  "workbookDrafts.field.appliedMvaObservation": "MVA aplicada informada",
  "workbookDrafts.field.treatmentText": "Texto sobre tratamiento fiscal",
  "workbookDrafts.field.legalReferenceText": "Texto de referencia legal",
  "workbookDrafts.field.destinationUf": "UF de destino informada",
  "workbookDrafts.field.mvaObservation": "MVA informada",
  "workbookDrafts.field.stApplicabilityDeclaration": "Declaración de aplicación de ST",
  "workbookDrafts.field.productScopeText": "Texto sobre el alcance del producto",
  "workbookDrafts.unit.EXCEL_FRACTION": "Fracción de Excel",
  "workbookDrafts.unit.PERCENT": "Porcentaje",
  "workbookDrafts.unit.UNKNOWN": "Unidad desconocida",
  "workbookDrafts.kind.NCM": "NCM informado",
  "workbookDrafts.kind.NCM_VARIANT": "NCM y variante",
  "workbookDrafts.kind.CEST": "CEST informado",
  "workbookDrafts.kind.UF": "UF informada",
  "workbookDrafts.kind.DECIMAL": "Valor decimal de origen",
  "workbookDrafts.kind.BOOLEAN": "Declaración sí/no",
  "workbookDrafts.kind.HASH_ONLY": "Solo huella; texto omitido",
  "workbookDrafts.kind.MISSING": "Valor ausente",
  "workbookDrafts.kind.FORMULA": "Fórmula sin ejecutar",
  "workbookDrafts.cache.ABSENT": "Sin resultado almacenado",
  "workbookDrafts.cache.EMPTY": "Resultado almacenado vacío",
  "workbookDrafts.cache.VALUE": "Resultado almacenado; fórmula sin ejecutar",
  "workbookDrafts.normalizedText": "Fragmento normalizado de esta página",
  "workbookDrafts.evidenceSearch": "Buscar documentos aprobados",
  "workbookDrafts.evidenceSearchHint":
    "Busque un documento aprobado y compruebe el título y la entidad publicadora antes de seleccionarlo.",
  "workbookDrafts.evidenceSearchPlaceholder": "Buscar documento",
  "workbookDrafts.evidenceSearchAction": "Buscar",
  "workbookDrafts.evidenceSearchResults": "{count} documentos aprobados en esta lista",
  "workbookDrafts.noEvidenceResults": "No se encontraron documentos aprobados. Ajuste la búsqueda.",
  "workbookDrafts.chooseEvidence": "Seleccionar documento",
  "workbookDrafts.evidencePublisher": "Entidad publicadora",
  "workbookDrafts.evidenceById": "Abrir por ID",
  "workbookDrafts.moreEvidence": "Cargar más documentos",
  "workbookDrafts.evidenceDocument": "Documento de evidencia",
  "fiscalExtract.open": "Guardar JSON fiscal",
  "fiscalExtract.title": "Admisión de extracto fiscal",
  "fiscalExtract.reset": "Limpiar",
  "fiscalExtract.preview": "Previsualizar JSON",
  "fiscalExtract.working": "Procesando…",
  "fiscalExtract.retain": "Guardar como NEW",
  "fiscalExtract.limits":
    "Pega solo el extracto JSON fiscal permitido. Este flujo no abre el XLSX ni verifica su hash o estructura. La vigencia legal sigue desconocida; ninguna regla se aprueba ni publica.",
  "fiscalExtract.json": "JSON fiscal (objeto extract)",
  "fiscalExtract.hint":
    "Perfil versionado COMMERCIAL_FISCAL_PARAMETERS_V1 · máximo 256 KB. Los textos libres y fórmulas deben ser huellas; los datos comerciales se rechazan.",
  "fiscalExtract.error":
    "No se pudo validar o guardar este JSON. Revisa el contrato, selección, permisos y conexión y vuelve a previsualizar.",
  "fiscalExtract.saved": "Extracto guardado como NEW",
  "fiscalExtract.previewTitle": "Revisar vista previa del JSON",
  "fiscalExtract.hash": "SHA-256 del extracto",
  "fiscalExtract.counts": "Observaciones seleccionadas",
  "fiscalExtract.countValues":
    "Filas fiscales tipadas: {fiscal} · sin datos tipados: {unknown} · referencias geográficas: {geographic} · réplicas: {duplicates}",
  "fiscalExtract.valid":
    "Selección JSON válida para guardar. Aún falta revisar evidencia oficial, procedencia, vigencia legal y aplicabilidad del producto.",
  "fiscalExtract.blocked":
    "Guardado bloqueado: corrige los diagnósticos de estructura, rango, tipo o réplicas en conflicto.",
  "fiscalExtract.diagnostics": "Diagnósticos por fila",
  "fiscalExtract.confirm":
    "Confirmo que este JSON contiene solo la selección fiscal permitida, sin datos comerciales. Entiendo que el hash y mapeo del workbook son declarados y no verificados.",
  "fiscalExtract.savedBody":
    "Se guardó un recibo JSON no ejecutable. No se creó documento de evidencia aprobado, propuesta ni regla. Recibo:",
  "fiscalExtract.diagnostic.LAYOUT_MAPPING_INVALID": "Mapeo declarado no coincide con el perfil",
  "fiscalExtract.diagnostic.PROFILE_RANGE_INVALID": "Hoja o fila fuera del perfil permitido",
  "fiscalExtract.diagnostic.DUPLICATE_LOCATOR": "Localizador de origen repetido",
  "fiscalExtract.diagnostic.CELL_TYPE_INVALID": "Tipo de celda incompatible con la columna",
  "fiscalExtract.diagnostic.MISSING_VALUE": "Valor faltante",
  "fiscalExtract.diagnostic.UNKNOWN_UNIT": "Unidad decimal desconocida",
  "fiscalExtract.diagnostic.FREE_TEXT_NOT_RETAINED": "Texto libre conservado solo como huella",
  "fiscalExtract.diagnostic.FORMULA_NOT_EXECUTED": "Fórmula conservada como huella; no ejecutada",
  "fiscalExtract.diagnostic.CACHE_UNAVAILABLE": "Sin caché utilizable de la fórmula",
  "fiscalExtract.diagnostic.ALIAS_CONFLICT": "Las hojas replicadas discrepan",

  "operation.federal.title": "PIS/COFINS de la operación",
  "operation.federal.regime": "Régimen declarado para esta simulación",
  "operation.federal.unknown": "Sin informar / pendiente",
  "operation.federal.cumulative": "Acumulativo",
  "operation.federal.nonCumulative": "No acumulativo",
  "operation.federal.creditEligibility": "Derecho a crédito en esta adquisición",
  "operation.federal.eligible": "Adquisición elegible según análisis fiscal",
  "operation.federal.ineligible": "Sin derecho a crédito",
  "operation.federal.catalog": "Resolver con el catálogo legal",
  "operation.federal.stBasis":
    "El análisis fiscal confirma PIS/COFINS sobre el valor de venta cuando ST cierra la operación interna.",
  "operation.federal.declarationHint":
    "Declaraciones del operador para esta simulación. El régimen de BackChannel sigue sin acreditar; confirme régimen, clasificación y derecho a crédito con el responsable fiscal. Simples Nacional queda fuera.",
  "operation.federal.calculatedScope":
    "PIS/COFINS incluidos según las declaraciones y fuentes siguientes. Recuperación de ST sin determinar; FCP solo cuando se informa. Esta simulación no certifica el régimen de la empresa.",
  "operation.federal.fiscalTotals":
    "Los totales de esta memoria ICMS/IPI conservan su alcance original. PIS/COFINS aparecen por separado y se incluyen en la vista comercial cuando se calculan.",
  "operation.federal.base": "Base sin ICMS propio",
  "operation.federal.pending.FISCAL_LEGS_PENDING":
    "PIS/COFINS esperan la resolución fiscal de la compra y la venta.",
  "operation.federal.pending.REGIME_UNKNOWN":
    "Informe el régimen PIS/COFINS validado por el responsable fiscal.",
  "operation.federal.pending.PROFILE_PENDING":
    "El perfil del producto requiere confirmación fiscal; no se presume ninguna tasa.",
  "operation.federal.pending.CREDIT_ELIGIBILITY_UNKNOWN":
    "Falta confirmar el derecho a crédito de esta adquisición. No se deduce un crédito supuesto.",
  "operation.federal.pending.ST_RESALE_BASIS_UNKNOWN":
    "Falta confirmar la base federal de la reventa interna con ST cerrada en la entrada.",
  "operation.federal.pending.POST_2026_REGIME":
    "Desde 2027, este cálculo de PIS/COFINS espera la transición CBS. No se aplican tasas anteriores.",
  "operation.federal.pending.PURCHASE_OWN_ICMS_UNKNOWN":
    "Compra a distribuidor con ST previa: falta el ICMS propio desglosado para determinar la base del crédito federal.",
  "operation.federal.pending.RATE_RULE_AMBIGUOUS":
    "Hay reglas federales publicadas en conflicto para esta ruta; requiere revisión.",
  "commercial.federalPurchaseCredit": "Crédito PIS/COFINS de compra",
  "commercial.federalSaleDebit": "Débito PIS/COFINS de venta",
  "commercial.federalCarryover": "Saldo de crédito PIS/COFINS · activo",
  "overview.issue.purchaseCreditBasePending": "Base de crédito de compra sin confirmar",
  "issueHelp.purchaseCreditBasePending":
    "El precio incluye ST anterior, pero falta el desglose fiscal validado para calcular créditos de PIS/COFINS. Revisa la base fiscal antes de usar el costo neto o el margen.",
  "calcTrace.step.SUPPLIER_CREDIT_BASE_PENDING": "Base de crédito de compra pendiente",
  "supplier.type": "Tipo de proveedor",
  "supplier.choose": "Selecciona el tipo de proveedor",
  "supplier.legacy": "Mantener cálculo anterior · sin declaración",
  "supplier.industry": "Industria",
  "supplier.distributor": "Proveedor / distribuidor ordinario",
  "supplier.hint":
    "El distribuidor ordinario no cobra IPI de fabricante. Un establecimiento equiparado a industrial requiere su propio análisis.",
  "supplier.priorSt": "¿ST ya pagado e incluido en el precio?",
  "supplier.stUnknown": "Sin verificar · revisar factura",
  "supplier.stConfirmed": "Sí · retención anterior confirmada",
  "supplier.stNotConfirmed": "Sin confirmar",
  "supplier.stHint":
    "La confirmación solo aplica a una operación interna con ST vigente. Las operaciones interestatales requieren analizar la retención en factura; no hay exención automática.",
  "supplier.templateHint":
    "Completa tipo_fornecedor con INDUSTRY o DISTRIBUTOR. Para un distribuidor interno, st_pago_anteriormente=TRUE confirma ST anterior incluido en el precio; FALSE o vacío no confirma retención. Sigue siendo obligatoria una regla vigente.",
  "lotMap.field.tipo_fornecedor": "Tipo de proveedor · INDUSTRY o DISTRIBUTOR",
  "lotMap.field.st_pago_anteriormente": "ST anterior incluido · TRUE o FALSE",
  "wb.field.tipo_fornecedor": "tipo de proveedor",
  "wb.field.st_pago_anteriormente": "ST pagado anteriormente",
  "overview.issue.purchaseStStatusPending": "ST de compra requiere confirmación",
  "issueHelp.purchaseStStatusPending":
    "Revisa la factura y la regla vigente: distribuidor no implica exención de ST; la retención anterior solo se confirma en una ruta interna con ST aplicable.",
  "calcTrace.step.DISTRIBUTOR_IPI_NOT_CHARGED": "Distribuidor ordinario · sin IPI de fabricante",
  "calcTrace.step.SUPPLIER_ST_PREVIOUSLY_PAID": "ST anterior incluido en el precio",
  "calcTrace.step.SUPPLIER_ST_PENDING": "Retención de ST pendiente de confirmación",
  "monetary.inputCost": "Costo de mercancía",
  "monetary.resultBasisHint":
    "Para entradas UNIT o LINE_TOTAL, los impuestos y costos calculados son totales de línea. En el formato anterior son unitarios. El costo editable conserva la base declarada en la entrada.",
  "lotMap.field.custo_original": "Costo original declarado",
  "monetary.amountBrl": "Valor (R$)",
  "monetary.lotCostTotal": "Costo total del lote (con cantidades)",
  "monetary.tableHint":
    "Valores calculados en la base indicada en cada fila: total de línea o unitario en el formato anterior.",
  "monetary.unitShort": "Unitario",
  "monetary.totalShort": "Total de línea",

  "monetary.templateHint":
    "En el template, indique UNIT o LINE_TOTAL en base_valor y UN, CX, etc. en unidade_comercial. UNIT requiere cantidad; no complete impuestos calculados.",
  "calcTrace.step.COMMERCIAL_FIXED_COSTS_EXTENDED": "Costos fijos por unidad comercial × cantidad",

  "monetary.basis": "Base de los valores",
  "monetary.unit": "Precio por unidad comercial · hasta 6 decimales",
  "monetary.total": "Total de mercancía de la línea",
  "monetary.legacy": "Formato anterior · cálculo por unidad",
  "monetary.commercialUnit": "Unidad comercial (UN, CX…)",
  "monetary.totalCost": "Costo total de mercancía (R$)",
  "monetary.lineQuantity": "Resultado por línea · cantidad comercial {quantity}",
  "monetary.result": "Costo fiscal total de la línea",
  "monetary.lineUnit": "BRL por línea",
  "monetary.hint":
    "El precio unitario se multiplica por cantidad antes de redondear la línea. El total no se multiplica de nuevo. CX es la unidad comercial; no se infiere el contenido de la caja.",
  "lotMap.field.base_valor": "Base del valor · UNIT o LINE_TOTAL",
  "lotMap.field.unidade_comercial": "Unidad comercial",
  "wb.field.base_valor": "base del valor",
  "wb.field.unidade_comercial": "unidad comercial",
  "calcTrace.step.MONETARY_BASIS_NORMALIZED": "Valor total de línea normalizado",

  "commercial.editConditions": "Editar condiciones y gastos comerciales",
  "commercial.upfront": "Al contado",
  "commercial.days": "{count} días",
  "commercial.title": "Vista comercial",
  "commercial.subtitle": "Flujo de caja y P&L de la misma operación, con conciliación de créditos.",
  "commercial.transaction": "Tipo de transacción",
  "commercial.buySell": "Compra y venta",
  "commercial.status": "Estado",
  "commercial.simulation": "Simulación · parcial",
  "commercial.supplierName": "Vendedor original",
  "commercial.customerName": "Comprador final",
  "commercial.partyLocation": "{name} · Estado: {uf}",
  "commercial.category": "Categoría",
  "commercial.supplierPaymentDays": "Plazo del proveedor (días)",
  "commercial.customerPaymentDays": "Plazo del comprador (días)",
  "commercial.paymentPlaceholder": "0 = al contado",
  "commercial.paymentHint":
    "Plazos informativos. Esta vista no proyecta fechas de caja ni calcula intereses por plazo.",
  "commercial.expenses": "Gastos comerciales de la operación",
  "commercial.expensesHint":
    "Indique los totales en R$, incluido cero cuando no haya gasto. No son precios unitarios ni tasas fiscales.",
  "commercial.scope":
    "Subtotal parcial: PIS/COFINS pendientes o fuera de esta simulación. FCP solo cuando la regla lo informa. Contribución y margen aún no representan el resultado completo.",
  "commercial.cashFlow": "Flujo de caja",
  "commercial.cashHint": "Desembolsos e ingresos; el saldo de crédito no se convierte en caja.",
  "commercial.profitLoss": "P&L · resultados",
  "commercial.earningsHint": "Costo neto del crédito e impuestos de venta antes de compensarlos.",
  "commercial.salesPrice": "Precio de venta",
  "commercial.cashTaxes": "(−) Impuestos pagados en venta · parcial",
  "commercial.netRevenue": "(=) Ingreso neto · parcial",
  "commercial.acquisitionPrice": "(−) Precio de adquisición",
  "commercial.grossProfit": "(=) Beneficio bruto · parcial",
  "commercial.operations": "Gastos operativos",
  "commercial.commission": "Comisión de terceros",
  "commercial.financing": "Costo de anticipo de crédito",
  "commercial.contribution": "(=) Contribución antes de bonos · parcial",
  "commercial.creditBalance": "Saldo de crédito fiscal · activo",
  "commercial.gmv": "Ingreso bruto (GMV sin ST de transferencia)",
  "commercial.earningsTaxes": "(−) Impuestos sobre venta · parcial",
  "commercial.cogs": "(−) Costo de mercancía (CMV)",
  "commercial.margin": "Contribución / GMV · parcial",
  "commercial.cashTaxesTitle": "Impuestos y créditos",
  "commercial.icmsPayable": "ICMS por pagar",
  "commercial.difalFcp": "DIFAL y FCP en venta",
  "commercial.customerSt": "ST/FCP cobrado al cliente · transferencia",
  "commercial.pisCofins": "PIS/COFINS",
  "commercial.pending": "Pendiente",
  "commercial.stRecovery": "Recuperación de ST",
  "commercial.notAssessed": "Sin determinar",
  "commercial.creditHint":
    "El crédito no utilizado es un activo. La recuperación de ST depende de análisis y procedimiento; no se sumó a caja ni al beneficio.",
  "commercial.acquisition": "Adquisición",
  "commercial.purchaseInvoice": "Valor de adquisición con IPI/ST",
  "commercial.purchaseCredit": "(−) Créditos fiscales de compra incluidos",
  "commercial.netInventory": "(=) Inventario neto · parcial",
  "commercial.sales": "Venta",
  "commercial.salesInvoice": "(=) Total de factura de venta",
  "commercial.expensesPending":
    "Complete los tres gastos para calcular la contribución. Use cero explícitamente cuando no haya costo.",
  "commercial.unsaved": "Simulación comercial sin guardar",
  "commercial.hideInputs": "Ocultar datos fiscales",
  "commercial.editInputs": "Editar compra y venta",

  "operation.supplierType": "Tipo de proveedor",
  "operation.supplierType.industry": "Industria o equiparado",
  "operation.supplierType.distributor": "Distribuidor / revendedor común",
  "operation.supplierType.hint":
    "Industria: IPI y ST según la regla. Revendedor común: sin IPI de fabricante; indica la situación de ST en la compra.",
  "operation.valueBasis": "Valores ingresados",
  "operation.valueBasis.unit": "Precios por unidad",
  "operation.valueBasis.total": "Totales de la operación",
  "operation.quantity": "Cantidad de unidades comerciales",
  "operation.quantity.hint":
    "Use la misma unidad de compra y venta. Los precios conservan hasta seis decimales antes de multiplicar.",
  "operation.purchaseUnitValue": "Compra por unidad, antes de IPI y ST (R$)",
  "operation.saleUnitValue": "Venta por unidad, antes de la ST trasladada (R$)",
  "operation.invalid.supplierType": "Seleccione el tipo de proveedor.",
  "operation.invalid.quantity": "Indique una cantidad entera de 1 a 999.999.999.",
  "operation.invalid.precision":
    "Revise los valores: unitarios hasta seis decimales, totales hasta dos y sin superar el límite monetario.",
  "operation.stPreviouslyPaid":
    "La NF confirma ST anterior incluida en el precio, sin nuevo cargo en esta compra interna.",
  "operation.stPreviouslyPaid.short": "ST anterior incluida en el precio",
  "operation.distributor.internalHint":
    "Confirme la ST anterior con soporte de la NF. Sin confirmación, un producto sujeto a ST queda en revisión.",
  "operation.distributor.interstateHint":
    "En compra interestatal, indica la ST retenida para el destino en la NF. Ser distribuidor requiere revisar la anticipación.",
  "operation.issue.purchase_ipi_pending":
    "Falta resolver el tratamiento de IPI de la compra industrial. La falta de información no significa tasa cero.",
  "operation.issue.purchase_fcp_pending":
    "El FCP-ST de la compra es desconocido o no está incluido en el costo.",
  "operation.ipiPending": "IPI con tratamiento fiscal pendiente",
  "operation.issue.purchase_st_status_pending":
    "Confirme la ST de compra: retención en la NF o ST anterior en compra interna.",
  "operation.commercialSummary": "Resumen comercial",
  "operation.closedSalePrice": "Precio de venta ingresado, con ST/FCP de la NF cuando corresponda.",
  "operation.showFiscalDetails": "Ver tributos, créditos y memoria de cálculo",
  "operation.unitExtended": "Precio unitario × cantidad",
  "operation.distributorIpi": "IPI sin nuevo cargo del revendedor",
  "calcTrace.step.BASE_SELECTED": "Base de cálculo seleccionada",
  "calcTrace.step.RULE_SELECTED": "Regla seleccionada",
  "calcTrace.step.RULE_NOT_SELECTED": "Regla no encontrada",
  "calcTrace.step.TAX_EXEMPT": "Tributo exento",
  "calcTrace.step.TAX_EXCLUDED": "No informado por la regla",
  "calcTrace.step.IPI_CALCULATED": "IPI calculado",
  "calcTrace.step.ICMS_ST_CALCULATED": "ICMS-ST calculado",
  "calcTrace.step.ICMS_ST_MVA_ADJUSTMENT": "Ajuste de la MVA",
  "calcTrace.step.ICMS_ST_NOT_APPLICABLE": "ICMS-ST no aplica",
  "calcTrace.step.ICMS_STANDARD_CALCULATED": "ICMS propio calculado",
  "calcTrace.step.PIS_CALCULATED": "PIS calculado",
  "calcTrace.step.COFINS_CALCULATED": "COFINS calculada",
  "calcTrace.step.ISS_CALCULATED": "ISS calculado",
  "calcTrace.step.OPERATIONAL_COST_CALCULATED": "Costo operativo calculado",
  "calcTrace.step.COMMERCIAL_FEE_CALCULATED": "Tarifa comercial calculada",
  "calcTrace.step.OPERATIONAL_COST_NOT_CONFIGURED": "Costo operativo no configurado",
  "calcTrace.step.COMMERCIAL_FEE_NOT_CONFIGURED": "Tarifa comercial no configurada",
  "calcTrace.step.TOTAL_CALCULATED": "Costo fiscal puesto calculado",
  "calcTrace.step.FCP_CALCULATED": "FCP calculado",
  "calcTrace.step.FCP_NOT_APPLICABLE": "FCP no aplica",
  "calcTrace.step.FCP_NOT_TRACKED": "FCP no seguido",
  "calcTrace.step.PIS_COFINS_RATE_SELECTED": "Alícuotas de PIS/COFINS seleccionadas",
  "calcTrace.step.PIS_COFINS_NOT_TRACKED": "PIS/COFINS no seguido",
  "calcTrace.step.SALE_PRICE_CALCULATED": "Precio de venta calculado",
  "calcTrace.step.PIS_ON_SALE_CALCULATED": "PIS en la venta calculado",
  "calcTrace.step.COFINS_ON_SALE_CALCULATED": "COFINS en la venta calculada",
  "calcTrace.step.MARGIN_CALCULATED": "Margen calculado",
  "calcTrace.step.NET_SALE_PRICE_CALCULATED": "Precio de venta por margen neto calculado",
  "calcTrace.step.NET_SALE_LEG_INVALID": "Tramo de venta inválido",
  "calcTrace.step.NET_MARGIN_UNREACHABLE": "Margen neto inalcanzable",
  "calcTrace.step.PURCHASE_OWN_ICMS_CALCULATED": "ICMS propio de la compra calculado",
  "calcTrace.step.PURCHASE_OWN_ICMS_NOT_TRACKED": "ICMS propio de la compra no seguido",
  "calcTrace.step.PURCHASE_PIS_COFINS_CALCULATED": "PIS/COFINS de la compra calculado",
  "calcTrace.step.PURCHASE_PIS_COFINS_NOT_TRACKED": "PIS/COFINS de la compra no seguido",
  "calcTrace.step.TR_SALE_PRICE_CALCULATED": "Precio de venta (costo + TR) calculado",
  "calcTrace.step.TR_SALE_LEG_CALCULATED": "Tramo de venta (costo + TR) calculado",
  "calcTrace.step.TR_SALE_IMPORTED_INTERSTATE_RATE":
    "Alícuota interestatal de importados en la venta con TR (4%)",
  "calcTrace.step.NET_SALE_IMPORTED_INTERSTATE_RATE":
    "Alícuota interestatal de importados en la venta a margen neto (4%)",
  "calcTrace.step.ICMS_IMPORTED_INTERSTATE_RATE": "Alícuota interestatal de importados (4%)",
  "calcTrace.step.ICMS_GENERAL_RULE_APPLIED": "Regla general de ICMS aplicada",
  "calcTrace.step.ICMS_DESTINATION_ST_DERIVED": "ICMS-ST del destino derivado",
  "calcTrace.step.ICMS_ST_FCP_IN_ALQ_INTRA": "FECP en la alícuota interna de la MVA ajustada",
  "calcTrace.step.ICMS_ST_SENDER_WITHHOLDING": "ST retenido por el remitente",
  "calcTrace.step.PURCHASE_OWN_ICMS_STATUTORY_RATE": "Alícuota interestatal legal del ICMS propio",
  "calcTrace.step.RESALE_PURCHASE_CALCULATED": "Compra para reventa calculada",
  "calcTrace.step.RESALE_SALE_CALCULATED": "Venta de reventa calculada",
  "calcTrace.step.RESALE_MARGIN_CALCULATED": "Margen de reventa calculado",
  "calcTrace.step.RESALE_MARGIN_PENDING": "Margen de reventa pendiente",
  "calcTrace.step.PIS_COFINS_PROFILE_RESOLVED": "Perfil de PIS/COFINS resuelto",
  "calcTrace.result.NOT_TRACKED": "no seguido",
  "calcTrace.result.NOT_CONFIGURED": "no configurado",
  "calcTrace.result.NOT_CALCULATED": "no calculado",
  "calcTrace.result.NOT_PRICED": "sin precio",
  "lotOps.fixedInput": "Ruta fija configurada para el archivo",
  "lotOps.inferredBySheet": "Inferida por la planilla",
  "lotOps.editedInput": "Valor corregido; en el archivo: {value}",
  "lotOps.finding": "Dato encontrado",
  "lotOps.missingFields": "Campos pendientes",
  "lotOps.detailDescription": "Resultados, cobertura y memoria fiscal de cada fila.",
  "lotOps.today": "Operación de hoy",
  "lotOps.live": "Actualización automática",
  "lotOps.lotsToday": "Lotes hoy",
  "lotOps.rowsCalculated": "Filas calculadas",
  "lotOps.rowsReview": "Filas en revisión",
  "lotOps.taxRecorded": "Tributos registrados",
  "lotOps.researchRunning": "Investigaciones en curso",
  "lotOps.summaryScope":
    "Todos los {count} lotes de hoy. Valores calculados × cantidad; los escenarios son alternativas independientes.",
  "lotOps.summaryLimited": "Hay más lotes en el período.",
  "lotOps.upload": "Enviar planillas",
  "lotOps.scenarios.one": "1 escenario de este archivo",
  "lotOps.scenarios.other": "{count} escenarios del mismo archivo",
  "lotOps.independentScenarios": "Alternativas; no sumar entre sí",
  "lotOps.open": "Abrir",
  "lotOps.export": "Exportar CSV",
  "lotOps.exportExcel": "Descargar Excel comercial",
  "lotOps.exportLimit": "Exportación limitada a 20.000 filas.",
  "lotOps.recalculateHelp": "Abrir registro y elegir nueva versión para recalcular",
  "lotOps.actions": "Acciones",
  "lotOps.eta": "~{minutes} min restantes",
  "lotOps.etaWaiting": "Estimando tiempo restante",
  "lotOps.dynamic": "Ruta por fila",
  "lotOps.allRoutes": "Todas las rutas",
  "lotOps.excluded": "Filas excluidas",
  "lotOps.totalIpi": "Total IPI",
  "lotOps.totalSt": "Total ICMS-ST",
  "lotOps.totalLanded": "Costo fiscal total",
  "lotOps.coverage": "Cobertura",
  "lotOps.quantityTotals": "Valores ponderados por cantidad; solo filas calculadas.",
  "lotStory.title": "De la compra al precio",
  "lotStory.basis": "Valores del lote ponderados por cantidad · {rows} de {total} filas calculadas",
  "lotStory.loading": "Sumando las filas del lote…",
  "lotStory.purchase": "Costo de compra",
  "lotStory.purchaseTaxes": "Impuestos en la compra",
  "lotStory.otherTaxes": "otros tributos {value}",
  "lotStory.landed": "Costo puesto",
  "lotStory.sale": "Precio de venta",
  "lotStory.margin": "Margen neto",
  "lotStory.notPriced": "No calculado",
  "lotStory.onSale": "En la venta:",
  "lotStory.pisCofinsUntracked": "PIS/COFINS no se siguen en este régimen",
  "lotStory.credits": "créditos {value}",
  "lotStory.saleSt": "ICMS-ST/FCP-ST en las NF de venta {value}",
  "lotStory.invoices.title": "NF de compra vs NF de venta:",
  "lotStory.invoices.body": "compra {purchase} · venta {sale} · diferencia bruta {difference}",
  "lotStory.invoices.pisCofinsNet": "PIS/COFINS a pagar (venta − crédito de la compra) {value}",
  "lotStory.invoices.discounted":
    "Con el descuento de la planilla (solo visualización, no cambia la base de los impuestos): V final comprador {saleFinal} ({saleDiscount}) · V final vendedor {purchaseFinal} ({purchaseDiscount}) · diferencia neta {net}",
  "lotStory.invoices.discount.with": "descuento {pct} · {cell}",
  "lotStory.invoices.discount.none": "sin descuento",
  "lotStory.invoices.discount.hint":
    "Descuento comercial leído de la planilla. Si es incondicional (en la NF), reduce la base del ICMS y del PIS/COFINS; eso depende de la confirmación del dueño, así que aquí solo aparece en los totales.",
  "lotStory.priceHint":
    "Para ver precio de venta, PIS/COFINS en la venta y margen, use Recalcular lote y elija un método en Precio de venta.",
  "lotStory.notTracked": "no seguido",
  "lotStory.column.pis": "PIS venta",
  "lotStory.column.cofins": "COFINS venta",
  "lotStory.column.icmsSale": "ICMS venta",
  "lotStory.column.saleSt": "ICMS-ST/FCP-ST venta",
  "lotStory.column.saleStHint": "ICMS-ST + FCP-ST en la NF de venta (columna AU de la planilla).",
  "lotStory.column.saleStFcpUntracked": "FCP-ST no seguido",
  "lotStory.column.buyerInvoice": "NF comprador",
  "lotStory.done": "Lote calculado",
  "lotStory.doneReview": "Lote calculado con filas para revisar",
  "lotStory.rows.one": "{count} fila",
  "lotStory.rows.other": "{count} filas",
  "lotStory.in": "en {duration}",
  "lotStory.seconds": "{count} s",
  "lotStory.minutesSeconds": "{minutes} min {seconds} s",
  "lotStory.calculated": "{count} calculadas",
  "lotStory.toReview": "{count} para revisar",
  "lotStory.excluded": "{count} excluidas",
  "lotStory.coverage": "cobertura hoy {value}",
  "lotStory.coverageStale":
    "La cobertura de las reglas publicadas actuales incluye {covered} filas; este registro calculó {calculated}. El recálculo sigue verificando la calificación fiscal de la operación.",
  "lotStory.rules": "reglas {version}",
  "lotStory.date": "fecha fiscal {date}",
  "lotStory.next.title": "Próximos pasos",
  "lotStory.next.export": "Descargar Excel comercial",
  "lotStory.next.exportBody":
    "Todas las filas, con impuestos, precio, PIS/COFINS y la regla de cada una.",
  "lotStory.next.share": "Copiar enlace del lote",
  "lotStory.next.shareBody":
    "Para que un colega con acceso abra este mismo resultado, con la memoria fijada.",
  "lotStory.next.review.one": "Revisar {count} fila",
  "lotStory.next.review.other": "Revisar {count} filas",
  "lotStory.next.reviewBody":
    "Filtra la tabla en las filas que necesitan revisión, con el motivo de cada una.",
  "lotStory.next.research.one": "Investigar {count} vacío",
  "lotStory.next.research.other": "Investigar {count} vacíos",
  "lotStory.next.researchBody":
    "Combinaciones de ruta y NCM sin regla publicada: el agente busca evidencia en la web para revisión.",
  "lotStory.linkCopied": "Enlace del lote copiado",
  "lotStory.linkManual": "Copie el enlace del lote",
  "lotStory.row.title": "Historia de esta fila",
  "lotStory.row.base": "Costo",
  "lotStory.row.otherTaxes": "Otros tributos",
  "lotStory.row.icmsSale": "ICMS venta",
  "lotStory.row.credits": "Créditos",
  "lotStory.row.costBasis": "Costo puesto (base del precio)",
  "lotStory.row.onSale": "En la venta, por unidad",
  "lotStory.row.notPriced":
    "Precio y margen no calculados: el lote se calculó sin método de Precio de venta.",
  "lotStory.row.unusable":
    "Esta fila no tiene valores utilizables: no se muestra ningún valor hasta resolver la revisión.",
  "lotStory.compare.match": "Igual",
  "lotStory.compare.difference": "Diferente",
  "lotStory.compare.pending": "Sin cálculo",
  "lotStory.compare.allMatch": "· todo igual al archivo",
  "lotStory.compare.differs": "· {count} diferencia(s) con el archivo",
  "lotStory.outside.title": "Fuera del costo puesto:",
  "lotStory.outside.ownIcms": "ICMS propio de la compra {value}",
  "lotStory.outside.pisCofins": "PIS/COFINS de la compra (fuera de la base) {value} · {treatment}",
  "lotStory.outside.treatment.CREDIT": "crédito (no acumulativo)",
  "lotStory.outside.treatment.INFORMATIONAL": "informativo (sin crédito en este régimen)",
  "lotStory.outside.treatment.MIXED": "crédito o informativo según el régimen de cada fila",
  "lotStory.outside.pisCofinsUntracked":
    "PIS/COFINS de la compra sin seguimiento: elija el régimen PIS/COFINS al recalcular el lote",
  "lotStory.outside.untrackedRows.one": "{count} fila sin régimen PIS/COFINS",
  "lotStory.outside.untrackedRows.other": "{count} filas sin régimen PIS/COFINS",
  "lotStory.outside.burdenNeeded.one":
    "Regla necesaria: {count} fila de operación interna sin reducción de base declarada en la regla. El ICMS propio usó la alícuota nominal; si hay reducción (p. ej. art. 39 del Anexo II del RICMS/SP), debe publicarse en la regla.",
  "lotStory.outside.burdenNeeded.other":
    "Regla necesaria: {count} filas de operación interna sin reducción de base declarada en la regla. El ICMS propio usó la alícuota nominal; si hay reducción (p. ej. art. 39 del Anexo II del RICMS/SP), debe publicarse en la regla.",
  "lotStory.row.outside": "Fuera del costo puesto (no suma al costo)",
  "lotStory.row.ownIcms": "ICMS propio de la compra",
  "lotStory.row.notInCost": "fuera del costo",
  "lotStory.row.buyerInvoice":
    "NF de venta del comprador = {price} + ICMS-ST {st} + FCP-ST {fcp} = {total}",
  "lotStory.row.ownIcmsFormula": "{base} × {rate}",
  "lotStory.row.ownIcmsReduced": "base reducida {base} × {nominal} = carga de {rate} · {reference}",
  "lotStory.row.pisCofins": "PIS/COFINS de la compra (fuera de la base)",
  "lotStory.row.pisCofinsFormula": "({base} − ICMS propio {icms}) × {rate}",
  "lotStory.row.pisCofinsCredit": "crédito (no acumulativo)",
  "lotStory.row.pisCofinsInfo": "informativo",
  "lotStory.row.pisCofinsUntracked": "sin seguimiento: elija el régimen PIS/COFINS del lote",
  "lotStory.row.burdenNeeded":
    "Regla necesaria: la regla de esta operación interna no declara reducción de base; el ICMS propio usó la alícuota nominal.",
  "lotStory.row.ownIcmsStatutory":
    "Alícuota interestatal legal del ICMS propio (compra sin ST): {reference}.",
  "lotStory.row.burdenExpired":
    "La carga efectiva de la regla está fuera de vigencia en esta fecha; el ICMS propio usó la alícuota nominal.",
  "lotOps.partialTotals": "Subtotal parcial: pendientes excluidos de los importes.",
  "lotOps.byNcm": "Tributos por NCM",
  "lotOps.byRoute": "Tributos por ruta",
  "lotOps.reviewReasons": "Qué necesita revisión",
  "lotOps.fixHint": "Elija un motivo para ver las filas afectadas.",
  "lotOps.fixCost": "Corregir costo o mapeo del archivo",
  "lotOps.fixClassification": "Revisar NCM, CEST y clasificación",
  "lotOps.fixProfile": "Confirmar el tratamiento por el producto y recalcular",
  "lotOps.fixRule": "Investigar y revisar la regla; publicar antes de recalcular",
  "lotOps.rowCount": "{count} filas",
  "lotOps.rowCountCalculated": "{calculated} de {count} filas calculadas",
  "lotOps.resultCount": "{count} resultados",
  "lotOps.waitingResults": "Los resultados aparecerán al terminar los bloques.",
  "lotOps.unavailable": "Valor no disponible",
  "lotOps.research": "Investigación fiscal de esta planilla",
  "lotOps.webUnverified":
    "La investigación reúne evidencias candidatas. Su verificación y la publicación de reglas son etapas distintas; consulte la situación de cada una a continuación.",
  "lotOps.allResearch": "Ver investigaciones",
  "lotOps.noResearch":
    "Ninguna investigación vinculada. Use “Buscar con agente” para investigar las lagunas.",
  "lotOps.noGaps": "Sin lagunas de cobertura en esta versión.",
  "lotOps.rowResearch": "Investigación de esta fila",
  "lotOps.sourceRow": "Fila {row} del archivo",
  "lotOps.sourceUnavailable": "Coordenadas de origen no registradas para este lote.",
  "lotOps.ruleUnavailable": "No hay una regla determinista para esta fila.",
  "lotOps.anyOrigin": "La regla acepta cualquier origen; el destino define el alcance.",
  "lotOps.stepInputs": "Entradas y precisión de cada paso",
  "lotOps.compare": "Comparar con valores del archivo",
  "lotOps.fileValue": "En el archivo",
  "lotOps.calculatedValue": "Calculado",
  "lotOps.noComparison": "El archivo no tiene columnas de comparación mapeadas.",
  "lotOps.tableHint": "Valores por unidad · abra la fila para ver la memoria",
  "lotOps.inTape": "Ver memoria",
  "lotOps.warning.short": "Con aviso",
  "lotOps.warning.coverageNeedsReview":
    "Revisar la regla {rule}: informa ICMS interestatal de {stated} para cualquier origen, pero la Res. SF 22/89 fija {expected} para esta ruta. Los valores no se modificaron.",
  "lotOps.warningRows": "Calculadas con aviso",
  "lotOps.group.base": "Base",
  "lotOps.group.ipi": "IPI",
  "lotOps.group.own": "ICMS propio",
  "lotOps.group.st": "ICMS-ST",
  "lotOps.group.landedAmount": "Costo fiscal (R$)",
  "lotOps.stBaseAmount": "Base ST (R$)",
  "lotOps.group.landed": "Costo fiscal / un.",
  "lotOps.group.workbookCost": "Costo como en la planilla",
  "lotOps.workbookCostFormula": "Prod + IPI + ST",
  "lotOps.workbookCostHint":
    "Como la planilla (columna AQ): productos + IPI + ICMS-ST. No suma el ICMS propio. El costo puesto del motor suma el ICMS propio cuando no hay ST (decisión pendiente del dueño).",
  "lotOps.importedOrigin": "Importada · {origin}",
  "lotOps.group.purchasePisCofins": "PIS/COFINS compra",
  "lotOps.purchasePisCofinsHint":
    "PIS/COFINS de la compra fuera de la base: (costo − ICMS propio) × alícuota. No entra en el costo.",
  "lotOps.group.issues": "Pendientes",
  "lotOps.quantity": "Cant.",
  "lotOps.rate": "Alícuota",
  "lotOps.perUnitBrl": "BRL / ud.",
  "lotOps.mva": "MVA orig. → ajust.",
  "lotOps.stBase": "Base ST / un.",
  "lotOps.openRow": "Abrir memoria de {item}",
  "lotOps.search": "Buscar ítem, SKU o NCM",
  "lotOps.filter.status": "Todos los estados",
  "lotOps.filter.route": "Todas las rutas",
  "lotOps.filter.ncm": "Todos los NCM",
  "lotOps.filter.issue": "Todos los pendientes",
  "lotOps.clearFilters": "Limpiar filtros",
  "lotOps.disconnected": "Actualización interrumpida. Mostrando el último estado confirmado.",
  "lotOps.scenario": "Escenario fiscal",
  "lotOps.routeUnrecorded": "Modo de ruta no registrado",
  "lotOps.pinnedRecord": "Registro fijado",
  "lotOps.queueTitle": "Cola de archivos",
  "lotOps.queueHint":
    "Confirme las hojas de cada archivo, en secuencia. Los lotes siguen en curso.",
  "lotOps.queueMore": "Suelte más planillas aquí o elija archivos",
  "lotOps.nextFile": "Configurar siguiente archivo",
  "lotOps.nextFileUncalculated":
    "Este archivo todavía no se calculó: si sigue, queda importado en Lotes, sin cálculo.",
  "lotOps.queuePosition": "Archivo {current} de {total}",
  "lotOps.queueWaiting": "En cola",
  "lotOps.queueActive": "Configurando",
  "lotOps.queueDone": "Hojas confirmadas",
  "lotOps.queueSkip": "Omitir archivo",
  "lotOps.followLots": "Seguir todos los lotes",

  "calculatorFocus.back": "Volver",
  "calculatorFocus.announce": "Modo calculadora. Pulse Escape para volver.",
  "calculatorUi.memoryPermission":
    "La lectura de la memoria detallada no está disponible para este perfil. Consulte a un operador con acceso a los cálculos.",
  "calculatorUi.currencyHint": "Moneda: reales brasileños (BRL).",
  "calculatorUi.origin.entered": "Informado",
  "calculatorUi.origin.published": "Regla publicada",
  "calculatorUi.origin.calculated": "Calculado",
  "calculatorUi.origin.pending": "Pendiente",
  "calculatorUi.origin.finding": "Evidencia — pendiente de revisión",
  "calculatorUi.origin.treatment": "Tratamiento publicado",
  "calculatorUi.status.covered": "Cubierto",
  "calculatorUi.status.missing": "Sin regla",
  "calculatorUi.status.stale": "Fuera de vigencia",
  "calculatorUi.status.researching": "Investigando",
  "calculatorUi.status.unchecked": "No verificado",
  "calculatorUi.status.review": "Revisión necesaria",
  "calculatorUi.why": "¿Por qué este valor? {label}",
  "calculatorUi.date": "Fecha del cálculo",
  "calculatorUi.selected": "Conjunto seleccionado",
  "calculatorUi.pinned": "Calculado con",
  "calculatorUi.viewMemory": "Ver memoria",
  "calculatorUi.memory": "Memoria de cálculo",
  "calculatorUi.purchasePisCredit": "Crédito de PIS · compra",
  "calculatorUi.purchaseCofinsCredit": "Crédito de COFINS · compra",
  "calculatorUi.memoryHint":
    "Entradas y valores del registro, en orden de lectura. La memoria original se conserva en el detalle.",
  "calculatorUi.result.empty": "Esperando entradas",
  "calculatorUi.result.loading": "Calculando…",
  "calculatorUi.result.unavailable": "Valor no disponible",
  "calculatorUi.individual.empty":
    "Indique producto, ruta y costo para calcular con las reglas publicadas.",
  "calculatorUi.individual.definition": "Costo fiscal por unidad",
  "calculatorUi.operation.definition": "Carga tributaria neta de la operación",
  "calculatorUi.unit": "BRL por unidad",
  "calculatorUi.operation.unit": "BRL · operación",
  "calculatorUi.unitQuantity": "Cálculo unitario · cantidad {quantity}",
  "calculatorUi.inputTitle": "Entradas del escenario",
  "calculatorUi.context": "Contexto del cálculo",
  "calculatorUi.scope":
    "Alcance: valores resueltos por el motor. Las familias no cubiertas no equivalen a cero.",
  "calculatorUi.operation.scope":
    "PIS/COFINS y precios fuera de este cálculo. IBS/CBS e ISS no incluidos.",
  "calculatorUi.operation.empty": "Informe producto, ambas rutas y los valores de compra y venta.",
  "calculatorUi.operation.example": "Cargar ejemplo",
  "calculatorUi.operation.exampleLoaded":
    "Ejemplo cargado · revise las entradas antes de calcular.",
  "calculatorUi.operation.routeRequired":
    "Informe proveedor, centro y cliente con estados válidos.",
  "calculatorUi.operation.active": "Seleccione un conjunto publicado para la operación.",
  "calculatorUi.operation.unsaved": "Simulación de la operación · no es un registro guardado.",
  "calculatorUi.previous": "Resultado anterior — entradas modificadas",
  "calculatorUi.completed": "Cálculo completado. Consulte el resultado a continuación.",
  "calculatorUi.goResult": "Ir al resultado",
  "calculatorUi.blocked": "Las incidencias impiden un resultado completo. Revise los motivos.",
  "calculatorUi.taxSubtotal": "Subtotal de impuestos: {value}",
  "calculatorUi.formulaUnavailable":
    "Fórmula no informada en este registro. Consulte la memoria completa.",
  "calculatorUi.sourceUnavailable": "Base legal no informada en este registro",
  "calculatorUi.sourceRelationship":
    "Fuentes del registro. La relación con un paso aparece solo cuando la informa el motor.",
  "calculatorUi.sources": "Reglas y fuentes ({count})",
  "calculatorUi.canonical": "Valor canónico",
  "calculatorUi.notCovered": "No informado · no es tasa cero",
  "calculatorUi.openRule": "Abrir regla aplicada",
  "calculatorUi.presentationOrder":
    "Orden de lectura: principal → ICMS → base PIS/COFINS → IPI → MVA/ST → adquisición. Se conservan los valores y la memoria original.",
  "calculatorUi.rule": "Regla aplicada",
  "calculatorUi.precision": "Precisión y redondeo",
  "calculatorUi.precisionUnavailable": "Precisión intermedia no informada en este registro.",
  "calculatorUi.numberLabel": "{label} · {unit} · reales brasileños",
  "calculatorUi.tape.empty":
    "La memoria estará disponible después del cálculo. No se ha supuesto ninguna tasa.",
  "calculatorUi.tape.loading": "Cargando la memoria del registro…",
  "calculatorUi.tape.blocked":
    "Memoria fiscal no disponible mientras el resultado requiere revisión.",
  "calculatorUi.tape.error": "No se pudo cargar la memoria. Inténtelo de nuevo.",
  "calculatorUi.export.record": "Registro reproducible con entradas, versión y memoria.",
  "calculatorUi.export.partial":
    "Incluye incidencias; los valores no disponibles siguen identificados.",
  "calculatorUi.export.simulation": "Exportar simulación (JSON)",
  "calculatorUi.diff.title": "Comparación de revisiones",
  "calculatorUi.diff.field": "Campo",
  "calculatorUi.diff.before": "Anterior",
  "calculatorUi.diff.after": "Actual",
  "calculatorUi.diff.delta": "Variación absoluta",
  "calculatorUi.mode.individual": "Individual",
  "calculatorUi.mode.workbook": "Planilla",
  "calculatorUi.mode.operation": "Compra y venta",
  "calculatorUi.mode.choose": "¿Qué cálculo usar?",
  "calculatorUi.mode.individualHint": "Un producto y un trayecto: consulta el costo con impuestos.",
  "calculatorUi.mode.operationHint": "Compra y reventa: compara caja, resultado y precio de venta.",
  "calculatorUi.mode.workbookHint":
    "Varios productos: carga una hoja de cálculo y sigue los lotes.",
  "operation.form.cestInvalid": "Indica los 7 dígitos del CEST o deja el campo vacío.",
  "operation.design.purchaseTitle": "Compra y producto",
  "operation.design.saleTitle": "Venta y formación del precio",
  "operation.design.expensesTitle": "Gastos de esta operación",
  "operation.design.declaredSummary": "Resumen de datos",
  "operation.design.declaredOnly": "Valores declarados · aún sin resultado",
  "operation.design.toCalculate": "Por calcular",
  "operation.design.resultTitle": "Resultado de la operación",
  "operation.design.resultSubtitle":
    "Caja, resultado e impuestos del mismo cálculo. Revisa lo pendiente antes de decidir.",
  "operation.design.contextDetails": "Datos de la operación y formación del precio",
  "operation.design.saleTotal": "Venta · total sin ST repercutida",
  "operation.design.earningsBasis": "Base P&L · después de gastos declarados",
  "operation.design.statementTitle": "Cómo se forma el resultado",
  "operation.form.title": "Simula tu compra y venta",
  "operation.form.intro": "Indica el producto, lo que compras y a quién lo revenderás.",
  "operation.form.required": "Obligatorio",
  "operation.form.requiredHint":
    "* Campos obligatorios. Los datos fiscales ausentes pueden requerir revisión.",
  "operation.form.product": "Producto",
  "operation.form.classification": "CEST y origen de la mercancía",
  "operation.form.classificationHint":
    "Declara los datos de la factura. La clasificación puede ser necesaria para resolver las reglas; su ausencia no significa exención.",
  "operation.form.purchaseHint": "Del proveedor al centro de distribución.",
  "operation.form.saleHint": "Del centro de distribución a tu cliente.",
  "operation.form.unitHint": "Valor por unidad. La cantidad se aplicará a la compra y a la venta.",
  "operation.form.totalHint": "Valor total de la operación. Sin multiplicación por cantidad.",
  "operation.form.invoiceSt": "ST de la factura de compra",
  "operation.form.declared": "Valor declarado",
  "operation.form.priceGoal": "¿Cómo definir el precio de venta?",
  "operation.form.knownPrice": "Ya tengo el precio",
  "operation.form.knownPriceHint": "Indica el valor para simular caja y resultado.",
  "operation.form.findPrice": "Quiero calcular el precio",
  "operation.form.findPriceHint":
    "Define una contribución NET o una participación TR sobre la venta.",
  "operation.form.federalPending": "Régimen sin declarar · el resultado puede ser parcial",
  "operation.form.nextHint":
    "La simulación muestra flujo de caja y P&L. Las cuestiones fiscales pendientes siguen visibles.",
  "operation.form.submit": "Simular compra y venta",
  "operation.form.needExample": "¿Necesitas un ejemplo?",
  "operation.form.resultHint":
    "Completa los datos y simula para comparar flujo de caja y P&L. Podrás consultar el detalle fiscal.",
  "operation.form.fixFields": "Revisa los campos señalados antes de simular.",
  "operation.form.purchaseRequired": "Indica un valor de compra válido.",
  "operation.form.saleRequired": "Indica un precio de venta válido.",
  "operation.form.retainedInvalid":
    "Indica la ST de la factura en reales, con hasta dos decimales, o deja el campo vacío.",
  "calculatorUi.description": "Producto, ruta y reglas publicadas en un cálculo trazable.",
  "calculatorUi.recent.retry": "Intentar cargar de nuevo",
  "calculatorUi.recent.review": "{count} artículos pendientes de revisión fiscal",

  "legacy.batch.exportJson": "Exportar memoria (JSON)",
  "legacy.batch.exportCsv": "Exportar todas las filas (CSV)",
  "legacy.batch.onlyReview": "Solo filas que requieren revisión ({count})",
  "legacy.batch.noReview": "Ninguna fila de este archivo requiere revisión.",
  "legacy.breakdown": "Desglose de impuestos y costos",
  "legacy.pricing": "Venta y pago",
  "legacy.resultEmpty":
    "Complete la operación y calcule para consultar precio, costos, impuestos y margen.",
  "workspace.operationsTitle": "Operaciones fiscales",
  "workspace.researchTitle": "Investigación con agentes",
  "review.savedResult": "Abrir resultado guardado",
  "review.progress": "{calculated} calculados · {review} por revisar",
  "evidence.empty.prepareResearch": "Preparar investigación de este NCM",
  "evidence.empty.researchHint":
    "Ningún documento coincide con estos filtros. Abra la investigación con este NCM, elija las fuentes y revise el motivo antes de iniciarla.",
  "recalculateLot.action": "Recalcular lote",
  "recalculateLot.body":
    "Cree un cálculo nuevo para los {count} artículos guardados con fecha {date}, conservando las correcciones de entrada. El cálculo anterior seguirá disponible.",
  "recalculateLot.previousVersion": "Versión original",
  "recalculateLot.nextVersion": "Nueva versión publicada",
  "recalculateLot.noVersion": "Publique otra versión de reglas antes de recalcular este lote.",
  "recalculateLot.incomplete":
    "Los datos guardados del lote están incompletos o son inconsistentes. Actualice los resultados antes de reintentarlo.",
  "recalculateLot.submit": "Crear cálculo nuevo",
  "recalculateLot.created": "Nuevo cálculo del lote creado.",
  "recalculateLot.originalEngine": "Motor original",
  "recalculateLot.engineBefore": "anterior a {version}",
  "recalculateLot.unchanged.title": "Nada cambió desde el cálculo original.",
  "recalculateLot.unchanged.body":
    "Con las reglas ({ruleset}) y el motor actual ({engine}), cada fila saldría igual que en el cálculo original, así que un nuevo cálculo no cambiaría nada.",
  "recalculateLot.how": "Cómo recalcular",
  "recalculateLot.engine.title":
    "Recalcular con el motor actual ({engine}) y las mismas reglas ({ruleset})",
  "recalculateLot.engine.hint":
    "Mismos ítems, mismas correcciones y misma versión de reglas; solo cambia el motor.",
  "recalculateLot.changes.title": "Qué cambió desde el cálculo original",
  "recalculateLot.change.IMPORTED_PURCHASE_LINES":
    "Alinea el ICMS propio de la compra interestatal importada y la base de crédito de PIS/COFINS con la tasa aplicada del 4% (motor 1.19.0). Crea un registro nuevo y conserva el original.",
  "recalculateLot.change.PURCHASE_LINES":
    "1.6.0 · ICMS propio y PIS/COFINS de la compra fuera de la base",
  "recalculateLot.change.GENERAL_RULE":
    "1.7.0 · Regla general (sin ST) para rutas sin regla publicada",
  "recalculateLot.change.PIS_COFINS_PROFILES":
    "1.8.0 · Perfiles de PIS/COFINS (monofásico, alícuota cero, pendiente)",
  "recalculateLot.change.ROUTE_RULES":
    "1.9.0 · ST derivada de la regla de destino y regla general en la venta",
  "recalculateLot.change.ST_ADJUSTMENTS":
    "1.10.0 · FECP de RJ en la MVA ajustada, ST retenido por el remitente PR→SP e ICMS propio interestatal de la compra",
  "recalculateLot.change.PIS_COFINS_CATALOG_V2":
    "1.13.0 · Catálogo legal PIS/COFINS ampliado para combustibles y agua mineral; los productos que requieren confirmación siguen en revisión",
  "recalculateLot.ruleset.title": "Usar otra versión publicada de las reglas",
  "recalculateLot.ruleset.hint": "Los ítems se recalculan con la versión elegida.",
  "recalculateLot.reason": "Motivo (opcional)",
  "recalculateLot.reasonPlaceholder": "Ej.: revisar el lote con el motor 1.13.0",
  "recalculateLot.audit":
    "Queda registrado quién recalculó, el motivo y el enlace al lote original.",
  "pisCofinsConfirm.open": "Confirmar perfil en lote ({count})",
  "pisCofinsConfirm.title": "Confirmar perfil PIS/COFINS",
  "pisCofinsConfirm.intro":
    "El motor 1.8.0 no aplica alícuota cero cuando la condición de la ley no se prueba por el NCM, ni elige una lista cuando el NCM está en más de una. Revise lo que el archivo dice de cada producto y confirme el tratamiento de cada NCM. La confirmación queda registrada con quién, cuándo y por qué; el cálculo original no cambia.",
  "pisCofinsConfirm.loading": "Leyendo los {count} ítems que esperan confirmación…",
  "pisCofinsConfirm.notConfirmable":
    "Estos ítems no se pueden confirmar en lote: el catálogo no acepta confirmación para sus NCM (bebidas o fuera del catálogo). Abra el ítem para ver el motivo.",
  "pisCofinsConfirm.recalculate": "Recalcular con las confirmaciones",
  "pisCofinsConfirm.list.STANDARD": "Régimen estándar (CST 01)",
  "pisCofinsConfirm.list.ZERO_RATE": "Alícuota cero (CST 06)",
  "pisCofinsConfirm.list.SINGLE_STAGE": "Monofásico (CST 04)",
  "pisCofinsConfirm.list.BEVERAGE": "Monofásico / bebidas frías",
  "pisCofinsConfirm.lists.note":
    "NCM en más de una lista. El motor no elige: indique cuál se aplica a estos productos. Nada viene preseleccionado.",
  "pisCofinsConfirm.lists.hint.STANDARD":
    "El producto no encaja en ninguna de las listas de abajo: PIS/COFINS con las alícuotas del régimen, con crédito en la compra cuando no es acumulativo.",
  "pisCofinsConfirm.lists.hint.ZERO_RATE":
    "El producto cumple la condición de esta lista: CST 06 en la venta y sin crédito en la compra (CST 73).",
  "pisCofinsConfirm.lists.hint.SINGLE_STAGE":
    "Reventa monofásica: CST 04 en la venta y sin crédito en la compra (CST 70).",
  "pisCofinsConfirm.lists.hint.BEVERAGE":
    "No disponible: el motor no calcula el régimen de bebidas frías (alícuotas del art. 25 para el mayorista). Si esta es la lista, el ítem sigue en revisión.",
  "pisCofinsConfirm.lists.noSuggestion":
    "Sin sugerencia para un NCM en más de una lista: elija después de revisar el producto.",
  "pisCofinsConfirm.row.open": "Confirmar perfil PIS/COFINS",
  "pisCofinsConfirm.row.confirmed":
    "Confirmado: {treatment}. Entra en el próximo cálculo de este archivo; este cálculo queda como se hizo.",
  "pisCofinsConfirm.row.otherReasons":
    "Solo se confirma el perfil PIS/COFINS; los demás motivos de revisión siguen.",
  "pisCofinsConfirm.treatment.STANDARD": "Régimen normal",
  "pisCofinsConfirm.treatment.ZERO_RATE": "Alícuota cero",
  "pisCofinsConfirm.treatment.SINGLE_STAGE_RESALE": "Monofásico (reventa)",
  "pisCofinsConfirm.qualifier.not": "no es {subject}",
  "pisCofinsConfirm.qualifier.is": "es {subject}",
  "pisCofinsConfirm.qualifier.outside": "fuera de la condición",
  "pisCofinsConfirm.qualifier.meets": "cumple la condición",
  "pisCofinsConfirm.subject.ORDINARY_BREAD": "pan común",
  "pisCofinsConfirm.subject.BREAD_PREMIX": "premezcla para pan común",
  "pisCofinsConfirm.reason.suggested":
    "{treatment}: las descripciones del archivo citan {terms} (NCM {ncm}).",
  "pisCofinsConfirm.reason.default":
    "{treatment}: verificado con las descripciones del archivo (NCM {ncm}).",
  "pisCofinsConfirm.done.one": "{count} ítem confirmado: {treatment}",
  "pisCofinsConfirm.done.other": "{count} ítems confirmados: {treatment}",
  "pisCofinsConfirm.recorded":
    "Registrado con su usuario, la fecha y el motivo. Entra en el próximo cálculo de este archivo.",
  "pisCofinsConfirm.groupTitle.one": "Confirmar perfil para {count} ítem con NCM {ncm}",
  "pisCofinsConfirm.groupTitle.other": "Confirmar perfil para {count} ítems con NCM {ncm}",
  "pisCofinsConfirm.alreadyConfirmed": "{count} ya confirmados en este archivo",
  "pisCofinsConfirm.items": "Productos, como el archivo los describe",
  "pisCofinsConfirm.selected": "{selected} de {total} seleccionados",
  "pisCofinsConfirm.noDescription": "Sin descripción en el archivo",
  "pisCofinsConfirm.treatmentLabel": "Tratamiento",
  "pisCofinsConfirm.hint.STANDARD":
    "CST 01: débito en la venta y crédito en la compra con las alícuotas del régimen.",
  "pisCofinsConfirm.hint.ZERO_RATE":
    "CST 06: sin débito en la venta ni crédito en la compra. Solo vale si el catálogo respalda el NCM.",
  "pisCofinsConfirm.hint.SINGLE_STAGE_RESALE":
    "CST 04: reventa monofásica, sin débito ni crédito. Solo vale si el catálogo respalda el NCM.",
  "pisCofinsConfirm.suggested":
    "Preseleccionado porque las descripciones citan {terms}. Revise y confirme: nada se aplica sin su clic.",
  "pisCofinsConfirm.noSuggestion": "Elija el tratamiento después de revisar las descripciones.",
  "pisCofinsConfirm.reason": "Motivo",
  "pisCofinsConfirm.audit":
    "Queda registrado quién confirmó, cuándo y el motivo. El cálculo original no cambia.",
  "pisCofinsConfirm.submit.one": "Confirmar {treatment} para {count} ítem",
  "pisCofinsConfirm.submit.other": "Confirmar {treatment} para {count} ítems",
  "pisCofinsConfirm.choose": "Elija el tratamiento",
  "pisCofinsConfirm.band.title.one": "{count} ítem con perfil PIS/COFINS confirmado",
  "pisCofinsConfirm.band.title.other": "{count} ítems con perfil PIS/COFINS confirmado",
  "pisCofinsConfirm.band.body":
    "Las confirmaciones entran en el próximo cálculo de este archivo; este cálculo sigue como se hizo.",
  "recalculateLot.change.INPUT_CORRECTIONS": "Perfil PIS/COFINS confirmado en {count} ítems",
  "recalculateLot.reasonConfirmations": "Recalcular con las confirmaciones de perfil PIS/COFINS",
  "calculateSheets.action.one": "Calcular {count} hoja",
  "calculateSheets.action.other": "Calcular {count} hojas",
  "calculateSheets.body":
    "Hojas de {file} importadas y nunca calculadas. Cada hoja usa las filas, el mapeo y las premisas guardados en la importación; no hace falta subir el archivo de nuevo.",
  "calculateSheets.bodyNoFile":
    "Cada hoja usa las filas, el mapeo y las premisas guardados en la importación; no hace falta subir el archivo de nuevo.",
  "calculateSheets.listLabel": "Hojas a calcular",
  "calculateSheets.reading": "Leyendo las hojas y las premisas de cada una en el archivo guardado…",
  "calculateSheets.readingShort": "Leyendo premisas…",
  "calculateSheets.rows": "{count} ítems válidos",
  "calculateSheets.excluded": "{count} con error quedan fuera",
  "calculateSheets.premise.tr": "TR {value}",
  "calculateSheets.premise.saleUf": "Venta a {value}",
  "calculateSheets.premise.regime.NON_CUMULATIVE": "PIS/COFINS no acumulativo",
  "calculateSheets.premise.regime.CUMULATIVE": "PIS/COFINS acumulativo",
  "calculateSheets.premise.regime.UNKNOWN": "Régimen no informado",
  "calculateSheets.noPremises":
    "La hoja no declara premisas de venta: calcula los tributos de la compra, sin precio de venta.",
  "calculateSheets.unread":
    "Archivo demasiado grande para releer las premisas aquí: se calcula sin precio de venta, o ajuste esta hoja.",
  "calculateSheets.blockedPricing":
    "La TR de la hoja no tiene una UF de venta válida. Ajuste esta hoja para calcularla.",
  "calculateSheets.adjust": "Ajustar premisas",
  "calculateSheets.sending": "Creando cálculo…",
  "calculateSheets.state.created": "En cálculo",
  "calculateSheets.state.failed": "No iniciado",
  "calculateSheets.state.existing": "Ya calculada",
  "calculateSheets.running": "Creando {done} de {total}…",
  "calculateSheets.retry": "Reintentar las que fallaron",
  "calculateSheets.once":
    "Cada hoja se calcula una sola vez: un segundo clic, otra pestaña o un colega reciben el mismo cálculo, sin duplicarlo.",
  "calculateSheets.created": "Cálculos de las hojas creados.",
  "calculateSheets.bandLabel": "Hojas importadas sin cálculo",
  "calculateSheets.band.title.one": "{count} hoja de este archivo aún no se calculó",
  "calculateSheets.band.title.other": "{count} hojas de este archivo aún no se calcularon",
  "calculateSheets.band.body.one":
    "{sheets} se importó con las premisas de su propia hoja. Calcúlela sin subir el archivo de nuevo.",
  "calculateSheets.band.body.other":
    "{sheets} se importaron con las premisas de cada hoja. Calcúlelas sin subir el archivo de nuevo.",
  "calculateUpload.action": "Calcular",
  "calculateUpload.help": "Calcular a partir del archivo ya importado, sin subirlo de nuevo",
  "calculateUpload.title": "Calcular hoja importada",
  "calculateUpload.body":
    "{count} ítems válidos de {file} · {sheet}. Se usan el archivo y el mapeo guardados en la importación; no hace falta subirlo de nuevo.",
  "calculateUpload.excluded": "{count} filas con error quedan fuera, como en la importación.",
  "calculateUpload.readingPremises": "Leyendo las premisas de la hoja…",
  "calculateUpload.premisesNone":
    "La hoja no declara premisas de venta (TR, UF de venta, régimen). Elíjalas abajo para ver el precio de venta.",
  "calculateUpload.premisesUnavailable":
    "No fue posible releer las premisas de la hoja (TR, UF de venta, régimen). Revíselas antes de calcular.",
  "calculateUpload.submit": "Calcular {count} ítems",
  "calculateUpload.created": "Cálculo del lote creado.",
  "recalculation.basis.CURRENT_ENGINE": "Recalculado con el motor actual y las mismas reglas",
  "recalculation.basis.RULESET": "Recalculado con otra versión de las reglas",
  "recalculation.compare.title": "Comparación con el cálculo original",
  "recalculation.compare.openOriginal": "Abrir cálculo original",
  "recalculation.compare.rules": "Reglas {before} → {after}",
  "recalculation.compare.engine": "Motor {before} → {after}",
  "recalculation.compare.byYou": "por usted",
  "recalculation.compare.by": "por {id}",
  "recalculation.compare.reviewToCalculated": "Salieron de revisión",
  "recalculation.compare.calculatedToReview": "Pasaron a revisión",
  "recalculation.compare.stillReview": "Siguen en revisión",
  "recalculation.compare.taxDelta": "Variación de impuestos",
  "recalculation.compare.newlyCalculatedTax": "Impuestos de los ítems que salieron de revisión",
  "recalculation.compare.note":
    "La variación compara solo los ítems calculados en ambos cálculos ({changed} cambiaron): {before} → {after}, impuestos de la compra × cantidad.",
  "recalculation.compare.pinned": "El cálculo original sigue fijado y no se modificó.",
  "recalculation.compare.unmatched":
    "{count} ítems no tienen par en el otro cálculo y quedaron fuera de la comparación.",
  "proposals.create.advancedEditingHint":
    "Los cambios JSON se envían tal como se introducen y no actualizan el formulario guiado. El tipo de regla queda fijo al editar JSON. Las referencias de evidencia se adjuntan automáticamente.",
  "proposals.create.discardJson": "Descartar cambios JSON y volver al formulario guiado",
  "proposals.create.editJsonHint":
    "Continúe desde el borrador guiado completo. El formulario guiado se conservará por separado.",
  "proposals.create.startJsonHint":
    "El borrador guiado está incompleto. Inicie una plantilla JSON separada; los campos parciales seguirán disponibles al volver, pero no se copiarán a la plantilla.",
  "proposals.create.editJson": "Editar borrador completo como JSON",
  "proposals.create.startJson": "Iniciar plantilla JSON separada",
  "proposals.create.unlinkEvidence": "Quitar",
  "proposals.create.linkedEvidence": "Evidencias vinculadas",
  "proposals.create.linkedEvidenceHint":
    "Adjunta los documentos aprobados que respaldan la tasa, ruta, vigencia y excepciones. Hasta 100 documentos; el servidor vuelve a comprobar su aprobación al crear la propuesta.",
  "proposals.create.removeEvidence": "Quitar evidencia: {title}",
  "proposals.create.addEvidence": "Añadir evidencia aprobada",
  "proposals.create.changeEvidence": "Cambiar evidencia",
  "proposals.create.selectEvidence": "Elija evidencia aprobada para respaldar la nueva propuesta.",
  "proposals.create.noEvidence":
    "No hay evidencia aprobada que coincida. Revise la evidencia antes de crear una propuesta.",
  "proposals.create.type.fiscal": "Parámetro fiscal",
  "proposals.create.type.commercial": "Comisión comercial",
  "proposals.create.type.operational": "Costo operativo",
  "proposals.create.business.scope": "Aplicabilidad",
  "proposals.create.business.scopeHint":
    "Identificadores exactos opcionales. Los campos vacíos se aplican a todos los valores de la organización.",
  "proposals.create.business.category": "Categoría",
  "proposals.create.business.paymentMethod": "Método de pago",
  "proposals.create.business.transactionType": "Tipo de transacción",
  "proposals.create.business.takeRate": "Comisión comercial (%)",
  "proposals.create.business.percentHint":
    "Introduzca un porcentaje entre 0 y 100. Por ejemplo, 10 significa 10 %.",
  "proposals.create.business.logistics": "Logística",
  "proposals.create.business.freight": "Flete",
  "proposals.create.business.other": "Otros costos",
  "proposals.create.business.formula": "Método de cálculo",
  "proposals.create.business.fixed": "Importe fijo (BRL)",
  "proposals.create.business.percent": "Porcentaje (%)",
  "proposals.create.business.amount": "Importe (BRL)",
  "proposals.create.business.amountHint":
    "Introduzca un importe no negativo en reales. Introduzca 0 explícitamente si este costo no se aplica.",
  "review.nextTitle": "Qué hacer ahora",
  "review.correctInput":
    "Revise el producto, la ruta y el costo fiscal; después ejecuta un cálculo nuevo.",
  "review.fiscalHelp":
    "Revise las reglas fiscales aplicables. Las tasas faltantes o en conflicto necesitan una propuesta revisada y una versión publicada.",
  "review.costHelp":
    "Revise las comisiones y los costos operativos. Aprobar una propuesta no modifica por sí solo un cálculo guardado.",
  "review.immutableHelp":
    "Cada cálculo nuevo conserva intactos el resultado anterior y su versión de reglas.",
  "review.correctRecalculate": "Corregir y recalcular",
  "review.inspectRules": "Revisar reglas aplicables",
  "review.proposeRule": "Crear propuesta de regla",
  "review.loadSource": "Recupere la entrada original para preparar un cálculo nuevo.",
  "review.sourceUnavailable":
    "La entrada original no está disponible para este registro. Inicie un cálculo nuevo con los datos verificados del producto y su costo.",
  "review.sourceLoaded":
    "Entrada original recuperada de la versión {version}. Revise los campos y elija la versión publicada para el cálculo nuevo. No se envía nada automáticamente.",
  "review.amountsPending":
    "Los importes y las tasas no son definitivos mientras este producto requiera revisión.",
  "review.taskHelp":
    "Este archivo necesita revisión. Abra una fila afectada para revisar sus datos o reglas. Tras publicar las correcciones, cree un cálculo nuevo; reintentar una tarea interrumpida no aplica reglas nuevas.",
  "lotMap.empty": "No se encontraron hojas legibles. Elija otro archivo XLSX o CSV.",
  "lotMap.inspecting": "Leyendo hojas y sugiriendo columnas…",
  "lotMap.requiredCost": "Seleccione la columna de costo de la mercancía para continuar.",
  "lotMap.duplicateColumns":
    "Cada columna de origen solo se puede asignar a un campo. Revise las selecciones marcadas.",
  "lotMap.originalHelp":
    "Esta descarga contiene el archivo original. Las correcciones del cálculo no lo modifican.",
  "lotMap.downloading": "Preparando descarga…",
  "ui.results.new": "Nuevo cálculo",
  "legacy.batch.template": "Descargar plantilla CSV (v8)",
  "legacy.batch.supplier": "Valores del proveedor",
  "legacy.batch.error":
    "Revise la plantilla de 26 columnas, los valores numéricos, la fecha y los límites (5 MB / 500 filas).",
  "legacy.batch.count": "{count} filas procesadas",
  "legacy.batch.product": "Producto / NCM",
  "legacy.batch.result": "Estado e incidencias",
  "legacy.batch.sale": "Precio de venta",
  "legacy.batch.margin": "Margen",
  "rules.detail.fiscal.title": "Parámetros fiscales publicados",
  "rules.detail.fiscal.ipi": "IPI",
  "rules.detail.fiscal.internal": "ICMS interno",
  "rules.detail.fiscal.interstate": "ICMS interestatal",
  "rules.detail.fiscal.st": "ICMS-ST declarado",
  "rules.detail.fiscal.mva": "MVA original",
  "rules.detail.fiscal.effectiveRate": "Carga efectiva (ALQ intra de la MVA)",
  "rules.detail.fiscal.effectiveUntil": "hasta {date}",
  "rules.detail.fiscal.adjustedMva": "MVA ajustada publicada",
  "rules.detail.fiscal.missing": "No informado",
  "rules.detail.fiscal.yes": "Aplicable",
  "rules.detail.fiscal.no": "No aplicable",
  "rules.detail.fiscal.ipiTreatment": "Tratamiento del IPI",
  "rules.detail.fiscal.icmsTreatment": "Tratamiento del ICMS",
  "rules.detail.fiscal.mode": "Modo del ICMS",
  "rules.detail.fiscal.reduction": "Reducción de base (%)",
  "rules.detail.fiscal.conditions": "Condiciones adicionales",
  "rules.detail.fiscal.payment": "Método de pago",
  "rules.detail.fiscal.transaction": "Tipo de transacción",
  "rules.detail.fiscal.TAXED": "Gravado",
  "rules.detail.fiscal.EXEMPT": "Exento",
  "rules.detail.fiscal.EXCLUDED": "Excluido",
  "rules.detail.fiscal.unspecified.one": "{count} parámetro no informado",
  "rules.detail.fiscal.unspecified.other": "{count} parámetros no informados",
  "rules.detail.fiscal.empty": "Ningún parámetro informado",
  "rules.detail.sourceNote": "Nota de la fuente (texto original)",

  "workspace.calculationDescription":
    "Revise los impuestos y pendientes de cada producto. Abra la explicación para ver cómo se calculó el resultado.",
  "workspace.calculationSummary": "Resumen del cálculo",

  "workspace.savedCommercialNote":
    "Este registro conserva las revisiones de datos comerciales del flujo original. No son campos adicionales que deba introducir en la calculadora fiscal.",
  "lookup.routeFilter": "Filtrar por ruta y fecha",
  "lookup.routeOptional": "Opcional · consulte el NCM antes de definir la operación",
  "lookup.dateMissing": "Fecha sin definir",
  "lookup.useToday": "Usar la fecha de hoy",
  "lookup.clearRoute": "Limpiar ruta y fecha",
  "lookup.refineMissing": "Para filtrar por operación, complete: {fields}.",
  "lookup.officialClassification": "Consultar clasificación oficial",
  "workspace.individualVersionUnavailable":
    "Seleccione una versión de reglas disponible para simular.",

  "workspace.addEvidence": "Investigar una consulta",
  "workspace.unitCostSum": "Suma de costos unitarios (sin cantidades)",
  "workspace.openFile": "Abrir la carga",
  "workspace.reviews": "Revisiones",
  "workspace.documents": "Documentos",
  "workspace.discovery": "Investigar una consulta",
  "workspace.publications": "Publicaciones",
  "workspace.individual": "Individual",
  "workspace.spreadsheet": "Planilla",
  "workspace.optionalColumns": "Más columnas (opcionales)",
  "workspace.fileType": "Elija Excel (.xlsx, .xlsm), CSV o TXT delimitado.",
  "workspace.newProposal": "Elegir evidencia para crear propuesta",
  "lookup.registered": "Reglas publicadas para este NCM",
  "lookup.registeredNote":
    "Estas reglas están vinculadas al NCM. La ruta y la fecha ayudan a precisar la consulta.",
  "lookup.noRegistered": "No hay reglas publicadas para este NCM",
  "lookup.noRegisteredBody":
    "La base aún no tiene reglas publicadas para este código. Esto no significa impuesto cero. Consulte otro producto o la biblioteca de reglas.",
  "ui.filters.remove": "Quitar filtro: {filter}",
  "ui.results.search": "Buscar cálculos guardados",
  "ui.upload.pending": "Leyendo su archivo…",
  "customer.results.action": "Ver resultados",
  "lookup.title": "Consultar reglas",
  "workspace.operation": "Compra + venta",
  "operation.title": "Impuestos de la operación de reventa",
  "operation.body":
    "Compra del proveedor al CD de BackChannel y venta al cliente, con las reglas publicadas de cada tramo. Introduce un precio cerrado, TR o una meta de contribución vía SP.",
  "operation.route": "Trayecto de la operación",
  "operation.supplier": "Proveedor (UF)",
  "operation.supplierHint": "Quien emite la NF de compra",
  "operation.center": "CD BackChannel (UF)",
  "operation.centerHint": "Donde BCH recibe y revende",
  "operation.customer": "Cliente (UF)",
  "operation.customerHint": "Destino de la venta",
  "operation.cest": "CEST (opcional)",
  "operation.goodsOrigin": "Origen de la mercancía (CST)",
  "operation.goodsOrigin.hint":
    "Los orígenes 1, 2, 3 y 8 usan la alícuota interestatal del 4% (Resolución del Senado 13/2012). No informado: rige la alícuota de la regla.",
  "operation.goodsOrigin.notInformed": "No informado",
  "operation.goodsOrigin.option.0": "Nacional",
  "operation.goodsOrigin.option.1": "Extranjera, importación directa",
  "operation.goodsOrigin.option.2": "Extranjera, adquirida en el mercado interno",
  "operation.goodsOrigin.option.3":
    "Nacional, contenido de importación superior al 40% y hasta el 70%",
  "operation.goodsOrigin.option.4": "Nacional, procesos productivos básicos (PPB)",
  "operation.goodsOrigin.option.5": "Nacional, contenido de importación de hasta el 40%",
  "operation.goodsOrigin.option.6": "Extranjera, importación directa sin similar nacional (CAMEX)",
  "operation.goodsOrigin.option.7": "Extranjera, mercado interno sin similar nacional (CAMEX)",
  "operation.goodsOrigin.option.8": "Nacional, contenido de importación superior al 70%",
  "operation.purchaseValue": "Compra antes de IPI y ST (R$)",
  "operation.saleValue": "Venta antes de la ST trasladada (R$)",
  "operation.buyer": "Cliente",
  "operation.taxpayer": "Contribuyente de ICMS (reventa)",
  "operation.finalConsumer": "Consumidor final (DIFAL)",
  "operation.calculate": "Calcular operación",
  "operation.calculating": "Calculando…",
  "operation.invalid.ncm": "Indique un NCM de 8 dígitos.",
  "operation.invalid.values": "Indique valores de compra y venta válidos.",
  "operation.result": "Resultado fiscal",
  "operation.ruleset": "Conjunto",
  "operation.status.ok": "Calculado con reglas publicadas",
  "operation.status.review": "Requiere revisión",
  "operation.issue.purchase_rule_missing": "Sin regla de ICMS publicada para la compra",
  "operation.issue.purchase_rule_ambiguous": "Regla de compra ambigua (indique el CEST)",
  "operation.issue.sale_rule_missing": "Sin regla de ICMS publicada para la venta",
  "operation.issue.sale_rule_ambiguous": "Regla de venta ambigua (indique el CEST)",
  "operation.issue.purchase_value_missing": "Falta el valor de compra",
  "operation.issue.sale_value_missing": "Falta el valor de venta",
  "operation.mode.ST": "ICMS-ST",
  "operation.mode.STANDARD": "ICMS propio",
  "operation.mode.NOT_TAXED": "ICMS no gravado",
  "operation.mode.none": "Sin regla publicada",
  "operation.purchase": "Compra",
  "operation.sale": "Venta",
  "operation.totals": "Carga fiscal de la operación",
  "operation.totalsHint": "Lo que BCH paga y lo que traslada al cliente",
  "operation.stClosed": "ST pagada en la entrada: venta interna sin ICMS",
  "operation.line.value": "Valor de la NF",
  "operation.line.ownIcms": "ICMS propio",
  "operation.line.mva": "Base ST · MVA",
  "operation.line.stEntry": "ICMS-ST en la entrada",
  "operation.line.stRetained": "ICMS-ST retenido en la NF del proveedor",
  "operation.line.fcpDifal": "FCP del destino en el DIFAL",
  "operation.stRetained": "ICMS-ST retenido en la NF de compra (opcional)",
  "operation.stRetainedHint":
    "Total retenido en la factura, incluso con precios unitarios. Declara 0 si la factura indica cero; deja vacío si no se informa. La declaración no acredita la responsabilidad de pago.",
  "operation.line.acquisition": "Costo de adquisición",
  "operation.line.credit": "Crédito de ICMS",
  "operation.line.saleValue": "Valor de venta",
  "operation.line.stSale": "ICMS-ST retenido al cliente",
  "operation.line.invoice": "Total de la NF de venta",
  "operation.line.taxesInCost": "Impuestos en el costo (IPI + ST entrada)",
  "operation.line.icmsPayable": "ICMS a pagar (venta − crédito)",
  "operation.line.carryover": "Crédito a trasladar",
  "operation.line.salePaid": "Pagado por BCH en la venta (ICMS + DIFAL)",
  "operation.line.stCustomer": "ST trasladada al cliente",
  "operation.line.burden": "Carga fiscal neta",
  "operation.note.pisCofins":
    "PIS/COFINS están fuera de esta base (régimen aún no acreditado); no aparecen como cero.",
  "operation.note.pricing":
    "Precio, markup y margen comercial quedan en la calculadora comercial (R-15).",
  "operation.note.reimbursement":
    "ST pagada en la entrada y venta interestatal: el resarcimiento de la ST no se modela aquí.",
  "operation.note.senderWithholding": "ST retenido por el remitente ({agreement})",
  "operation.stReview.title": "Recaudación de ST en la compra",
  "operation.stReview.route": "Trayecto de la compra",
  "operation.stReview.source": "Procedencia del importe",
  "operation.stReview.source.prior":
    "ST anterior declarada como incluida en el precio; sin nuevo cargo declarado.",
  "operation.stReview.source.invoice":
    "Importe declarado como retenido en la NF del proveedor; no confirma un protocolo.",
  "operation.stReview.source.calculated":
    "Importe calculado en el resultado devuelto; esta procedencia no define quién recauda.",
  "operation.stReview.source.pending": "Procedencia pendiente de revisión.",
  "operation.stReview.responsibility": "Responsabilidad de recaudación",
  "operation.stReview.responsibility.pending": "Responsabilidad por resolver.",
  "operation.stReview.responsibility.prior": "Sin nueva recaudación declarada en esta compra.",
  "operation.stReview.responsibility.sender":
    "Remitente, según el acuerdo devuelto para este trayecto.",
  "operation.stReview.responsibility.general":
    "Sin ST calculada en esta compra según la regla general devuelta.",
  "operation.stReview.responsibility.rule": "La regla seleccionada no calcula ST para esta compra.",
  "operation.stReview.stAmount": "ICMS-ST informado en el resultado",
  "operation.stReview.fcpAmount": "FCP/FECP-ST de la compra",
  "operation.stReview.fcpUndetailed": "Sin desglose separado",
  "operation.stReview.conflict":
    "Las declaraciones y los metadatos fiscales devueltos se contradicen. Revise la NF, el trayecto y la regla antes de usar los importes o asignar responsabilidad de recaudación.",
  "operation.stReview.review":
    "Este resultado requiere revisión. Los importes y la responsabilidad siguen pendientes; cualquier acuerdo mostrado es información devuelta, no confirmación de retención aplicada.",
  "operation.stReview.anticipation":
    "La anticipación del destinatario todavía requiere revisión. La ausencia de información sobre el remitente no define quién paga ni acredita ausencia de ST.",
  "operation.stReview.returnedAgreement": "Acuerdo devuelto, para revisión:",
  "operation.stReview.returnedBasis": "Fundamento devuelto:",
  "operation.stReview.generalBasis": "Fundamento de la regla general devuelta:",
  "operation.stReview.cashScope":
    "Desglose del costo de adquisición, sin pago adicional ni reparto entre proveedor y Fisco. Recuperación de ST y plazos no evaluados.",
  "operation.note.statutoryOwnIcms": "ICMS propio interestatal a la alícuota legal ({basis})",
  "operation.note.generalRule": "Compra calculada con la regla general (sin ST)",
  "operation.note.saleGeneralRule": "Venta calculada con la regla general (sin ST)",
  "operation.note.destinationStRule": "Compra calculada con la regla de destino derivada",
  "operation.statutory.sf2289": "Res. SF 22/89",
  "operation.statutory.sf132012": "Res. SF 13/2012",
  "operation.evidence": "Evidencias y reglas ({count})",
  "rulesets.policy.label": "Política de cálculo",
  "rulesets.policy.title": "Política de cálculo del borrador",
  "rulesets.policy.body":
    "La política viaja con la próxima publicación y no altera cálculos anteriores. tax-family-v1: una regla solo responde por los impuestos que declara; la fila TIPI aporta el IPI y nunca un ICMS cero. tax-family-v2: igual, y la MVA ajustada usa la carga efectiva de la regla como ALQ intra, sin redondear.",
  "rulesets.policy.legacy-v1": "regla entera; MVA ajustada almacenada permitida",
  "rulesets.policy.derived-mva-v1": "regla entera; MVA ajustada derivada",
  "rulesets.policy.tax-family-v1": "por impuesto: ICMS de la ruta, IPI de la TIPI; MVA derivada",
  "rulesets.policy.tax-family-v2": "por impuesto; MVA ajustada con la carga efectiva (ALQ_intra)",
  "rulesets.policy.reason": "Motivo del cambio",
  "rulesets.policy.reasonRequired": "Escriba al menos 10 caracteres.",
  "rulesets.policy.saved": "Política actualizada en el borrador.",
  "rulesets.policy.save": "Guardar política",
  "gaps.tab": "Brechas",
  "gaps.title": "Brechas de cobertura",
  "gaps.description":
    "NCM y trayectos que los cálculos no encontraron en el conjunto publicado. Investigue con IA en las fuentes oficiales y registre lo verificado.",
  "gaps.summary": "Resumen de brechas",
  "gaps.how":
    "La investigación usa Vertex AI con Google Search, solo fuentes oficiales revisadas (CONFAZ y SEFAZ de origen y destino). El resultado queda como evidencia para revisión; nunca publica reglas.",
  "gaps.researchNext": "Investigar las 5 prioritarias con IA",
  "gaps.researching": "Enviando investigaciones…",
  "gaps.researchNext.done":
    "{queued} investigación(es) enviada(s); {failed} sin fuente disponible.",
  "gaps.error": "No se pudo completar. Inténtelo de nuevo.",
  "gaps.filter": "Filtrar por estado",
  "gaps.filter.all": "Todas",
  "gaps.status.OPEN": "Abiertas",
  "gaps.status.RESEARCHING": "En investigación",
  "gaps.status.NO_RULE_FOUND": "Verificadas sin ST",
  "gaps.status.RULE_FOUND": "Regla encontrada",
  "gaps.status.RESOLVED": "Resueltas",
  "gaps.status.DISMISSED": "Descartadas",
  "gaps.state.OPEN": "Abierta",
  "gaps.state.RESEARCHING": "En investigación",
  "gaps.state.NO_RULE_FOUND": "Verificada sin ST",
  "gaps.state.RULE_FOUND": "Regla encontrada",
  "gaps.state.RESOLVED": "Resuelta",
  "gaps.state.DISMISSED": "Descartada",
  "gaps.list": "Brechas por prioridad",
  "gaps.empty": "Ninguna brecha en este filtro",
  "gaps.emptyBody":
    "Cuando un cálculo no encuentra regla para un NCM y trayecto, la brecha aparece aquí automáticamente.",
  "gaps.honesty":
    "Una brecha no es impuesto cero: el cálculo queda en revisión hasta que exista una regla publicada. “Verificada sin ST” registra la revisión con evidencia.",
  "gaps.occurrences": "Ítems",
  "gaps.calculations": "Cálculos",
  "gaps.lastSeen": "Último",
  "gaps.researchTask": "Investigación: {status}",
  "gaps.research.QUEUED": "en cola",
  "gaps.research.RUNNING": "en curso",
  "gaps.research.WAITING_REVIEW": "esperando revisión",
  "gaps.research.SUCCEEDED": "completada",
  "gaps.research.FAILED": "falló",
  "gaps.research.CANCELLED": "cancelada",
  "gaps.outcome.NO_ST_FOUND": "Sin ST encontrada",
  "gaps.outcome.RULE_FOUND": "Regla encontrada",
  "gaps.outcome.INCONCLUSIVE": "No concluyente",
  "gaps.outcomeHint.NO_ST_FOUND":
    "Fuentes oficiales revisadas; no hay ST vigente para este NCM y trayecto. Es una respuesta válida.",
  "gaps.outcomeHint.RULE_FOUND":
    "Existe un acto vigente (MVA, CEST). Cree la propuesta de regla a partir de la evidencia.",
  "gaps.outcomeHint.INCONCLUSIVE":
    "Aún no se puede concluir; la brecha sigue abierta para otra investigación.",
  "gaps.research": "Investigar con IA",
  "gaps.recordFinding": "Registrar resultado",
  "gaps.proposeStandard": "Crear propuesta",
  "gaps.dismiss": "Descartar",
  "gaps.finding.title": "Resultado · NCM {ncm} · {route}",
  "gaps.finding.outcome": "Qué se verificó",
  "gaps.finding.note": "Nota del revisor",
  "gaps.finding.notePlaceholder":
    "Ej.: Protocolo ICMS 97/10 revisado; NCM fuera del anexo para SP→RJ.",
  "gaps.finding.cited": "Evidencias de la investigación",
  "gaps.finding.evidenceIds": "Otras evidencias (IDs)",
  "gaps.finding.checkedAsOf": "Verificado para la fecha",
  "gaps.finding.noteRequired": "Escriba al menos 10 caracteres.",
  "gaps.finding.evidenceRequired": "Cita al menos una evidencia oficial.",
  "gaps.finding.evidenceInvalid": "IDs de evidencia inválidos.",
  "gaps.finding.boundary":
    "Registrar el resultado no publica reglas. Las reglas siguen propuesta, revisión y publicación.",
  "gaps.finding.save": "Guardar resultado",
  "gaps.dismissTitle": "Descartar brecha · NCM {ncm}",
  "gaps.dismissReason": "Motivo",
  "quick.description": "Indique el NCM, el CEST o el producto. Origen y destino son opcionales.",
  "quick.searchBy": "Buscar por",
  "quick.mode.ncm": "Búsqueda por NCM",
  "quick.mode.cest": "Búsqueda por CEST",
  "quick.mode.product": "Búsqueda por producto",
  "quick.hint.ncm":
    "Indique los ocho dígitos del NCM según la TIPI. Con menos dígitos, elija el producto en la lista.",
  "quick.hint.cest": "Indique el CEST (ej.: 17.001.00) para ver los NCM que abarca.",
  "quick.hint.product": "Describa el producto (ej.: chocolate, galleta, secador) y elija el NCM.",
  "quick.placeholder.ncm": "Ej.: 1704.90.10",
  "quick.placeholder.cest": "Ej.: 17.001.00",
  "quick.placeholder.product": "Ej.: chocolate",
  "quick.anyState": "Cualquier estado",
  "quick.search": "Buscar",
  "quick.invalid.ncm": "Indique un NCM de 2 a 8 dígitos.",
  "quick.invalid.cest": "Indique un CEST de 7 dígitos (ej.: 17.001.00).",
  "quick.invalid.product": "Describa el producto para buscar.",
  "quick.inForceOn": "Vigente el",
  "quick.routeOptional": "Sin origen ni destino, mostramos todas las reglas del NCM.",
  "quick.clear": "Limpiar consulta",
  "quick.start.title": "Empiece por el NCM",
  "quick.start.body":
    "Verás los datos fiscales publicados: régimen de ICMS, MVA, alícuotas, CEST, vigencia y fundamento legal.",
  "quick.start.try": "Pruebe:",
  "quick.start.exampleLabel": "Consultar NCM {ncm} de {origin} a {destination}",
  "quick.candidates.title": "Elija el producto",
  "quick.candidates.body": "Productos del catálogo NCM para “{query}”.",
  "quick.cest.missing": "CEST no encontrado",
  "quick.cest.missingBody": "Revise el código en el Convenio ICMS 142/18 o busque por NCM.",
  "quick.cest.pick": "Elija un NCM que abarque este CEST:",
  "quick.loadingCatalog": "Cargando descripción…",
  "quick.internalSt.title": "Atención:",
  "quick.internalSt.body": "este NCM tiene ST en la operación interna de {uf}.",
  "quick.internalSt.action": "Consultar ST interna {uf} → {uf}",
  "quick.inForce.title": "Reglas vigentes para la operación",
  "quick.outside.title": "Fuera de vigencia en esta fecha",
  "quick.other.title": "Otras reglas de este NCM",
  "quick.other.body":
    "Reglas vigentes en otros trayectos. Haga clic en el trayecto para consultarlo.",
  "quick.more": "Mostrando las primeras {count} reglas. Vea todas en la",
  "quick.honesty":
    "Solo reglas publicadas en el conjunto vigente. La ausencia de regla no es exención; PIS/COFINS están fuera de esta base.",
  "quick.none.title": "No aplica.",
  "quick.none.route": "No existen reglas publicadas vigentes para {route}.",
  "quick.none.body":
    "Este NCM todavía no tiene regla fiscal publicada. Eso no significa impuesto cero: el cálculo queda para revisión.",
  "quick.none.bodyOther":
    "Hay reglas de este NCM en otros trayectos (abajo). Para este trayecto, el cálculo queda para revisión.",
  "quick.regime.st": "ICMS-ST",
  "quick.regime.stOff": "ST no aplica",
  "quick.regime.standard": "ICMS propio",
  "quick.regime.exempt": "ICMS no gravado",
  "quick.value.exempt": "Exento",
  "quick.value.outside": "Fuera de esta base",
  "quick.value.internalOp": "Operación interna",
  "quick.fact.regime": "Régimen",
  "quick.fact.originalMva": "MVA original",
  "quick.fact.adjustedMva": "MVA ajustada",
  "quick.fact.derived": "calculada",
  "quick.fact.internal": "Alícuota interna (destino)",
  "quick.fact.interstate": "Alícuota interestatal",
  "quick.fact.reduction": "Reducción de base",
  "quick.detail": "Ver detalle",
  "quick.regime.ipiOnly": "Solo IPI (TIPI)",
  "quick.ipi.title": "IPI nacional (TIPI)",
  "quick.ipi.body":
    "Fila nacional de la TIPI: informa solo el IPI de este NCM. El ICMS viene de las reglas del trayecto de arriba.",
  "quick.gap.seen": "{count} ítem(s) de cálculo sin regla",
  "quick.gap.openResearch": "Abrir investigación",
  "quick.gap.all": "Ver brechas",
  "quick.pickRoute":
    "Varias reglas vigentes. Elija el trayecto para ver los datos fiscales completos.",
  "quick.validity": "Vigencia",
  "quick.legal": "Fundamento legal",
  "quick.useRoute": "Consultar este trayecto",
  "lookup.catalog": "Catálogo NCM",
  "lookup.library": "Biblioteca de reglas",
  "lookup.description": "Encuentre un producto o NCM y abra sus reglas publicadas.",
  "lookup.catalogNote": "El catálogo identifica la clasificación; no acredita una tasa.",
  "lookup.destinations": "Herramientas fiscales",
  "lookup.route": "Trayecto de la operación",
  "lookup.origin": "Estado de origen",
  "lookup.destination": "Estado de destino",
  "lookup.swap": "Invertir origen y destino",
  "lookup.internal": "Operación interna",
  "account.description": "Su perfil, idioma y formas de acceso.",
  "account.section.profile": "Perfil",
  "account.section.preferences": "Preferencias",
  "account.section.passkeys": "Passkeys",
  "account.section.password": "Contraseña",
  "account.profileManaged": "Su administrador gestiona los datos de su cuenta.",
  "account.passwordHelp":
    "Cree una contraseña o cambie la actual mediante un enlace seguro enviado al correo de su cuenta. Este proceso verifica su correo y no requiere una contraseña anterior.",
  "account.passwordAction": "Enviar enlace de contraseña",
  "account.passwordUnavailable":
    "El envío de correo requiere iniciar sesión en una cuenta conectada.",
  "account.title": "Mi cuenta",
  "account.sections": "Secciones de la cuenta",
  "account.section.language": "Idioma",
  "account.section.profile.description": "Su nombre, correo y perfil de acceso.",
  "account.section.language.description": "Idioma de los textos de la interfaz.",
  "account.languageHint": "El cambio se aplica al instante, sin recargar la página.",
  "account.passwordSentTo": "El enlace se enviará a",
  "legacy.modeHelp":
    "Exporte los resultados antes de salir de esta página; nada se guarda en la plataforma.",
  "legacy.switch": "Calculadora anterior",
  "legacy.switch.help":
    "Abre la calculadora anterior ({version}) de next.backchannel.ws. Tablas fijas; las reglas publicadas no cambian.",
  "legacy.switch.helpActive": "Activo. Pulse para volver a las reglas publicadas.",
  "legacy.title": "Calculadora anterior",
  "legacy.tabs.label": "Herramientas de la calculadora anterior",
  "legacy.engineTitle": "Calculadora anterior {version}",
  "legacy.provenance":
    "fijado el {date} · commit {commit} · tablas históricas, no reglas publicadas",
  "legacy.routeLabel": "Ruta",
  "legacy.confirm.date": "Fecha",
  "legacy.drop.title": "Suelte aquí el CSV de la calculadora anterior (v8)",
  "legacy.drop.limits": ".csv · 26 columnas (v8) · hasta 500 filas · 5 MB",
  "legacy.batch.foot":
    "Los campos vacíos usan los valores del proveedor; los inválidos requieren revisión. Exporte Excel a CSV antes.",
  "legacy.batch.supplierFact": "valores {supplier}",
  "legacy.batch.local": "Cálculo local. No se guarda como resultado de la plataforma.",
  "legacy.batch.parsingNote":
    "Esta calculadora lee “1.250,00” como mil doscientos cincuenta y acepta el CSV con la fila de título de la plantilla. La app original lee ese número como 1,25 y puede rechazar la fila de título; si los resultados difieren, revise primero esos campos.",
  "legacy.batch.results": "Filas del CSV",
  "legacy.description":
    "Calculadora de rentabilidad de next.backchannel.ws, versión {version}, con tablas fijas: CMV, créditos, ST, DIFAL, margen e intermediación. No usa ni altera las reglas publicadas; los resultados quedan en este navegador.",
  "legacy.operation": "Operación",
  "legacy.resale": "Compra y reventa",
  "legacy.intermediation": "Intermediación",
  "legacy.route": "Producto y ruta",
  "legacy.legalDescription": "Descripción legal del producto",
  "legacy.costs": "Costos de compra",
  "legacy.options": "Evidencia fiscal y pago",
  "legacy.quantityNote":
    "La calculadora anterior usa importes totales por fila. La cantidad solo afecta la comisión del boleto; no multiplica costo ni ingreso.",
  "legacy.channel": "Canal de pago",
  "legacy.inPerson": "Presencial",
  "legacy.brand": "Marca de tarjeta",
  "legacy.installments": "Cuotas",
  "legacy.stProof": "Añadir evidencia estructurada de ST",
  "legacy.compare": "Comparar BCH SP / ES",
  "legacy.calculate": "Calcular con la calculadora anterior",
  "legacy.result": "Resultado de la calculadora anterior",
  "legacy.resultNote":
    "Calculado con las tablas fijas de la calculadora anterior {version}. Es un resultado de compatibilidad, no una aprobación fiscal.",
  "legacy.review":
    "Revisión requerida. Estos datos no producen un cálculo completo en la calculadora anterior.",
  "legacy.block.purchase": "Compra",
  "legacy.block.sale": "Venta",
  "legacy.block.saleTaxes": "Tributos de la venta",
  "legacy.block.result": "Resultado",
  "legacy.block.service": "Servicio",
  "legacy.block.margin": "Margen",
  "legacy.marginSub": "margen {pct}",
  "legacy.cm1Sub": "CM1 / GMV {pct}",
  "legacy.compareTitle": "BCH SP × BCH ES",
  "legacy.export": "Exportar memoria del cálculo (JSON)",
  "legacy.field.supplierUF": "Estado del proveedor",
  "legacy.field.bchCenter": "Centro BCH",
  "legacy.field.customerUF": "Estado del cliente",
  "legacy.field.purchasePurpose": "Finalidad de compra",
  "legacy.field.supplierTotalInclTaxes": "Valor de factura del proveedor (BRL)",
  "legacy.field.freight": "Flete de compra (BRL)",
  "legacy.field.insurance": "Seguro (BRL)",
  "legacy.field.otherExpenses": "Otros gastos de compra (BRL)",
  "legacy.field.freightRevenue": "Flete cobrado al cliente (BRL)",
  "legacy.field.freightCost": "Costo del flete de entrega (BRL)",
  "legacy.field.logisticsCost": "Costo logístico (BRL)",
  "legacy.field.stValueFromSupplier": "ST en factura del proveedor (BRL)",
  "legacy.field.boletoFeeFixed": "Comisión de boleto (BRL)",
  "legacy.field.markupPct": "Porcentaje de precio",
  "legacy.field.backchannelCommissionPct": "Comisión BCH",
  "legacy.field.quantity": "Cantidad",
  "legacy.field.ipiBase": "Base de IPI",
  "legacy.field.isImported": "Producto importado",
  "legacy.field.isZFMSupplier": "Proveedor de Zona Franca de Manaus",
  "legacy.field.customerIsIcmsTaxpayer": "Cliente contribuyente de ICMS",
  "legacy.field.stAlreadyCollected": "Proveedor ya cobró ST",
  "legacy.field.pricing_method": "Método de precio",
  "legacy.field.paymentMethod": "Método de pago",
  "legacy.option.resale": "Reventa",
  "legacy.option.own_use": "Uso propio",
  "legacy.option.fixed_asset": "Activo fijo",
  "legacy.option.manufacturing": "Fabricación",
  "legacy.option.valor_com_imposto": "Con IPI",
  "legacy.option.valor_sem_imposto": "Sin IPI",
  "legacy.option.gross_margin_on_purchase": "Margen bruto sobre compra",
  "legacy.option.markup_on_cost": "Markup sobre costo",
  "legacy.option.target_contribution_after_tax": "Contribución objetivo después de impuestos",
  "legacy.option.credit_card": "Tarjeta de crédito",
  "legacy.option.boleto": "Boleto",
  "legacy.option.pix": "PIX",
  "legacy.service.gmv": "GMV (BRL)",
  "legacy.service.take": "Comisión de servicio (%)",
  "legacy.service.iss": "ISS (%)",
  "legacy.service.cost": "Costo de operaciones (BRL)",
  "legacy.result.purchaseValue": "Valor de compra",
  "legacy.result.totalCredits": "Créditos totales",
  "legacy.result.fiscalCMV": "Costo fiscal de mercancía",
  "legacy.result.entryAnticipation": "Anticipación de entrada",
  "legacy.result.merchandisePrice": "Precio de mercancía",
  "legacy.result.invoiceTotal": "Total de factura",
  "legacy.result.icmsST": "ICMS-ST",
  "legacy.result.fecpST": "FECP-ST",
  "legacy.result.difalOnSale": "DIFAL",
  "legacy.result.totalSaleTaxes": "Impuestos de venta",
  "legacy.result.paymentFees": "Comisiones de pago",
  "legacy.result.marginValue": "Contribución",
  "legacy.serviceResult.serviceValue": "Valor del servicio",
  "legacy.serviceResult.iss": "ISS",
  "legacy.serviceResult.totalWithholding": "Retenciones",
  "legacy.serviceResult.netCashToReceive": "Neto por recibir",
  "legacy.serviceResult.revenueTaxes": "Impuestos sobre ingreso",
  "legacy.serviceResult.valueForMargin": "Valor para margen",
  "legacy.serviceResult.operationsCost": "Costo de operaciones",
  "lookup.product": "Producto o NCM",
  "lookup.placeholder": "Ej.: café, 0901 o 0901.21.00",
  "lookup.category": "Categoría · capítulo SA",
  "lookup.allCategories": "Todas las categorías",
  "lookup.clear": "Limpiar producto y categoría",
  "lookup.selected": "Producto seleccionado",
  "lookup.change": "Cambiar producto",
  "lookup.calculate": "Calcular este producto",
  "lookup.descriptionColumn": "Descripción",
  "lookup.chapterColumn": "Capítulo SH",
  "common.nextPage": "Página siguiente",
  "common.pageResults": "{count} en esta página · {total} resultados",
  "lookup.results": "Productos del catálogo",
  "lookup.noProducts": "No se encontraron productos",
  "lookup.noProductsBody": "Pruebe otro término, NCM o capítulo.",
  "lookup.candidates": "Reglas publicadas encontradas",
  "lookup.conditions":
    "Coincidencias por NCM, trayecto y vigencia. Falta comprobar CEST, régimen y condiciones de la operación. Revise la fundamentación y complete los datos en la calculadora para determinar el resultado.",
  "lookup.noRules": "Sin regla publicada para esta consulta",
  "lookup.noRulesBody":
    "Esto no significa impuesto cero. La base puede estar incompleta; consulte la biblioteca y las fuentes.",
  "lookup.unavailable": "No informado",
  "lookup.version": "Versión",
  "lotMap.help":
    "Seleccione hoja, encabezados y columnas. Declare si cada costo de mercancía es unitario o total de línea. Los precios de venta no se convierten automáticamente.",
  "lotMap.mesa.fields": "Campos fiscales",
  "lotMap.mesa.preview": "Vista previa · {count} filas después del encabezado",
  "lotMap.mesa.column": "Columna {index}",
  "lotMap.mesa.mapped": "Columna {column} → {field}",
  "lotMap.mesa.required": "Obligatorio",
  "lotMap.confirmHint":
    "Guarda el archivo original y lee todas las filas. Ninguna fila se descarta en silencio.",
  "lotMap.sheet": "Hoja",
  "lotMap.header": "Fila de encabezados",
  "lotMap.unmapped": "Sin asignar",
  "lotMap.decimal": "Formato numérico",
  "lotMap.originUf": "UF de origen si falta en la fila",
  "lotMap.destinationUf": "UF de destino si falta en la fila",
  "lotMap.sample": "Valores de muestra",
  "lotMap.comparisonHelp":
    "Comparación opcional: mapee los importes por unidad que informa el archivo. El motor recalcula con reglas publicadas. Las diferencias de hasta R$ 0,01 cuentan como iguales. Una coincidencia compara importes; no aprueba una fórmula de Excel. CSV no conserva las fórmulas de Excel.",
  "lotMap.field.expected_ipi": "IPI esperado por unidad",
  "lotMap.field.expected_icms_st": "ICMS-ST esperado por unidad",
  "lotMap.field.expected_tax_total": "Total de impuestos esperado por unidad",
  "lotCompare.title": "Comparar importes de mi archivo (opcional)",
  "lotCompare.field": "Impuesto",
  "lotCompare.expected": "Archivo / unidad",
  "lotCompare.actual": "Motor / unidad",
  "lotCompare.delta": "Motor menos archivo",
  "lotCompare.status": "Comparación",
  "lotCompare.match": "Importes coinciden",
  "lotCompare.difference": "Importe diferente",
  "lotCompare.pending": "Pendiente de cálculo válido",
  "lotMap.cached":
    "Usar valores guardados de fórmulas. No se recalcularán; confirme que el archivo se actualizó en Excel.",
  "lotMap.confirm": "Confirmar y revisar cobertura",
  "lotFlow.label": "Etapas del cálculo de la planilla",
  "lotFlow.stepOf": "Etapa {current} de {total}",
  "lotFlow.step.send": "Enviar",
  "lotFlow.step.columns": "Revisar columnas",
  "lotFlow.step.coverage": "Revisar cobertura",
  "lotFlow.step.calculate": "Calcular",
  "lotFlow.step.results": "Resultados",
  "lotFlow.session.title": "Lotes enviados en esta sesión",
  "lotFlow.session.hint.one": "Siga calculando mientras envía otra planilla.",
  "lotFlow.session.hint.other": "Siguen calculando mientras envía otra planilla.",
  "lotFlow.session.view": "Ver progreso",
  "lotFlow.session.viewResult": "Ver resultado",
  "lotFlow.session.open": "Abrir registro",
  "lotFlow.record.created": "Registro del lote creado para seguimiento y auditoría.",
  "lotFlow.record.open": "Ver registro y responsable",
  "lotFlow.session.another": "Enviar otra planilla",
  "lotFlow.session.count.one": "{count} lote de esta sesión sigue en esta página",
  "lotFlow.session.count.other": "{count} lotes de esta sesión siguen en esta página",
  "lotFlow.reading.title": "Leyendo la planilla",
  "lotFlow.reading.sheets": "Buscando hojas con lista de productos",
  "lotFlow.reading.header": "Encontrando el encabezado y el formato de los números",
  "lotFlow.reading.columns": "Sugiriendo las columnas de NCM, costo, cantidad y ruta",
  "lotFlow.detect.title": "Lo que encontramos",
  "lotFlow.detect.body.one": "Hoja {sheet} · 1 fila de producto. Si algo está mal, ajústelo abajo.",
  "lotFlow.detect.body.other":
    "Hoja {sheet} · {rows} filas de producto. Si algo está mal, ajústelo abajo.",
  "lotFlow.detect.ok": "Detectado",
  "lotFlow.detect.check": "Revise",
  "lotFlow.detect.sheets.one": "{count} hoja",
  "lotFlow.detect.sheets.other": "{count} hojas",
  "lotFlow.detect.lists.one": "{count} lista de productos",
  "lotFlow.detect.lists.other": "{count} listas de productos",
  "lotFlow.detect.header": "Encabezado en la fila {row}",
  "lotFlow.detect.decimal": "Números en formato {format}, leído de los propios valores",
  "lotFlow.detect.decimalDefault":
    "Números en formato {format} (por defecto: los valores no lo aclaran)",
  "lotFlow.detect.routeFixed": "Ruta única",
  "lotFlow.detect.source.SHEET_NAME": "leída del nombre de la hoja",
  "lotFlow.detect.source.COLUMN": "leída de las columnas de UF",
  "lotFlow.detect.source.HEADER_BLOCK": "leída del bloque sobre el encabezado",
  "lotFlow.detect.source.PARAMETER_SHEET": "leída de la hoja de parámetros",
  "lotFlow.detect.routeRows.one": "Ruta por fila · {count} ruta en el archivo",
  "lotFlow.detect.routeRows.other": "Ruta por fila · {count} rutas en el archivo",
  "lotFlow.detect.routeMissing": "Falta la ruta: elija la UF de origen y la de destino abajo",
  "lotFlow.detect.costMissing":
    "Falta la columna de costo fiscal unitario: elíjala en Campos fiscales",
  "lotFlow.detect.column": "{field} en {column}",
  "lotFlow.field.ncm": "NCM",
  "lotFlow.field.custo": "Costo",
  "lotFlow.field.quantidade": "Cantidad",
  "lotFlow.confirm.title": "Resumen antes de confirmar",
  "lotFlow.confirm.rows": "filas de producto",
  "lotFlow.confirm.repair": "filas con reparación sugerida",
  "lotFlow.confirm.mended": "filas reparadas",
  "lotFlow.confirm.open": "filas con pendientes",
  "lotFlow.confirm.mini": "{rows} filas · {open} con pendientes",
  "lotFlow.run.title": "Configurar el cálculo",
  "lotFlow.run.body":
    "Fecha, versión de las reglas y, si quiere, el régimen de PIS/COFINS y el precio de venta. Lo demás viene de la planilla.",
  "lotFlow.run.ready": "{count} filas listas para calcular.",
  "lotFlow.premises.title": "Premisas leídas de la planilla, ya completadas abajo:",
  "lotFlow.premises.tr": "Valor de venta con TR {value} ({cell})",
  "lotFlow.premises.saleUf":
    "UF de destino de la venta {value} ({cell}), cliente contribuyente de ICMS",
  "lotFlow.premises.regime": "Régimen PIS/COFINS {value} ({cell})",
  "lotFlow.premises.saleDiscount":
    "Descuento comercial de la venta {value} ({cell}) · solo en los totales, no cambia la base de los impuestos",
  "lotFlow.premises.purchaseDiscount":
    "Descuento comercial de la compra {value} ({cell}) · solo en los totales, no cambia la base de los impuestos",
  "lotFlow.premises.changed": "cambiado por usted",
  "lotFlow.premises.check":
    "Son premisas del archivo, no reglas publicadas: revíselas antes de calcular.",
  "lotMap.field.item_id": "Identificador de fila",
  "lotMap.field.sku": "SKU",
  "lotMap.field.category": "Categoría",
  "lotMap.field.marca": "Marca",
  "lotMap.field.familia": "Familia",
  "lotMap.field.ean": "EAN",
  "lotMap.field.peso": "Peso",
  "lotMap.field.ncm": "NCM",
  "productFile.title": "Producto en el archivo",
  "productFile.fact.description": "Descripción",
  "productFile.fact.category": "Categoría",
  "productFile.fact.brand": "Marca",
  "productFile.fact.family": "Familia",
  "productFile.fact.ean": "EAN",
  "productFile.fact.weight": "Peso",
  "productFile.cellTitle": "{header}, celda {cell}",
  "productFile.cellTitlePlain": "celda {cell}",
  "lotMap.field.cest": "CEST",
  "lotMap.field.origem_mercadoria": "Origen de la mercancía (CST)",
  "lotMap.field.uf_origem": "UF de origen",
  "lotMap.field.uf_destino": "UF de destino",
  "lotMap.field.custo": "Costo de mercancía (obligatorio)",
  "lotMap.field.quantidade": "Cantidad",
  "lotMap.field.meio_pagamento": "Medio de pago",
  "lotMap.field.tipo_transacao": "Tipo de transacción",

  "lotSim.permission": "Se necesita permiso para ejecutar cálculos para importar y simular.",
  "lotSim.retry.slow": "El servidor tardó en responder; reintentando…",
  "lotSim.retry.network": "Se cayó la conexión; reintentando…",
  "lotSim.retry.action": "Reintentar",
  "lotSim.missingUpload": "Importe el archivo antes de iniciar la tarea.",
  "lotSim.downloadOriginal": "Descargar original",
  "lotSim.title": "Calculadora fiscal",
  "lotSim.subtitle": "Operaciones · Calculadora fiscal en lote · reglas publicadas",
  "lotSim.body":
    "Aplique las reglas publicadas a su lista y compruebe el desglose de cada impuesto.",
  "lotSim.input": "Preparar simulación",
  "lotSim.template": "Descargar plantilla CSV",
  "lotSim.file": "Archivo Excel o CSV · hasta 5.000 filas por hoja y 25 MB",
  "lotSim.date": "Fecha de operación",
  "lotSim.version": "Versión de reglas",
  "lotSim.choose": "Seleccione una versión publicada",
  "lotSim.loading": "Procesando…",
  "lotSim.noRules":
    "No hay reglas publicadas para simular. Pide al responsable fiscal que compruebe la cobertura necesaria.",
  "lotSim.run": "Calcular lote",
  "lotSim.rows": "Filas del archivo",
  "lotSim.fix":
    "Las filas con error quedan fuera de la simulación y se listan abajo. Corríjalas en el archivo e importe de nuevo para incluirlas. Ninguna fila se descarta en silencio.",
  "lotSim.row": "Fila",
  "lotSim.cost": "Costo fiscal unitario",
  "lotSim.result": "Resultado / pendientes",
  "lotSim.receipt": "Recibo de simulación",
  "lotSim.trace": "Abrir memoria de cálculo",
  "lotSim.export": "Exportar solicitud y resultado",
  "lotSim.size": "El límite del archivo es 25 MB.",
  "lotSim.runHint": "La tarea se registrará con la versión seleccionada.",
  "lotSim.mode.label": "Modo de la calculadora",
  "lotSim.mode.lote": "Carga en lote",
  "lotSim.mode.individual": "Simulación individual",
  "lotSim.drop.title": "Suelte sus planillas aquí",
  "lotSim.drop.active": "Suelte para leer la planilla",
  "lotSim.drop.limits": ".xlsx, .xlsm o .csv · hasta 5.000 filas por hoja · 25 MB",
  "lotSim.drop.legacySteps": "Cómo resolverlo",
  "lotSim.drop.choose": "Elegir archivos",
  "lotSim.drop.orOne": "o elija un archivo",
  "lotSim.drop.sending": "Enviando {size} MB directo al almacenamiento…",
  "lotSim.upload.title": "Calcular desde una planilla",
  "lotSim.upload.body":
    "Suba el Excel o CSV. Revisamos las columnas y las reglas fiscales publicadas; lo que no tenga regla queda pendiente de revisión.",
  "lotSim.guide.title": "Cómo se procesa la planilla",
  "lotSim.guide.files": "Varios archivos a la vez, confirmados en secuencia",
  "lotSim.guide.sheets": "Cada hoja de productos elegida se vuelve un cálculo",
  "lotSim.guide.route": "Ruta fija o una ruta por fila, de las columnas de UF",
  "lotSim.guide.numbers": "El formato de los números, 1.234,56 o 1,234.56",
  "lotSim.guide.premises":
    "TR, UF de venta y régimen del encabezado de la hoja, ofrecidos como entrada",
  "lotSim.guide.repair": "“Reparar la hoja” sugiere correcciones; usted las acepta una por una",
  "lotSim.rowsShown": "Mostrando {shown} de {total} filas",
  "lotSim.showMoreRows": "Mostrar {count} más",
  "lotSim.showAllRows": "Mostrar las {total}",
  "lotSim.drop.invalid": "No se pudo leer este archivo",
  "lotSim.file.change": "Cambiar archivo",
  "lotSim.file.facts.sheets": "{count} hojas",
  "lotSim.file.facts.rows": "{count} filas",
  "lotSim.file.facts.rowsRead": "{count} filas leídas",
  "lotSim.file.facts.columns": "{count} columnas",
  "lotSim.file.facts.formulas": "{count} fórmulas",
  "lotSim.file.facts.invalid": "{count} filas con error",
  "lotSim.file.facts.size": "{size} KB",
  "lotSim.file.facts.fiscalDate": "fecha fiscal {date}",
  "lotSim.file.noDrop": "Ninguna fila se descartó en silencio.",
  "lotSim.run.blocked.rows":
    "No hay filas válidas para simular. Corrija el archivo e impórtelo de nuevo.",
  "lotSim.run.excludedNote": "{count} filas con error quedarán fuera y se listan abajo.",
  "lotSim.excluded.title": "{count} filas fuera de la simulación",
  "lotSim.excluded.hint":
    "Estas filas tienen errores en el archivo. Las filas válidas se calculan; cada fila excluida se lista aquí con su hoja, fila, columna y motivo, y en las exportaciones.",
  "lotSim.status.excluded": "Excluida",
  "lotSim.row.excluded": "Excluida: {reason}",
  "lotSim.run.blocked.version": "Elija una versión publicada.",
  "lotSim.run.blocked.date": "Indique la fecha de operación.",
  "lotSim.drop.or": "o elija varios archivos",
  "lotSim.stepKicker": "PASO {n}",
  "lotSim.banner":
    "El costo puede ser unitario o total de línea, según base_valor. Los impuestos provienen de las reglas publicadas.",
  "lotSim.clear": "Quitar archivo",
  "lotLive.steps.label": "Etapas de lectura",
  "lotLive.steps.sheets": "Buscando hojas",
  "lotLive.steps.header": "Encabezado y formato",
  "lotLive.steps.columns": "Sugiriendo columnas",
  "lotLive.steps.state.complete": "completado",
  "lotLive.steps.state.running": "en curso",
  "lotLive.steps.state.waiting": "en espera",
  "lotLive.caption": "Primeras filas · encabezado en la fila {row}",
  "lotLive.headerTag": "Encabezado",
  "lotLive.table.region": "Vista previa de la hoja {sheet}",
  "lotLive.table.rowNumber": "Número de fila",
  "lotLive.columns.title": "Columnas reconocidas",
  "lotLive.columns.field": "{field} · {column}",
  "lotLive.columns.missing": "{field} no encontrado(a)",
  "lotLive.review": "Revisar columnas",
  "lotLive.reviewNeeded": "Revisar columnas",
  "lotLive.summary.decimal": "{format}",
  "lotLive.fixedRoute": "Ruta {origin} → {destination}",
  "lotLive.sheets.ready": "{count} hojas listas para calcular",
  "lotLive.premise.tr": "TR",
  "lotLive.premise.saleUf": "UF de venta",
  "lotLive.premise.regime": "PIS/COFINS",
  "lotLive.premise.saleDiscount": "Descuento de la venta",
  "lotLive.premise.purchaseDiscount": "Descuento de la compra",
  "lotLive.premise.missing": "No informado en la hoja",
  "lotLive.ignored.one": "{count} hoja ignorada: {names}",
  "lotLive.ignored.other": "{count} hojas ignoradas: {names}",
  "lotLive.calculate.invalid": "Revise las columnas de {sheets} antes de calcular",
  "lotLive.calculate.choose": "Elija al menos una hoja",
  "lotLive.autoInfo":
    "Si la planilla ya incluye la ruta, el proveedor y los datos fiscales, el cálculo empieza automáticamente al terminar esta revisión. Si no, revise las columnas y confirme; las filas sin regla o datos quedan para revisión.",
  "lotLive.announce.reading": "{file}: leyendo la planilla",
  "lotLive.announce.header": "Encabezado en la fila {row} · {count} columnas reconocidas",
  "lotLive.announce.sheetsReady": "{count} hojas listas para calcular",
  "lotLive.format.notAccepted": "no aceptado",
  "lotLive.format.saveAsXlsx": "Guárdelo como .xlsx",
  "lotLive.format.rule":
    "Formatos aceptados: .xlsx, .xlsm, .csv y .txt delimitado en UTF-8. No se acepta .xls (Excel 97-2003). Hasta 5.000 filas por hoja y 25 MB.",
  "lotLive.format.limits": "hasta 5.000 filas por hoja · 25 MB",
  "lotSim.metric.rows": "Filas",
  "lotSim.metric.calculated": "Calculadas",
  "lotSim.metric.review": "Revisión",
  "reviewFix.title": "Qué falta para calcular",
  "reviewFix.generalRuleRow": "Regla general (sin ST), no es una regla publicada: {basis}.",
  "reviewFix.generalRule.one":
    "{count} fila calculada por la regla general (sin ST): alícuota de la Res. SF 22/89 (o interna verificada) y NCM sin ST comprobado.",
  "reviewFix.generalRule.other":
    "{count} filas calculadas por la regla general (sin ST): alícuota de la Res. SF 22/89 (o interna verificada) y NCM sin ST comprobado.",
  "reviewFix.destinationStRuleRow":
    "{label}: regla de ST del destino, publicada como {source}, con la alícuota interestatal de la Res. SF 22/89. {basis}.",
  "reviewFix.fcpInAlqIntraRow":
    "FECP del destino en la MVA ajustada: ALQ intra {alqIntra} ({internal} + FECP {fcp}). ICMS-ST {icmsSt} y FECP-ST {fcpSt}, en líneas separadas. {basis}.",
  "reviewFix.stCollectionRow":
    "ST retenido por el remitente ({agreement}, {route}): ICMS-ST {amount}, FECP-ST {fcpAmount}, en la NF del proveedor. {basis}.",
  "reviewFix.destinationStRule.one":
    "{count} fila calculada con la regla de ST derivada de la regla publicada del destino (otro origen, misma MVA, alícuota interestatal legal).",
  "reviewFix.destinationStRule.other":
    "{count} filas calculadas con la regla de ST derivada de la regla publicada del destino (otro origen, misma MVA, alícuota interestatal legal).",
  "compareFile.name.ipi": "IPI",
  "compareFile.name.icmsSt": "ICMS-ST",
  "compareFile.name.taxTotal": "total de tributos",
  "compareFile.name.landed": "costo puesto",
  "compareFile.name.ownIcms": "ICMS de la entrada",
  "compareFile.name.purchasePisCofins": "PIS/COFINS de la compra",
  "compareFile.name.workbookCost": "costo como en la planilla (prod. + IPI + ST)",
  "compareFile.name.salePrice": "valor de venta con TR",
  "compareFile.name.saleIcms": "ICMS propio de la venta",
  "compareFile.name.salePisCofins": "PIS/COFINS de la venta",
  "compareFile.name.saleStFcp": "ICMS-ST y FCP-ST de la NF de venta",
  "compareFile.name.buyerInvoice": "NF de venta del comprador",
  "compareFile.toggle": "Comparar con mi archivo",
  "compareFile.fields":
    "Compara {fields} con las columnas que informa el archivo. Las diferencias de hasta R$ 0,01 cuentan como iguales.",
  "compareFile.tally.rows": "filas comparadas",
  "compareFile.tally.difference": "diferentes",
  "compareFile.tally.match": "iguales",
  "compareFile.tally.pending": "sin valor del motor",
  "compareFile.onlyDifferent": "Solo diferentes",
  "compareFile.caption": "Resultados comparados con el archivo",
  "compareFile.base": "Base BRL / u.",
  "compareFile.field.ipi": "IPI / u.",
  "compareFile.field.icmsSt": "ICMS-ST / u.",
  "compareFile.field.taxTotal": "Tributos / u.",
  "compareFile.field.landed": "Costo puesto / u.",
  "compareFile.field.ownIcms": "ICMS entrada / u.",
  "compareFile.field.purchasePisCofins": "PIS/COFINS compra / u.",
  "compareFile.field.workbookCost": "Costo como en la planilla / u.",
  "compareFile.field.salePrice": "Venta c/ TR / u.",
  "compareFile.field.saleIcms": "ICMS propio venta / u.",
  "compareFile.field.salePisCofins": "PIS/COFINS venta / u.",
  "compareFile.field.saleStFcp": "ICMS-ST/FCP-ST venta / u.",
  "compareFile.field.buyerInvoice": "NF venta Buyer / u.",
  "compareFile.file": "Archivo",
  "compareFile.engine": "Motor",
  "compareFile.delta": "Δ",
  "compareFile.deltaHint": "Diferencia: motor − archivo",
  "compareFile.verdict": "Comparación",
  "compareFile.notMapped": "Sin columna en el archivo",
  "compareFile.note":
    "Solo lectura: los valores del archivo vienen de las columnas mapeadas en la importación. Las diferencias de hasta R$ 0,01 cuentan como iguales. Una fila sin regla no tiene valor del motor y nunca se trata como cero. Desactive la comparación para volver a la tabla de resultados.",
  "compareFile.limit":
    "Mostrando {shown} de {total} filas diferentes. Exporte el CSV para verlas todas.",
  "compareFile.empty.title": "Ninguna fila diferente",
  "compareFile.empty.body":
    "Con los filtros actuales, los valores del motor coinciden con el archivo o todavía no tienen cálculo.",
  "reviewCause.title": "{count} de {total} filas por revisar",
  "reviewCause.hint":
    "Por motivo, con la acción que resuelve cada uno. Una fila puede tener más de un motivo: los grupos no se suman. Las cotizaciones estimadas se identifican y se separan de los totales fiscales confirmados.",
  "reviewCause.reading": "Leyendo los motivos de cada fila…",
  "reviewCause.example": "Ej.: {text}",
  "reviewCause.less": "Mostrar menos motivos",
  "reviewCause.more.one": "{count} motivo más",
  "reviewCause.more.other": "{count} motivos más",
  "reviewCause.viewRows.one": "Ver la fila",
  "reviewCause.viewRows.other": "Ver las {count} filas",
  "reviewCause.research.one": "Investigar {count} laguna",
  "reviewCause.research.other": "Investigar {count} lagunas",
  "reviewCause.scope.ncm.one": "{count} NCM",
  "reviewCause.scope.ncm.other": "{count} NCM",
  "reviewCause.scope.route.one": "{count} ruta",
  "reviewCause.scope.route.other": "{count} rutas",
  "reviewCause.kind.RULE": "Regla",
  "reviewCause.kind.CEST": "Clasificación",
  "reviewCause.kind.FILE": "Planilla",
  "reviewCause.kind.PROFILE": "PIS/COFINS",
  "reviewCause.kind.OTHER": "Revisión",
  "reviewCause.short.CEST_MISMATCH": "El CEST no coincide con la regla",
  "reviewCause.short.AMBIGUOUS_CEST": "Varios CEST posibles",
  "reviewCause.short.NO_RULE_FOR_ROUTE": "NCM sin regla publicada en esta ruta",
  "reviewCause.short.NO_RULE_FOR_NCM": "NCM sin regla publicada",
  "reviewCause.short.ICMS_NOT_PUBLISHED": "ICMS no publicado para la ruta",
  "reviewCause.short.RULE_EXPIRED": "Regla vencida en la fecha del cálculo",
  "reviewCause.short.RULE_NOT_YET_EFFECTIVE": "Regla aún no vigente en la fecha",
  "reviewCause.short.RULESET_EMPTY": "Sin reglas publicadas",
  "reviewCause.short.FIELD_MISSING": "Falta un campo en la planilla",
  "reviewCause.short.PROFILE_PENDING": "Perfil PIS/COFINS por confirmar",
  "reviewCause.short.BENEFIT_NOT_IN_RULE": "cBenef fuera de la regla de la venta",
  "reviewCause.short.SALE_RULE_MISSING": "Sin regla para el ICMS de la venta",
  "reviewCause.short.OTHER": "Otro motivo",
  "reviewCause.short.ACQUISITION_PENDING": "Datos fiscales de la adquisición pendientes",
  "reviewCause.next.ACQUISITION_PENDING":
    "Abre el detalle de la fila para revisar y completar la clasificación, el origen de la mercancía o la regla fiscal que esté pendiente.",
  "reviewCause.next.RULE":
    "Revise las reglas aplicables o investigue la ruta; publique antes de recalcular.",
  "reviewCause.next.CEST": "Corrija el CEST y recalcule.",
  "reviewCause.next.FILE": "Corrija la planilla e impórtela de nuevo.",
  "reviewCause.next.PROFILE": "Confirme el perfil PIS/COFINS por producto y recalcule.",
  "reviewCause.next.OTHER": "Abra la fila para ver la memoria del cálculo.",
  "reviewCause.profile.BEVERAGE_PROFILE": "bebida fría de la Lei 13.097/2015",
  "reviewCause.profile.REQUIRES_CONFIRMATION": "lista con una condición que el NCM no prueba",
  "reviewCause.profile.OVERLAPPING_LISTS": "en más de una lista",
  "reviewCause.profile.NOT_IN_CATALOG": "tratamiento fuera de la lista legal",
  "reviewCause.profile.OTHER": "por confirmar",
  "reviewCause.rowTitle": "Por qué esta fila necesita revisión",
  "reviewCause.fact.product": "Producto",
  "reviewCause.fact.route": "NCM y ruta",
  "reviewCause.fact.provenance": "Procedencia",
  "reviewCause.fact.provenanceRow": "{sheet}, fila {row}",
  "reviewCause.fact.rules": "reglas {version}",
  "reviewCause.noRule": "Sin regla publicada",
  "reviewCause.pending": "Pendiente",
  "reviewFix.fixCests": "Corregir CEST y recalcular ({count})",
  "reviewFix.reason.CEST_MISMATCH":
    "El CEST {cest} no corresponde al NCM {ncm} en {route} (se espera {expected}).",
  "reviewFix.reason.AMBIGUOUS_CEST":
    "El NCM {ncm} en {route} tiene reglas para varios CEST ({expected}); la fila no informa CEST.",
  "reviewFix.reason.NO_RULE_FOR_ROUTE":
    "El NCM {ncm} tiene reglas publicadas, pero ninguna para {route}.",
  "reviewFix.reason.NO_RULE_FOR_NCM": "Ninguna regla publicada para el NCM {ncm} ({route}).",
  "reviewFix.reason.ICMS_NOT_PUBLISHED":
    "Solo la fila de la TIPI cubre el NCM {ncm}: ICMS no publicado para {route}.",
  "reviewFix.reason.RULE_EXPIRED":
    "La regla del NCM {ncm} en {route} terminó antes de la fecha del cálculo.",
  "reviewFix.reason.RULE_NOT_YET_EFFECTIVE":
    "La regla del NCM {ncm} en {route} empieza después de la fecha del cálculo.",
  "reviewFix.reason.RULESET_EMPTY": "No hay reglas fiscales publicadas.",
  "reviewFix.reason.FIELD_MISSING": "La fila no tiene {field} válido.",
  "reviewFix.reason.PROFILE_PENDING":
    "El NCM {ncm} tiene un tratamiento propio de PIS/COFINS ({profile}).",
  "reviewFix.reason.BENEFIT_NOT_IN_RULE":
    "El cBenef {benefit} no está en la regla publicada de la venta.",
  "reviewFix.reason.SALE_RULE_MISSING":
    "Ninguna regla informa el ICMS de la venta {saleRoute} para el NCM {ncm}.",
  "reviewFix.reason.OTHER": "Revisión necesaria para el NCM {ncm} en {route}.",
  "reviewFix.fix.SET_CEST": "Corrección: usar el CEST {value} de la regla publicada.",
  "reviewFix.fix.PICK_CEST": "Corrección: elegir el CEST en Reparar planilla.",
  "reviewFix.fix.RESEARCH_ROUTE": "Siguiente paso: investigar la ruta.",
  "reviewFix.fix.FIX_SHEET": "Corrección: completar {field} en la hoja e importarla de nuevo.",
  "reviewFix.fix.STATE_TREATMENT": "Corrección: informar el tratamiento confirmado.",
  "reviewFix.fixFailed": "No se pudo aplicar ninguna corrección de CEST a la hoja.",
  "lotSim.column.item": "Ítem",
  "lotSim.column.ncm": "NCM / ruta",
  "lotSim.column.ipi": "IPI",
  "lotSim.column.icmsSt": "ICMS (ST o propio)",
  "lotSim.column.taxTotal": "Tributos",
  "lotSim.column.landed": "Costo puesto",
  "lotSim.column.status": "Estado",
  "lotSim.expand": "Abrir memoria de la fila {row}",
  "lotSim.collapse": "Cerrar memoria de la fila {row}",
  "lotSim.waterfall.title": "Memoria fiscal",
  "lotSim.waterfall.cost": "Costo fiscal unitario",
  "lotSim.waterfall.ipi": "(+) IPI",
  "lotSim.waterfall.icmsSt": "(+) ICMS (ST o propio)",
  "lotSim.waterfall.taxTotal": "Total de tributos",
  "lotSim.waterfall.take": "(+) Tasa de intermediación",
  "lotSim.waterfall.logistics": "(+) Logística",
  "lotSim.waterfall.freight": "(+) Flete",
  "lotSim.waterfall.other": "(+) Otros",
  "lotSim.waterfall.landed": "Costo puesto unitario",
  "costs.operationalNotConfigured": "Costo operativo no configurado — fuera del cálculo fiscal",
  "costs.feeNotConfigured": "Comisión comercial no configurada — fuera del cálculo fiscal",
  "costs.bothNotConfigured":
    "Costo operativo y comisión comercial no configurados — fuera del cálculo fiscal",
  "costs.explainer":
    "IPI, ICMS e ICMS-ST y el costo fiscal puesto están calculados. El costo comercial puesto no está disponible hasta que se publiquen estos costos.",
  "costs.fiscalLanded": "Costo fiscal puesto unitario",
  "costs.pricingBasis":
    "El precio de venta y el margen usan el costo fiscal puesto, antes del costo operativo y de la comisión comercial.",
  "costs.notConfiguredShort": "No configurado",
  "costs.invalid":
    "La regla de costo operativo o de comisión comercial no se puede aplicar; el ítem necesita revisión.",
  "lotSim.waterfall.ipiRate": "Alícuota IPI publicada",
  "lotSim.waterfall.mva": "MVA ajustada",
  "shadow.title": "Comparación con datos verificados",
  "shadow.hint":
    "Modo sombra: el mismo ítem calculado con hechos fiscales verificados o certificados vigentes el {date}. Solo lectura.",
  "shadow.returned": "Los valores devueltos y guardados siguen siendo los de la regla publicada.",
  "shadow.unavailable":
    "No se pudieron leer los hechos en este cálculo. El cálculo no se vio afectado.",
  "shadow.status.NO_FACTS": "Ningún hecho verificado o certificado cubre este NCM y trayecto.",
  "shadow.status.INCOMPLETE":
    "Los hechos verificados no cubren todos los campos necesarios, así que no hay resultado alternativo.",
  "shadow.status.CONFLICT":
    "Los hechos verificados difieren entre sí; no se calculó ningún resultado alternativo.",
  "shadow.status.AMBIGUOUS":
    "Hay hechos de CEST distintos para este NCM y el ítem no informa CEST.",
  "shadow.status.NOT_COMPARABLE": "Ítem sin NCM o UF: nada que comparar.",
  "shadow.changed": "Los datos verificados cambiarían este ítem.",
  "shadow.same": "Los datos verificados confirman este ítem.",
  "shadow.level.CERTIFIED": "Nivel: certificado.",
  "shadow.level.VERIFIED": "Nivel: verificado.",
  "shadow.gap": "sin regla publicada, los hechos llenarían esta brecha",
  "shadow.revalidation": "revalidación solicitada",
  "shadow.column.field": "Campo",
  "shadow.column.rule": "Regla publicada",
  "shadow.column.facts": "Datos verificados",
  "shadow.field.stApplicable": "ICMS-ST aplicable",
  "shadow.field.originalMva": "MVA original",
  "shadow.field.destinationInternalRate": "Alícuota interna en destino",
  "shadow.field.interstateRate": "Alícuota interestatal",
  "shadow.st.yes": "sí",
  "shadow.st.no": "no",
  "shadow.noSt.certified": "Sin ST (certificado IOB)",
  "shadow.noSt.verified": "Sin ST (datos verificados)",
  "shadow.noSt.internal":
    "ST interna en el destino ({uf}): sin retención por el remitente; el destinatario recauda la anticipación o ST en las operaciones internas.",
  "shadow.noSt.internalNoUf":
    "ST interna en el destino: sin retención por el remitente; el destinatario recauda la anticipación o ST en las operaciones internas.",
  "shadow.admin.title": "Modo sombra: comparación con datos verificados",
  "shadow.admin.hint":
    "Últimos {days} días. Cuántos ítems cambiarían los hechos verificados o certificados. Los valores devueltos siguen siendo los de la regla.",
  "shadow.admin.off":
    "Modo sombra apagado. Necesita FISCAL_FACTS_MODE=SHADOW en el entorno (hoy: {environment}) y el modo Sombra o Encendido guardado arriba.",
  "shadow.admin.calculations": "Cálculos",
  "shadow.admin.compared": "Ítems comparados",
  "shadow.admin.changed": "Cambiarían",
  "shadow.admin.gapsFilled": "Brechas cubiertas",
  "shadow.admin.disagreements": "Difieren de la regla",
  "shadow.admin.noFacts": "Sin hechos",
  "shadow.admin.incomplete": "Incompletos o en conflicto",
  "shadow.admin.levels": "Certificado / verificado",
  "shadow.admin.landedDelta": "Δ costo puesto (suma)",
  "shadow.admin.maxDelta": "Mayor |Δ| por ítem",
  "shadow.admin.routes": "Trayectos con más ítems comparados",
  "shadow.admin.column.route": "NCM · trayecto",
  "shadow.admin.column.compared": "Comparados",
  "shadow.admin.column.changed": "Cambiarían",
  "shadow.admin.column.delta": "Δ costo puesto",
  "shadow.admin.last": "Última comparación: {time}",
  "shadow.admin.none": "Ninguna comparación registrada en el período.",
  "calc.form.regime": "Régimen de PIS/COFINS",
  "calc.form.regime.UNKNOWN": "No informado",
  "calc.form.regime.NON_CUMULATIVE": "No acumulativo (1,65% / 7,6%)",
  "calc.form.regime.CUMULATIVE": "Acumulativo (0,65% / 3%)",
  "calc.form.regimeHint":
    "Se usa cuando la regla no trae PIS/COFINS. En las planillas prevalece el régimen informado en la fila, incluso UNKNOWN; este control completa regímenes ausentes o el valor predeterminado sin confirmar del mapeo. Sin régimen, PIS/COFINS queda sin seguimiento.",
  "calc.form.pricing": "Precio de venta",
  "calc.form.pricing.NONE": "No calcular",
  "calc.form.pricing.MARKUP": "Markup sobre el costo puesto",
  "calc.form.pricing.TARGET_MARGIN": "Margen bruto sobre el precio",
  "calc.form.pricingRate": "Porcentaje (%)",
  "calc.form.pricingRateError":
    "Indique un porcentaje válido. El margen objetivo debe quedar por debajo del 100%.",
  "fiscalLines.fcp": "(+) FCP/FECP",
  "fiscalLines.fcpSt": "(+) FCP-ST",
  "fiscalLines.fcpNote":
    "Fondo de combate a la pobreza de la UF de destino, tal como lo declara la regla vigente. Sin FCP en la regla, queda como no seguido.",
  "fiscalLines.notTracked": "no seguido",
  "fiscalLines.notApplicable": "no aplica",
  "fiscalLines.exempt": "exento",
  "fiscalLines.pisRate": "Alícuota PIS en la venta",
  "fiscalLines.cofinsRate": "Alícuota COFINS en la venta",
  "fiscalLines.pisOnSale": "(−) PIS en la venta",
  "fiscalLines.cofinsOnSale": "(−) COFINS en la venta",
  "fiscalLines.source.RULE": "regla publicada",
  "fiscalLines.source.REGIME_DEFAULT": "alícuota general del régimen",
  "pricing.title": "Precio y margen",
  "pricing.salePrice": "Precio de venta",
  "pricing.method.MARKUP": "markup {rate}",
  "pricing.method.TARGET_MARGIN": "margen objetivo {rate}",
  "pricing.margin": "Margen",
  "pricing.marginPct": "{value} del precio",
  "calc.form.pricing.NET_TARGET_MARGIN": "Margen neto deseado (después de impuestos de la venta)",
  "calc.form.pricing.COST_PLUS_TR": "Valor de venta con TR (costo de la NF de compra ÷ (1 − TR))",
  "calc.form.pricingTrHint":
    "Como en la planilla: precio = costo de la NF de compra (productos + IPI + ICMS-ST) ÷ (1 − TR). ICMS, PIS/COFINS y ST de la venta se calculan sobre ese precio, sin embutirlos.",
  "pricing.method.COST_PLUS_TR": "TR {rate}",
  "pricing.tr.invoiceCost": "Costo de la NF de compra (productos + IPI + ICMS-ST)",
  "pricing.tr.icmsOnSale": "ICMS propio de la venta",
  "pricing.tr.icmsClosed":
    "Mercadería ya sustituida: venta interna sin nuevo ICMS (CST 60). PIS/COFINS sobre el precio completo.",
  "pricing.tr.icmsBurdenNeeded":
    "Venta interna sin reducción de base declarada en la regla: ICMS propio a la alícuota nominal. Si hay carga efectiva (p. ej. art. 39 del RICMS/SP), debe publicarse en la regla.",
  "pricing.tr.pisCofins": "PIS/COFINS de la venta (fuera de la base)",
  "pricing.tr.pisCofinsFormula": "({price} − ICMS {icms}) × alícuota",
  "pricing.tr.st": "ICMS-ST en la NF de venta",
  "pricing.tr.stNotOnInvoice":
    "La regla de la venta es ST, pero la NF no lleva la retención (sin acuerdo o cliente no contribuyente); una eventual anticipación es del destinatario.",
  "pricing.tr.fcpSt": "FCP/FECP-ST en la NF de venta",
  "pricing.tr.difal": "DIFAL + FCP del destino",
  "pricing.tr.buyerInvoice": "NF de venta del comprador (precio + ICMS-ST + FCP-ST)",
  "pricing.tr.margin": "Lo que queda tras los impuestos de la venta",
  "pricing.tr.marginNote":
    "El TR no embute los impuestos de la venta: lo que queda tras ellos es menor que el TR (nota 4 de la planilla).",
  "pricing.tr.cst": "CST indicativo {cst}",
  "calc.form.pricingNetHint":
    "El precio sale de (costo puesto − créditos) ÷ (1 − margen − impuestos de la venta): el margen indicado es el que queda después de ICMS, PIS y COFINS de la venta.",
  "calc.form.pricingNetRegime":
    "Sin el régimen de PIS/COFINS, el margen neto no descuenta PIS/COFINS de la venta ni suma los créditos de la compra.",
  "calc.form.saleDestination": "Destino de la venta",
  "calc.form.saleDestination.center": "Venta interna en el CD",
  "calc.form.customerType": "Cliente de la venta",
  "calc.form.customerType.ICMS_TAXPAYER": "Contribuyente de ICMS",
  "calc.form.customerType.FINAL_CONSUMER": "Consumidor final (DIFAL)",
  "pricing.method.NET_TARGET_MARGIN": "margen neto {rate}",
  "pricing.net.route": "Venta {origin} → {destination} · {customer}",
  "pricing.net.assumedDestination": "venta interna en el CD",
  "pricing.net.assumedCustomer": "cliente contribuyente de ICMS",
  "pricing.net.assumedNote":
    "Supuesto: {what}. Indique el destino y el cliente de la venta para fijarlo.",
  "pricing.net.formula":
    "Precio = (costo puesto − créditos) ÷ (1 − margen − impuestos de la venta)",
  "pricing.net.formulaValues": "({cost} − {credits}) ÷ {divisor} = {price}",
  "pricing.net.icmsOnSale": "(−) ICMS en la venta",
  "pricing.net.icmsClosed":
    "ICMS-ST pagado en la entrada: sin ICMS en la venta y sin crédito de ICMS.",
  "pricing.net.icmsNotTaxed": "Venta sin ICMS: el crédito de ICMS de la compra se revierte.",
  "pricing.net.fcpOnSale": "(−) FCP en la venta",
  "pricing.net.difalOnSale": "(−) DIFAL en la venta",
  "pricing.net.credits": "(−) Créditos de la compra",
  "pricing.net.creditsDetail": "ICMS {icms} · PIS {pis} · COFINS {cofins}",
  "pricing.net.netCost": "Costo neto de créditos",
  "pricing.net.margin": "Margen neto",
  "pricing.net.markup": "Markup sobre el costo puesto",
  "lotOps.group.price": "Precio sugerido",
  "lotOps.price.netMargin": "Margen neto",
  "lotOps.price.markup": "Markup",
  "pricing.untracked": "PIS/COFINS no seguido: el margen está antes de esas contribuciones.",
  "calculations.explain.fiscalLines": "FCP, PIS/COFINS y margen",
  "lotSim.status.calculated": "Calculado",
  "lotSim.status.review": "Revisión",
  "lotSim.pending": "Esperando simulación",
  "lotSim.individual.body":
    "Una SKU, una ruta, las reglas publicadas. Precio y margen están en Más opciones.",
  "lotSim.individual.ncm": "NCM",
  "lotSim.individual.origin": "UF de origen",
  "lotSim.individual.destination": "UF de destino",
  "lotSim.selectUf": "Seleccione la UF",
  "lotSim.individual.quantity": "Cantidad",
  "lotSim.individual.result": "Resultado",
  "lotSim.individual.resultMeta": "{date} · {version}",
  "calc.form.title": "Producto y ruta",
  "calc.form.ncmPlaceholder": "Ej.: 8471.30.12",
  "calc.form.ncmHint": "Los 8 dígitos de la NCM del producto.",
  "calc.form.ncmError": "Indique los 8 dígitos de la NCM.",
  "calc.form.route": "Ruta",
  "calc.form.ufError": "Seleccione la UF.",
  "calc.form.swap": "Invertir origen y destino",
  "calc.form.costHint": "Costo fiscal de una unidad, antes de tributos.",
  "calc.form.costInvalid": "Use el formato 1.000,00.",
  "calc.form.costError": "Indique el costo fiscal unitario.",
  "calc.form.more": "Más opciones",
  "calc.form.moreSummary": "Cant. {quantity} · {date} · Reglas {version}",
  "calc.form.sku": "SKU (opcional)",
  "calc.form.skuPlaceholder": "Ej.: CAFE-500G",
  "calc.form.cest": "CEST (opcional)",
  "calc.form.cestPlaceholder": "Ej.: 17.001.00",
  "calc.form.cestHint": "Solo si el producto tiene CEST asignado; no suponga el código.",
  "calc.form.cestRemoved": "CEST eliminado: {cest} no corresponde al NCM {ncm}",
  "calc.form.missing": "Falta completar: {fields}.",
  "calc.form.ready": "Listo para calcular.",
  "calc.form.calculate": "Calcular",
  "calc.form.calculating": "Calculando…",
  "calc.result.cost": "Costo",
  "calc.result.empty":
    "Complete NCM, ruta y costo y haga clic en Calcular. El resultado aparece aquí, impuesto por impuesto.",
  "calc.result.taxes": "{value} en tributos",
  "calc.result.mva": "MVA {value}",
  "calc.result.icmsNote":
    "Con sustitución tributaria, este valor es el ICMS-ST. Sin ST, es el ICMS propio de la compra, sumado al costo sin crédito.",
  "calc.fecp.omitted": "FECP del destino no informado en la regla; ST calculada sin FECP",
  "calc.recent.title": "Últimos cálculos",
  "calc.recent.all": "Ver todos los lotes",
  "calc.recent.error": "No se pudieron cargar los últimos cálculos.",
  "calc.recent.empty": "Ningún cálculo en los últimos 30 días.",
  "calc.recent.items.one": "{count} ítem",
  "calc.recent.items.other": "{count} ítems",
  "calc.recent.missing": "Qué falta",
  "calc.recent.missingIssue": "{issue} · {count}",
  "calc.recent.seeItems": "Ver ítems",
  "calc.recent.next.queued": "Esperando su turno en la cola",
  "calc.recent.next.running": "{done} de {total} ítems calculados",
  "calc.recent.next.failed": "El cálculo se detuvo; ábralo para ver el motivo.",
  "calc.error.details": "Detalles técnicos",
  "calc.error.generic.title": "No se pudo calcular",
  "calc.error.generic.body":
    "Inténtelo de nuevo. Si persiste, envíe los detalles técnicos a soporte.",
  "calc.error.lot.title": "El lote se detuvo antes de terminar",
  "calc.error.lot.body":
    "El motivo está en Detalles técnicos. Corrija la planilla y envíe el lote de nuevo; si no sabe qué corregir, envíe el código a soporte.",
  "calc.error.lot.retryableBody":
    "Fue una falla temporal. Use Reprocesar para intentarlo de nuevo; si vuelve a fallar, envíe el código a soporte.",
  "calc.error.OPERATION_NOT_AVAILABLE.title": "Cálculo no disponible en este entorno",
  "calc.error.OPERATION_NOT_AVAILABLE.body":
    "Este entorno no ejecuta el motor fiscal (por ejemplo, el modo de demostración). Calcule en el entorno en vivo.",
  "calc.error.DEPENDENCY_UNAVAILABLE.title": "El motor de cálculo no respondió",
  "calc.error.DEPENDENCY_UNAVAILABLE.body":
    "No se guardó nada. Inténtelo de nuevo en unos instantes.",
  "calc.error.NO_PUBLISHED_RULESET.title": "No hay reglas publicadas para calcular",
  "calc.error.NO_PUBLISHED_RULESET.body":
    "Selecciona otra versión publicada. Si no hay una versión aplicable, pide al responsable fiscal que compruebe la cobertura del NCM, la ruta y la fecha de la operación.",
  "calc.error.VALIDATION_FAILED.title": "Algunos datos no fueron aceptados",
  "calc.error.VALIDATION_FAILED.body": "Revise NCM, UF, costo y fecha e inténtelo de nuevo.",
  "calc.error.BATCH_TOO_LARGE.title": "Lote por encima del límite",
  "calc.error.BATCH_TOO_LARGE.body":
    "Divida la planilla en archivos más pequeños y envíela de nuevo.",
  "calc.error.RATE_LIMITED.title": "Demasiados cálculos seguidos",
  "calc.error.RATE_LIMITED.body": "Espere unos segundos e inténtelo de nuevo.",
  "calc.error.PERMISSION_DENIED.title": "Sin permiso para calcular",
  "calc.error.PERMISSION_DENIED.body": "Pida a un administrador el permiso para ejecutar cálculos.",
  "calc.error.NETWORK.title": "Sin conexión con la API fiscal",
  "calc.error.NETWORK.body": "Revise su conexión e inténtelo de nuevo.",
  "calc.rate.ipiRate": "Alícuota de IPI",
  "calc.rate.interstateIcmsRate": "Alícuota interestatal de ICMS",
  "calc.rate.destinationInternalIcmsRate": "Alícuota interna de ICMS en el destino",
  "calc.rate.originalMva": "MVA original",
  "calc.rate.adjustedMva": "MVA ajustada",
  "mva.adjust.title": "Ajuste de la MVA (ICMS-ST)",
  "mva.adjust.alqInter": "ALQ interestadual",
  "mva.adjust.alqIntra": "ALQ intra efectiva",
  "mva.adjust.original": "MVA original",
  "mva.adjust.adjusted": "MVA ajustada",
  "mva.adjust.applied": "Ajuste aplicado",
  "mva.adjust.yes": "Sí",
  "mva.adjust.no": "No",
  "mva.adjust.reason.ADJUSTED": "ALQ intra por encima de la interestadual: la MVA fue ajustada.",
  "mva.adjust.reason.NOT_INTERSTATE": "Operación interna: vale la MVA original.",
  "mva.adjust.reason.INTRA_NOT_GREATER_THAN_INTER":
    "ALQ intra no supera la interestadual: vale la MVA original, sin ajuste.",
  "mva.adjust.source.RULE": "Carga efectiva de la regla: {legal}",
  "mva.adjust.source.NOMINAL_NOT_INFORMED":
    "carga efectiva no informada — usando alícuota interna nominal",
  "mva.adjust.source.NOMINAL_OUT_OF_VALIDITY":
    "carga efectiva fuera de vigencia — usando alícuota interna nominal",
  "mva.adjust.debit": "El débito de la ST usa la alícuota interna nominal ({rate}).",
  "calc.rate.takeRate": "Tasa de intermediación",
  "calc.engine.name": "Motor",
  "calc.engine.version": "Versión del motor",
  "calc.engine.policy": "Política de cálculo",
  "calc.engine.rounding": "Redondeo",
  "calc.engine.scale": "Decimales",
  "lotSim.exportCsv": "Exportar CSV",
  "lotSim.results": "Resultados por ítem",
  "lotSim.resultsHint": "{count} filas · {date} · {version}",

  "app.name": "Operaciones Fiscales",
  "app.org": "BackChannel",

  "nav.areas": "Áreas",
  "nav.overview": "Resumen",
  "nav.evidence": "Evidencias",
  "nav.proposals": "Propuestas",
  "nav.rulesets": "Conjuntos",
  "nav.rules": "Reglas",
  "nav.calculator": "Calculadora",
  "nav.calculations": "Cálculos",
  "nav.sources": "Fuentes",
  "nav.audit": "Auditoría",
  "nav.settings": "Perfil",
  "nav.admin.module": "Administración",
  "nav.users": "Usuarios",
  "nav.legal": "Datos de la empresa",
  "nav.agents": "Agentes",
  "nav.demos": "Demos",
  "nav.agentFindings": "Registros del agente",
  "agents.retention": "Los registros de ejecución están disponibles durante 30 días.",
  "agents.retentionFindings": "Los hallazgos quedan para siempre en Registros del agente.",
  "agentFindings.title": "Registros del agente",
  "agentFindings.description":
    "Todo lo que extrajo el agente de navegador, día a día (hora de Brasilia): totales por resultado y por ruta, filtros y exportación. Los hallazgos son material de revisión y se guardan de forma permanente.",
  "agentFindings.day.previous": "Día anterior",
  "agentFindings.day.next": "Día siguiente",
  "agentFindings.day.pick": "Elegir el día",
  "agentFindings.day.today": "Hoy",
  "agentFindings.day.total.one": "{count} hallazgo",
  "agentFindings.day.total.other": "{count} hallazgos",
  "agentFindings.byOutcome": "Por resultado",
  "agentFindings.byRoute": "Por ruta",
  "agentFindings.heat.title": "Hallazgos en los últimos {days} días",
  "agentFindings.heat.window": "Período del gráfico",
  "agentFindings.heat.days": "{days} días",
  "agentFindings.heat.less": "Menos",
  "agentFindings.heat.more": "Más",
  "agentFindings.heat.error": "No se pudieron cargar los totales diarios.",
  "agentFindings.table.title": "Hallazgos del día",
  "agentFindings.retention":
    "Los hallazgos se guardan de forma permanente. Las capturas y los registros de ejecución están disponibles durante 30 días (salvo los guardados como demo).",
  "agentFindings.export.dayCsv": "Exportar día (CSV)",
  "agentFindings.export.dayJson": "Exportar día (JSON)",
  "agentFindings.export.range": "Exportar período…",
  "agentFindings.export.rangeTitle": "Exportar período",
  "agentFindings.export.rangeBody":
    "Descarga los hallazgos entre las fechas elegidas (días de Brasilia, inclusive), hasta un año.",
  "agentFindings.export.from": "Desde",
  "agentFindings.export.to": "Hasta",
  "agentFindings.export.format": "Formato",
  "agentFindings.export.filtersApply":
    "Los filtros actuales (resultado, ruta, NCM) también se aplican a la exportación.",
  "agentFindings.export.invalid": "Elija un período válido de hasta 366 días, sin fechas futuras.",
  "agentFindings.export.go": "Descargar",
  "agentFindings.export.busy": "Preparando…",
  "agentFindings.export.done": "{count} hallazgos exportados.",
  "agentFindings.export.truncated":
    "{count} hallazgos exportados; se alcanzó el límite de 20.000. Reduzca el período.",
  "agentFindings.export.error": "No se pudo exportar. Inténtelo de nuevo.",
  "agentFindings.filter.ncm": "NCM o descripción",
  "agentFindings.filter.ncmPlaceholder": "Ej.: 8516 o secadores",
  "agentFindings.filter.outcome": "Resultado",
  "agentFindings.filter.route": "Ruta",
  "agentFindings.filter.all": "Todos",
  "agentFindings.filter.clear": "Limpiar filtros",
  "agentFindings.filteredCount": "Mostrando {shown} de {total} hallazgos del día.",
  "agentFindings.empty.day": "Ningún hallazgo en este día",
  "agentFindings.empty.dayBody":
    "El agente no registró consultas en esta fecha. Use el gráfico para ir a un día con actividad.",
  "agentFindings.empty.filtered": "Ningún hallazgo con estos filtros",
  "agentFindings.col.time": "Hora",
  "agentFindings.col.ncm": "NCM",
  "agentFindings.col.route": "Ruta",
  "agentFindings.col.outcome": "Resultado",
  "agentFindings.col.mva": "MVA original",
  "agentFindings.col.cest": "CEST",
  "agentFindings.col.validity": "Vigencia",
  "agentFindings.col.basis": "Base legal",
  "agentFindings.col.source": "Origen",
  "agentFindings.col.run": "Ejecución",
  "agentFindings.col.frame": "Captura",
  "agentFindings.source.task": "Tarea de la cola",
  "agentFindings.source.lookupJob": "Consulta del sistema",
  "agentFindings.source.gap": "Brecha de cobertura",
  "agentFindings.openRun": "Ver ejecución",
  "agentFindings.openFrame": "Abrir la captura del NCM {ncm}",
  "agents.schedule.recordRuns": "Grabar la pantalla de las ejecuciones",
  "agents.schedule.recordRunsHint":
    "La grabación empieza después del inicio de sesión (nunca muestra el formulario de acceso) y alimenta la sección Demos. Los archivos de las ejecuciones se borran a los 30 días; los guardados como demo se conservan.",
  "agents.live.recording": "Grabando",
  "agents.live.recordingHint":
    "La pantalla de esta ejecución se está grabando desde el final del inicio de sesión.",
  "agents.runs.current": "Ejecución iniciada el {time}.",
  "agents.runs.col.demo": "Demo",
  "demos.title": "Demos",
  "demos.description":
    "Ejecuciones del agente grabadas y guardadas para presentar cómo funciona el proceso: el video de la pantalla, los pasos narrados en sincronía y lo que se encontró.",
  "demos.listLabel": "Demos guardadas",
  "demos.empty.title": "Aún no hay demos",
  "demos.empty.body":
    "En Administración → Agentes, abra una ejecución grabada y use “Guardar como demo”.",
  "demos.empty.action": "Ir a Agentes",
  "demos.card.routes.one": "{count} ruta",
  "demos.card.routes.other": "{count} rutas",
  "demos.card.ncms.one": "{count} NCM",
  "demos.card.ncms.other": "{count} NCM",
  "demos.card.findings.one": "{count} hallazgo",
  "demos.card.findings.other": "{count} hallazgos",
  "demos.notFound.title": "Demo no encontrada",
  "demos.notFound.body": "Puede haber sido eliminada. La ejecución original sigue en Agentes.",
  "demos.back": "Todas las demos",
  "demos.detail.savedOn": "Guardada el {time}",
  "demos.detail.openRun": "Ver ejecución en Agentes",
  "demos.delete.action": "Eliminar demo",
  "demos.delete.title": "¿Eliminar esta demo?",
  "demos.delete.body":
    "“{title}” sale de la sección Demos. La ejecución, sus pasos, hallazgos y grabaciones siguen en Agentes. La acción queda registrada en la auditoría.",
  "demos.delete.confirm": "Eliminar demo",
  "demos.delete.error": "No se pudo eliminar la demo. Inténtelo de nuevo.",
  "demos.summary.title": "Resumen de la ejecución",
  "demos.summary.duration": "Video",
  "demos.summary.lookups": "Consultas",
  "demos.summary.findings": "Hallazgos",
  "demos.summary.routes": "Rutas",
  "demos.summary.run": "Ejecución",
  "demos.summary.boundary":
    "Demostración del proceso. Los hallazgos son material de revisión: no crean, aprueban ni publican reglas.",
  "demos.timeline.title": "Pasos narrados",
  "demos.timeline.hint": "Haga clic en un paso para ir a ese momento del video.",
  "demos.timeline.empty": "Esta ejecución no tiene pasos.",
  "demos.timeline.seek": "Ir a {time}",
  "demos.timeline.offCamera": "fuera de la grabación",
  "demos.findings.moment": "En el video",
  "demos.findings.seek": "Ir a este hallazgo en el video",
  "demos.player.noRecording": "Esta demo no tiene grabación.",
  "demos.player.unavailable":
    "El video no está disponible ahora. Los pasos y hallazgos siguen abajo.",
  "demos.player.leave": "Salir del modo presentación",
  "demos.player.leaveShort": "Salir",
  "demos.player.segment": "Parte {part} de {count}",
  "demos.player.single": "Grabación de pantalla",
  "demos.player.present": "Modo presentación",
  "demos.save.action": "Guardar como demo",
  "demos.save.open": "Ver demo",
  "demos.save.reasonRunning": "Disponible cuando termine la ejecución.",
  "demos.save.reasonNoRecording": "Esta ejecución no tiene grabación.",
  "demos.save.defaultTitle": "Agente IOB · {time}",
  "demos.save.title": "Guardar como demo",
  "demos.save.body":
    "La grabación, los pasos y los hallazgos de esta ejecución quedan disponibles en Administración → Demos.",
  "demos.save.titleLabel": "Título",
  "demos.save.titleHint": "Sugerido a partir de la tarea de la cola. Hasta 120 caracteres.",
  "demos.save.titleRequired": "Indique un título.",
  "demos.save.descriptionLabel": "Descripción",
  "demos.save.optional": "(opcional)",
  "demos.save.retention":
    "El video y los cuadros se copian al área de demos y dejan de seguir el borrado de 30 días de las ejecuciones.",
  "demos.save.confirm": "Guardar demo",
  "demos.save.saving": "Guardando…",
  "demos.save.errorConflict": "Esta ejecución ya se guardó como demo o aún no terminó.",
  "demos.save.errorStorage":
    "No se pudo preservar la grabación ahora. Inténtelo de nuevo en unos instantes.",
  "demos.save.error": "No se pudo guardar la demo. Inténtelo de nuevo.",
  "agents.title": "Agente IOB",
  "agents.description":
    "Siga al agente que consulta el IOB Simulador Tributário, organice la cola y la agenda y revise lo que encontró.",
  "agents.statusLabel": "Estado del agente",
  "agents.tabs": "Secciones del agente",
  "agents.tab.live": "En vivo",
  "agents.tab.queue": "Cola",
  "agents.tab.schedule": "Agenda",
  "agents.tab.history": "Historial",
  "agents.tab.settings": "Configuración",
  "agents.state.running": "Ejecución en curso",
  "agents.state.recording": "Grabando la pantalla de esta ejecución",
  "agents.state.stopping": "Deteniendo",
  "agents.state.stoppingDetail": "Detención solicitada; la consulta actual termina antes",
  "agents.state.noSignal": "Sin señal",
  "agents.state.pausedDetail": "Ninguna consulta nueva empieza hasta reanudarlo",
  "agents.state.outsideWindow": "Fuera del horario",
  "agents.state.noCredentialsDetail": "Registre el acceso a IOB en Configuración",
  "agents.state.stoppedDetail": "La última ejecución falló; vea el Historial",
  "agents.findings.open": "{count} hallazgos: ver en el Historial",
  "agents.findings.runTitle": "Hallazgos de la ejecución del {time}",
  "agents.findings.openLive": "Ver pantalla y pasos",
  "agents.status.RUNNING": "En ejecución",
  "agents.status.WAITING_WINDOW": "En espera fuera del horario",
  "agents.status.STOPPED": "Detenido con error",
  "agents.status.IDLE": "Esperando trabajo",
  "agents.status.NO_CREDENTIALS": "Sin credenciales IOB",
  "agents.source": "Fuente",
  "agents.source.IOB_SIMULADOR": "IOB Simulador Tributário",
  "agents.currentLookup": "Consulta actual",
  "agents.noLookup": "Ninguna consulta en curso",
  "agents.lookupsDone": "Consultas hechas",
  "agents.findings": "Hallazgos",
  "agents.errors": "Errores",
  "agents.heartbeat": "Última señal",
  "agents.lastPoll": "Última consulta",
  "agents.heartbeatAgo": "hace {age}",
  "agents.heartbeatStale": "Sin señal hace {age}",
  "agents.stop": "Detener ejecución",
  "agents.stopping": "Detención solicitada",
  "agents.stop.title": "¿Detener la ejecución del agente?",
  "agents.stop.body":
    "El agente termina el paso actual de forma segura y cierra la sesión. Solo vuelve a ejecutarse en el próximo horario de la agenda semanal.",
  "agents.stop.confirm": "Detener ejecución",
  "agents.stop.error": "No se pudo solicitar la detención. Inténtelo de nuevo.",
  "agents.lastError": "Último error",
  "agents.live.title": "Pantalla del agente",
  "agents.live.meta.idle": "Ninguna ejecución en curso",
  "agents.live.note.disconnectedIdle": "Visor sin transmisión; nuevo intento en {time}.",
  "agents.live.note.disconnectedIdleNow": "Visor sin transmisión; reconectando…",
  "agents.live.note.unconfiguredIdle": "Este entorno no transmite la pantalla del agente.",
  "agents.live.viewer.label": "Visor:",
  "agents.live.viewer.live": "en vivo",
  "agents.live.viewer.connecting": "conectando…",
  "agents.live.viewer.disconnected": "desconectado",
  "agents.live.viewer.unconfigured": "transmisión no configurada",
  "agents.live.viewer.historical": "captura histórica",
  "agents.live.meta.streaming": "Transmisión en vivo del navegador del agente",
  "agents.live.meta.frame": "Cuadro de las {time} · hace {age}",
  "agents.live.meta.noFrame": "Sin cuadro registrado",
  "agents.live.note.historical":
    "Ejecución del {time}: es el registro de esa ejecución, no la pantalla actual.",
  "agents.live.note.historicalPlain": "Registro de una ejecución anterior, no la pantalla actual.",
  "agents.live.note.disconnectedWorking":
    "El agente sigue trabajando; solo se cayó el visor. Nuevo intento en {time}.",
  "agents.live.note.disconnectedWorkingNow":
    "El agente sigue trabajando; solo se cayó el visor. Reconectando…",
  "agents.live.note.connectingWorking": "El agente está trabajando; abriendo la transmisión.",
  "agents.live.note.unconfiguredWorking":
    "El agente está trabajando. Este entorno no transmite la pantalla; los cuadros registrados siguen abajo.",
  "agents.live.art.waiting": "Agente en espera",
  "agents.live.art.blocked": "Agente bloqueado",
  "agents.live.art.noFrame": "El visor aún no recibió ningún cuadro",
  "agents.live.stage.label": "Etapa de la consulta actual",
  "agents.live.stage.query": "Consulta",
  "agents.live.stage.capture": "Captura",
  "agents.live.stage.finding": "Hallazgo",
  "agents.live.stage.state.done": "completada",
  "agents.live.stage.state.current": "en curso",
  "agents.live.stage.state.recovering": "recuperándose de un error",
  "agents.live.stage.state.todo": "pendiente",
  "agents.live.stage.at": "Último evento {time}",
  "agents.live.viewOnly": "Solo visualización",
  "agents.live.reconnect": "Reconectar ahora",
  "agents.live.canvasLabel": "Pantalla en vivo del navegador del agente, solo visualización",
  "agents.live.noFrame": "Aún no hay cuadros registrados.",
  "agents.steps.title": "Pasos",
  "agents.steps.hint": "Más recientes primero",
  "agents.steps.polling": "En vivo · se actualiza cada 2,5 s",
  "agents.steps.empty": "No hay pasos registrados en esta ejecución.",
  "agents.steps.openFrame": "Ampliar el cuadro del paso {sequence}",
  "agents.steps.group.session": "Sesión y navegación",
  "agents.steps.group.inProgress": "En curso",
  "agents.steps.group.count.one": "{count} paso",
  "agents.steps.group.count.other": "{count} pasos",
  "agents.steps.recovery.one": "Recuperación asistida · {count} acción",
  "agents.steps.recovery.other": "Recuperación asistida · {count} acciones",
  "agents.live.overlay.IDLE": "Agente esperando trabajo · próxima verificación en hasta 5 min",
  "agents.live.overlay.STOPPED": "La última ejecución falló · próxima verificación en hasta 5 min",
  "agents.live.overlay.WAITING_WINDOW": "Fuera del horario de la agenda · {detail}",
  "agents.live.overlay.PAUSED": "Agente en pausa · ninguna consulta nueva empieza hasta reanudarlo",
  "agents.live.overlay.NO_CREDENTIALS":
    "Faltan credenciales de IOB · el agente no puede entrar al simulador",
  "agents.kind.SESSION": "Sesión",
  "agents.kind.NAVIGATE": "Navegación",
  "agents.kind.INPUT": "Llenado",
  "agents.kind.CLICK": "Clic",
  "agents.kind.WAIT": "Espera",
  "agents.kind.READ": "Lectura",
  "agents.kind.EXTRACT": "Extracción",
  "agents.kind.RECOVER": "Recuperación",
  "agents.kind.PAUSE": "Pausa",
  "agents.kind.ERROR": "Error",
  "agents.frame.title": "Cuadro · {time}",
  "agents.frame.alt": "Cuadro capturado por el agente a las {time}",
  "agents.frame.error": "No se pudo cargar el cuadro.",
  "agents.frame.loading": "Cargando cuadro…",
  "agents.findings.title": "Hallazgos de la ejecución",
  "agents.findings.boundary":
    "Los hallazgos son material de revisión: registran lo que mostró la página del simulador. No crean, aprueban ni publican reglas; una regla solo cambia con el acto oficial, por propuesta → revisión → publicación.",
  "agents.findings.filter": "Filtrar por resultado",
  "agents.findings.all": "Todos",
  "agents.findings.compare": "Comparar con reglas publicadas",
  "agents.findings.compareShort": "Comparar reglas",
  "agents.findings.viewFrame": "Ver cuadro",
  "agents.findings.empty": "No hay hallazgos en esta ejecución.",
  "agents.findings.emptyFiltered": "No hay hallazgos con este resultado.",
  "agents.outcome.ST_FOUND": "ST encontrada",
  "agents.outcome.NO_ST_FOUND": "Sin ST",
  "agents.outcome.INTERNAL_ST_ONLY": "Solo ST interna",
  "agents.outcome.NCM_NOT_FOUND": "NCM no encontrado",
  "agents.outcome.UNREADABLE": "Ilegible",
  "agents.outcome.INCONCLUSIVE": "No concluyente",
  "agents.col.ncm": "NCM",
  "agents.col.route": "Ruta",
  "agents.col.outcome": "Resultado",
  "agents.col.mva": "MVA original",
  "agents.col.cest": "CEST",
  "agents.col.validity": "Vigencia",
  "agents.col.basis": "Fundamento",
  "agents.col.captured": "Capturado",
  "agents.col.actions": "Acciones",
  "agents.validity.range": "{from} a {to}",
  "agents.validity.from": "desde {from}",
  "agents.runs.title": "Historial de ejecuciones",
  "agents.runs.viewing": "Viendo la ejecución iniciada el {time}.",
  "agents.runs.backToLatest": "Volver a la ejecución actual",
  "agents.runs.select": "Ver la ejecución del {time}",
  "agents.runs.col.started": "Inicio",
  "agents.runs.col.status": "Estado",
  "agents.runs.col.duration": "Duración",
  "agents.runs.col.lookups": "Consultas",
  "agents.runs.col.findings": "Hallazgos",
  "agents.runs.col.errors": "Errores",
  "agents.runs.trigger.SCHEDULE": "Programada",
  "agents.runs.trigger.MANUAL": "Manual",
  "agents.run.status.RUNNING": "En ejecución",
  "agents.run.status.SUCCEEDED": "Completada",
  "agents.run.status.FAILED": "Falló",
  "agents.run.status.STOPPED": "Detenida",
  "agents.noRuns.title": "Aún no hay ejecuciones",
  "agents.noRuns.body":
    "Cuando el agente inicie dentro del horario de la agenda semanal, la pantalla, los pasos y los hallazgos aparecen aquí.",
  "agents.status.PAUSED": "Pausado",
  "agents.workingOn": "Trabajando en",
  "agents.workingOnPosition": "{position}.ª de {count} en la cola",
  "agents.workingOnWaiting": "Ninguna en curso · {count} esperando en la cola",
  "agents.workingOnNone": "Ninguna tarea en la cola",
  "agents.workingOnGaps": "Cola vacía · brechas de cobertura",
  "agents.schedule.weekly": "Agenda semanal",
  "agents.schedule.block.mondayToThursday": "Lunes a jueves",
  "agents.schedule.block.friday": "Viernes",
  "agents.schedule.block.weekend": "Sábado y domingo",
  "agents.schedule.off": "Apagado",
  "agents.schedule.perDayHours": "{hours} por día",
  "agents.schedule.allDay": "24 horas",
  "agents.schedule.allDayNote": "Día completo · 00:00–24:00",
  "agents.schedule.from": "Inicio",
  "agents.schedule.to": "Fin",
  "agents.schedule.nextDay": "termina a las {time} del día siguiente",
  "agents.schedule.issue.CLOCK_INVALID": "Use el formato 24 h HH:MM, de 00:00 a 23:59.",
  "agents.schedule.fullDayNextDay": "24 h, termina a las {time} del día siguiente",
  "agents.schedule.week": "Semana · horario de Brasilia",
  "agents.schedule.dayAria": "{day}: {ranges}",
  "agents.schedule.dayAriaOff": "{day}: sin horario",
  "agents.schedule.legendOn": "Horario activo",
  "agents.schedule.legendNow": "Ahora",
  "agents.schedule.noActive":
    "Ningún horario activo: el agente no hará consultas hasta que se encienda un bloque.",
  "agents.schedule.weeklyHours": "Horas por semana",
  "agents.schedule.weeklyHoursMeta": "{percent} de la semana",
  "agents.schedule.perWeek": "Por semana",
  "agents.schedule.perWeekValue": "{count} consultas",
  "agents.schedule.perWeekMeta": "al ritmo efectivo, dentro de la agenda",
  "agents.scheduleNow": "Agenda",
  "agents.scheduleNow.active": "Dentro del horario",
  "agents.scheduleNow.idle": "Fuera del horario",
  "agents.scheduleNow.none": "Sin horario activo",
  "agents.scheduleNow.until": "hasta {time}",
  "agents.scheduleNow.resumes": "retoma {time}",
  "agents.scheduleNow.always": "24 h, 7 días",
  "agents.queueEta": "Cola restante",
  "agents.queueEtaEmpty": "Sin elementos en la cola",
  "agents.schedule.day.0": "Lun",
  "agents.schedule.dayLong.0": "Lunes",
  "agents.schedule.day.1": "Mar",
  "agents.schedule.dayLong.1": "Martes",
  "agents.schedule.day.2": "Mié",
  "agents.schedule.dayLong.2": "Miércoles",
  "agents.schedule.day.3": "Jue",
  "agents.schedule.dayLong.3": "Jueves",
  "agents.schedule.day.4": "Vie",
  "agents.schedule.dayLong.4": "Viernes",
  "agents.schedule.day.5": "Sáb",
  "agents.schedule.dayLong.5": "Sábado",
  "agents.schedule.day.6": "Dom",
  "agents.schedule.dayLong.6": "Domingo",
  "agents.schedule.title": "Horario y ritmo",
  "agents.schedule.hint": "Agenda semanal en horario de Brasilia (America/Sao_Paulo), formato 24 h",
  "agents.schedule.pause": "Pausa entre consultas (s)",
  "agents.schedule.pauseHint": "Entre {min} y {max} segundos",
  "agents.schedule.maxPerHour": "Máx. de consultas por hora",
  "agents.schedule.maxPerHourHint": "Hasta {max} por hora",
  "agents.schedule.fallback": "Usar brechas cuando la cola esté vacía",
  "agents.schedule.fallbackHint":
    "Sin tareas en la cola, el agente consulta las brechas de cobertura más frecuentes.",
  "agents.schedule.killSwitch": "Pausar el agente",
  "agents.schedule.killSwitchOn":
    "El agente está pausado. Ninguna consulta nueva en IOB hasta reanudar; la VM sigue encendida.",
  "agents.schedule.killSwitchOff":
    "Deja de consultar IOB en la próxima verificación del agente (hasta 5 min), sin apagar la VM.",
  "agents.schedule.pauseConfirm.title": "¿Pausar el agente?",
  "agents.schedule.pauseConfirm.body":
    "El agente termina la consulta actual y no inicia ninguna otra en IOB hasta que alguien lo reanude. La cola y el progreso de las tareas se mantienen.",
  "agents.schedule.pauseConfirm.confirm": "Pausar agente",
  "agents.schedule.effective": "Ritmo efectivo",
  "agents.schedule.effectiveValue": "{count} consultas/h",
  "agents.schedule.limitedByCap": "limitado por el máximo por hora",
  "agents.schedule.limitedByPause": "limitado por la pausa",
  "agents.schedule.issue.PAUSE_RANGE": "La pausa debe ser un entero entre {min} y {max} segundos.",
  "agents.schedule.issue.RATE_RANGE": "El máximo por hora debe ser un entero entre 1 y {max}.",
  "agents.schedule.updated": "Actualizado por {who} el {time}",
  "agents.schedule.neverUpdated": "Valores predeterminados, nunca modificados",
  "agents.schedule.save": "Guardar horario y ritmo",
  "agents.schedule.discard": "Descartar",
  "agents.schedule.saved":
    "Horario y ritmo guardados. El agente los aplica en la próxima consulta.",
  "agents.schedule.conflict":
    "Otra persona modificó esta configuración. Cargamos los valores actuales; revise y guarde de nuevo.",
  "agents.schedule.error": "No se pudo guardar. Inténtelo de nuevo.",
  "agents.schedule.dirty": "Cambios sin guardar",
  "agents.who.you": "usted",
  "agents.credentials.title": "Credenciales IOB",
  "agents.credentials.configured": "Configuradas",
  "agents.credentials.notConfigured": "No configuradas",
  "agents.credentials.notConfiguredBody":
    "Sin credenciales el agente no puede entrar en IOB Simulador.",
  "agents.credentials.account": "Cuenta",
  "agents.credentials.updated": "Actualizadas por {who} el {time}",
  "agents.credentials.explain":
    "Se guardan directamente en el almacén de credenciales de la plataforma. No quedan en la base de datos, en los logs ni en este navegador, y nadie puede leerlas de vuelta desde aquí. El agente usa las nuevas credenciales en su próxima sesión.",
  "agents.credentials.username": "Usuario de IOB",
  "agents.credentials.password": "Contraseña de IOB",
  "agents.credentials.save": "Guardar credenciales",
  "agents.credentials.replace": "Reemplazar credenciales",
  "agents.credentials.saving": "Guardando…",
  "agents.credentials.saved":
    "Credenciales guardadas de forma segura. El agente las usa en su próxima sesión.",
  "agents.credentials.error":
    "No se pudieron guardar las credenciales. No se modificó nada; inténtelo de nuevo.",
  "agents.credentials.unavailableTitle": "Almacén de credenciales no configurado",
  "agents.credentials.unavailableBody":
    "Este entorno aún no tiene el almacén de las credenciales IOB. Cuando la infraestructura esté lista, podrán registrarse aquí.",
  "agents.queue.title": "Cola de tareas",
  "agents.queue.description":
    "El agente trabaja la cola de arriba abajo, una consulta a la vez, al ritmo y con la agenda semanal configurados.",
  "agents.queue.pace":
    "{perHour} consultas/h · {perWeek} por semana · {hours} de agenda por semana",
  "agents.queue.new": "Nueva tarea",
  "agents.queue.empty.title": "La cola está vacía",
  "agents.queue.empty.body":
    "Cree una tarea para que el agente consulte el catálogo, los NCM que usamos o una lista.",
  "agents.queue.emptyGaps":
    "Mientras la cola esté vacía, el agente trabaja en las brechas de cobertura.",
  "agents.queue.finished": "Concluidas",
  "agents.queue.workingNow": "Trabajando ahora",
  "agents.queue.position": "Posición {position}",
  "agents.queue.progress": "{processed} de {items}",
  "agents.queue.count.done": "{count} consultadas",
  "agents.queue.count.cached": "{count} ya cubiertas",
  "agents.queue.count.failed": "{count} con fallo",
  "agents.queue.count.pending": "{count} pendientes",
  "agents.queue.count.skipped": "{count} omitidas",
  "agents.queue.eta": "Estimación",
  "agents.queue.eta.minutes": "≈ {count} min de agenda",
  "agents.queue.eta.hours": "≈ {count} h de agenda",
  "agents.queue.eta.until": "fin ≈ {time} (Brasilia)",
  "agents.queue.eta.done": "Sin elementos pendientes",
  "agents.queue.eta.paused": "En pausa · sin estimación",
  "agents.queue.eta.agentPaused": "Agente pausado · sin estimación",
  "agents.queue.eta.none": "Sin estimación: revise horario y ritmo",
  "agents.queue.eta.completed": "Concluida el {time}",
  "agents.queue.eta.cancelled": "Cancelada el {time}",
  "agents.queue.created": "Creada el {time}",
  "agents.queue.actions": "Acciones de la tarea {name}",
  "agents.queue.action.MOVE_UP": "Subir",
  "agents.queue.action.MOVE_DOWN": "Bajar",
  "agents.queue.action.MOVE_TO_FRONT": "Mover al inicio",
  "agents.queue.action.PAUSE": "Pausar",
  "agents.queue.action.RESUME": "Reanudar",
  "agents.queue.action.CANCEL": "Cancelar tarea",
  "agents.queue.details": "Detalles",
  "agents.queue.actionError": "No se pudo actualizar la tarea. Inténtelo de nuevo.",
  "agents.queue.cancel.title": "¿Cancelar la tarea «{name}»?",
  "agents.queue.cancel.body":
    "Los {count} elementos pendientes se omitirán. Lo ya consultado sigue registrado como hallazgo. No se puede deshacer.",
  "agents.queue.cancel.confirm": "Cancelar tarea",
  "agents.queue.cancel.keep": "Mantener en la cola",
  "agents.task.status.QUEUED": "En cola",
  "agents.task.status.RUNNING": "En curso",
  "agents.task.status.PAUSED": "Pausada",
  "agents.task.status.COMPLETED": "Concluida",
  "agents.task.status.CANCELLED": "Cancelada",
  "agents.task.scope.CATALOG": "Catálogo NCM completo",
  "agents.task.scope.CATALOG_CHAPTERS": "Catálogo NCM · capítulos {chapters}",
  "agents.task.scope.SEEN": "NCM usados en nuestros cálculos (12 meses)",
  "agents.task.scope.LIST": "Lista de {count} NCM",
  "agents.task.scope.LOOKUP_JOB": "Consulta del sistema",
  "agents.task.scope.SWEEP": "Investigación web",
  "agents.task.item.PENDING": "Pendiente",
  "agents.task.item.IN_PROGRESS": "Consultando",
  "agents.task.item.DONE": "Consultado",
  "agents.task.item.CACHED": "Ya cubierto",
  "agents.task.item.FAILED": "Falló",
  "agents.task.item.SKIPPED": "Omitido",
  "agents.task.detail.route": "Ruta",
  "agents.task.detail.scope": "Alcance",
  "agents.task.detail.started": "Inicio",
  "agents.task.detail.items": "Elementos",
  "agents.task.detail.filter": "Filtrar elementos por estado",
  "agents.task.detail.all": "Todos",
  "agents.task.detail.col.ncm": "NCM",
  "agents.task.detail.col.status": "Estado",
  "agents.task.detail.col.outcome": "Resultado",
  "agents.task.detail.col.attempts": "Intentos",
  "agents.task.detail.col.updated": "Actualizado",
  "agents.task.detail.empty": "Ningún elemento con este estado.",
  "agents.task.detail.showing": "{shown} de {total}",
  "agents.task.detail.notFound": "Tarea no encontrada.",
  "agents.create.title": "Nueva tarea",
  "agents.create.name": "Nombre",
  "agents.create.nameHint": "Si queda vacío, usamos «{name}».",
  "agents.create.scope": "Qué consultar",
  "agents.create.scope.CATALOG.body":
    "Todos los NCM activos del catálogo oficial, o solo los capítulos elegidos.",
  "agents.create.scope.SEEN.body":
    "NCM que aparecieron en nuestros cálculos en los últimos 365 días.",
  "agents.create.scope.LIST": "Lista de NCM",
  "agents.create.scope.LIST.body": "Pegue los códigos: uno por línea o separados por coma.",
  "agents.create.chapters": "Capítulos (opcional)",
  "agents.create.chaptersAll": "Ningún capítulo elegido: el catálogo completo.",
  "agents.create.chaptersSome.one": "{count} capítulo elegido",
  "agents.create.chaptersSome.other": "{count} capítulos elegidos",
  "agents.create.chaptersClear": "Limpiar",
  "agents.create.chapter": "Capítulo {chapter}",
  "agents.create.list": "NCM",
  "agents.create.listPlaceholder": "8516.31.00\n85094050\n2203.00.00, 3304.99.90",
  "agents.create.listCount": "Válidos: {count}",
  "agents.create.listDuplicates": "Repetidos ignorados: {count}",
  "agents.create.listInvalid": "Inválidos: {count}",
  "agents.create.listInvalidLine": "Línea {line}: «{value}»",
  "agents.create.listMore": "y {count} más",
  "agents.create.listTooMany": "Máximo de {max} NCM por tarea.",
  "agents.create.listEmpty": "Pegue al menos un NCM de 8 dígitos.",
  "agents.create.listInvalidBlock": "Corrija o elimine las líneas inválidas para crear la tarea.",
  "agents.create.origin": "UF de origen",
  "agents.create.destination": "UF de destino",
  "agents.create.skipCovered": "Omitir NCM ya cubiertos",
  "agents.create.skipCoveredHint":
    "No consulta lo que una regla publicada o un hallazgo de los últimos 30 días ya responde.",
  "agents.create.placement": "Posición en la cola",
  "agents.create.placement.END": "Al final de la cola",
  "agents.create.placement.FRONT": "Al frente",
  "agents.create.estimate": "Estimación",
  "agents.create.estimateOnCreate":
    "Se calcula al crear: el total de NCM solo se conoce en el servidor.",
  "agents.create.estimateList": "{count} consultas · {eta} · {until}",
  "agents.create.estimateSkip": "Antes de omitir los ya cubiertos; el total real puede ser menor.",
  "agents.create.estimatePending": "Pegue la lista para ver la estimación.",
  "agents.create.submit": "Crear tarea",
  "agents.create.creating": "Creando…",
  "agents.create.error": "No se pudo crear la tarea. Revise los campos e inténtelo de nuevo.",
  "agents.jobs.title": "Consultas del sistema",
  "agents.jobs.description":
    "Solo lectura. Los flujos del backend envían miles de NCM × ruta; lo que una regla publicada ya cubre se responde al instante, el resto va a investigación.",
  "agents.jobs.empty": "Ninguna consulta enviada por el sistema.",
  "agents.jobs.entries": "{count} entradas",
  "agents.jobs.lanes": "Investigación",
  "agents.jobs.lane.iob": "IOB",
  "agents.jobs.lane.web": "Web",
  "agents.jobs.lane.none": "Solo caché",
  "agents.jobs.eta": "Previsión",
  "agents.jobs.heading": "Consulta por lotes · cálculo del {date}",
  "agents.jobs.workflow": "Flujo",
  "agents.jobs.created": "Creado",
  "agents.jobs.completed": "Concluido",
  "agents.jobs.calcDate": "Fecha de cálculo",
  "agents.jobs.openTask": "Ver tarea",
  "agents.jobs.noTask": "Sin tarea IOB",
  "agents.jobs.breakdown": "Entradas por estado",
  "agents.jobs.status.RUNNING": "En curso",
  "agents.jobs.status.COMPLETED": "Concluido",
  "agents.jobs.status.CANCELLED": "Cancelado",
  "agents.jobs.entry.COVERED": "Cubierto",
  "agents.jobs.entry.FOUND": "Encontrado",
  "agents.jobs.entry.NO_ST": "Sin ST",
  "agents.jobs.entry.NOT_FOUND": "No encontrado",
  "agents.jobs.entry.FAILED": "Falló",
  "agents.jobs.entry.QUEUED": "En cola",
  "agents.jobs.entry.RESEARCHING": "Investigando",
  "nav.mode": "Modo",
  "nav.mode.developers": "Desarrolladores",
  "nav.developers.keys": "Claves de API",
  "nav.developers.requests": "Solicitudes",
  "nav.developers.docs": "Documentación API",
  "nav.developers.mcp": "Herramientas MCP",
  "nav.developers.section": "API",
  "nav.developers.dock": "Desarrolladores",
  "nav.viewAs.title": "Vista previa por rol",
  "nav.viewAs.help":
    "Revise la navegación y las herramientas disponibles. Su cuenta sigue siendo Superadministrador; las acciones usan su cuenta real.",
  "nav.viewAs.label": "Ver como",
  "nav.viewAs.own": "Yo",
  "nav.viewAs.short.commercial": "Comercial",
  "nav.viewAs.short.manager": "Gestor",
  "nav.viewAs.short.developer": "Dev",
  "nav.viewAs.short.reader": "Lector",
  "nav.viewAs.acting": "Viendo como {role}",
  "nav.viewAs.banner":
    "Está viendo el espacio como {role}. La sesión de superadministrador no cambia.",
  "nav.viewAs.exit": "Volver a Superadministrador",
  "nav.operationsHome": "Operaciones",
  "nav.menu": "Menú de navegación",
  "nav.open": "Abrir navegación",
  "nav.close": "Cerrar navegación",
  "nav.collapse": "Contraer navegación",
  "nav.expand": "Expandir navegación",
  "nav.locked": "Sin permiso",

  "trace.origin": "Origen",
  "trace.state": "Estado",
  "trace.next": "Siguiente paso",
  "trace.howItWorks": "Cómo funciona",
  "trace.evidence.origin": "Fuente observada",
  "trace.evidence.state": "Triaje",
  "trace.evidence.next": "Proponer o archivar",
  "trace.sources.origin": "Fuente oficial revisada",
  "trace.sources.state": "Recolección",
  "trace.sources.next": "Ejecutar o reprocesar",
  "trace.proposals.origin": "Evidencia aceptada",
  "trace.proposals.state": "Revisión",
  "trace.proposals.next": "Publicar conjunto",
  "trace.rulesets.origin": "Propuestas aprobadas",
  "trace.rulesets.state": "Publicación",
  "trace.rulesets.next": "El cálculo fija la versión",
  "trace.rules.origin": "Capítulo SH",
  "trace.rules.state": "Regla publicada",
  "trace.rules.next": "Hueco sin alícuota inventada",
  "trace.rules.chapter.origin": "Capítulo SH",
  "trace.rules.chapter.state": "Clasificación oficial",
  "trace.rules.chapter.next": "Subconjunto publicado, si existe",
  "trace.audit.origin": "Actor",
  "trace.audit.state": "Acción",
  "trace.audit.next": "Correlación",
  "commandSearch.trigger": "Buscar en el espacio fiscal",
  "commandSearch.title": "Búsqueda fiscal",
  "commandSearch.description":
    "Lance una extracción, abra el catálogo Siscomex (clasificación, no alícuota) o un registro ya guardado.",
  "commandSearch.placeholder": "ICMS SP papelería, NCM 84713012, o un destino…",
  "commandSearch.results": "Resultados de la búsqueda fiscal",
  "commandSearch.emptyTitle": "Nada encontrado en esta base",
  "commandSearch.emptyBody":
    "Pruebe un impuesto, UF, NCM, capítulo SH o el título de una evidencia.",
  "commandSearch.move": "Mover",
  "commandSearch.open": "Abrir",
  "commandSearch.close": "Cerrar búsqueda",
  "commandSearch.honesty": "El catálogo clasifica. Solo el conjunto publicado calcula.",
  "commandSearch.group.launch": "Lanzar extracción",
  "commandSearch.group.evidence": "Evidencias",
  "commandSearch.group.rules": "Reglas",
  "commandSearch.group.sources": "Fuentes",
  "commandSearch.group.proposals": "Propuestas",
  "commandSearch.group.calculations": "Cálculos",
  "commandSearch.group.catalog": "Catálogo NCM",
  "commandSearch.launch.label": "Buscar {query} en fuentes oficiales",
  "commandSearch.launch.hint": "Fetcher y extractor. No publica una regla.",
  "commandSearch.catalog.label": "NCM {ncm} en el catálogo Siscomex",
  "commandSearch.catalog.hint": "Clasificación oficial. No es alícuota publicada.",
  "commandSearch.catalog.prefix.label": "NCM {ncm}… en el catálogo Siscomex",
  "commandSearch.catalog.chapter.label": "SH {chapter} · {title}",
  "commandSearch.catalog.chapter.hint": "Capítulo del Sistema Armonizado. No es alícuota.",
  "commandSearch.searching": "Buscando en {groups}…",
  "commandSearch.partialError": "No se pudo buscar en {groups}.",
  "commandSearch.emptyPartialTitle": "Nada encontrado en las categorías que respondieron",
  "commandSearch.denied": "Fuera de su acceso, no buscado: {groups}.",
  "ui.sort.label": "Ordenar por",
  "ui.sort.direction": "Orden {direction}",
  "ui.table.staleError": "No se pudo actualizar la lista. Las filas pueden estar desactualizadas.",
  "ui.table.refreshing": "Actualizando…",
  "ui.table.loading": "Cargando resultados…",
  "ui.table.density": "Densidad",
  "ui.table.density.normal": "Normal",
  "ui.table.density.compact": "Compacta",
  "ui.table.columns": "Columnas",
  "ui.table.columnsLegend": "Columnas secundarias",
  "ui.drawer.navLabel": "Navegar por la lista",
  "ui.drawer.previous": "Anterior en la lista",
  "ui.drawer.next": "Siguiente en la lista",
  "ui.drawer.position": "{index} de {total}",
  "ui.toast.region": "Notificaciones",
  "ui.toast.close": "Cerrar notificación",
  "ui.stat.error": "No se pudo cargar este número",
  "ui.stat.unknown": "Sin datos para este período",
  "ui.stat.stale": "Desactualizado",
  "ui.stat.staleSince": "Desactualizado · {since}",
  "lots.summary.count.one": "{count} lote",
  "lots.summary.count.other": "{count} lotes",
  "lots.summary.window": "· período: {period}",
  "lots.toast.exported": "{format} exportado · {count} ítems",
  "lots.toast.truncated": "{format} exportado hasta el límite de {cap} ítems",
  "lots.toast.failed": "Exportación {format} no completada",
  "proposals.summary.count.one": "{count} propuesta",
  "proposals.summary.count.other": "{count} propuestas",
  "evidence.toast.APPROVED.one": "{count} documento aprobado",
  "evidence.toast.APPROVED.other": "{count} documentos aprobados",
  "evidence.toast.REJECTED.one": "{count} documento rechazado",
  "evidence.toast.REJECTED.other": "{count} documentos rechazados",
  "evidence.toast.DUPLICATE.one": "{count} documento marcado como duplicado",
  "evidence.toast.DUPLICATE.other": "{count} documentos marcados como duplicados",

  "common.placeholder.url": "https://…",
  "common.placeholder.evidencePath": "/evidence/…",
  "common.placeholder.sourceRunPath": "/sources/…/runs/…",
  "common.placeholder.uuid": "00000000-0000-0000-0000-000000000000",
  "common.placeholder.time": "HH:MM",
  "common.search": "Buscar",
  "proposals.filter.search": "Resumen, referencia o NCM",
  "rulesets.filter.search": "Versión o autor",
  "rules.filter.search": "NCM, fragmento o referencia",
  "audit.filter.search": "Acción, actor o correlación",
  "rulesets.inForce": "Conjunto en vigor",
  "rulesets.inForce.missing": "Ningún conjunto publicado",
  "common.filters": "Filtros",
  "common.moreFilters": "Más filtros",
  "common.clear": "Limpiar",
  "common.clearFilters": "Limpiar filtros",
  "date.placeholder.dmy": "dd/mm/aaaa",
  "date.placeholder.mdy": "mm/dd/yyyy",
  "date.openCalendar": "Abrir calendario",
  "common.apply": "Aplicar",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.back": "Volver",
  "common.next": "Siguiente",
  "tabs.scrollNext": "Más pestañas",
  "tabs.scrollPrev": "Pestañas anteriores",
  "common.confirm": "Confirmar",
  "common.copy": "Copiar",
  "common.copied": "Copiado",
  "common.loading": "Cargando…",
  "common.refresh": "Actualizar",
  "common.retry": "Reintentar",
  "common.details": "Detalles",
  "common.status": "Estado",
  "common.jurisdiction": "Jurisdicción",
  "common.publisher": "Publicador",
  "common.updated": "Actualizado",
  "common.created": "Creado",
  "common.author": "Autor",
  "common.reviewer": "Revisor",
  "common.reason": "Justificación",
  "common.none": "Ninguno",
  "common.all": "Todos",
  "common.selected.one": "{count} seleccionado",
  "common.selected.other": "{count} seleccionados",
  "common.selectAll": "Seleccionar todo en la página",
  "common.selectRow": "Seleccionar {label}",
  "common.results.one": "{count} resultado",
  "common.results.other": "{count} resultados",
  "common.loadMore": "Cargar más",
  "common.loadingMore": "Cargando resultados…",
  "common.endOfList": "Fin de la lista",
  "common.firstPage": "Primera página",
  "common.pageSize": "Filas por página",
  "common.sortBy": "Ordenar por {field}",
  "common.sortAscending": "ascendente",
  "common.sortDescending": "descendente",
  "common.language": "Idioma",
  "common.environment": "Entorno",
  "common.of": "de",
  "common.yes": "Sí",
  "common.no": "No",
  "common.notAvailable": "—",
  "common.workspaceHome": "Inicio del espacio fiscal",

  "state.empty.title": "Ningún resultado en este recorte",
  "state.empty.body": "Limpie los filtros para ver la lista, o busque con otro término.",
  "stepper.state.pending": "pendiente",
  "stepper.state.current": "etapa actual",
  "stepper.state.complete": "completada",
  "stepper.state.invalid": "necesita corrección",
  "stepper.state.blocked": "bloqueada hasta corregir una etapa anterior",
  "stepper.state.submitting": "enviando",
  "stepper.state.result": "resultado",
  "state.error.title": "No se pudo cargar",
  "state.error.body": "La solicitud falló. Verifique la conexión e intente de nuevo.",
  "state.loading.label": "Cargando contenido",

  "access.denied.title": "Acceso denegado",
  "access.denied.body":
    "Su perfil no incluye {permission}. Solicítelo al administrador del espacio fiscal.",
  "access.denied.short": "Requiere {permission}",
  "access.disabled.title": "Acción no disponible aún",
  "access.disabled.body": "{reason}",
  "access.unavailable.title": "Servicio no disponible",
  "access.unavailable.body": "Una dependencia necesaria no responde: {reason}. Intente más tarde.",
  "access.requestAccess": "Solicitar acceso",
  "access.legend": "Denegado, deshabilitado y no disponible son estados distintos.",

  "auth.accessTitle": "Inicie sesión en su cuenta",
  "auth.signIn": "Iniciar sesión",
  "auth.email": "Correo electrónico",
  "auth.emailPlaceholder": "nombre@backchannel.com.br",
  "auth.password": "Contraseña",
  "auth.showPassword": "Mostrar contraseña",
  "auth.hidePassword": "Ocultar contraseña",
  "auth.forgotPassword": "¿Olvidó su contraseña?",
  "auth.resetPassword": "Restablecer contraseña",
  "auth.resetPasswordDescription":
    "Enviaremos un enlace al correo de la cuenta, en el idioma con el que fue creada.",
  "auth.resetLinkDescription": "Defina una nueva contraseña para entrar a Tax Operations.",
  "auth.error.passwordMismatch": "Las contraseñas no coinciden.",
  "auth.invite.title": "Configurar cuenta",
  "auth.invite.description":
    "Elija primero su contraseña. En el siguiente paso puede añadir una passkey o entrar a su espacio de trabajo.",
  "auth.invite.activationError":
    "No pudimos activar su cuenta. Inténtelo de nuevo. Si el problema continúa, contacte con su administrador.",
  "auth.invite.submit": "Activar cuenta",
  "auth.invite.invalid": "Esta invitación es inválida o ya venció. Pida una nueva invitación.",
  "auth.invite.invalidHelp": "Pida una nueva invitación a un superadministrador.",
  "auth.invite.displayName": "Cómo debemos llamarte",
  "auth.invite.expires": "Invitación válida hasta {date}",
  "auth.invite.passkeyTitle": "Registrar una passkey (opcional)",
  "auth.invite.passkeyDescription":
    "La passkey entra a este espacio sin contraseña. Puede omitir este paso y registrarla después en su perfil.",
  "auth.invite.passkeySkip": "Ahora no",
  "auth.passwordPolicy": "Mínimo 8 caracteres. No necesita mayúsculas, números ni símbolos.",
  "auth.error.passwordLength": "Use entre 8 y 128 caracteres.",
  "auth.sendResetLink": "Enviar enlace",
  "auth.resetMissing":
    "Este enlace de restablecimiento es inválido o ya venció. Pida uno nuevo en Entrar.",
  "auth.newPassword": "Nueva contraseña",
  "auth.confirmPassword": "Confirmar nueva contraseña",
  "auth.confirmReset": "Definir nueva contraseña",
  "auth.backToSignIn": "Volver a iniciar sesión",
  "auth.resetting": "Actualizando…",
  "auth.resetSent": "Si esta cuenta puede recuperarse, enviamos un enlace de restablecimiento.",
  "auth.resetComplete": "Contraseña actualizada. Inicie sesión con su nueva contraseña.",
  "auth.signOut": "Cerrar sesión",
  "auth.accountMenu": "Menú de cuenta",
  "auth.accountTrigger": "Abrir el menú de cuenta de {name}",
  "auth.accountSection": "Su cuenta",
  "auth.accountSettings": "Mi cuenta",
  "auth.enterDevelopers": "Ir a Developers",
  "auth.backToOperations": "Volver a Operaciones",
  "auth.languagePreference": "Preferencia de idioma",
  "auth.signingIn": "Autenticando…",
  "auth.loading.title": "Preparando su espacio.",
  "auth.loading.description": "Un momento para abrir su espacio de trabajo.",
  "auth.loading.delayedDetail": "Puede seguir esperando.",
  "auth.loading.territory": "Brasil · Territorio fiscal",
  "auth.loading.country": "Brasil",
  "auth.loading.reconnect": "Restableciendo su conexión",
  "auth.loading.session": "Restaurando la sesión protegida",
  "auth.loading.identity": "Verificando su identidad BackChannel",
  "auth.loading.workspace": "Continuarás en cuanto esté listo.",
  "auth.loading.delayed": "Está tardando más de lo habitual.",
  "auth.session": "Sesión",
  "auth.sessionUnavailable": "No se pudo cargar su sesión",
  "auth.sessionUnavailableDescription":
    "Su identidad sigue autenticada, pero el espacio fiscal no respondió. Inténtelo de nuevo o cierre la sesión.",
  "auth.role": "Perfil",
  "auth.permissions": "Permisos",
  "auth.mock": "Sesión simulada",
  "auth.callback.title": "Finalizando el inicio de sesión",
  "auth.callback.body": "Intercambiando el código de autorización por tokens de sesión.",
  "auth.error.title": "Falló el inicio de sesión",
  "auth.error.state": "Parámetro state inválido: posible intento de CSRF.",
  "auth.error.missingCode": "El proveedor no devolvió un código de autorización.",
  "auth.error.exchange": "Falló el intercambio del código de autorización.",
  "auth.error.config": "El acceso no está configurado: {reason}.",
  "auth.error.credentials": "No se pudo iniciar sesión. Revise el email y la contraseña.",
  "auth.error.resetEmailRequired": "Introduzca primero su email para restablecer la contraseña.",
  "auth.error.resetMismatch": "Las contraseñas no coinciden.",
  "auth.error.reset":
    "No se pudo restablecer la contraseña. Solicite un enlace nuevo e inténtelo otra vez.",
  "auth.error.network":
    "El servicio de identidad no está disponible ahora. Revise su conexión e inténtelo de nuevo.",
  "auth.error.challenge":
    "Su cuenta requiere un paso adicional. Termine la configuración de la cuenta y vuelva a intentarlo.",
  "auth.error.passwordResetRequired":
    "Su contraseña debe restablecerse. Use «¿Olvidó su contraseña?» para continuar.",
  "auth.passkey": "Entrar con passkey",
  "auth.passkeySigningIn": "Esperando su passkey…",
  "auth.google": "Continuar con Google",
  "auth.googleRedirecting": "Abriendo Google…",
  "auth.googleReaderNote": "Primer acceso con Google: perfil Lector.",
  "auth.continueWithEmail": "Continuar con correo electrónico",
  "auth.otherOptions": "Otras formas de entrar",
  "auth.emailFormLabel": "Entrar con correo y contraseña",
  "auth.lastUsed": "Último método usado en este navegador",
  "auth.callback.googleBody": "Confirmando su inicio de sesión con Google.",
  "auth.callback.provisionedTitle": "Cuenta creada",
  "auth.callback.provisionedBody":
    "Cuenta creada como Lector — pida a un administrador que ajuste su acceso.",
  "auth.callback.provisionedHint":
    "Ya puede consultar las áreas de lectura. Un superadministrador puede cambiar su perfil en Administración → Usuarios.",
  "auth.callback.provisionedContinue": "Continuar",
  "auth.error.google": "No se pudo iniciar sesión con Google. Inténtelo de nuevo.",
  "auth.error.googleNotInvited":
    "Esta cuenta de Google no tiene acceso a Operaciones Fiscales. Use su cuenta @backchannel.com.br o pida acceso a un superadministrador.",
  "auth.error.googleRejected": "Google no confirmó este inicio de sesión. Inténtelo de nuevo.",
  "auth.error.googleUnavailable":
    "El inicio de sesión con Google no está disponible ahora. Use correo y contraseña o passkey.",
  "auth.error.googleCancelled": "Se canceló el inicio de sesión con Google.",
  "auth.or": "o",
  "auth.passkeyHostHint": "Disponible en tax.backchannel.com.br o en este localhost.",
  "auth.passkeyHostHintDeployed": "Disponible en tax.backchannel.com.br.",
  "auth.error.passkey": "No se pudo verificar la passkey. Inténtelo de nuevo.",
  "auth.error.passkeyUnsupported": "Este navegador no admite passkeys.",
  "auth.error.passkeyCancelled":
    "No se usó la passkey. Inténtelo de nuevo o elija otra forma de entrar.",
  "auth.error.passkeyOrigin":
    "Abra Operaciones Fiscales desde su dominio BackChannel para usar esta passkey.",
  "auth.error.passkeyUnavailable":
    "El acceso con passkey no está disponible temporalmente. Use su contraseña o inténtelo más tarde.",
  "auth.error.passkeyTimeout":
    "La solicitud de passkey tardó demasiado. Inténtelo de nuevo o use su contraseña.",
  "auth.accessPending.title": "Acceso al espacio fiscal pendiente",
  "auth.accessPending.body":
    "Su identidad BackChannel fue validada, pero todavía no está registrada como operador fiscal en este espacio. Solicite a un administrador que la agregue al registro de operadores.",
  "auth.accessPending.request": "Solicitar acceso al espacio fiscal",
  "auth.expired": "Su sesión expiró. Inicie sesión nuevamente para continuar.",
  "auth.tokenNotice":
    "El token de identidad permanece en memoria; esta pestaña conserva un refresh token aislado y nunca registra credenciales.",
  "auth.loginDescription": "Evidencias, reglas y cálculos fiscales de Brasil.",
  "auth.brand.secure": "Acceso protegido por la identidad BackChannel.",
  "auth.brand.help": "¿Necesita ayuda?",
  "auth.map.title": "Mapa fiscal de Brasil",
  "auth.map.legend.label": "Leyenda del mapa",
  "auth.map.legend.unwatched": "Fuera de la lista actual",
  "auth.map.stateLabel": "{state} ({uf}). Capital {capital}. {watch}.",
  "auth.map.watched": "SEFAZ observada",
  "auth.map.unwatched": "Fuera de la lista actual de SEFAZ",
  "auth.map.fact.AC": "El nombre viene del río Aquiri; limita con Perú y Bolivia.",
  "auth.map.fact.AL": "El segundo estado más pequeño de Brasil; Maceió vive entre lagunas y mar.",
  "auth.map.fact.AP": "La línea del Ecuador cruza Amapá.",
  "auth.map.fact.AM":
    "El estado más grande del país: aquí está la mayor parte de la Amazonia brasileña.",
  "auth.map.fact.BA": "Salvador fue la primera capital de Brasil.",
  "auth.map.fact.CE": "Fortaleza tiene uno de los litorales urbanos más largos del país.",
  "auth.map.fact.DF": "Brasilia se inauguró en 1960; es distrito federal, no estado.",
  "auth.map.fact.ES": "Vitória es una capital-isla, unida al continente por puentes.",
  "auth.map.fact.GO": "Corazón del Cerrado; Goiânia nació planificada en 1933.",
  "auth.map.fact.MA": "Los Lençóis Maranhenses son dunas con lagunas de lluvia.",
  "auth.map.fact.MT": "Aloja el norte del Pantanal y la Chapada dos Guimarães.",
  "auth.map.fact.MS": "Bonito y el sur del Pantanal quedan en este estado.",
  "auth.map.fact.MG": "Tiene más municipios que cualquier otro estado.",
  "auth.map.fact.PA": "Belém está en la desembocadura del Amazonas; Marajó es inmensa.",
  "auth.map.fact.PB": "Ponta do Seixas es el extremo este de las Américas.",
  "auth.map.fact.PR": "Las cataratas del Iguazú están en la frontera con Argentina.",
  "auth.map.fact.PE": "Recife y Olinda forman el par colonial de la costa.",
  "auth.map.fact.PI": "Tiene el litoral más corto del Nordeste, en el delta del Parnaíba.",
  "auth.map.fact.RJ": "Fue la capital de Brasil hasta 1960.",
  "auth.map.fact.RN": "Natal fue fundada en Navidad de 1599.",
  "auth.map.fact.RS": "Único estado de mayoría pampa; tierra gaucha.",
  "auth.map.fact.RO": "Nació del territorio del ferrocarril Madeira-Mamoré.",
  "auth.map.fact.RR": "El estado más al norte; el Monte Roraima es un tepuy.",
  "auth.map.fact.SC": "Florianópolis es capital-isla, con fuerte inmigración europea.",
  "auth.map.fact.SP": "El estado más poblado; la sede de BackChannel está en Vila Olímpia.",
  "auth.map.fact.SE": "El estado más pequeño de Brasil en superficie.",
  "auth.map.fact.TO": "El estado más nuevo, creado en 1988 a partir del norte de Goiás.",
  "auth.map.hq.fact": "Rua Tenerife 31, conj. 31A — Edifício Tenerife, Vila Olímpia.",
  "auth.map.capital": "Capital",
  "auth.map.sefaz": "SEFAZ",
  "auth.map.close": "Cerrar",
  "auth.map.illustrationKind": "Ilustración de la región",
  "auth.map.regionArt.north": "Ilustración del Norte: territorio, río y documento citado",
  "auth.map.regionArt.northeast":
    "Ilustración del Nordeste: territorio, sol en el litoral y documento citado",
  "auth.map.regionArt.centralWest":
    "Ilustración del Centro-Oeste: territorio, chapadas y documento citado",
  "auth.map.regionArt.southeast": "Ilustración del Sudeste: territorio, ciudad y documento citado",
  "auth.map.regionArt.south": "Ilustración del Sur: territorio, araucarias y documento citado",
  "auth.map.hq.name": "Sede BackChannel",
  "auth.map.hq.eyebrow": "São Paulo",
  "auth.map.hq.role": "Oficina · Vila Olímpia",
  "auth.map.hq.address": "Dirección",
  "auth.map.hq.phone": "Teléfono",
  "auth.map.hq.openMaps": "Abrir en Google Maps",
  "auth.map.hq.pinLabel": "Sede BackChannel en Vila Olímpia, São Paulo",
  "auth.map.hq.illustrationAlt":
    "Ilustración de la sede BackChannel: São Paulo en el mapa y el edificio del conjunto 31A en Vila Olímpia",
  "auth.map.hq.label": "São Paulo · sede",
  "auth.domainHint": "Use su cuenta @backchannel.com.br.",
  "auth.providersLoading": "Comprobando las formas de entrar…",
  "auth.providersFailed": "No se pudo comprobar el acceso con Google.",
  "auth.error.emailRequired": "Ingrese su correo electrónico.",
  "auth.error.emailInvalid": "Ingrese un correo válido, como nombre@backchannel.com.br.",
  "auth.error.passwordRequired": "Ingrese su contraseña.",
  "auth.atlas.title": "El territorio fiscal, UF por UF.",
  "auth.atlas.context": "{count} SEFAZ en la lista de fuentes observadas",
  "auth.atlas.place": "Vila Olímpia",
  "auth.atlas.compactLabel": "Brasil, con la sede de BackChannel en São Paulo",
  "auth.value.label": "Qué hace la plataforma",
  "auth.value.calculation": "Cálculo de ICMS, ST e IPI por NCM y ruta",
  "auth.value.evidence": "Reglas con evidencia oficial",
  "auth.value.research": "Agente IOB e investigación en las SEFAZ",

  "overview.workspace.eyebrow": "Impuestos de productos",
  "overview.workspace.title": "Consulte, calcule y revise",
  "overview.workspace.description":
    "Busque reglas por producto y trayecto, calcule su planilla y consulte los resultados.",
  "overview.mockNotice": "Demostración local: los datos visibles son simulados.",
  "overview.ledger.eyebrow": "Base fiscal",
  "overview.ledger.title": "Lo que la base ya guarda, y lo que aún no gobierna",
  "overview.ledger.publishedOn": "Conjunto {version} publicado el {date}.",
  "overview.ledger.publishedEmpty":
    "No hay un conjunto de reglas publicado. Este sistema todavía no precifica listas.",
  "overview.ledger.unpublished": "No publicado",
  "overview.ledger.noCount": "—",
  "overview.ledger.outsideBase": "fuera de esta base",
  "overview.ledger.ofCatalog": "de {catalog}",
  "overview.ledger.state.published": "publicado",
  "overview.ledger.state.draft": "en revisión",
  "overview.ledger.state.reference": "referencia, no gobernada",
  "overview.ledger.state.absent": "ausente",
  "overview.ledger.state.notCollected": "no se sigue aquí",
  "overview.ledger.family.ncm": "NCM",
  "overview.ledger.family.ncm.hint": "catálogo Siscomex, no alícuota",
  "overview.ledger.openCatalog": "Abrir catálogo NCM de referencia",
  "overview.ledger.openCestCatalog": "Abrir catálogo CEST de referencia",
  "overview.ledger.family.cest": "CEST",
  "overview.ledger.family.cest.hint": "catálogo CONFAZ, no alícuota",
  "overview.ledger.family.ipi": "IPI / TIPI",
  "overview.ledger.family.ipi.hint": "alícuota federal del IPI",
  "overview.ledger.family.pisCofins": "PIS / COFINS",
  "overview.ledger.family.pisCofins.hint":
    "catálogo legal V2 en calculadora · régimen no acreditado",
  "overview.ledger.family.icms": "ICMS interno e interestatal",
  "overview.ledger.family.icms.hint": "alícuota interna e interestatal",
  "overview.ledger.family.icmsSt": "ICMS-ST",
  "overview.ledger.family.icmsSt.hint": "sustitución tributaria",
  "overview.ledger.family.mva": "MVA / IVA-ST",
  "overview.ledger.family.mva.hint": "margen de valor agregado",
  "overview.ledger.family.iss": "ISS",
  "overview.ledger.family.iss.hint":
    "fuera de esta base: reventa de mercancías, no servicio municipal",
  "overview.ledger.openPublished": "Abrir reglas publicadas",
  "overview.ledger.openDraft": "Abrir propuestas en revisión",
  "overview.cycle.published": "Publicado",
  "overview.catalog.expiring": "Vencen en 30 días",
  "overview.catalog.missingProvenance": "Sin proveniencia",
  "overview.coverage.eyebrow": "Cobertura territorial",
  "overview.coverage.title": "Evidencia y reglas por UF",
  "overview.coverage.description":
    "Consulte dónde se concentran las reglas de ruta publicadas y las evidencias capturadas. Seleccione un estado para abrir el catálogo filtrado.",
  "overview.coverage.mode.label": "Datos de cobertura",
  "overview.coverage.mode.rules": "Reglas publicadas",
  "overview.coverage.mode.evidence": "Evidencias y noticias",
  "overview.coverage.map.title": "Mapa interactivo de cobertura fiscal de Brasil",
  "overview.coverage.map.description":
    "Cada estado se puede seleccionar y su color representa el conteo relativo de registros. Los conteos exactos aparecen en los detalles del estado.",
  "overview.coverage.map.stateLabel":
    "{state}, {uf}: {count} registros. Seleccione para ver detalles.",
  "overview.coverage.legend.label": "Registros por UF en esta vista",
  "overview.coverage.legend.none": "0 registros",
  "overview.coverage.legend.low": "Menor",
  "overview.coverage.legend.mid": "Media",
  "overview.coverage.legend.high": "Mayor",
  "overview.coverage.legend.unknown": "Sin datos",
  "overview.coverage.legend.explain.rules":
    "Color = reglas publicadas que citan la UF como origen o destino, en franjas relativas entre las UF de esta vista. No es alícuota ni porcentaje nacional.",
  "overview.coverage.legend.explain.evidence":
    "Color = evidencias y noticias capturadas por UF, en franjas relativas entre las UF de esta vista. No es alícuota ni porcentaje nacional.",
  "overview.coverage.legend.ufCount": "{count} UF",
  "overview.coverage.legend.range": "{min}–{max} · {count} UF",
  "overview.coverage.map.stateLabelUnknown":
    "{state}, {uf}: sin datos en esta vista. Seleccione para ver detalles.",
  "overview.coverage.freshness.updated": "Actualizado el {time}",
  "overview.coverage.freshness.stale": "No se pudo actualizar · datos de {time}",
  "overview.coverage.freshness.retry": "Reintentar",
  "overview.coverage.state.band": "{band} · {count} registros en esta vista",
  "overview.coverage.state.unknown": "Sin datos de esta UF en “{mode}”",
  "overview.coverage.summary.unknown":
    "La lectura no trajo cobertura por UF. Ningún estado aparece como cero.",
  "overview.coverage.list.title": "Todas las UF",
  "overview.coverage.list.description": "Lista equivalente al mapa · {mode}",
  "overview.coverage.list.sort": "Ordenar",
  "overview.coverage.list.sort.count": "Registros",
  "overview.coverage.list.sort.name": "A–Z",
  "overview.coverage.list.sort.region": "Región",
  "overview.coverage.list.row": "{state} ({uf}), {region}: {count} registros, franja {band}",
  "overview.coverage.list.rowUnknown": "{state} ({uf}), {region}: sin datos",
  "overview.coverage.error.title": "No se pudo cargar la cobertura por UF",
  "overview.coverage.error.body":
    "La base fiscal y el mapa dependen de la misma lectura. Nada se muestra como cero mientras falla.",
  "overview.coverage.error.retry": "Reintentar",
  "overview.coverage.attribution": "Geometría del mapa: @svg-maps/brazil · CC BY 4.0",
  "overview.coverage.clear": "Vista nacional",
  "overview.coverage.state.eyebrow": "Estado seleccionado",
  "overview.coverage.state.rules": "Reglas publicadas",
  "overview.coverage.state.evidence": "Evidencias y noticias",
  "overview.coverage.state.origin": "Rutas de origen",
  "overview.coverage.state.destination": "Rutas de destino",
  "overview.coverage.state.pending": "evidencias esperan revisión en este estado.",
  "overview.coverage.region.north": "Norte",
  "overview.coverage.region.northeast": "Nordeste",
  "overview.coverage.region.centralWest": "Centro-Oeste",
  "overview.coverage.region.southeast": "Sudeste",
  "overview.coverage.region.south": "Sur",
  "overview.coverage.updates.eyebrow": "Evidencias recientes de la UF",
  "overview.coverage.updates.title": "Actualizaciones regionales recientes",
  "overview.coverage.updates.scope": "Evidencia capturada",
  "overview.coverage.updates.error":
    "Las actualizaciones regionales no están disponibles ahora. Abra el catálogo de evidencias del estado para continuar.",
  "overview.coverage.updates.empty": "Todavía no se capturaron evidencias para este estado.",
  "overview.coverage.openRules": "Abrir reglas de {uf}",
  "overview.coverage.openEvidence": "Abrir evidencias de {uf}",
  "overview.coverage.summary.eyebrow": "Vista del país",
  "overview.coverage.summary.title": "Panorama nacional",
  "overview.coverage.summary.description":
    "Las bandas comparan registros por UF dentro de esta vista: reglas con UF de origen o destino, o evidencias capturadas. No miden cobertura nacional ni alícuotas.",
  "overview.coverage.summary.nationalRules": "Reglas sin UF de origen y destino",
  "overview.coverage.summary.federalEvidence": "Evidencias federales",
  "overview.coverage.summary.federalPending": "Ítems federales pendientes",
  "overview.coverage.summary.empty": "No hay registros estatales disponibles en esta vista.",
  "overview.coverage.ranking.title": "Mayor concentración",
  "overview.coverage.ranking.description": "Relativa a esta vista",
  "overview.coverage.crossing.federal":
    "{family} es federal. Los colores del mapa siguen siendo reglas de ruta o evidencias por UF. No hay alícuota de esta familia por estado.",
  "overview.coverage.crossing.convenio":
    "{family} viene del CONFAZ. El mapa no recorta esta familia por UF.",
  "overview.coverage.crossing.state":
    "{watched} de {total} SEFAZ observadas. Las demás UF quedan apagadas hasta revisión de URL. Los colores no son alícuotas.",
  "overview.coverage.crossing.stateAll":
    "Las {total} SEFAZ están en la lista de fuentes observada. Los colores siguen siendo registros por UF, no la alícuota de {family}.",
  "overview.coverage.crossing.municipal":
    "El ISS es municipal. Esta base de mercancías no sigue el ISS.",
  "overview.coverage.crossing.stateWatched":
    "{state} ({uf}) está en la allow-list de SEFAZ. Los números abajo son reglas y evidencias de esta UF, no la alícuota de {family}.",
  "overview.coverage.crossing.stateUnwatched":
    "{state} ({uf}) aún no tiene host SEFAZ revisado. Sin URL revisada, no inventamos alícuota.",
  "overview.work.rules.action": "Consultar reglas",
  "overview.route.label": "Ruta del día",
  "overview.route.calculator": "Calcular planilla",
  "overview.gaps.eyebrow": "Lo que la base aún no gobierna",
  "overview.gaps.title": "Huecos de la base",
  "overview.gaps.description":
    "Familias de esta base aún sin regla publicada. PIS/COFINS quedan fuera de esta base y no piden formulario. ISS municipal no entra: BackChannel precifica mercancía con tributos federales y estatales. No inventamos alícuota.",
  "overview.gaps.empty":
    "Las familias de esta base ya tienen regla publicada. PIS/COFINS permanecen fuera de esta base. ISS municipal no entra.",
  "overview.gaps.openProposals": "Abrir propuestas",
  "overview.gaps.openRules": "Abrir reglas",
  "overview.gaps.openOfficialSource": "Abrir fuente oficial",
  "overview.gaps.pisCofins.guidance":
    "La entidad legal de la plataforma está fuera de Simples Nacional (socio PJ en el QSA). Aún faltan el régimen Lucro Presumido o Lucro Real, el tratamiento del producto y evidencia vigente para gobernar PIS/COFINS; no hay alícuota única segura.",
  "overview.gaps.iss.guidance":
    "ISS es un impuesto municipal sobre servicios. BackChannel no cobra ISS: la operación es mayorista de mercancías, con IPI federal e ICMS estadual. No modelamos municipio.",
  "overview.gaps.noForm": "Sin feed oficial aquí",
  "overview.priority.empty": "Este resumen no tiene trabajo que requiera acción ahora.",
  "overview.priority.shownOf": "{shown} de {total}",
  "overview.changes.eyebrow": "Gobernanza mensual",
  "overview.changes.title": "Qué cambió en este ciclo",
  "overview.changes.description": "Diferencia entre la versión activa y su base gobernada.",
  "overview.changes.added": "Agregadas",
  "overview.changes.changed": "Modificadas",
  "overview.changes.removed": "Eliminadas",
  "overview.changes.total": "{count} cambios de reglas gobernados en esta publicación",
  "overview.changes.noBaseline": "Esta versión no tiene una base publicada comparable.",
  "overview.changes.noRuleset": "No hay un conjunto publicado para comparar.",
  "overview.changes.openCatalog": "Abrir catálogo publicado",
  "overview.exceptions.window":
    "Señales estructuradas más frecuentes en cálculos completados durante las últimas 24 horas.",
  "overview.exceptions.openReviews": "Abrir revisión financiera",
  "overview.technical.title": "Detalles de ingesta y auditoría",
  "overview.technical.description":
    "Salud técnica de entrega, secundaria al trabajo de decisión fiscal.",

  "overview.priority.eyebrow": "Trabajo de decisión",
  "overview.priority.title": "Bandeja de prioridades",
  "overview.priority.description":
    "Trabajo que puede cambiar un resultado fiscal o bloquear un cálculo seguro.",
  "overview.priority.open": "abiertas",
  "overview.priority.more": " · {count} alertas adicionales no visibles",
  "overview.ingestion.eyebrow": "Suministro de evidencia",
  "overview.exceptions.eyebrow": "Calidad de cálculo",
  "overview.section.instruments": "Indicadores operativos",
  "overview.section.attention": "Requiere atención",
  "overview.section.recentRuns": "Ejecuciones recientes",
  "overview.section.recentActivity": "Actividad de gobernanza",
  "overview.section.issues": "Principales inconsistencias",
  "overview.issues.hint": "Códigos de inconsistencia más frecuentes en los cálculos recientes.",
  "overview.issues.relativeHint": "Relativo a la inconsistencia listada más frecuente.",
  "overview.ruleset.integrity": "Digest del contenido publicado",
  "overview.runs.stalled":
    "Esta ejecución superó la ventana de procesamiento de dos horas. Revise la fuente o reinténtela.",
  "overview.runs.viewSources": "Ver todas las ejecuciones de fuentes",
  "overview.activity.viewAudit": "Ver el registro completo de auditoría",
  "overview.empty.priority": "Este resumen no devolvió alertas operativas.",
  "overview.empty.issues": "No se devolvieron inconsistencias estructuradas de cálculo.",
  "overview.empty.runs": "No se devolvieron ejecuciones recientes de fuentes.",
  "overview.empty.activity": "No se devolvió actividad gobernada reciente.",
  "overview.attention.evidenceAged.title":
    "{count} evidencias esperan triaje desde hace más de 24 h",
  "overview.attention.evidenceAged.detail":
    "La cola crece más rápido que el triaje de las fuentes estatales.",
  "overview.attention.proposalStuck.title": "{count} propuestas esperan al segundo aprobador",
  "overview.attention.proposalStuck.detail":
    "La segregación de funciones requiere un revisor distinto del autor.",
  "overview.attention.sourceDegraded.title": "Fuente degradada: {source}",
  "overview.attention.sourceDegraded.detail": "La fuente informó: {reason}",
  "overview.attention.sourceDegraded.failedRuns":
    "Las ejecuciones recientes de esta fuente fallaron.",
  "overview.attention.dlqDepth.title": "{count} fallas pendientes en {publisher}",
  "overview.attention.dlqDepth.detail":
    "Observación por fuente a las {observedAt}. Monitoring es la fuente de verdad de la suscripción física compartida; haga una vista previa por fuente antes de reprocesar.",
  "overview.attention.refreshError":
    "La actualización no está disponible; el conteo de fallas pendientes queda oculto hasta una lectura exitosa.",
  "overview.attention.kind.evidence": "Cola de evidencias",
  "overview.attention.kind.proposal": "Revisión de reglas",
  "overview.attention.kind.source": "Salud de fuentes",
  "overview.attention.kind.review": "Cola de revisión",
  "overview.attention.kind.dlq": "Cola de mensajes fallidos",
  "overview.issue.taxConfigTableNotConfigured": "Tabla de configuración fiscal no configurada",
  "overview.issue.ncmMissingOrInvalid": "NCM ausente o inválido",
  "overview.issue.originUfMissingOrInvalid": "UF de origen ausente o inválida",
  "overview.issue.destinationUfMissingOrInvalid": "UF de destino ausente o inválida",
  "overview.issue.fiscalParameterMissing": "Parámetro fiscal ausente",
  "overview.issue.fiscalParameterAmbiguous": "Parámetro fiscal ambiguo para la ruta NCM",
  "overview.issue.baseCostMissingOrInvalid": "Costo base ausente o inválido",
  "overview.issue.baseCostInferred": "Costo base inferido a partir del precio",
  "overview.issue.originalMvaMissingOrInvalid": "MVA original (IVA-ST) ausente o inválido",
  "overview.issue.destinationIcmsMissingOrInvalid":
    "Alícuota interna de ICMS en destino ausente o inválida",
  "overview.issue.interstateIcmsInvalid": "Alícuota interestatal de ICMS inválida",
  "overview.issue.ipiMissingOrInvalid": "Alícuota de IPI ausente o inválida",
  "overview.issue.takeRateMissingOrInvalid": "Tasa de intermediación ausente o inválida",
  "overview.issue.operationalCostInvalid": "Costo operativo inválido",
  "overview.issue.saleLegMissingOrInvalid": "Sin regla para la ruta de venta",
  "overview.issue.netMarginUnreachable": "Margen neto inalcanzable",
  "overview.issue.resaleProfilePending": "Perfil de PIS/COFINS pendiente",
  "overview.issue.icmsBenefitNotApplicable": "Beneficio de ICMS no previsto en la regla",
  "fiscalLines.source.PIS_COFINS_PROFILE": "perfil PIS/COFINS",
  "lotOps.group.pisCofinsProfile": "Perfil PIS/COFINS",
  "overview.issue.pisCofinsProfilePending": "Perfil PIS/COFINS por confirmar",
  "overview.issue.cbsIbsRatePending": "CBS/IBS: alícuota del año no publicada",
  "overview.issue.cbsIbsClassPending": "CBS/IBS: confirmar la clasificación (cClassTrib)",
  "issueHelp.pisCofinsProfilePending":
    "El catálogo legal no decide el PIS/COFINS de este NCM (bebida fría, condición por confirmar o listas superpuestas). Informe el tratamiento confirmado; no se presume ninguna alícuota y el ítem queda en revisión.",
  "issueHelp.cbsIbsRatePending":
    "No hay alícuota CBS/IBS publicada para el año de la fecha fiscal, o la fecha es 2027 o posterior (el régimen debido aún no se calcula). Publique la alícuota del año o espere el motor.",
  "issueHelp.cbsIbsClassPending":
    "La clasificación CBS/IBS (cClassTrib) requiere su confirmación. Informe la clase y el fundamento; no se presume ninguna alícuota y el ítem queda en revisión.",
  "pisCofinsProfile.title": "Perfil PIS/COFINS",
  "pisCofinsProfile.profile.STANDARD": "Régimen normal",
  "pisCofinsProfile.profile.SINGLE_STAGE": "Monofásico (reventa a tasa cero)",
  "pisCofinsProfile.profile.ZERO_RATE": "Tasa cero",
  "pisCofinsProfile.profile.PENDING": "Pendiente",
  "pisCofinsProfile.short.STANDARD": "Régimen normal",
  "pisCofinsProfile.short.SINGLE_STAGE": "Monofásico",
  "pisCofinsProfile.short.ZERO_RATE": "Tasa cero",
  "pisCofinsProfile.short.PENDING": "Pendiente",
  "pisCofinsProfile.candidate.SINGLE_STAGE": "monofásico",
  "pisCofinsProfile.candidate.ZERO_RATE": "tasa cero",
  "pisCofinsProfile.candidate.BEVERAGE": "bebida fría",
  "pisCofinsProfile.cst": "CST {cst}",
  "pisCofinsProfile.creditCst": "crédito CST {cst}",
  "pisCofinsProfile.field.profile": "Perfil",
  "pisCofinsProfile.field.saleCst": "CST de venta",
  "pisCofinsProfile.field.creditCst": "CST de crédito",
  "pisCofinsProfile.field.source": "Origen",
  "pisCofinsProfile.field.basis": "Base legal",
  "pisCofinsProfile.field.condition": "Condición legal",
  "pisCofinsProfile.field.candidate": "Perfil probable",
  "pisCofinsProfile.none": "sin CST",
  "pisCofinsProfile.source.CATALOG": "catálogo legal",
  "pisCofinsProfile.source.OPERATOR": "informado por el operador",
  "pisCofinsProfile.source.REGIME": "régimen",
  "pisCofinsProfile.validFrom": "vigente desde {date}",
  "pisCofinsProfile.validRange": "vigente del {from} al {to}",
  "pisCofinsProfile.regimeBasis": "Base del régimen (ninguna lista legal se aplica al NCM)",
  "pisCofinsProfile.catalog": "Catálogo {catalog} · motor 1.8.0",
  "pisCofinsProfile.opensSource": "abre la ley en Planalto",
  "pisCofinsProfile.pending.BEVERAGE_PROFILE":
    "Bebida fría (Ley 13.097/2015): mayorista sin tasa cero; informe el tratamiento",
  "pisCofinsProfile.pending.REQUIRES_CONFIRMATION":
    "Condición legal que el NCM no comprueba (Ex de la TIPI o descripción); confirme el tratamiento",
  "pisCofinsProfile.pending.OVERLAPPING_LISTS":
    "NCM en más de una lista (monofásico y tasa cero); confirme cuál se aplica",
  "pisCofinsProfile.pending.NOT_IN_CATALOG":
    "El tratamiento informado no está en la lista legal de este NCM",
  "issueHelp.resaleProfilePending":
    "El NCM tiene un tratamiento propio de PIS/COFINS (monofásico, bebidas frías o alícuota cero). Informe el tratamiento confirmado; el margen queda pendiente, nunca cero.",
  "issueHelp.icmsBenefitNotApplicable":
    "El cBenef informado no está en la regla publicada de la venta o no está vigente. Confirme el código o publique la regla con el beneficio.",
  "wb.issue.NCM_WITH_SUFFIX.title": "NCM con complemento no mapeado",
  "wb.issue.NCM_WITH_SUFFIX.hint":
    "El campo tiene 10 dígitos (NCM de 8 + complemento interno). Confirme el NCM de 8 dígitos y el atributo adicional en el catastro; la fila no se trunca automáticamente.",
  "issueHelp.taxConfigTableNotConfigured":
    "No hay reglas fiscales publicadas. Publique un conjunto de reglas antes de calcular.",
  "issueHelp.ncmMissingOrInvalid":
    "La fila no tiene un NCM de 8 dígitos. Corrija la columna NCM en el archivo o en la fila y recalcule.",
  "issueHelp.originUfMissingOrInvalid":
    "La UF de origen está vacía o no es una UF. Corrija la columna de origen o fije la ruta del lote.",
  "issueHelp.destinationUfMissingOrInvalid":
    "La UF de destino está vacía o no es una UF. Corrija la columna de destino o fije la ruta del lote.",
  "issueHelp.fiscalParameterMissing":
    "Ninguna regla publicada informa el ICMS de este NCM en esta ruta. Investigue la regla (Investigar brechas) y publíquela antes de recalcular.",
  "issueHelp.fiscalParameterAmbiguous":
    "Más de una regla sirve a este NCM y ruta. Informe el CEST de la fila para elegir la regla correcta.",
  "issueHelp.baseCostMissingOrInvalid":
    "El costo unitario está vacío, es cero o no es un número. Corrija la columna de costo y recalcule.",
  "issueHelp.baseCostInferred":
    "No había costo: el cálculo usó el precio de venta como base. Informe el costo de compra para un valor confiable.",
  "issueHelp.originalMvaMissingOrInvalid":
    "La regla de ICMS-ST no trae la MVA (IVA-ST) original. La regla debe corregirse por propuesta.",
  "issueHelp.destinationIcmsMissingOrInvalid":
    "La regla no trae la alícuota interna del destino. La regla debe corregirse por propuesta.",
  "issueHelp.interstateIcmsInvalid":
    "La alícuota interestatal de la regla no coincide con la ruta. La regla debe revisarse.",
  "issueHelp.ipiMissingOrInvalid": "La regla no trae la alícuota de IPI de este NCM.",
  "issueHelp.takeRateMissingOrInvalid":
    "No hay tasa de intermediación configurada para esta categoría y forma de pago.",
  "issueHelp.operationalCostInvalid":
    "No hay costo operativo (logística, flete) configurado para esta categoría.",
  "issueHelp.saleLegMissingOrInvalid":
    "El precio necesita la regla de la venta (centro → cliente) y ninguna regla publicada informa el ICMS de esa ruta. Elija otro destino de venta o publique la regla.",
  "issueHelp.netMarginUnreachable":
    "Con este margen y los tributos de la venta no existe precio positivo. Reduzca el margen pedido.",

  "evidence.empty.title": "Ninguna evidencia en la cola",
  "evidence.empty.body":
    "El descubrimiento corre cada 3 horas (hora de Brasilia) y llena esta cola con documentos oficiales.",
  "evidence.empty.action": "Ver fuentes",
  "evidence.attention.lowConfidence": "Baja confianza",
  "evidence.title": "Evidencias",
  "evidence.description":
    "Documentos recolectados de fuentes oficiales. La extracción propone evidencias; nunca aprueba, publica ni calcula.",
  "evidence.tabs.label": "Área de evidencias",
  "evidence.tabs.documents": "Cola de revisión",
  "evidence.tabs.tasks": "Tareas",
  "evidence.tasks.title": "Tareas de evidencia",
  "evidence.tasks.description":
    "Organice el seguimiento de la evidencia observada. Completar una tarea no aprueba el documento ni cambia una regla publicada.",
  "evidence.tasks.agentEyebrow": "Cola del agente",
  "evidence.tasks.agentTitle": "Investigaciones fiscales en curso",
  "evidence.tasks.agentDescription":
    "Las tareas enviadas al agente de investigación quedan aquí con su estado, citas y siguiente paso de revisión.",
  "evidence.tasks.agentActive": "En curso",
  "evidence.tasks.agentReview": "En revisión",
  "evidence.tasks.agentQueue": "Tareas de investigación",
  "evidence.tasks.agentWindowHint": "Mostrando las 12 tareas fiscales más recientes.",
  "evidence.tasks.agentSearch": "Buscar por pregunta o tarea",
  "evidence.tasks.agentStatus": "Filtrar por estado",
  "evidence.tasks.agentEmpty":
    "Aún no se ha enviado ninguna investigación. Use Investigar una consulta en Documentos para crear la primera.",
  "evidence.tasks.agentSelected": "Investigación seleccionada",
  "evidence.tasks.agentCitations": "Citas",
  "evidence.tasks.agentEvidence": "En evidencia",
  "evidence.tasks.agentProvider": "Motor fiscal",
  "evidence.tasks.agentNoSummary": "El agente todavía no publicó una síntesis.",
  "evidence.tasks.agentDetailStale":
    "No se pudo actualizar el detalle; se muestra el último estado conocido.",
  "evidence.tasks.agentOpenDesk": "Abrir en la Mesa",
  "evidence.tasks.agentOpenEvidence": "Abrir evidencia",
  "evidence.tasks.results.one": "{count} tarea",
  "evidence.tasks.results.other": "{count} tareas",
  "evidence.tasks.results.many": "{count} tareas",
  "evidence.tasks.create": "Crear tarea",
  "evidence.tasks.edit": "Editar tarea",
  "evidence.tasks.titleLabel": "Título",
  "evidence.tasks.descriptionLabel": "Descripción",
  "evidence.tasks.assignee": "Responsable",
  "evidence.tasks.dueDate": "Fecha de vencimiento",
  "evidence.tasks.dueDateHint": "Fecha del calendario, sin hora.",
  "evidence.tasks.state": "Estado",
  "evidence.tasks.createdBy": "Creada por",
  "evidence.tasks.updated": "Actualizada",
  "evidence.tasks.evidence": "Abrir evidencia",
  "evidence.tasks.run": "Abrir ejecución",
  "evidence.tasks.evidenceId": "Evidencia vinculada (opcional)",
  "evidence.tasks.sourceRunId": "Ejecución vinculada (opcional)",
  "evidence.tasks.referenceHint":
    "Pegue un enlace interno o un identificador ya usado en esta organización.",
  "evidence.tasks.referenceInvalid":
    "Use un enlace interno válido o el identificador correspondiente.",
  "evidence.tasks.noReference": "Sin referencia",
  "evidence.tasks.empty": "Todavía no hay tareas de evidencia.",
  "evidence.tasks.emptyBody": "Cree una tarea para seguir una verificación manual.",
  "evidence.tasks.save": "Guardar tarea",
  "evidence.tasks.cancel": "Cancelar edición",
  "evidence.tasks.statusSaved": "Tarea guardada para esta cuenta.",
  "evidence.tasks.saving": "Guardando tarea…",
  "evidence.tasks.loadError": "No se pudieron cargar las tareas.",
  "evidence.tasks.saveError": "No se pudo guardar. Inténtelo de nuevo.",
  "evidence.tasks.retry": "Recargar e intentar de nuevo",
  "evidence.tasks.conflict": "La tarea cambió en otra sesión. Recargue para continuar.",
  "evidence.tasks.terminal": "Las tareas completadas o canceladas no se pueden reabrir.",
  "evidence.tasks.state.OPEN": "Abierta",
  "evidence.tasks.state.IN_PROGRESS": "En curso",
  "evidence.tasks.state.BLOCKED": "Bloqueada",
  "evidence.tasks.state.DONE": "Completada",
  "evidence.tasks.state.CANCELLED": "Cancelada",
  "evidence.extract.note":
    "El extractor lee el artefacto y escribe un extracto para revisión. No aprueba evidencia y no publica una regla.",
  "evidence.column.title": "Documento",
  "evidence.column.source": "Fuente",
  "evidence.column.jurisdiction": "Jurisdicción",
  "evidence.column.published": "Publicado",
  "evidence.column.fetched": "Recolectado",
  "evidence.column.confidence": "Confianza",
  "evidence.column.status": "Estado",
  "evidence.column.tags": "Etiquetas",
  "evidence.filter.status": "Estado de revisión",
  "evidence.filter.jurisdiction": "Jurisdicción",
  "evidence.filter.tag": "Etiqueta fiscal",
  "evidence.filter.search": "Título, editor o hash",
  "evidence.bulk.approve": "Aprobar seleccionados",
  "evidence.bulk.reject": "Rechazar seleccionados",
  "evidence.bulk.markDuplicate": "Marcar como duplicado",
  "evidence.bulk.cap": "El triaje masivo está limitado a {max} documentos por operación.",
  "evidence.bulk.capReached": "Límite de {max} documentos alcanzado; la selección se detuvo ahí.",
  "evidence.bulk.confirm.one": "¿Aplicar {action} a {count} documento?",
  "evidence.bulk.confirm.other": "¿Aplicar {action} a {count} documentos?",
  "evidence.bulk.done.one": "{count} documento actualizado.",
  "evidence.bulk.done.other": "{count} documentos actualizados.",
  "evidence.detail.title": "Revisión de evidencia",
  "evidence.detail.canonicalUrl": "URL canónica",
  "evidence.detail.contentHash": "Hash del contenido",
  "evidence.locator.css": "Fragmento de la página",
  "evidence.locator.pdf-page": "Página del PDF",
  "evidence.locator.document": "Documento completo",
  "evidence.locator.value.excerpt": "extracto",
  "evidence.detail.rawArtifact": "Artefacto original",
  "evidence.detail.normalizedArtifact": "Artefacto normalizado",
  "evidence.detail.noNormalized": "Aún no normalizado",
  "evidence.detail.storedDocument": "Documento almacenado",
  "evidence.detail.storedDocumentHint": "Texto preservado para revisión.",
  "evidence.detail.byteRange": "Bytes {start}–{end}",
  "evidence.detail.downloadRaw": "Descargar artefacto bruto",
  "evidence.detail.rawDownloading": "Descargando artefacto bruto…",
  "evidence.detail.rawDownloadUnavailable":
    "El artefacto bruto no está disponible para descargar ahora.",
  "evidence.detail.artifactUnavailable": "El documento almacenado no está disponible ahora.",
  "evidence.detail.locators": "Localizadores del documento",
  "evidence.detail.previousPage": "Página anterior",
  "evidence.detail.nextPage": "Página siguiente",
  "evidence.detail.decision": "Decisión de revisión",
  "evidence.detail.approve": "Aprobar evidencia",
  "evidence.detail.reject": "Rechazar",
  "evidence.detail.duplicate": "Duplicado",
  "evidence.detail.announce.APPROVED": "Evidencia aprobada",
  "evidence.detail.announce.REJECTED": "Evidencia rechazada",
  "evidence.detail.announce.DUPLICATE": "Marcada como duplicada",
  "evidence.detail.reasonHint":
    "Escriba al menos 10 caracteres. El motivo queda registrado en la auditoría.",
  "evidence.detail.reasonRequired": "Escriba al menos 10 caracteres para registrar la decisión.",
  "evidence.detail.proposeRule": "Crear propuesta de regla",
  "evidence.detail.extract": "Fragmento extraído",
  "evidence.detail.part.summary": "Parte {number} de {count} · páginas {pageFrom}–{pageTo}",
  "evidence.detail.part.link": "Parte {number} · páginas {pageFrom}–{pageTo}",
  "evidence.detail.part.html.summary": "Parte {number} de {count} · {sectionFrom} – {sectionTo}",
  "evidence.detail.part.html.link": "Parte {number} · {sectionFrom} – {sectionTo}",
  "evidence.detail.noExtract": "Aún no se ha extraído ningún fragmento de esta fuente.",
  "evidence.detail.relatedProposals": "Propuestas relacionadas",
  "evidence.catalogue.label": "Catálogo de noticias y evidencias fiscales",
  "evidence.catalogue.results": "Aproximadamente {count} documentos recolectados",
  "evidence.catalogue.hint":
    "Revise el material fuente como un catálogo editorial, sin perder los controles de gobernanza.",
  "evidence.catalogue.selectPage": "Seleccionar esta página",
  "evidence.catalogue.sort.fetchedAt": "Recolección reciente",
  "evidence.catalogue.sort.confidence": "Confianza",
  "evidence.catalogue.sort.jurisdiction": "Jurisdicción",
  "evidence.catalogue.signals": "Señales fiscales detectadas",
  "evidence.catalogue.noSignals": "Todavía no hay señales fiscales estructuradas",
  "evidence.catalogue.imageUnavailable": "Sin imagen de la fuente",
  "evidence.catalogue.proposals": "Propuestas",
  "evidence.detail.openOriginal": "Abrir original",
  "evidence.detail.opensNewTab": "se abre en una pestaña nueva",
  "evidence.detail.imageUnavailable": "La fuente no publicó una imagen",
  "evidence.detail.fiscalData": "Datos fiscales extraídos",
  "evidence.detail.detectedSignals": "Señales fiscales detectadas",
  "evidence.detail.keyFacts": "Datos clave encontrados en la fuente",
  "evidence.detail.integrity": "Integridad de la evidencia",
  "evidence.detail.technicalDetails": "Procedencia técnica",
  "evidence.detail.preserved": "Evidencia preservada",
  "evidence.detail.noProposals":
    "Todavía no se derivó ninguna propuesta de regla de esta evidencia.",
  "evidence.detail.insights": "Insights de revisión",
  "evidence.detail.reviewReadiness": "Preparación para revisión",
  "evidence.detail.taxScope": "Alcance fiscal detectado",
  "evidence.detail.taxScopeCount": "Se detectaron {count} señales fiscales estructuradas",
  "evidence.detail.ruleImpact": "Impacto en reglas",
  "evidence.detail.proposalImpact.one": "Vinculada con {count} propuesta de regla",
  "evidence.detail.proposalImpact.other": "Vinculada con {count} propuestas de regla",
  "evidence.detail.noProposalImpact": "Aún no se propuso impacto en reglas",
  "evidence.detail.noStructuredInsight": "Esperando extracción estructurada",
  "evidence.detail.insightDisclaimer":
    "Los insights resumen metadatos capturados. Nunca aprueban evidencias ni publican una regla fiscal.",
  "evidence.detail.readiness.approved": "Revisión humana completada",
  "evidence.detail.readiness.closed": "Revisión cerrada",
  "evidence.detail.readiness.unscored": "Se requiere verificación manual",
  "evidence.detail.readiness.low": "Confianza baja — verifique contra la fuente",
  "evidence.detail.readiness.medium": "Lista para revisión del analista",
  "evidence.detail.readiness.high": "Extracción de alta confianza",
  "evidence.detail.candidates.title": "Candidatos de entrada fiscal",
  "evidence.detail.candidates.description":
    "Menciones fiscales encontradas en el documento y vinculadas al fragmento original.",
  "evidence.detail.candidates.status": "CANDIDATO · no aplicado",
  "evidence.detail.candidates.empty":
    "No se identificaron datos fiscales estructurados. Compruebe el documento manualmente.",
  "evidence.detail.candidates.disclaimer":
    "Un candidato nunca cambia una regla. Apruebe la evidencia, prepare la propuesta y envíela a revisión independiente.",
  "evidence.detail.candidates.use": "Usar datos en la propuesta",
  "evidence.detail.candidates.kind.NCM": "NCM",
  "evidence.detail.candidates.kind.CEST": "CEST",
  "evidence.detail.candidates.kind.UF": "UF",
  "evidence.detail.candidates.kind.RATE": "Alícuota mencionada",

  "proposals.title": "Propuestas de regla",
  "proposals.description":
    "Todo cambio fiscal pasa por propuesta, revisión, aprobación y publicación.",
  "proposals.column.summary": "Resumen",
  "proposals.column.scope": "Alcance",
  "proposals.column.impact": "Impacto",
  "proposals.column.status": "Estado",
  "proposals.column.author": "Autor",
  "proposals.column.age": "Antigüedad",
  "proposals.detail.title": "Propuesta {id}",
  "proposals.detail.evidence": "Evidencia de respaldo",
  "proposals.detail.change": "Cambio propuesto",
  "proposals.detail.approve": "Aprobar propuesta",
  "proposals.detail.reject": "Rechazar propuesta",
  "proposals.detail.approvals": "Aprobaciones",
  "proposals.fourEyes.badge": "Aprobación",
  "proposals.fourEyes.needed": "Una aprobación registrada. El autor puede aprobar y publicar.",
  "proposals.fourEyes.youAreAuthor": "Usted es el autor",
  "proposals.fourEyes.selfBlocked": "Usted redactó esta propuesta. Puede aprobarla y publicarla.",
  "proposals.fourEyes.progress": "{approved} de {required} aprobaciones",
  "proposals.fourEyes.count.one": "{approved} de {required} aprobación",
  "proposals.fourEyes.count.other": "{approved} de {required} aprobaciones",
  "proposals.fourEyes.alreadyDecided": "Ya registró su decisión en esta propuesta.",
  "proposals.next.pendingFirst": "Espera aprobación. El autor puede aprobar.",
  "proposals.next.pendingSecond": "Espera aprobación. El autor puede aprobar.",
  "proposals.next.approved": "Aprobada. Entró en la minuta actual. El autor puede publicar.",
  "proposals.next.rejected": "Rechazada. No entra en la minuta hasta una propuesta nueva.",
  "proposals.next.published": "Publicada en este conjunto. El contenido publicado es inmutable.",
  "proposals.next.title": "Siguiente paso",
  "proposals.change.kind": "Tipo",
  "proposals.change.path": "Ruta",
  "proposals.change.before": "Antes",
  "proposals.change.after": "Después",
  "proposals.change.ADDED": "Añadido",
  "proposals.change.REMOVED": "Eliminado",
  "proposals.change.CHANGED": "Modificado",
  /* Governança — proposal detail, readable change table and decision bar (UX plan PR 5). */
  "proposals.change.field": "Campo",
  "proposals.change.rule": "Regla {id}",
  "proposals.change.item": "Cambio {index} de {total}",
  "proposals.detail.byline": "{reference} · propuesta por {author} el {created}",
  "proposals.detail.supersedes": "Sustituye la regla publicada",
  "proposals.detail.appliesTo": "Se aplica a",
  "proposals.detail.noDecisions": "Aún no hay decisiones registradas.",
  "proposals.detail.evidenceItem": "Documento {index}",
  "proposals.decision.title": "Su decisión",
  "proposals.decision.placeholder": "Ej.: Verificado en el documento oficial, art. 52 del RICMS",
  "proposals.scope.category": "Categoría: {value}",
  "proposals.scope.paymentMethod": "Pago: {value}",
  "proposals.scope.transactionType": "Transacción: {value}",
  "proposals.field.takeRate": "Tasa de intermediación",
  "proposals.field.originalMva": "MVA original",
  "proposals.field.adjustedMva": "MVA ajustada",
  "proposals.field.effectiveInternalRate": "Carga interna efectiva",
  "proposals.field.effectiveLegalReference": "Base legal de la carga efectiva",
  "proposals.field.effectiveSourceUrl": "Fuente de la carga efectiva",
  "proposals.field.effectiveValidFrom": "Carga efectiva vigente desde",
  "proposals.field.effectiveValidTo": "Carga efectiva vigente hasta",
  "proposals.field.destinationInternalIcmsRate": "Alícuota interna de ICMS en destino",
  "proposals.field.interstateIcmsRate": "Alícuota interestatal de ICMS",
  "proposals.field.ipiRate": "Alícuota de IPI",
  "proposals.field.stateBenefitBaseReductionPct": "Reducción de base (beneficio estatal)",
  "proposals.field.logistics": "Costo logístico",
  "proposals.field.freight": "Flete",
  "proposals.field.other": "Otros costos",
  "proposals.field.validFrom": "Vigencia inicial",
  "proposals.field.validTo": "Vigencia final",
  "proposals.field.treatmentOf": "Tratamiento del {tax}",
  "proposals.field.rateOf": "Alícuota de {tax}",
  "proposals.field.icmsMode": "Modalidad del ICMS",
  "proposals.field.icmsMode.ST": "Sustitución tributaria (ST)",
  "proposals.field.icmsMode.STANDARD": "ICMS propio",
  "proposals.field.tax.ipi": "IPI",
  "proposals.field.tax.icms": "ICMS",
  "proposals.field.tax.pis": "PIS",
  "proposals.field.tax.cofins": "COFINS",
  "proposals.field.tax.iss": "ISS",
  "proposals.field.treatment.TAXED": "Gravado",
  "proposals.field.treatment.EXEMPT": "Exento",
  "proposals.field.treatment.EXCLUDED": "Fuera de esta base",
  "proposals.empty.title": "Ninguna propuesta",
  "proposals.empty.body":
    "Las propuestas nacen de evidencia aprobada. Revise un documento oficial y conviértalo en un cambio gobernado.",
  "proposals.empty.action": "Abrir evidencia aprobada",
  "proposals.detail.minuta": "Minuta generada",
  "proposals.matches.title": "Comparación con reglas publicadas",
  "proposals.matches.description":
    "Consulta de solo lectura contra la versión publicada actual de esta organización.",
  "proposals.matches.publishedVersion": "Versión publicada: {version}",
  "proposals.matches.openRuleset": "Abrir conjunto publicado",
  "proposals.matches.checked.one": "Se comprobó {count} regla de esta categoría.",
  "proposals.matches.checked.other": "Se comprobaron {count} reglas de esta categoría.",
  "proposals.matches.exact": "Coincidencia exacta",
  "proposals.matches.exactHint":
    "Coinciden comportamiento, vigencia y aplicabilidad; los IDs y las evidencias quedan fuera de la comparación.",
  "proposals.matches.sameApplicability": "Misma aplicabilidad",
  "proposals.matches.sameApplicabilityHint":
    "Coinciden la ruta y la vigencia. Esto no establece un tratamiento tributario equivalente.",
  "proposals.matches.none": "No se encontraron coincidencias",
  "proposals.matches.noneHint": "Ninguna regla publicada de esta categoría tiene la misma huella.",
  "proposals.matches.noBase": "No hay una base publicada disponible",
  "proposals.matches.noBaseHint": "El aviso estará disponible cuando exista una versión publicada.",
  "proposals.matches.truncated":
    "La lista muestra las primeras {count} coincidencias; hay más coincidencias en esta categoría.",
  "proposalPlan.action": "Importar plan",
  "proposalPlan.title": "Importar plan de propuestas",
  "proposalPlan.description":
    "Cargue un plan revisado (JSON), confirme la simulación contra el conjunto vigente y cree propuestas pendientes de revisión. Nada se aprueba ni se publica.",
  "proposalPlan.noAccess":
    "Importar planes exige el permiso para crear propuestas. Pida acceso a quien administra la plataforma.",
  "proposalPlan.steps.label": "Etapas de la importación",
  "proposalPlan.step.file": "Archivo",
  "proposalPlan.step.review": "Simulación",
  "proposalPlan.step.result": "Resultado",
  "proposalPlan.file.title": "Plan",
  "proposalPlan.file.drop": "Suelte el plan aquí o elija el archivo",
  "proposalPlan.file.dropActive": "Suelte para cargar el plan",
  "proposalPlan.file.hint":
    "Archivo JSON generado por el script de plan, que solo lee y no crea nada. Hasta {size}.",
  "proposalPlan.file.pick": "Elegir archivo",
  "proposalPlan.file.replace": "Cambiar archivo",
  "proposalPlan.file.sample": "Usar plan de ejemplo",
  "proposalPlan.file.sampleHint":
    "Modo demostración: un plan generado a partir de los datos de ejemplo.",
  "proposalPlan.file.reading": "Leyendo el archivo…",
  "proposalPlan.file.problem.EMPTY": "El archivo está vacío.",
  "proposalPlan.file.problem.TOO_LARGE": "El archivo es demasiado grande para importar.",
  "proposalPlan.file.problem.NOT_JSON": "El archivo no es un JSON válido.",
  "proposalPlan.file.problem.NOT_A_PLAN":
    "El archivo no es un plan de propuestas: falta el campo kind.",
  "proposalPlan.file.problem.UNSUPPORTED_KIND": "Esta versión no importa planes del tipo {kind}.",
  "proposalPlan.file.problem.INVALID_PLAN": "El plan no sigue el formato esperado.",
  "proposalPlan.kind.effective-burden-proposal-plan": "Carga efectiva del ICMS-ST",
  "proposalPlan.plan.kind": "Tipo",
  "proposalPlan.plan.source": "Generado a partir de",
  "proposalPlan.plan.destination": "UF de destino",
  "proposalPlan.plan.segments": "Segmentos CEST",
  "proposalPlan.plan.burden": "Carga efectiva",
  "proposalPlan.plan.basis": "Base legal",
  "proposalPlan.plan.validUntil": "Vigente hasta",
  "proposalPlan.items.count.one": "{count} ítem",
  "proposalPlan.items.count.other": "{count} ítems",
  "proposalPlan.plan.items": "Ítems del plan",
  "proposalPlan.plan.skipped": "{count} reglas dejadas fuera por el generador",
  "proposalPlan.plan.note": "Nota del plan",
  "proposalPlan.export.action": "Exportar conjunto activo",
  "proposalPlan.export.exporting": "Exportando…",
  "proposalPlan.export.hint":
    "Descarga el contenido del conjunto de reglas vigente (solo lectura) para generar el plan con el script a partir del conjunto real.",
  "proposalPlan.evidence.pickTitle": "Elegir evidencia aprobada",
  "proposalPlan.evidenceSource.ACTIVE_RULE": "evidencia heredada de la regla activa",
  "proposalPlan.evidenceSource.ADDITIONAL_ONLY": "solo la evidencia adicional aprobada",
  "proposalPlan.evidenceSource.PLAN": "evidencia del plan",
  "proposalPlan.evidence.title": "Evidencia adicional (opcional)",
  "proposalPlan.evidence.body":
    "La evidencia de cada regla cubre el MVA, no la carga efectiva. Pegue los IDs de las evidencias aprobadas (por ejemplo RICMS/SP art. 39 y DN CAT 8/2015) para adjuntarlas a todas las propuestas creadas.",
  "proposalPlan.evidence.label": "IDs de las evidencias",
  "proposalPlan.evidence.placeholder": "Un ID por línea, o separados por coma",
  "proposalPlan.evidence.browse": "Ver evidencias aprobadas",
  "proposalPlan.evidence.count.one": "{count} evidencia para adjuntar",
  "proposalPlan.evidence.count.other": "{count} evidencias para adjuntar",
  "proposalPlan.evidence.invalid": "No es un ID de evidencia: {ids}",
  "proposalPlan.evidence.tooMany": "Máximo {max} evidencias por importación.",
  "proposalPlan.note.label": "Nota para quien va a revisar (opcional)",
  "proposalPlan.note.hint": "Entra al comienzo del motivo de cada propuesta creada.",
  "proposalPlan.note.short": "Escriba al menos 10 caracteres o déjelo en blanco.",
  "proposalPlan.validate": "Simular importación",
  "proposalPlan.validating": "Simulando…",
  "proposalPlan.review.title": "Simulación contra el conjunto vigente",
  "proposalPlan.review.hint":
    "Conjunto {version}. No se creó nada: revise cada ítem antes de confirmar.",
  "proposalPlan.review.back": "Cambiar plan",
  "proposalPlan.review.refresh": "Simular de nuevo",
  "proposalPlan.review.empty": "El plan no tiene ítems.",
  "proposalPlan.filter.legend": "Filtrar por situación",
  "proposalPlan.filter.all": "Todas",
  "proposalPlan.table.caption": "Ítems del plan y situación de cada uno",
  "proposalPlan.table.rule": "Regla",
  "proposalPlan.table.route": "Ruta",
  "proposalPlan.table.key": "NCM / CEST",
  "proposalPlan.table.change": "Cambio",
  "proposalPlan.table.status": "Situación",
  "proposalPlan.change.effective": "carga efectiva {rate} — {article}",
  "proposalPlan.change.effectiveNoArticle": "carga efectiva {rate}",
  "proposalPlan.change.until": "hasta {date}",
  "proposalPlan.change.source": "Abrir la fuente oficial",
  "proposalPlan.tally.NEW": "Nuevas",
  "proposalPlan.tally.CREATED": "Creadas",
  "proposalPlan.tally.DUPLICATE": "Duplicadas",
  "proposalPlan.tally.STALE": "Obsoletas",
  "proposalPlan.tally.INVALID": "Inválidas",
  "proposalPlan.status.NEW": "Nueva",
  "proposalPlan.status.CREATED": "Creada",
  "proposalPlan.status.DUPLICATE": "Duplicada",
  "proposalPlan.status.STALE": "Obsoleta",
  "proposalPlan.status.INVALID": "Inválida",
  "proposalPlan.status.help.NEW": "Se creará como propuesta pendiente de revisión.",
  "proposalPlan.status.help.CREATED": "Creada en esta importación, pendiente de revisión.",
  "proposalPlan.status.help.DUPLICATE":
    "Este ítem de este plan ya fue importado: no se creará nada.",
  "proposalPlan.status.help.STALE": "La regla vigente no es la que el plan supuso: no se creará.",
  "proposalPlan.status.help.INVALID": "No puede ser propuesta: vea el motivo.",
  "proposalPlan.reason.RULE_NOT_FOUND": "La regla ya no está en el conjunto vigente.",
  "proposalPlan.reason.RULE_CHANGED": "La regla vigente cambió desde que se generó el plan.",
  "proposalPlan.reason.ALREADY_STATED": "La regla vigente ya declara la carga efectiva.",
  "proposalPlan.reason.EVIDENCE_REJECTED":
    "Evidencia no aprobada o distinta del registro aprobado.",
  "proposalPlan.reason.POLICY_VIOLATION": "La regla no cumple la política exigida.",
  "proposalPlan.reason.changedFields": "Campos distintos: {fields}",
  "proposalPlan.reason.alreadyImported": "Ya importada",
  "proposalPlan.proposal.open": "Abrir propuesta",
  "proposalPlan.confirm.action.one": "Crear {count} propuesta",
  "proposalPlan.confirm.action.other": "Crear {count} propuestas",
  "proposalPlan.confirm.none": "Ningún ítem nuevo para crear.",
  "proposalPlan.confirm.title": "¿Crear propuestas a partir del plan?",
  "proposalPlan.confirm.body.one":
    "Se creará {count} propuesta pendiente de revisión. Necesita la aprobación de otra persona; esta importación no aprueba ni publica nada.",
  "proposalPlan.confirm.body.other":
    "Se crearán {count} propuestas pendientes de revisión. Cada una necesita la aprobación de otra persona; esta importación no aprueba ni publica nada.",
  "proposalPlan.confirm.skipped":
    "Quedan fuera: {stale} obsoletas, {invalid} inválidas y {duplicate} duplicadas.",
  "proposalPlan.confirm.evidence": "Evidencia adicional adjuntada a cada propuesta: {count}.",
  "proposalPlan.confirm.cancel": "Cancelar",
  "proposalPlan.confirm.submit": "Crear propuestas",
  "proposalPlan.confirm.creating": "Creando…",
  "proposalPlan.result.title": "Propuestas creadas",
  "proposalPlan.result.created.one": "{count} propuesta creada, pendiente de revisión.",
  "proposalPlan.result.created.other": "{count} propuestas creadas, pendientes de revisión.",
  "proposalPlan.result.none":
    "Ninguna propuesta nueva: todo en este plan ya se había importado o ya no aplica.",
  "proposalPlan.result.skipped":
    "No creadas: {stale} obsoletas, {invalid} inválidas y {duplicate} duplicadas.",
  "proposalPlan.result.review": "Revisar propuestas pendientes",
  "proposalPlan.result.another": "Importar otro plan",
  "proposalPlan.next.title": "Próximo paso: usar la política {policy} en el borrador",
  "proposalPlan.next.switchBody":
    "Estas propuestas solo pueden publicarse con la política {policy}, que usa la carga efectiva como ALQ intra en el ajuste del MVA. El borrador {version} está en la política {current}; cambiarla no altera cálculos anteriores.",
  "proposalPlan.next.switchAction": "Abrir el borrador y cambiar la política",
  "proposalPlan.next.readyBody":
    "El borrador {version} ya usa la política {policy}. Cuando se aprueben las propuestas, prepare el borrador para incluirlas y publique por el flujo normal.",
  "proposalPlan.next.readyAction": "Abrir el borrador",
  "proposalPlan.next.prepareBody":
    "Todavía no hay borrador. En Publicaciones, prepare el próximo borrador: la política {policy} viene seleccionada.",
  "proposalPlan.next.prepareAction": "Ir a Publicaciones",
  "rulesets.policy.suggested":
    "El plan importado pide la política {policy}. Ya está seleccionada: escriba el motivo y guarde.",
  "proposals.create.title": "Crear propuesta de regla",
  "proposals.create.description":
    "Convierte evidencia aprobada en un cambio gobernado. Crear la propuesta no publica la regla.",
  "proposals.create.evidence": "Evidencia vinculada: {title}",
  "proposals.create.operation": "Tipo de cambio",
  "proposals.create.operation.upsert": "Agregar una regla nueva",
  "proposals.create.operation.supersede": "Reemplazar una regla existente",
  "proposals.create.supersedesRuleId": "ID de la regla existente",
  "proposals.create.supersedesRuleIdHint": "Copie el ID del detalle de la regla publicada.",
  "proposals.create.ruleType": "Tipo de regla",
  "proposals.create.ruleJson": "Regla propuesta (JSON)",
  "proposals.create.ruleJsonHint":
    "La plataforma agregará automáticamente la procedencia inmutable de la evidencia.",
  "proposals.create.validation": "Complete o corrija el campo: {issue}",
  "proposals.create.reasonHint":
    "Explique el cambio en al menos 10 caracteres. El motivo se registra en auditoría.",
  "proposals.create.submit": "Crear propuesta",
  "proposals.create.created": "{reference} fue creada y enviada a revisión.",
  "proposals.create.requiresApprovedEvidence":
    "La evidencia debe estar aprobada antes de originar una propuesta.",
  "proposals.create.ncm": "NCM",
  "proposals.create.ncmHint":
    "Ocho dígitos ya rotulados en la evidencia. No invente clasificación.",
  "proposals.create.cest": "CEST",
  "proposals.create.unconfirmed": "Por confirmar en la fuente",
  "proposals.create.treatmentHint":
    "Confirme si hay tributación, exención o exclusión. La falta de información no es exclusión.",
  "proposals.create.verifySource":
    "Verifique la fila de la fuente antes de crear la propuesta. Las menciones del documento no confirman la alícuota, la ruta ni la vigencia de este NCM.",
  "proposals.create.validFromHint":
    "Use la vigencia indicada en el acto. La fecha de publicación o captura no confirma el inicio de la regla.",
  "proposals.create.validFrom": "Vigencia inicial",
  "proposals.create.validTo": "Vigencia final",
  "proposals.create.originUf": "UF de origen",
  "proposals.create.destinationUf": "UF de destino",
  "proposals.create.treatment": "Tratamiento",
  "proposals.create.taxed": "Gravado",
  "proposals.create.exempt": "Exento",
  "proposals.create.excluded": "Fuera de esta evidencia",
  "proposals.create.rate": "Alícuota oficial",
  "proposals.create.rateHint":
    "Copie el valor de la evidencia. Use 0–1 o porcentaje hasta 100. El campo vacío no inventa alícuota.",
  "proposals.create.componentReason": "Motivo del tratamiento",
  "proposals.create.ipi": "IPI / TIPI",
  "proposals.create.icms": "ICMS",
  "proposals.create.mode": "Modalidad",
  "proposals.create.mode.standard": "Estándar",
  "proposals.create.mode.st": "Sustitución (ST)",
  "proposals.create.interstate": "Alícuota interestadual",
  "proposals.create.internal": "Alícuota interna de destino",
  "proposals.create.mva": "MVA original (%)",
  "proposals.create.mvaHint":
    "Introduzca el porcentaje de la evidencia: 125 significa 125%. Puede superar el 100%.",
  "proposals.create.effective.title": "Carga efectiva (opcional)",
  "proposals.create.effective.hint":
    "Solo para el ajuste de la MVA (tax-family-v2): la alícuota interna efectiva del sustituto en el destino, por ejemplo 12% para alimentos (RICMS/SP, Anexo II, art. 39). El débito de la ST mantiene la alícuota interna nominal. Sin ella, el motor usa la alícuota nominal y lo advierte en el cálculo.",
  "proposals.create.effective.rate": "Alícuota interna efectiva",
  "proposals.create.effective.basis": "Base legal de la carga efectiva",
  "proposals.create.effective.basisPlaceholder": "Ej.: RICMS/SP, Anexo II, art. 39; DN CAT 8/2015",
  "proposals.create.effective.url": "Enlace de la fuente (opcional)",
  "proposals.create.effective.validFrom": "Carga efectiva: inicio de vigencia (opcional)",
  "proposals.create.effective.validTo": "Carga efectiva: fin de vigencia (opcional)",
  "proposals.create.effective.validToHint":
    "Después de esta fecha el motor vuelve a la alícuota nominal y lo advierte en el cálculo.",
  "proposals.create.locked":
    "PIS, COFINS e ISS quedan fuera de esta base. Este formulario no publica alícuota para esas familias.",
  "proposals.create.advanced": "JSON avanzado",

  "rulesets.title": "Conjuntos de reglas",
  "rulesets.description":
    "Los conjuntos publicados son inmutables y tienen hash de contenido. Cada cálculo fija una versión exacta.",
  "rulesets.column.version": "Versión",
  "rulesets.column.status": "Estado",
  "rulesets.column.digest": "Hash",
  "rulesets.column.rules": "Reglas",
  "rulesets.column.published": "Publicado",
  "rulesets.column.publishedBy": "Publicado por",
  "rulesets.immutable": "Inmutable",
  "rulesets.immutable.hint":
    "Publicado y con hash de contenido. No puede editarse, solo sucederse o revertirse.",
  "rulesets.active": "Activo",
  "rulesets.compare": "Comparar",
  "rulesets.compare.mode": "Comparar dos versiones",
  "rulesets.diff.title": "Diferencias de {from} a {to}",
  "rulesets.diff.added": "agregado",
  "rulesets.diff.removed": "eliminado",
  "rulesets.diff.changed": "modificado",
  "rulesets.diff.summary": "{added} agregadas, {removed} eliminadas, {changed} modificadas",
  "rulesets.diff.none": "No hay diferencias entre las versiones elegidas.",
  "fieldDiff.kind.added": "Añadido",
  "fieldDiff.kind.changed": "Modificado",
  "fieldDiff.kind.removed": "Eliminado",
  "fieldDiff.kind.unchanged": "Sin cambios",
  "fieldDiff.col.field": "Campo",
  "fieldDiff.col.change": "Cambio",
  "fieldDiff.col.before": "Antes",
  "fieldDiff.col.after": "Después",
  "fieldDiff.count.added.one": "{count} añadido",
  "fieldDiff.count.added.other": "{count} añadidos",
  "fieldDiff.count.changed.one": "{count} modificado",
  "fieldDiff.count.changed.other": "{count} modificados",
  "fieldDiff.count.removed.one": "{count} eliminado",
  "fieldDiff.count.removed.other": "{count} eliminados",
  "fieldDiff.unchanged.one": "{count} campo sin cambios",
  "fieldDiff.unchanged.other": "{count} campos sin cambios",
  "fieldDiff.unknownField": "Campo no mapeado",
  "fieldDiff.unknownField.hint":
    "Se muestra tal como está guardado; este campo aún no tiene etiqueta.",
  "fieldDiff.unit": "Unidad: {unit}",
  "fieldDiff.technical": "Detalles técnicos",
  "fieldDiff.technical.path": "Ruta guardada",
  "fieldDiff.validity": "Vigencia",
  "fieldDiff.validity.none": "No informada",
  "fieldDiff.evidence": "Evidencia",
  "fieldDiff.evidence.none": "Sin evidencia vinculada",
  "fieldDiff.route": "Ruta",
  "fieldDiff.empty": "Ningún campo cambió.",
  "fieldDiff.error": "No se pudo cargar esta versión.",
  "auditTimeline.actor.human": "Persona",
  "auditTimeline.actor.machine": "Sistema",
  "auditTimeline.group": "Decisión en grupo · {count}",
  "auditTimeline.tz": "BRT",
  "auditTimeline.tz.title": "Hora de Brasilia (UTC−3)",
  "auditTimeline.empty": "Aún no hay eventos registrados.",
  "auditTimeline.partial": "Mostrando {shown} de {total}",
  "auditTimeline.error": "No se pudo cargar el historial.",
  "auditTimeline.technical": "Detalles técnicos",
  "auditTimeline.current": "Este evento",
  "auditTimeline.summary.one": "{count} evento",
  "auditTimeline.summary.other": "{count} eventos",
  "auditTimeline.summary.success.one": "{count} completado",
  "auditTimeline.summary.success.other": "{count} completados",
  "auditTimeline.summary.rejection.one": "{count} rechazado",
  "auditTimeline.summary.rejection.other": "{count} rechazados",
  "audit.detail.history": "Historial de este recurso",
  "audit.detail.change": "Cambio registrado",
  "audit.detail.change.hint": "Campos de la propuesta {reference}, tal como están guardados ahora.",
  "audit.detail.change.none":
    "Este evento no registra valores antes y después. Abra el recurso para ver el estado actual.",
  "audit.detail.change.missing": "No se encontró la propuesta {reference}.",
  "proposals.detail.history": "Historial",
  "trust.OFFICIAL_SOURCE": "Fuente oficial",
  "trust.OFFICIAL_SOURCE.off": "Fuente fuera del catálogo",
  "trust.OFFICIAL_SOURCE.meaning":
    "Solo acredita la procedencia: la fuente está en el catálogo revisado de fuentes oficiales. No aprueba el contenido.",
  "trust.OFFICIAL_SOURCE.offMeaning":
    "El host citado no corresponde a ninguna fuente del catálogo revisado.",
  "trust.OFFICIAL_SOURCE.basis": "Catálogo de fuentes · {source}",
  "trust.VERIFIED": "Verificado",
  "trust.VERIFIED.off": "Sin revisión humana",
  "trust.VERIFIED.meaning": "Una persona revisora confirmó este hecho.",
  "trust.VERIFIED.offMeaning": "Ninguna persona confirmó este hecho todavía.",
  "trust.VERIFIED.basis": "Revisión humana",
  "trust.PUBLISHED_RULE": "Regla publicada",
  "trust.PUBLISHED_RULE.off": "Regla fuera de vigencia",
  "trust.PUBLISHED_RULE.meaning":
    "La regla está en un conjunto publicado; es lo que usa el cálculo.",
  "trust.PUBLISHED_RULE.offMeaning": "La regla se publicó, pero la vigencia terminó.",
  "trust.PUBLISHED_RULE.basis": "Conjunto publicado · {version}",
  "trust.tip.captured": "Capturado el {date}",
  "trust.tip.verifiedAt": "Confirmado el {date}",
  "trust.tip.citation": "Cita",
  "trust.tip.citation.available": "Disponible · {host}",
  "trust.tip.citation.absent": "Sin cita",
  "trust.tip.validity": "Vigencia",
  "trust.tip.current": "vigente",
  "trust.tip.expired": "vencida",
  "trust.tip.basis": "Base",
  "ruleDiff.field.legacyMva": "MVA ajustado (legado)",
  "ruleDiff.field.reasonOf": "Justificación ({tax})",
  "ruleDiff.field.evidence": "Evidencias",
  "ruleDiff.value.documents.one": "{count} documento",
  "ruleDiff.value.documents.other": "{count} documentos",
  "ruleDiff.change.removed": "Eliminada",
  "ruleDiff.count.added.one": "{count} nueva",
  "ruleDiff.count.added.other": "{count} nuevas",
  "ruleDiff.count.changed.one": "{count} modificada",
  "ruleDiff.count.changed.other": "{count} modificadas",
  "ruleDiff.count.removed.one": "{count} eliminada",
  "ruleDiff.count.removed.other": "{count} eliminadas",
  "ruleDiff.listLabel": "Reglas que cambiaron",
  "ruleDiff.allRoutes": "Todas las rutas",
  "ruleDiff.anyUf": "Cualquier UF",
  "ruleDiff.anyNcm": "Cualquier NCM",
  "ruleDiff.family.operational": "Costo operativo",
  "ruleDiff.family.commercial": "Tarifa comercial",
  "ruleDiff.scope.category": "Categoría {value}",
  "ruleDiff.scope.paymentMethod": "Pago {value}",
  "ruleDiff.scope.transactionType": "Transacción {value}",
  "ruleDiff.openRule": "Abrir regla",
  "ruleDiff.more.one": "Mostrar {count} regla más",
  "ruleDiff.more.other": "Mostrar {count} reglas más",
  "ruleDiff.other.title": "Otros cambios",
  "ruleDiff.noRuleChanges": "Ninguna regla cambió entre las versiones. Vea la diferencia técnica.",
  "ruleDiff.technical.show": "Ver diferencia técnica",
  "ruleDiff.technical.hide": "Ocultar diferencia técnica",
  "ruleDiff.technical.title": "Diferencia técnica",
  "ruleDiff.technical.hint":
    "Líneas originales del conjunto, tal como se guardaron, para auditoría.",
  "rulesets.publish": "Publicar",
  "rulesets.publish.title": "Publicar conjunto de reglas",
  "rulesets.publish.step.review": "Revisar diferencias",
  "rulesets.publish.step.impact": "Confirmar impacto",
  "rulesets.publish.step.confirm": "Confirmar publicación",
  "rulesets.publish.confirmHint": "Escriba {version} para confirmar la publicación.",
  "rulesets.publish.effect":
    "Desde la publicación, los cálculos nuevos usan esta versión. Los cálculos existentes conservan su versión fijada.",
  "rulesets.rollback": "Revertir",
  "rulesets.rollback.title": "Revertir a {version}",
  "rulesets.rollback.step.select": "Elegir versión objetivo",
  "rulesets.rollback.step.review": "Revisar diferencias",
  "rulesets.rollback.step.confirm": "Confirmar reversión",
  "rulesets.rollback.effect":
    "La reversión no borra nada: vuelve a publicar el contenido de la versión objetivo como una versión nueva.",
  "rulesets.rollback.confirmHint": "Escriba {version} para confirmar la reversión.",
  "rulesets.staleBase": "La base de este borrador está desactualizada frente al conjunto activo.",
  "rulesets.publish.onlyDraft": "Solo la minuta puede publicarse.",
  "rulesets.publish.needsProposal": "La minuta necesita al menos una propuesta aprobada.",
  "rulesets.publish.publisherConflict": "La minuta necesita al menos una propuesta aprobada.",
  "rulesets.publish.segregation":
    "La publicación queda registrada en la auditoría. El autor puede publicar.",
  "rulesets.publish.included": "Propuestas incluidas",
  "rulesets.publish.includedMore": "y {count} más",
  "rulesets.rollback.onlyPublished":
    "Solo versiones publicadas o sustituidas pueden ser objetivo de reversión.",
  "rulesets.rollback.target": "Objetivo: {version}",
  "rulesets.empty.title": "Ningún conjunto de reglas",
  "rulesets.empty.body": "La minuta se genera automáticamente cuando una propuesta es aprobada.",
  "rulesets.empty.action": "Abrir propuestas en revisión",
  "rulesets.column.basedOn": "Base",
  "rulesets.column.supersededBy": "Sustituido por",
  "rulesets.included.author": "Autor",
  "rulesets.included.reviewers": "Revisores",

  "rules.title": "Reglas",
  "rules.description": "Consulta de las reglas vigentes por ruta (origen → destino), NCM y tipo.",
  "rules.browse.title": "Buscar reglas publicadas",
  "rules.browse.hint":
    "Busque reglas publicadas por NCM, origen o destino. Cada filtro es opcional.",
  "rules.browse.prompt":
    "Filtre las reglas publicadas de abajo. Abra un resultado para ver su alcance y evidencia.",
  "rules.browse.ncm": "NCM",
  "rules.browse.ncmPlaceholder": "Ej.: 2106.90.90",
  "rules.route.choose": "Elegir UF",
  "rules.route.swap": "Invertir origen y destino",
  "rules.route.applied": "{origin} → {destination} · {count} reglas publicadas en esta ruta",
  "rules.routes.priority": "Rutas prioritarias",
  "rules.catalogs": "Catálogos Siscomex y CEST",
  "rules.sources.title": "Fuentes de esta ruta",
  "rules.sources.hint":
    "Fuentes oficiales ya ligadas al origen, al destino o a la Unión. Sin fuente, no se inventa alícuota.",
  "rules.sources.empty": "Ninguna fuente de esta ruta está en la allow-list.",
  "rules.sources.search": "Buscar esta ruta en Mesa",
  "rules.sources.open": "Abrir fuentes",
  "rules.sources.unwatched":
    "{origin} o {destination} aún no está en la watchlist de SEFAZ. La recolección periódica no cubre esa punta.",
  "rules.empty.route.title": "Ninguna regla publicada en {origin} → {destination}",
  "rules.empty.route.body":
    "La ruta está elegida. Sin alícuota en este conjunto, no se inventan ICMS, ST ni MVA.",
  "rules.lookup.cest.title": "CEST {cest}",
  "rules.lookup.cest.segment": "Segmento",
  "rules.lookup.cest.ncm": "Prefijos NCM/SH",
  "rules.chapters.label": "Capítulos SH",
  "rules.chapters.note":
    "Capítulos SH de dos dígitos con el título oficial. Abra un capítulo para ver las reglas publicadas. No son alícuota ni conjunto publicado.",
  "rules.chapterDetail.eyebrow": "Capítulo SH",
  "rules.chapterDetail.honesty":
    "Este capítulo es clasificación Siscomex. No es alícuota ni conjunto publicado.",
  "rules.chapterDetail.notFound": "Este capítulo SH no existe.",
  "rules.chapterDetail.notFound.body":
    "Los capítulos oficiales van de 01 a 97. Vuelva a la lista de reglas.",
  "rules.chapterDetail.published": "Reglas publicadas en este capítulo",
  "rules.chapterDetail.empty.title": "Ninguna regla publicada en este capítulo",
  "rules.chapterDetail.empty.body":
    "El catálogo clasifica el capítulo. Sin ruleset con este prefijo NCM, no se inventa alícuota.",
  "rules.chapterDetail.seeAll": "Ver todas en la lista de reglas",
  "rules.chapterDetail.section": "Sección {section}",
  "rules.chapterDetail.section.label": "Sección SH",
  "rules.chapterDetail.prefix": "Prefijo NCM",
  "rules.chapterDetail.prefix.hint": "Ocho dígitos. Solo los dos primeros están cerrados.",
  "rules.chapterDetail.published.hint": "En este conjunto publicado. No es el catálogo.",
  "rules.chapterDetail.catalog.asOf": "Classif el {asOf}: {catalog} códigos. No es alícuota.",
  "rules.chapterDetail.structure": "Estructura",
  "rules.chapterDetail.structure.chapter": "Capítulo",
  "rules.chapterDetail.structure.heading": "Partida",
  "rules.chapterDetail.structure.subheading": "Subpartida",
  "rules.chapterDetail.structure.mercosur": "Mercosur",
  "rules.chapterDetail.structure.hint":
    "Recorte didáctico. El texto legal vigente está en Classif; esto no clasifica un producto.",
  "rules.chapterDetail.classification": "Clasificación",
  "rules.chapterDetail.titles": "Títulos oficiales",
  "rules.chapterDetail.sources": "Fuentes oficiales",
  "rules.chapterDetail.openClassif": "Abrir Classif",
  "rules.chapterDetail.openNesh": "Abrir NESH",
  "rules.chapterDetail.openHub": "Hub de clasificación",
  "rules.chapterDetail.neighbors": "Capítulos vecinos",
  "rules.chapterDetail.previous": "Capítulo anterior, SH {chapter}",
  "rules.chapterDetail.next": "Capítulo siguiente, SH {chapter}",
  "rules.chapterDetail.illustration.alt":
    "Ilustración cívica de {title}. No es foto oficial ni alícuota.",
  "rules.chapterDetail.illustration.generated":
    "Ilustración Vertex del capítulo. No es foto oficial ni alícuota.",
  "rules.chapterDetail.illustration.paper":
    "Papel cívico. Aún no hay ilustración de este capítulo.",
  "rules.empty.noRuleset.title": "Ninguna regla publicada",
  "rules.empty.published.title": "Ninguna regla fiscal en este conjunto",
  "rules.empty.published.body":
    "El conjunto publicado no tiene reglas de este tipo. El catálogo Siscomex sigue siendo clasificación, no alícuota.",
  "rules.lookup.title": "Consulta {ncm}",
  "rules.lookup.catalog": "Catálogo Siscomex",
  "rules.lookup.published": "Reglas publicadas en este NCM",
  "rules.lookup.associated": "Reglas asociadas",
  "rules.ncm.all": "Todas las reglas de {ncm}",
  "rules.lookup.proposals": "Propuestas",
  "rules.lookup.evidence": "Evidencia",
  "rules.lookup.state.reference": "referencia (no es alícuota)",
  "rules.lookup.state.absent": "ausente",
  "rules.lookup.catalogMiss":
    "Este NCM de 8 dígitos no está en el catálogo Siscomex de esta organización.",
  "rules.lookup.honesty":
    "PIS y COFINS quedan fuera de esta base. ISS municipal no entra en esta operación. Sin ruleset publicado, no se inventan ST, ICMS ni MVA.",
  "rules.lookup.openEvidence": "Abrir evidencia de este NCM",
  "rules.lookup.openProposals": "Abrir propuestas de este NCM",
  "rules.column.kind": "Tipo",
  "rules.column.ncm": "NCM",
  "rules.chapter": "Capítulo {chapter}",
  "rules.chapter.short": "SH {chapter}",
  "rules.column.route": "Ruta",
  "rules.column.rate": "Alícuota",
  "rules.column.value": "Valor",
  "rules.column.validity": "Vigencia",
  "rules.column.reference": "Referencia legal",
  "rules.filter.kind": "Tipo de regla",
  "rules.filter.ncm": "NCM",
  "rules.filter.originUf": "UF de origen",
  "rules.filter.destinationUf": "UF de destino",
  "rules.filter.asOf": "Vigente el",
  "rules.filter.asOf.applied": "Vigente el {date}",
  "rules.filter.uf": "UF",
  "rules.validFrom": "Vigente desde {date}",
  "rules.validTo": "hasta {date}",
  "rules.openEnded": "sin término final",
  "rules.kind.FISCAL": "Fiscal",
  "rules.kind.OPERATIONAL_COST": "Costo operacional",
  "rules.kind.COMMERCIAL_FEE": "Tarifa comercial",
  "rules.route.any": "todas",
  "rules.activeRuleset": "Conjunto {version}, publicado el {date}",
  "rules.provenance": "Procedencia",
  "rules.provenance.legacyCommercialFee":
    "Tasa de intermediación de la calculadora anterior (base 100)",
  "rules.provenance.retailCommercialFee": "Tarifa comercial minorista (base 100)",
  "rules.provenance.global": "global",
  "rules.empty.noRuleset.body": "Las reglas vigentes aparecen después de publicar una minuta.",
  "rules.empty.noRuleset.action": "Abrir conjuntos de reglas",
  "rules.detail.technicalId": "Identificador técnico",
  "rules.detail.title": "Detalle de la regla",
  "rules.detail.honesty":
    "La alícuota de abajo es la figura publicada en este conjunto. El catálogo Siscomex clasifica; no calcula.",
  "rules.detail.notFound": "Esta regla no está en el conjunto publicado.",
  "rules.detail.notFound.body":
    "El detalle solo muestra el registro vigente. Vuelva a la lista o abra el conjunto publicado.",
  "rules.detail.openRuleset": "Abrir conjunto {version}",
  "rules.detail.cest": "CEST",
  "rules.related.scope":
    "Reglas vinculadas al NCM {ncm} en la versión {version}, para todos los trayectos y vigencias. Una regla relacionada no es necesariamente aplicable a su operación.",
  "rules.related.current": "Regla actual",
  "rules.detail.siblings": "Otras reglas de este NCM",
  "record.id": "Id",
  "record.backToList": "Volver a la lista",
  "listing.figure.gazette": "Ilustración de un boletín oficial en papel",
  "listing.figure.ledger": "Ilustración de un registro cívico abierto",
  "listing.figure.portal": "Ilustración de un portal cívico",

  "calculations.empty.action": "Ver conjuntos de reglas",
  "calculations.title": "Auditoría de cálculos",
  "calculations.description":
    "Cada cálculo registra la versión exacta del conjunto de reglas, el hash de la solicitud y las inconsistencias detectadas.",
  "calculations.playground.eyebrow": "Ensayo",
  "calculations.playground.title": "Cómo un lote entra en el cálculo",
  "calculations.playground.body":
    "El lote vive en el marketplace. Aquí entra solo el snapshot fiscal: NCM, ruta, fecha y valor de entrada. No es la base de lotes de producción.",
  "calculations.playground.honesty":
    "Cambiar el lote en el marketplace no altera la regla. Un nuevo CALCULATE contra un conjunto publicado genera otro recibo. Sin conjunto publicado, no hay cálculo honesto.",
  "calculations.playground.openRules": "Ver reglas que coinciden con este snapshot",
  "calculations.playground.matching": "Reglas publicadas para este NCM",
  "calculations.playground.noRules":
    "Ninguna regla publicada para este NCM. El catálogo clasifica; el conjunto publicado es el que calcula.",
  "calculations.playground.noRuleset":
    "No hay conjunto publicado. El ensayo muestra clasificación y ruta; no inventa alícuota.",
  "calculations.playground.ncm": "NCM",
  "calculations.playground.route": "Ruta",
  "calculations.playground.cest": "CEST",
  "calculations.playground.date": "Fecha del cálculo",
  "calculations.playground.value": "Valor de entrada",
  "calculations.playground.quantity": "Cantidad",
  "calculations.playground.emptyCest": "sin CEST en este snapshot",
  "calculations.playground.snapshot.stationery": "Papelería SP → RJ",
  "calculations.playground.snapshot.machinery": "Máquinas MG → SP",
  "calculations.playground.snapshot.beverages": "Bebidas RS → SC",
  "calculations.column.ruleset": "Conjunto",
  "calculations.column.items": "Ítems",
  "calculations.column.review": "Revisión",
  "calculations.column.workflow": "Flujo",
  "calculations.column.itemId": "Ítem",
  "calculations.column.baseCost": "Costo base",
  "calculations.column.ipi": "IPI",
  "calculations.column.icmsSt": "ICMS (ST o propio)",
  "calculations.column.landedUnitCost": "Costo unitario puesto",
  "calculations.column.issues": "Inconsistencias",
  "calculations.filter.issue": "Código de inconsistencia",
  "calculations.detail.title": "Cálculo {id}",
  "calculations.detail.replayed": "Respuesta reproducida por idempotencia",
  "calculations.detail.engine": "Motor",
  "calculations.detail.pinned": "Versión fijada",
  "calculations.detail.items": "Ítems",
  "calculations.detail.explain": "Explicar",
  "calculations.detail.export": "Exportar",
  "calculations.detail.exported": "La exportación {filename} está lista.",
  "calculations.explain.title": "Cómo se calculó {item}",
  "calculations.explain.inputs": "Entradas",
  "calculations.explain.steps": "Pasos",
  "calculations.explain.provenance": "Procedencia de las reglas",
  "calculations.explain.issues": "Inconsistencias",
  "calculations.explain.baseCost": "Costo base ({source})",
  "calculations.explain.lookup": "Modo de búsqueda: {mode}",
  "calculations.explain.reviewRequired":
    "Este ítem requiere revisión financiera antes de convertirse en precio.",
  "calculations.explain.close": "Cerrar explicación",

  "calculations.tabs.label": "Herramientas de la calculadora",
  "fiscalTasks.description":
    "Siga lotes fiscales de larga duración, su snapshot inmutable, progreso y resultados calculados.",
  "fiscalTasks.summary.review": "Esperando revisión",
  "fiscalTasks.summary.items": "Ítems del lote",
  "fiscalTasks.summary.calculated": "Ítems calculados",
  "fiscalTasks.summary.attempts": "Intentos",
  "fiscalTasks.status.QUEUED": "En cola",
  "fiscalTasks.status.RUNNING": "En ejecución",
  "fiscalTasks.status.WAITING_REVIEW": "Requiere revisión",
  "fiscalTasks.status.SUCCEEDED": "Completado",
  "fiscalTasks.status.FAILED": "Falló",
  "fiscalTasks.status.CANCELLED": "Cancelada",
  "fiscalTasks.column.lot": "Lote fiscal",
  "fiscalTasks.detail.title": "Carga {id}",
  "fiscalTasks.detail.description":
    "Registro operativo del lote: entradas, reglas fijadas, ejecución y resultado auditable.",
  "fiscalTasks.record.title": "Registro",
  "fiscalTasks.record.hint":
    "Hechos fijados al crear la carga. Las correcciones posteriores no los cambian.",
  "fiscalTasks.detail.progress": "Progreso de ejecución",
  "fiscalTasks.detail.updated": "Actualizada el {date}",
  "fiscalTasks.detail.chunks": "etapas concluidas",
  "fiscalTasks.detail.polling": "Este estado se actualiza solo mientras corre el cálculo.",
  "lotWait.title.queued": "Lote en cola",
  "lotWait.title.chunk": "Calculando bloque {current} de {total}",
  "lotWait.title.running": "Calculando el lote",
  "lotWait.seconds": "{count} s",
  "lotWait.minutes": "{count} min",
  "lotWait.waited": "en cola hace {duration}",
  "lotWait.ahead.none": "Ningún lote delante: el suyo es el siguiente",
  "lotWait.ahead.one": "{count} lote delante",
  "lotWait.ahead.other": "{count} lotes delante",
  "lotWait.rows": "{done} de {total} filas",
  "lotWait.stagesLabel": "Etapas del lote",
  "lotWait.stage.received": "Recibido",
  "lotWait.stage.queued": "En cola",
  "lotWait.stage.running": "Calculando",
  "lotWait.stage.results": "Resultados",
  "lotWait.state.done": "completado",
  "lotWait.state.active": "ahora",
  "lotWait.state.pending": "a continuación",
  "lotWait.chunks.one": "{count} bloque",
  "lotWait.chunks.other": "{count} bloques",
  "lotWait.chunksLabel": "Bloques del cálculo",
  "lotWait.chunksDone": "{done} de {total} bloques completados",
  "lotWait.chunk": "Bloque {index} de {total}",
  "lotWait.chunkState.done": "completado",
  "lotWait.chunkState.active": "calculando ahora",
  "lotWait.chunkState.pending": "a continuación",
  "lotWait.chunkState.failed": "con error",
  "lotWait.count.calculated": "Calculadas",
  "lotWait.count.review": "Para revisar",
  "lotWait.count.failedChunks": "Bloques con error",
  "lotWait.next.title": "Qué pasa ahora",
  "lotWait.next.start":
    "El cálculo empieza solo: los lotes en cola se retoman automáticamente, en general en menos de 1 minuto.",
  "lotWait.next.chunks.one":
    "Calculamos en {count} bloque; los resultados aparecen cuando termina.",
  "lotWait.next.chunks.other":
    "Calculamos en {count} bloques; los resultados parciales aparecen al terminar cada bloque.",
  "lotWait.next.leave":
    "Puede salir de esta pantalla: el cálculo sigue en el servidor y el lote queda en Lotes.",
  "lotWait.attempt":
    "Intento {current} de {max}: un intento anterior no terminó y el lote se retomó.",
  "lotWait.follow": "Seguir en Lotes",
  "lotWait.partialTitle": "Subtotal parcial · se actualiza con cada bloque",
  "fiscalTasks.detail.results": "Resultados por ítem",
  "fiscalTasks.detail.resultsHint": "{count} ítems ya tienen un resultado persistido",
  "fiscalTasks.detail.sourceSystem": "Sistema de origen",
  "fiscalTasks.detail.lotId": "ID del lote",
  "fiscalTasks.detail.listId": "ID de la lista",
  "fiscalTasks.detail.calculationDate": "Fecha fiscal",
  "fiscalTasks.detail.snapshotRows": "Filas capturadas",
  "fiscalTasks.detail.snapshotHash": "Hash del snapshot",
  "fiscalTasks.detail.ruleset": "Conjunto usado",
  "fiscalTasks.detail.selector": "Selector solicitado",
  "fiscalTasks.detail.resolvedVersion": "Versión resuelta",
  "fiscalTasks.detail.digest": "Digest del conjunto",
  "fiscalTasks.detail.artifact": "Artefacto de entrada",
  "fiscalTasks.detail.noArtifact": "Sin artefacto adjunto",
  "fiscalTasks.detail.issues": "Inconsistencias encontradas",
  "fiscalTasks.detail.noIssues": "No hay inconsistencias registradas en este snapshot.",
  "fiscalTasks.detail.trace": "Rastro operativo",
  "fiscalTasks.detail.workflow": "Workflow de origen",
  "fiscalTasks.detail.requestId": "requestId",
  "fiscalTasks.detail.created": "Creada el",
  "fiscalTasks.detail.started": "Iniciada el",
  "fiscalTasks.detail.completed": "Completada el",
  "fiscalTasks.detail.revision": "Revisión de concurrencia",
  "fiscalTasks.action.cancel": "Cancelar tarea",
  "fiscalTasks.action.retry": "Reprocesar",
  "fiscalTasks.action.cancelDisabled":
    "Solo se puede cancelar una tarea en cola, en ejecución o esperando revisión.",
  "fiscalTasks.action.retryDisabled": "Solo se puede reprocesar una tarea fallida o cancelada.",
  "fiscalTasks.action.cancelled": "Solicitud de cancelación enviada.",
  "fiscalTasks.action.requeued": "Tarea devuelta a la cola.",
  "fiscalTasks.retry.defaultReason": "Reprocesar después de revisar la entrada fiscal del lote.",
  "fiscalTasks.resultStatus.CALCULATED": "Calculado",
  "fiscalTasks.resultStatus.REVIEW_REQUIRED": "Requiere revisión",
  "fiscalTasks.results.item": "Ítem",
  "fiscalTasks.results.route": "Ruta",
  "fiscalTasks.results.taxes": "IPI + ICMS-ST",
  "fiscalTasks.results.landed": "Costo puesto",
  "fiscalTasks.results.issues": "Inconsistencias",
  "fiscalTasks.results.calculation": "Cálculo",
  "fiscalTasks.results.openCalculation": "Abrir recibo",
  "fiscalTasks.results.search": "Filtrar por ítem",
  "fiscalTasks.results.empty.title": "No hay resultados persistidos",
  "fiscalTasks.results.empty.filtered": "Ningún ítem coincide con este filtro.",
  "fiscalTasks.results.empty.body": "Los resultados aparecen a medida que avanza el cálculo.",
  "fiscalTasks.dialog.cancel.title": "¿Cancelar esta tarea fiscal?",
  "fiscalTasks.dialog.cancel.body":
    "No se calculará ninguna fila nueva. Una etapa ya en curso puede terminar.",
  "fiscalTasks.dialog.cancel.warning":
    "El snapshot y los resultados ya persistidos siguen preservados para auditoría.",
  "fiscalTasks.dialog.cancel.confirm": "Confirmar cancelación",
  "fiscalTasks.dialog.retry.title": "Reprocesar tarea fiscal",
  "fiscalTasks.dialog.retry.body":
    "Las etapas concluidas quedan inmutables; solo lo que falta calcular vuelve a la cola.",
  "fiscalTasks.dialog.retry.reason": "Motivo del reproceso",
  "fiscalTasks.dialog.retry.reasonHint":
    "Indique al menos 10 caracteres para registrar la decisión.",
  "fiscalTasks.dialog.retry.confirm": "Poner en cola",

  "sources.empty.title": "Ninguna fuente registrada",
  "sources.empty.body":
    "Las fuentes vienen del registro oficial; no se pueden agregar URLs desde la interfaz.",
  "sources.title": "Fuentes oficiales",
  "sources.description":
    "Compruebe qué fuentes están al día y abra los documentos que necesitan revisión.",
  "sources.registry.eyebrow": "Registro oficial",
  "sources.registry.title": "Fuentes que sostienen cada investigación",
  "sources.registry.description":
    "El catálogo define dónde puede buscar el agente. Una fuente no es una regla fiscal: entrega documentos para revisión.",
  "sources.registry.flow": "Cómo llega una fuente a la evidencia",
  "sources.registry.step.review": "Fuente revisada",
  "sources.registry.step.reviewHint": "Dominio, jurisdicción y cadencia quedan bajo control.",
  "sources.registry.step.grounding": "Búsqueda fundamentada",
  "sources.registry.step.groundingHint":
    "La búsqueda se limita a las fuentes oficiales autorizadas.",
  "sources.registry.step.evidence": "Evidencia para revisar",
  "sources.registry.step.evidenceHint": "Nada se convierte en regla o alícuota automáticamente.",
  "sources.registry.note":
    "Las URLs libres no entran directamente al registro; pida a su equipo revisar una nueva fuente.",
  "sources.action.requestReview": "Solicitar nueva fuente",
  "sources.request.title": "Solicitar incorporación de una fuente",
  "sources.request.titlePrefix": "Revisar fuente",
  "sources.request.notice":
    "Esta acción crea una tarea de revisión; no activa la URL ni modifica el registro oficial.",
  "sources.request.name": "Nombre de la fuente",
  "sources.request.publisher": "Publicador",
  "sources.request.jurisdiction": "Jurisdicción",
  "sources.request.url": "URL oficial",
  "sources.request.reasonHint":
    "Explique por qué debe revisarse esta fuente y qué información fiscal puede respaldar.",
  "sources.request.submit": "Crear tarea de revisión",
  "sources.request.created": "Solicitud registrada como tarea de revisión.",
  "sources.request.openTasks": "Ver tareas",
  "sources.request.payload.name": "Nombre",
  "sources.request.payload.publisher": "Publicador",
  "sources.request.payload.jurisdiction": "Jurisdicción",
  "sources.request.payload.url": "URL oficial",
  "sources.request.payload.reason": "Motivo",
  "sources.request.payload.governance":
    "El registro oficial solo debe actualizarse después de la revisión y configuración gobernada.",
  "sources.discovery.note":
    "La recolección automática revisa cada 3 horas (hora de Brasilia) cuando no está en pausa y visita cada fuente una vez por su frecuencia (hoy diaria), de la más antigua a la más reciente; una fuente degradada se reintenta una vez por frecuencia. «Ejecutar ahora» no espera al próximo horario. La columna «Última ejecución» muestra lo que realmente corrió.",
  "sources.extract.note":
    "El extractor solo escribe evidencia para revisión. La fuente Siscomex (NCM) queda en pausa hasta que Classif se publique como catálogo de referencia, nunca como alícuota.",
  "sources.intro.summary": "Cómo se recopilan los documentos",
  "sources.filter.dlq": "Con fallas pendientes",
  "sources.filter.search": "Nombre, editor o jurisdicción",
  "sources.status.ACTIVE": "Activa",
  "sources.status.PAUSED": "Pausada",
  "sources.status.DEGRADED": "Degradada",
  "sources.status.DISABLED": "Desactivada",
  "sources.catalogue.results": "{count} fuentes",
  "sources.catalogue.degraded.one": "{count} degradada",
  "sources.catalogue.degraded.other": "{count} degradadas",
  "sources.fact.rate": "Éxito 7 d",
  "sources.fact.documents": "Documentos",
  "sources.column.name": "Fuente",
  "sources.column.status": "Estado",
  "sources.column.lastRun": "Última ejecución",
  "sources.column.nextDue": "Próxima búsqueda",
  "sources.column.successRate": "Tasa de éxito",
  "sources.column.documents": "Documentos (7 d)",
  "sources.column.cadence": "Cadencia",
  "sources.column.baseUrl": "URL base",
  "sources.dlq.label": "Fallas pendientes",
  "sources.health.current": "Fallas pendientes de la fuente: {count}",
  "sources.health.observedAt": "Observada en {when}",
  "sources.health.stale": "El conteo de fallas pendientes de la fuente está desactualizado",
  "sources.health.unavailable": "Conteo de fallas pendientes de la fuente no disponible",
  "sources.health.lastObserved": "Última observación: {when}",
  "sources.health.diagnostic":
    "El monitoreo de la nube es la referencia para el conteo compartido de fallas. Haga una vista previa por fuente para revisar los IDs exactos.",
  "sources.health.failedRuns": "Fallos recientes de ejecuciones de la fuente",
  "sources.health.compact.current": "{count}",
  "sources.health.compact.stale": "⚠ {count}",
  "sources.health.compact.unavailable": "—",
  "sources.cadence.daily": "Diaria",
  "sources.cadence.weekly": "Semanal",
  "sources.due.now": "En el próximo ciclo",
  "sources.run.detail.title": "Ejecución {id}",
  "sources.run.detail.description":
    "Resultado de la extracción y documentos vinculados a esta ejecución.",
  "sources.run.detail.identity": "{name} · {publisher} · {jurisdiction}",
  "sources.run.detail.notFound": "Ejecución no encontrada",
  "sources.run.detail.invalid":
    "El identificador no es válido o la ejecución no pertenece a esta fuente.",
  "sources.run.detail.sourceError": "No se pudo consultar la fuente",
  "sources.run.detail.readError": "No se pudo consultar la ejecución",
  "sources.run.detail.result": "Resultado de la ejecución",
  "sources.run.detail.live": "Siguiendo la ejecución · actualización automática",
  "sources.run.detail.ageNotice": "Sin finalización registrada tras dos horas",
  "sources.run.detail.staleNotice":
    "Sin actualizaciones registradas desde hace más de 24 horas. Cierre esta ejecución para permitir nuevas consultas. Se conservarán los documentos extraídos.",
  "sources.run.detail.cancelStale": "Cerrar ejecución estancada",
  "sources.run.detail.cancelling": "Solicitando cierre…",
  "sources.run.detail.cancelRequested":
    "Cierre solicitado. Esperando la confirmación del estado de la ejecución.",
  "sources.run.detail.created": "Creados",
  "sources.run.detail.reused": "Reutilizados",
  "sources.run.detail.countNote":
    "Creados y reutilizados cuentan documentos vinculados a esta ejecución. Un documento reutilizado no acredita la aprobación de reglas fiscales.",
  "sources.run.detail.documents": "Documentos de esta ejecución",
  "sources.run.detail.review": "Revisar documento",
  "sources.run.detail.waiting": "Esperando documentos",
  "sources.run.detail.waitingBody":
    "Aún no hay documentos vinculados. Esta página consulta el estado y los recibos.",
  "sources.run.detail.empty": "Ningún documento vinculado",
  "sources.run.detail.emptyBody":
    "No hay vínculos de documentos registrados para esta ejecución. Esto no permite concluir que la fuente nunca se haya extraído.",
  "sources.run.detail.timing": "Cuándo ocurrió",
  "sources.run.detail.started": "Inicio",
  "sources.run.detail.finished": "Finalización",
  "sources.run.detail.technical": "Identificadores técnicos",
  "sources.run.detail.runId": "ID de ejecución",
  "sources.run.detail.sourceId": "ID de fuente",
  "sources.runs": "Ejecuciones",
  "sources.run.duration": "Duración",
  "sources.run.discovered": "Descubiertos",
  "sources.run.ingested": "Ingeridos",
  "sources.run.failed": "Fallidos",
  "sources.run.compact.discovered.one": "{count} descubierto",
  "sources.run.compact.discovered.other": "{count} descubiertos",
  "sources.run.compact.failed.one": "{count} falla",
  "sources.run.compact.failed.other": "{count} fallas",
  "sources.action.runNow": "Ejecutar ahora",
  "sources.action.pause": "Pausar",
  "sources.action.resume": "Reanudar",
  "sources.action.replayDlq": "Reprocesar fallas pendientes",
  "sources.action.inspectDlq": "Inspeccionar fallas pendientes",
  "sources.run.accepted": "Ejecución fiscal encolada con el identificador {id}.",
  "sources.dlq.title": "Recuperación de fallas pendientes — {source}",
  "sources.dlq.previewNotice":
    "La vista previa es asíncrona: no publica ni confirma mensajes. Revise los logs de la ejecución y copie únicamente los IDs aprobados.",
  "sources.dlq.executeNotice":
    "La ejecución republicará únicamente los IDs indicados y confirmará cada falla pendiente después de publicarla.",
  "sources.dlq.maxMessages": "Límite de lectura (1–100)",
  "sources.dlq.rate": "Mensajes por segundo (0,1–10)",
  "sources.dlq.execute": "Ejecutar los IDs revisados previamente",
  "sources.dlq.messageIds": "IDs exactos de los mensajes",
  "sources.dlq.messageIdsHint":
    "Un ID por línea, copiado de la vista previa. Se rechazan duplicados, espacios y más de 100 IDs.",
  "sources.dlq.reasonHint":
    "Indique el ticket o registro de cambio y la aprobación (10–256 caracteres).",
  "sources.dlq.queuePreview": "Encolar vista previa segura",
  "sources.dlq.confirmExecute": "Encolar reproceso seleccionado",
  "sources.dlq.acceptedPreview":
    "Vista previa encolada ({id}). Revise los logs antes de seleccionar cualquier mensaje.",
  "sources.dlq.acceptedExecute":
    "Reproceso seleccionado encolado ({id}); verifique el resultado en los logs y métricas.",
  "sources.degraded": "Fuente degradada: {reason}",
  "sources.degraded.noRun": "Aún no hay ejecución registrada",
  "sources.degraded.technical": "Detalle técnico",
  "sources.degraded.timeout": "Se agotó el tiempo al conectar",
  "sources.degraded.timeoutHost": "Se agotó el tiempo al conectar a {host}",
  "sources.degraded.dns": "Fallo de DNS",
  "sources.degraded.dnsHost": "Fallo de DNS en {host}",
  "sources.degraded.tls": "Error de certificado TLS",
  "sources.degraded.tlsHost": "Error de certificado TLS en {host}",
  "sources.degraded.http": "La fuente respondió HTTP {status}",
  "sources.degraded.httpHost": "La fuente {host} respondió HTTP {status}",
  "sources.degraded.reset": "La conexión se interrumpió",
  "sources.degraded.resetHost": "La conexión con {host} se interrumpió",
  "sources.degraded.connect": "No fue posible conectar",
  "sources.degraded.connectHost": "No fue posible conectar a {host}",
  "sources.degraded.security": "Bloqueada por la política de seguridad",
  "sources.degraded.robots": "Bloqueada por robots.txt",
  "sources.degraded.unsupported": "Formato de documento no admitido",
  "sources.degraded.parse": "Fallo al leer el documento",
  "sources.degraded.unknown": "Fallo al recolectar la fuente · {raw}",

  "discovery.title": "Lanzar una búsqueda fiscal",
  "discovery.description":
    "Hágale una pregunta al agente o extraiga una URL oficial; siga todo hasta la revisión humana.",
  "discovery.mode.label": "Tipo de tarea fiscal",
  "discovery.mode.research": "Investigar una pregunta",
  "discovery.mode.researchHint": "Sin URL: el agente investiga en las fuentes oficiales elegidas.",
  "discovery.mode.url": "Extraer desde una URL",
  "discovery.mode.urlHint": "Con URL: conserva el documento y revise candidatos.",
  "discovery.queryHint": "Describa la pregunta, el impuesto, la UF o el NCM que desea investigar.",
  "discovery.sourcesHint":
    "La tarea queda acotada a fuentes activas o degradadas del registro revisado.",
  "discovery.degraded.badge": "Fuente degradada",
  "discovery.degraded.hint": "La última captura falló; las citas siguen sujetas a revisión.",
  "discovery.degraded.hintWithReason":
    "La última captura falló ({reason}); las citas siguen sujetas a revisión.",
  "discovery.stage.eyebrow": "Área de trabajo",
  "discovery.stage.title": "Siga lo que entró",
  "discovery.stage.description":
    "Consulte la ejecución, las evidencias y lo que aún necesita revisión humana.",
  "discovery.stage.urlEmpty": "Envíe una URL oficial para seguir aquí su recepción y candidatos.",
  "discovery.research.retryDispatch": "Reintentar envío",
  "discovery.research.retryReason": "Motivo del reintento",
  "discovery.research.retryHint":
    "Envíe las citas pendientes de esta tarea. Conserve las evidencias recibidas.",
  "discovery.research.eyebrow": "Agente fiscal",
  "discovery.research.title": "Investigar fuentes oficiales en línea",
  "discovery.research.description":
    "El agente busca en la web, filtra los dominios autorizados y guarda las citas para revisión.",
  "discovery.research.provider": "Proveedor de IA",
  "discovery.research.defaultModel": "gemini-4-argon",
  "discovery.research.grounding": "Fundamentación con Google Search",
  "discovery.research.taskMode": "Cada envío crea una tarea auditable",
  "discovery.research.conversation": "Conversación con el agente fiscal",
  "discovery.research.operator": "Solicitud del operador",
  "discovery.research.agent": "Agente de investigación",
  "discovery.research.noUrl": "No necesita pegar una URL para comenzar.",
  "discovery.research.emptyPrompt": "Escriba una pregunta o tarea fiscal arriba.",
  "discovery.research.waitingAnswer":
    "El agente está procesando la tarea y guardará su respuesta aquí.",
  "discovery.research.resultReady":
    "La síntesis quedó abajo; revise las citas antes de proponer un cambio.",
  "discovery.research.chatHint":
    "La respuesta, las citas oficiales y los enlaces a evidencia aparecerán aquí cuando termine.",
  "discovery.research.launch": "Investigar con agente",
  "discovery.research.launchTask": "Enviar al agente de investigación",
  "discovery.research.pending": "Investigando fuentes oficiales…",
  "discovery.research.failed": "La investigación fiscal no terminó.",
  "discovery.research.summary": "Síntesis del agente",
  "discovery.research.noSummary": "Todavía no hay síntesis disponible.",
  "discovery.research.candidates": "Resultados",
  "discovery.research.accepted": "Aceptados",
  "discovery.research.ingested": "En evidencia",
  "discovery.research.rejected": "Descartados",
  "discovery.research.citations": "Citas oficiales",
  "discovery.research.citationStatus.QUEUED": "En cola de ingestión",
  "discovery.research.citationStatus.FETCHING": "Incorporando",
  "discovery.research.citationStatus.INGESTED": "En evidencia",
  "discovery.research.citationStatus.REJECTED": "Descartada",
  "discovery.research.rejectionReason": "Motivo del descarte: {reason}",
  "discovery.research.noCitations": "No se aceptaron citas oficiales para esta investigación.",
  "discovery.research.openSourceRun": "Abrir ejecución",
  "discovery.research.openEvidence": "Abrir evidencia",
  "discovery.research.disclaimer":
    "La síntesis y las citas no modifican reglas ni alícuotas. La evidencia debe revisarse antes de proponer cambios.",
  "discovery.research.execution": "Ejecución de la tarea",
  "discovery.research.step.request": "Tarea persistida",
  "discovery.research.step.requestHint":
    "La solicitud queda guardada en Tax Platform con correlación e idempotencia.",
  "discovery.research.step.vertex": "Investigación del agente",
  "discovery.research.step.vertexHint":
    "El agente recibe la consulta y busca en las fuentes oficiales.",
  "discovery.research.step.grounding": "Fuentes y citas",
  "discovery.research.step.groundingHint":
    "Las citas se filtran al registro de fuentes autorizadas y pasan al pipeline de evidencia.",
  "discovery.research.step.review": "Revisión humana",
  "discovery.research.step.reviewHint":
    "Una persona debe revisar la evidencia antes de crear una propuesta o tocar reglas.",
  "discovery.research.step.done": "Completado",
  "discovery.research.step.active": "En curso",
  "discovery.research.step.pending": "Pendiente",
  "discovery.research.step.failed": "Falló",
  "discovery.research.error.VERTEX_QUOTA": "Se agotó la cuota de Vertex (HTTP 429).",
  "discovery.research.error.VERTEX_UNAVAILABLE":
    "Vertex no estaba disponible (HTTP 408, 425 o 5xx).",
  "discovery.research.error.VERTEX_TIMEOUT": "La búsqueda en Vertex superó el tiempo límite.",
  "discovery.research.error.VERTEX_NETWORK": "Falló la conexión con Vertex.",
  "discovery.research.error.VERTEX_OUTPUT_BUDGET":
    "La respuesta de Vertex agotó el límite de tokens de salida.",
  "discovery.research.error.VERTEX_BLOCKED":
    "Vertex bloqueó la respuesta (seguridad o recitación).",
  "discovery.research.error.VERTEX_REJECTED": "Vertex rechazó la solicitud de investigación.",
  "discovery.research.error.VERTEX_INVALID_RESPONSE": "Vertex devolvió una respuesta no válida.",
  "discovery.research.error.RUNTIME_UNAVAILABLE":
    "El registro de la tarea todavía no está disponible.",
  "discovery.research.error.CITATION_DISPATCH_FAILED":
    "No se pudieron enviar las citas a la cola de evidencia.",
  "discovery.research.error.INTERNAL_ERROR": "La investigación fiscal falló por un error interno.",
  "discovery.research.error.retryable": "Se intentará de nuevo automáticamente.",
  "discovery.research.taskId": "ID de tarea",
  "discovery.research.requestId": "ID de solicitud del proveedor",
  "discovery.research.searchQueries": "Consultas ejecutadas",
  "discovery.research.trace": "Ver trazabilidad técnica",
  "discovery.research.history": "Historial de búsquedas del agente",
  "discovery.query": "Qué buscar",
  "discovery.placeholder": "ICMS SP papelería, NCM 84713012, MVA MG…",
  "discovery.sources": "Fuentes oficiales coincidentes",
  "discovery.noSources": "Ninguna fuente oficial autorizada coincide con esta consulta.",
  "discovery.needQuery": "Escriba una pregunta fiscal de al menos 3 caracteres.",
  "discovery.needSource": "Seleccione al menos una fuente activa.",
  "discovery.needReason":
    "La justificación queda en el registro de auditoría. Use al menos 10 caracteres.",
  "discovery.excluded":
    "PIS, COFINS e ISS quedan fuera de esta base. La búsqueda no inventa alícuota ni dispara una fuente.",
  "discovery.reasonHint": "Registre el motivo de la búsqueda para el equipo.",
  "discovery.launch": "Lanzar extracción",
  "discovery.harvest": "Evidencias extraídas para esta consulta",
  "discovery.openEvidence": "Abrir",
  "discovery.awaitingFigure": "Seleccione una evidencia de la cola para consultar su extracto.",
  "discovery.timelineEmpty": "Las fuentes elegidas aparecen aquí cuando la consulta cierra.",
  "discovery.idle": "Sin ejecución",
  "discovery.ncmChip": "NCM {ncm}",
  "discovery.disclaimer":
    "Los documentos recibidos pasan por revisión antes de proponer una regla.",
  "discovery.figure.note":
    "Extracto del documento guardado. Abra la fuente para consultar la publicación.",
  "discovery.figure.unavailable": "Figura oficial no disponible",
  "discovery.figure.noHost": "host oficial",
  "discovery.figure.emptyExcerpt": "El extractor aún no devolvió texto de este artefacto.",
  "discovery.harvestNew": "de esta corrida",
  "discovery.harvestKnown": "ya en la cola",
  "discovery.findings.claim": "Lo que afirma la fuente",
  "discovery.findings.vigencia": "Vigencia",
  "discovery.findings.pending": "Pendencias",
  "discovery.findings.noDate": "El artefacto no trajo fecha de vigencia",
  "discovery.findings.needsTriage": "Aún sin triaje",
  "discovery.findings.noRate": "No se copió ninguna alícuota",
  "discovery.maxDocuments": "Como máximo {count} documentos por fuente.",
  "discovery.retryPending": "Reintentar fuentes pendientes",
  "discovery.accepted": "{source}: ejecución recibida ({id}).",
  "discovery.dispatchFailed":
    "{source}: no se pudo confirmar la solicitud. Las ejecuciones aceptadas continúan.",
  "discovery.linkDisclosure": "Extraer datos fiscales desde una URL",
  "discovery.linkTitle": "Extraer datos de un enlace oficial",
  "discovery.linkHint":
    "Indique la URL de una fuente revisada. El sistema conserva el documento, extrae candidatos fiscales y espera la aprobación humana.",
  "discovery.linkFlow": "Flujo de extracción fiscal por URL",
  "discovery.linkFlow.url": "URL",
  "discovery.linkFlow.evidence": "Evidencia",
  "discovery.linkFlow.candidate": "Candidato",
  "discovery.linkFlow.approval": "Aprobación",
  "discovery.linkSource": "Fuente revisada",
  "discovery.linkSelectSource": "Seleccione una fuente revisada",
  "discovery.linkUrl": "URL oficial",
  "discovery.linkSubmit": "Extraer datos fiscales",
  "discovery.linkNeedSource": "Seleccione una fuente revisada.",
  "discovery.linkNeedUrl": "Introduzca el enlace oficial revisado.",
  "discovery.linkInvalidUrl": "Introduzca un enlace HTTPS válido.",
  "discovery.linkHttps": "El enlace debe usar HTTPS.",
  "discovery.linkNeedReason": "El motivo debe tener al menos 10 caracteres.",
  "discovery.linkFailed": "El enlace dirigido no fue aceptado.",
  "discovery.linkAccepted": "URL aceptada. La extracción fiscal está en curso.",
  "discovery.linkProgress": "Progreso de extracción por URL",
  "discovery.linkProgressHint":
    "Cuando llegue el documento, abra la evidencia para revisar los candidatos y crear una propuesta.",
  "discovery.linkCandidateReady": "candidato disponible",
  "discovery.linkWaiting": "La ejecución está buscando y normalizando el documento oficial…",
  "discovery.linkNoDocuments":
    "La ejecución terminó sin documentos. Abra los detalles para investigar.",
  "discovery.linkOpenRun": "Abrir ejecución",
  "discovery.runUnavailable": "Estado no disponible",
  "discovery.receipts.created": "Documento nuevo",
  "discovery.receipts.reused": "Ya guardado",
  "discovery.receipts": "Documentos de la ejecución {source}",
  "discovery.receipts.hasMore": "Esta ejecución tiene más documentos que esta página.",
  "discovery.receipts.endedEmpty": "Esta ejecución terminó sin documentos recibidos.",
  "discovery.failedDocuments": "{count} documentos con errores",
  "discovery.receipts.empty": "Esta ejecución aún no devolvió documentos.",
  "discovery.counts": "{created} creados · {reused} reutilizados",
  "discovery.reusedNotRate":
    "Un documento reutilizado no es una alícuota aprobada ni una regla publicada.",

  "audit.empty.title": "Ningún evento todavía",
  "audit.empty.body": "Cada decisión, publicación y ejecución genera un evento inmutable.",
  "audit.access.roleRequired":
    "Auditoría pertenece al módulo Desarrolladores. Se necesita un perfil de desarrollador fiscal o de superadministrador autorizado.",
  "audit.title": "Auditoría",
  "audit.description":
    "Registro inmutable de decisiones: quién actuó, cuándo, sobre qué recurso y con qué correlación.",
  "audit.column.when": "Cuándo",
  "audit.column.actor": "Autor de la acción",
  "audit.column.action": "Acción",
  "audit.column.resource": "Recurso",
  "audit.column.correlation": "Correlación",
  "audit.filter.actor": "Autor",
  "audit.filter.action": "Acción",
  "audit.action.EVIDENCE_APPROVED": "Evidencia aprobada",
  "audit.action.EVIDENCE_REJECTED": "Evidencia rechazada",
  "audit.action.EVIDENCE_BULK_REVIEWED": "Evidencias revisadas en lote",
  "audit.action.PROPOSAL_CREATED": "Propuesta creada",
  "audit.action.PROPOSAL_APPROVED": "Propuesta aprobada",
  "audit.action.PROPOSAL_REJECTED": "Propuesta rechazada",
  "audit.action.RULESET_PUBLISHED": "Conjunto publicado",
  "audit.action.RULESET_ROLLED_BACK": "Conjunto revertido",
  "audit.action.SOURCE_RUN_TRIGGERED": "Recolección iniciada",
  "audit.action.SOURCE_PAUSED": "Fuente pausada",
  "audit.action.DLQ_REPLAYED": "Fallas pendientes reprocesadas",
  "audit.action.CALCULATION_EXPORTED": "Cálculo exportado",
  "audit.immutable": "Solo lectura. Las entradas de auditoría no pueden editarse ni borrarse.",
  "audit.detail.title": "Evento de auditoría",
  "audit.detail.notFound": "Este evento no está en el registro.",
  "audit.detail.notFound.body":
    "El detalle solo muestra el evento inmutable. Vuelva a la lista para buscar por acción, autor o correlación.",
  /* Auditoria — readable resource labels and record byline (UX plan PR 5). */
  "audit.detail.byline": "{actor} · {when}",
  "audit.detail.technical": "Identificadores técnicos",
  "audit.resource.evidence": "Documento",
  "audit.resource.evidence_documents": "Documentos",
  "audit.resource.evidence_task": "Tarea de documento",
  "audit.resource.fiscal_task": "Tarea fiscal",
  "audit.resource.rule_proposal": "Propuesta",
  "audit.resource.proposal": "Propuesta",
  "audit.resource.ruleset": "Publicación",
  "audit.resource.rule": "Regla",
  "audit.resource.source": "Fuente",
  "audit.resource.calculation": "Cálculo",
  "audit.resource.principal": "Usuario",
  "audit.resource.principal_allowlist": "Invitación de usuario",
  "audit.resource.tax_integration_key": "Clave de API",
  "audit.resource.ncm_catalog": "Catálogo NCM",
  "audit.resource.cest_catalog": "Catálogo CEST",
  "audit.action.admin-command.requested": "Comando administrativo solicitado",
  "audit.action.admin-command.dispatched": "Comando administrativo enviado",
  "audit.action.admin-command.dispatch-failed": "Fallo al enviar comando administrativo",
  "audit.action.browser-agent.credentials-updated": "Credenciales del agente IOB actualizadas",
  "audit.action.browser-agent.demo-created": "Demostración del agente grabada",
  "audit.action.browser-agent.demo-deleted": "Demostración del agente eliminada",
  "audit.action.browser-agent.settings-updated": "Configuración del agente IOB actualizada",
  "audit.action.browser-agent.stop-requested": "Detención del agente IOB solicitada",
  "audit.action.browser-agent.task-created": "Tarea del agente IOB creada",
  "audit.action.browser-agent.task-pause": "Tarea del agente IOB pausada",
  "audit.action.browser-agent.task-resume": "Tarea del agente IOB reanudada",
  "audit.action.browser-agent.task-cancel": "Tarea del agente IOB cancelada",
  "audit.action.browser-agent.task-move-up": "Tarea del agente IOB movida hacia arriba",
  "audit.action.browser-agent.task-move-down": "Tarea del agente IOB movida hacia abajo",
  "audit.action.browser-agent.task-move-to-front":
    "Tarea del agente IOB movida al inicio de la cola",
  "audit.action.calculation.completed": "Cálculo completado",
  "audit.action.evidence-task.assigned": "Tarea de documento asignada",
  "audit.action.evidence-task.created": "Tarea de documento creada",
  "audit.action.evidence-task.status-changed": "Estado de la tarea de documento cambiado",
  "audit.action.evidence-task.updated": "Tarea de documento actualizada",
  "audit.action.evidence.artifact-read": "Archivo original del documento consultado",
  "audit.action.evidence.bulk-reviewed": "Documentos revisados en lote",
  "audit.action.evidence.normalized-ingested": "Documento recolectado",
  "audit.action.evidence.normalized-reused": "Documento reutilizado",
  "audit.action.evidence.reviewed": "Documento revisado",
  "audit.action.fiscal-facts.revoked": "Hecho fiscal revocado",
  "audit.action.fiscal-facts.settings-updated": "Configuración de hechos fiscales actualizada",
  "audit.action.fiscal-research-citation.stale-update-ignored":
    "Actualización antigua de cita ignorada",
  "audit.action.fiscal-research-citation.updated": "Cita de la investigación actualizada",
  "audit.action.fiscal-research.dispatch-failed": "Fallo al enviar investigación fiscal",
  "audit.action.fiscal-research.dispatch-retry-requested":
    "Nuevo envío de la investigación fiscal solicitado",
  "audit.action.fiscal-research.dispatch-retry-updated":
    "Nuevo envío de la investigación fiscal actualizado",
  "audit.action.fiscal-research.dispatched": "Investigación fiscal enviada",
  "audit.action.fiscal-research.requested": "Investigación fiscal solicitada",
  "audit.action.fiscal-research.research-retry-updated":
    "Nuevo intento de la investigación fiscal actualizado",
  "audit.action.fiscal-research.retry-restarted": "Investigación fiscal reiniciada",
  "audit.action.fiscal-research.stale-update-ignored":
    "Actualización antigua de la investigación ignorada",
  "audit.action.fiscal-research.updated": "Investigación fiscal actualizada",
  "audit.action.fiscal-task.cancel-requested": "Cancelación de tarea fiscal solicitada",
  "audit.action.fiscal-task.cancelled": "Tarea fiscal cancelada",
  "audit.action.fiscal-task.chunk-completed": "Parte de la tarea fiscal completada",
  "audit.action.fiscal-task.completed": "Tarea fiscal completada",
  "audit.action.fiscal-task.created": "Tarea fiscal creada",
  "audit.action.fiscal-task.failed": "Tarea fiscal fallida",
  "audit.action.fiscal-task.requeued": "Tarea fiscal puesta de nuevo en la cola",
  "audit.action.fiscal-task.retry-resolved": "Nuevo intento de la tarea fiscal resuelto",
  "audit.action.fiscal-task.retry-scheduled": "Nuevo intento de la tarea fiscal programado",
  "audit.action.integration-key.created": "Clave de API creada",
  "audit.action.integration-key.revoked": "Clave de API revocada",
  "audit.action.integration-key.rotated": "Clave de API rotada",
  "audit.action.principal.allowlist.created": "Invitación de usuario creada",
  "audit.action.principal.allowlist.updated": "Invitación de usuario actualizada",
  "audit.action.principal.updated": "Usuario actualizado",
  "audit.action.rule-proposal.created": "Propuesta creada",
  "audit.action.rule-proposal.approved": "Propuesta aprobada",
  "audit.action.rule-proposal.rejected": "Propuesta rechazada",
  "audit.action.ruleset.policy-changed": "Política de cálculo cambiada",
  "audit.action.ruleset.published": "Conjunto de reglas publicado",
  "audit.action.ruleset.rolled-back": "Conjunto de reglas revertido",
  "audit.action.source-run.cancellation-requested": "Cierre de ejecución solicitado",
  "audit.action.source-run.stale-cancelled": "Ejecución estancada cerrada",
  "audit.action.source-run.worker-updated": "Ejecución de la fuente actualizada",
  "audit.action.source.paused": "Fuente pausada",
  "audit.action.source.resumed": "Fuente reanudada",
  "audit.action.tax-lookup-job.submitted": "Consulta fiscal enviada",
  "audit.action.web-research.settings-updated": "Configuración de la búsqueda web actualizada",
  "audit.action.web-research.sweep-created": "Barrido de búsqueda web creado",
  "audit.action.EVIDENCE_TASK_ASSIGNED": "Tarea de documento asignada",
  "audit.action.EVIDENCE_TASK_CREATED": "Tarea de documento creada",
  "audit.action.EVIDENCE_TASK_STATUS_CHANGED": "Estado de la tarea de documento cambiado",
  "audit.action.EVIDENCE_TASK_UPDATED": "Tarea de documento actualizada",
  "audit.action.FISCAL_TASK_CANCEL_REQUESTED": "Cancelación de tarea fiscal solicitada",
  "audit.action.FISCAL_TASK_CREATED": "Tarea fiscal creada",
  "audit.action.FISCAL_TASK_REQUEUED": "Tarea fiscal puesta de nuevo en la cola",
  "audit.resource.admin_command": "Comando administrativo",
  "audit.resource.browser_agent_credentials": "Credenciales del agente IOB",
  "audit.resource.browser_agent_demo": "Demostración del agente",
  "audit.resource.browser_agent_run": "Ejecución del agente IOB",
  "audit.resource.browser_agent_settings": "Configuración del agente IOB",
  "audit.resource.browser_agent_task": "Tarea del agente IOB",
  "audit.resource.coverage_gap": "Brecha de cobertura",
  "audit.resource.evidence_artifact": "Archivo del documento",
  "audit.resource.fiscal_fact": "Hecho fiscal",
  "audit.resource.fiscal_facts_settings": "Configuración de hechos fiscales",
  "audit.resource.fiscal_research_citation": "Cita de investigación",
  "audit.resource.fiscal_research_task": "Investigación fiscal",
  "audit.resource.source_run": "Ejecución de la fuente",
  "audit.resource.tax_lookup_job": "Consulta fiscal",
  "audit.resource.web_research_settings": "Configuración de la búsqueda web",
  "audit.resource.web_research_sweep": "Barrido de búsqueda web",
  "audit.column.actorId": "Identidad",
  "audit.column.request": "Pedido",
  "audit.column.reason": "Motivo",

  "legal.title": "Datos de la empresa",
  "legal.description":
    "Identidad registral de BackChannel. No es una alícuota publicada y no sustituye un conjunto de reglas.",
  "legal.section.entity": "Entidad legal de la plataforma",
  "legal.entity.hint": "Identidad registral de BackChannel. No es una alícuota publicada.",
  "legal.entity.legalName": "Razón social",
  "legal.entity.tradeName": "Nombre de fantasía",
  "legal.entity.cnpj": "CNPJ",
  "legal.entity.status": "Situación registral",
  "legal.entity.status.active": "Activa",
  "legal.entity.nature": "Naturaleza jurídica",
  "legal.entity.registeredAddress": "Domicilio en el cadastro de la Receita",
  "legal.entity.commercialOffice": "Oficina comercial",
  "legal.entity.simples": "Simples Nacional",
  "legal.entity.simples.badge": "Fuera de Simples",
  "legal.entity.simples.excluded":
    "Fuera de Simples Nacional: socio persona jurídica en el QSA (LC 123/2006 art. 3º, §4º, I). No calculamos alícuota DAS.",
  "legal.entity.federalRegime": "Régimen federal de apuración",
  "legal.entity.federalRegime.unaccredited":
    "El registro de Receita no acredita el régimen PIS/COFINS. La política confirmada por contabilidad, cuando se registra, aparece en esta página.",
  "legal.entity.notice":
    "Este cuadro identifica a la empresa. No calcula impuesto y no sustituye un conjunto de reglas publicado.",
  "legal.entity.uf": "UF",
  "legal.entity.cnae": "CNAE principal",
  "settings.title": "Perfil",
  "settings.description": "Su nombre, idioma y passkeys en este espacio.",
  "users.title": "Usuarios",
  "users.description":
    "Invite operadores, elija el rol y el idioma, y reenvíe el correo de configuración.",
  "users.missingOrganization":
    "Esta cuenta no tiene organización, así que no se pueden crear invitaciones.",
  "settings.passkeys.title": "Passkeys",
  "settings.passkeys.description":
    "Registre una passkey solo para Operaciones Fiscales. No reemplaza la passkey de Internal Tool.",
  "settings.passkeys.add": "Añadir passkey",
  "settings.passkeys.adding": "Esperando el autenticador…",
  "settings.passkeys.remove": "Revocar",
  "settings.passkeys.loading": "Cargando passkeys…",
  "settings.passkeys.empty": "No hay passkeys registradas en este espacio fiscal.",
  "settings.passkeys.added": "Passkey registrada. Úsela en el próximo inicio de sesión.",
  "settings.passkeys.removed": "Passkey revocada.",
  "settings.passkeys.error": "No se pudieron actualizar las passkeys. Inténtelo de nuevo.",
  "settings.passkeys.unsupported": "Este navegador no admite passkeys.",
  "settings.passkeys.hostHint":
    "Registre passkeys en tax.backchannel.com.br o en el localhost de la API local.",
  "settings.passkeys.hostHintDeployed": "Registre passkeys en tax.backchannel.com.br.",
  "settings.passkeys.created": "Creada el {date}",
  "settings.passkeys.lastUsed": "Último uso {date}",
  "settings.passkeys.neverUsed": "aún no usada",
  "settings.apiBase": "Origen de la API",
  "settings.buildInfo": "Build",
  "settings.technical.summary": "Mostrar detalles técnicos",
  "settings.technical.identity": "Detalles de identidad",
  "settings.principalId": "ID principal",
  "settings.organizationScopes": "Alcance de la organización",
  "settings.tokenPresent": "Token disponible",
  "settings.expiresIn": "Caduca en",
  "settings.bulkCap": "Límite de triaje masivo",
  "settings.access.inviteError":
    "No se pudo completar la invitación. Puede que el usuario pendiente ya exista. Cierre el panel y revise la lista antes de intentarlo otra vez; use Reenviar invitación si ya aparece.",
  "settings.access.editHelp":
    "Los cambios se aplican al acceso del usuario. El reenvío usa el último rol e idioma guardados.",
  "settings.access.search": "Nombre, correo o rol",
  "settings.access.noMatches": "No hay usuarios que coincidan con la búsqueda.",
  "settings.access.inviteHelp":
    "Elija un rol y un idioma. La persona recibe un enlace seguro para configurar su cuenta.",
  "settings.access.resent": "Invitación reenviada. El enlace anterior ya no funciona.",
  "settings.access.resendError":
    "No se pudo reenviar la invitación. Inténtelo de nuevo; el envío no está confirmado.",
  "settings.access.title": "Acceso al espacio fiscal",
  "settings.access.hint": "Gestiona roles y acceso a las cuentas",
  "settings.access.new": "Invitar usuario",
  "settings.access.description":
    "Cree cuentas, envíe invitaciones por correo y elija el idioma. Solo el superadministrador ve este módulo.",
  "settings.access.singleEnvironment":
    "Espacio controlado único: los alcances se limitan a la organización seleccionada y cada cambio genera auditoría.",
  "settings.access.tableCaption": "Principales autorizados e invitaciones pendientes",
  "settings.access.email": "Correo electrónico",
  "settings.access.status": "Estado",
  "settings.access.role": "Perfil",
  "settings.access.role.platformAdmin": "Superadministrador",
  "settings.access.role.taxOperator": "Gestor fiscal",
  "settings.access.role.superAdmin": "Superadministrador",
  "settings.access.role.taxManager": "Gestor fiscal",
  "settings.access.role.taxCommercial": "Comercial",
  "settings.access.commercialRoleHint":
    "Calculadora, lotes y consulta y carga de notas fiscales de tu organización. Sin revisión ni publicación fiscal.",
  "settings.access.role.taxReader": "Lector fiscal",
  "settings.access.role.taxDeveloper": "Desarrollador fiscal",
  "settings.access.origin": "Origen",
  "settings.access.origin.googleAuto": "Google (automático)",
  "settings.access.origin.manual": "Alta manual",
  "settings.access.origin.invite": "Invitación",
  "settings.access.origin.googleLinked": "Google vinculado",
  "settings.access.readerUntilPromoted": "Lector hasta ser promovido",
  "settings.access.googleAutoNotice":
    "Creado automáticamente en el primer inicio de sesión con Google, como Lector. Cambie el perfil para promoverlo (por ejemplo, Gestor fiscal, Desarrollador fiscal o Superadministrador).",
  "settings.access.locale": "Idioma de la invitación",
  "settings.access.localeHint": "La invitación y la configuración de cuenta llegan en este idioma.",
  "settings.access.resendInvite": "Reenviar invitación",
  "settings.access.superAdminRoleHint": "Acceso completo, incluidos Usuarios y Developers.",
  "settings.access.managerRoleHint":
    "Consulta fiscal, calculadora, lotes y fuentes. No ve Usuarios ni Developers.",
  "settings.access.readerRoleHint":
    "Solo lectura. No ejecuta cálculos, publicaciones ni ingestión.",
  "settings.access.developerRoleHint":
    "Claves de API, documentación del consumidor y herramientas MCP. No publica reglas ni invita usuarios.",
  "settings.access.permissionsCount": "Permisos",
  "settings.access.active": "Activo",
  "settings.access.pending": "Invitación pendiente",
  "settings.access.inactive": "inactivo",
  "settings.access.empty": "No hay accesos registrados.",
  "settings.access.edit": "Editar acceso",
  "settings.access.invite": "Invitar operador",
  "settings.access.displayName": "Nombre visible",
  "settings.access.yourAreas": "Áreas disponibles para usted",
  "settings.access.activeToggle": "Permitir el inicio de sesión en este espacio",
  "settings.access.permissions": "Permisos explícitos",
  "settings.access.permissionsHint":
    "Los permisos son explícitos. Los administradores de la plataforma conservan siempre el permiso de administrador.",
  "settings.access.adminRoleHint": "Acceso completo al espacio y gestión de la allowlist.",
  "settings.access.operatorRoleHint": "Acceso únicamente a las áreas seleccionadas abajo.",
  "settings.access.preview": "Ver accesos",
  "settings.access.previewEyebrow": "Vista previa segura",
  "settings.access.previewTitle": "Lo que este usuario puede ver",
  "settings.access.previewNotice":
    "Solo vista previa. Su sesión de administrador no cambia y no se ejecuta ninguna acción como este usuario.",
  "settings.access.previewInactive":
    "Este acceso está inactivo o pendiente; todos los destinos permanecen bloqueados hasta completar el registro.",
  "settings.access.previewAllowed": "Disponible",
  "settings.access.previewDenied": "No disponible",
  "settings.access.auditHint": "La acción se registrará en la auditoría inmutable.",
  "settings.access.createAccount": "Enviar invitación",
  "settings.access.invited":
    "Cuenta creada. Revise el estado de la invitación en la lista de usuarios.",
  "settings.access.saved":
    "Acceso actualizado. El usuario podrá entrar con los permisos asignados.",
  "settings.access.saveError":
    "No se pudo guardar el acceso. Revise los datos e inténtelo de nuevo.",
  "settings.access.unavailableEdit":
    "La lista de accesos no está disponible. Espere a que cargue antes de editar.",

  "settings.integrations.title": "Claves emitidas",
  "settings.integrations.hint": "Credenciales atribuibles y con alcance",
  "settings.integrations.description":
    "Cree claves individuales para sistemas autorizados. La organización, los flujos y los alcances quedan vinculados a la integración.",
  "settings.integrations.new": "Nueva clave",
  "settings.integrations.currentOrganization": "Organización actual",
  "settings.integrations.tableCaption": "Claves de integración registradas",
  "settings.integrations.empty": "Todavía no se crearon claves de integración.",
  "settings.integrations.name": "Nombre",
  "settings.integrations.owner": "Responsable",
  "settings.integrations.organization": "Organización",
  "settings.integrations.environment": "Entorno",
  "settings.integrations.scopes": "Alcances",
  "settings.integrations.scope.READ_RULES": "Leer reglas publicadas",
  "settings.integrations.scope.READ_RULES.description":
    "Consulta las reglas gobernadas de una versión fijada.",
  "settings.integrations.scope.READ_NCM_CATALOG": "Leer catálogo NCM",
  "settings.integrations.scope.READ_NCM_CATALOG.description":
    "Consulta la clasificación y la procedencia NCM.",
  "settings.integrations.scope.CALCULATE": "Ejecutar cálculos",
  "settings.integrations.scope.CALCULATE.description": "Envía lotes acotados al motor fiscal.",
  "settings.integrations.scope.READ_CALCULATION": "Leer cálculos de la integración",
  "settings.integrations.scope.READ_CALCULATION.description":
    "Consulta resultados creados por esta integración.",
  "settings.integrations.workflows": "Flujos permitidos",
  "settings.integrations.expiry": "Caducidad",
  "settings.integrations.lastUsed": "Último uso",
  "settings.integrations.status": "Estado",
  "settings.integrations.active": "Activa",
  "settings.integrations.revoked": "Revocada",
  "settings.integrations.expired": "Caducada",
  "settings.integrations.created": "Creada",
  "settings.integrations.rotate": "Rotar",
  "settings.integrations.revoke": "Revocar",
  "settings.integrations.form.title": "Registrar clave de integración",
  "settings.integrations.form.nameHint": "Use un nombre que identifique el sistema consumidor.",
  "settings.integrations.form.workflowHint":
    "Separe los IDs con comas. Se requiere al menos un flujo.",
  "settings.integrations.form.scopeHint":
    "La clave solo puede llamar operaciones cubiertas por los alcances seleccionados.",
  "settings.integrations.form.expiryDays": "Caduca en (días)",
  "settings.integrations.form.expiryHint": "Predeterminado: 30 días · máximo: 90 días.",
  "settings.integrations.form.reason": "Motivo",
  "settings.integrations.form.reasonHint":
    "Al menos 10 caracteres. El motivo se registra en auditoría.",
  "settings.integrations.form.submit": "Crear clave",
  "settings.integrations.form.cancel": "Cancelar",
  "settings.integrations.form.overlap": "Solapamiento de rotación (horas)",
  "settings.integrations.form.overlapHint": "La clave anterior sigue válida como máximo 24 horas.",
  "settings.integrations.form.secretTitle": "Guarde esta clave ahora",
  "settings.integrations.form.secretNotice":
    "El secreto se muestra una vez y no se guarda en la consola. Cópielo al almacén de su sistema antes de cerrar.",
  "settings.integrations.form.secretReplay":
    "Esta fue una repetición idempotente. Por seguridad, el secreto no se puede recuperar; rote la clave cuando esté listo.",
  "settings.integrations.form.secretCopy": "Secreto de la clave",
  "settings.integrations.form.secretClose": "Cerrar y conservar mi copia",
  "settings.integrations.form.secretDiscardTitle": "¿Descartar el secreto mostrado?",
  "settings.integrations.form.secretDiscardBody":
    "Después de cerrar, la consola no podrá mostrar este secreto otra vez. Confirme solo después de copiarlo.",
  "settings.integrations.form.secretDiscard": "Cerrar y descartar",
  "settings.integrations.form.secretKeep": "Volver al secreto",
  "settings.integrations.form.recovery":
    "Secreto no disponible en esta repetición. Rote la clave para emitir un nuevo secreto.",
  "settings.integrations.form.rotateTitle": "Rotar clave de integración",
  "settings.integrations.form.rotateBody":
    "La nueva clave conserva los mismos alcances y flujos. La clave actual caduca después del solapamiento elegido.",
  "settings.integrations.form.revokeTitle": "Revocar clave de integración",
  "settings.integrations.form.revokeBody":
    "La revocación bloquea nuevas solicitudes de inmediato y no se puede deshacer.",
  "settings.integrations.form.confirmRevoke": "Confirmar revocación",
  "settings.integrations.action.success": "Cambio registrado y auditado.",
  "settings.integrations.action.error": "No se pudo completar el cambio. Inténtelo de nuevo.",
  "settings.integrations.action.replay":
    "Repetición recibida: se devolvieron los metadatos otra vez.",
  "settings.integrations.more": "Alcances y detalles",
  "settings.mcp.title": "Conexión MCP",
  "settings.mcp.hint": "Cinco operaciones para un cliente de IA con clave atribuible",
  "settings.mcp.description":
    "El servidor MCP responde en POST /v1/mcp. Configure su cliente de IA (por ejemplo, Cursor) con la URL de abajo y el encabezado X-Tax-Api-Key. Consulte el conjunto publicado, el catálogo NCM y el cálculo por lote. Nunca use la sesión de un operador; las tareas fiscales y las fuentes quedan fuera de esta clave.",
  "settings.mcp.auth":
    "Cabecera X-Tax-Api-Key · alcances READ_RULES, READ_NCM_CATALOG, CALCULATE y READ_CALCULATION",
  "settings.mcp.config": "Ejemplo de configuración MCP",
  "settings.mcp.tools": "Herramientas",
  "settings.mcp.tool.current": "tax_current_ruleset",
  "settings.mcp.tool.current.body": "Versión publicada fijada para el cálculo.",
  "settings.mcp.tool.rules": "tax_lookup_rules",
  "settings.mcp.tool.rules.body":
    "Reglas publicadas en la ruta origen → destino, con la versión del conjunto.",
  "settings.mcp.tool.ncm": "tax_ncm_catalog",
  "settings.mcp.tool.ncm.body": "Clasificación Siscomex. No es alícuota.",
  "settings.mcp.tool.batch": "tax_calculate_batch",
  "settings.mcp.tool.batch.body": "Aplica el conjunto publicado a un lote.",
  "settings.mcp.tool.calculation": "tax_get_calculation",
  "settings.mcp.tool.calculation.body": "Memoria fiscal de un cálculo de esta integración.",
  "settings.apiDocs.title": "Documentación para consumidores",
  "settings.apiDocs.hint": "Cinco operaciones gobernadas · ejemplos listos para copiar",
  "settings.apiDocs.description":
    "Use el encabezado X-Tax-Api-Key. Nunca coloque una clave en la URL, la caché de consultas ni los registros.",
  "settings.apiDocs.baseUrl": "URL base de la API de este espacio: {baseUrl}",
  "settings.apiDocs.auth": "Autenticación y alcances",
  "settings.apiDocs.scopes":
    "READ_RULES consulta reglas publicadas; READ_NCM_CATALOG consulta clasificación y procedencia; CALCULATE envía lotes; READ_CALCULATION consulta resultados de la misma integración.",
  "settings.apiDocs.requestIdentity":
    "Identidad de la solicitud: X-Tax-Attempt-Id es un UUID generado por el servidor para cada intento. X-Request-Id y X-Correlation-Id pueden venir del cliente y no son únicos; conserve los tres IDs para soporte. El historial solo incluye intentos autenticados en las cinco rutas de integración; los 401 sin identidad y los fallos del gateway no aparecen.",
  "settings.apiDocs.errors": "Errores",
  "settings.apiDocs.endpoints": "Referencia de endpoints",
  "settings.apiDocs.requiredScope": "Alcance requerido",
  "settings.apiDocs.parameters": "Parámetros",
  "settings.apiDocs.endpoint.current.parameters": "Ninguno.",
  "settings.apiDocs.endpoint.current.output":
    "Metadatos del conjunto publicado actual: versión, versión de política, digest y hora de publicación.",
  "settings.apiDocs.endpoint.rules.parameters":
    "Consulta: rulesetVersion es obligatorio y debe estar PUBLISHED o SUPERSEDED; cursor, limit (máximo 100) y q son opcionales.",
  "settings.apiDocs.endpoint.rules.output":
    "Una página acotada de payloads completos de reglas con vigencia, aplicabilidad NCM y procedencia de evidencias.",
  "settings.apiDocs.endpoint.ncm.parameters":
    "Consulta: cursor, limit (máximo 100) y q son opcionales.",
  "settings.apiDocs.endpoint.ncm.output":
    "Una página acotada de clasificación y procedencia NCM. No contiene alícuotas.",
  "settings.apiDocs.endpoint.batch.parameters":
    "Encabezado: Idempotency-Key. Cuerpo JSON abajo; un flujo permitido y como máximo 500 elementos.",
  "settings.apiDocs.endpoint.batch.output":
    "El resultado de cálculo determinista guardado, con el ID del cálculo y los resultados de sus elementos.",
  "settings.apiDocs.endpoint.calculation.parameters":
    "Ruta: id es el UUID de cálculo devuelto por la operación por lotes.",
  "settings.apiDocs.endpoint.calculation.output":
    "El resultado solo cuando el cálculo pertenece a esta integración y organización.",
  "settings.apiDocs.error.400":
    "Solicitud inválida: JSON mal formado, falta rulesetVersion fijado, campos inválidos o limit superior a 100.",
  "settings.apiDocs.error.401":
    "X-Tax-Api-Key ausente, mal formada, duplicada, caducada o revocada, o el propietario de la integración ya no está autorizado. Envíe un único encabezado.",
  "settings.apiDocs.error.403":
    "La clave no tiene el alcance requerido o el flujo no está en su lista permitida.",
  "settings.apiDocs.error.404":
    "El conjunto de reglas o cálculo no existe, o el cálculo pertenece a otra integración.",
  "settings.apiDocs.error.409":
    "No hay conjunto publicado actual, o se reutilizó Idempotency-Key con otro cuerpo. Mantenga estable la versión fijada y el cuerpo.",
  "settings.apiDocs.error.413": "La solicitud JSON supera el límite de 5 MiB.",
  "settings.apiDocs.error.429":
    "La integración superó 120 lecturas o 10 lotes en el minuto. Espere los segundos de Retry-After y repita el lote con su Idempotency-Key.",
  "settings.apiDocs.error.500":
    "Fallo inesperado del servicio. Conserve los IDs de solicitud y correlación; repita un lote solo con el mismo Idempotency-Key.",
  "settings.apiDocs.ncm":
    "El catálogo NCM contiene clasificación y procedencia. No es una tabla de alícuotas.",
  "settings.apiDocs.operations": "Operaciones",
  "settings.apiDocs.explorerHint":
    "Elija una operación para ver su contrato y un ejemplo seguro de solicitud.",
  "settings.apiDocs.path": "Ruta",
  "settings.apiDocs.method": "Método",
  "settings.apiDocs.limits": "Límites",
  "settings.apiDocs.more": "Parámetros, límites y errores",
  "settings.apiDocs.example": "Ejemplo de solicitud",
  "settings.apiDocs.copyExample": "Copiar ejemplo",
  "settings.apiDocs.copyJson": "Copiar JSON",
  "settings.apiDocs.baseUrlLabel": "URL base de la API",
  "settings.apiDocs.endpoint.current.name": "Conjunto publicado actual",
  "settings.apiDocs.endpoint.current.purpose": "Leer los metadatos del conjunto publicado actual.",
  "settings.apiDocs.endpoint.current.limits":
    "120 lecturas por minuto por integración. Sin parámetros de consulta.",
  "settings.apiDocs.endpoint.rules.name": "Reglas publicadas",
  "settings.apiDocs.endpoint.rules.purpose":
    "Leer reglas gobernadas de una versión publicada o sustituida, siempre con la versión fijada.",
  "settings.apiDocs.endpoint.rules.limits":
    "120 lecturas por minuto. rulesetVersion es obligatorio; limit es como máximo 100.",
  "settings.apiDocs.endpoint.ncm.name": "Catálogo NCM",
  "settings.apiDocs.endpoint.ncm.purpose":
    "Leer clasificación y procedencia NCM. Esto es un catálogo, no una tabla de alícuotas.",
  "settings.apiDocs.endpoint.ncm.limits":
    "120 lecturas por minuto. cursor, limit (máximo 100) y q son opcionales. El catálogo no contiene alícuotas.",
  "settings.apiDocs.endpoint.batch.name": "Cálculo por lotes",
  "settings.apiDocs.endpoint.batch.purpose":
    "Enviar un lote acotado de cálculo contra un flujo permitido.",
  "settings.apiDocs.endpoint.batch.limits":
    "10 lotes por minuto. Como máximo 500 elementos y 5 MiB. Idempotency-Key es obligatorio.",
  "settings.apiDocs.endpoint.calculation.name": "Resultado del cálculo",
  "settings.apiDocs.endpoint.calculation.purpose":
    "Leer un cálculo creado por esta integración y organización.",
  "settings.apiDocs.endpoint.calculation.limits":
    "120 lecturas por minuto. El cálculo debe pertenecer a esta integración y organización.",
  "settings.apiDocs.batchJson": "Cuerpo de la solicitud: batch.json",
  "settings.developers.title": "Desarrolladores",
  "settings.developers.description.integrations":
    "Cree y administre la clave individual de cada sistema integrado.",
  "settings.developers.description.api-docs":
    "Endpoints, formatos y ejemplos para integrar sistemas con la API fiscal.",
  "settings.developers.description.mcp":
    "Herramientas que los asistentes de IA pueden usar con una clave de integración.",
  "settings.developers.description.requests":
    "Diagnóstico seguro de las solicitudes recientes hechas por las integraciones.",
  "settings.requests.title": "Solicitudes recientes",
  "settings.requests.hint": "Solo metadatos · últimos 30 días",
  "settings.requests.description":
    "Revise intentos autenticados de las integraciones para investigar estado, duración y correlación sin exponer credenciales ni contenido.",
  "settings.requests.demoNotice":
    "Demo local: estas filas provienen de fixtures del mock y no representan registros reales.",
  "settings.requests.liveNotice":
    "El historial se limita a los últimos 30 días y contiene solo metadatos del intento.",
  "settings.requests.authenticatedNotice":
    "Solo se registran intentos autenticados en las cinco rutas de integración admitidas; los 401 sin identidad y los fallos del gateway no se muestran. Ventana visible: últimos 30 días.",
  "settings.requests.filter.status": "Estado HTTP",
  "settings.requests.filter.statusHint": "Ingrese un estado entre 100 y 599.",
  "settings.requests.filter.integration": "Integración",
  "settings.requests.filter.key": "Clave de integración",
  "settings.requests.filter.method": "Método",
  "settings.requests.filter.route": "Ruta",
  "settings.requests.filter.problem": "Código del problema",
  "settings.requests.filter.all": "Todos",
  "settings.requests.filter.get": "GET",
  "settings.requests.filter.post": "POST",
  "settings.requests.filter.replayed": "Repetición idempotente",
  "settings.requests.filter.replayedOnly": "Solo repetidas",
  "settings.requests.filter.notReplayed": "Sin repetición",
  "settings.requests.column.when": "Cuándo",
  "settings.requests.column.operation": "Operación",
  "settings.requests.column.status": "Estado HTTP",
  "settings.requests.column.duration": "Duración",
  "settings.requests.column.integration": "Integración",
  "settings.requests.column.key": "Clave",
  "settings.requests.column.replay": "Repetición",
  "settings.requests.replayed": "Sí",
  "settings.requests.notReplayed": "No",
  "settings.requests.tableCaption": "Solicitudes de integración de los últimos 30 días",
  "settings.requests.empty.title": "No hay solicitudes recientes",
  "settings.requests.empty.body":
    "No hay intentos que coincidan con estos filtros en la ventana de 30 días.",
  "settings.requests.details.title": "Detalles de la solicitud",
  "settings.requests.details.notice":
    "Solo metadatos. El UUID del intento en el servidor identifica este intento registrado; requestId y correlationId pueden venir del cliente y son opcionales. No se muestran clave, cuerpo, query string ni stack trace.",
  "settings.requests.details.attemptId": "UUID del intento en el servidor",
  "settings.requests.details.organization": "Organización",
  "settings.requests.details.integration": "ID de integración",
  "settings.requests.details.key": "ID de clave",
  "settings.requests.details.environment": "Entorno",
  "settings.requests.details.method": "Método",
  "settings.requests.details.route": "Ruta",
  "settings.requests.details.when": "Cuándo",
  "settings.requests.details.duration": "Duración",
  "settings.requests.details.status": "Estado HTTP",
  "settings.requests.details.problem": "Código del problema",
  "settings.requests.details.requestId": "requestId",
  "settings.requests.details.correlationId": "correlationId",
  "settings.requests.details.replay": "Repetición idempotente",
  "settings.requests.details.available": "Disponible",
  "settings.requests.details.unavailable": "No disponible",
  "settings.requests.details.cause": "Causa",
  "settings.requests.details.diagnostic": "Diagnóstico",
  "settings.requests.details.noCause": "Completada sin código de problema",
  "settings.requests.details.nextStep": "Siguiente paso",
  "settings.requests.details.nextStep.retryWrite":
    "Reintente con la misma clave de idempotencia y conserve los identificadores para soporte.",
  "settings.requests.details.nextStep.retryRead":
    "Repita la solicitud y conserve los identificadores para soporte si el error del servicio continúa.",
  "settings.requests.details.nextStep.rateLimited":
    "Espere el valor Retry-After de la respuesta y después repita la misma operación idempotente.",
  "settings.requests.details.nextStep.permission":
    "Revise el alcance de la clave API y el flujo permitido para esta integración.",
  "settings.requests.details.nextStep.validation":
    "Revise los parámetros y el entorno de la solicitud; después vuelva a intentarlo.",
  "settings.requests.details.nextStep.idempotency":
    "Reutilice la clave solo con el mismo cuerpo o envíe el cuerpo modificado con una clave de idempotencia nueva.",
  "settings.requests.details.nextStep.notFound":
    "Revise el identificador del recurso o la versión publicada del conjunto de reglas.",
  "settings.requests.details.nextStep.check":
    "Revise el alcance, el flujo y los parámetros; después vuelva a intentarlo.",
  "settings.requests.details.nextStep.continue":
    "No hace falta actuar. Conserve el UUID de intento para trazabilidad.",
  "settings.requests.details.identifiers": "Identificadores",
  "settings.requests.details.more": "Más metadatos",
  "settings.requests.recordingDetails": "Qué se registra",
  "settings.requests.status.invalid": "El estado debe estar entre 100 y 599.",
  "settings.requests.status.http": "HTTP {code}",

  "a11y.skipToContent": "Ir al contenido principal",
  "a11y.breadcrumb": "Ruta de navegación",
  "a11y.mainLandmark": "Contenido principal",
  "a11y.routeAnnounce": "{title} cargado",
  "a11y.sortState": "ordenado {direction}",
  "a11y.rowActions": "Acciones de la fila",
  "a11y.drawerOpened": "Panel de detalles abierto",
  "a11y.drawerClosed": "Panel de detalles cerrado",
  "a11y.statusLabel": "Estado: {label}",
  "status.evidence.NEW": "Nuevo",
  "status.evidence.IN_REVIEW": "En revisión",
  "status.evidence.APPROVED": "Aprobado",
  "status.evidence.REJECTED": "Rechazado",
  "status.evidence.DUPLICATE": "Duplicado",
  "status.proposal.DRAFT": "Borrador",
  "status.proposal.PENDING_REVIEW": "Pendiente de revisión",
  "status.proposal.APPROVED": "Aprobada",
  "status.proposal.REJECTED": "Rechazada",
  "status.proposal.PUBLISHED": "Publicada",
  "status.ruleset.DRAFT": "Borrador",
  "status.ruleset.PENDING_REVIEW": "Pendiente de revisión",
  "status.ruleset.IN_REVIEW": "En revisión",
  "status.ruleset.APPROVED": "Aprobado",
  "status.ruleset.PUBLISHED": "Publicado",
  "status.ruleset.SUPERSEDED": "Sustituido",
  "status.ruleset.REJECTED": "Rechazado",
  "status.source.ACTIVE": "Activa",
  "status.source.PAUSED": "Pausada",
  "status.source.DEGRADED": "Degradada",
  "status.source.DISABLED": "Desactivada",
  "status.run.QUEUED": "En cola",
  "status.run.DISCOVERING": "Descubriendo",
  "status.run.FETCHING": "Descargando",
  "status.run.EXTRACTING": "Extrayendo",
  "status.run.WAITING_REVIEW": "Pendiente de revisión",
  "status.run.STALLED": "Detenida",
  "status.run.SUCCEEDED": "Completada",
  "status.run.PARTIAL": "Parcial",
  "status.run.FAILED": "Falló",
  "status.run.CANCELLED": "Cancelada",
  "status.run.CREATED": "Creado",
  "status.run.REUSED": "Reutilizado",
  "status.calculation.CALCULATED": "Calculado",
  "status.calculation.REVIEW_REQUIRED": "Requiere revisión",
  "status.audit.ALLOWED": "Permitido",
  "status.audit.DENIED": "Denegado",
  "a11y.keyboardHint": "Use {key} para abrir el ítem enfocado.",

  "rules.guide.link": "Guía de la matriz fiscal",
  "rules.guide.eyebrow": "Cómo leer una ruta",
  "rules.guide.title": "Matriz fiscal por producto y trayecto",
  "rules.guide.description":
    "Use esta página para entender qué hechos deben coincidir antes de que una regla ICMS o ICMS-ST entre en revisión.",
  "rules.guide.back": "Volver a la consulta",
  "rules.guide.equationLabel": "La clave de lectura",
  "rules.guide.equationTitle": "Cuatro hechos cierran el contexto de la operación",
  "rules.guide.formula": "NCM × CEST × origen → destino",
  "rules.guide.equationAria": "Flujo NCM, CEST, origen, destino y resultado de revisión",
  "rules.guide.equationNote":
    "La combinación encuentra evidencia aplicable. No crea una alícuota por sí sola: vigencia, descripción legal, operación y procedencia aún deben comprobarse.",
  "rules.guide.result.code": "REVISIÓN",
  "rules.guide.variable.ncm.title": "Producto",
  "rules.guide.variable.ncm.detail": "Clasificación NCM de 8 dígitos",
  "rules.guide.variable.cest.title": "Sustitución",
  "rules.guide.variable.cest.detail": "CEST y descripción del artículo",
  "rules.guide.variable.origin.title": "Origen",
  "rules.guide.variable.origin.detail": "UF de salida de la operación",
  "rules.guide.variable.destination.title": "Destino",
  "rules.guide.variable.destination.detail": "UF de llegada de la operación",
  "rules.guide.variable.result.title": "Regla candidata",
  "rules.guide.variable.result.detail": "Evidencia, vigencia y revisión humana",
  "rules.guide.stepsTitle": "Cómo se aplica la matriz",
  "rules.guide.stepsHint": "El orden evita convertir clasificación en impuesto.",
  "rules.guide.step.1.title": "Clasifique el producto",
  "rules.guide.step.1.detail":
    "Confirme el NCM oficial y conserve la descripción y la fecha de clasificación.",
  "rules.guide.step.2.title": "Valide el CEST",
  "rules.guide.step.2.detail":
    "Relacione el CEST y la descripción legal; NCM solo no confirma ICMS-ST.",
  "rules.guide.step.3.title": "Defina la ruta",
  "rules.guide.step.3.detail":
    "Indique origen, destino, tipo de operación y fecha del hecho generador.",
  "rules.guide.step.4.title": "Reúna la legislación",
  "rules.guide.step.4.detail":
    "Busque RICMS, convenio, protocolo, MVA/PMPF y actos de modificación o revocación.",
  "rules.guide.step.5.title": "Envíe a revisión",
  "rules.guide.step.5.detail":
    "Solo una propuesta aprobada y publicada puede usarse como regla ejecutable.",
  "rules.guide.matrixTitle": "Qué responde cada campo",
  "rules.guide.matrixHint": "La tabla orienta la investigación; no sustituye la fuente oficial.",
  "rules.guide.matrixAria": "Matriz de hechos fiscales",
  "rules.guide.matrix.variable": "Campo",
  "rules.guide.matrix.question": "Pregunta",
  "rules.guide.matrix.output": "Salida esperada",
  "rules.guide.matrix.ncm.variable": "NCM",
  "rules.guide.matrix.ncm.question": "¿Qué mercancía es exactamente?",
  "rules.guide.matrix.ncm.output": "Código y descripción oficial; no una alícuota.",
  "rules.guide.matrix.cest.variable": "CEST",
  "rules.guide.matrix.cest.question": "¿Hay artículo y descripción de ST compatibles?",
  "rules.guide.matrix.cest.output": "Catálogo y aplicabilidad a confirmar en la legislación.",
  "rules.guide.matrix.origin.variable": "Origen",
  "rules.guide.matrix.origin.question": "¿De qué UF sale la operación?",
  "rules.guide.matrix.origin.output": "Alícuota interestatal y beneficios de salida a investigar.",
  "rules.guide.matrix.destination.variable": "Destino",
  "rules.guide.matrix.destination.question": "¿A qué UF y tipo de destinatario llega?",
  "rules.guide.matrix.destination.output": "Alícuota interna, protocolo y excepciones a comprobar.",
  "rules.guide.matrix.result.variable": "Resultado",
  "rules.guide.matrix.result.question": "¿Existe evidencia suficiente y vigente?",
  "rules.guide.matrix.result.output": "Candidato, revisión necesaria o regla publicada.",
  "rules.guide.routes.column.detail": "Qué cambia",
  "rules.guide.routesTitle": "Rutas prioritarias",
  "rules.guide.routesHint":
    "El estado de distribución y el destino cambian la investigación jurídica.",
  "rules.guide.route.esSp.name": "ES → SP",
  "rules.guide.route.esSp.status": "Prioridad P0",
  "rules.guide.route.esSp.detail":
    "Cruzar GETRI, ST, MVA/CEST de ES con la legislación de destino de SP.",
  "rules.guide.route.spSp.name": "SP → SP",
  "rules.guide.route.spSp.status": "Prioridad P0",
  "rules.guide.route.spSp.detail":
    "Verificar RICMS, Portarias SRE, vigencia y revocaciones dentro de SP.",
  "rules.guide.route.rj.name": "SP/ES → RJ",
  "rules.guide.route.rj.status": "Fuente bloqueada",
  "rules.guide.route.rj.detail":
    "La fuente oficial de RJ debe estar accesible antes de proponer una regla para esta ruta.",
  "rules.guide.sourcesTitle": "Fuentes para empezar",
  "rules.guide.sourcesHint": "Guarde URL, acto, vigencia y el fragmento usado.",
  "rules.guide.source.ncm.title": "Receita Federal · Classif",
  "rules.guide.source.ncm.detail": "NCM, notas legales e historial de clasificación.",
  "rules.guide.source.cest.title": "CONFAZ · Convenio 142/18",
  "rules.guide.source.cest.detail":
    "Catálogo CEST de referencia; no prueba incidencia por sí solo.",
  "rules.guide.source.es.title": "SEFAZ-ES · MVA/PMPF/PCF/PMC",
  "rules.guide.source.es.detail": "Parámetros y actos estatales para ST en ES.",
  "rules.guide.source.sp.title": "SEFAZ-SP · Portaria SRE 12/2026",
  "rules.guide.source.sp.detail": "NCM, CEST, IVA-ST y condiciones de vigencia en SP.",
  "rules.guide.guardrailTitle": "Regla de seguridad",
  "rules.guide.guardrailBody":
    "NCM y CEST son identificadores de referencia. No copie una tasa de una fuente genérica ni trate un CEST como prueba automática de ST.",
  "rules.guide.guardrailNote":
    "Si falta NCM, CEST, UF, fecha o fundamento legal, el resultado queda en revisión fiscal.",
  "rules.guide.openLookup": "Abrir consulta por NCM y ruta",
  "errors.PERMISSION_DENIED": "No tiene permiso para esta operación.",
  "errors.UNAUTHENTICATED": "Sesión ausente o expirada.",
  "errors.SEPARATION_OF_DUTIES_VIOLATION": "Ya registró una decisión en esta propuesta.",
  "errors.VERSION_PRECONDITION_FAILED": "El registro cambió desde la carga. Recargue.",
  "errors.IDEMPOTENCY_KEY_REUSED": "Este intento ya se usó con datos diferentes.",
  "errors.RULESET_STALE_BASE": "La base del borrador está desactualizada.",
  "errors.BATCH_TOO_LARGE": "Lote por encima del límite permitido.",
  "errors.RATE_LIMITED": "Demasiadas solicitudes. Espere e intente de nuevo.",
  "errors.DEPENDENCY_UNAVAILABLE": "Una dependencia del servicio no está disponible.",
  "errors.ARTIFACT_UNAVAILABLE": "El documento de evidencia almacenado no está disponible.",
  "errors.OPERATION_NOT_AVAILABLE": "Esta operación no está habilitada en este espacio.",
  "errors.NOT_FOUND": "Registro no encontrado.",
  "errors.NO_PUBLISHED_RULESET": "No hay un conjunto de reglas publicado.",
  "errors.VALIDATION_FAILED": "Datos inválidos en la solicitud.",
  "errors.ENVIRONMENT_MISMATCH": "El contexto de la solicitud difiere del servicio.",
  "errors.INTERNAL_ERROR": "Error interno del servicio.",
  "errors.NETWORK": "Fallo de red al contactar la API.",
  "errors.TIMEOUT": "La API tardó demasiado en responder.",
  "errors.GATEWAY_TIMEOUT": "El servidor superó el tiempo límite.",
  "errors.UNEXPECTED_RESPONSE": "El servidor respondió en un formato inesperado.",
  "failure.offline.what": "Está sin conexión a internet.",
  "failure.offline.todo": "Vuelva a conectarse e intente de nuevo. No se envió nada.",
  "failure.network.what": "No fue posible contactar la API fiscal.",
  "failure.network.todo": "Revise su conexión o VPN e intente de nuevo.",
  "failure.timeout.what": "La API tardó demasiado en responder.",
  "failure.timeout.todo":
    "Espere un momento e intente de nuevo. Las operaciones largas siguen en el servidor.",
  "failure.gatewayTimeout.what": "El servidor superó el tiempo límite al procesar.",
  "failure.gatewayTimeout.todo":
    "Intente de nuevo en unos instantes. Si es un lote grande, divida el archivo.",
  "failure.unavailable.what": "Un servicio necesario no está disponible por ahora.",
  "failure.unavailable.todo":
    "Intente de nuevo en unos instantes. Si persiste, contacte a soporte e informe el código de soporte, si lo hay.",
  "failure.notAvailable.what": "Esta operación no está disponible en este entorno.",
  "failure.notAvailable.todo": "Use otra opción o pida a un administrador que la habilite.",
  "failure.rateLimited.what": "Demasiadas solicitudes en poco tiempo.",
  "failure.rateLimited.todo": "Espere unos segundos e intente de nuevo.",
  "failure.inProgress.what": "Esta operación sigue en curso.",
  "failure.inProgress.todo": "Espere unos segundos y verifique de nuevo; no es necesario reenviar.",
  "failure.validation.what": "Algunos datos no fueron aceptados.",
  "failure.validation.todo": "Corrija los campos o el archivo indicado y envíe de nuevo.",
  "failure.unauthenticated.what": "Su sesión expiró.",
  "failure.unauthenticated.todo": "Inicie sesión de nuevo y repita la acción.",
  "failure.forbidden.what": "No tiene permiso para esta acción.",
  "failure.forbidden.todo":
    "Pida acceso a un administrador e informe el código de soporte, si lo hay.",
  "failure.notFound.what": "No se encontró el registro.",
  "failure.notFound.todo": "Puede haber sido eliminado. Vuelva a la lista y ábralo de nuevo.",
  "failure.conflict.what": "El registro cambió mientras usted trabajaba.",
  "failure.conflict.todo": "Recargue la página para ver la versión actual y repita la acción.",
  "failure.tooLarge.what": "El archivo o lote supera el límite aceptado.",
  "failure.tooLarge.todo": "Divida la planilla en archivos más pequeños y envíe de nuevo.",
  "failure.server.what": "El servidor encontró un error inesperado.",
  "failure.server.todo":
    "Intente de nuevo. Si persiste, contacte a soporte e informe el código de soporte, si lo hay.",
  "failure.unexpected.what": "El servidor respondió en un formato inesperado.",
  "failure.unexpected.todo":
    "Intente de nuevo. Si persiste, actualice la página o contacte a soporte e informe el código de soporte, si lo hay.",
  "failure.committed.what": "Puede haberse completado — verifique antes de repetir.",
  "failure.committed.todo":
    "La respuesta no llegó a tiempo. Revise en Lotes si el elemento ya existe antes de enviar de nuevo, para no duplicar.",
  "failure.verifying": "Puede haberse completado — verificando…",
  "failure.verifyingBody":
    "La respuesta tardó, pero el servidor puede haber terminado. Estamos confirmando sin duplicar nada.",
  "failure.supportId": "Código para soporte: {id}",
  "failure.openLots": "Verificar en Lotes",
  "failure.longRunning":
    "Las operaciones largas siguen en el servidor: puede salir de esta pantalla y retomar luego en Lotes.",
  "calc.boundary.title": "La calculadora dejó de responder",
  "calc.boundary.body":
    "Esta pantalla encontró un error inesperado y no guardó nada. Recárguela; si persiste, informe el código a soporte.",
  "calc.boundary.reload": "Recargar la pantalla",
  "calc.boundary.home": "Volver al inicio",
  "errors.notFoundRoute": "Página no encontrada.",
  "errors.notFoundBody": "La ruta solicitada no existe o no está disponible en este espacio.",
  "errors.unexpectedTitle": "La operación se interrumpió",
  "errors.unexpectedBody":
    "La consola encontró un error inesperado. Intente de nuevo o vuelva al resumen; no se confirmó ningún cambio.",
  "legacy.band.excellent": "Excelente",
  "legacy.band.healthy": "Saludable",
  "legacy.band.fair": "Justa",
  "legacy.band.critical": "Crítica",
  "legacy.yes": "Sí",
  "legacy.no": "No",
  "legacy.blocked": "Cálculo bloqueado",
  "legacy.wf.title": "Waterfall del CMV — 12 pasos",
  "legacy.wf.benchmark": "Referencia: Mondial_BackChannel_VFinal_9_EN.xlsx",
  "legacy.wf.entry": "Valor del ítem con ICMS/PIS/COFINS",
  "legacy.wf.icmsEmbedded": "↳ ICMS incluido (NF × {rate} bruto)",
  "legacy.wf.pisEmbedded": "↳ PIS incluido ((NF − {own}) × 1,65%)",
  "legacy.wf.cofinsEmbedded": "↳ COFINS incluido ((NF − {own}) × 7,6%)",
  "legacy.wf.purchaseValue": "Valor final de compra",
  "legacy.wf.icmsCreditClosed": "(−) Crédito de ICMS [∅ Caso A — cadena ST cerrada]",
  "legacy.wf.icmsCredit": "(−) Crédito de ICMS [NF × {rate} bruto]",
  "legacy.wf.pisCredit": "(−) Crédito de PIS [(NF − {own}) × 1,65%]",
  "legacy.wf.cofinsCredit": "(−) Crédito de COFINS [(NF − {own}) × 7,6%]",
  "legacy.wf.totalCredits": "(−) Créditos totales",
  "legacy.wf.fiscalCMV": "CMV fiscal",
  "legacy.wf.salePriceZero": "Precio de venta (markup 0% — traslado del costo)",
  "legacy.wf.salePrice": "Precio de venta ({markup}% de margen sobre la venta ÷ {rest}%)",
  "legacy.wf.freightRevenue": "(+) Flete cobrado al comprador",
  "legacy.wf.bcIcms": "↳ BC ICMS = venta + flete = {value}",
  "legacy.wf.icmsSaleClosed": "(−) ICMS en la venta [∅ cadena ST cerrada]",
  "legacy.wf.icmsSale": "(−) ICMS en la venta (BC_ICMS × {rate}%)",
  "legacy.wf.pisSale": "(−) PIS en la venta [(BC_ICMS − ICMS) × 1,65%] base {base}",
  "legacy.wf.cofinsSale": "(−) COFINS en la venta [(BC_ICMS − ICMS) × 7,6%]",
  "legacy.wf.protocol": "Protocolo ST ({route}): {status}",
  "legacy.wf.protocolClosed": "CERRADO",
  "legacy.wf.protocolOpen": "ABIERTO — aplica crédito de ICMS",
  "legacy.wf.difal": "(−) DIFAL ({uf} destino)",
  "legacy.wf.fcp": "(−) FCP ({uf})",
  "legacy.wf.logistics": "(−) Logística (costo del transportista)",
  "legacy.wf.freightCost": "(−) Costo logístico del flete",
  "legacy.wf.commission": "(−) Comisión",
  "legacy.wf.paymentFee": "(−) Tarifa de pago ({fee})",
  "legacy.wf.marginValue": "Margen",
  "legacy.ncm.missing":
    "NCM no encontrado en la tabla fiscal de la calculadora anterior. Cálculo automático bloqueado; revise manualmente.",
  "legacy.ncm.found": "{description} · CEST {cest} · IPI {ipi}% · IVA {iva}% · ST en SP: {st}",
  "legacy.buyerInfo":
    "El régimen del comprador no entra en los tributos de salida de BCH; solo define si aplica el DIFAL.",
  "legacy.difal.applies":
    "Aplica DIFAL interestatal. UF destino {uf}: {base}% + FCP {fcp}% = {total}% sobre el precio de venta BCH.",
  "legacy.getnet.mdr": "MDR Getnet",
  "legacy.getnet.anticipation": "Anticipación ({n}× × 1,59%)",
  "legacy.getnet.effective": "Tasa efectiva",
  "legacy.getnet.contract": "Tabla Getnet del contrato 3313293 (Tabla 2).",
  "legacy.boleto.total": "{n} boleto(s) × {fee} = {total}",
  "legacy.pix.free": "PIX sin tarifa en el acuerdo B2B actual de BCH (R$ 0,00 / 0,00%).",
  "legacy.result.salePrice": "Precio de venta (NF salida)",
  "legacy.result.difal": "DIFAL + FCP (UF destino)",
  "legacy.result.marginPct": "Margen %",
  "legacy.st.caseA": "Caso A",
  "legacy.st.caseB": "Caso B",
  "legacy.st.paidBySupplier": "ICMS-ST pagado por el proveedor (verificar con la NF)",
  "legacy.st.payableByBch": "ICMS-ST a pagar por BCH",
  "legacy.st.adjusted": "MVA ajustada",
  "legacy.st.base": "base ST",
  "legacy.st.creditClosed": "Crédito de ICMS = R$ 0,00 (cadena ST cerrada)",
  "legacy.st.creditOpen": "Crédito de ICMS = {value} (cadena abierta)",
  "legacy.ipi.gross": "Base IPI bruta (estándar Mondial): {base} × {rate}% = {value}",
  "legacy.ipi.net": "Base IPI neta (legado): {base} × {rate}% = {value}",
  "legacy.v15Fields": "Campos v15: NF, anticipación y traslado",
  "legacy.spReimbursement": "Resarcimiento de ICMS-ST SP pendiente: {value}",
  "legacy.memory": "Memoria de cálculo",
  "legacy.memoryGenerated": "Generada el {at}",
  "legacy.bestCenter": "Mejor centro: {center}",
  "legacy.serviceResult.cm1": "CM1 / GMV",
  "legacy.int.pl": "P&L — Intermediación",
  "legacy.int.gmv": "GMV (total de la NF)",
  "legacy.int.serviceValue": "Valor del servicio (tasa de intermediación)",
  "legacy.int.irrf": "(−) IRRF retenido",
  "legacy.int.csll": "(−) CSLL retenida",
  "legacy.int.cofins": "(−) COFINS retenida",
  "legacy.int.pis": "(−) PIS retenido",
  "legacy.int.netCash": "(=) Neto a cobrar",
  "legacy.int.valueForMargin": "(=) Valor para margen",
  "legacy.int.operations": "(−) Operaciones",
  "legacy.int.cm1": "(=) CM1 (antes de comisiones)",
  "legacy.int.approved": "Aprobado para vender",
  "legacy.int.notApproved": "No aprobado (< 8%)",
  "legacy.int.sellerUF": "UF del vendedor",
  "legacy.int.buyerUF": "UF del comprador",
  "legacy.int.sellerTerms": "Condición — vendedor",
  "legacy.int.buyerTerms": "Condición — comprador",
  "legacy.int.ownPis": "PIS propio",
  "legacy.int.ownCofins": "COFINS propio",
  "legacy.int.revenueTaxes": "Tributos sobre el ingreso",
  "legacy.int.withholdingTotal": "Retención total",
  "legacy.int.cashFlow": "Flujo de caja — obligaciones a pagar",
  "legacy.int.ownPisCofins": "PIS + COFINS propios",
  "legacy.int.onService": "6,15% sobre el servicio",
  "legacy.terms.Upfront": "Al contado",
  "legacy.terms.30": "30 días",
  "legacy.terms.60": "60 días",
  "legacy.terms.90": "90 días",
  "legacy.batch.noDefaults": "sin estándar",
  "legacy.batch.commission": "{pct}% comisión",
  "legacy.batch.exportReport": "Exportar informe (formato v8 original)",
  "legacy.batch.route": "NCM / UF",
  "legacy.batch.purchase": "= Compra",
  "legacy.batch.saleTaxes": "Imp. salida",
  "legacy.batch.profit": "Ganancia",
  "legacy.batch.total": "Total ({count} filas)",
  "legacy.batch.kpi.revenue": "Ingreso total",
  "legacy.batch.kpi.profit": "Ganancia neta",
  "legacy.batch.kpi.margin": "Margen promedio",
  "legacy.batch.kpi.critical": "Zona crítica",
  "legacy.batch.kpi.products": "{count} producto(s)",
  "legacy.batch.kpi.review": "{count} en revisión",
  "legacy.batch.kpi.merch": "Compra/venta (mercadería) · {count}",
  "legacy.batch.kpi.int": "Intermediación (GMV × tasa de intermediación) · {count}",
  "legacy.batch.showWaterfall": "Ver waterfall",
  "legacy.batch.hideWaterfall": "Ocultar waterfall",
  "legacy.option.ecommerce": "Comercio electrónico",
  "legacy.wf.ipiGross": "(+) IPI ({rate}% bruta)",
  "legacy.wf.ipiNet": "(+) IPI ({rate}% neta)",
  "legacy.wf.icmsStPaid": "(+) ICMS-ST pagado por el proveedor",
  "legacy.wf.icmsStAnticipation": "(+) Anticipo ICMS-ST de entrada (RICMS/SP Art. 426-A)",
  "legacy.wf.icmsStPayable": "(+) ICMS-ST a pagar por BCH",
  "legacy.wf.feeBoleto": "Boleto ×{n}",
  "legacy.wf.feePix": "PIX",
  "legacy.wf.protocolNa": "N/A",
  "legacy.wf.feeGetnet": "Getnet {pct}%",
  "legacy.alert.OPERATION_DATE_MISSING.info":
    "Sin fecha de la operación: se usa la de hoy. Los parámetros por fecha pueden variar.",
  "legacy.alert.NCM_MISSING.error": "El NCM es obligatorio para el cálculo automático.",
  "legacy.alert.NCM_NOT_IN_TABLE.error":
    "El NCM {ncm} no está en la tabla de parámetros fiscales. Se requiere revisión manual.",
  "legacy.alert.CEST_MISSING.warning": "El NCM {ncm} exige CEST, pero no hay ninguno configurado.",
  "legacy.alert.CEST_MISSING.error":
    "El NCM {ncm} tiene el CEST pendiente de confirmación (VALIDAR). El cálculo queda bloqueado hasta que el área fiscal o jurídica confirme el CEST.",
  "legacy.alert.ST_REVOKED_BY_PORTARIA.info": "ST de SP revocada para este CEST: {detail}",
  "legacy.alert.ST_EVIDENCE_MISSING.error":
    "ST marcado como pagado sin importe informado (DQ-01). Cálculo bloqueado.",
  "legacy.alert.ST_EVIDENCE_MISSING.warning":
    "ST marcado como pagado sin el valor del proveedor. Se usa R$ 0; verifíquelo manualmente.",
  "legacy.alert.ST_COLLECTED.warning":
    "ST ya cobrado: ICMS-ST = R$ 0 · crédito de ICMS = R$ 0 · débito de ICMS en la salida = R$ 0",
  "legacy.alert.CALCULATION_DEVIATION.error":
    "El markup debe ser menor que 100% (recibido {pct}%). Cálculo bloqueado.",
  "legacy.alert.ST_PROTOCOL_REVOKED.info": "Protocolo SP→{uf}: {detail}. Sin ST en la NF de BCH.",
  "legacy.alert.ICMS_DOUBLE_TAX.error":
    "Débito de ICMS en la salida > 0 con ST ya cobrado: doble tributación detectada.",
  "legacy.alert.ST_PROTOCOL_VERIFY.warning":
    "Protocolo de ST SP → {uf}: requiere verificación en CONFAZ.",
  "legacy.batch.supplierOther": "Otro proveedor (sin configuración)",
  "legacy.batch.kind.int": "INT",
  "legacy.batch.kind.resale": "C/V",
  "legacy.batch.takeIss": "Tasa {take}% · ISS {iss}%",
  "legacy.batch.gmv": "GMV {value}",
  "legacy.batch.kpi.intSplit": "GMV {gmv} · CM1 {cm1} · {pct}",
  "legacy.ncm.pRedBC": "pRedBC {pct}%",
  "overview.home.eyebrow": "Visión general",
  "overview.home.title": "Calcule y siga sus lotes",
  "overview.home.description":
    "Calculadora, reglas publicadas y el historial de cada lote en un solo lugar.",
  "overview.home.cta.eyebrow": "Calcular",
  "overview.home.cta.title": "Calculadora fiscal",
  "overview.home.cta.body":
    "Calcule un producto por NCM o envíe una planilla con el lote completo.",
  "overview.home.cta.upload": "Enviar planilla",
  "overview.home.cta.single": "Calcular un producto",
  "overview.home.cta.ncmLabel": "NCM (8 dígitos)",
  "overview.home.cta.ncmPlaceholder": "Ej.: 8471.30.12",
  "overview.home.cta.ncmSubmit": "Calcular",
  "overview.home.cta.ncmInvalid": "Ingrese los 8 dígitos del NCM.",
  "overview.home.cta.readerTitle": "Consultar regla por NCM",
  "overview.home.cta.readerBody":
    "Su perfil es de lectura. Consulte la regla publicada para un NCM y ruta.",
  "overview.home.cta.readerSubmit": "Consultar",
  "overview.home.rules.eyebrow": "Reglas publicadas",
  "overview.home.rules.count": "reglas fiscales vigentes",
  "overview.home.rules.ncms": "{count} NCM",
  "overview.home.rules.routes": "{count} rutas UF → UF",
  "overview.home.rules.st": "{count} con ICMS-ST",
  "overview.home.rules.expiring": "{count} vencen en 30 días",
  "overview.home.rules.version": "Versión {version} · publicada el {date}",
  "overview.home.rules.coverage": "Cobertura por familia",
  "overview.home.rules.openLibrary": "Ver todas las reglas",
  "overview.home.rules.openCoverage": "Ver cobertura por UF",
  "overview.home.rules.none": "Todavía no hay un conjunto de reglas publicado.",
  "overview.home.new.eyebrow": "Reglas nuevas",
  "overview.home.new.title": "Qué cambió en la versión {version}",
  "overview.home.new.since": "Comparado con {from} · publicada {relative}",
  "overview.home.new.sinceDate": "Comparado con {from} · última publicación el {date}",
  "overview.home.new.added": "Nueva",
  "overview.home.new.changed": "Modificada",
  "overview.home.new.addedCount": "+{count} nuevas",
  "overview.home.new.changedCount": "{count} modificadas",
  "overview.home.new.removedCount": "−{count} eliminadas",
  "overview.home.new.national": "Nacional",
  "overview.home.new.validFrom": "vigente desde {date}",
  "overview.home.new.more.one": "Ver {count} cambio más",
  "overview.home.new.more.other": "Ver {count} cambios más",
  "overview.home.new.openDiff": "Ver diferencias completas",
  "overview.home.new.openHistory": "Historial de publicaciones",
  "overview.home.new.empty": "Ninguna regla nueva o modificada en esta versión.",
  "overview.home.new.noBaseline":
    "Esta es la primera versión publicada; no hay base para comparar.",
  "overview.home.jobs.eyebrow": "Historial de lotes",
  "overview.home.jobs.title": "Últimos lotes procesados",
  "overview.home.jobs.items.one": "{count} ítem",
  "overview.home.jobs.items.other": "{count} ítems",
  "overview.home.jobs.review": "{count} para revisión",
  "overview.home.jobs.single": "Cálculo individual",
  "overview.home.jobs.openAll": "Ver historial completo",
  "overview.home.jobs.empty": "Ningún lote procesado en los últimos 30 días.",
  "overview.home.jobs.emptyCta": "Enviar planilla",
  "overview.home.jobs.origin.LOT_UPLOAD": "Planilla",
  "overview.home.jobs.origin.FISCAL_TASK": "Tarea fiscal",
  "overview.home.jobs.origin.CALCULATOR": "Calculadora",
  "overview.home.jobs.origin.INTEGRATION": "Integración",
  "overview.home.jobs.origin.DYNAMIC_LIST": "Lista dinámica",
  "overview.home.jobs.origin.RUNTIME": "Workflow automático",
  "overview.home.admin.title": "Operación de la plataforma",
  "overview.home.admin.description":
    "Pendientes de evidencias, fuentes, colas y actividad técnica.",
  /* -- UX PR 4: Início and Regras ---------------------------------------- */
  "overview.pulse.agent.trendLabel": "Hallazgos por día en los últimos {days} días: {values}",
  "overview.pulse.agent.trend": "{count} hallazgos en {days} días",
  "overview.pulse.research.one": "barrido activo",
  "overview.pulse.research.other": "barridos activos",
  "overview.pulse.research.lastDone": "Último concluido {when}",
  "overview.pulse.research.none": "Todavía no hay barridos",
  "overview.activity.denied": "denegado",
  "home.title": "Inicio",
  "home.commercial.title": "Inicio comercial",
  "home.commercial.description": "Calcule una operación, envíe una planilla o consulte sus notas.",
  "home.commercial.hero.context": "Compra → centro de operación → venta",
  "home.commercial.hero.title": "De la compra al precio de venta, con un próximo paso claro.",
  "home.commercial.hero.description":
    "Declare la compra, la venta y los costos. Consulte el resultado y los pendientes de la operación.",
  "home.commercial.hero.action": "Calcular nueva operación",
  "home.commercial.priority.title": "Prioridad operativa",
  "home.commercial.priority.route":
    "Todos los estados, pasando por São Paulo, hacia todos los estados.",
  "home.commercial.priority.description": "El proveedor y el cliente se definen en cada operación.",
  "home.commercial.priority.next": "Espírito Santo queda para una próxima fase.",
  "home.commercial.priority.qualification": "La prioridad operativa no certifica cobertura fiscal.",
  "home.commercial.destinations": "Accesos del trabajo comercial",
  "home.commercial.calculate.title": "Calculadora",
  "home.commercial.calculate.description": "Una compra, una venta y los costos declarados.",
  "home.commercial.calculate.action": "Simular operación",
  "home.commercial.calculate.readAction": "Abrir calculadora",
  "home.commercial.upload.title": "Lotes y planillas",
  "home.commercial.upload.description":
    "Envíe varios ítems y siga el procesamiento y la revisión de cada lote.",
  "home.commercial.lots.action": "Ver lotes",
  "home.commercial.invoices.help":
    "Consulte notas emitidas y recibidas y los análisis disponibles para la operación.",
  "home.commercial.invoices.title": "Notas fiscales",
  "home.commercial.invoices.action": "Abrir notas fiscales",
  "home.jobs.description":
    "Siga los envíos y abra un lote para consultar el resultado o revisar pendientes.",
  "home.jobs.loading": "Cargando los últimos lotes…",
  "home.jobs.empty":
    "Aún no hay lotes para mostrar. Después del primer envío, siga el avance aquí.",
  "home.jobs.stale":
    "No se pudieron actualizar los lotes. La lista muestra la última consulta disponible.",
  "home.jobs.paused":
    "La actualización de lotes está en pausa. Puede abrir Lotes y reintentar cuando vuelva la conexión.",
  "home.description": "Empiece un cálculo, retome sus lotes y revise las reglas vigentes.",
  "home.cta.body":
    "Escriba el NCM para calcular un producto o envíe una planilla con el lote completo.",
  "home.cta.ncmLabel": "NCM",
  "home.cta.ncmHint": "8 dígitos, con el formato 0000.00.00.",
  "home.cta.or": "o",
  "home.cta.openCalculator": "Abrir la calculadora completa",
  "home.rules.title": "Reglas vigentes",
  "home.rules.inVersion": "reglas en el conjunto {version}",
  "home.rules.fiscalInVersion": "reglas fiscales en el conjunto {version}",
  "home.rules.published": "Publicado el {date}",
  "home.rules.byKind": "Por tipo de regla",
  "home.rules.fiscalFacts": "En las reglas fiscales",
  "home.rules.kindLink": "{kind}: {count} reglas. Abrir en la biblioteca",
  "home.rules.openLibrary": "Abrir biblioteca",
  "home.new.title": "Cambios de la versión",
  "home.new.versus": "comparado con {from}",
  "home.new.openTab": "Ver reglas nuevas",
  "home.jobs.title": "Últimos lotes",
  "home.jobs.openAll": "Ver todos",
  "rules.new.tab": "Reglas nuevas",
  "rules.new.title": "Reglas nuevas",
  "rules.new.description":
    "Lo que entró y lo que cambió en el conjunto vigente, comparado con la versión anterior.",
  "rules.new.none.title": "Nada que comparar",
  "rules.new.rulesTitle": "Reglas nuevas y modificadas",
  "rules.new.rulesHint": "Cada fila abre la regla publicada en esta versión.",
  "rules.new.noItems": "La lista por regla no está disponible; mire los campos modificados abajo.",
  "rules.new.truncated.one":
    "Se muestran {shown} reglas. {count} cambio más aparece en los campos modificados abajo.",
  "rules.new.truncated.other":
    "Se muestran {shown} reglas. {count} cambios más aparecen en los campos modificados abajo.",
  "rules.new.fieldsTitle": "Campos modificados",
  "rules.new.fieldsHint": "Diferencia campo por campo entre las dos versiones.",
  "rules.new.openRuleset": "Abrir publicación",
  "rules.help.short": "Guía",
  "rules.library.count.all.one": "{count} regla en el conjunto {version}",
  "rules.library.count.all.other": "{count} reglas en el conjunto {version}",
  "rules.library.count.filtered": "{count} de {total} reglas en el conjunto {version}",
  "quick.chapters.title": "O navega el catálogo por capítulo SH",
  "quick.chapters.body":
    "Elija un capítulo para ver los productos del catálogo Siscomex. El catálogo identifica la clasificación; no es una alícuota.",
  "quick.chapters.open": "Ver productos del capítulo SH {chapter} · {title}",
  "quick.chapters.results": "Productos del capítulo SH {chapter} · {title}",
  "quick.chapters.resultsBody": "Catálogo Siscomex. Elija el NCM para ver las reglas publicadas.",
  "quick.chapters.clear": "Quitar el filtro del capítulo SH {chapter}",
  "quick.chapters.openRules": "Reglas publicadas del capítulo {chapter}",
  "quick.value.ipiMissing": "Sin IPI publicado",
  "quick.fact.fromTipi": "TIPI nacional",
  "status.job.QUEUED": "En cola",
  "status.job.RUNNING": "En ejecución",
  "status.job.COMPLETED": "Completado",
  "status.job.SUCCEEDED": "Completado",
  "status.job.REVIEW_REQUIRED": "Requiere revisión",
  "status.job.WAITING_REVIEW": "Requiere revisión",
  "status.job.FAILED": "Falló",
  "status.job.CANCELLED": "Cancelado",
  "nav.governance": "Gobernanza",
  "nav.publications": "Publicaciones",
  "coverage.tab": "Cobertura",
  "coverage.title": "Cobertura por familia y UF",
  "coverage.description":
    "Lo que la base publicada guarda por familia fiscal y dónde se concentran las reglas en el mapa.",
  "nav.jobs": "Historial de lotes",
  "lots.title": "Lotes",
  "lots.description":
    "Siga archivos, escenarios e investigaciones. Del origen a la memoria fiscal de cada fila.",
  "lots.status.reviewRows": "{count} filas por revisar",
  "lots.filter.period": "Período",
  "lots.period.today": "Hoy",
  "lots.period.7d": "7 días",
  "lots.period.30d": "30 días",
  "lots.period.custom": "Personalizado",
  "lots.filter.from": "Desde",
  "lots.filter.to": "Hasta",
  "lots.filter.status": "Estado",
  "lots.filter.origin": "Origen",
  "lots.filter.review": "Revisión",
  "lots.filter.reviewOnly": "Solo con revisión",
  "lots.filter.search": "Buscar",
  "lots.filter.placeholder": "Buscar por lote, ID o integración",
  "lots.window.incomplete": "Elija las dos fechas del período personalizado.",
  "lots.window.order": "La fecha inicial debe ser anterior a la final.",
  "lots.window.tooLong": "El período puede tener como máximo 90 días.",
  "lots.column.lot": "Lote / origen",
  "lots.column.submittedBy": "Enviado por",
  "lots.column.when": "Cuándo",
  "lots.column.status": "Estado",
  "lots.column.items": "Ítems",
  "lots.column.review": "Revisión",
  "lots.column.rulesetVersion": "Versión",
  "lots.column.correlation": "Correlación",
  "lots.column.taxTotal": "Impuesto total",
  "lots.empty.title": "Ningún lote en este período",
  "lots.empty.body": "Envíe una planilla o amplíe el período para ver ejecuciones anteriores.",
  "lots.submitter.unrecorded": "Origen no registrado",
  "lots.batches": "{received} de {expected} partes recibidas",
  "lots.invalidRows": "{count} filas inválidas",
  "lots.running": "Calculando",
  "lots.openJob": "Abrir detalles de {name}",
  "lots.drawer.subtitle": "{origin} · enviado {relative}",
  "lots.drawer.exportCsv": "Exportar CSV",
  "lots.drawer.exportJson": "Exportar JSON",
  "lots.drawer.exporting": "Exportando {loaded} de {total} ítems…",
  "lots.drawer.cancelExport": "Cancelar exportación",
  "lots.drawer.exportCancelled": "Exportación cancelada.",
  "lots.drawer.exportDone": "Archivo listo con {count} ítems.",
  "lots.drawer.exportTruncated": "El archivo se detuvo en {cap} ítems, el límite de exportación.",
  "lots.drawer.exportFailed": "No se pudo exportar. Inténtelo de nuevo.",
  "lots.drawer.openTask": "Abrir tarea fiscal",
  "lots.drawer.openCalculation": "Abrir cálculo",
  "lots.drawer.downloadOriginal": "Descargar archivo original",
  "lots.drawer.downloadFailed": "El archivo original no está disponible.",
  "lots.drawer.notFound":
    "Este lote no aparece en el período filtrado. Amplíe el período para abrirlo.",
  "lots.drawer.notFoundTitle": "Lote fuera del período",
  "lots.section.summary": "Resumen",
  "lots.section.items": "Ítems devueltos",
  "lots.section.origin": "Origen",
  "lots.section.trace": "Trazabilidad",
  "lots.section.audit": "Eventos de auditoría",
  "lots.summary.submittedAt": "Enviado el",
  "lots.summary.startedAt": "Inicio",
  "lots.summary.completedAt": "Completado el",
  "lots.summary.submittedBy": "Enviado por",
  "lots.summary.workflow": "Origen",
  "lots.summary.ruleset": "Versión de las reglas",
  "lots.summary.counts": "Ítems",
  "lots.summary.countsValue":
    "{items} ítems · {calculated} calculados · {review} para revisión · {rejected} rechazados",
  "lots.summary.taxTotal": "Impuesto total",
  "lots.summary.landed": "Costo fiscal total",
  "lots.summary.topIssues": "Principales pendientes",
  "lots.summary.noIssues": "Ningún pendiente registrado.",
  "lots.summary.notYet": "Disponible al completar",
  "lots.summary.partial":
    "Recibimos {received} de {expected} partes de este lote. Los totales suman solo las partes recibidas.",
  "lots.summary.lastError": "Último error",
  "lots.summary.invalid":
    "{count} de {total} filas no pasaron la validación. Corrija el archivo y envíelo de nuevo.",
  "lots.summary.imported": "Archivo importado y todavía sin calcular.",
  "lots.items.position": "#",
  "lots.items.item": "Ítem / SKU",
  "lots.items.ncm": "NCM",
  "lots.items.route": "UF origen → destino",
  "lots.items.status": "Estado",
  "lots.items.ipi": "IPI",
  "lots.items.icmsSt": "ICMS (ST o propio)",
  "lots.items.taxTotal": "Impuesto total",
  "lots.items.landed": "Costo final",
  "lots.items.issues": "Pendientes",
  "lots.items.actions": "Acciones",
  "lots.items.empty": "Ningún ítem devuelto todavía.",
  "lots.items.part": "Parte",
  "lots.items.more": "Más ítems",
  "lots.items.partOption": "Parte {index} de {count}",
  "lots.items.explain": "Explicar {item}",
  "lots.items.row": "Fila",
  "lots.items.rowValid": "Válida",
  "lots.items.rowErrors": "Errores",
  "lots.origin.filename": "Archivo",
  "lots.origin.rows": "Filas",
  "lots.origin.uploadedAt": "Importado el",
  "lots.origin.parser": "Lector",
  "lots.origin.integration": "Integración",
  "lots.origin.attempts": "Intentos de la integración",
  "lots.origin.noAttempts":
    "Ningún intento registrado en los últimos 30 días para esta correlación.",
  "lots.origin.attemptLine": "{method} {route} · {status} · {duration} ms",
  "lots.origin.replayed": "reutilizada",
  "lots.origin.operator": "Enviado por {name} en la plataforma.",
  "lots.origin.unrecorded": "Este cálculo es anterior al registro de quién llamó a la API.",
  "lots.trace.jobId": "ID del lote",
  "lots.trace.correlation": "ID de correlación",
  "lots.trace.request": "ID de la solicitud",
  "lots.trace.calculations": "Cálculos almacenados ({count})",
  "lots.trace.replayed": "Reutilizado por idempotencia",
  "lots.trace.sourceStatus": "Estado almacenado",
  "lots.trace.moreIds": "y {count} más",
  "lots.trace.workflow": "Flujo (ID técnico)",
  "lots.origin.automatic": "Enviado automáticamente · {origin}.",
  "lots.trace.none": "Ningún cálculo almacenado.",
  "lots.audit.empty": "Ningún evento de auditoría para esta correlación.",
  "lots.audit.open": "Abrir en auditoría",
  "overview.home.jobs.origin.UNKNOWN": "Origen no registrado",
  "overview.home.new.icms.ST": "ICMS-ST",
  "overview.home.new.icms.STANDARD": "ICMS propio",
  "overview.home.new.icms.NOT_TAXED": "Sin ICMS",
  "overview.home.new.noNcm": "Sin NCM",
  "overview.home.new.openRule": "Abrir regla {ncm}",
  "status.job.IMPORTED": "Importado",
  "status.job.INVALID": "Inválido",
  "status.job.PARTIAL": "Parcial",
  "settings.requests.details.openLot": "Ver lote",
  "nav.webResearch": "Investigación web",
  "agents.create.webHint": "Esta cola es solo del IOB. Para investigación en la web, use",
  "agents.create.webHintLink": "Investigación web",
  "webResearch.title": "Investigación web",
  "webResearch.description":
    "Planifique barridos de fuentes oficiales en la web (SEFAZ, CONFAZ, Senado), siga etapas, costo y documentos encontrados, y ajuste el ritmo de la investigación.",
  "webResearch.new": "Nueva investigación",
  "webResearch.tabs": "Secciones de la investigación web",
  "webResearch.tab.sweeps": "Investigaciones",
  "webResearch.tab.settings": "Configuración",
  "webResearch.boundary":
    "Anexos y hallazgos son material de revisión. Ninguna investigación aprueba, publica ni calcula reglas.",
  "webResearch.list.title": "Investigaciones",
  "webResearch.empty.title": "Aún no hay investigaciones web",
  "webResearch.empty.body":
    "Cree una investigación para localizar, descargar y extraer los anexos oficiales de ST por segmento y UF. La vista previa muestra llamadas, costo y plazo antes de crear.",
  "webResearch.empty.infra":
    "La investigación web permanece apagada hasta que se active el servicio de ejecución. Hasta entonces, las investigaciones creadas quedan en cola y no gastan nada.",
  "webResearch.empty.action": "Planificar la primera investigación",
  "webResearch.lane.label": "Estado de la investigación web",
  "webResearch.lane.PAUSED": "Pausada",
  "webResearch.lane.PAUSED.detail":
    "El interruptor general está activado: no se entrega ninguna unidad al ejecutor.",
  "webResearch.lane.RUNNING": "En ejecución",
  "webResearch.lane.RUNNING.detail":
    "Hay una investigación en curso, dentro de los límites de ritmo y presupuesto.",
  "webResearch.lane.WAITING": "En cola",
  "webResearch.lane.WAITING.detail":
    "Hay investigaciones esperando al ejecutor. Si nada empieza, la infraestructura aún no se activó.",
  "webResearch.lane.IDLE": "Inactiva",
  "webResearch.lane.IDLE.detail": "Ninguna investigación activa.",
  "webResearch.lane.grounded": "Búsquedas",
  "webResearch.lane.extraction": "Extracciones",
  "webResearch.lane.dailyCap": "Tope diario de búsquedas",
  "webResearch.lane.monthly": "Presupuesto mensual",
  "webResearch.lane.infra":
    "La ejecución depende de que el servicio de investigación web esté activado. Mientras esté apagado, las investigaciones se aceptan y quedan en cola, sin gastar nada.",
  "webResearch.perMinute": "{count}/min",
  "webResearch.status.QUEUED": "En cola",
  "webResearch.status.RUNNING": "En ejecución",
  "webResearch.status.PAUSED": "Pausada",
  "webResearch.status.COMPLETED": "Completada",
  "webResearch.status.CANCELLED": "Cancelada",
  "webResearch.status.BUDGET_EXHAUSTED": "Presupuesto agotado",
  "webResearch.scope.USED": "Usados",
  "webResearch.scope.USED.body":
    "NCM y rutas que BackChannel calculó en el período. Cubra primero lo que importa.",
  "webResearch.scope.USED.short": "Usados {days} d",
  "webResearch.scope.CATALOG": "Catálogo completo",
  "webResearch.scope.CATALOG.body":
    "NCM activos del catálogo oficial, opcionalmente solo algunos capítulos.",
  "webResearch.scope.CATALOG.short": "Catálogo completo",
  "webResearch.scope.CATALOG.chapters.one": "Catálogo · {count} capítulo",
  "webResearch.scope.CATALOG.chapters.other": "Catálogo · {count} capítulos",
  "webResearch.scope.LIST": "Lista",
  "webResearch.scope.LIST.body": "Pegue NCM (hasta 10.000), uno por línea o separados por coma.",
  "webResearch.scope.LIST.short.one": "Lista de {count} NCM",
  "webResearch.scope.LIST.short.other": "Lista de {count} NCM",
  "webResearch.routes.USED": "Rutas usadas",
  "webResearch.routes.USED.body":
    "Solo las rutas origen → destino vistas en cálculos para cada NCM.",
  "webResearch.routes.USED.short": "rutas usadas",
  "webResearch.routes.ALL_DESTINATIONS": "Todas las UF de destino",
  "webResearch.routes.ALL_DESTINATIONS.body":
    "Las 27 UF como destino; el origen no importa. Solo con la estrategia Segmento.",
  "webResearch.routes.ALL_DESTINATIONS.short": "todas las UF",
  "webResearch.routes.UF_ALL": "Todas desde/hacia una UF",
  "webResearch.routes.UF_ALL.body":
    "Cada ruta que sale de, llega a, o involucra una UF (26 o 52 rutas).",
  "webResearch.routes.UF_ALL.FROM": "desde {uf}",
  "webResearch.routes.UF_ALL.TO": "hacia {uf}",
  "webResearch.routes.UF_ALL.BOTH": "desde y hacia {uf}",
  "webResearch.routes.EXPLICIT": "Rutas explícitas",
  "webResearch.routes.EXPLICIT.body": "Elija ruta por ruta (origen → destino).",
  "webResearch.routes.EXPLICIT.short.one": "{count} ruta",
  "webResearch.routes.EXPLICIT.short.other": "{count} rutas",
  "webResearch.strategy.SEGMENT": "Segmento",
  "webResearch.strategy.SEGMENT.body":
    "Investiga donde se escribe la ley: un anexo por segmento × UF de destino cubre todos los NCM de ese segmento. Mucho más barato.",
  "webResearch.strategy.PAIR": "Par",
  "webResearch.strategy.PAIR.body":
    "Verifica cada NCM × ruta por separado. Solo para Lista o Usados, hasta 2.000 unidades.",
  "webResearch.card.progress": "{percent} completado",
  "webResearch.card.failed": "{count} con fallo",
  "webResearch.detail.created": "Creada",
  "webResearch.detail.started": "Iniciada",
  "webResearch.detail.completed": "Finalizada",
  "webResearch.detail.queuedInfra":
    "Esta investigación aún no empezó. Se ejecuta cuando el ejecutor de la investigación web esté activado; hasta entonces no gasta nada.",
  "webResearch.detail.budgetExhausted":
    "La investigación se detuvo en el límite de llamadas o presupuesto. Las unidades pendientes quedan como están; cree otra investigación con límites mayores para continuar.",
  "webResearch.action.PAUSE": "Pausar",
  "webResearch.action.RESUME": "Reanudar",
  "webResearch.action.CANCEL": "Cancelar investigación",
  "webResearch.action.RETRY_FAILED": "Reprocesar fallos",
  "webResearch.status.COMPLETED_WITH_FAILURES": "Completada con fallos",
  "webResearch.action.RETRY_STALLED": "Descargar de nuevo",
  "webResearch.action.CLOSE": "Cerrar barrido",
  "webResearch.action.refetched":
    "Se solicitaron de nuevo las descargas. Las unidades en espera se reanudan cuando lleguen los documentos.",
  "webResearch.action.closed":
    "El barrido se cerró. Lo que encontró sigue disponible para revisión.",
  "webResearch.stalled.title": "Esperando documentos",
  "webResearch.stalled.body":
    "No puede ejecutarse nada más: {count} unidades esperan documentos que no se descargaron. Una unidad falla sola en cuanto falla su descarga o su lectura, o {minutes} min después de solicitar la descarga (como máximo {hours} h). Descárguelos de nuevo o cierre el barrido ahora.",
  "webResearch.close.title": "¿Cerrar este barrido?",
  "webResearch.close.body":
    "{count} unidades que aún no se ejecutaron se marcan como fallidas (cerradas por un operador) y el barrido se completa. Lo que encontró sigue disponible para revisión, y Reprocesar fallos las reabre después.",
  "webResearch.close.confirm": "Cerrar barrido",
  "webResearch.completion.ok": "Completada: todas las unidades terminaron.",
  "webResearch.completion.closed": "Cerrada por un operador: todas las unidades habían terminado.",
  "webResearch.outcome.title.one": "Concluida con 1 falla",
  "webResearch.outcome.title.other": "Concluida con {count} fallas",
  "webResearch.outcome.lead":
    "{finished} de {total} unidades terminaron ({percent}). Lo encontrado ya pasa a revisión; las fallas de abajo no bloquean ese material.",
  "webResearch.outcome.leadOperator":
    "Cerrada por un operador: {finished} de {total} unidades habían terminado ({percent}).",
  "webResearch.outcome.more": "+{count}",
  "webResearch.outcome.blockedDownloads.one": "descarga bloqueada por el sitio oficial",
  "webResearch.outcome.blockedDownloads.other": "descargas bloqueadas por el sitio oficial",
  "webResearch.outcome.missingDownloads.one": "descarga no llegó",
  "webResearch.outcome.missingDownloads.other": "descargas no llegaron",
  "webResearch.outcome.noOfficialSource.one": "búsqueda sin fuente oficial citada",
  "webResearch.outcome.noOfficialSource.other": "búsquedas sin fuente oficial citada",
  "webResearch.outcome.extraction.one": "lectura de documento rechazada",
  "webResearch.outcome.extraction.other": "lecturas de documento rechazadas",
  "webResearch.outcome.providerLimits.one": "unidad se detuvo en un límite del proveedor",
  "webResearch.outcome.providerLimits.other": "unidades se detuvieron en límites del proveedor",
  "webResearch.outcome.closedByOperator.one": "unidad cerrada antes de terminar",
  "webResearch.outcome.closedByOperator.other": "unidades cerradas antes de terminar",
  "webResearch.outcome.other.one": "otra falla",
  "webResearch.outcome.other.other": "otras fallas",
  "webResearch.outcome.next.blockedDownloads":
    "Reprocesar vuelve a intentarlo, lo que resuelve bloqueos temporales. Si persiste, registre o revise una fuente alternativa para esas UF.",
  "webResearch.outcome.next.missingDownloads":
    "Suele ser temporal: reprocesar solicita las descargas de nuevo.",
  "webResearch.outcome.next.noOfficialSource":
    "La búsqueda no citó un host del catálogo de fuentes. Revise las fuentes de esas UF; reprocesar busca de nuevo.",
  "webResearch.outcome.next.extraction":
    "La lectura no pasó las verificaciones; reprocesar lee el documento de nuevo. Si persiste, revise el documento en la lista de abajo.",
  "webResearch.outcome.next.providerLimits":
    "Temporal: reprocesar vuelve a poner en cola respetando el ritmo configurado.",
  "webResearch.outcome.next.closedByOperator":
    "Reprocesar reabre la búsqueda y retoma esas unidades.",
  "webResearch.outcome.next.other": "Vea el error de cada unidad en la tabla de abajo.",
  "webResearch.outcome.partial":
    "UF y hosts nombrados a partir de las primeras 200 unidades con falla; los conteos incluyen todas.",
  "webResearch.outcome.retry.one": "Reprocesar 1 falla",
  "webResearch.outcome.retry.other": "Reprocesar {count} fallas",
  "webResearch.outcome.sources": "Fuentes alternativas",
  "webResearch.error.FETCH_FAILED": "No se pudo descargar ni leer el documento",
  "webResearch.error.FETCH_TIMEOUT": "El documento no llegó a tiempo",
  "webResearch.error.NO_REVIEWED_SOURCE": "Ninguna fuente revisada cubre esta unidad",
  "webResearch.error.CLOSED_BY_OPERATOR": "Barrido cerrado antes de que esta unidad se ejecutara",
  "webResearch.action.conflict":
    "La investigación cambió desde que la abrió. Recargamos el estado actual; revise e intente de nuevo.",
  "webResearch.action.error": "No se pudo aplicar la acción. Intente de nuevo.",
  "webResearch.action.retried": "Las unidades con fallo volvieron a la cola.",
  "webResearch.cancel.title": "¿Cancelar esta investigación?",
  "webResearch.cancel.body":
    "Las unidades pendientes y bloqueadas se omiten y la investigación no puede reanudarse. Lo ya encontrado sigue disponible para revisión.",
  "webResearch.cancel.keep": "Mantener",
  "webResearch.cancel.confirm": "Cancelar investigación",
  "webResearch.stages.title": "Etapas",
  "webResearch.stages.units": "{count} unidades",
  "webResearch.stages.none": "sin unidades",
  "webResearch.stages.error": "No se pudo cargar el progreso por etapa.",
  "webResearch.stages.of": "de {total}",
  "webResearch.stages.open": "{count} abiertas",
  "webResearch.stages.closed": "ninguna abierta",
  "webResearch.stage.state.active": "En curso",
  "webResearch.stage.state.attention": "Con fallos",
  "webResearch.stage.state.done": "Completada",
  "webResearch.stage.review": "Revisar",
  "webResearch.stage.review.unit": "lecturas de anexo",
  "webResearch.stage.review.hint":
    "Los valores leídos entran como hechos no verificados; una persona decide en Reglas → Verificación.",
  "webResearch.stage.review.open": "Abrir Verificación",
  "webResearch.stage.locate": "Localizar",
  "webResearch.stage.locate.hint":
    "Busque en la web los anexos por segmento × UF, convenios CONFAZ, alícuotas internas y la tabla interestatal.",
  "webResearch.stage.fetch": "Descargar",
  "webResearch.error.NO_OFFICIAL_CITATION": "Ninguna fuente oficial citada",
  "webResearch.error.GROUNDED_RESPONSE_INVALID": "Respuesta de la búsqueda inválida",
  "webResearch.error.PROVIDER_RATE_LIMITED": "Límite de búsquedas alcanzado",
  "webResearch.error.PROVIDER_UNAVAILABLE": "Servicio de búsqueda no disponible",
  "webResearch.error.URL_NOT_ALLOWED": "Dirección fuera de las fuentes permitidas",
  "webResearch.error.FETCH_ROBOTS_DENIED":
    "El sitio oficial no permite descargas automatizadas según su política de robots",
  "webResearch.error.FETCH_HTTP": "El sitio oficial rechazó la descarga (HTTP {status})",
  "webResearch.error.FETCH": "No se pudo descargar el documento",
  "webResearch.error.DOCUMENT_CHANGED": "El documento cambió durante la lectura",
  "webResearch.error.EXTRACT_CHECKS_FAILED":
    "Las filas extraídas no pasaron la verificación CEST/NCM",
  "webResearch.error.EXTRACTION_INVALID": "Extracción con formato inválido",
  "webResearch.error.EXTRACTION_REJECTED": "Extracción rechazada por el servicio de lectura",
  "webResearch.error.EXTRACTION_TOO_LARGE": "Resultado de la extracción demasiado grande",
  "webResearch.error.CHUNK_TOO_LARGE": "Fragmento del documento demasiado grande para leer",
  "webResearch.error.RESULT_INVALID": "Resultado rechazado por la validación",
  "webResearch.error.FETCH_BLOCKED":
    "El sitio oficial bloquea nuestra dirección de salida; esperando que el órgano la autorice",
  "webResearch.error.DOCUMENT_UNSUPPORTED":
    "Documento descargado, pero en un formato que no podemos leer",
  "webResearch.error.WORKER_ERROR": "Falla interna del ejecutor; se intentará de nuevo",
  "webResearch.error.LEASE_EXPIRED": "Tiempo de procesamiento agotado",
  "webResearch.error.INVALID_UNIT_KEY": "Unidad de investigación incompleta",
  "webResearch.error.UNSUPPORTED_KIND": "Etapa no soportada por el ejecutor",
  "webResearch.error.unknown": "Falla técnica",
  "webResearch.stage.fetch.hint":
    "Descarga nuestra propia copia de cada documento oficial localizado.",
  "webResearch.stage.extract": "Extraer",
  "webResearch.stage.extract.hint":
    "Lee las filas del anexo (CEST, NCM, MVA, vigencia) de la copia descargada, con la cita literal.",
  "webResearch.stage.verify": "Verificar pares",
  "webResearch.stage.verify.hint":
    "Comprueba NCM × ruta solo cuando el segmento es ambiguo o la estrategia es Par.",
  "webResearch.cost.title": "Costo",
  "webResearch.cost.live": "en vivo",
  "webResearch.cost.spent": "Gasto vs. presupuesto",
  "webResearch.cost.grounded": "Búsquedas vs. límite",
  "webResearch.cost.extraction": "Extracciones",
  "webResearch.cost.estimated": "{count} estimadas",
  "webResearch.cost.eta": "Previsión",
  "webResearch.cost.etaNone": "finalizada",
  "webResearch.cost.etaPaused": "pausada",
  "webResearch.cost.throughput": "Rendimiento",
  "webResearch.cost.throughputValue": "{units} unidades/min · {searches} búsquedas/min",
  "webResearch.cost.throughputMeta": "últimos {minutes} min · {inFlight} en curso",
  "webResearch.cost.etaRate": "al ritmo real, {units} unidades abiertas",
  "webResearch.cost.etaPace": "al ritmo configurado",
  "webResearch.cost.estimate": "Reserva de planificación al crear",
  "webResearch.cost.iob": "Certificar con IOB",
  "webResearch.failed.title": "Unidades con fallo",
  "webResearch.failed.hint":
    "Se rindieron tras 3 intentos o un error permanente. Reprocesar reinicia los intentos y las vuelve a poner en cola.",
  "webResearch.failed.retry": "Reprocesar fallos",
  "webResearch.failed.none": "Ninguna unidad con fallo.",
  "webResearch.col.kind": "Etapa",
  "webResearch.col.subject": "Objetivo",
  "webResearch.col.error": "Error",
  "webResearch.col.attempts": "Intentos",
  "webResearch.col.updated": "Actualizada",
  "webResearch.col.host": "Documento",
  "webResearch.col.uf": "UF",
  "webResearch.col.segments": "Segmentos",
  "webResearch.col.hash": "Hash",
  "webResearch.col.change": "Desde la última ejecución",
  "webResearch.kind.LOCATE_SEGMENT_UF": "Localizar segmento × UF",
  "webResearch.kind.LOCATE_CONFAZ_SEGMENT": "Localizar convenio CONFAZ",
  "webResearch.kind.LOCATE_INTERNAL_RATE_UF": "Localizar alícuota interna",
  "webResearch.kind.LOCATE_INTERSTATE_TABLE": "Localizar tabla interestatal",
  "webResearch.kind.FETCH_DOCUMENT": "Descargar documento",
  "webResearch.kind.EXTRACT_DOCUMENT_SEGMENT": "Extraer anexo",
  "webResearch.kind.VERIFY_PAIR": "Verificar par",
  "webResearch.docs.title": "Documentos encontrados",
  "webResearch.docs.hint": "Hash comparado con la investigación anterior, “{name}”.",
  "webResearch.docs.hintFirst":
    "Primera investigación: todos los documentos descargados aparecen como nuevos.",
  "webResearch.docs.filter": "Filtrar documentos por cambio",
  "webResearch.docs.all": "Todos",
  "webResearch.docs.change.CHANGED": "Cambió",
  "webResearch.docs.change.NEW": "Nuevo",
  "webResearch.docs.change.SAME": "Sin cambios",
  "webResearch.docs.change.PENDING": "Esperando descarga",
  "webResearch.docs.failed": "Una unidad de este documento falló",
  "webResearch.docs.none": "Aún no se localizó ningún documento.",
  "webResearch.docs.more": "Mostrar {count} más",
  "webResearch.docs.less": "Mostrar menos",
  "webResearch.docs.truncated":
    "Mostrando los primeros 200 registros de documentos de esta investigación.",
  "webResearch.wizard.title": "Nueva investigación web",
  "webResearch.wizard.steps": "Pasos de la nueva investigación",
  "webResearch.wizard.step.scope": "Alcance",
  "webResearch.wizard.step.routes": "Rutas",
  "webResearch.wizard.step.strategy": "Estrategia",
  "webResearch.wizard.step.caps": "Límites",
  "webResearch.wizard.step.preview": "Vista previa",
  "webResearch.wizard.summary.caps": "{calls} búsquedas · US$ {budget}",
  "webResearch.wizard.summary.preview": "vista previa actual · {cost}",
  "webResearch.wizard.summary.stale": "vista previa desactualizada",
  "webResearch.wizard.summary.notYet": "aún no calculada",
  "webResearch.wizard.summary.blocked": "bloqueada",
  "webResearch.wizard.plan.title": "Plan de esta vista previa",
  "webResearch.wizard.plan.edit": "Editar",
  "webResearch.wizard.name": "Nombre",
  "webResearch.wizard.scope": "Qué investigar",
  "webResearch.wizard.recommended": "Recomendado",
  "webResearch.wizard.days": "Período",
  "webResearch.wizard.daysValue": "{days} días",
  "webResearch.wizard.routes": "Qué rutas",
  "webResearch.wizard.routes.uf": "UF",
  "webResearch.wizard.routes.direction": "Sentido",
  "webResearch.wizard.routes.direction.FROM": "Desde la UF",
  "webResearch.wizard.routes.direction.TO": "Hacia la UF",
  "webResearch.wizard.routes.direction.BOTH": "Ambos",
  "webResearch.wizard.routes.list": "Rutas (origen → destino)",
  "webResearch.wizard.routes.add": "Agregar ruta",
  "webResearch.wizard.routes.remove": "Quitar ruta {route}",
  "webResearch.wizard.routes.explicitEmpty": "Agregue al menos una ruta.",
  "webResearch.wizard.strategy": "Cómo investigar",
  "webResearch.wizard.strategy.pairNotAllowed":
    "Par no está disponible para Catálogo completo ni para Todas las UF de destino.",
  "webResearch.wizard.skipFresh": "Reutilizar respuestas de los últimos 30 días",
  "webResearch.wizard.skipFreshHint":
    "Las búsquedas ya respondidas por otra investigación hace menos de 30 días entran como “en caché” y no gastan.",
  "webResearch.wizard.caps.calls": "Máximo de búsquedas (grounded)",
  "webResearch.wizard.caps.callsHint": "≈ {time} a {pace} búsquedas/min.",
  "webResearch.wizard.caps.callsRange": "Entre 1 y 100.000.",
  "webResearch.wizard.caps.budget": "Presupuesto",
  "webResearch.wizard.caps.budgetHint":
    "La investigación se detiene al alcanzar este gasto estimado.",
  "webResearch.wizard.caps.budgetInvalid":
    "Indique un valor en dólares mayor que cero (ej.: 80 o 12.50).",
  "webResearch.wizard.caps.campaign": "ID de la campaña de financiación",
  "webResearch.wizard.caps.campaignHint":
    "Copia el ID de la campaña que aparece en esta página. Google Grounding requiere una campaña verificada; seleccionarla no aumenta su presupuesto.",
  "webResearch.wizard.caps.campaignInvalid":
    "Introduce el UUID de la campaña verificada que financiará esta investigación.",
  "webResearch.wizard.caps.iob": "Certificar top N con IOB",
  "webResearch.wizard.caps.iobHint":
    "Encola tareas IOB para los N pares más usados. 0 lo desactiva.",
  "webResearch.wizard.caps.iobUsedOnly": "Solo disponible en el alcance Usados.",
  "webResearch.wizard.caps.iobRange": "Entre 0 y 3.000.",
  "webResearch.wizard.caps.note":
    "Los límites valen por investigación. El tope diario y el presupuesto mensual de Configuración también se aplican.",
  "webResearch.wizard.back": "Volver",
  "webResearch.wizard.next": "Siguiente",
  "webResearch.wizard.toPreview": "Vista previa",
  "webResearch.wizard.create": "Crear investigación",
  "webResearch.wizard.creating": "Creando…",
  "webResearch.wizard.createNeedsPreview": "Previsualice el plan actual antes de crear.",
  "webResearch.wizard.createError":
    "No se pudo crear la investigación. Intente de nuevo; el mismo plan no se crea dos veces.",
  "webResearch.wizard.createConflict":
    "Esta clave ya se usó para otro plan. Actualice la vista previa e intente de nuevo.",
  "webResearch.wizard.preview.lead":
    "Nada se guarda hasta que cree. Revise qué se investigará y cuánto debería costar.",
  "webResearch.wizard.preview.loading": "Calculando el plan…",
  "webResearch.wizard.preview.refresh": "Actualizar vista previa",
  "webResearch.wizard.preview.run": "Previsualizar plan",
  "webResearch.wizard.preview.stale": "El plan cambió desde la última vista previa.",
  "webResearch.wizard.preview.error":
    "No se pudo previsualizar. Revise los pasos e intente de nuevo.",
  "webResearch.wizard.preview.invalid": "Corrija el paso “{step}” antes de previsualizar.",
  "webResearch.wizard.preview.fix": "Ir al paso",
  "webResearch.preview.ncms": "NCM",
  "webResearch.preview.routes.one": "{count} ruta",
  "webResearch.preview.routes.other": "{count} rutas",
  "webResearch.preview.withCest": "Candidatos a CEST",
  "webResearch.preview.withoutCest": "{count} fuera del Conv. 142/18",
  "webResearch.preview.ambiguous": "{count} ambiguos",
  "webResearch.preview.segmentsUfs": "Segmentos × UF",
  "webResearch.preview.locates.one": "{count} localización",
  "webResearch.preview.locates.other": "{count} localizaciones",
  "webResearch.preview.cached": "{count} en caché",
  "webResearch.preview.pairs": "Pares a verificar",
  "webResearch.preview.pairsHint": "Solo ambiguos o estrategia Par.",
  "webResearch.preview.grounded": "Búsquedas estimadas",
  "webResearch.preview.extraction": "Extracciones estimadas",
  "webResearch.preview.usageForecast": "Previsión según consumo confirmado",
  "webResearch.preview.forecastUnavailable": "Consumo confirmado insuficiente",
  "webResearch.preview.reservationHint":
    "La reserva supone el contexto completo del modelo en cada llamada prevista. No es el gasto esperado ni un tope garantizado de factura. La admisión presupuestaria sigue usando reservas.",
  "webResearch.preview.forecastHint":
    "Previsión con {searches} llamadas de búsqueda y {extractions} de extracción en {days} días. Excluye {unresolved} llamadas sin consumo confirmado; reintentos y fallos pueden cambiar el coste. Precios de la plataforma antes de cuotas gratuitas o créditos; no es una factura de Google.",
  "webResearch.preview.cost": "Reserva conservadora de planificación",
  "webResearch.preview.eta": "Duración estimada",
  "webResearch.preview.withinCaps":
    "La reserva de planificación cabe en los límites de búsquedas y presupuesto.",
  "webResearch.preview.fitCaps": "Ajustar límites a la reserva de planificación (+20%)",
  "webResearch.warning.cestEmpty":
    "El catálogo CEST está vacío: todo NCM cuenta como fuera del Conv. 142/18.",
  "webResearch.warning.noRoutes":
    "No se encontró ruta para estos NCM (las rutas usadas dependen de cálculos).",
  "webResearch.warning.nothing": "Nada que investigar en este alcance.",
  "webResearch.warning.pairOver":
    "El plan Par necesita {units} unidades, por encima del límite de {max}.",
  "webResearch.preview.overCaps":
    "La reserva de planificación supera los límites. La ejecución podría detenerse antes; esto no significa que se haya gastado el coste previsto.",
  "webResearch.preview.segmentsList.one": "{count} segmento del Conv. 142/18",
  "webResearch.preview.segmentsList.other": "{count} segmentos del Conv. 142/18",
  "webResearch.preview.segmentMeta": "{ncms} NCM · {cests} CEST",
  "webResearch.preview.unitsList": "Unidades planificadas por tipo",
  "webResearch.preview.warnings": "Avisos de la API",
  "webResearch.settings.title": "Ritmo y presupuesto",
  "webResearch.settings.hint":
    "Valen para todas las investigaciones web. La API aplica los límites a cada unidad entregada.",
  "webResearch.settings.kill": "Pausar investigación web",
  "webResearch.settings.killOn": "Pausada: no se entrega ninguna unidad, en ninguna investigación.",
  "webResearch.settings.killOff":
    "Activa: las investigaciones activas siguen dentro del ritmo y los límites.",
  "webResearch.settings.pace": "Ritmo",
  "webResearch.settings.grounded": "Búsquedas por minuto",
  "webResearch.settings.groundedHint":
    "De 1 a 30. Empiece bajo y suba tras una semana sin errores 429.",
  "webResearch.settings.extraction": "Extracciones por minuto",
  "webResearch.settings.extractionHint":
    "De 1 a 60 llamadas al modelo; las páginas sin nada que leer no cuentan.",
  "webResearch.settings.workers": "Trabajadores en paralelo",
  "webResearch.settings.workersHint":
    "De 1 a {max}. Unidades procesadas a la vez; los ritmos y límites de arriba siguen siendo globales.",
  "webResearch.settings.caps": "Límites",
  "webResearch.settings.daily": "Tope diario de búsquedas",
  "webResearch.settings.dailyHint": "Día de Brasilia. De 1 a 100.000.",
  "webResearch.settings.monthly": "Presupuesto mensual",
  "webResearch.settings.monthlyHint":
    "Al alcanzarlo, ninguna investigación recibe trabajo hasta el mes siguiente.",
  "webResearch.settings.perDay": "Búsquedas por día",
  "webResearch.settings.perDayMeta": "menor entre ritmo y tope diario",
  "webResearch.settings.perHour": "Búsquedas por hora",
  "webResearch.settings.perHourMeta": "al ritmo configurado",
  "webResearch.settings.budgetMonth": "Presupuesto del mes",
  "webResearch.settings.budgetMonthMeta": "todas las investigaciones sumadas",
  "webResearch.settings.prices": "Tabla de precios (estimaciones)",
  "webResearch.settings.pricesHint":
    "Se usa para convertir en US$ el uso informado por el ejecutor. Actualícela cuando cambie el precio del proveedor.",
  "webResearch.settings.price.groundedPromptUsdPer1000": "Por 1.000 prompts con búsqueda",
  "webResearch.settings.price.searchQueryUsdPer1000": "Por 1.000 consultas de búsqueda",
  "webResearch.settings.price.inputTokensUsdPerMillion": "Por millón de tokens de entrada",
  "webResearch.settings.price.outputTokensUsdPerMillion": "Por millón de tokens de salida",
  "webResearch.calculatorBudget.title": "Presupuesto por investigación de la calculadora",
  "webResearch.calculatorBudget.hint":
    "Se aplica a nuevas investigaciones de datos fiscales faltantes, incluidas las automáticas. Los límites diario, mensual y de campaña siguen siendo independientes.",
  "webResearch.calculatorBudget.label": "Límite individual (US$)",
  "webResearch.calculatorBudget.fieldHint":
    "Reserva estimada para búsqueda y extracción. Se registra el consumo real; una llamada en curso puede superar la estimación. Las investigaciones existentes conservan su presupuesto original.",
  "webResearch.calculatorBudget.unavailable":
    "La investigación de la calculadora no está disponible en este entorno.",
  "webResearch.settings.saved": "Configuración guardada.",
  "webResearch.settings.conflict":
    "Otra persona cambió esta configuración. Recargamos la versión actual; rehaga su cambio.",
  "webResearch.settings.error": "No se pudo guardar. Intente de nuevo.",
  "webResearch.settings.pauseTitle": "¿Pausar la investigación web?",
  "webResearch.settings.pauseBody":
    "Todas las investigaciones dejan de recibir trabajo en la próxima solicitud del ejecutor. Las unidades en curso terminan; nada se pierde.",
  "webResearch.settings.pauseConfirm": "Pausar investigación web",
  "certification.badge.PUBLISHED_RULE": "Regla publicada",
  "certification.badge.CERTIFIED": "Certificado IOB",
  "certification.badge.VERIFIED": "Verificado",
  "certification.badge.UNVERIFIED": "No verificado",
  "certification.badge.EXPIRED": "Vencido",
  "certification.badge.CONFLICTING": "En conflicto",
  "certification.badge.REJECTED": "Rechazado",
  "certification.badge.SUPERSEDED": "Sustituido",
  "certification.meaning.PUBLISHED_RULE":
    "Valor de un conjunto de reglas publicado; siempre prevalece sobre los hechos.",
  "certification.meaning.CERTIFIED":
    "Leído en el simulador IOB con el cuadro del resultado registrado.",
  "certification.meaning.VERIFIED": "Confirmado por un revisor o corroborado por un hecho IOB.",
  "certification.meaning.UNVERIFIED":
    "Extraído de una fuente oficial en la web; aún sin confirmación humana ni IOB.",
  "certification.meaning.EXPIRED": "La vigencia terminó y no hay sucesor.",
  "certification.meaning.CONFLICTING":
    "Discrepa de otro hecho del mismo nivel; no se usa hasta que alguien decida.",
  "certification.meaning.REJECTED": "Rechazado por un revisor o revocado; nunca se usa.",
  "certification.meaning.SUPERSEDED":
    "Un hecho más reciente de la misma clave lo sustituyó desde la nueva vigencia.",
  "certification.source.IOB_SIMULADOR": "Simulador IOB",
  "certification.source.WEB_RESEARCH": "Investigación web",
  "certification.source.OPERATOR": "Revisor",
  "certification.source.CATALOG_DERIVATION": "Catálogo CEST",
  "certification.source.PUBLISHED_RULESET": "Conjunto de reglas publicado",
  "certification.tip.source": "Fuente",
  "certification.tip.ruleset": "Versión",
  "certification.tip.checked": "Verificado el",
  "certification.tip.validity": "Vigencia",
  "certification.tip.validRange": "{from} a {to}",
  "certification.tip.validFrom": "desde {from}",
  "certification.tip.host": "Cita",
  "certification.inferred": "vigencia inferida",
  "revalidation.awaiting":
    "Verificación en IOB: entra en la cola en la próxima consulta del agente · próxima ventana {window}",
  "revalidation.queued": "Verificación en IOB en cola · {ahead} · previsión {eta}",
  "revalidation.queuedHeld": "Verificación en IOB en cola · {ahead} · la tarea está en pausa",
  "revalidation.ahead.one": "{count} consulta por delante",
  "revalidation.ahead.other": "{count} consultas por delante",
  "revalidation.running": "Verificación en IOB en curso",
  "revalidation.checked": "IOB consultado {age}: revise el resultado",
  "revalidation.ended": "La verificación en IOB terminó sin respuesta: envíela a IOB de nuevo",
  "revalidation.notQueueable": "IOB solo verifica hechos de NCM × ruta: confirme o rechace este",
  "revalidation.paused": "Agente IOB en pausa: la verificación espera a que un admin lo reanude",
  "certification.revalidation": "Revalidación pendiente",
  "certification.revalidation.hint":
    "El hecho sigue siendo utilizable mientras IOB lo vuelve a verificar.",
  "verification.tab": "Verificación",
  "verification.title": "Verificación de hechos fiscales",
  "verification.description":
    "Confirme, rechace o envíe a IOB los hechos que encontró la investigación, en el nivel en que se extrajeron: una fila de anexo verifica todas las rutas que cubre.",
  "verification.boundary":
    "Los hechos fiscales aún no entran en ningún cálculo y nunca publican una regla. Verificar aquí prepara la base para cuando el motor los consulte.",
  "verification.queue.title": "Cola de verificación",
  "verification.tabs": "Colas de verificación",
  "verification.tab.unverified": "No verificados",
  "verification.tab.conflicting": "En conflicto",
  "verification.tab.drift": "Divergencias con regla publicada",
  "verification.tab.revalidation": "Revalidación pendiente",
  "verification.tab.expired": "Vencidos",
  "verification.tabHint.unverified":
    "Ordenados por impacto: ocurrencias de las brechas abiertas que cada hecho respondería.",
  "verification.tabHint.conflicting":
    "Hechos del mismo nivel que discrepan. Ningún lado se usa hasta que alguien decida.",
  "verification.tabHint.drift":
    "Hechos certificados o verificados que discrepan de la regla publicada. La regla sigue vigente.",
  "verification.tabHint.revalidation":
    "Hechos aún utilizables que IOB debe volver a verificar: la web discrepó, la fuente cambió o la vigencia está por terminar.",
  "verification.tabHint.expired":
    "Vigencia terminada sin sucesor. No valen para fechas posteriores al fin.",
  "verification.queue.count": "{shown} de {total}",
  "verification.queue.first": "Inicio",
  "verification.queue.next": "Página siguiente",
  "verification.empty.unverified": "Ningún hecho pendiente de verificación",
  "verification.empty.conflicting": "Ningún conflicto abierto",
  "verification.empty.drift": "Ninguna divergencia con la regla publicada",
  "verification.empty.revalidation": "Ninguna revalidación pendiente",
  "verification.empty.expired": "Ningún hecho vencido",
  "verification.empty.body":
    "Los hechos llegan del simulador IOB y de la investigación web. Cuando haya algo para revisar, aparecerá aquí.",
  "verification.detail.none": "Seleccione un hecho para ver los campos y la evidencia.",
  "verification.item.drift": "Diverge en {fields} · regla {version}",
  "verification.item.conflicts.one": "{count} hecho en conflicto",
  "verification.item.conflicts.other": "{count} hechos en conflicto",
  "verification.item.impact": "{gaps} · {occurrences}",
  "verification.gaps.one": "{count} brecha",
  "verification.gaps.other": "{count} brechas",
  "verification.occurrences.one": "{count} ocurrencia",
  "verification.occurrences.other": "{count} ocurrencias",
  "verification.item.noImpact": "Sin brechas abiertas",
  "verification.field.stApplicable": "ST aplicable",
  "verification.field.originalMva": "MVA original",
  "verification.field.destinationInternalRate": "Alícuota interna",
  "verification.field.interstateRate": "Alícuota interestatal",
  "verification.field.ncmPrefixes": "NCM del anexo",
  "verification.field.segment": "Destino y orígenes",
  "verification.field.uf": "UF",
  "verification.field.route": "Ruta",
  "verification.field.kind": "Tipo",
  "verification.field.validity": "Vigencia",
  "verification.field.effectiveTo": "Vale hasta",
  "verification.field.legalBasis": "Fundamento",
  "verification.field.checked": "Última verificación",
  "verification.field.verified": "Verificación",
  "verification.field.id": "Hecho",
  "verification.value.yes": "Sí",
  "verification.value.no": "No",
  "verification.scope.ORIGINS": "orígenes {ufs}",
  "verification.scope.ALL_ORIGINS": "todos los orígenes",
  "verification.scope.INTERNAL_ONLY": "solo operaciones internas",
  "verification.kind.ST_ROUTE": "Ruta NCM",
  "verification.kind.ST_SEGMENT": "Segmento de anexo",
  "verification.kind.NO_ST_CATALOG": "Sin ST en el catálogo",
  "verification.kind.INTERNAL_RATE": "Alícuota interna",
  "verification.kind.INTERSTATE_RATE": "Alícuota interestatal",
  "verification.subject.internal": "Interna {uf}",
  "verification.subject.modal": "modal de la UF",
  "verification.short.st": "ST",
  "verification.value.internalSt": "ST interna en el destino ({uf})",
  "verification.short.mva": "MVA",
  "verification.short.internal": "Interna",
  "verification.short.interstate": "Interestatal",
  "verification.bootstrap.title": "Configuración de la base",
  "verification.bootstrap.hint":
    "Empiece por lo que más se expande: las 27 alícuotas internas modales y la tabla interestatal valen para todas las rutas.",
  "verification.bootstrap.internal": "Alícuotas internas por UF",
  "verification.bootstrap.internalTally":
    "{confirmed} de {total} verificadas · {pending} pendientes",
  "verification.bootstrap.interstate": "Tabla interestatal",
  "verification.bootstrap.interstateTally":
    "{confirmed} de {total} rutas verificadas · {pending} pendientes",
  "verification.bootstrap.interstateNote":
    "Cada ruta origen → destino es un hecho propio; confírmelo desde la pestaña No verificados.",
  "verification.bootstrap.legend": "Leyenda",
  "verification.bootstrap.cell.CONFIRMED": "verificada o certificada",
  "verification.bootstrap.cell.PENDING": "pendiente de verificación",
  "verification.bootstrap.cell.CONFLICT": "en conflicto",
  "verification.bootstrap.cell.NONE": "sin hecho",
  "verification.settings.title": "Uso de los hechos en el cálculo",
  "verification.settings.hint":
    "Modo y llaves de corte de la capa de hechos. Solo los administradores lo cambian.",
  "verification.settings.loading": "Cargando configuración…",
  "verification.settings.dormant":
    "Los valores de los cálculos nunca usan hechos fiscales. En modo Sombra, la calculadora y las planillas guardan una comparación con los hechos verificados y certificados; el modo Encendido aún no cambia resultados.",
  "verification.settings.effective": "Modo efectivo",
  "verification.settings.environment": "Entorno",
  "verification.settings.restricted":
    "Guardado como {mode}, pero el entorno lo limita a {environment}: siempre vale el más restrictivo.",
  "verification.settings.effectiveHint":
    "El modo efectivo es el más restrictivo entre el guardado aquí y el del entorno (FISCAL_FACTS_MODE).",
  "verification.settings.mode": "Modo",
  "verification.mode.OFF": "Apagado",
  "verification.mode.SHADOW": "Sombra",
  "verification.mode.ON": "Encendido",
  "verification.mode.OFF.hint": "Los hechos no se consultan.",
  "verification.mode.SHADOW.hint":
    "El motor calcula también con hechos verificados y certificados y guarda la diferencia por ítem, sin cambiar resultados.",
  "verification.mode.ON.hint":
    "Los hechos completarían ítems sin regla publicada, siempre con el nivel de certificación.",
  "verification.settings.useCertified": "Usar hechos certificados y verificados",
  "verification.settings.useCertifiedHint": "IOB y hechos confirmados por revisores.",
  "verification.settings.useUnverified": "Usar hechos no verificados",
  "verification.settings.useUnverifiedHint":
    "Llave de corte de los datos web: apáguela para ignorarlos al instante.",
  "verification.settings.saved": "Configuración guardada.",
  "verification.settings.conflict":
    "Alguien cambió esta configuración: cargamos la versión actual. Revise y guarde de nuevo.",
  "verification.settings.error": "No se pudo guardar. Inténtelo de nuevo.",
  "verification.settings.save": "Guardar",
  "verification.action.CONFIRM": "Confirmar",
  "verification.action.REVALIDATE": "Confirmar valores",
  "verification.action.REJECT": "Rechazar",
  "verification.action.REQUEST_IOB": "Pedir IOB",
  "verification.done.CONFIRM": "Hecho confirmado.",
  "verification.done.REJECT": "Hecho rechazado. No se usará.",
  "verification.done.REQUEST_IOB":
    "Solicitud de verificación IOB registrada; el hecho queda en Revalidación pendiente.",
  "verification.error.stale": "Alguien cambió este hecho: recargue antes de decidir.",
  "verification.error.notAllowed":
    "Esta acción no está permitida en el estado actual del hecho. Recargue para ver el estado más reciente.",
  "verification.error.generic": "No se pudo registrar la decisión. Inténtelo de nuevo.",
  "verification.reload": "Recargar",
  "verification.dialog.CONFIRM.title": "Confirmar hecho",
  "verification.dialog.CONFIRM.body":
    "Usted verificó los valores en la fuente citada. El hecho pasa a Verificado y vale para todas las rutas que cubre.",
  "verification.dialog.REVALIDATE.title": "Confirmar valores actuales",
  "verification.dialog.REVALIDATE.body":
    "Usted verificó que los valores siguen siendo correctos. Se cierra la revalidación pendiente.",
  "verification.dialog.REJECT.title": "Rechazar hecho",
  "verification.dialog.REJECT.body":
    "El hecho deja de usarse. El motivo queda en el registro de auditoría.",
  "verification.dialog.REQUEST_IOB.title": "Pedir verificación en IOB",
  "verification.dialog.REQUEST_IOB.body":
    "Marca el hecho para que el simulador IOB lo verifique. Mantiene su nivel actual hasta que llegue el resultado.",
  "verification.dialog.sending": "Enviando…",
  "verification.dialog.reason": "Motivo",
  "verification.dialog.note": "Nota (opcional)",
  "verification.dialog.reasonHint": "Mínimo de {min} caracteres · {count} escritos",
  "verification.dialog.noteHint": "Queda registrada en el historial del hecho.",
  "verification.detail.fact": "Hecho",
  "verification.detail.history": "Historial",
  "verification.detail.evidence": "Evidencia",
  "verification.validity.range": "{from} a {to}",
  "verification.validity.open": "desde {from} · abierta",
  "verification.validity.inferredHint":
    "La fuente no declaró el inicio; usamos la fecha de captura.",
  "verification.verifiedBy": "{who} · {time}",
  "verification.event.DERIVED": "Derivado",
  "verification.event.RECHECKED": "Verificado de nuevo",
  "verification.event.CORROBORATED": "Corroborado",
  "verification.event.CONFLICT_DETECTED": "Conflicto detectado",
  "verification.event.SUPERSEDED": "Sustituido",
  "verification.event.REVALIDATION_REQUESTED": "Revalidación solicitada",
  "verification.event.CONFIRMED": "Confirmado",
  "verification.event.REJECTED": "Rechazado",
  "verification.event.IOB_REQUESTED": "IOB solicitado",
  "verification.event.REVOKED": "Revocado",
  "verification.event.EXPIRED": "Vencido",
  "verification.event.related": "Ver hecho relacionado",
  "verification.evidence.iob": "Cuadro registrado en el simulador IOB",
  "verification.evidence.enlarge": "Ampliar el cuadro del simulador",
  "verification.evidence.frameAdmin": "El cuadro del simulador es visible para administradores.",
  "verification.evidence.noFrame": "Sin cuadro registrado para este hallazgo.",
  "verification.evidence.openRun": "Abrir ejecución del agente",
  "verification.evidence.frameTitle": "Resultado IOB · {ncm} · {route}",
  "verification.evidence.annex": "Fila del anexo",
  "verification.evidence.checksPassed": "controles aprobados",
  "verification.evidence.checksFailed": "controles con fallas",
  "verification.evidence.locator": "Posición {start}–{end} en el texto normalizado",
  "verification.evidence.noLocator": "Sin localizador en el texto",
  "verification.evidence.extracted": "extraída el {time}",
  "verification.evidence.none": "Ninguna evidencia adjunta a este hecho.",
  "verification.evidence.allowlisted": "Fuente oficial · {source}",
  "verification.evidence.notAllowlisted": "Fuera de la lista de fuentes",
  "verification.evidence.openDocument": "Abrir documento",
  "verification.evidence.newTab": "(abre en una pestaña nueva)",
  "verification.evidence.openEvidence": "Ver evidencia",
  "verification.compare.conflictTitle": "Lado a lado",
  "verification.compare.field": "Campo",
  "verification.compare.this": "Este hecho",
  "verification.compare.open": "Abrir",
  "verification.compare.differs": "(diverge)",
  "verification.compare.host": "Fuente",
  "verification.compare.driftTitle": "Hecho × regla publicada",
  "verification.compare.driftHint":
    "La regla publicada sigue vigente. Si el hecho es correcto, proponga la corrección de la regla por el flujo de propuestas.",
  "verification.compare.rule": "Regla {version}",
  /* Shell and navigation (UX plan PR 1). */
  "shell.nav.home": "Inicio",
  "shell.nav.lots": "Lotes",
  "shell.nav.rules": "Reglas",
  "shell.nav.documents": "Documentos",
  "shell.nav.productSearch": "Búsqueda por producto",
  "shell.nav.agentsGroup": "Agentes",
  "shell.nav.agentIob": "Agente IOB",
  "shell.nav.agentLogs": "Registros",
  "shell.nav.collapse": "Contraer menú",
  "shell.nav.expand": "Expandir menú",
  "shell.search.trigger": "Buscar NCM, reglas, documentos…",
  "shell.viewAs.self": "{role} (usted)",
  "nav.howItWorks": "Cómo funciona",
  "howItWorks.title": "Cómo funciona",
  "howItWorks.description":
    "Mire, con números reales del motor, qué busca y qué aplica el sistema cuando un producto viaja de una UF a otra.",
  "howItWorks.sections": "Secciones",
  "howItWorks.section.run": "Ejecución guiada",
  "howItWorks.section.runHint":
    "Una simulación real, paso a paso: cada fórmula muestra los números que usó el motor y de dónde salió cada valor.",
  "howItWorks.section.map": "Mapa del sistema",
  "howItWorks.onboarding.title": "En tres pasos",
  "howItWorks.onboarding.source": "Fuente oficial",
  "howItWorks.onboarding.sourceBody":
    "Un sitio del catálogo (SEFAZ, CONFAZ, Senado) publica el acto.",
  "howItWorks.onboarding.evidence": "Evidencia",
  "howItWorks.onboarding.evidenceBody":
    "Guardamos nuestra copia con hash y la cita de cada valor leído.",
  "howItWorks.onboarding.review": "Revisión",
  "howItWorks.onboarding.reviewBody":
    "Una persona confirma antes de que cualquier regla se proponga y publique.",
  "howItWorks.onboarding.dismiss": "Entendido",
  "howItWorks.onboarding.dismissLabel": "Cerrar la introducción",
  "howItWorks.section.mapHint":
    "De dónde vienen los datos y el camino que recorren hasta convertirse en cálculo. Seleccione una etapa para ver qué entra, qué sale y quién decide.",
  "howItWorks.section.glossary": "Glosario",
  "howItWorks.section.glossaryHint":
    "Los términos que aparecen en el cálculo, con un ejemplo ilustrativo cada uno.",
  "howItWorks.form.title": "Operación",
  "howItWorks.form.presets": "Ejemplos",
  "howItWorks.form.ncm": "NCM",
  "howItWorks.form.origin": "Origen",
  "howItWorks.form.destination": "Destino",
  "howItWorks.form.cost": "Costo del producto",
  "howItWorks.form.taxpayer": "¿Destinatario contribuyente de ICMS?",
  "howItWorks.form.taxpayerYes": "Sí — reventa o industria",
  "howItWorks.form.taxpayerNo": "No — consumidor final",
  "howItWorks.form.date": "Fecha del cálculo",
  "howItWorks.form.run": "Ejecutar",
  "howItWorks.form.running": "Ejecutando…",
  "howItWorks.form.invalid": "Indique NCM de 8 dígitos, origen, destino, costo y fecha.",
  "howItWorks.form.stateless":
    "Simulación sin guardado: usa el mismo motor de la Calculadora (modo Operación) sobre el conjunto de reglas vigente. No se guarda nada en el historial.",
  "howItWorks.form.permission":
    "Se necesita el permiso de ejecutar cálculos para correr la simulación.",
  "howItWorks.preset.tyre": "Neumático SP → RJ",
  "howItWorks.preset.tyreHint": "4011.10.00 · ICMS-ST con MVA",
  "howItWorks.preset.soda": "Refresco SP → MG",
  "howItWorks.preset.sodaHint": "2202.10.00 · ICMS-ST",
  "howItWorks.preset.notebook": "Notebook SP → SP",
  "howItWorks.preset.notebookHint": "8471.30.12 · operación interna",
  "howItWorks.preset.airFryer": "Freidora de aire BA → MG",
  "howItWorks.preset.airFryerHint": "8516.60.00 · ST revocada · consumidor final",
  "howItWorks.player.empty":
    "Elija un ejemplo o complete la operación y haga clic en Ejecutar para ver al motor trabajar.",
  "howItWorks.player.loading": "Consultando catálogo, reglas y hechos fiscales…",
  "howItWorks.player.controls": "Controles de la animación",
  "howItWorks.player.play": "Reproducir",
  "howItWorks.player.pause": "Pausar",
  "howItWorks.player.back": "Paso anterior",
  "howItWorks.player.forward": "Paso siguiente",
  "howItWorks.player.restart": "Reiniciar",
  "howItWorks.player.showAll": "Mostrar todo",
  "howItWorks.player.speed": "Velocidad",
  "howItWorks.player.progress": "Paso {current} de {total}",
  "howItWorks.player.progressLabel": "Progreso de la ejecución",
  "howItWorks.perspective.entry":
    "Destinatario contribuyente: el motor calcula la entrada {origin} → {destination} — IPI, ICMS propio e ICMS-ST, como en el costo de la Calculadora.",
  "howItWorks.perspective.consumer":
    "Consumidor final: el motor calcula la venta {origin} → {destination} — ICMS propio y DIFAL (EC 87/2015). No hay ICMS-ST para consumidor final.",
  "howItWorks.tone.done": "Aplicado",
  "howItWorks.tone.skip": "No aplica",
  "howItWorks.tone.gap": "Requiere revisión",
  "howItWorks.tone.warn": "Consulta parcial",
  "howItWorks.stepTitle.ncm": "NCM validado en el catálogo",
  "howItWorks.stepTitle.cest": "CEST y segmento (Conv. ICMS 142/18)",
  "howItWorks.stepTitle.ruleset": "Conjunto de reglas vigente",
  "howItWorks.stepTitle.rule": "Regla para NCM × ruta",
  "howItWorks.stepTitle.ipi": "IPI (TIPI)",
  "howItWorks.stepTitle.ownIcms": "ICMS propio",
  "howItWorks.stepTitle.mva": "¿Aplica ST? MVA original → ajustada",
  "howItWorks.stepTitle.icmsSt": "Base ST e ICMS-ST",
  "howItWorks.stepTitle.difal": "DIFAL y FCP",
  "howItWorks.stepTitle.total": "Costo final",
  "howItWorks.step.ncm.found":
    "El código existe en el catálogo oficial Siscomex. El catálogo identifica el producto; no trae alícuota.",
  "howItWorks.step.ncm.missing":
    "Código fuera del catálogo Siscomex. El motor igual busca reglas por él, pero revise la clasificación.",
  "howItWorks.step.ncm.error":
    "No se pudo consultar el catálogo NCM ahora. El cálculo sigue por las reglas.",
  "howItWorks.step.cest.none":
    "Ningún CEST en las reglas de este NCM × ruta. Sin CEST, el motor exige una única regla para NCM + ruta.",
  "howItWorks.step.cest.rule":
    "La regla encontrada es específica del CEST {cest}; el segmento viene del Convenio ICMS 142/18.",
  "howItWorks.step.cest.candidates":
    "{count} CEST aparecen en las reglas y hechos de este NCM. Indicar el CEST desempata reglas concurrentes.",
  "howItWorks.step.ruleset.body":
    "El motor fija el conjunto publicado {version} y solo considera reglas vigentes en la fecha del cálculo. El resultado siempre cita esa versión.",
  "howItWorks.step.rule.found": "Una regla publicada cubre este NCM en esta ruta y en esta fecha.",
  "howItWorks.step.rule.specific":
    "{count} reglas sirven para esta ruta; el motor eligió la más específica (CEST, origen, destino).",
  "howItWorks.step.rule.ambiguous":
    "{count} reglas empatan para NCM + ruta sin CEST. El motor no elige: el ítem pasa a revisión y la ruta queda como brecha de cobertura.",
  "howItWorks.step.rule.missing":
    "Ninguna regla publicada cubre este NCM en esta ruta y fecha. El motor no inventa alícuota: el ítem pasa a revisión y la ruta queda como brecha de cobertura.",
  "howItWorks.step.ipi.body":
    "El IPI viene de la línea nacional de la TIPI para el NCM, aplicada sobre el costo.",
  "howItWorks.step.ipi.none": "No hay línea TIPI publicada para este NCM: el motor no suma IPI.",
  "howItWorks.step.ownIcms.internal":
    "Operación interna en {uf}: vale la alícuota interna de la UF.",
  "howItWorks.step.ownIcms.notTaxed":
    "La regla no grava el ICMS en esta operación. Abra la regla para ver si es una exención declarada o silencio.",
  "howItWorks.step.ownIcms.noRule": "Sin regla de ICMS, el motor no calcula ICMS propio.",
  "howItWorks.step.ownIcms.closed":
    "El ICMS-ST pagado en la entrada ya cerró la cadena de esta venta interna.",
  "howItWorks.band.4":
    "{origin} → {destination}: 4%, la alícuota de importados (Resolución del Senado 13/2012).",
  "howItWorks.band.7":
    "{origin} → {destination}: 7%, del Sur/Sudeste (excepto ES) hacia Norte, Nordeste, Centro-Oeste y ES (Resolución del Senado 22/89).",
  "howItWorks.band.12":
    "{origin} → {destination}: 12%, la alícuota interestatal general (Resolución del Senado 22/89).",
  "howItWorks.band.other":
    "{origin} → {destination}: alícuota interestatal declarada por la regla publicada.",
  "howItWorks.step.mva.adjusted":
    "Aplica ST. Como la alícuota interestatal es menor que la interna, la MVA original se ajusta para no favorecer a quien compra de afuera.",
  "howItWorks.step.mva.intrastate":
    "Aplica ST. En operación interna, la MVA original vale sin ajuste.",
  "howItWorks.step.mva.materialized":
    "Aplica ST. Esta política usa la MVA ajustada ya materializada en la regla.",
  "howItWorks.step.mva.standard":
    "La regla no prevé sustitución tributaria en esta ruta: sin MVA y sin ICMS-ST.",
  "howItWorks.step.mva.revoked":
    "La regla registra ST no aplicable en esta ruta (revocada): el producto sigue por el ICMS normal.",
  "howItWorks.step.mva.consumer":
    "El consumidor final no revende: el motor no retiene ICMS-ST en esta venta.",
  "howItWorks.step.mva.noRule": "Sin regla publicada, el motor no sabe si hay ST.",
  "howItWorks.step.icmsSt.body":
    "El ICMS-ST anticipa el impuesto de las etapas siguientes: base presunta × alícuota interna del destino, menos el ICMS propio ya destacado.",
  "howItWorks.step.icmsSt.none":
    "Sin sustitución tributaria en esta operación: el ICMS-ST no entra en el costo.",
  "howItWorks.step.icmsSt.noRule": "Sin regla publicada, el ICMS-ST no se calcula.",
  "howItWorks.step.difal.body":
    "Venta a consumidor final en otra UF: el remitente recoge a {uf} la diferencia entre la alícuota interna y la interestatal.",
  "howItWorks.step.difal.taxpayer":
    "Destinatario contribuyente: no hay DIFAL de consumidor final; la diferencia se trata por ICMS-ST o por el crédito.",
  "howItWorks.step.difal.intrastate": "Operación interna: no existe diferencial de alícuota.",
  "howItWorks.step.difal.noRule": "Sin regla publicada, el DIFAL no se calcula.",
  "howItWorks.step.total.entry":
    "Costo con los tributos que quedan en el producto: IPI e ICMS-ST (el ICMS propio se vuelve crédito).",
  "howItWorks.step.total.consumer":
    "Costo con IPI y el DIFAL recogido al destino (el ICMS propio está en el precio).",
  "howItWorks.step.total.review":
    "Resultado no autoritativo: falta regla para esta ruta. Publique la regla antes de usar este valor.",
  "howItWorks.step.rule.icmsSilent":
    "La regla seleccionada es la fila nacional de la TIPI: declara el IPI y guarda silencio sobre el ICMS (EXCLUDED). Con la política {policy} el motor usa la regla entera y responde ICMS 0. Es un vacío por revisar, no una exención.",
  "howItWorks.step.ownIcms.silent":
    "La regla no declara ICMS (EXCLUDED significa silencio, no exención). El motor deja el ICMS propio en cero; falta una regla de ruta que declare el ICMS.",
  "howItWorks.step.ownIcms.exempt": "La regla declara el ICMS exento en esta operación.",
  "howItWorks.step.mva.silent":
    "La regla no dice si hay ST. El motor aplicó “sin ST”; revise los hechos fiscales y publique la regla de la ruta.",
  "howItWorks.step.icmsSt.silent":
    "ICMS-ST no calculado porque la regla guarda silencio sobre el ICMS. El costo de abajo puede estar subestimado.",
  "howItWorks.step.total.icmsSilent":
    "Valor del motor sin ICMS propio ni ICMS-ST: la regla guarda silencio sobre el ICMS. No use este costo antes de publicar la regla de la ruta.",
  "howItWorks.value.notStated": "No declarado",
  "howItWorks.summary.icmsSilent":
    "Regla en silencio sobre ICMS: el motor devolvió ICMS 0 por la política del conjunto. Trátelo como vacío y revíselo.",
  "ruleDivergence.source.IOB_SIMULADOR": "IOB",
  "ruleDivergence.source.WEB_RESEARCH": "Investigación web",
  "ruleDivergence.source.OPERATOR": "Operador",
  "ruleDivergence.source.CATALOG_DERIVATION": "Catálogo",
  "ruleDivergence.certified": "certificó",
  "ruleDivergence.verified": "verificó",
  "ruleDivergence.stMva": "Difiere de la regla — {source} {verb} ST MVA {mva}",
  "ruleDivergence.st": "Difiere de la regla — {source} {verb} ST",
  "ruleDivergence.noSt": "Difiere de la regla — {source} {verb} sin ST",
  "ruleDivergence.hint":
    "Un hecho fiscal certificado o verificado no coincide con la regla publicada. Ábralo en Verificación → Divergencias y prepare la propuesta de corrección.",
  "verification.item.driftSilent":
    "Regla en silencio sobre ICMS (fila TIPI): el motor responde ICMS 0",
  "calc.result.icmsSilent":
    "La regla aplicada guarda silencio sobre el ICMS (fila TIPI, EXCLUDED). El motor dejó ICMS e ICMS-ST en cero por la política del conjunto; no es una exención. Trátelo como vacío y revíselo antes de usar este costo.",
  "howItWorks.fact.ncm": "NCM",
  "howItWorks.fact.description": "Descripción oficial",
  "howItWorks.fact.cest": "CEST",
  "howItWorks.fact.version": "Versión",
  "howItWorks.fact.policy": "Política del motor",
  "howItWorks.fact.digest": "Contenido (hash)",
  "howItWorks.fact.date": "Fecha",
  "howItWorks.fact.ruleId": "Regla",
  "howItWorks.fact.route": "Ruta",
  "howItWorks.fact.validFrom": "Vigente desde",
  "howItWorks.fact.validTo": "Vigente hasta",
  "howItWorks.fact.legalReference": "Base legal",
  "howItWorks.fact.lookup": "Resultado de la búsqueda",
  "howItWorks.fact.stApplicable": "Aplica ST",
  "howItWorks.fact.fcp": "FCP",
  "howItWorks.value.openEnded": "sin fecha final",
  "howItWorks.value.yes": "Sí",
  "howItWorks.value.no": "No",
  "howItWorks.value.fcpNotModeled": "no se calcula en esta base (sin alícuota publicada)",
  "howItWorks.term.cost": "costo",
  "howItWorks.term.ipiRate": "alícuota IPI",
  "howItWorks.term.internalRate": "interna destino",
  "howItWorks.term.interstateRate": "interestatal",
  "howItWorks.term.originalMva": "MVA original",
  "howItWorks.term.adjustedMva": "MVA ajustada",
  "howItWorks.term.ipi": "IPI",
  "howItWorks.term.reduction": "reducción de base",
  "howItWorks.term.stBase": "base ST",
  "howItWorks.term.ownIcms": "ICMS propio",
  "howItWorks.term.icmsSt": "ICMS-ST",
  "howItWorks.term.difal": "DIFAL",
  "howItWorks.formula.ipi": "IPI",
  "howItWorks.formula.ownIcms": "ICMS propio",
  "howItWorks.formula.adjustedMva": "MVA ajustada",
  "howItWorks.formula.stBase": "Base ST",
  "howItWorks.formula.icmsSt": "ICMS-ST",
  "howItWorks.formula.difal": "DIFAL",
  "howItWorks.formula.total": "Costo final",
  "howItWorks.source.label": "Fuente",
  "howItWorks.source.catalogNcm": "Catálogo Siscomex",
  "howItWorks.source.catalogCest": "CEST · Conv. ICMS 142/18",
  "howItWorks.source.tipi": "TIPI · línea nacional",
  "howItWorks.source.rule": "Regla {id}",
  "howItWorks.source.engine": "Motor de cálculo",
  "howItWorks.source.factAgrees": "coincide con la regla",
  "howItWorks.source.factDiffers": "difiere de la regla",
  "howItWorks.source.factOnly": "hecho fiscal, no usado en el cálculo",
  "howItWorks.summary.title": "Resultado",
  "howItWorks.summary.taxes": "Tributos en el costo: {value}",
  "howItWorks.summary.ruleset": "Conjunto {version} · {date}",
  "howItWorks.summary.openCalculator": "Abrir en la Calculadora",
  "howItWorks.summary.openGaps": "Ver brechas de cobertura",
  "howItWorks.summary.openRule": "Ver regla",
  "howItWorks.summary.pisCofins": "PIS/COFINS quedan fuera de esta base.",
  "howItWorks.map.tour": "Recorrer el flujo",
  "howItWorks.map.stop": "Detener",
  "howItWorks.map.bandData": "De dónde vienen los datos",
  "howItWorks.map.bandRules": "Cómo se vuelve regla y cálculo",
  "howItWorks.map.laneWeb": "Búsqueda pública",
  "howItWorks.map.laneIob": "Simulador IOB",
  "howItWorks.map.promotion":
    "Los hechos certificados o verificados pueden volverse propuesta (ADR 0013, en propuesta). Ningún hecho se publica solo.",
  "howItWorks.map.count.facts": "{count} hechos",
  "howItWorks.map.count.sources": "{count} fuentes",
  "howItWorks.map.count.queue": "{count} en cola",
  "howItWorks.map.count.inReview": "{count} en revisión",
  "howItWorks.map.count.rules": "{count} reglas",
  "howItWorks.map.count.calculations": "{count} cálculos en 24 h",
  "howItWorks.map.node.sources": "Fuentes oficiales",
  "howItWorks.map.node.sourcesSub": "CONFAZ · SEFAZ · Senado",
  "howItWorks.map.node.sourcesBody":
    "El sistema observa las publicaciones oficiales de las 27 SEFAZ, del CONFAZ y del Senado. Cada documento capturado guarda hash y fecha.",
  "howItWorks.map.node.webResearch": "Búsqueda web",
  "howItWorks.map.node.webResearchSub": "localizar → descargar → extraer",
  "howItWorks.map.node.webResearchBody":
    "Los barridos localizan el anexo correcto, descargan el documento y extraen filas NCM/CEST, MVA y alícuotas, siempre con cita.",
  "howItWorks.map.node.unverified": "Hecho fiscal",
  "howItWorks.map.node.unverifiedSub": "No verificado",
  "howItWorks.map.node.unverifiedBody":
    "Lo que extrae la búsqueda se vuelve hecho fiscal no verificado: útil para orientar, etiquetado y nunca tratado como regla.",
  "howItWorks.map.node.verification": "Verificación humana",
  "howItWorks.map.node.verificationSub": "Reglas → Verificación",
  "howItWorks.map.node.verificationBody":
    "Un revisor contrasta el hecho con el documento citado y lo confirma o rechaza. Las diferencias con IOB aparecen como conflicto.",
  "howItWorks.map.node.verified": "Hecho fiscal",
  "howItWorks.map.node.verifiedSub": "Verificado",
  "howItWorks.map.node.verifiedBody":
    "Hecho confirmado por una persona, con la cita que lo respalda.",
  "howItWorks.map.node.iob": "Agente IOB",
  "howItWorks.map.node.iobSub": "navegador en VM",
  "howItWorks.map.node.iobBody":
    "Un agente opera el Simulador IOB en una máquina virtual, consulta NCM × ruta y graba la pantalla del resultado.",
  "howItWorks.map.node.iobFindings": "Registros del agente",
  "howItWorks.map.node.iobFindingsSub": "ST, MVA y cuadros",
  "howItWorks.map.node.iobFindingsBody":
    "Cada consulta se vuelve un registro con el resultado y los cuadros grabados.",
  "howItWorks.map.node.certified": "Hecho fiscal",
  "howItWorks.map.node.certifiedSub": "Certificado IOB",
  "howItWorks.map.node.certifiedBody":
    "El resultado de IOB se certifica por defecto y vale hasta que aparezca una nueva vigencia.",
  "howItWorks.map.node.documents": "Documentos",
  "howItWorks.map.node.documentsSub": "evidencia aprobada",
  "howItWorks.map.node.documentsBody":
    "Toda regla publicada necesita un documento oficial aprobado como evidencia.",
  "howItWorks.map.node.proposals": "Propuestas",
  "howItWorks.map.node.proposalsSub": "cambio con evidencia",
  "howItWorks.map.node.proposalsBody":
    "Una propuesta describe el cambio de regla (MVA, alícuotas, vigencia) y apunta a la evidencia.",
  "howItWorks.map.node.review": "Revisión",
  "howItWorks.map.node.reviewSub": "dos aprobaciones",
  "howItWorks.map.node.reviewBody":
    "Dos personas distintas aprueban; quien propone no aprueba su propio cambio.",
  "howItWorks.map.node.publication": "Publicación",
  "howItWorks.map.node.publicationSub": "versión inmutable",
  "howItWorks.map.node.publicationBody":
    "Publicar genera una nueva versión del conjunto con hash de contenido. Las versiones publicadas nunca cambian.",
  "howItWorks.map.node.ruleset": "Conjunto de reglas",
  "howItWorks.map.node.rulesetSub": "vigente",
  "howItWorks.map.node.rulesetBody":
    "La versión vigente es la única fuente que el motor lee para calcular.",
  "howItWorks.map.node.engine": "Motor de cálculo",
  "howItWorks.map.node.engineSub": "determinista",
  "howItWorks.map.node.engineBody":
    "La misma entrada y la misma versión dan siempre el mismo resultado, con memoria de cálculo y versión citada.",
  "howItWorks.map.node.outputs": "Calculadora · Lotes · API",
  "howItWorks.map.node.outputsSub": "quién consume",
  "howItWorks.map.node.outputsBody":
    "La Calculadora, los lotes de planilla y las integraciones por API usan el mismo motor y la misma versión.",
  "howItWorks.map.detail.label": "Etapa seleccionada",
  "howItWorks.map.detail.hint":
    "Seleccione una etapa para ver qué entra, qué sale y quién decide allí.",
  "howItWorks.map.detail.open": "Abrir {name}",
  "howItWorks.map.detail.In": "Entra",
  "howItWorks.map.detail.Out": "Sale",
  "howItWorks.map.detail.Who": "Quién decide",
  "howItWorks.map.node.sourcesIn":
    "Sitios oficiales registrados (CONFAZ, SEFAZ, Senado) y los hosts permitidos de cada uno.",
  "howItWorks.map.node.sourcesOut":
    "El catálogo de dónde la búsqueda puede buscar y descargar, con hash y fecha de cada captura.",
  "howItWorks.map.node.sourcesWho": "Los administradores registran y revisan cada fuente.",
  "howItWorks.map.node.webResearchIn":
    "Alcance de NCM y rutas, estrategia, límite de búsquedas y presupuesto.",
  "howItWorks.map.node.webResearchOut":
    "Documentos oficiales descargados y líneas de anexo leídas, cada una con la cita literal.",
  "howItWorks.map.node.webResearchWho":
    "El sistema ejecuta; un administrador crea, pausa, cancela o cierra la búsqueda.",
  "howItWorks.map.node.unverifiedIn":
    "Valores leídos de los anexos: CEST, NCM, MVA, alícuota y vigencia.",
  "howItWorks.map.node.unverifiedOut":
    "Hechos etiquetados como no verificados, en la cola de Verificación.",
  "howItWorks.map.node.unverifiedWho":
    "Nadie todavía: un hecho no verificado nunca entra en un cálculo.",
  "howItWorks.map.node.verificationIn":
    "El hecho no verificado, el documento conservado y la cita.",
  "howItWorks.map.node.verificationOut":
    "Hecho verificado o rechazado, con el motivo registrado en la auditoría.",
  "howItWorks.map.node.verificationWho":
    "Una persona revisora. Verificar un hecho no publica una regla.",
  "howItWorks.map.node.verifiedIn": "Hechos confirmados por revisión humana.",
  "howItWorks.map.node.verifiedOut": "Base para una propuesta de regla (ADR 0013, en propuesta).",
  "howItWorks.map.node.verifiedWho":
    "La decisión ya está registrada; el hecho no publica nada por sí solo.",
  "howItWorks.map.node.iobIn": "La cola de NCM × ruta y la agenda semanal del agente.",
  "howItWorks.map.node.iobOut": "Consultas al Simulador IOB, grabadas cuadro a cuadro.",
  "howItWorks.map.node.iobWho":
    "El agente ejecuta; un administrador organiza la cola y la agenda y puede detener la ejecución.",
  "howItWorks.map.node.iobFindingsIn": "Las pantallas de resultado capturadas por el agente.",
  "howItWorks.map.node.iobFindingsOut":
    "Registros: ST encontrada, sin ST, solo ST interna o ilegible, con los cuadros.",
  "howItWorks.map.node.iobFindingsWho": "El sistema registra lo que mostró la pantalla.",
  "howItWorks.map.node.certifiedIn": "Registros del IOB para un NCM × ruta.",
  "howItWorks.map.node.certifiedOut":
    "Hechos certificados por el IOB, válidos hasta que surja una nueva vigencia.",
  "howItWorks.map.node.certifiedWho":
    "La regla de certificación; las divergencias con la búsqueda web van a revisión humana.",
  "howItWorks.map.node.documentsIn": "Documentos oficiales recogidos de las fuentes.",
  "howItWorks.map.node.documentsOut": "Evidencia aprobada que puede sustentar una propuesta.",
  "howItWorks.map.node.documentsWho": "Los operadores aprueban o rechazan cada documento.",
  "howItWorks.map.node.proposalsIn":
    "Un cambio de regla (MVA, alícuotas, vigencia) y la evidencia aprobada.",
  "howItWorks.map.node.proposalsOut": "Una propuesta en revisión, con el diff antes/después.",
  "howItWorks.map.node.proposalsWho": "Un operador propone; proponer no cambia ninguna regla.",
  "howItWorks.map.node.reviewIn": "La propuesta, su diff y la evidencia citada.",
  "howItWorks.map.node.reviewOut": "Aprobación o rechazo, cada uno con motivo.",
  "howItWorks.map.node.reviewWho": "Dos personas distintas de quien propuso.",
  "howItWorks.map.node.publicationIn": "Propuestas aprobadas para el próximo conjunto.",
  "howItWorks.map.node.publicationOut":
    "Una nueva versión inmutable del conjunto, con hash de contenido.",
  "howItWorks.map.node.publicationWho": "Quien tiene permiso para publicar, con motivo registrado.",
  "howItWorks.map.node.rulesetIn": "La versión publicada.",
  "howItWorks.map.node.rulesetOut":
    "Las reglas vigentes en cada fecha, la única fuente que lee el motor.",
  "howItWorks.map.node.rulesetWho": "Nadie edita una versión publicada; se cambia publicando otra.",
  "howItWorks.map.node.engineIn":
    "La operación (NCM, ruta, valor, fecha) y la versión de reglas vigente.",
  "howItWorks.map.node.engineOut":
    "Un cálculo determinista con memoria de cálculo y la versión citada.",
  "howItWorks.map.node.engineWho": "Nadie: el motor solo aplica reglas publicadas.",
  "howItWorks.map.node.outputsIn": "Resultados del motor para la versión fijada.",
  "howItWorks.map.node.outputsOut": "Calculadora, lotes de planilla y respuestas de la API.",
  "howItWorks.map.node.outputsWho": "Quien consume decide cómo usar el resultado.",
  "howItWorks.glossary.example": "Ejemplo ilustrativo",
  "howItWorks.glossary.internal.term": "Alícuota interna",
  "howItWorks.glossary.internal.body":
    "El porcentaje que la UF cobra en las operaciones dentro de ella; en ICMS-ST y DIFAL es la del destino.",
  "howItWorks.glossary.internal.example": "Interna 18% sobre R$ 100,00 = R$ 18,00.",
  "howItWorks.glossary.interstate.term": "Interestatal 4 / 7 / 12%",
  "howItWorks.glossary.interstate.body":
    "Alícuota entre UF fijada por el Senado: 12% en general, 7% del Sur/Sudeste (excepto ES) hacia N, NE, CO y ES, 4% para importados.",
  "howItWorks.glossary.interstate.example": "SP → BA: 7%. BA → SP: 12%. Producto importado: 4%.",
  "howItWorks.glossary.mvaOriginal.term": "MVA original",
  "howItWorks.glossary.mvaOriginal.body":
    "Margen de valor agregado presunto que el convenio o protocolo publica para el producto.",
  "howItWorks.glossary.mvaOriginal.example":
    "MVA 40% sobre R$ 100,00 → base presunta de R$ 140,00.",
  "howItWorks.glossary.mvaAdjusted.term": "MVA ajustada",
  "howItWorks.glossary.mvaAdjusted.body":
    "Corrige la MVA cuando la interestatal es menor que la interna: ((1 + MVA) × (1 − inter) ÷ (1 − interna)) − 1.",
  "howItWorks.glossary.mvaAdjusted.example": "((1,40 × 0,88) ÷ 0,82) − 1 = 50,24%.",
  "howItWorks.glossary.icmsSt.term": "ICMS-ST",
  "howItWorks.glossary.icmsSt.body":
    "Sustitución tributaria: un contribuyente recoge por anticipado el ICMS de las etapas siguientes. Base ST × interna − ICMS propio.",
  "howItWorks.glossary.icmsSt.example": "R$ 150,24 × 18% − R$ 12,00 = R$ 15,04.",
  "howItWorks.glossary.difal.term": "DIFAL",
  "howItWorks.glossary.difal.body":
    "Diferencial de alícuota en la venta a consumidor final de otra UF (EC 87/2015): valor × (interna destino − interestatal).",
  "howItWorks.glossary.difal.example": "R$ 100,00 × (18% − 12%) = R$ 6,00.",
  "howItWorks.glossary.fcp.term": "FCP",
  "howItWorks.glossary.fcp.body":
    "Fondo de Combate a la Pobreza: adicional de hasta 2 puntos en la alícuota interna de algunos productos en algunas UF. No se calcula en esta base.",
  "howItWorks.glossary.fcp.example":
    "Interna 18% + FCP 2% = 20%; en R$ 100,00, R$ 2,00 van al fondo.",
  "howItWorks.glossary.cest.term": "CEST",
  "howItWorks.glossary.cest.body":
    "Código Especificador de la Sustitución Tributaria (Conv. ICMS 142/18): identifica los bienes sujetos a ST por segmento.",
  "howItWorks.glossary.cest.example":
    "16.001.00 — neumáticos nuevos para automóviles (NCM 4011.10.00), segmento 16.",
  "howItWorks.glossary.validity.term": "Vigencia",
  "howItWorks.glossary.validity.body":
    "El período en que la regla vale. El motor usa solo reglas vigentes en la fecha del cálculo.",
  "howItWorks.glossary.validity.example":
    "Regla desde 01/03/2026, sin fin: vale el 28/09/2026, no el 15/02/2026.",
  /* -- Home v3: attention strip, operations, shell help ------------------ */
  "home.env.tag": "Demostración",
  "home.attention.label": "Pendientes",
  "home.attention.clear": "Nada pendiente",
  "home.attention.clearDetail": "Lotes, verificación y vencimientos al día.",
  "home.attention.checking": "verificando…",
  "home.attention.unavailable": "no disponible",
  "home.attention.period7d": "últimos 7 días",
  "home.attention.lotsReview.name": "Lotes para revisión",
  "home.attention.lotsReview.one": "lote para revisión",
  "home.attention.lotsReview.other": "lotes para revisión",
  "home.attention.lotsReview.action": "Revisar",
  "home.attention.lotsFailed.name": "Lotes con falla",
  "home.attention.lotsFailed.one": "lote con falla",
  "home.attention.lotsFailed.other": "lotes con falla",
  "home.attention.lotsFailed.action": "Ver fallas",
  "home.attention.verification.name": "Verificación",
  "home.attention.verification.one": "hecho por verificar",
  "home.attention.verification.other": "hechos por verificar",
  "home.attention.verification.meta": "Sin divergencias ni conflictos",
  "home.attention.verification.action": "Verificar",
  "home.attention.drift.one": "{count} divergencia",
  "home.attention.drift.other": "{count} divergencias",
  "home.attention.conflicting.one": "{count} en conflicto",
  "home.attention.conflicting.other": "{count} en conflicto",
  "home.attention.rulesExpiring.name": "Vencimientos",
  "home.attention.rulesExpiring.one": "regla por vencer",
  "home.attention.rulesExpiring.other": "reglas por vencer",
  "home.attention.rulesExpiring.meta": "próximos 30 días · conjunto vigente",
  "home.attention.rulesExpiring.action": "Ver reglas",
  "home.cta.title": "Iniciar cálculo",
  "home.cta.continue": "Continuar cálculo",
  "home.cta.continueHint": "8 dígitos. En la calculadora completará la ruta y el costo.",
  "home.jobs.next.review": "Revisar",
  "home.jobs.next.failure": "Ver falla",
  "home.jobs.next.open": "Abrir",
  "home.rules.openCoverage": "Cobertura por familia y UF",
  "home.ops.description": "Agentes, investigación web y actividad de gobernanza.",
  "home.ops.openAgent": "Abrir Agente IOB",
  "home.ops.openResearch": "Abrir Investigación web",
  "home.ops.research.units": "{done} de {total} unidades concluidas",
  "nav.help": "Ayuda",
  "shell.nav.collapseTooltip": "Contraer menú · {shortcut}",
  "shell.nav.expandTooltip": "Expandir menú · {shortcut}",
  "verification.bootstrap.summaryInternal": "Alícuotas internas",
  "verification.bootstrap.summaryInterstate": "Tabla interestatal",
  "verification.bootstrap.summaryOf": "{confirmed} de {total}",
  "verification.bootstrap.showDetail": "Detalles",
  "agents.lookupRelation.task": "parte de la tarea en curso",
  "agents.lookupRelation.gap": "brecha de cobertura, fuera de la ruta de la tarea ({route})",
  "agents.lookupRelation.direct": "consulta suelta, fuera de la ruta de la tarea ({route})",
  "calc.result.waiting": "Esperando datos",
  "ruleDrafts.next.action": "Preparar el próximo borrador",
  "ruleDrafts.next.open": "Abrir borrador {version}",
  "ruleDrafts.next.title": "Preparar el próximo borrador de versión",
  "ruleDrafts.next.body":
    "El borrador parte de la versión publicada {version} y de todas las propuestas aprobadas (puede no haber ninguna). No se publica nada: publicar sigue exigiendo al menos una propuesta aprobada y el flujo de publicación.",
  "ruleDrafts.next.noActive":
    "No hay versión publicada: el borrador nace de las propuestas aprobadas.",
  "ruleDrafts.next.policy": "Política del borrador",
  "ruleDrafts.next.recommended": "recomendada (ADR 0011, 0015)",
  "ruleDrafts.next.reason": "Motivo",
  "ruleDrafts.next.reasonDefault":
    "Adoptar tax-family-v1 (ADR 0011): las rutas sin regla de ICMS pasan a revisión y brecha, no a ICMS 0.",
  "ruleDrafts.next.create": "Crear borrador",
  "ruleDrafts.next.created": "Borrador {version} creado con {policy}.",
  "ruleDrafts.readiness.loading": "Verificando el contenido bajo {policy}…",
  "ruleDrafts.readiness.blocking":
    "{count} infracciones impiden adoptar {policy}. Corríjalas por propuesta antes.",
  "ruleDrafts.readiness.ok": "El contenido cumple {policy}.",
  "ruleDrafts.readiness.ipiSummary":
    "{total} reglas de ruta marcan IPI EXCLUDED: {review} para revisar y {placeholder} placeholders. Bajo tax-family-v1, EXCLUDED significa silencio y el IPI viene de la TIPI. La lista para revisar aparece en el borrador.",
  "ruleDrafts.adoption.title": "Adopción de tax-family-v1 (ADR 0011)",
  "ruleDrafts.adoption.hint": "revisión antes de publicar",
  "ruleDrafts.adoption.body":
    "Bajo tax-family-v1, una regla de ruta con IPI EXCLUDED es silenciosa: el IPI viene de la fila TIPI y entra en el costo y en la base del ST. Si la exclusión es un tratamiento revisado, reescríbala como EXEMPT. Los placeholders (la planilla no cotizó la TIPI) pueden quedar como están.",
  "ruleDrafts.adoption.none": "Ninguna regla de ruta marca IPI EXCLUDED.",
  "ruleDrafts.adoption.column.rule": "NCM · CEST",
  "ruleDrafts.adoption.column.route": "Ruta",
  "ruleDrafts.adoption.column.reason": "Motivo del IPI EXCLUDED",
  "ruleDrafts.adoption.column.kind": "Clasificación",
  "ruleDrafts.adoption.column.change": "IPI bajo tax-family-v1",
  "ruleDrafts.adoption.column.draft": "Borrador",
  "ruleDrafts.adoption.kind.REVIEW": "Revisar",
  "ruleDrafts.adoption.kind.PLACEHOLDER": "Placeholder",
  "ruleDrafts.adoption.fromTipi": "EXCLUDED → TIPI {rate}",
  "ruleDrafts.adoption.tipiExempt": "EXCLUDED → TIPI exento",
  "ruleDrafts.adoption.noTipi": "EXCLUDED → sin IPI (ninguna TIPI)",
  "ruleDrafts.adoption.restated": "→ EXEMPT (reescrita)",
  "ruleDrafts.adoption.select": "Seleccionar {rule}",
  "ruleDrafts.adoption.reason": "Motivo de la reescritura",
  "ruleDrafts.adoption.restate": "Reescribir como EXEMPT ({count})",
  "ruleDrafts.adoption.result":
    "{created} borradores creados, {existing} ya existían. Adjunte la evidencia y envíe en Borradores de propuesta.",
  "ruleDrafts.adoption.truncated": "Mostrando {shown} de {total}.",
  "ruleDrafts.adoption.violations": "Infracciones bajo {policy}",
  "ruleDrafts.status.EVIDENCE_REQUIRED": "Evidencia pendiente",
  "ruleDrafts.status.READY": "Listo para enviar",
  "ruleDrafts.status.SUBMITTED": "Enviado",
  "ruleDrafts.status.DISCARDED": "Descartado",
  "ruleDrafts.origin.FISCAL_FACT": "Hecho certificado",
  "ruleDrafts.origin.IPI_RESTATEMENT": "Reescritura de IPI",
  "ruleDrafts.panel.title": "Borradores de propuesta",
  "ruleDrafts.panel.hint": "{count} borradores",
  "ruleDrafts.panel.body":
    "Los borradores no son propuestas. Cada uno pasa a propuesta (Pendiente de revisión) solo después de adjuntar evidencia aprobada en Documentos; revisión, aprobación y publicación siguen las reglas actuales.",
  "ruleDrafts.panel.empty":
    "Ningún borrador para esta versión. Use Verificación → Divergencias → Proponer reglas, o la reescritura de IPI de arriba.",
  "ruleDrafts.group": "Grupo {group}",
  "ruleDrafts.group.submit": "Adjuntar evidencia al grupo ({count})",
  "ruleDrafts.values":
    "ST {st} · MVA original {mva} · interestatal {interstate} · interna {internal}",
  "ruleDrafts.value.blank": "en blanco",
  "ruleDrafts.value.yes": "sí",
  "ruleDrafts.value.no": "no",
  "ruleDrafts.operation.SUPERSEDE": "Sustituye la regla {rule}",
  "ruleDrafts.operation.UPSERT": "Nueva regla de ruta",
  "ruleDrafts.checklist.title": "Documentos oficiales a adjuntar",
  "ruleDrafts.checklist.CONV_142_18_ANNEX":
    "Conv. ICMS 142/18, Anexo {annex} (segmento {segment}, CEST {cest})",
  "ruleDrafts.checklist.CONV_142_18_ANNEX.noCest":
    "Conv. ICMS 142/18: identifique el CEST del NCM {ncm}",
  "ruleDrafts.checklist.ST_AGREEMENT":
    "Convenio o protocolo ICMS que vincula {originUf} y {destinationUf} en el segmento",
  "ruleDrafts.checklist.hint": "sugerencia: {hint}; confirme la adhesión de las dos UF",
  "ruleDrafts.checklist.RICMS_DESTINATION":
    "RICMS/{destinationUf}: ítem del anexo de ST para el NCM {ncm}",
  "ruleDrafts.checklist.INTERNAL_RATE":
    "Alícuota interna de {destinationUf}: artículo del RICMS/{destinationUf}",
  "ruleDrafts.checklist.INTERNAL_RATE.fact":
    "Alícuota interna de {destinationUf}: del hecho VERIFICADO; adjunte el acto que cita",
  "ruleDrafts.checklist.INTERSTATE_RATE":
    "Res. Senado 22/89: {rate} de {originUf} a {destinationUf}; 4% para importados (Res. Senado 13/2012)",
  "ruleDrafts.checklist.IPI_EXEMPTION_ACT":
    "Acto que concede la exención de IPI al NCM {ncm} (nota TIPI, ley o decreto)",
  "ruleDrafts.checklist.optional": "informativo",
  "ruleDrafts.flag.INTERNAL_RATE_MISSING": "Interna en blanco: ningún hecho VERIFICADO",
  "ruleDrafts.flag.FACT_INTERSTATE_DIFFERS": "El hecho declara otra interestatal",
  "ruleDrafts.flag.IMPORTED_GOODS_CHECK": "Confirme el origen de la mercancía (4% si es importada)",
  "ruleDrafts.flag.INTERNAL_OPERATION": "Operación interna: informe la alícuota",
  "ruleDrafts.flag.IPI_FROM_TIPI": "IPI silencioso: viene de la TIPI",
  "ruleDrafts.flag.IPI_COPIED_FROM_TIPI": "IPI copiado de la TIPI (política heredada)",
  "ruleDrafts.flag.IPI_NOT_STATED": "Ninguna TIPI declara IPI",
  "ruleDrafts.flag.NO_ST_EXPRESSION":
    "Sin ST: ST con stApplicable=false (decisión abierta ADR 0013)",
  "ruleDrafts.flag.SUPERSEDES_ROUTE_RULE": "Sustituye la regla de ruta de la misma clave",
  "ruleDrafts.flag.MERGED_FACTS": "Varios hechos en la misma clave",
  "ruleDrafts.missing": "Pendiente: {fields}",
  "ruleDrafts.missing.evidence": "evidencia",
  "ruleDrafts.missing.originalMva": "MVA original",
  "ruleDrafts.missing.destinationInternalRate": "alícuota interna",
  "ruleDrafts.missing.interstateRate": "alícuota interestatal",
  "ruleDrafts.facts": "{count} hecho(s) · {findings} hallazgo(s) IOB",
  "ruleDrafts.submit.title": "Adjuntar evidencia y enviar",
  "ruleDrafts.submit.groupTitle": "Adjuntar evidencia al grupo {group}",
  "ruleDrafts.submit.body":
    "La evidencia debe estar aprobada en Documentos; el hallazgo del IOB no es evidencia. Cada borrador pasa a una propuesta Pendiente de revisión.",
  "ruleDrafts.submit.evidence": "Evidencias seleccionadas",
  "ruleDrafts.submit.noEvidence": "Ninguna evidencia seleccionada.",
  "ruleDrafts.submit.remove": "Quitar",
  "ruleDrafts.submit.internal": "Alícuota interna (fracción, p. ej. 0.20)",
  "ruleDrafts.submit.interstate": "Alícuota interestatal (fracción)",
  "ruleDrafts.submit.mva": "MVA original (fracción)",
  "ruleDrafts.submit.action": "Enviar a revisión",
  "ruleDrafts.submit.done": "{count} propuesta(s) creada(s), pendiente(s) de revisión.",
  "ruleDrafts.submit.failed": "{count} no enviado(s): {detail}",
  "ruleDrafts.submit.blocked": "Adjunte al menos una evidencia aprobada.",
  "ruleDrafts.submit.rateInvalid": "Use una fracción decimal, por ejemplo 0.18.",
  "ruleDrafts.submit.effective.title": "Carga efectiva de la MVA (opcional)",
  "ruleDrafts.submit.effective.hint":
    "Vale solo bajo tax-family-v2 y solo ajusta la MVA; el débito de la ST sigue en la alícuota interna nominal. Indique la base legal, por ejemplo RICMS/SP, Anexo II, art. 39 (12% para alimentos).",
  "ruleDrafts.submit.effective.rate": "Alícuota interna efectiva (fracción, ej.: 0.12)",
  "ruleDrafts.submit.effective.legal": "Base legal",
  "ruleDrafts.submit.effective.validFrom": "Vigente desde (opcional)",
  "ruleDrafts.submit.effective.validTo": "Vigente hasta (opcional)",
  "ruleDrafts.submit.effective.invalid":
    "Indique la alícuota como fracción junto con la base legal; el fin de vigencia no puede ser anterior al inicio.",
  "ruleDrafts.discard.action": "Descartar",
  "ruleDrafts.discard.title": "Descartar borrador",
  "ruleDrafts.discard.reason": "Motivo (mín. 10 caracteres)",
  "ruleDrafts.openProposal": "Abrir propuesta",
  "ruleDrafts.propose.action": "Proponer reglas ({count})",
  "ruleDrafts.propose.title": "Proponer reglas a partir de los hechos certificados",
  "ruleDrafts.propose.body":
    "Crea un borrador de propuesta por NCM × CEST × ruta para las {count} divergencias, en el borrador {version} ({policy}). ST y MVA original vienen del hecho; la interestatal sigue la Res. Senado 22/89; la interna solo viene de un hecho VERIFICADO, si no queda en blanco y señalada.",
  "ruleDrafts.propose.evidence":
    "Los hallazgos del IOB no son evidencia. Cada borrador trae la lista de actos oficiales a adjuntar (Conv. ICMS 142/18, convenio o protocolo del segmento, RICMS de la UF de destino) y no se puede enviar sin evidencia aprobada.",
  "ruleDrafts.propose.idempotent":
    "Volver a ejecutar no duplica: cada hecho se redacta una vez por versión. Hasta 200 hechos por ejecución.",
  "ruleDrafts.propose.noDraft":
    "No hay borrador de versión. Prepare el próximo borrador en Publicaciones antes de proponer.",
  "ruleDrafts.propose.goPublications": "Ir a Publicaciones",
  "ruleDrafts.propose.confirm": "Crear borradores",
  "ruleDrafts.propose.result":
    "{created} borradores creados · {existing} hechos ya redactados · {skipped} omitidos.",
  "ruleDrafts.propose.open": "Abrir borradores en {version}",
  "ruleDrafts.adoption.selectHint": "Seleccione al menos una regla.",
  "evidenceViewer.title": "Evidencia",
  "evidenceViewer.untitled": "Documento sin título",
  "evidenceViewer.captured": "capturado el {time}",
  "evidenceViewer.official": "Fuente oficial · {source}",
  "evidenceViewer.notOfficial": "Fuera de la lista de fuentes",
  "evidenceViewer.historical": "Captura histórica",
  "evidenceViewer.openDocument": "Abrir documento",
  "evidenceViewer.openEvidence": "Ver documento preservado",
  "evidenceViewer.locator": "Localizador",
  "evidenceViewer.locatorRange": "caracteres {start}–{end} del texto preservado",
  "evidenceViewer.noLocator": "Sin localizador",
  "evidenceViewer.noLocatorHint":
    "La cita no está anclada en el documento: verifique la línea en el documento original antes de decidir.",
  "evidenceViewer.noQuote": "Sin cita literal para este hecho.",
  "evidenceViewer.expand": "Ampliar contexto",
  "evidenceViewer.notFound":
    "La cita no aparece en el texto preservado en esta posición. Trátelo como discrepancia.",
  "evidenceViewer.unavailable.forbidden":
    "El texto preservado requiere permiso de lectura de documentos; la cita es la registrada en la extracción.",
  "evidenceViewer.unavailable.missing":
    "Documento preservado no disponible; la cita es la registrada en la extracción.",
  "evidenceViewer.unavailable.error": "No fue posible leer el documento preservado ahora.",
  "evidenceViewer.folded": "Encontrada con espacios normalizados (saltos de línea del documento).",
  "evidenceViewer.hashDiffers":
    "El texto leído tiene otro hash que el de la extracción: hay una versión más reciente.",
  "evidenceViewer.checks": "Controles del extractor: {checks}",
  "evidenceViewer.linkedFields": "Campos vinculados a la cita",
  "evidenceViewer.inQuote": "en la cita",
  "evidenceViewer.notInQuote": "no encontrado en la cita",
  "factReview.view.label": "Agrupar",
  "factReview.view.document": "Documento / anexo",
  "factReview.view.segment": "Segmento × UF",
  "factReview.view.facts": "Hechos individuales",
  "factReview.key.inferred": "vigencia inferida (sin inicio declarado)",
  "factReview.key.segment": "Segmento {segment}",
  "factReview.key.segmentNamed": "Seg. {segment} · {name}",
  "factReview.key.segmentUf": "{segment} → {uf}",
  "factReview.filter.search": "Buscar",
  "factReview.filter.searchPlaceholder": "Ej.: Anexo 1, 17.031.00, sefaz.ba",
  "factReview.filter.uf": "UF destino",
  "factReview.filter.segment": "Segmento",
  "factReview.filter.all": "Todos",
  "factReview.filter.scope": "Alcance de origen",
  "factReview.filter.scope.ALL_ORIGINS": "Todos los orígenes",
  "factReview.filter.scope.ORIGINS": "Orígenes listados",
  "factReview.filter.scope.INTERNAL_ONLY": "Solo internas",
  "factReview.filter.validity": "Vigencia",
  "factReview.filter.validity.STATED": "Inicio declarado",
  "factReview.filter.validity.INFERRED": "Inicio inferido",
  "factReview.filter.exceptions": "Excepciones y señales",
  "factReview.filter.exceptions.WITH": "Con excepciones o señales",
  "factReview.filter.exceptions.WITHOUT": "Sin excepciones ni señales",
  "factReview.filter.desk.all": "Todos los hechos",
  "factReview.filter.desk.sample": "Muestra",
  "factReview.filter.desk.pending": "Por inspeccionar",
  "factReview.filter.desk.exceptions": "Excepciones",
  "factReview.filter.desk.flagged": "Con señales",
  "factReview.sort.label": "Ordenar por",
  "factReview.sort.IMPACT": "Impacto (ocurrencias, luego alcance) ↓",
  "factReview.sort.AGE": "Más antiguos primero",
  "factReview.sort.SIZE": "Más hechos primero",
  "factReview.empty.title": "Ningún hecho sin verificar para agrupar",
  "factReview.empty.body":
    "Cuando la investigación web extraiga filas de anexos, los hechos aparecen aquí agrupados por documento.",
  "factReview.empty.filtered": "Ningún grupo con estos filtros",
  "factReview.summary": "{groups} · {facts}",
  "factReview.groups.one": "{count} grupo",
  "factReview.groups.other": "{count} grupos",
  "factReview.pendingFacts.one": "{count} hecho pendiente",
  "factReview.pendingFacts.other": "{count} hechos pendientes",
  "factReview.documents.one": "{count} documento",
  "factReview.documents.other": "{count} documentos",
  "factReview.flagged.one": "{count} con señal",
  "factReview.flagged.other": "{count} con señales",
  "factReview.factsCount.one": "{count} hecho",
  "factReview.factsCount.other": "{count} hechos",
  "factReview.resume": "Retomar revisión",
  "factReview.caption": "Grupos de hechos sin verificar",
  "factReview.col.group": "Documento / grupo",
  "factReview.col.facts": "Hechos",
  "factReview.col.reviewed": "Revisados",
  "factReview.col.exceptions": "Excepciones",
  "factReview.col.impact": "Impacto · alcance",
  "factReview.col.action": "Acción",
  "factReview.reach": "{ncms} NCM × {routes} orígenes",
  "factReview.reach.oneOrigin": "{ncms} NCM × 1 origen",
  "factReview.reach.none": "Sin NCM en el catálogo",
  "factReview.reach.hint": "sin brechas abiertas",
  "factReview.reach.title":
    "Ningún cálculo pidió estos hechos todavía (0 brechas abiertas). Alcance: NCM activos del catálogo que cubre el grupo × UF de origen a las que se aplica.",
  "factReview.impact.gaps.one": "{count} brecha abierta",
  "factReview.impact.gaps.other": "{count} brechas abiertas",
  "factReview.signals.title": "Señales del grupo",
  "factReview.signals.hint":
    "Todos los hechos las comparten: las reconoce una vez al confirmar, no hecho por hecho.",
  "factReview.signal.INFERRED_VALIDITY": "Vigencia inferida en todo el documento",
  "factReview.signal.ORIGIN_SCOPE": "Mismo ámbito de origen: {scope}",
  "factReview.signal.ack.INFERRED_VALIDITY":
    "Vigencia inferida: el documento no declara inicio; se usa la fecha de captura/publicación como inicio — confirmo.",
  "factReview.signal.ack.ORIGIN_SCOPE":
    "Ámbito de origen: la decisión vale para {scope} en todo el grupo — confirmo.",
  "factReview.decision.signals": "Propiedades del grupo (reconózcalas una vez)",
  "factReview.blocker.SIGNALS": "Reconoce las propiedades del grupo arriba.",
  "factReview.bar.complete": "Muestra completa, sin discrepancias",
  "factReview.bar.confirmGroup": "Confirmar grupo · {count} hechos",
  "factReview.state.IN_REVIEW": "En revisión",
  "factReview.state.REVIEW_REQUIRED": "Revisión necesaria",
  "factReview.age": "extraído {time}",
  "factReview.ofTotal": "de {total}",
  "factReview.conflicting": "{count} en conflicto",
  "factReview.review": "Revisar",
  "factReview.continue": "Continuar",
  "factReview.footnote":
    "Los conteos cubren todos los hechos pendientes del filtro, no solo esta página. Seleccionar esta página no selecciona todos los resultados.",
  "factReview.back": "Grupos",
  "factReview.backToFacts": "Hechos",
  "factReview.facts": "Hechos del grupo",
  "factReview.method.label": "Método de revisión",
  "factReview.method.FULL": "Revisión integral",
  "factReview.method.SAMPLE": "Muestreo",
  "factReview.method.sampleDocumentOnly": "El muestreo solo aplica a un grupo de documento/anexo.",
  "factReview.shortcuts.open": "Atajos",
  "factReview.shortcuts.title": "Atajos de la mesa de revisión",
  "factReview.shortcuts.walk": "Hecho siguiente / anterior",
  "factReview.shortcuts.agree": "Concuerda con la evidencia y sigue",
  "factReview.shortcuts.evidence": "Llevar el foco a la evidencia",
  "factReview.shortcuts.exception": "Marcar excepción o discrepancia",
  "factReview.shortcuts.decision": "Abrir la revisión de la decisión (no confirma)",
  "factReview.shortcuts.escape": "Cerrar la superficie superior o volver a los grupos",
  "factReview.shortcuts.help": "Mostrar esta lista",
  "factReview.shortcuts.scope":
    "Los atajos solo valen en esta mesa y nunca dentro de campos de texto.",
  "factReview.shortcuts.toggle": "Atajos de teclado activados",
  "factReview.nav.label": "Resumen del grupo",
  "factReview.nav.facts": "Hechos",
  "factReview.nav.inspected": "Revisados",
  "factReview.nav.exceptions": "Excepciones",
  "factReview.nav.progress": "{done} de {total} por inspeccionar",
  "factReview.nav.show": "Mostrar",
  "factReview.sample.title": "Muestra del revisor",
  "factReview.sample.size": "{size} de {population} hechos",
  "factReview.sample.mandatory": "Obligatorios (con señal)",
  "factReview.sample.representatives": "Representantes",
  "factReview.sample.random": "Aleatorios reproducibles",
  "factReview.sample.policy": "Política {policy} · semilla",
  "factReview.sample.expansions.one": "ampliada {count} vez",
  "factReview.sample.expansions.other": "ampliada {count} veces",
  "factReview.sample.expand": "Ampliar muestra",
  "factReview.sample.full": "Pasar a revisión integral",
  "factReview.sample.startFirst": "Inspeccione un hecho para iniciar la sesión.",
  "factReview.sample.how": "Cómo se elige la muestra",
  "factReview.sample.rule.mandatory":
    "Entran siempre los hechos con señal propia: control fallido o escalado, sin localizador, discrepancia, documento modificado o divergencia del IOB. Lo que comparte todo el grupo (vigencia inferida, mismo ámbito de origen) se reconoce una vez al confirmar.",
  "factReview.sample.rule.representatives":
    "Un representante fijo por combinación de campos y alcance de origen y por capítulo NCM, para cubrir las variantes de CEST/NCM.",
  "factReview.sample.rule.random":
    "El resto sale de un sorteo con semilla fija del grupo y del manifiesto: 15 % del grupo (10 a 60 hechos); los grupos de hasta 10 hechos se revisan enteros.",
  "factReview.sample.rule.discrepancy":
    "Una discrepancia lleva el grupo a «Revisión necesaria» y amplía la muestra; con dos, solo la revisión integral confirma.",
  "factReview.sample.rule.exceptions":
    "Las excepciones quedan fuera de la decisión y se deciden una a una en la cola de hechos.",
  "factReview.sample.notCertification":
    "El muestreo es una política del revisor, no una certificación automática: los hechos incluidos pasan a Verificado con el registro «incluido por muestreo».",
  "factReview.sample.required":
    "Revisión necesaria: {count} discrepancia(s). La muestra se amplió y los hechos con discrepancia se decidirán individualmente.",
  "factReview.sample.closed":
    "Muestreo cerrado en este grupo: hay demasiadas discrepancias. Pase a revisión integral para confirmar.",
  "factReview.iob.title": "Corroboración IOB",
  "factReview.iob.match": "Coincide con el IOB",
  "factReview.iob.mismatch": "Difiere del IOB",
  "factReview.iob.none": "Sin resultado IOB",
  "factReview.iob.never":
    "El IOB nunca confirma un hecho: el resultado certificado aparece junto a la muestra para que decida el revisor.",
  "factReview.iob.request": "Pedir corroboración IOB",
  "factReview.iob.reason.NO_NCM": "Ningún NCM del catálogo para consultar en esta muestra.",
  "factReview.iob.reason.INTERNAL_ONLY":
    "Las operaciones internas no tienen ruta interestatal para el IOB.",
  "factReview.iob.reason.NOT_ST": "El IOB solo consulta ST por NCM × ruta.",
  "factReview.iob.state.MATCH": "IOB certificado coincide",
  "factReview.iob.state.MISMATCH": "IOB certificado difiere",
  "factReview.iob.dialog": "Pedir corroboración al agente IOB",
  "factReview.iob.body":
    "Encola consultas LIST de {ncms} NCM(s) de la muestra en las rutas {routes}, al final de la cola del agente. Se reutilizan resultados recientes.",
  "factReview.iob.enqueue": "Encolar {count} tarea(s)",
  "factReview.iob.done": "{count} tarea(s) encolada(s). Siga en Agente IOB → Cola.",
  "factReview.iob.partial": "{count} tarea(s) encolada(s); otras fallaron. Intente de nuevo.",
  "factReview.iob.taskName": "Corroboración · seg. {segment} · {route}",
  "factReview.session.started": "Sesión de {who} desde {time}",
  "factReview.session.abandon": "Abandonar sesión",
  "factReview.list.empty": "Ningún hecho en este filtro.",
  "factReview.list.count": "{shown} de {total} hechos",
  "factReview.mark.AGREES": "Concuerda",
  "factReview.mark.DISCREPANCY": "Discrepancia",
  "factReview.mark.EXCEPTION": "Excepción",
  "factReview.mark.PENDING": "Por inspeccionar",
  "factReview.mark.sampled": "en la muestra",
  "factReview.flag.CHECKS_FAILED": "Control fallido o escalado en el extractor",
  "factReview.flag.INFERRED_VALIDITY": "Vigencia inferida (sin inicio declarado)",
  "factReview.flag.MISSING_LOCATOR": "Sin localizador en el documento",
  "factReview.flag.DISCREPANCY": "Conflicto o revalidación pendiente",
  "factReview.flag.DOCUMENT_CHANGED": "Hay una versión más reciente del documento",
  "factReview.flag.IOB_MISMATCH": "El IOB certificado difiere de este valor",
  "factReview.field.validFrom": "Inicio de vigencia",
  "factReview.field.origin": "Origen del dato",
  "factReview.undo": "Deshacer marca",
  "factReview.pane.label": "Mostrar",
  "factReview.pane.fact": "Hecho",
  "factReview.pane.evidence": "Evidencia",
  "factReview.bar.label": "Decisión",
  "factReview.bar.progress": "{done} de {total} revisados",
  "factReview.bar.progressSample": "{done} de {total} de la muestra",
  "factReview.bar.exception": "Marcar excepción",
  "factReview.bar.skip": "Saltar",
  "factReview.bar.agree": "Concuerda · siguiente",
  "factReview.bar.review": "Revisar decisión",
  "factReview.bar.reviewReady": "Revisar decisión · {count}",
  "factReview.bar.startFirst": "Inspeccione un hecho para iniciar la sesión.",
  "factReview.bar.readOnly": "Lectura: confirmar requiere el permiso de revisión de reglas.",
  "factReview.error.changed": "El grupo cambió desde que se abrió. Recargue para continuar.",
  "factReview.error.generic": "No fue posible registrar esta acción. Recargue e intente de nuevo.",
  "factReview.stale":
    "Desde el inicio de la sesión: {changed} hecho(s) cambiaron, {added} entraron y {removed} salieron del grupo. Los que cambiaron se omitirán al confirmar.",
  "factReview.refresh": "Actualizar revisión del grupo",
  "factReview.truncated":
    "El grupo tiene más de 500 hechos pendientes: filtre por segmento o UF para revisar el resto.",
  "factReview.exception.title": "Excepción o discrepancia",
  "factReview.exception.kind": "Tipo de marca",
  "factReview.exception.DISCREPANCY.title": "Discrepancia con el documento",
  "factReview.exception.DISCREPANCY.hint":
    "El valor no coincide con la fila. El grupo pasa a «Revisión necesaria» y la muestra se amplía.",
  "factReview.exception.EXCEPTION.title": "Excepción (decidir individualmente)",
  "factReview.exception.EXCEPTION.hint":
    "Queda fuera de la decisión del grupo, sin afirmar que está mal.",
  "factReview.exception.presets": "Motivos frecuentes",
  "factReview.exception.preset.unreadable": "Fila ilegible en el documento",
  "factReview.exception.preset.otherSegment": "Ítem de otro segmento",
  "factReview.exception.preset.valueDiffers": "El valor difiere del documento",
  "factReview.exception.preset.validity": "Vigencia por confirmar",
  "factReview.exception.note": "Qué difiere (opcional)",
  "factReview.exception.noteHint": "Queda en el historial de la sesión y en el hecho.",
  "factReview.exception.reason": "Motivo",
  "factReview.exception.reasonHint": "Mínimo de {min} caracteres.",
  "factReview.exception.submit": "Marcar excepción",
  "factReview.exception.submitDiscrepancy": "Registrar discrepancia",
  "factReview.decision.title": "Confirmar grupo",
  "factReview.decision.inGroup": "Hechos en el manifiesto",
  "factReview.decision.inspected": "Inspeccionados directamente",
  "factReview.decision.sampled": "Incluidos por muestreo",
  "factReview.decision.excluded": "Excepciones excluidas",
  "factReview.decision.included": "Incluidos en esta decisión",
  "factReview.decision.list": "Ver la lista completa de los {count} hechos",
  "factReview.decision.stale":
    "{count} hecho(s) cambiaron desde el inicio de la sesión y se omitirán (resultado parcial).",
  "factReview.decision.blocked": "Aún no es posible confirmar",
  "factReview.decision.note": "Nota de la revisión",
  "factReview.decision.boundary":
    "Esta acción verifica hechos. No publica reglas ni cambia cálculos.",
  "factReview.decision.back": "Volver a la revisión",
  "factReview.decision.confirm": "Confirmar {count} hechos",
  "factReview.decision.problem.changed":
    "El alcance cambió (muestra, excepciones o manifiesto). Recargue el grupo y revise lo que cambió.",
  "factReview.decision.problem.incomplete":
    "Faltan inspecciones exigidas por la política. Recargue el grupo.",
  "factReview.decision.problem.error": "No fue posible confirmar ahora. No se cambió nada.",
  "factReview.blocker.SESSION_NOT_OPEN": "La sesión no está abierta.",
  "factReview.blocker.NOTHING_TO_CONFIRM": "Ningún hecho incluido: todos son excepciones.",
  "factReview.blocker.SAMPLE_NOT_ALLOWED": "Los grupos segmento × UF no admiten muestreo.",
  "factReview.blocker.TOO_MANY_DISCREPANCIES":
    "Demasiadas discrepancias para muestreo: revise integralmente.",
  "factReview.blocker.UNINSPECTED": "{count} hecho(s) aún por inspeccionar.",
  "factReview.inclusion.INSPECTED": "inspeccionado directamente",
  "factReview.inclusion.SAMPLED": "incluido por muestreo",
  "factReview.history.GROUP_REVIEW_INSPECTED": "Revisión por grupo · inspeccionado directamente",
  "factReview.history.GROUP_REVIEW_SAMPLED": "Revisión por grupo · incluido por muestreo",
  "factReview.result.title": "Grupo confirmado",
  "factReview.result.summary": "{applied} pasaron a Verificado. No se publicó ninguna regla.",
  "factReview.result.inspected": "Inspeccionados directamente",
  "factReview.result.sampled": "Incluidos por muestreo",
  "factReview.result.excluded": "Excepciones (pendientes)",
  "factReview.result.skipped": "Omitidos",
  "factReview.result.exceptionsNext":
    "Las excepciones siguen sin verificar: decide cada una en la lista de hechos individuales.",
  "factReview.result.when": "Confirmado el {time}",
  "factReview.scopeChoice.reason.AGREEMENT_SIGNATORIES":
    "La matriz CONFAZ ({agreements}) deriva los orígenes: el anexo de {uf} cubre las operaciones internas y la retención interestatal vale solo para las UF firmantes en la fecha de la operación.",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.label":
    "Confirmar internas + orígenes firmantes ({count} UF)",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.hint":
    "Derivados de {agreements} el {date}. Adhesiones, denuncias y exclusiones rigen en sus fechas; los orígenes fuera del acuerdo no retienen ST hacia {uf} (el destino puede cobrar anticipación).",
  "factReview.scopeChoice.agreementShort":
    "operaciones internas de {uf} + {count} orígenes firmantes",
  "factReview.scopeChoice.proposedAgreement": "propuesto: internas + {count} orígenes firmantes",
  "factReview.scopeChoice.agreementUnverified":
    "El acuerdo aún no está verificado: las rutas interestatales solo entran en SHADOW después de confirmarlo en Acuerdos CONFAZ.",
  "factReview.scopeChoice.partial":
    "{known} de {total} hechos tienen CEST cubierto por el acuerdo; los demás quedan solo con operaciones internas.",
  "factReview.scopeChoice.change.JOINS": "{uf} entra el {date} ({agreement})",
  "factReview.scopeChoice.change.LEAVES": "{uf} sale el {date} ({agreement})",
  "factReview.result.scopeAgreement":
    "Confirmado para las operaciones internas de {uf} y para los orígenes firmantes del acuerdo CONFAZ en cada fecha.",
  "verification.scope.verifiedAgreement": "verificado: internas de {uf} + firmantes ({agreements})",
  "verification.tab.agreements": "Acuerdos CONFAZ",
  "stAgreements.hint":
    "Firmantes de los convenios y protocolos de ST por segmento. De ellos salen los orígenes interestatales de los hechos de anexo.",
  "stAgreements.counts":
    "{unverified} por verificar · {verified} verificados · {total} en el catálogo",
  "stAgreements.membersToday": "{count} firmantes hoy",
  "stAgreements.checksFailed": "{count} verificación(es) a revisar",
  "stAgreements.status.UNVERIFIED": "No verificado",
  "stAgreements.status.VERIFIED": "Verificado",
  "stAgreements.status.REJECTED": "Rechazado",
  "stAgreements.status.SUPERSEDED": "Sustituido",
  "stAgreements.status.MISSING": "No leído",
  "stAgreements.missing.title": "Acuerdo aún no leído",
  "stAgreements.missing.body":
    "Ejecute una investigación de Acuerdos CONFAZ en Administración → Investigación web → Nueva investigación para leer la página oficial.",
  "stAgreements.action.CONFIRM": "Confirmar acuerdo",
  "stAgreements.action.REJECT": "Rechazar",
  "stAgreements.meta.segments": "Segmentos (Conv. 142/18)",
  "stAgreements.meta.validity": "Vigencia",
  "stAgreements.meta.published": "Publicado en el DOU",
  "stAgreements.meta.document": "Documento",
  "stAgreements.validity.open": "desde {from}",
  "stAgreements.validity.range": "{from} a {to}",
  "stAgreements.checks.title": "Verificaciones del extractor a revisar:",
  "stAgreements.members.title": "Firmantes el {date} ({count})",
  "stAgreements.members.none": "Ninguna UF vinculada en esta fecha.",
  "stAgreements.excluded": "CEST exceptuados: {cests}",
  "stAgreements.matrix.title": "Matriz de adhesión",
  "stAgreements.matrix.uf": "UF",
  "stAgreements.matrix.from": "Desde",
  "stAgreements.matrix.to": "Hasta",
  "stAgreements.matrix.how": "Entrada → salida",
  "stAgreements.matrix.act": "Acto",
  "stAgreements.matrix.quote": "Fragmento",
  "stAgreements.matrix.open": "vigente",
  "stAgreements.joined.ORIGINAL": "Firmante original",
  "stAgreements.joined.ADHESION": "Adhesión",
  "stAgreements.joined.PLENARY": "Convenio (todas las UF)",
  "stAgreements.joined.OBSERVED": "Cláusula vigente",
  "stAgreements.left.DENUNCIA": "Denuncia",
  "stAgreements.left.EXCLUSAO": "Exclusión",
  "stAgreements.left.REVOGACAO": "Revocación",
  "stAgreements.history": "Historial",
  "stAgreements.event.DERIVED": "Leído de la página oficial",
  "stAgreements.event.RECHECKED": "Releído (misma versión)",
  "stAgreements.event.CONFIRMED": "Confirmado",
  "stAgreements.event.REJECTED": "Rechazado",
  "stAgreements.event.SUPERSEDED": "Sustituido por una versión más nueva",
  "stAgreements.boundary":
    "Confirmar un acuerdo no publica una regla: pasa a derivar los orígenes interestatales de los hechos de segmento en cada fecha.",
  "stAgreements.dialog.CONFIRM.title": "Confirmar {agreement}",
  "stAgreements.dialog.CONFIRM.body":
    "Compare firmantes, adhesiones, denuncias, exclusiones y vigencia con la página oficial preservada. La versión verificada anterior de este acuerdo pasa a Sustituida.",
  "stAgreements.dialog.REJECT.title": "Rechazar {agreement}",
  "stAgreements.dialog.REJECT.body":
    "El acuerdo sale de la matriz; los hechos de segmento vuelven a valer solo para operaciones internas mientras no haya otra versión verificada.",
  "stAgreements.retire.open": "Retirar lecturas divergentes ({count})",
  "stAgreements.retire.title": "Retirar lecturas con identidad divergente",
  "stAgreements.retire.body":
    "Estas observaciones no verificadas se guardaron con un número que la propia página no trae (una línea de listado leída como encabezado). Se rechazarán con el motivo de abajo y el registro queda en la auditoría. Los acuerdos verificados y sembrados no cambian.",
  "stAgreements.retire.none": "Ninguna lectura divergente.",
  "stAgreements.retire.readFor": "página leída para {agreement}",
  "stAgreements.retire.urlOnly": "sin encabezado, identificada solo por la dirección",
  "stAgreements.retire.submit": "Rechazar ({count})",
  "stAgreements.dialog.changed": "El acuerdo cambió desde que lo abrió: recargue.",
  "stAgreements.dialog.error": "No se pudo registrar ahora. No se cambió nada.",
  "webResearch.scope.CONFAZ_AGREEMENTS": "Acuerdos CONFAZ (firmantes)",
  "webResearch.scope.CONFAZ_AGREEMENTS.body":
    "Lee la página oficial de cada convenio/protocolo de ST del catálogo revisado (firmantes, adhesiones, denuncias, vigencia) para la matriz de orígenes.",
  "webResearch.scope.CONFAZ_AGREEMENTS.short": "Acuerdos CONFAZ",
  "webResearch.scope.CONFAZ_AGREEMENTS.segments": "Acuerdos CONFAZ · seg. {segments}",
  "webResearch.scope.CONFAZ_AGREEMENTS.route": "páginas oficiales",
  "webResearch.wizard.agreements.segments": "Segmentos",
  "webResearch.wizard.agreements.all": "Los {count} acuerdos del catálogo",
  "webResearch.wizard.agreements.some": "{count} acuerdo(s) de los segmentos marcados",
  "webResearch.wizard.agreements.segment": "Segmento {segment}",
  "webResearch.wizard.agreements.locate": "Buscar otros acuerdos y modificaciones",
  "webResearch.wizard.agreements.locateHint":
    "Una búsqueda CONFAZ por segmento (llamada con búsqueda): las páginas de convenio/protocolo encontradas también se leen como acuerdos.",
  "webResearch.wizard.agreements.noRoutes":
    "Los acuerdos CONFAZ no usan rutas: cada página oficial se descarga y se lee una vez.",
  "verification.scope.verifiedInternal": "verificado solo para operaciones internas ({uf}→{uf})",
  "factReview.scopeChoice.title": "Ámbito de origen de la decisión",
  "factReview.scopeChoice.reason.AGREEMENTS_UNKNOWN":
    "Los firmantes del convenio o protocolo CONFAZ de este segmento aún no están verificados. El anexo de {uf} cubre las operaciones internas; la retención interestatal solo existe cuando la UF de origen firmó el acuerdo.",
  "factReview.scopeChoice.default": "sugerido",
  "factReview.scopeChoice.INTERNAL_ONLY.label": "Confirmar solo operaciones internas ({uf}→{uf})",
  "factReview.scopeChoice.INTERNAL_ONLY.hint":
    "Las rutas interestatales hacia {uf} siguen sin verificar, a la espera del IOB y de la matriz de firmantes CONFAZ.",
  "factReview.scopeChoice.AS_EXTRACTED.label": "Confirmar como se extrajo: {scope}",
  "factReview.scopeChoice.AS_EXTRACTED.hint": "Vale para los orígenes que lista el anexo.",
  "factReview.scopeChoice.AS_EXTRACTED.hintAll":
    "Úselo solo si el documento prueba retención desde todas las UF: sin acuerdo CONFAZ la UF de origen no retiene el ICMS-ST hacia {uf}.",
  "factReview.scopeChoice.allUfs": "{count} UF de origen",
  "factReview.scopeChoice.origins": "UF de origen cubiertas",
  "factReview.scopeChoice.internalShort": "operaciones internas ({uf}→{uf})",
  "factReview.scopeChoice.proposedInternal": "propuesto: solo internas ({uf}→{uf})",
  "factReview.result.scopeInternal":
    "Confirmado solo para operaciones internas ({uf}→{uf}); las rutas interestatales siguen sin verificar.",
  "factReview.result.groups": "Volver a los grupos",
  "factReview.result.next": "Siguiente grupo",
  "factReview.skip.STALE_REVISION": "cambió desde el inicio de la sesión",
  "factReview.skip.NOT_UNVERIFIED": "ya está {status}",
  "factReview.skip.NOT_FOUND": "no encontrado",
  "scopeFix.scope.INTERNAL_ONLY": "Solo operaciones internas ({uf}→{uf})",
  "scopeFix.scope.AGREEMENT_ORIGINS": "Internas de {uf} + {count} orígenes signatarios",
  "scopeFix.scope.ORIGINS": "Orígenes restringidos: {ufs}",
  "scopeFix.scope.ALL": "Todos los orígenes ({count} UF)",
  "scopeFix.scope.LISTED": "Orígenes listados en el documento ({count} UF): {ufs}",
  "scopeFix.summary.chosen": "Alcance que se confirmará",
  "scopeFix.summary.confirmed": "Alcance confirmado",
  "scopeFix.summary.internalOnly": "Ninguna ruta interestatal pasa a Verificado: solo {uf}→{uf}.",
  "scopeFix.summary.interstate": "{count} UF de origen interestatales pasan a Verificado.",
  "scopeFix.summary.wide":
    "Más amplio que lo propuesto: la ST interestatal depende de los signatarios CONFAZ del segmento.",
  "scopeFix.ack.title": "Todos los orígenes exigen confirmación explícita",
  "scopeFix.ack.why":
    "Lo propuesto es {proposed}. La ST interestatal depende de los signatarios CONFAZ del segmento: confirme todos los orígenes solo si el propio documento prueba la retención desde cada UF.",
  "scopeFix.ack.proven": "El documento prueba la retención de todas las UF",
  "scopeFix.ack.justification": "Justificación (dónde lo prueba el documento)",
  "scopeFix.ack.missing": "Faltan {count} caracteres",
  "scopeFix.ack.ok": "Queda registrada en la auditoría y en el resultado.",
  "scopeFix.ack.recorded": "Justificación de todos los orígenes:",
  "scopeFix.action.group": "Corregir alcance",
  "scopeFix.action.fact": "Restringir alcance de origen",
  "scopeFix.dialog.title": "Restringir alcance de origen",
  "scopeFix.dialog.current": "Cubre hoy",
  "scopeFix.dialog.to": "Restringir a",
  "scopeFix.dialog.internalHint":
    "Las rutas interestatales hacia {uf} vuelven a no verificadas (quedan para el IOB y la matriz CONFAZ).",
  "scopeFix.dialog.listLabel": "Solo estas UF de origen",
  "scopeFix.dialog.listHint":
    "Marque los orígenes que prueba el documento; los demás vuelven a no verificados.",
  "scopeFix.dialog.listProblem": "Mantenga al menos una UF y quite al menos una.",
  "scopeFix.dialog.reason": "Motivo de la corrección",
  "scopeFix.dialog.boundary":
    "Crea una nueva revisión de cada hecho y conserva todo el historial. El cálculo en sombra usa el nuevo alcance al instante. Ampliarlo de nuevo exige una nueva revisión del grupo o del hecho.",
  "scopeFix.dialog.submit": "Restringir alcance",
  "scopeFix.dialog.doneTitle": "Alcance corregido",
  "scopeFix.dialog.done": "{restricted} de {facts} hechos con el alcance restringido.",
  "scopeFix.dialog.doneHint":
    "Cada hecho recibió una nueva revisión con el evento “Alcance restringido”; la confirmación original sigue en el historial.",
  "scopeFix.dialog.correction": "Corrección",
  "scopeFix.dialog.replayed": "ya aplicada antes (repetición)",
  "scopeFix.dialog.problem.stale":
    "El hecho cambió desde que se abrió. Recargue e intente de nuevo.",
  "scopeFix.dialog.problem.notAllowed":
    "Nada que restringir para ese alcance (ya está dentro, o lo ampliaría).",
  "scopeFix.dialog.problem.error": "No se pudo corregir el alcance. Intente de nuevo.",
  "scopeFix.skip.NOT_VERIFIED": "ya no está verificado",
  "scopeFix.skip.NOT_FOUND": "no encontrado",
  "scopeFix.skip.NOT_ST_SEGMENT": "sin alcance de origen",
  "scopeFix.skip.ALREADY_WITHIN": "ya dentro de ese alcance",
  "scopeFix.skip.OUTSIDE_EXTRACTED": "el hecho no cita esos orígenes",
  "scopeFix.skip.WIDENS": "ampliaría el alcance (use una nueva revisión)",
  "scopeFix.history.hint":
    "Grupos ya confirmados, con el alcance que decidieron y lo que sus hechos cubren hoy. Corrija aquí un grupo confirmado con demasiados orígenes.",
  "scopeFix.history.empty": "Ningún grupo confirmado todavía",
  "scopeFix.history.emptyBody": "Los grupos aparecen aquí después de “Confirmar grupo”.",
  "scopeFix.history.confirmed": "{who} · {when} · {count} hechos",
  "scopeFix.history.decision": "Decisión:",
  "scopeFix.history.facts": "{count} hechos",
  "scopeFix.history.restricted": "corregido",
  "scopeFix.history.noneVerified": "Ningún hecho sigue verificado.",
  "scopeFix.history.wide":
    "Cubre orígenes interestatales sin acuerdo CONFAZ verificado: revise el alcance.",
  "scopeFix.history.correction": "{scope} · {who} · {when} · {count} hechos",
  "scopeFix.history.first": "Más recientes",
  "scopeFix.history.more": "Más antiguos",
  "scopeFix.decision.AS_EXTRACTED": "Como se extrajo",
  "scopeFix.decision.INTERNAL_ONLY": "Solo operaciones internas",
  "scopeFix.decision.AGREEMENT_ORIGINS": "Internas + orígenes signatarios",
  "scopeFix.event.restricted": "Alcance verificado ahora: {ufs}",
  "factReview.blocker.ALL_ORIGINS":
    "Confirme que el documento prueba la retención de todas las UF y justifique.",
  "verification.tab.confirmed": "Grupos confirmados",
  "verification.event.SCOPE_RESTRICTED": "Alcance restringido",
  "verification.scope.verifiedOrigins": "verificado solo para los orígenes: {ufs}",
  "audit.scope.title": "Alcance de origen",
  "audit.scope.decision": "Alcance decidido",
  "audit.scope.proposed": "Alcance propuesto",
  "audit.scope.restriction": "Restringido a",
  "audit.scope.previous": "Cubría antes",
  "audit.scope.origins": "UF de origen cubiertas",
  "audit.scope.acknowledged": "Todos los orígenes: justificación",
  "audit.scope.allUfs": "todas las {count} UF",
  "audit.action.fiscal-fact.confirm": "Hecho fiscal confirmado",
  "audit.action.fiscal-fact.scope-restricted": "Alcance de origen del hecho restringido",
  "audit.action.fiscal-fact-review.confirmed": "Grupo de hechos confirmado",
  "audit.action.fiscal-fact-review.scope-restricted": "Alcance del grupo confirmado corregido",
  "audit.resource.fiscal_fact_review_session": "Revisión de grupo",
  "verification.tab.nfe": "Notas fiscales",
  "ruleDrafts.origin.NFE_OBSERVATION": "Observación de NF-e",
  "ruleDrafts.flag.NFE_CORROBORATION_ONLY":
    "La NF-e solo corrobora: no es fuente legal; alícuotas en blanco hasta el acto oficial",
  "ruleDrafts.corroboration":
    "Corroboración NF-e: {invoices} notas, {items} ítems, CFOP {cfop} ({status}). No es fuente legal.",
  "nfe.boundary":
    "Las notas fiscales corroboran cómo proveedores reales tributaron operaciones reales. No son fuente legal: nada aquí certifica un hecho, cambia ni publica una regla. La comparación con la plataforma es solo lectura.",
  "nfe.privacy":
    "Privacidad: no se guardan el XML original, nombres, direcciones, correos ni teléfonos. Solo quedan los campos fiscales, la clave de acceso y el CNPJ del emisor.",
  "nfe.upload.title": "Enviar notas fiscales",
  "nfe.upload.hint":
    "XML autorizados de la NF-e (layout 4.00), uno a uno o dentro de un .zip con miles de notas. Los eventos de cancelación (procEventoNFe 110111) pueden ir en el mismo envío; las notas canceladas y las copias Omie XML_Invertido nunca llegan a las rutas.",
  "nfe.upload.drop": "Arrastre archivos .xml o .zip aquí",
  "nfe.upload.dropActive": "Suelte para añadir",
  "nfe.upload.limits":
    "XML hasta {xml} cada uno · un .zip de hasta {zip} va en un envío; uno mayor se descomprime en este navegador y se envía por partes · XML sueltos en envíos de hasta {files} archivos y {chunk}.",
  "nfe.upload.unpacking": "Leyendo {name}…",
  "nfe.upload.unpackFailed": "No se pudo leer {name} en el navegador: {reason}",
  "nfe.upload.pick": "Elegir archivos",
  "nfe.upload.addMore": "Añadir más",
  "nfe.upload.selected": "{count} archivos seleccionados",
  "nfe.upload.ready.one": "{count} archivo listo",
  "nfe.upload.ready.other": "{count} archivos listos",
  "nfe.upload.readyDetail": "· {xml} XML, {zip} ZIP · {size} · {requests} envíos",
  "nfe.upload.rejected.one": "{count} archivo no se enviará:",
  "nfe.upload.rejected.other": "{count} archivos no se enviarán:",
  "nfe.upload.reject.EXTENSION": "solo .xml o .zip",
  "nfe.upload.reject.EMPTY": "archivo vacío",
  "nfe.upload.reject.XML_TOO_LARGE": "XML de más de 3 MB",
  "nfe.upload.reject.ZIP_TOO_LARGE":
    "zip de más de 8 MB y este navegador no puede descomprimirlo: divídalo en archivos menores",
  "nfe.upload.more": "y {count} más",
  "nfe.upload.send.one": "Enviar {count} archivo",
  "nfe.upload.send.other": "Enviar {count} archivos",
  "nfe.upload.clear": "Limpiar selección",
  "nfe.upload.progress": "Envío {done} de {total}",
  "nfe.upload.progressFiles": "{done} de {total} archivos procesados",
  "nfe.upload.progressLabel": "Progreso del envío de notas fiscales",
  "nfe.upload.cancel": "Detener tras el envío actual",
  "nfe.upload.cancelled":
    "Envío interrumpido. Los envíos completados se importaron; los demás pueden reanudarse.",
  "nfe.upload.failedRequests.one": "{count} envío falló.",
  "nfe.upload.failedRequests.other": "{count} envíos fallaron.",
  "nfe.upload.retry.one": "Reanudar {count} envío",
  "nfe.upload.retry.other": "Reanudar {count} envíos",
  "nfe.upload.openBatch": "Abrir lote",
  "nfe.upload.again": "Nuevo envío",
  "nfe.upload.toast": "{imported} de {total} notas importadas",
  "nfe.outcome.IMPORTED": "Importada",
  "nfe.outcome.IMPORTED.plural": "Importadas",
  "nfe.outcome.DUPLICATE": "Duplicada",
  "nfe.outcome.DUPLICATE.plural": "Duplicadas",
  "nfe.outcome.INVALID": "Inválida",
  "nfe.outcome.INVALID.plural": "Inválidas",
  "nfe.outcome.SKIPPED": "Ignorada",
  "nfe.outcome.SKIPPED.plural": "Ignoradas",
  "nfe.outcome.CANCELLED": "Cancelada",
  "nfe.outcome.CANCELLED.plural": "Canceladas",
  "nfe.tally.items": "Ítems",
  "nfe.tally.paths": "Caminos afectados",
  "nfe.files.file": "Archivo",
  "nfe.files.inside": "en {container}",
  "nfe.files.outcome": "Resultado",
  "nfe.files.reason": "Motivo",
  "nfe.files.accessKey": "Clave de acceso",
  "nfe.files.items": "Ítems",
  "nfe.files.filter": "Filtrar por resultado",
  "nfe.files.all": "Todos",
  "nfe.files.none": "Ningún archivo con este resultado.",
  "nfe.files.caption": "Resultado por archivo",
  "nfe.files.showMore": "Mostrar más ({shown} de {total})",
  "nfe.reason.ALREADY_IMPORTED": "Clave ya importada antes",
  "nfe.reason.REPEATED_IN_UPLOAD": "Repetida en este envío",
  "nfe.reason.REPLACED_INVERTED_COPY":
    "El original reemplazó una copia invertida del ERP guardada antes",
  "nfe.reason.PROTOCOL_CANCELLED": "Cancelada: el protocolo lo indica (cStat 101/135/155)",
  "nfe.reason.CANCELLATION_EVENT":
    "Evento de cancelación (110111); la factura queda fuera de las rutas",
  "nfe.reason.NOT_NFE_DOCUMENT": "No es una NF-e (CT-e, MDF-e o inutilización)",
  "nfe.reason.EVENT_IGNORED": "Evento de NF-e distinto de la cancelación",
  "nfe.reason.INVERTED_ERP_COPY":
    "Copia invertida del ERP (Omie XML_Invertido), no la factura autorizada",
  "nfe.reason.NOT_XML": "No es XML (p. ej., DANFE en PDF)",
  "nfe.reason.DIRECTORY": "Carpeta dentro del zip",
  "nfe.reason.SYSTEM_FILE": "Archivo de sistema (p. ej., __MACOSX)",
  "nfe.reason.NESTED_ZIP": "Zip dentro de zip no se abre",
  "nfe.reason.FOREIGN_OPERATION": "Operación con el exterior (idDest 3)",
  "nfe.reason.FILE_TOO_LARGE": "Archivo demasiado grande",
  "nfe.reason.ZIP_INVALID": "Zip ilegible",
  "nfe.reason.ZIP_TOO_MANY_ENTRIES": "Zip con demasiadas entradas",
  "nfe.reason.ZIP_TOO_LARGE": "El zip se expande más allá del límite",
  "nfe.reason.ZIP_ENTRY_UNSAFE_PATH": "Ruta insegura dentro del zip",
  "nfe.reason.ZIP_ENTRY_ENCRYPTED": "Entrada protegida con contraseña",
  "nfe.reason.ZIP_ENTRY_UNSUPPORTED": "Compresión no admitida",
  "nfe.reason.ZIP_ENTRY_TOO_LARGE": "XML demasiado grande dentro del zip",
  "nfe.reason.ZIP_ENTRY_RATIO": "Tasa de compresión sospechosa",
  "nfe.reason.ZIP_ENTRY_CORRUPT": "Entrada dañada",
  "nfe.reason.TOO_MANY_DOCUMENTS": "Demasiados documentos en este envío",
  "nfe.reason.XML_MALFORMED": "XML mal formado",
  "nfe.reason.XML_DTD_FORBIDDEN": "No se acepta XML con DTD",
  "nfe.reason.NOT_NFE": "No es una NF-e",
  "nfe.reason.UNSUPPORTED_VERSION": "Layout distinto del 4.00",
  "nfe.reason.UNSUPPORTED_MODEL": "Modelo distinto de 55",
  "nfe.reason.INVALID_ACCESS_KEY": "Clave de acceso inválida (dígito verificador)",
  "nfe.reason.ACCESS_KEY_MISMATCH": "La clave no coincide con los datos de la nota",
  "nfe.reason.NOT_AUTHORIZED": "Sin protocolo de autorización",
  "nfe.reason.HOMOLOGATION": "Nota de homologación (prueba)",
  "nfe.reason.MISSING_FIELD": "Falta un campo obligatorio",
  "nfe.reason.INVALID_FIELD": "Campo con valor inválido",
  "nfe.reason.TOO_MANY_ITEMS": "Más de 990 ítems",
  "nfe.batches.title": "Lotes importados",
  "nfe.batches.empty":
    "Aún no hay lotes. Los envíos aparecen aquí con el resultado de cada archivo.",
  "nfe.batch.status.COMPLETED": "Completado",
  "nfe.batch.status.COMPLETED_WITH_ERRORS": "Con inválidas",
  "nfe.batch.files.one": "{count} archivo",
  "nfe.batch.files.other": "{count} archivos",
  "nfe.batch.entries.one": "{count} documento",
  "nfe.batch.entries.other": "{count} documentos",
  "nfe.batch.byYou": "por usted",
  "nfe.batch.by": "por operador {id}",
  "nfe.batch.result": "{items} ítems · {paths} caminos",
  "nfe.batch.title": "Lote del {when}",
  "nfe.paths.title": "Caminos fiscales observados",
  "nfe.paths.hint":
    "Ítems con la misma ruta, NCM, CFOP, operación y tratamiento forman un camino, comparado con la regla publicada, los hechos CERTIFICADOS/VERIFICADOS y el IOB.",
  "nfe.paths.count.one": "{count} camino",
  "nfe.paths.count.other": "{count} caminos",
  "nfe.paths.truncated":
    "Hay más caminos de los que una comparación lee de una vez. Filtre por UF o NCM para verlos todos.",
  "nfe.paths.empty.title": "Aún no hay notas fiscales importadas",
  "nfe.paths.empty.body":
    "Envíe XML o un .zip de NF-e arriba. Cada ítem se vuelve evidencia de corroboración, nunca una regla.",
  "nfe.paths.empty.readOnly": "Cuando se importen notas, los caminos observados aparecerán aquí.",
  "nfe.column.route": "Ruta",
  "nfe.column.operation": "Operación",
  "nfe.column.treatment": "Tratamiento",
  "nfe.column.invoices": "Notas",
  "nfe.column.items": "Ítems",
  "nfe.column.emitters": "Emisores",
  "nfe.column.period": "Período",
  "nfe.column.status": "Comparación",
  "nfe.column.inconsistent.one": "{count} ítem con valores inconsistentes",
  "nfe.column.inconsistent.other": "{count} ítems con valores inconsistentes",
  "nfe.status.MATCHES": "Coincide",
  "nfe.status.DIVERGES": "Diverge",
  "nfe.status.NOT_COVERED": "Sin cobertura",
  "nfe.scope.INTERNAL": "Interna",
  "nfe.scope.INTERSTATE": "Interestatal",
  "nfe.recipient.CONTRIBUTOR": "Contribuyente",
  "nfe.recipient.EXEMPT_CONTRIBUTOR": "Contribuyente exento",
  "nfe.recipient.NON_CONTRIBUTOR": "No contribuyente",
  "nfe.operation.finalConsumer": "consumidor final",
  "nfe.operation.entry": "entrada",
  "nfe.operation.fin.1": "normal",
  "nfe.operation.fin.2": "complementaria",
  "nfe.operation.fin.3": "ajuste",
  "nfe.operation.fin.4": "devolución",
  "nfe.filter.origin": "UF de origen",
  "nfe.filter.destination": "UF de destino",
  "nfe.filter.anyUf": "Todas",
  "nfe.filter.ncm": "NCM (prefijo)",
  "nfe.filter.ncmPlaceholder": "Ej.: 2202",
  "nfe.filter.ncmHint": "Use de 2 a 8 dígitos.",
  "nfe.filter.status": "Comparación",
  "nfe.treatment.title": "Tratamiento observado",
  "nfe.treatment.reduced": "base reducida {rate}",
  "nfe.treatment.st": "ST",
  "nfe.treatment.retained": "ST retenida anteriormente",
  "nfe.treatment.difal": "DIFAL",
  "nfe.treatment.group": "Grupo",
  "nfe.treatment.orig": "Origen",
  "nfe.treatment.stTitle": "ICMS-ST",
  "nfe.treatment.notStated": "No informado en las notas.",
  "nfe.treatment.ibsNote":
    "IBS/CBS aparecen como se informaron en la nota; solo observados, nunca comparados.",
  "nfe.orig.0": "nacional",
  "nfe.orig.1": "extranjera, importación directa",
  "nfe.orig.2": "extranjera, mercado interno",
  "nfe.orig.3": "nacional, contenido importado > 40%",
  "nfe.orig.4": "nacional, proceso productivo básico",
  "nfe.orig.5": "nacional, contenido importado ≤ 40%",
  "nfe.orig.6": "extranjera sin similar (CAMEX), directa",
  "nfe.orig.7": "extranjera sin similar (CAMEX), interno",
  "nfe.orig.8": "nacional, contenido importado > 70%",
  "nfe.volume.title": "Volumen observado",
  "nfe.value.yes": "Sí",
  "nfe.value.no": "No",
  "nfe.detail.boundary":
    "Comparación de solo lectura. Las notas corroboran; no sustituyen la evidencia legal ni cambian la regla.",
  "nfe.compare.title": "Esperado × observado",
  "nfe.compare.field": "Campo",
  "nfe.compare.expected": "Esperado por la plataforma",
  "nfe.compare.observed": "Observado en las notas",
  "nfe.compare.result": "Resultado",
  "nfe.compare.state.diverges": "diverge",
  "nfe.compare.state.matches": "coincide",
  "nfe.compare.state.skipped": "no comparado",
  "nfe.compare.notStated": "No declarado",
  "nfe.compare.notComparable": "No comparable",
  "nfe.compare.adjusted": "MVA original {original} · ajustada {adjusted}",
  "nfe.compare.rule": "Regla publicada",
  "nfe.compare.noRule": "Ninguna regla publicada cubre esta ruta",
  "nfe.compare.factLevel": "Nivel de los hechos",
  "nfe.compare.facts.one": "{count} hecho",
  "nfe.compare.facts.other": "{count} hechos",
  "nfe.compare.comparedOn": "Comparado con el estado del",
  "nfe.factLevel.PUBLISHED_RULE": "Regla publicada",
  "nfe.factLevel.CERTIFIED": "Certificado",
  "nfe.factLevel.VERIFIED": "Verificado",
  "nfe.factLevel.UNVERIFIED": "No verificado (no se usa)",
  "nfe.factLevel.NONE": "Ningún hecho",
  "nfe.source.PUBLISHED_RULE": "Regla publicada",
  "nfe.source.FISCAL_FACT": "Hecho fiscal",
  "nfe.source.FISCAL_FACT.CERTIFIED": "Hecho certificado",
  "nfe.source.FISCAL_FACT.VERIFIED": "Hecho verificado",
  "nfe.source.IOB_FINDING": "IOB",
  "nfe.source.SENATE_RESOLUTION_13_2012": "Res. Senado 13/2012",
  "nfe.field.stApplicable": "ST",
  "nfe.field.mva": "MVA",
  "nfe.field.destinationInternalRate": "Alícuota interna destino",
  "nfe.field.interstateRate": "Alícuota interestatal",
  "nfe.field.fcpRate": "FCP",
  "nfe.stMode.RETAINED": "retenida por el remitente",
  "nfe.stMode.PREVIOUSLY_RETAINED": "retenida anteriormente",
  "nfe.stMode.NONE": "sin ST",
  "nfe.note.ST_PREVIOUSLY_RETAINED":
    "CST 60 / CSOSN 500: la ST se retuvo antes; en operación interestatal no se compara ST sí/no.",
  "nfe.note.FINAL_CONSUMER":
    "Consumidor final: no se comparan ST ni MVA (la ST trata de la cadena de reventa).",
  "nfe.note.ST_BASE_NOT_MVA":
    "La base de la ST no es MVA (pauta, precio de lista): MVA no comparada.",
  "nfe.note.SIMPLES_NACIONAL":
    "Simples Nacional (CSOSN): la alícuota propia del ICMS no consta en el ítem.",
  "nfe.note.IMPORTED_GOODS":
    "Origen 1, 2, 3 u 8: aplica la interestatal del 4% (Res. Senado 13/2012).",
  "nfe.note.INTERNAL_ST_ONLY": "El IOB indicó ST solo interna: sin retención por el remitente.",
  "nfe.note.ADJUSTED_MVA": "La MVA observada coincide con la MVA ajustada, no con la original.",
  "nfe.note.RULE_FACT_DISAGREE":
    "La regla publicada y los hechos certificados discrepan; se usó la regla.",
  "nfe.note.NOT_ORDINARY_SALE":
    "Entrada, complementaria, ajuste o devolución: no es una venta común.",
  "nfe.note.REDUCED_BASE":
    "Base reducida (pRedBC / pRedBCST): se comparan las alícuotas nominales.",
  "nfe.note.INCONSISTENT_ITEMS": "Algunos ítems fallaron en las verificaciones internas de valor.",
  "nfe.note.FACTS_UNRESOLVED":
    "Los hechos certificados son ambiguos o contradictorios para esta clave.",
  "nfe.consistency.title": "Consistencia de los ítems",
  "nfe.consistency.body.one":
    "{count} de {items} ítems tiene un valor distinto de base × alícuota más allá del redondeo.",
  "nfe.consistency.body.other":
    "{count} de {items} ítems tienen un valor distinto de base × alícuota más allá del redondeo.",
  "nfe.consistency.sample": "Muestra de ítems inconsistentes",
  "nfe.consistency.item": "Ítem n.º",
  "nfe.consistency.issues": "Verificaciones",
  "nfe.issue.ICMS_VALUE_MISMATCH": "vICMS ≠ base × pICMS",
  "nfe.issue.FCP_VALUE_MISMATCH": "vFCP ≠ base × pFCP",
  "nfe.issue.ICMS_ST_BASE_MISMATCH": "La base de la ST no coincide con la MVA",
  "nfe.issue.ICMS_ST_VALUE_MISMATCH": "vICMSST no coincide",
  "nfe.issue.FCP_ST_VALUE_MISMATCH": "vFCPST no coincide",
  "nfe.issue.ST_RETAINED_VALUE_MISMATCH": "ST retenida (vICMSSTRet) no coincide",
  "nfe.issue.DIFAL_VALUE_MISMATCH": "DIFAL (vICMSUFDest) no coincide",
  "nfe.issue.IPI_VALUE_MISMATCH": "vIPI ≠ base × pIPI",
  "nfe.issue.PIS_VALUE_MISMATCH": "vPIS ≠ base × alícuota",
  "nfe.issue.COFINS_VALUE_MISMATCH": "vCOFINS ≠ base × alícuota",
  "nfe.issue.IBS_CBS_VALUE_MISMATCH": "IBS/CBS ≠ base × alícuota",
  "nfe.invoices.title": "Notas de muestra {count}",
  "nfe.invoices.hint":
    "Más recientes primero. Solo clave de acceso, fecha de emisión y CNPJ del emisor.",
  "nfe.invoices.none": "Sin notas de muestra.",
  "nfe.invoices.issuedAt": "Emisión",
  "nfe.invoices.emitter": "CNPJ del emisor",
  "nfe.invoices.cpf": "Emisor persona física (no se guarda)",
  "nfe.drafts.title": "Borradores creados a partir de este camino",
  "nfe.drafts.none": "Aún no hay borradores.",
  "nfe.drafts.open": "Abrir en el borrador del conjunto",
  "nfe.drafts.publications": "Ver Publicaciones",
  "nfe.draft.action": "Crear borrador de propuesta",
  "nfe.draft.title": "Crear borrador de propuesta a partir de las notas",
  "nfe.draft.volume": "{invoices} notas · {items} ítems",
  "nfe.draft.body":
    "Prepara un borrador en el próximo conjunto en borrador ({version}) con esta observación adjunta como corroboración NF-e (tipo NFE_OBSERVATION).",
  "nfe.draft.bodyNoVersion":
    "Prepara un borrador en el próximo conjunto en borrador con esta observación adjunta como corroboración NF-e (tipo NFE_OBSERVATION).",
  "nfe.draft.point.corroboration": "Las notas entran como corroboración, nunca como fuente legal.",
  "nfe.draft.point.rates": "Las alícuotas quedan en blanco hasta leerse del acto oficial.",
  "nfe.draft.point.nothingAutomatic": "Nada se aprueba ni se publica automáticamente.",
  "nfe.draft.evidence":
    "La evidencia legal oficial aún debe adjuntarse y aprobarse en Documentos antes de que la propuesta pueda aprobarse.",
  "nfe.draft.noDraft":
    'No hay conjunto en borrador. En Publicaciones, use "Preparar próximo borrador" y vuelva aquí.',
  "nfe.draft.matches": "Este camino coincide con la plataforma: no hay nada que proponer.",
  "nfe.draft.reason": "Motivo (opcional)",
  "nfe.draft.reasonHint":
    "Si lo informa, use al menos 10 caracteres. Queda en el borrador y en la auditoría.",
  "nfe.draft.confirm": "Crear borrador",
  "nfe.draft.creating": "Creando…",
  "nfe.draft.created": "Borrador creado en {version}",
  "nfe.draft.existing": "Este camino ya tenía borrador en {version}",
  "nfe.draft.toastBody":
    "Adjunte y apruebe la evidencia oficial en Documentos antes de enviar la propuesta.",
  "nfe.draft.open": "Abrir borradores de {version}",
  /* Insights — calculation / lot summary + header inbox */
  "insights.eyebrow": "Insights",
  "insights.title.calculation": "Lo que muestra este cálculo",
  "insights.title.lot": "Lo que muestra este lote",
  "insights.headline.driver":
    "{driver} representa el {share} de los tributos en {calculated} líneas calculadas",
  "insights.headline.review.one": "{count} línea necesita revisión",
  "insights.headline.review.other": "{count} líneas necesitan revisión",
  "insights.headline.empty": "Esperando líneas calculadas con una regla publicada.",
  "insights.kpi.purchaseTax": "Tributos en la compra",
  "insights.kpi.effectiveRate": "Alícuota efectiva",
  "insights.kpi.effectiveRateCaption": "sobre el valor de las mercancías {amount}",
  "insights.kpi.linesCalculated": "Líneas calculadas",
  "insights.kpi.linesCalculatedValue": "{calculated} / {total}",
  "insights.kpi.valueAtRisk": "Valor en riesgo",
  "insights.kpi.valueAtRiskCaption": "valor de las mercancías en líneas en revisión",
  "insights.kpi.saleTax": "Tributos en la venta",
  "insights.drivers.title": "Principales tributos",
  "insights.drivers.empty":
    "Aún no hay línea calculada — los tributos aparecen cuando una línea tiene regla.",
  "insights.drivers.saleHeading": "En la venta",
  "insights.drivers.onLines.one": "en {count} línea",
  "insights.drivers.onLines.other": "en {count} líneas",
  "insights.drivers.a11y": "{name}: {amount}, {share}, en {lines} líneas",
  "insights.driver.ICMS_ST": "ICMS-ST",
  "insights.driver.IPI": "IPI",
  "insights.driver.FCP": "FCP/FECP",
  "insights.driver.OTHER_PURCHASE": "Otros tributos en la compra",
  "insights.driver.PIS_COFINS": "PIS/COFINS en la venta",
  "insights.driver.DIFAL": "DIFAL en la venta",
  "insights.review.title": "Necesita revisión",
  "insights.review.reason.NO_RULE": "Sin regla",
  "insights.review.reason.AMBIGUOUS_RULE": "Regla ambigua",
  "insights.review.reason.STALE_RULE": "Regla vencida",
  "insights.review.reason.UNVERIFIED_DATA": "Datos no verificados",
  "insights.review.reason.INPUT_DATA": "Datos de entrada",
  "insights.review.reason.PENDING_CONFIRMATION": "Confirmación pendiente",
  "insights.review.reason.OTHER": "Otro",
  "insights.review.explain.NO_RULE": "No hay regla publicada para este NCM y ruta",
  "insights.review.explain.AMBIGUOUS_RULE": "Coincide más de una regla — elija una",
  "insights.review.explain.STALE_RULE": "La regla usada venció en la fecha fiscal",
  "insights.review.explain.UNVERIFIED_DATA":
    "Se encontraron datos, pero están pendientes de verificación — los montos no cambian hasta la revisión",
  "insights.review.explain.INPUT_DATA":
    "Faltan datos de entrada o son inválidos (NCM, UF, costo o alícuotas)",
  "insights.review.explain.PENDING_CONFIRMATION":
    "Un perfil o clasificación necesita su confirmación",
  "insights.review.explain.OTHER": "Necesita una revisión financiera",
  "insights.review.lines.one": "{count} línea",
  "insights.review.lines.other": "{count} líneas",
  "insights.review.valueAtRisk": "Valor en riesgo: {amount}",
  "insights.review.action": "Revise las líneas",
  "insights.review.staleNote.one":
    "{count} línea calculada usa una regla que venció en la fecha fiscal",
  "insights.review.staleNote.other":
    "{count} líneas calculadas usan una regla que venció en la fecha fiscal",
  "insights.savings.title": "Oportunidad de ahorro",
  "insights.savings.headline": "Hasta {amount} menos de ICMS-ST en una ruta comparable",
  "insights.savings.row":
    "NCM {ncm} · {origin} → {destination} paga {rate} de ST; desde {comparable} → {destination} es {comparableRate}",
  "insights.savings.footnote":
    "Estimación a partir de las líneas de este cálculo con el mismo NCM y destino; no es asesoría tributaria.",
  "insights.research.title": "En investigación",
  "insights.research.chip.running": "{count} en ejecución",
  "insights.research.chip.queued": "{count} en cola",
  "insights.research.chip.found": "{count} encontradas",
  "insights.research.chip.needsReview": "{count} por revisar",
  "insights.research.chip.notFoundFailed": "{count} sin hallazgo / fallidas",
  "insights.research.gap": "{ncm} · {origin} → {destination} — {status}, estimado {eta}",
  "insights.research.status.QUEUED": "en cola",
  "insights.research.status.RUNNING": "en ejecución",
  "insights.research.idle": "Ninguna búsqueda en ejecución ahora",
  "insights.research.open": "Abra la investigación",
  "insights.revision.title": "Qué cambió en la revisión {number}",
  "insights.revision.noValueBefore": "Sin valor antes",
  "insights.revision.noValueYet": "Aún sin valor",
  "insights.revision.summary":
    "La revisión {number} cambió {changed} de {total} líneas; tributos en las líneas con valor antes y después: {delta}.",
  "insights.revision.newlyCalculated.one":
    "{count} línea se calculó por primera vez ({amount} en tributos)",
  "insights.revision.newlyCalculated.other":
    "{count} líneas se calcularon por primera vez ({amount} en tributos)",
  "insights.revision.cause.NEW_RULE": "Nueva regla publicada",
  "insights.revision.cause.RULE_CHANGED": "Regla cambiada",
  "insights.revision.cause.UNVERIFIED_PENDING": "Datos encontrados, pendientes de verificación",
  "insights.revision.cause.FACTS_NOT_APPLIED": "Hechos comparados, no aplicados",
  "insights.revision.cause.RULESET_UPDATED": "Conjunto de reglas actualizado",
  "insights.revision.cause.STATUS_CHANGED": "Estado cambiado",
  "insights.revision.ruleset": "Reglas v{before} → v{after}",
  "insights.inbox.trigger": "Insights",
  "insights.inbox.triggerUnread": "Insights, {count} sin leer",
  "insights.inbox.unread": "No leído",
  "insights.inbox.title": "Insights",
  "insights.inbox.empty": "Nada nuevo — los insights de sus cálculos aparecen aquí.",
  "insights.inbox.generic": "Nuevo insight",
  "insights.inbox.atRisk": "{amount} en riesgo",
  "insights.inbox.badgeMore": "9+",
  "insights.inbox.kind.RECALCULATION_READY.one":
    "{count} línea puede recalcularse con reglas nuevas",
  "insights.inbox.kind.RECALCULATION_READY.other":
    "{count} líneas pueden recalcularse con reglas nuevas",
  "insights.inbox.kind.RESEARCH_FOUND.one": "La investigación encontró datos para {count} línea",
  "insights.inbox.kind.RESEARCH_FOUND.other": "La investigación encontró datos para {count} líneas",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.one":
    "{count} resultado de investigación espera verificación",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.other":
    "{count} resultados de investigación esperan verificación",
  "insights.inbox.kind.RESEARCH_RUNNING.one": "{count} búsqueda en ejecución",
  "insights.inbox.kind.RESEARCH_RUNNING.other": "{count} búsquedas en ejecución",
  "insights.inbox.kind.REVIEW_REQUIRED.one": "{count} línea necesita revisión",
  "insights.inbox.kind.REVIEW_REQUIRED.other": "{count} líneas necesitan revisión",
  "insights.inbox.kind.RULE_PUBLISHED.one": "Nueva regla publicada que afecta {count} línea",
  "insights.inbox.kind.RULE_PUBLISHED.other": "Nueva regla publicada que afecta {count} líneas",
  "insights.inbox.kind.SAVINGS_OPPORTUNITY": "Posible ahorro de {amount}",
  /* Notas fiscais workspace (tax managers) */
  "shell.nav.invoices": "Notas fiscales",
  "inv.title": "Notas fiscales",
  "inv.description":
    "Suba las notas fiscales de la empresa, véalas por mes, valide cada mes y lea los hallazgos.",
  "inv.upload.open": "Enviar notas fiscales",
  "inv.upload.hide": "Cerrar envío",
  "inv.views.label": "Áreas de las notas fiscales",
  "inv.views.months": "Meses",
  "inv.views.batches": "Lotes de envío",
  "inv.batches.hint":
    "Un envío puede mezclar meses: cada nota va al mes de su fecha de emisión. Aquí están los lotes enviados y lo que pasó con cada archivo.",
  "inv.readOnly":
    "Solo lectura: revisar y validar meses requiere el permiso de revisión de reglas.",
  "inv.empty.title": "Aún no hay notas fiscales",
  "inv.empty.body":
    "Suba los XML o ZIP de las notas de la empresa. Se organizan por mes de emisión, emitidas y recibidas.",
  "inv.empty.readOnly":
    "Aún no hay notas fiscales. Quien pueda subir archivos debe hacer el primer envío.",
  "inv.direction.label": "Dirección",
  "inv.direction.ALL": "Todas las notas",
  "inv.direction.EMITIDA": "Emitidas",
  "inv.direction.RECEBIDA": "Recibidas",
  "inv.direction.EMITIDA.tag": "Emitida",
  "inv.direction.RECEBIDA.tag": "Recibida",
  "inv.status.NOT_REVIEWED": "Sin revisar",
  "inv.status.IN_REVIEW": "En revisión",
  "inv.status.VALIDATED": "Validado",
  "inv.severity.HIGH": "Alta",
  "inv.severity.MEDIUM": "Media",
  "inv.severity.LOW": "Baja",
  "inv.nav.label": "Períodos",
  "inv.nav.title": "Períodos",
  "inv.nav.change": "Cambiar de mes",
  "inv.nav.choose": "Elegir un mes",
  "inv.nav.yearLabel": "Meses de {year}",
  "inv.nav.months.one": "{count} mes",
  "inv.nav.months.other": "{count} meses",
  "inv.nav.pending.one": "{count} por validar",
  "inv.nav.pending.other": "{count} por validar",
  "inv.nav.invoices.one": "{count} nota",
  "inv.nav.invoices.other": "{count} notas",
  "inv.nav.diverging.one": "{count} diverge",
  "inv.nav.diverging.other": "{count} divergen",
  "inv.nav.high.one": "{count} alto",
  "inv.nav.high.other": "{count} altos",
  "inv.nav.reopened": "Reabierto",
  "inv.nav.outside.one":
    "{count} nota en la base no es emitida ni recibida por la empresa y queda fuera de esta área.",
  "inv.nav.outside.other":
    "{count} notas en la base no son emitidas ni recibidas por la empresa y quedan fuera de esta área.",
  "inv.affected.title.one": "El envío tocó {count} mes",
  "inv.affected.title.other": "El envío tocó {count} meses",
  "inv.affected.text.one":
    "{count} nota nueva o cambiada, colocada en el mes de su fecha de emisión.",
  "inv.affected.text.other":
    "{count} notas nuevas o cambiadas, colocadas en el mes de su fecha de emisión.",
  "inv.affected.changed.one": "{count} nota",
  "inv.affected.changed.other": "{count} notas",
  "inv.affected.reopened": "Volvió a revisión",
  "inv.month.older": "Mes anterior",
  "inv.month.newer": "Mes siguiente",
  "inv.month.openBatch": "Ver el lote",
  "inv.month.reopened.one":
    "Este mes estaba validado y volvió a revisión: un envío el {when} trajo {count} nota nueva o cambiada. Revise antes de validar de nuevo.",
  "inv.month.reopened.other":
    "Este mes estaba validado y volvió a revisión: un envío el {when} trajo {count} notas nuevas o cambiadas. Revise antes de validar de nuevo.",
  "inv.dashboard.label": "Cifras del mes",
  "inv.dashboard.bothDirections": "emitidas y recibidas",
  "inv.dashboard.invoices": "Notas",
  "inv.dashboard.items": "Ítems",
  "inv.dashboard.value": "Valor total",
  "inv.dashboard.cancelled": "Canceladas",
  "inv.dashboard.cancelledScope": "no entran en las demás cuentas",
  "inv.dashboard.cancelledShare": "{share} de las notas del mes",
  "inv.dashboard.paths": "Caminos",
  "inv.dashboard.findings": "Hallazgos",
  "inv.dashboard.aiSuggestions.one": "{count} sugerencia de la IA",
  "inv.dashboard.aiSuggestions.other": "{count} sugerencias de la IA",
  "inv.dashboard.byDirection": "Por dirección",
  "inv.dashboard.itemsCount.one": "{count} ítem",
  "inv.dashboard.itemsCount.other": "{count} ítems",
  "inv.validation.title": "Validación del mes",
  "inv.validation.notReviewed":
    "Este mes aún no se revisó. Inicie la revisión para registrar decisiones y validar.",
  "inv.validation.blocked": "Faltan decisiones registradas antes de validar el mes.",
  "inv.validation.ready": "Listo para validar: nada pendiente de decisión.",
  "inv.validation.validated": "Mes validado el {when}.",
  "inv.validation.nothingBlocks": "Nada impide la validación de este mes.",
  "inv.validation.bothDirections":
    "El conteo considera emitidas y recibidas, sea cual sea el filtro de dirección.",
  "inv.validation.blocker.paths.one": "{open} de {total} camino divergente sin decisión",
  "inv.validation.blocker.paths.other": "{open} de {total} caminos divergentes sin decisión",
  "inv.validation.blocker.findings.one": "{open} de {total} hallazgo alto sin decisión",
  "inv.validation.blocker.findings.other": "{open} de {total} hallazgos altos sin decisión",
  "inv.validation.show.paths": "Ver caminos",
  "inv.validation.show.findings": "Ver hallazgos",
  "inv.validation.start": "Iniciar revisión",
  "inv.validation.validate": "Validar mes",
  "inv.validation.blockedReason":
    "Registre una decisión para cada camino divergente y cada hallazgo alto antes de validar.",
  "inv.validation.reopen": "Reabrir mes",
  "inv.validation.stale":
    "El mes cambió desde que se cargó. Actualizamos la pantalla; revise e intente de nuevo.",
  "inv.validation.done.START_REVIEW": "Revisión de {month} iniciada",
  "inv.validation.done.VALIDATE": "{month} validado",
  "inv.validation.done.REOPEN": "{month} reabierto para revisión",
  "inv.reopen.title": "Reabrir {month}",
  "inv.reopen.body":
    "El mes vuelve a revisión y debe validarse de nuevo. La reapertura queda en el historial con el motivo.",
  "inv.reopen.reason": "Motivo de la reapertura",
  "inv.reopen.confirm": "Reabrir mes",
  "inv.reopen.saving": "Reabriendo…",
  "inv.tabs.label": "Secciones del mes",
  "inv.tabs.paths": "Caminos observados",
  "inv.tabs.findings": "Hallazgos",
  "inv.tabs.ai": "Sugerencias de la IA",
  "inv.tabs.analysis": "Análisis",
  "inv.tabs.history": "Historial",
  "inv.paths.title": "Caminos observados en el mes",
  "inv.paths.hint":
    "Cada camino es un tratamiento fiscal visto en las notas del mes, comparado con lo que la plataforma conoce. Las divergencias necesitan una decisión antes de la validación.",
  "inv.paths.decision": "Decisión",
  "inv.paths.empty.title": "Ningún camino en este mes",
  "inv.paths.empty.body": "Cuando haya notas en este mes, los caminos fiscales aparecen aquí.",
  "inv.filter.all": "Todos",
  "inv.filter.pending": "Pendientes",
  "inv.filter.decided": "Con decisión",
  "inv.filter.decision": "Decisión",
  "inv.filter.review": "Revisión",
  "inv.filter.toReview": "Por revisar",
  "inv.filter.dismissed": "Descartadas",
  "inv.filter.severity": "Gravedad",
  "inv.filter.code": "Verificación",
  "inv.filter.anyCode": "Todas las verificaciones",
  "inv.findings.title": "Hallazgos de las verificaciones automáticas",
  "inv.findings.hint":
    "Verificaciones fijas sobre las notas del mes, siempre activas. Cada hallazgo dice qué ve, qué hacer y cuánto está en juego.",
  "inv.findings.count.one": "{count} hallazgo",
  "inv.findings.count.other": "{count} hallazgos",
  "inv.findings.empty.title": "Ningún hallazgo abierto",
  "inv.findings.empty.body": "Las verificaciones automáticas no señalaron nada en este mes.",
  "inv.findings.aiPointer.one": "{count} sugerencia de la IA espera revisión.",
  "inv.findings.aiPointer.other": "{count} sugerencias de la IA esperan revisión.",
  "inv.findings.aiPointerAction": "Ver sugerencias",
  "inv.finding.action": "Qué hacer:",
  "inv.finding.value": "Valor en juego",
  "inv.finding.valueUnknown": "No estimado",
  "inv.finding.invoice": "Nota",
  "inv.finding.related": "Nota relacionada",
  "inv.finding.items": "Ítems",
  "inv.finding.openPath": "Ver camino",
  "inv.code.ICMS_ZERO_RATE_ON_TAXED_CST": "ICMS con alícuota cero en CST gravado",
  "inv.code.DIFAL_MISSING_NON_CONTRIBUTOR": "DIFAL ausente para no contribuyente",
  "inv.code.INTERSTATE_RATE_INCONSISTENT": "Alícuota interestatal incoherente con la ruta",
  "inv.code.ST_CFOP_WITHOUT_ST_GROUP": "CFOP de ST sin el grupo de ST",
  "inv.code.ST_CST_WITHOUT_ST_VALUES": "CST de ST sin valores de ST",
  "inv.code.REDUCTION_WITHOUT_PRED_BC": "CST de reducción sin pRedBC",
  "inv.code.PRED_BC_WITHOUT_REDUCTION_CST": "pRedBC en CST sin reducción",
  "inv.code.ICMS_VALUE_MISMATCH": "ICMS distinto de base × alícuota",
  "inv.code.ICMS_ST_BASE_MISMATCH": "Base de ICMS-ST fuera de la fórmula",
  "inv.code.ICMS_ST_VALUE_MISMATCH": "Valor de ICMS-ST fuera de la fórmula",
  "inv.code.OTHER_TAX_VALUE_MISMATCH": "Otro tributo fuera de base × alícuota",
  "inv.code.PIS_COFINS_ZERO_RATE_CST01": "PIS/COFINS con CST 01 al 0%",
  "inv.code.MONOPHASIC_CHARGED_AS_CST01": "NCM monofásico gravado como CST 01",
  "inv.code.POSSIBLE_DUPLICATE_EMITTED": "Posible duplicidad en nota emitida",
  "inv.code.PLATFORM_RULE_DIVERGENCE": "El camino diverge de lo que la plataforma conoce",
  "inv.ack.action": "Registrar decisión",
  "inv.ack.change": "Cambiar decisión",
  "inv.ack.pending": "Sin decisión",
  "inv.ack.open": "Abierto",
  "inv.ack.stale": "Decisión desactualizada",
  "inv.ack.staleHint": "La divergencia cambió después de esta decisión. Registre una nueva.",
  "inv.ack.title": "Registrar decisión",
  "inv.ack.titleAi": "Descartar sugerencia de la IA",
  "inv.ack.resolution": "¿Qué decidió?",
  "inv.ack.reason": "Motivo",
  "inv.ack.reasonHint":
    "Obligatorio: de {min} a {max} caracteres. Queda en el historial del mes. ({count})",
  "inv.ack.submit": "Registrar decisión",
  "inv.ack.saving": "Registrando…",
  "inv.ack.convertNote":
    "Crea o reutiliza un borrador de propuesta de regla. Sigue necesitando evidencia oficial, revisión y aprobación: nada se publica.",
  "inv.ack.conflict": "No se pudo registrar ahora: el estado del mes no permite esta decisión.",
  "inv.ack.replaces": "Sustituye la decisión de {who} el {when}: {resolution}.",
  "inv.ack.done.ACCEPTED_ISSUER_ERROR": "Decisión registrada: error del emisor",
  "inv.ack.done.ACCEPTED_CORRECT": "Decisión registrada: tratamiento correcto",
  "inv.ack.done.CONVERTED_TO_DRAFT": "Borrador de propuesta creado",
  "inv.ack.done.DISMISSED": "Sugerencia descartada",
  "inv.resolution.ACCEPTED_ISSUER_ERROR": "Error del emisor",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.short": "Error del emisor",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.hint":
    "La nota está equivocada. Registro el motivo y sigo; la plataforma no cambia.",
  "inv.resolution.ACCEPTED_CORRECT": "Tratamiento correcto",
  "inv.resolution.ACCEPTED_CORRECT.short": "Tratamiento correcto",
  "inv.resolution.ACCEPTED_CORRECT.hint":
    "La nota está bien. Acepto el tratamiento observado como válido en este mes.",
  "inv.resolution.CONVERTED_TO_DRAFT": "Crear borrador de propuesta de regla",
  "inv.resolution.CONVERTED_TO_DRAFT.short": "Borrador creado",
  "inv.resolution.CONVERTED_TO_DRAFT.hint":
    "Prepara un borrador con este camino como corroboración. No aprueba ni publica nada.",
  "inv.resolution.DISMISSED": "Descartar sugerencia",
  "inv.resolution.DISMISSED.short": "Descartada",
  "inv.resolution.DISMISSED.hint": "Revisé y no voy a seguir esta sugerencia.",
  "inv.drawer.decision": "Decisión registrada",
  "inv.drawer.decisionWhat": "Qué",
  "inv.drawer.decisionWho": "Quién y cuándo",
  "inv.drawer.issuerRoot": "Raíz del CNPJ del emisor",
  "inv.ai.title": "Sugerencias de la IA — necesitan revisión",
  "inv.ai.hint":
    "Hipótesis planteadas por un modelo de IA sobre los datos agregados del mes. Quedan separadas de los hallazgos de las verificaciones automáticas.",
  "inv.ai.boundary":
    "El modelo ve solo datos agregados y sin identificación de las notas. Las sugerencias nunca se aplican solas, no son evidencia y no se vuelven regla: la base legal citada es un puntero para verificar en fuente oficial.",
  "inv.ai.analyze": "Analizar con IA",
  "inv.ai.running": "Analizando…",
  "inv.ai.running.reason": "Ya hay un análisis de IA de este mes en curso.",
  "inv.ai.queued": "Análisis con IA de {month} en cola",
  "inv.ai.lastRun": "Último análisis con IA:",
  "inv.ai.neverRun": "Este mes aún no tuvo análisis con IA.",
  "inv.ai.cost": "costo {cost}",
  "inv.ai.followUp": "siguiendo el avance",
  "inv.ai.reason.ARGON_COST_BOUND_UNAVAILABLE":
    "Argon requiere calificar capacidades y precios para Taxes antes del análisis con IA.",
  "inv.ai.reason.NOT_DEPLOYED": "El análisis con IA no está habilitado en este entorno.",
  "inv.ai.reason.SWITCHED_OFF":
    "Un administrador desactivó el análisis con IA en la configuración.",
  "inv.ai.reason.MONTHLY_BUDGET_REACHED": "Se alcanzó el presupuesto mensual de IA.",
  "inv.ai.reason.DAILY_CAP_REACHED": "Se alcanzó el límite diario de análisis de IA.",
  "inv.ai.empty.title": "Ninguna sugerencia de la IA en este mes",
  "inv.ai.empty.body": "Use «Analizar con IA» para pedir hipótesis sobre este mes. Nada se aplica.",
  "inv.ai.empty.unavailable":
    "El análisis con IA no está disponible ahora. Las verificaciones automáticas siguen activas.",
  "inv.ai.toReview": "Por revisar",
  "inv.ai.dismiss": "Descartar",
  "inv.ai.kind.CANDIDATE_RULE": "Regla candidata",
  "inv.ai.kind.SUSPECTED_ISSUER_ERROR": "Probable error del emisor",
  "inv.ai.kind.COMPLIANCE_RISK": "Riesgo de cumplimiento",
  "inv.ai.kind.RESEARCH_SUGGESTION": "Sugerencia de investigación",
  "inv.ai.confidence": "Confianza informada por el modelo",
  "inv.ai.confidenceValue": "Confianza de {percent}%",
  "inv.ai.confidenceNote": "Es el número que declara el modelo, no una probabilidad.",
  "inv.ai.candidate": "Regla candidata (no aplicada)",
  "inv.ai.candidateNote":
    "Una regla solo nace de una propuesta con evidencia oficial, revisión y aprobación.",
  "inv.ai.legal": "Base legal citada por el modelo — por verificar, no es evidencia",
  "inv.ai.query": "Búsqueda sugerida:",
  "inv.settings.open": "Configuración de la IA",
  "inv.analysis.title": "Análisis del mes",
  "inv.analysis.hint":
    "Ejecute de nuevo las verificaciones automáticas o pida un análisis con IA, y vea las ejecuciones anteriores y el costo.",
  "inv.analysis.rules": "Verificaciones automáticas",
  "inv.analysis.rulesText":
    "Reglas fijas sobre cada nota e ítem del mes. Corren siempre que entran notas y pueden repetirse aquí.",
  "inv.analysis.rulesLast": "Última ejecución: {when}",
  "inv.analysis.rulesNever": "Aún no se ejecutaron en este mes.",
  "inv.analysis.runRules": "Ejecutar verificaciones",
  "inv.analysis.running": "Ejecutando…",
  "inv.analysis.rulesDone.one": "Verificaciones ejecutadas: {count} hallazgo",
  "inv.analysis.rulesDone.other": "Verificaciones ejecutadas: {count} hallazgos",
  "inv.analysis.ai": "Análisis con IA",
  "inv.analysis.aiText":
    "Opcional. Un modelo lee solo los datos agregados del mes y plantea hipótesis para revisión.",
  "inv.analysis.runs": "Ejecuciones",
  "inv.analysis.runsEmpty": "Ninguna ejecución registrada",
  "inv.analysis.runCount.one": "{count} ejecución",
  "inv.analysis.runCount.other": "{count} ejecuciones",
  "inv.run.when": "Cuándo",
  "inv.run.kind": "Tipo",
  "inv.run.statusLabel": "Situación",
  "inv.run.trigger": "Origen",
  "inv.run.findings": "Hallazgos",
  "inv.run.cost": "Costo",
  "inv.run.tokens": "Tokens (entrada / salida)",
  "inv.run.kind.RULES": "Reglas",
  "inv.run.kind.AI": "IA",
  "inv.run.trigger.IMPORT": "Envío de notas",
  "inv.run.trigger.MANUAL": "Manual",
  "inv.run.trigger.AUTO_AFTER_IMPORT": "Automática tras el envío",
  "inv.run.status.QUEUED": "En cola",
  "inv.run.status.RUNNING": "En análisis",
  "inv.run.status.COMPLETED": "Completada",
  "inv.run.status.FAILED": "Falló",
  "inv.run.status.CANCELLED": "Cancelada",
  "inv.history.title": "Historial del mes",
  "inv.history.hint":
    "Quién hizo qué, cuándo y por qué: revisión, decisiones, validación, reaperturas y análisis.",
  "inv.history.empty": "Nada registrado en este mes aún.",
  "inv.event.system": "Sistema",
  "inv.event.importer": "Importación de notas",
  "inv.event.REVIEW_STARTED": "Revisión iniciada",
  "inv.event.VALIDATED": "Mes validado",
  "inv.event.REOPENED": "Mes reabierto",
  "inv.event.REOPENED_BY_UPLOAD": "Reabierto por un envío de notas",
  "inv.event.ACKNOWLEDGED": "Decisión registrada",
  "inv.event.RULES_ANALYSIS_RUN": "Verificaciones automáticas ejecutadas",
  "inv.event.AI_ANALYSIS_REQUESTED": "Análisis con IA solicitado",
  "inv.event.AI_ANALYSIS_COMPLETED": "Análisis con IA completado",
  "inv.event.meta.resolution": "Decisión",
  "inv.event.meta.target": "Objetivo",
  "inv.event.meta.code": "Verificación",
  "inv.event.meta.runId": "Ejecución",
  "inv.event.meta.batchId": "Lote",
  "inv.event.meta.changedInvoices": "Notas cambiadas",
  "inv.event.meta.findings": "Hallazgos",
  "inv.settings.title": "Configuración del análisis con IA",
  "inv.settings.intro":
    "Control de la faja de IA de las notas fiscales: interruptor general, ejecución automática, presupuesto mensual, límite diario y la tabla de precios usada para calcular el costo.",
  "inv.settings.notDeployed":
    "Este entorno no tiene instalada la faja de IA. La configuración queda guardada, pero ningún análisis corre.",
  "inv.settings.enabled": "Análisis con IA activado",
  "inv.settings.enabledHint":
    "Interruptor general. Apagado, nada entra en cola y ningún botón de IA funciona.",
  "inv.settings.autoRun": "Correr tras cada envío",
  "inv.settings.autoRunHint":
    "Encola un análisis por mes afectado tras cada envío, mientras haya presupuesto.",
  "inv.settings.budget": "Presupuesto mensual (US$)",
  "inv.settings.budgetHint": "Al alcanzarlo, la IA queda no disponible hasta el mes siguiente.",
  "inv.settings.cap": "Límite diario de análisis",
  "inv.settings.capHint": "De 1 a 1.000 análisis por día.",
  "inv.settings.priceIn": "Precio de entrada (US$ por millón de tokens)",
  "inv.settings.priceOut": "Precio de salida (US$ por millón de tokens)",
  "inv.settings.spent": "Gasto del mes / presupuesto",
  "inv.settings.runsToday": "Análisis hoy / límite",
  "inv.settings.availability": "Situación ahora",
  "inv.settings.available": "Disponible",
  "inv.settings.save": "Guardar",
  "inv.settings.saving": "Guardando…",
  "inv.settings.saved": "Configuración de la IA guardada",
  "inv.settings.conflict":
    "La configuración cambió desde que se cargó. Recargamos los valores; revise y guarde de nuevo.",
  "nfe.workspaceLink.body":
    "Gestión fiscal: organice las notas de la empresa por mes, valide cada mes y lea los hallazgos en el área dedicada.",
  "nfe.workspaceLink.action": "Abrir Notas fiscales",
  "inv.ft.affected": "{count} ítems están afectados; los valores citados son los del primero.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.explain":
    "El CST {cst} informa una base de cálculo de {vBC}, pero el pICMS es 0% en una venta (CFOP {cfop}, NCM {ncm}). Un CST gravado con base y sin alícuota no recauda ICMS.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.reference":
    "La alícuota de referencia de esta operación es {rate}.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.action":
    "Confirme con el emisor si la operación es gravada. Si lo es, pida la nota de corrección o recalcule; si es exenta o no gravada, el CST debería ser 40/41 (o el beneficio informado en cBenef).",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.nonContributor":
    "El CFOP {cfop} (NCM {ncm}) para un destinatario no contribuyente (indIEDest 9) no trae el grupo ICMSUFDest. La EC 87/2015 hace debido el reparto del DIFAL; la operación debería usar CFOP 6108 o 6107 con los campos del ICMSUFDest.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.finalConsumer":
    "El CFOP {cfop} (NCM {ncm}) para un consumidor final (indFinal 1) no trae el grupo ICMSUFDest. La EC 87/2015 hace debido el reparto del DIFAL; la operación debería usar CFOP 6108 o 6107 con los campos del ICMSUFDest.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.rates":
    "pICMS informado: {stated}; alícuota interna de referencia del destino: {internal}.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.action":
    "Verifique el tipo de operación: para no contribuyente o consumidor final, emita (o pida) la nota con CFOP 6108/6107 y el grupo del DIFAL; de lo contrario, confirme el indIEDest del destinatario.",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.NATIONAL_AT_4":
    "El pICMS de {pICMS} es la alícuota de mercadería importada (Res. SF 13/2012), pero el origen {orig} no es 1, 2, 3 ni 8. La mercadería nacional paga {expected} en la ruta {from} → {to} (Res. SF 22/89).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.OTHER":
    "Se cobró pICMS de {pICMS} donde se aplica {expected} en la ruta {from} → {to} ({basis}).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.imported": "Res. SF 13/2012, mercadería importada",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.route":
    "Res. SF 22/89, tabla de rutas: 7% del Sur/Sudeste, salvo ES, hacia los demás; si no 12%",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.action":
    "Revise el origen de la mercadería (orig) y la ruta. Una alícuota errada del emisor cambia el crédito que la empresa puede tomar; pida nota de corrección si es un error.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.explain":
    "El CFOP {cfop} ({role}) se emitió con {group} CST {cst}, que no trae ICMS-ST. O el CFOP o el grupo de ICMS está equivocado.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substitute": "sustituto, ST retenida",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substituted": "sustituido, ST ya retenida",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.action":
    "Verifique si la mercadería está sujeta a ICMS-ST en esta ruta. En el x403 el emisor es el sustituto y debe informar el grupo y los valores de ST (CST 10/30/70); en el x405 la mercadería ya tuvo ST retenida (CST 60 / CSOSN 500).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.explain":
    "El {group} con CST/CSOSN {cst} retiene ICMS-ST, pero el ítem no tiene base de ST (vBCST) ni valor de ST (vICMSST).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.action":
    "Pregunte al emisor si hubo retención de ST. Si la hubo, la nota debe informar vBCST y vICMSST; si no, el CST está equivocado.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.explain":
    "El CST {cst} es de base reducida, pero el ítem no informa pRedBC; la reducción no puede verificarse.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.action":
    "Pida al emisor el porcentaje de reducción (pRedBC) y el fundamento legal de la reducción.",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.explain":
    "Hay un pRedBC de {pRedBC} informado, pero el CST es {cst}, que no es de base reducida (20, 70 o 90).",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.action":
    "Verifique si la base realmente se redujo. Si se redujo, el CST debería ser 20 (o 70 con ST); si no, retire el pRedBC.",
  "inv.ft.ICMS_VALUE_MISMATCH.explain":
    "El vICMS de {vICMS} difiere de vBC {vBC} × pICMS {pICMS} (= {expected}) más allá del redondeo.",
  "inv.ft.ICMS_VALUE_MISMATCH.action":
    "Compare con el DANFE y pida nota de corrección al emisor si el valor está errado.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.explain":
    "El vBCST de {vBCST} difiere de (vProd + IPI + flete + seg + otros − desc) × (1 + MVA {pMVAST}) = {expected} más allá de la tolerancia.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.reduction":
    "El pRedBCST de {pRedBCST} está informado: algunos ERP lo aplican a la base ajustada por la MVA, otros al valor de la operación, y algunos lo informan sin haberlo aplicado al vBCST; confirme qué convención usó el emisor.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.action":
    "Recalcule la base de ST con la MVA del destino (MVA ajustada en operación interestatal) y pida confirmación al emisor.",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.explain":
    "El vICMSST de {vICMSST} difiere de vBCST {vBCST} × pICMSST {pICMSST} menos el ICMS propio {vICMS} (= {expected}).",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.action":
    "Pida nota de corrección al emisor si el valor de ST está errado.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.explain":
    "{issues}: el valor informado difiere de base × alícuota más allá del redondeo.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.action":
    "Compare con el DANFE; pida nota de corrección al emisor solo si el valor es relevante.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.explain":
    "PIS CST {pisCst} ({pisRate}) y COFINS CST {cofinsCst} ({cofinsRate}): un CST gravable con alícuota cero no recauda nada.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.action":
    "Verifique el régimen de determinación y si la mercadería tiene alícuota cero, es monofásica o tiene suspensión; corrija el CST o la alícuota con el emisor.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.explain":
    "El NCM {ncm} ({act}) está en el régimen monofásico, pero esta reventa (CFOP {cfop}) cobra PIS/COFINS con CST 01. Después del cobro concentrado, la reventa normalmente usa CST 04.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.action":
    "Confirme que el vendedor no es fabricante ni importador de la mercadería. Si es revendedor, las contribuciones ya fueron recaudadas: pida nota de corrección (CST 04) y revise lo pagado. La tabla de NCM es una lista revisada, no un dictamen jurídico.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.one":
    "Mismos ítems, valores y totales ({total}) que otra nota emitida {days} día antes, el {date} (ventana de 30 días). El destinatario no se almacena: también puede ser una venta repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.other":
    "Mismos ítems, valores y totales ({total}) que otra nota emitida {days} días antes, el {date} (ventana de 30 días). El destinatario no se almacena: también puede ser una venta repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.sameDay":
    "Mismos ítems, valores y totales ({total}) que otra nota emitida el mismo día, {date}. El destinatario no se almacena: también puede ser una venta repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.action":
    "Verifique si la nota anterior debía haberse sustituido o cancelado, o si la venta realmente se repitió. Si es duplicidad, cancele dentro del plazo de la SEFAZ o emita el ajuste correspondiente.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.explain":
    "En este mes, {invoices} y {items} informan {details}. El valor de la plataforma viene de {source}.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.detail":
    "{field} {observed} donde la plataforma tiene {expected}",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.action":
    "Decida si el emisor se equivocó, si la plataforma está desactualizada (abra un borrador de propuesta desde el camino) o si la nota está bien para un caso que la plataforma no modela. La decisión sobre el camino lo registra.",
  "lotMap.field.descricao": "Descripción del producto",
  "lotMap.field.margem_alvo": "Margen objetivo (sobre el precio)",
  "lotMap.field.markup": "Markup (sobre el costo)",
  "lotMap.field.expected_landed": "Costo final esperado por unidad",
  "lotMap.field.expected_own_icms": "ICMS de la entrada esperado por unidad",
  "lotMap.field.expected_purchase_pis_cofins": "PIS/COFINS de la compra esperado por unidad",
  "lotMap.field.expected_workbook_cost": "Costo como en la planilla esperado por unidad",
  "lotMap.field.expected_sale_price": "Valor de venta con TR esperado por unidad",
  "lotMap.field.expected_sale_icms": "ICMS propio de la venta esperado por unidad",
  "lotMap.field.expected_sale_pis_cofins": "PIS/COFINS de la venta esperado por unidad",
  "lotMap.field.expected_sale_st_fcp": "ICMS-ST y FCP-ST de la NF de venta esperado por unidad",
  "lotMap.field.expected_buyer_invoice": "NF de venta del comprador esperada por unidad",
  "lotMap.field.ref_cfop": "CFOP (solo referencia)",
  "lotMap.field.ref_mva": "MVA / IVA-ST (solo referencia)",
  "lotMap.field.ref_aliq_ipi": "Alícuota de IPI (solo referencia)",
  "lotMap.field.ref_aliq_icms": "Alícuota de ICMS (solo referencia)",
  "lotMap.field.ref_pis_cofins": "Alícuota de PIS/COFINS (solo referencia)",
  "lotMap.field.ref_frete": "Flete (solo referencia)",
  "wb.where.sheet": "Hoja “{sheet}”",
  "wb.where.row": "fila {row}",
  "wb.where.column": "columna {column}",
  "wb.where.columnHeader": "columna {column} ({header})",
  "wb.detail.expected": "Esperado: {value}",
  "wb.detail.found": "Encontrado: {value}",
  "wb.expected.ncm-8-digits": "un NCM de 8 dígitos, por ejemplo 1905.90.20",
  "wb.expected.cest-single": "un único CEST con el formato 17.056.02",
  "wb.expected.uf-code": "la sigla del estado con 2 letras, por ejemplo SP",
  "wb.expected.amount-brl": "un valor en reales, sin signo negativo, con hasta 2 decimales",
  "wb.expected.unit-cost": "el costo unitario en reales",
  "wb.expected.quantity-whole-positive": "un número entero mayor que cero",
  "wb.expected.margin-percent": "un porcentaje entre 0 y 100 (o fracción entre 0 y 1)",
  "wb.expected.markup-fraction": "una fracción entre 0 y 1, por ejemplo 0,5 para 50%",
  "wb.expected.ncm-and-unit-cost-columns": "una columna de NCM y una de costo unitario",
  "wb.expected.uf-column-or-fallback": "una columna de UF o una UF de respaldo",
  "wb.issues.label": "Problemas encontrados en la planilla",
  "wb.issues.sheetLabel": "Avisos de la hoja {sheet}",
  "wb.issues.workbookNotes": "{count} avisos sobre el archivo en conjunto.",
  "calc.error.workbook.title": "No se pudo leer la planilla",
  "calc.error.workbook.body":
    "No se guardó nada y no empezó ningún cálculo. Corrija lo indicado y envíelo de nuevo.",
  "calc.error.howToFix": "Cómo resolverlo",
  "calc.error.chooseAnother": "Enviar otro archivo",
  "calc.error.supportLabel": "Código para soporte",
  "calc.error.supportHint":
    "Si necesita ayuda, envíe este código a soporte: identifica este intento.",
  "wb.issue.INVALID_WORKBOOK.steps":
    "Abra el archivo en Excel. Si no abre, pida una copia nueva a quien lo envió.\nUse Archivo → Guardar como → Libro de Excel (.xlsx), o exporte la hoja como .csv.\nEnvíe el archivo guardado.",
  "wb.issue.ENCRYPTED_WORKBOOK.steps":
    "Abra el archivo en Excel con la contraseña.\nEn Archivo → Información → Proteger libro, quite la contraseña.\nGuarde y envíelo de nuevo.",
  "wb.issue.LEGACY_XLS.steps":
    "Abra el archivo .xls en Excel.\nUse Archivo → Guardar como → Libro de Excel (.xlsx).\nEnvíe el archivo .xlsx.",
  "wb.issue.HTML_AS_XLS.steps":
    "Este archivo viene de un sistema web: tiene nombre de planilla, pero por dentro es una página.\nÁbralo en Excel y use Archivo → Guardar como → Libro de Excel (.xlsx).\nEnvíe el archivo guardado.",
  "wb.issue.ZIP_NO_WORKBOOK.steps":
    "Descomprima el .zip en su computadora.\nEnvíe el propio archivo .xlsx que estaba dentro.",
  "wb.issue.FILE_TOO_LARGE.title": "El archivo es demasiado grande para leerlo",
  "wb.issue.FILE_TOO_LARGE.hint":
    "El límite es {expected}. Elimine hojas o filas que no necesite calcular y envíelo de nuevo.",
  "wb.issue.INVALID_WORKBOOK.title": "El archivo está dañado o no es una planilla",
  "wb.issue.INVALID_WORKBOOK.hint":
    "Ábralo en Excel, guárdelo de nuevo como .xlsx (o exporte la hoja como .csv) y envíelo otra vez.",
  "wb.issue.ENCRYPTED_WORKBOOK.title": "La hoja está protegida con contraseña (cifrada)",
  "wb.issue.ENCRYPTED_WORKBOOK.hint":
    "Ábrala en Excel, quite la contraseña (Archivo > Información > Proteger libro), guárdela y envíela de nuevo.",
  "wb.issue.LEGACY_XLS.title": "Este es un archivo antiguo de Excel 97-2003 (.xls)",
  "wb.issue.LEGACY_XLS.hint":
    "Ábralo en Excel, guárdelo de nuevo como .xlsx (o exporte la hoja como .csv) y envíelo otra vez.",
  "wb.issue.TOO_MANY_SHEETS.title": "El archivo tiene demasiadas hojas",
  "wb.issue.TOO_MANY_SHEETS.hint":
    "Deje como máximo {expected} hojas (elimine, no solo oculte) y envíelo de nuevo.",
  "wb.issue.TOO_MANY_COLUMNS.title": "La hoja tiene demasiadas columnas ({found})",
  "wb.issue.TOO_MANY_COLUMNS.hint":
    "Cada hoja puede tener hasta {expected} columnas. Elimine columnas vacías o auxiliares y envíela de nuevo.",
  "wb.issue.TOO_MANY_ROWS.title": "La hoja supera el límite de 5.000 filas de productos",
  "wb.issue.TOO_MANY_ROWS.hint":
    "Cada hoja puede tener hasta 5.000 filas de productos, más el encabezado. Divida la hoja en partes más pequeñas y envíe cada una por separado.",
  "wb.issue.WORKSHEET_NOT_FOUND.title": "La hoja elegida no existe en el archivo",
  "wb.issue.WORKSHEET_NOT_FOUND.hint": "Elija una hoja de la lista e inténtelo de nuevo.",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.title": "La fila de encabezado está fuera de la hoja",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.hint": "Elija una fila de encabezado entre 1 y {expected}.",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.title": "Una columna elegida no existe en la hoja",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.hint": "Elija columnas hasta la {expected}.",
  "wb.issue.NO_DATA_ROWS.title": "No hay filas de datos debajo del encabezado",
  "wb.issue.NO_DATA_ROWS.hint":
    "Compruebe que la fila de encabezado sea la de los nombres de columna y que haya productos debajo.",
  "wb.issue.TOO_MANY_DATA_ROWS.title": "Más de 5.000 filas para calcular ({found})",
  "wb.issue.TOO_MANY_DATA_ROWS.hint":
    "Divida la hoja en partes más pequeñas y envíe cada una por separado.",
  "wb.issue.SHEET_NOT_CONVERTIBLE.title": "Esta hoja no se puede calcular",
  "wb.issue.SHEET_NOT_CONVERTIBLE.hint":
    "Una hoja calculable tiene una fila por producto, con NCM y costo unitario.",
  "wb.issue.ROWS_SKIPPED.title": "Se omitieron {count} filas sin datos de producto",
  "wb.issue.ROWS_SKIPPED.hint":
    "Las filas sin NCM, SKU, descripción ni identificador se tratan como filas en blanco o de total.",
  "wb.issue.INVALID_CSV.title": "No se pudo leer el archivo CSV",
  "wb.issue.INVALID_CSV.hint":
    "Revise las comillas y los separadores, o expórtelo de nuevo desde Excel como CSV.",
  "wb.issue.CACHED_ERROR_VALUE.title": "Excel guardó el error {error} en esta columna",
  "wb.issue.CACHED_ERROR_VALUE.hint":
    "Suele ocurrir cuando la hoja se copió fuera del libro original y las fórmulas perdieron su origen. Envíe el libro completo, o copie las celdas y péguelas como valores (Pegado especial → Valores) y envíelo de nuevo.",
  "wb.issue.FORMULA_NOT_CACHED.title": "Fórmula guardada sin resultado",
  "wb.issue.FORMULA_NOT_CACHED.hint":
    "Abra el archivo en Excel, deje que recalcule, guárdelo y envíelo de nuevo.",
  "wb.issue.FORMULA_REVIEW_REQUIRED.title": "El valor viene de una fórmula",
  "wb.issue.FORMULA_REVIEW_REQUIRED.hint":
    "Marque “Usar el valor que Excel guardó en las fórmulas” para calcular con lo que Excel mostraba.",
  "wb.issue.COLUMN_REQUIRED.title": "Falta una columna obligatoria",
  "wb.issue.COLUMN_REQUIRED.hint": "Elija la columna correspondiente en la lista de campos.",
  "wb.field.ncm": "NCM",
  "wb.field.custo": "costo unitario",
  "wb.field.origem_mercadoria": "origen de la mercancía",
  "wb.field.marca": "marca",
  "wb.field.familia": "familia",
  "wb.field.ean": "EAN",
  "wb.field.peso": "peso",
  "wb.issue.COLUMN_NOT_DETECTED.title": "No encontramos la columna de {field}",
  "wb.issue.COLUMN_NOT_DETECTED.hint":
    "Elija la columna en la lista de campos. Si la planilla no tiene esa columna, añádala (por ejemplo, NCM de 8 dígitos por producto) y envíela de nuevo.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.title": "Confirme esta columna",
  "wb.issue.COLUMN_LOW_CONFIDENCE.hint":
    "La asociamos por un nombre parecido. Revísela en la vista previa o elija otra columna.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.title": "Confirme la columna: {field}",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.hint":
    "Otras columnas también pueden alimentar este campo: {found}. Revise en la vista previa cuál es la correcta y elíjala si no es esta.",
  "wb.issue.COLUMN_DUPLICATE.title": "Una columna no puede alimentar dos campos",
  "wb.issue.COLUMN_DUPLICATE.hint": "Elija columnas diferentes para cada campo.",
  "wb.issue.ROUTE_REQUIRED.title": "La ruta de esta fila está incompleta",
  "wb.issue.ROUTE_REQUIRED.hint":
    "Complete la UF en la hoja, elija las columnas de UF o declare una ruta fija.",
  "wb.issue.ROUTE_COLUMN_REQUIRED.title": "Elija la columna de UF o una UF de respaldo",
  "wb.issue.ROUTE_COLUMN_REQUIRED.hint":
    "Con ruta por fila, cada extremo necesita una columna o una UF de respaldo.",
  "wb.issue.ROUTE_OVERRIDDEN.title": "{count} filas tenían otra UF; se usó la ruta fija",
  "wb.issue.ROUTE_OVERRIDDEN.hint":
    "La ruta fija vale para todas las filas. Use ruta por fila si cada una tiene la suya.",
  "wb.issue.MISSING_VALUE.title": "Valor ausente",
  "wb.issue.MISSING_VALUE.hint":
    "No se completa ningún valor por defecto. Los campos opcionales vacíos siguen señalados para revisión; si hay un error en una celda obligatoria, corrija la planilla y vuelva a enviarla antes de calcular esta fila.",
  "wb.issue.INVALID_NCM.title": "El NCM debe ser un único código de 8 dígitos",
  "wb.issue.INVALID_NCM.hint":
    "Corrija el NCM en la hoja (un código por producto, por ejemplo 1905.90.20) y envíela de nuevo.",
  "wb.issue.INVALID_CEST.title": "CEST inválido",
  "wb.issue.INVALID_CEST.hint":
    "Use un único código como 17.056.02 o déjelo en blanco; la fila se calcula sin CEST.",
  "wb.issue.INVALID_CEST.zero.title": "CEST 0 leído como “sin CEST”",
  "wb.issue.INVALID_CEST.zero.hint":
    "En las planillas BackChannel, 0 indica que el producto no tiene CEST. La fila se calcula sin CEST; si el producto tiene ST, complete el código de 7 dígitos.",
  "wb.issue.INVALID_CEST.placeholder.title": "CEST pendiente en la planilla ({found})",
  "wb.issue.INVALID_CEST.placeholder.hint":
    "La celda dice que el CEST aún no se ha definido. La fila se calcula sin CEST; complete el código cuando esté validado.",
  "wb.issue.INVALID_CEST.several.title": "Más de un CEST en la misma celda",
  "wb.issue.INVALID_CEST.several.hint":
    "Deje un único CEST por producto. La fila se calcula sin CEST hasta entonces.",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.title": "Origen de la mercancía no leído",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.hint":
    "Use 0 a 8, nacional, importada o extranjera, o déjelo en blanco. La fila se calcula sin origen.",
  "wb.issue.INVALID_UF.title": "UF inválida",
  "wb.issue.INVALID_UF.hint": "Use la sigla de 2 letras, por ejemplo SP.",
  "wb.issue.INVALID_MONEY.title": "Valor en reales inválido",
  "wb.issue.INVALID_MONEY.hint":
    "Use un número positivo con hasta 2 decimales, por ejemplo 1.234,56.",
  "wb.issue.ZERO_AMOUNT.title": "El costo unitario es cero",
  "wb.issue.ZERO_AMOUNT.hint":
    "La fila se calcula con costo cero. Si falta el precio, complételo en la hoja y envíela de nuevo.",
  "wb.issue.AMOUNT_ROUNDED.title":
    "{count} valores tenían más de 2 decimales y se redondearon a centavos",
  "wb.issue.AMOUNT_ROUNDED.hint": "El archivo original se conserva con el valor exacto.",
  "wb.issue.INVALID_QUANTITY.title": "La cantidad debe ser un número entero mayor que cero",
  "wb.issue.INVALID_QUANTITY.hint":
    "Corrija la cantidad en la hoja. Si queda en blanco, la fila se calcula por unidad.",
  "wb.issue.INVALID_RATE.title": "No entendimos el margen o el markup",
  "wb.issue.INVALID_RATE.hint": "Use un porcentaje entre 0 y 100. Se ignoró el valor en esta fila.",
  "wb.issue.INVALID_EXPECTED_AMOUNT.title": "El valor de comparación no es válido",
  "wb.issue.INVALID_EXPECTED_AMOUNT.hint":
    "Use un valor por unidad, sin signo negativo, con hasta 2 decimales, o desmarque la columna de comparación.",
  "wb.issue.DUPLICATE_ITEM_ID.title": "Identificador repetido",
  "wb.issue.DUPLICATE_ITEM_ID.hint": "Cada fila necesita un identificador distinto.",
  "wb.issue.INVALID_ITEM.title": "No se pudo leer la fila",
  "wb.issue.INVALID_ITEM.hint": "Revise los valores de esta fila en la hoja.",
  "wb.route.title": "Ruta del archivo",
  "wb.route.help":
    "Indique de dónde a dónde van las mercaderías. La misma ruta vale para todas las filas, o cada fila informa la suya.",
  "wb.route.fixed": "Una ruta para todo el archivo",
  "wb.route.fixedHelp": "Elija la UF de origen y la de destino.",
  "wb.route.dynamic": "Cada fila tiene su ruta",
  "wb.route.dynamicHelp": "Lea el origen y el destino de las columnas de UF.",
  "wb.route.origin": "UF de origen",
  "wb.route.destination": "UF de destino",
  "wb.route.choose": "Elija la UF",
  "wb.route.originColumn": "Columna de la UF de origen",
  "wb.route.destinationColumn": "Columna de la UF de destino",
  "wb.route.originFallback": "Origen cuando la fila no lo informa",
  "wb.route.destinationFallback": "Destino cuando la fila no lo informa",
  "wb.route.noFallback": "Ninguna (bloquear la fila)",
  "wb.route.requiredFixed": "Elija la UF de origen y la de destino para continuar.",
  "wb.route.requiredDynamic":
    "Para cada extremo de la ruta, elija una columna de UF o una UF de respaldo.",
  "wb.route.detected": "Sugerencia a partir de {source}.",
  "wb.route.source.COLUMN": "las columnas de UF",
  "wb.route.source.SHEET_NAME": "el nombre de la hoja",
  "wb.route.source.HEADER_BLOCK": "las celdas sobre la tabla",
  "wb.route.source.PARAMETER_SHEET": "una hoja de parámetros",
  "wb.route.source.NONE": "No identificamos la ruta en esta hoja. Elíjala arriba.",
  "wb.route.perRow": "ruta por fila",
  "wb.picker.title": "Hojas de este archivo",
  "wb.picker.help":
    "Elija las listas de productos a convertir. Cada hoja elegida se convierte en un cálculo aparte.",
  "wb.picker.select": "Convertir la hoja {sheet}",
  "wb.picker.kind.SCENARIO": "Lista de productos",
  "wb.picker.kind.CLIENT_SIMULATION": "Simulación de cliente",
  "wb.picker.kind.PARAMETERS": "Parámetros",
  "wb.picker.kind.AUXILIARY": "Hoja de apoyo",
  "wb.picker.kind.UNKNOWN": "No reconocida",
  "wb.picker.hidden": "oculta",
  "wb.picker.confidence": "{percent}% de certeza",
  "wb.picker.confidenceHelp": "Qué tan seguros estamos de que es este tipo de hoja.",
  "wb.picker.errors": "{count} por corregir",
  "wb.picker.warnings": "{count} por revisar",
  "wb.picker.incomplete": "falta completar",
  "wb.picker.noScenarios":
    "Ninguna hoja parece una lista de productos con NCM y costo. Abra una de las hojas de abajo y elija las columnas.",
  "wb.picker.others": "Otras hojas ({count})",
  "wb.picker.othersHelp":
    "Las simulaciones de cliente, los parámetros y las hojas de apoyo no tienen NCM y costo por producto. Aun así puede abrirlas y elegir columnas.",
  "wb.picker.parameters": "Premisas leídas de las hojas de parámetros",
  "wb.picker.parametersHelp":
    "Solo para revisión. Estos valores nunca se convierten en regla fiscal: las reglas vienen siempre del conjunto de reglas publicado.",
  "wb.picker.notConvertible.SCENARIO":
    "Esta hoja necesita una columna de NCM y una de costo unitario.",
  "wb.picker.notConvertible.CLIENT_SIMULATION":
    "Es una simulación comercial de cliente: no tiene NCM por producto, así que no se pueden calcular impuestos aquí.",
  "wb.picker.notConvertible.PARAMETERS":
    "Es una hoja de parámetros. Las premisas se muestran para revisión, pero no se convierten en regla fiscal.",
  "wb.picker.notConvertible.AUXILIARY":
    "Es una hoja de apoyo (auditoría, revisión o resumen), sin lista de productos.",
  "wb.picker.notConvertible.UNKNOWN":
    "No reconocemos esta hoja como una lista de productos. Elija las columnas manualmente si tiene NCM y costo.",
  "wb.picker.convertMany": "Convertir {count} hojas",
  "wb.picker.noneSelected": "Marque al menos una hoja para convertir.",
  "wb.picker.fixSelected":
    "Completa costo, ruta y objetivo del cálculo en las hojas marcadas para continuar.",
  "wb.map.confidence": "{percent}% de acierto",
  "wb.map.confidenceHelp": "Cuánto coinciden el nombre de la columna y sus valores con este campo.",
  "wb.map.manual": "elegida por usted",
  "wb.map.alternatives": "Otras candidatas: {columns}",
  "wb.map.premises": "Premisas sobre la tabla ({count})",
  "wb.map.premisesHelp":
    "Valores que la hoja trae sobre la tabla, como margen objetivo, take rate o UF de destino. Solo para revisión.",
  "wb.map.reference": "Tasas citadas en el archivo (solo referencia)",
  "wb.map.referenceHelp":
    "CFOP, MVA, IPI, ICMS, PIS/COFINS y flete que informa la hoja. Aparecen en la fila para revisión y nunca se usan como regla o alícuota.",
  "wb.coverage.title": "Cobertura de reglas",
  "wb.coverage.hint":
    "Qué rutas y NCM del archivo puede calcular el conjunto de reglas publicado. Una ruta sin regla nunca se calcula con un valor por defecto.",
  "wb.coverage.summary": "{covered} cubiertas · {missing} sin regla · {stale} desactualizadas",
  "wb.coverage.unidentifiedSummary.one": "{count} fila sin identificación fiscal",
  "wb.coverage.unidentifiedSummary.other": "{count} filas sin identificación fiscal",
  "wb.coverage.loading": "Verificando las reglas…",
  "wb.coverage.needVersion": "Elija una versión publicada para ver la cobertura.",
  "wb.coverage.onlyGaps": "Solo lo que falta",
  "wb.coverage.noRuleset": "No hay conjunto de reglas publicado: todas las rutas están sin regla.",
  "wb.coverage.allCovered": "Las {count} combinaciones de ruta y NCM tienen regla publicada.",
  "wb.coverage.gapNote": "{count} filas dependen de rutas sin regla válida y quedarán en revisión.",
  "wb.coverage.runNote":
    "{count} filas no tienen regla publicada válida. Se marcarán para revisión, sin ningún valor inventado.",
  "wb.coverage.unidentified":
    "{count} filas sin NCM o ruta no se pudieron verificar. Corríjalas en la hoja.",
  "wb.coverage.unidentifiedAutomatic":
    "La hoja está guardada. Al calcular, el sistema intentará identificar los productos sin NCM y verificar las reglas disponibles. Lo que no se resuelva quedará pendiente en el detalle.",
  "wb.coverage.column.route": "Ruta",
  "wb.coverage.column.ncm": "NCM",
  "wb.coverage.column.cest": "CEST",
  "wb.coverage.column.status": "Situación",
  "wb.coverage.column.reason": "Motivo",
  "wb.coverage.column.rows": "Filas",
  "wb.coverage.status.COVERED": "Cubierta",
  "wb.coverage.status.MISSING": "Sin regla",
  "wb.coverage.status.STALE": "Desactualizada",
  "wb.coverage.reason.RULE_FOUND": "Hay regla publicada vigente.",
  "wb.coverage.reason.NO_RULE_FOR_ROUTE": "Hay reglas para este NCM, pero no para esta ruta.",
  "wb.coverage.reason.NO_RULE_FOR_NCM": "Ninguna regla publicada para este NCM.",
  "wb.coverage.reason.RULE_EXPIRED": "La regla de esta ruta terminó antes de la fecha del cálculo.",
  "wb.coverage.reason.RULE_NOT_YET_EFFECTIVE":
    "La regla de esta ruta solo rige después de la fecha del cálculo.",
  "wb.coverage.reason.AMBIGUOUS_RULES": "Más de una regla sirve y falta el CEST para elegir.",
  "wb.coverage.reason.RULESET_EMPTY": "El conjunto de reglas no tiene reglas fiscales.",
  "wb.coverage.status.NEEDS_REVIEW": "Revisar",
  "wb.coverage.reason.RULE_FOUND_ANY_ORIGIN":
    "Cubierto por una regla válida para cualquier origen (destino {destination}).",
  "wb.coverage.reason.RULE_FOUND_ANY_ROUTE":
    "Cubierto por una regla válida para cualquier origen y destino.",
  "wb.coverage.reason.ICMS_NOT_PUBLISHED": "Solo IPI (TIPI): ICMS no publicado para esta ruta.",
  "wb.coverage.reason.DESTINATION_ST_DERIVED":
    "Derivada de la regla de ST de {destination} (origen {origin}): misma MVA y alícuota interna, alícuota interestatal {rate} de la Res. SF 22/89.",
  "wb.coverage.leg.SALE": "Venta {origin}→{destination}: {reason}",
  "wb.coverage.reason.GENERAL_RULE_NO_ST":
    "Regla general (sin ST): alícuota interestatal de la Res. SF 22/89 (o interna verificada) y NCM sin ST comprobado.",
  "wb.coverage.reason.INTERSTATE_RATE_MISMATCH":
    "La regla vigente declara ICMS interestatal de {stated}, pero la Res. SF 22/89 fija {expected} para {origin} → {destination}. Revise la regla.",
  "wb.coverage.viewRule": "Ver regla",
  "wb.coverage.anyOriginTag": "Regla para cualquier origen",
  "wb.coverage.summaryReview": " · {count} por revisar",
  "wb.coverage.reviewNote":
    "{count} filas usan una regla que necesita revisión: su alícuota interestatal declarada no coincide con la ruta.",
  "wb.coverage.showAll": "Mostrar {count} más",
  "wb.row.reference": "Referencia de la hoja",
  "wb.run.converting": "Convirtiendo la hoja {sheet}…",
  "wb.run.template": "Descargar CSV normalizado",
  "wb.run.backToSheets": "Volver a las hojas",
  "wb.run.notes": "Avisos de esta hoja ({count})",
  "wb.run.notesLabel": "Avisos de la conversión",
  "wb.run.tabs": "Hojas convertidas",
  "wb.runAll.label": "Calcular todas las hojas",
  "wb.runAll.title": "{count} hojas en este archivo",
  "wb.runAll.tally": "{done} calculadas · {running} en cálculo · {waiting} en espera",
  "wb.runAll.action": "Calcular todas ({count})",
  "wb.rows.one": "{count} fila",
  "wb.rows.other": "{count} filas",
  "wb.notes.one": "⚠ {count} aviso",
  "wb.notes.other": "⚠ {count} avisos",
  // -- Calculator research ("Buscar com agente?") — begin --
  "research.announce.CANCELLED": "Búsqueda cancelada: {route}, NCM {ncm}.",
  "research.announce.FAILED": "La búsqueda falló: {route}, NCM {ncm}.",
  "research.announce.FOUND": "Búsqueda concluida: {route}, NCM {ncm}. Resultado encontrado.",
  "research.announce.NEEDS_REVIEW":
    "Búsqueda concluida: {route}, NCM {ncm}. Evidencia pendiente de revisión.",
  "research.announce.NOT_FOUND": "Búsqueda concluida: {route}, NCM {ncm}. No se encontró nada.",
  "research.announce.QUEUED": "Búsqueda en cola: {route}, NCM {ncm}.",
  "research.announce.RUNNING": "Búsqueda en curso: {route}, NCM {ncm}.",
  "research.ask": "¿Buscar con el agente?",
  "research.auto.deferred.one":
    "{count} combinación quedó fuera del límite por planilla ({gaps} combinaciones, {cost}). Use «¿Buscar con el agente?» para ella.",
  "research.auto.deferred.other":
    "{count} combinaciones quedaron fuera del límite por planilla ({gaps} combinaciones, {cost}). Use «¿Buscar con el agente?» para ellas.",
  "research.auto.error": "No se pudo iniciar la búsqueda automática.",
  "research.auto.label": "Buscar automáticamente lo que falte",
  "research.auto.launching": "Iniciando la búsqueda automática de las combinaciones sin regla…",
  "research.auto.note":
    "Tras comprobar la cobertura, las combinaciones que faltan van a la búsqueda web con IA (aquí no se usa IOB). Límite por planilla: {gaps} combinaciones y hasta {cost} estimados; el resto queda con «¿Buscar con el agente?». El resultado es evidencia para revisión: no publica reglas.",
  "research.banner.alsoPending": "Todavía hay búsquedas en curso para este cálculo.",
  "research.banner.pending.body":
    "El resultado de este cálculo sigue igual hasta que termine la búsqueda.",
  "research.banner.pending.title.one": "{count} búsqueda en curso",
  "research.banner.pending.title.other": "{count} búsquedas en curso",
  "research.banner.recalculable.body.one":
    "{count} búsqueda terminó con datos utilizables. Recalcular crea un nuevo cálculo y muestra la diferencia; este queda como está.",
  "research.banner.recalculable.body.other":
    "{count} búsquedas terminaron con datos utilizables. Recalcular crea un nuevo cálculo y muestra la diferencia; este queda como está.",
  "research.banner.recalculable.title": "Nueva búsqueda concluida; resultado anterior preservado.",
  "research.banner.since": "Desde {when}.",
  "research.banner.upToDate.title": "El resultado ya considera lo que encontró la búsqueda.",
  "research.banner.waiting.body":
    "Consulte cada solicitud para distinguir datos que deben corregirse de evidencias que deben revisarse. Los valores y la versión de reglas del cálculo guardado se conservan.",
  "research.banner.waiting.title": "Investigación con pendientes; consulte los detalles",
  "research.bar.allLabel": "Todas las combinaciones sin regla",
  "research.bar.combinations.one": "{count} combinación",
  "research.bar.combinations.other": "{count} combinaciones",
  "research.bar.covered": "Ya buscada",
  "research.bar.disconnected":
    "Sin conexión: se muestra el último estado confirmado de las búsquedas.",
  "research.bar.follow": "Búsquedas",
  "research.bar.groups": "Combinaciones sin regla por ruta",
  "research.bar.hint":
    "El agente busca en la web. El resultado es evidencia para revisión: no publica ni cambia reglas.",
  "research.bar.running.one": "{count} buscando",
  "research.bar.running.other": "{count} buscando",
  "research.bar.title.one": "{count} combinación sin regla se puede buscar",
  "research.bar.title.other": "{count} combinaciones sin regla se pueden buscar",
  "research.blocked.DAILY_GROUNDED_CAP":
    "Se alcanzó el límite diario de consultas web. El pedido espera.",
  "research.blocked.FEATURE_DISABLED":
    "La búsqueda con el agente está desactivada por el administrador. El pedido espera.",
  "research.blocked.IOB_PAUSED": "El agente IOB está en pausa. El pedido espera.",
  "research.blocked.LANES_PAUSED":
    "Las búsquedas están en pausa. El pedido empieza cuando se reanuden.",
  "research.blocked.MONTHLY_BUDGET":
    "Se alcanzó el presupuesto mensual de búsqueda. El pedido espera.",
  "research.blocked.WEB_PAUSED": "La búsqueda web está en pausa. El pedido espera.",
  "research.boundary":
    "El agente solo trae evidencia. No se publica ni se calcula nada: un revisor debe aprobar antes de que sea regla.",
  "research.cancel": "Cancelar búsqueda",
  "research.cancel.reason": "Cancelado por el operador en la calculadora.",
  "research.cell.needsCest": "Indique el CEST",
  "research.cell.open": "Ver búsqueda",
  "research.column": "Búsqueda",
  "research.completed": "Concluida el {when}",
  "research.confirm.back": "Volver",
  "research.confirm.cancel.action": "Sí, cancelar",
  "research.confirm.cancel.body": "¿Cancelar esta búsqueda? Lo que ya se gastó no se recupera.",
  "research.confirm.cancel.shared":
    "Esta búsqueda se comparte con {count} orígenes. Cancelar afecta a todos.",
  "research.confirm.cancel.title": "Cancelar la búsqueda",
  "research.confirm.existing.one":
    "{count} combinación ya tiene una búsqueda en curso o reciente y se aprovechará, sin costo nuevo.",
  "research.confirm.existing.other":
    "{count} combinaciones ya tienen una búsqueda en curso o reciente y se aprovecharán, sin costo nuevo.",
  "research.confirm.follow": "Seguir búsqueda existente",
  "research.confirm.launching": "Iniciando…",
  "research.confirm.lead": "{scope} — {combinations}, {rows}.",
  "research.confirm.more.one": "y {count} más",
  "research.confirm.more.other": "y {count} más",
  "research.confirm.newSearches": "Búsquedas nuevas",
  "research.confirm.partialEstimate":
    "La estimación considera las primeras {count} combinaciones; las demás siguen en lotes.",
  "research.confirm.retry.action": "Repetir búsqueda",
  "research.confirm.retry.currentBudget":
    "Crea una nueva investigación con el presupuesto individual actual de {cost}. Se conservan el historial y las evidencias anteriores; las llamadas en curso pueden superar la reserva estimada.",
  "research.confirm.retry.body": "Repetir la búsqueda cuesta hasta {cost} (estimación).",
  "research.confirm.retry.title": "Repetir la búsqueda",
  "research.confirm.start": "Buscar",
  "research.cost.actual": "Gasto hasta ahora",
  "research.cost.estimated": "Presupuesto asignado a la investigación",
  "research.created": "Creada el {when}",
  "research.created.body":
    "El cálculo anterior se conservó. Revise la diferencia abajo antes de adoptar el nuevo como resultado.",
  "research.created.dismiss": "Cerrar",
  "research.created.open": "Abrir nuevo cálculo",
  "research.created.title": "Nuevo cálculo creado (revisión {number})",
  "research.deferral.AUTO_CAP_COST": "Aplazada: límite de costo de la planilla",
  "research.deferral.AUTO_CAP_GAPS": "Aplazada: límite de combinaciones de la planilla",
  "research.deferral.UPLOAD_NOT_AUTO": "Aplazada: la planilla no es automática",
  "research.diff.change.AMOUNT": "Valor",
  "research.diff.change.COVERAGE": "Cobertura",
  "research.diff.change.FACTS_LEVEL": "Nivel de los hechos",
  "research.diff.change.RULE": "Regla",
  "research.diff.change.STATUS": "Estado",
  "research.diff.col.changes": "Cambios",
  "research.diff.col.coverage": "Cobertura",
  "research.diff.col.item": "Ítem",
  "research.diff.col.landed": "Costo unitario",
  "research.diff.col.tax": "Tributos",
  "research.diff.coverage.AMBIGUOUS": "Ambigua",
  "research.diff.coverage.EXACT": "Regla exacta",
  "research.diff.coverage.MISSING": "Sin regla",
  "research.diff.coverage.NCM_UNIQUE": "Regla por NCM",
  "research.diff.deltaNote": "Suma solo los ítems que tenían valor antes y después.",
  "research.diff.factsMode": "Hechos: {mode}",
  "research.diff.factsNotApplied": "El valor aún no cambió: los hechos están en modo sombra.",
  "research.diff.noItems": "Ningún ítem cambió.",
  "research.diff.summary.amount": "Valores",
  "research.diff.summary.changed": "Ítems modificados",
  "research.diff.summary.coverage": "Cobertura",
  "research.diff.summary.delta": "Variación del costo unitario",
  "research.diff.summary.unverified": "Solo evidencia no verificada",
  "research.diff.table": "Ítems que cambiaron",
  "research.diff.title": "Diferencia de la revisión {number}",
  "research.diff.unavailable": "No disponible → calculado",
  "research.diff.unverifiedOnly": "Solo evidencia no verificada: no cuenta como cobertura.",
  "research.disconnected":
    "Sin conexión con el servidor. Se muestra el último estado confirmado, a las {when}. Las búsquedas siguen en el servidor.",
  "research.empty.body":
    "Cuando use «¿Buscar con el agente?» en una combinación sin regla, aparecerá aquí.",
  "research.empty.filtered.body": "Cambie el estado, el modo o el origen.",
  "research.empty.filtered.title": "Ninguna búsqueda con esos filtros",
  "research.empty.title": "Todavía no hay búsquedas",
  "research.eta": "Tiempo estimado",
  "research.etaValue": "≈ {minutes} min",
  "research.event.FOUND_IN_BASE": "Encontrado en la base: no hizo falta ningún agente",
  "research.event.IOB_LOOKUP_DONE": "Consulta IOB concluida",
  "research.event.IOB_LOOKUP_STARTED": "Consulta IOB iniciada",
  "research.event.LANES_PAUSED": "Búsquedas en pausa",
  "research.event.REQUEST_CANCELLED": "Pedido cancelado",
  "research.event.REQUEST_FAILED": "El pedido falló",
  "research.event.REQUEST_FOUND": "Resultado encontrado",
  "research.event.REQUEST_NEEDS_REVIEW": "Evidencia pendiente de revisión",
  "research.event.REQUEST_NOT_FOUND": "No se encontró nada",
  "research.event.REQUEST_QUEUED": "Pedido en cola",
  "research.event.RESOLVING_GAP": "Reevaluando la brecha",
  "research.event.WEB_SWEEP_DONE": "Búsqueda web concluida",
  "research.event.WEB_SWEEP_FAILED": "La búsqueda web falló",
  "research.event.WEB_SWEEP_STARTED": "Búsqueda web iniciada",
  "research.events.empty": "Todavía no hay eventos.",
  "research.events.title": "Línea de tiempo",
  "research.failed.detail": "Intentos: {attempts}.",
  "research.failed.final": "No se puede repetir automáticamente.",
  "research.failed.retryable": "Se puede repetir.",
  "research.family.ICMS": "ICMS",
  "research.family.ICMS_ST": "ICMS-ST",
  "research.filters.all": "Todos",
  "research.filters.label": "Filtros de las búsquedas",
  "research.filters.mode": "Modo",
  "research.filters.origin": "Origen",
  "research.filters.status": "Estado",
  "research.filters.status.active": "En curso",
  "research.filters.status.all": "Todas",
  "research.filters.status.cancelled": "Canceladas",
  "research.filters.status.failed": "Con fallo",
  "research.filters.status.found": "Encontradas",
  "research.filters.status.notFound": "No encontradas",
  "research.filters.status.review": "Pendientes de revisión",
  "research.hideDetail": "Ocultar detalles",
  "research.jobs.activeSr.one": "búsqueda en curso",
  "research.jobs.activeSr.other": "búsquedas en curso",
  "research.jobs.button": "Búsquedas",
  "research.jobs.closeKeeps": "Cerrar no cancela ninguna búsqueda.",
  "research.jobs.live": "{count} en curso",
  "research.jobs.openPage": "Abrir la página de búsquedas",
  "research.jobs.subtitle": "Lo que el agente está buscando para las combinaciones sin regla.",
  "research.jobs.title": "Búsquedas del agente",
  "research.lane.eta.estimate": "Estimación hecha al solicitar la búsqueda",
  "research.lane.eta.hours": "≈ {value} h",
  "research.lane.eta.minutes": "≈ {value} min",
  "research.lane.eta.rate": "Medido con las unidades ya terminadas",
  "research.lane.eta.seconds": "≈ {value} s",
  "research.lane.iob": "IOB",
  "research.lane.openIob": "Ver en el Agente IOB",
  "research.lane.openWeb": "Ver en Búsqueda web",
  "research.lane.status.DONE": "concluida",
  "research.lane.status.FAILED": "falló",
  "research.lane.status.NOT_PLANNED": "no planificada",
  "research.lane.status.QUEUED": "en cola",
  "research.lane.status.RUNNING": "consultando",
  "research.lane.status.SKIPPED": "no usada",
  "research.lane.units": "{done} de {total} unidades",
  "research.lane.web": "Web",
  "research.lanes.label": "Fuentes consultadas",
  "research.lanes.unavailable.AVAILABLE": "La fuente {lane} está disponible.",
  "research.lanes.unavailable.BUDGET":
    "Se alcanzó el presupuesto de la fuente {lane}. La búsqueda espera.",
  "research.lanes.unavailable.DAILY_CAP":
    "Se alcanzó el límite diario de la fuente {lane}. La búsqueda espera.",
  "research.lanes.unavailable.DISABLED": "La fuente {lane} está desactivada.",
  "research.lanes.unavailable.PAUSED":
    "La fuente {lane} está en pausa. La búsqueda espera hasta que se reanude.",
  "research.launched.announce.one": "Búsqueda iniciada para {count} combinación.",
  "research.launched.announce.other": "Búsqueda iniciada para {count} combinaciones.",
  "research.launched.follow": "Seguir",
  "research.launched.shared":
    "Parte ya tenía una búsqueda en curso o reciente y se aprovechó, sin costo nuevo.",
  "research.launched.title.one": "Búsqueda iniciada · {count} combinación",
  "research.launched.title.other": "Búsqueda iniciada · {count} combinaciones",
  "research.mode.ASK": "Manual",
  "research.mode.AUTO": "Automática",
  "research.more": "Mostrando las 100 más recientes.",
  "research.origin.CALCULATION": "Cálculo",
  "research.origin.UPLOAD": "Planilla",
  "research.origin.launched": "inició la búsqueda",
  "research.origins.title": "Usada por",
  "research.page.description":
    "Todas las búsquedas «¿Buscar con el agente?» de la organización, con estado, etapa y costo.",
  "research.page.title": "Búsquedas del agente",
  "research.page.unavailable": "La búsqueda con el agente no está disponible en este entorno.",
  "research.panel.all.one": "Ver la búsqueda",
  "research.panel.all.other": "Ver las {count} búsquedas",
  "research.panel.gaps.one": "{count} combinación de este cálculo todavía no se buscó.",
  "research.panel.gaps.other": "{count} combinaciones de este cálculo todavía no se buscaron.",
  "research.panel.scope": "Este cálculo",
  "research.panel.loadError":
    "No se pudo actualizar el estado de la investigación. El cálculo guardado no cambia. Vuelve a intentarlo.",
  "research.panel.title": "Búsquedas de este cálculo",
  "research.recalculate": "Recalcular",
  "research.recalculating": "Recalculando…",
  "research.reconnect": "Reintentar ahora",
  "research.resolution.applied":
    "Resultado disponible para esta combinación. Recalcule para usarlo en el cálculo.",
  "research.resolution.cancelled": "Búsqueda cancelada. La combinación sigue sin regla.",
  "research.resolution.failed": "La búsqueda no terminó. La combinación sigue sin regla.",
  "research.resolution.needsReview": "Evidencia encontrada — pendiente de revisión.",
  "research.resolution.notApplied":
    "Resultado encontrado, pero el valor aún no cambia: los hechos están en modo sombra.",
  "research.resolution.notFound":
    "No se encontró nada en las fuentes consultadas. La combinación sigue sin regla.",
  "research.resolution.queued": "Esperando su turno en la cola.",
  "research.resolution.running": "Buscando en las fuentes…",
  "research.resolution.unverified":
    "Evidencia de esta investigación no verificada; su revisión sigue pendiente. Esta evidencia, por sí sola, no establece una regla fiscal.",
  "research.resolution.webUnverified":
    "Evidencia encontrada en la web; su verificación sigue pendiente. Esta evidencia, por sí sola, no establece una regla fiscal.",
  "research.retry": "Repetir búsqueda",
  "research.revision.chain": "Revisiones",
  "research.revision.number": "Revisión {number}",
  "research.revision.openLatest": "Abrir revisión {number}",
  "research.revision.original": "Original",
  "research.revision.ownDiff": "Diferencias de la revisión {number}",
  "research.rows.one": "{count} fila",
  "research.rows.other": "{count} filas",
  "research.scope.calculation": "Mostrando solo las búsquedas de este cálculo.",
  "research.scope.clear": "Ver todas",
  "research.scope.upload": "Mostrando solo las búsquedas de esta planilla.",
  "research.shared": "Compartida con {count} orígenes: el resultado vale para todos.",
  "research.showDetail": "Ver detalles",
  "research.status.BLOCKED": "En pausa",
  "research.status.CANCELLED": "Cancelada",
  "research.status.FAILED": "Falló",
  "research.status.FOUND": "Encontrada",
  "research.status.NEEDS_REVIEW": "Pendiente de revisión",
  "research.status.NOT_FOUND": "No encontrada",
  "research.status.QUEUED": "En cola",
  "research.status.RUNNING": "Buscando",
  "research.step.DONE": "Concluida",
  "research.step.IOB": "IOB",
  "research.step.PLANNING": "Plan",
  "research.step.RESOLVING": "Resolución",
  "research.step.WEB": "Web",
  "research.stepState.blocked": "en pausa",
  "research.stepState.current": "en curso",
  "research.stepState.done": "concluida",
  "research.stepState.failed": "falló",
  "research.stepState.pending": "pendiente",
  "research.stepState.skipped": "no usada",
  "research.stepState.stopped": "interrumpida",
  "research.steps.label": "Etapas de la búsqueda",
  "research.summary":
    "{active} en curso · {review} pendientes de revisión · {found} encontradas · {failed} con fallo · gasto {cost}",
  "research.updated": "Actualizada el {when}",
  // -- Repair spreadsheet --
  "repair.title": "Reparar la hoja",
  "repair.intro.one": "Encontramos {count} valor que bloquea filas de esta hoja.",
  "repair.intro.other": "Encontramos {count} valores que bloquean filas de esta hoja.",
  "repair.safe":
    "No se aplica nada sin su confirmación. Un reparo confirmado cambia solo el valor leído, nunca el archivo original, y queda registrado con su nombre, la fecha y el valor anterior.",
  "repair.counter": "{done} de {total} reparos confirmados",
  "repair.acceptSuggestions": "Aceptar sugerencias ({count})",
  "repair.acceptSuggestions.help":
    "Acepta solo lo que no deja duda: NCM del catálogo muy por delante de los demás, cero a la izquierda del NCM, UF muy parecida y columna de costo única. Los valores escritos nunca entran aquí.",
  "repair.undoAll": "Deshacer todos",
  "repair.loading": "Buscando valores que se pueden reparar…",
  "repair.refreshing": "Actualizando las sugerencias…",
  "repair.error": "No se pudo buscar reparos ahora. Puede convertir la hoja sin ellos.",
  "repair.catalogUnchecked":
    "No se pudo consultar el catálogo de NCM: los códigos de abajo se verificaron solo por su formato.",
  "repair.pendingNote.one":
    "{count} reparo sin confirmar: las filas afectadas quedan fuera de la conversión.",
  "repair.pendingNote.other":
    "{count} reparos sin confirmar: las filas afectadas quedan fuera de la conversión.",
  "repair.kind.NCM_PICK": "Más de un NCM en la celda",
  "repair.kind.NCM_LEADING_ZERO": "NCM sin el cero a la izquierda",
  "repair.kind.UF_REPLACE": "UF que no existe",
  "repair.kind.CEST_REPLACE": "CEST que no corresponde al NCM",
  "repair.kind.NCM_REPLACE": "La columna de NCM contiene texto de producto",
  "repair.kind.COST_ALTERNATIVE_COLUMN": "Costo con error de Excel",
  "repair.kind.COST_MANUAL": "Costo con error de Excel, sin otra columna",
  "repair.kindShort.NCM_PICK": "NCM elegido",
  "repair.kindShort.NCM_LEADING_ZERO": "Cero a la izquierda del NCM",
  "repair.kindShort.NCM_REPLACE": "NCM de la tabla oficial",
  "repair.kindShort.UF_REPLACE": "UF reemplazada",
  "repair.kindShort.COST_ALTERNATIVE_COLUMN": "Costo de otra columna",
  "repair.kindShort.COST_MANUAL": "Costo escrito",
  "repair.column": "Columna {column} · {header}",
  "repair.original": "Valor actual",
  "repair.rowsMore": "y {count} más",
  "repair.choose.ncm": "¿Qué NCM vale para estas filas?",
  "repair.choose.uf": "¿Qué UF vale para estas filas?",
  "repair.choose.costManual": "¿Cuál es el costo de estas filas?",
  "repair.choose.cost": "¿De dónde viene el costo?",
  "repair.badge.inCatalog": "en el catálogo",
  "repair.badge.notInCatalog": "fuera del catálogo",
  "repair.badge.unchecked": "no verificado en el catálogo",
  "repair.best": "mejor sugerencia",
  "repair.noDescription": "Sin descripción en el catálogo",
  "repair.uf.other": "Elegir otra UF",
  "repair.uf.pick": "Seleccione una UF",
  "repair.uf.noCandidates": "Ninguna UF se parece a este valor. Elija la correcta.",
  "repair.cost.coverage": "{rows} de {total} filas",
  "repair.cost.partial": "Las filas sin valor en esta columna siguen sin reparo y bloqueadas.",
  "repair.cost.manual": "Escribir un valor",
  "repair.cost.manualLabel": "Costo unitario (R$)",
  "repair.cost.manualHelp":
    "El valor es suyo y queda registrado tal como lo escribió. Use coma o punto, con hasta 2 decimales.",
  "repair.cost.manualError": "Use solo números, con hasta 2 decimales (por ejemplo 12,50).",
  "repair.scope": "Aplicar a",
  "repair.scope.all": "Aplicar a las {count} filas con este valor",
  "repair.scope.first": "Solo la fila {row}",
  "repair.apply": "Aplicar",
  "repair.undo": "Deshacer",
  "repair.confirmed": "Reparo confirmado",
  "repair.willApply.one": "Vale para {count} fila",
  "repair.willApply.other": "Vale para {count} filas",
  "repair.willApply.none": "Ninguna fila tiene valor en esta columna",
  "repair.result.one": "{count} reparo confirmado",
  "repair.result.other": "{count} reparos confirmados",
  "repair.audit.title": "Reparos confirmados",
  "repair.audit.help":
    "Valores que una persona corrigió antes de la conversión. El archivo original no se modificó.",
  "repair.audit.what": "Qué",
  "repair.audit.where": "Dónde",
  "repair.audit.change": "De → A",
  "repair.audit.who": "Quién confirmó",
  "repair.audit.when": "Cuándo",
  "repair.audit.table": "Reparos confirmados en este archivo",
  "repair.recovered.title": "Archivo recuperado: revise los datos",
  "repair.recovered.body":
    "El archivo estaba dañado y se reconstruyó a partir de las partes que aún se podían leer. Revise nombres, valores y cantidad de filas antes de convertir.",
  "repair.recovered.lost": "Hojas que no se pudieron recuperar y no aparecen aquí: {sheets}.",
  "wb.issue.FILE_RECOVERED.title": "El archivo estaba dañado y se recuperó",
  "wb.issue.FILE_RECOVERED.hint":
    "Revise los datos antes de convertir: partes del archivo pueden haberse perdido. Si algo parece incorrecto, ábralo en Excel, guárdelo de nuevo como .xlsx y envíelo otra vez.",
  "wb.issue.FILE_RECOVERED.sheetLost.title": "La hoja “{sheet}” no se pudo recuperar",
  "wb.issue.FILE_RECOVERED.sheetLost.hint":
    "El archivo estaba dañado y esta hoja se perdió. Pida una copia íntegra o exporte la hoja de nuevo desde Excel.",
  "wb.issue.REPAIR_REJECTED.title": "Se rechazó un reparo confirmado: {reason}",
  "wb.issue.REPAIR_REJECTED.many.title":
    "Se rechazaron {count} reparos confirmados; el primero: {reason}",
  "wb.issue.REPAIR_REJECTED.hint":
    "No se importó nada. Vuelva al mapeo, revise los reparos y confirme de nuevo.",
  "wb.repairReject.SHEET_MISMATCH": "el reparo es de otra hoja",
  "wb.repairReject.FIELD_NOT_MAPPED": "la columna del reparo ya no está mapeada a ese campo",
  "wb.repairReject.CELL_MISSING": "la celda no existe en el archivo",
  "wb.repairReject.CELL_CHANGED": "el valor de la celda cambió desde la sugerencia",
  "wb.repairReject.DUPLICATE": "la misma celda se reparó dos veces",
  "wb.repairReject.VALUE_NOT_ALLOWED": "el nuevo valor no está permitido para este tipo de reparo",
  "wb.repairReject.SOURCE_UNUSABLE":
    "la columna de origen no tiene un valor utilizable en esta fila",
  "wb.repairReject.NOT_IN_CATALOG": "el NCM resultante no está en el catálogo",
  // -- Calculator research — end --
  "nav.uploadFailures": "Planillas con error",
  "uploadFailures.title": "Planillas con error",
  "uploadFailures.description":
    "Envíos a la calculadora que fallaron, con lo que vio el operador y el archivo original.",
  "uploadFailures.denied": "Solo los administradores de la plataforma ven las planillas con error.",
  "uploadFailures.filter.search": "Código para soporte",
  "uploadFailures.filter.placeholder": "Pegue el código aquí",
  "uploadFailures.filter.reviewed": "Revisión",
  "uploadFailures.filter.from": "Desde",
  "uploadFailures.filter.to": "Hasta",
  "uploadFailures.filter.operator": "Operador",
  "uploadFailures.filter.operatorPlaceholder": "Correo o id del operador",
  "uploadFailures.filter.errorCode": "Código de error",
  "uploadFailures.filter.anyError": "Todos los errores",
  "uploadFailures.filter.kind": "Contenido del archivo",
  "uploadFailures.filter.anyKind": "Todos los tipos",
  "uploadFailures.filter.stage": "Etapa",
  "uploadFailures.filter.anyStage": "Todas",
  "uploadFailures.filter.range": "Período",
  "uploadFailures.reviewed.all": "Todas",
  "uploadFailures.reviewed.pending": "Pendientes",
  "uploadFailures.reviewed.done": "Revisadas",
  "uploadFailures.stage.INSPECT": "Lectura",
  "uploadFailures.stage.IMPORT": "Importación",
  "uploadFailures.stage.REPAIR": "Corrección",
  "uploadFailures.kind.xlsx": "Excel (.xlsx)",
  "uploadFailures.kind.xls": "Excel antiguo (.xls)",
  "uploadFailures.kind.csv": "CSV",
  "uploadFailures.kind.zip": "Zip",
  "uploadFailures.kind.html": "HTML",
  "uploadFailures.kind.unknown": "Desconocido",
  "uploadFailures.column.when": "Cuándo",
  "uploadFailures.column.operator": "Operador",
  "uploadFailures.column.file": "Archivo",
  "uploadFailures.column.kind": "Contenido",
  "uploadFailures.column.stage": "Etapa",
  "uploadFailures.column.error": "Error principal",
  "uploadFailures.column.code": "Código para soporte",
  "uploadFailures.column.reviewed": "Revisión",
  "uploadFailures.status.reviewed": "Revisada",
  "uploadFailures.status.pending": "Pendiente",
  "uploadFailures.open": "Abrir {name}",
  "uploadFailures.noName": "Archivo sin nombre",
  "uploadFailures.nameSays": "nombre .{extension}",
  "uploadFailures.unknownOperator": "Operador sin correo",
  "uploadFailures.summary": "{count} en esta página",
  "uploadFailures.summaryMore": "{count} en esta página · hay más",
  "uploadFailures.empty.title": "Ninguna hoja con error",
  "uploadFailures.empty.body":
    "Cuando un envío a la calculadora falle, aparecerá aquí con el código que vio el operador.",
  "uploadFailures.searchHint":
    "También acepta request id y correlation id. Búsqueda exacta; con 8 o más caracteres, por el inicio.",
  "uploadFailures.drawer.subtitle": "{operator} · {relative}",
  "uploadFailures.drawer.notFoundTitle": "Envío no encontrado",
  "uploadFailures.drawer.notFound": "Ningún fallo con el código {code}. Revise el código pegado.",
  "uploadFailures.section.detected": "Lo que detectó el servidor",
  "uploadFailures.section.errors": "Errores",
  "uploadFailures.section.technical": "Detalles técnicos",
  "uploadFailures.section.versions": "Versiones",
  "uploadFailures.section.original": "Archivo original",
  "uploadFailures.section.review": "Revisión",
  "uploadFailures.finding.OOXML_WORKBOOK": "Hoja de Excel (.xlsx) válida",
  "uploadFailures.finding.OOXML_MACRO_WORKBOOK": "Hoja de Excel con macros (.xlsm)",
  "uploadFailures.finding.OOXML_ENCRYPTED": "xlsx protegido con contraseña (cifrado)",
  "uploadFailures.finding.LEGACY_XLS_BIFF": "xls antiguo (BIFF, Excel 97-2003)",
  "uploadFailures.finding.OLE2_OTHER": "Otro documento de Office (OLE2), no una planilla",
  "uploadFailures.finding.HTML_DISGUISED": "El archivo es HTML disfrazado de .xls/.xlsx",
  "uploadFailures.finding.ZIP_WITHOUT_WORKBOOK": "zip sin workbook (no hay xl/workbook.xml)",
  "uploadFailures.finding.ZIP_DAMAGED": "zip dañado (no se pudo leer el directorio del archivo)",
  "uploadFailures.finding.DELIMITED_TEXT": "Texto delimitado (CSV)",
  "uploadFailures.finding.PDF": "El archivo es un PDF, no una planilla",
  "uploadFailures.finding.EMPTY": "El archivo está vacío (0 bytes)",
  "uploadFailures.finding.TEXT_UNKNOWN": "Texto que no es una tabla",
  "uploadFailures.finding.BINARY_UNKNOWN": "Binario de formato desconocido",
  "uploadFailures.finding.NOT_RECEIVED": "Los bytes no llegaron al servidor",
  "uploadFailures.detected.magic": "Firma (magic bytes)",
  "uploadFailures.detected.noMagic": "Sin firma binaria (contenido de texto o no recibido)",
  "uploadFailures.detected.extension": "Extensión del nombre",
  "uploadFailures.detected.contentType": "Contenido detectado",
  "uploadFailures.detected.mismatch":
    "El nombre dice .{extension}, pero el contenido es {detected}.",
  "uploadFailures.detected.sheets": "Hojas leídas",
  "uploadFailures.detected.noSheets": "No se pudo leer ninguna hoja",
  "uploadFailures.detected.zipEntries": "Entradas en el zip",
  "uploadFailures.detected.noExtension": "sin extensión",
  "uploadFailures.errors.response": "HTTP {status} · {code}",
  "uploadFailures.errors.detail": "Mensaje técnico de la API (inglés)",
  "uploadFailures.errors.none":
    "La API no devolvió violaciones para este envío; vea el mensaje técnico.",
  "uploadFailures.errors.field": "Campo",
  "uploadFailures.tech.more": "Datos técnicos (MIME, navegador, hashes)",
  "uploadFailures.tech.supportCode": "Código para soporte",
  "uploadFailures.tech.requestId": "Request id",
  "uploadFailures.tech.correlationId": "Correlation id",
  "uploadFailures.tech.httpStatus": "Estado HTTP",
  "uploadFailures.tech.problemCode": "Código del problema",
  "uploadFailures.tech.userAgent": "Navegador (user agent)",
  "uploadFailures.tech.sha256": "SHA-256",
  "uploadFailures.tech.size": "Tamaño",
  "uploadFailures.tech.declaredContentType": "Tipo declarado por el nombre",
  "uploadFailures.tech.stage": "Etapa",
  "uploadFailures.tech.createdAt": "Recibido el",
  "uploadFailures.tech.operator": "Operador",
  "uploadFailures.versions.app": "Aplicación",
  "uploadFailures.versions.engine": "Motor de cálculo",
  "uploadFailures.versions.parser": "Lector de hojas",
  "uploadFailures.versions.ruleset": "Ruleset",
  "uploadFailures.original.status.STORED": "Guardado",
  "uploadFailures.original.status.PENDING": "Guardándose",
  "uploadFailures.original.status.NOT_RECEIVED": "No recibido",
  "uploadFailures.original.status.TOO_LARGE": "Demasiado grande",
  "uploadFailures.original.status.STORE_FAILED": "Fallo al guardar",
  "uploadFailures.original.status.EXPIRED": "Expirado",
  "uploadFailures.original.explain.STORED":
    "Disponible para administradores durante la retención de 30 días.",
  "uploadFailures.original.explain.PENDING":
    "El archivo aún se está guardando. Inténtelo de nuevo en unos instantes.",
  "uploadFailures.original.explain.NOT_RECEIVED":
    "Los bytes no llegaron al servidor; solo se registraron los metadatos.",
  "uploadFailures.original.explain.TOO_LARGE":
    "El archivo superó el límite de envío y no se guardó; solo se registraron los metadatos.",
  "uploadFailures.original.explain.STORE_FAILED":
    "El almacenamiento no estaba disponible; solo se registraron los metadatos.",
  "uploadFailures.original.explain.EXPIRED":
    "El archivo se eliminó al terminar la retención de 30 días.",
  "uploadFailures.original.expiresAt": "Expira el",
  "uploadFailures.original.expiredAt": "Expiró el",
  "uploadFailures.original.download": "Descargar archivo original",
  "uploadFailures.original.downloading": "Descargando…",
  "uploadFailures.toast.downloaded": "Archivo descargado · {name}",
  "uploadFailures.toast.downloadFailed": "No se pudo descargar {name}",
  "uploadFailures.review.pending": "Aún no revisada.",
  "uploadFailures.review.done": "Revisada por {by} el {date}.",
  "uploadFailures.review.markReviewed": "Marcar como revisada",
  "uploadFailures.review.reopen": "Reabrir",
  "uploadFailures.review.note": "Nota de la revisión",
  "uploadFailures.review.notePlaceholder": "Qué se vio y qué se le indicó al operador",
  "uploadFailures.review.noteCount": "{count} de {max} caracteres",
  "uploadFailures.review.saveNote": "Guardar nota",
  "uploadFailures.review.saving": "Guardando…",
  "uploadFailures.toast.reviewed": "Marcada como revisada · {name}",
  "uploadFailures.toast.reopened": "Reabierta · {name}",
  "uploadFailures.toast.noteSaved": "Nota guardada · {name}",
  "uploadFailures.toast.reviewFailed": "No se pudo guardar la revisión",
  "uploadFailures.copyCode": "Copiar código",
  "wb.issue.HTML_AS_XLS.title": "Este archivo es una página HTML con nombre de planilla",
  "wb.issue.HTML_AS_XLS.hint":
    "Ábralo en Excel y use Guardar como → Libro de Excel (.xlsx); luego envíelo de nuevo.",
  "wb.issue.ZIP_NO_WORKBOOK.title": "Este .zip no contiene una hoja de Excel",
  "wb.issue.ZIP_NO_WORKBOOK.hint": "Envíe el propio archivo .xlsx, sin comprimir.",
  "nav.infraCost": "Costo de la infraestructura",
  "infraCost.title": "Costo estimado de la infraestructura",
  "infraCost.description":
    "Cuánto cuesta la plataforma por mes en Google Cloud, por servicio, con escenarios de uso y dónde ahorrar.",
  "infraCost.denied":
    "Solo los administradores de la plataforma ven el costo estimado de la infraestructura.",
  "infraCost.estimateLabel": "Estimación, no es factura",
  "infraCost.loading": "Cargando la estimación",
  "infraCost.banner.title": "Una estimación, no una factura.",
  "infraCost.banner.body":
    "Precios públicos de lista de {region} revisados el {date}, sin descuentos, créditos, compromisos de uso ni impuestos. Lo que realmente se cobra está en Cloud Billing.",
  "infraCost.scenario.legend": "Escenario",
  "infraCost.scenario.IDLE": "Inactivo",
  "infraCost.scenario.TYPICAL": "Típico",
  "infraCost.scenario.HIGH": "Alta carga",
  "infraCost.scenario.IDLE.summary":
    "Nadie usándola: solo instancias mínimas, base de datos, VMs, programadores y almacenamiento.",
  "infraCost.scenario.TYPICAL.summary":
    "Uso de hoy: lotes, filas y gasto de IA de los últimos 30 días registrados en la app.",
  "infraCost.scenario.HIGH.summary":
    "Unos 2.000 usuarios simultáneos, IA en el tope del presupuesto y Cloud SQL dimensionado para la carga.",
  "infraCost.totals.label": "Totales del escenario",
  "infraCost.totals.usd": "Total mensual (US$)",
  "infraCost.totals.brl": "Total mensual (R$)",
  "infraCost.totals.perMonth": "por mes",
  "infraCost.totals.perMonthShort": "/mes",
  "infraCost.totals.perYear": "≈ {value} por año",
  "infraCost.totals.rate": "US$ 1 = R$ {rate} · PTAX venta del {date}",
  "infraCost.totals.fixed": "Costos fijos",
  "infraCost.totals.variable": "Costos por uso",
  "infraCost.totals.share": "{share} del total",
  "infraCost.totals.fixedHint": "se pagan aunque no haya uso",
  "infraCost.totals.variableHint": "crecen con el uso",
  "infraCost.kind.FIXED": "Fijo",
  "infraCost.kind.VARIABLE": "Por uso",
  "infraCost.byService.title": "Costo por servicio",
  "infraCost.byService.tooltip": "{service}: fijo {fixed}, por uso {variable}",
  "infraCost.split.title": "Fijo frente a por uso",
  "infraCost.split.hint": "en el escenario elegido",
  "infraCost.split.aria": "Fijo {fixed}, por uso {variable}",
  "infraCost.split.fixedHint":
    "Instancias mínimas, Cloud SQL, VMs, NAT, almacenamiento y programadores.",
  "infraCost.split.variableHint": "Solicitudes, CPU de los jobs, tokens de Gemini, egress y logs.",
  "infraCost.drivers.title": "Mayores costos",
  "infraCost.drivers.hint": "los 5 ítems más caros",
  "infraCost.compare.title": "Escenarios",
  "infraCost.compare.hint": "elija uno para ver el detalle",
  "infraCost.compare.shown": "En pantalla",
  "infraCost.compare.fixed": "Fijo",
  "infraCost.compare.variable": "Por uso",
  "infraCost.compare.requests": "Solicitudes/mes",
  "infraCost.compare.rows": "Filas/mes",
  "infraCost.compare.ai": "IA (Gemini)",
  "infraCost.table.title": "Detalle por ítem",
  "infraCost.table.hint": "escenario {scenario}",
  "infraCost.table.showAll": "Mostrar los {count} ítems",
  "infraCost.table.showLess": "Mostrar menos",
  "infraCost.table.item": "Ítem",
  "infraCost.table.service": "Servicio",
  "infraCost.table.kind": "Tipo",
  "infraCost.table.quantity": "Cantidad/mes",
  "infraCost.table.basis": "Base",
  "infraCost.table.usd": "US$/mes",
  "infraCost.table.brl": "R$/mes",
  "infraCost.basis.TERRAFORM": "Terraform",
  "infraCost.basis.RECORDED": "Registrado en la app",
  "infraCost.basis.MODELED": "Supuesto",
  "infraCost.service.CLOUD_RUN": "Cloud Run (servicios)",
  "infraCost.service.CLOUD_RUN_JOBS": "Cloud Run (jobs)",
  "infraCost.service.CLOUD_SQL": "Cloud SQL",
  "infraCost.service.COMPUTE_ENGINE": "Compute Engine (VMs)",
  "infraCost.service.NETWORKING": "Red (NAT, IPs, egress)",
  "infraCost.service.API_GATEWAY": "API Gateway",
  "infraCost.service.CLOUD_STORAGE": "Cloud Storage",
  "infraCost.service.ARTIFACT_REGISTRY": "Artifact Registry",
  "infraCost.service.PUBSUB": "Pub/Sub",
  "infraCost.service.CLOUD_SCHEDULER": "Cloud Scheduler",
  "infraCost.service.SECRET_MANAGER": "Secret Manager",
  "infraCost.service.CLOUD_LOGGING": "Cloud Logging",
  "infraCost.service.FIREBASE_HOSTING": "Firebase Hosting",
  "infraCost.service.VERTEX_AI": "Vertex AI (Gemini)",
  "infraCost.line.runMinInstances": "APIs siempre encendidas",
  "infraCost.lineDetail.runMinInstances":
    "1 instancia mínima de la API admin (2 vCPU, 2 GiB, CPU siempre asignada, tarifa por instancia) y de la runtime (2 vCPU, 2 GiB, tarifa inactiva).",
  "infraCost.line.runServiceRequests": "Solicitudes a las APIs",
  "infraCost.lineDetail.runServiceRequests":
    "CPU y memoria mientras atienden, más US$ 0,40 por millón.",
  "infraCost.line.runWorkers": "Workers de captura y extracción",
  "infraCost.lineDetail.runWorkers": "Fetcher y extractor (1 vCPU, 1 GiB) por documento procesado.",
  "infraCost.line.jobsScheduledTicks": "Ejecuciones programadas de jobs",
  "infraCost.lineDetail.jobsScheduledTicks":
    "Cada disparo inicia una ejecución aunque no haya trabajo: cola de lotes cada minuto, investigación de la calculadora cada 2 min, investigación web, NF-e y el agente cada 5 min.",
  "infraCost.line.jobsLotRows": "Cálculo de filas de lotes",
  "infraCost.lineDetail.jobsLotRows": "CPU del ejecutor de lotes por fila calculada.",
  "infraCost.line.jobsWebResearch": "Ejecución de la investigación web",
  "infraCost.lineDetail.jobsWebResearch":
    "Horas del job de investigación (2 vCPU, 2 GiB) con barridos activos.",
  "infraCost.line.sqlInstance": "Instancia de Cloud SQL",
  "infraCost.lineDetail.sqlInstance":
    "Postgres Enterprise db-custom-1-3840 (1 vCPU, 3,75 GB), zonal, 24 h.",
  "infraCost.line.sqlStorage": "Disco de Cloud SQL",
  "infraCost.lineDetail.sqlStorage": "25 GB SSD con crecimiento automático.",
  "infraCost.line.sqlBackups": "Backups de Cloud SQL",
  "infraCost.lineDetail.sqlBackups":
    "14 backups diarios y 7 días de recuperación a un punto en el tiempo.",
  "infraCost.line.vmBrowserAgent": "VM del agente de navegador",
  "infraCost.lineDetail.vmBrowserAgent":
    "e2-standard-4 (4 vCPU, 16 GB) encendida 24 h, más 80 GiB de disco: 60 de arranque y 20 del perfil.",
  "infraCost.line.vmTwingate": "VM del conector Twingate",
  "infraCost.lineDetail.vmTwingate": "e2-micro encendida 24 h, más 10 GB de disco.",
  "infraCost.line.natGateways": "Gateways de Cloud NAT",
  "infraCost.lineDetail.natGateways":
    "Dos NAT (workers y Twingate), cobrados por VM detrás de ellos.",
  "infraCost.line.natData": "Tráfico por el NAT",
  "infraCost.lineDetail.natData": "Datos que los workers y el agente descargan de internet.",
  "infraCost.line.externalIps": "IPs externas",
  "infraCost.lineDetail.externalIps": "IP fija de salida de los workers e IP del NAT de Twingate.",
  "infraCost.line.egress": "Egress a internet",
  "infraCost.lineDetail.egress": "Respuestas de la API y descargas que salen de São Paulo.",
  "infraCost.line.apiGateway": "Llamadas a API Gateway",
  "infraCost.lineDetail.apiGateway": "Llamadas del navegador a la API admin, US$ 3 por millón.",
  "infraCost.line.gcsStorage": "Buckets de Cloud Storage",
  "infraCost.lineDetail.gcsStorage":
    "Evidencias, normalizados, cálculos, planillas y cuadros del agente.",
  "infraCost.line.registryStorage": "Imágenes en Artifact Registry",
  "infraCost.lineDetail.registryStorage":
    "Imágenes inmutables de cada deploy, sin política de limpieza.",
  "infraCost.line.pubsub": "Mensajes de Pub/Sub",
  "infraCost.lineDetail.pubsub":
    "Descubrimiento, documentos capturados y normalizados, DLQ e investigación.",
  "infraCost.line.scheduler": "Jobs de Cloud Scheduler",
  "infraCost.lineDetail.scheduler": "8 programaciones a US$ 0,10 por mes cada una.",
  "infraCost.line.secretManager": "Secretos",
  "infraCost.lineDetail.secretManager": "Versiones activas de 12 secretos y sus accesos.",
  "infraCost.line.logging": "Ingesta de logs",
  "infraCost.lineDetail.logging": "Por encima de los 50 GiB gratuitos por proyecto.",
  "infraCost.line.firebaseHosting": "Firebase Hosting",
  "infraCost.lineDetail.firebaseHosting":
    "Transferencia de la app web por encima de 360 MB por día.",
  "infraCost.line.geminiResearch": "Gemini de la investigación web",
  "infraCost.lineDetail.geminiResearch":
    "Búsquedas fundamentadas y tokens de Gemini 2.5 Flash, tal como la app los registra por lote.",
  "infraCost.line.geminiNfe": "Gemini del análisis de NF-e",
  "infraCost.lineDetail.geminiNfe": "Tokens de Gemini 2.5 Flash registrados por ejecución.",
  "infraCost.line.geminiBrowserAgent": "Gemini del agente de navegador",
  "infraCost.lineDetail.geminiBrowserAgent": "Tokens estimados por paso del agente.",
  "infraCost.savings.title": "Dónde ahorrar",
  "infraCost.savings.hint": "hasta {total}/mes en el escenario típico",
  "infraCost.savings.perMonth": "−{value}/mes",
  "infraCost.saving.browserAgentSmallerVm.title": "VM del agente en e2-standard-2",
  "infraCost.saving.browserAgentSmallerVm.detail":
    "La mitad de CPU y memoria. O apagarla fuera del horario laboral con una programación.",
  "infraCost.saving.apiMinInstancesZero.title": "APIs sin instancia mínima",
  "infraCost.saving.apiMinInstancesZero.detail":
    "min_instance_count 0 en las APIs admin y runtime (api_min_instances en el módulo platform).",
  "infraCost.saving.cloudSqlCommittedUse.title": "Compromiso de uso de Cloud SQL",
  "infraCost.saving.cloudSqlCommittedUse.detail":
    "25% de descuento en vCPU y memoria con un compromiso de 1 año.",
  "infraCost.saving.taskRunnerEveryFiveMinutes.title": "Cola de lotes cada 5 minutos",
  "infraCost.saving.taskRunnerEveryFiveMinutes.detail":
    "Hoy el programador dispara el ejecutor de lotes cada minuto, haya o no trabajo.",
  "infraCost.saving.calculatorTickEveryFiveMinutes.title":
    "Investigación de la calculadora cada 5 minutos",
  "infraCost.saving.calculatorTickEveryFiveMinutes.detail":
    "El disparo instantáneo ya cubre el caso urgente; el programador es solo la red de seguridad.",
  "infraCost.saving.registryCleanupPolicy.title": "Limpieza de Artifact Registry",
  "infraCost.saving.registryCleanupPolicy.detail":
    "Conservar solo las últimas imágenes de cada servicio.",
  "infraCost.tradeoff.COLD_START":
    "Primera solicitud más lenta (arranque en frío antes del inicio de sesión).",
  "infraCost.tradeoff.SLOWER_PICKUP": "El trabajo nuevo puede esperar unos minutos más.",
  "infraCost.tradeoff.SLOWER_AGENT": "Agente de navegador más lento.",
  "infraCost.tradeoff.NONE": "Sin impacto en el producto.",
  "infraCost.tradeoff.COMMITMENT": "Compromiso de pago por 1 año.",
  "infraCost.usage.title": "Uso registrado en la app",
  "infraCost.usage.window": "{from} a {to}",
  "infraCost.usage.unavailable":
    "No se pudieron leer los registros de la app ahora. El escenario típico usa el perfil documentado.",
  "infraCost.usage.lots": "Lotes",
  "infraCost.usage.lotRows": "Filas de lotes",
  "infraCost.usage.calculations": "Cálculos",
  "infraCost.usage.researchUnits": "Unidades de investigación",
  "infraCost.usage.groundedCalls": "Búsquedas fundamentadas",
  "infraCost.usage.researchCost": "Gasto de investigación (registrado)",
  "infraCost.usage.nfeRuns": "Análisis de NF-e",
  "infraCost.usage.nfeCost": "Gasto de NF-e (registrado)",
  "infraCost.usage.browserAgentSteps": "Pasos del agente",
  "infraCost.usage.researchDocuments": "Documentos de investigación",
  "infraCost.usage.caps":
    "Topes mensuales de IA definidos en la app: investigación web {research}, NF-e {nfe}.",
  "infraCost.assumptions.title": "Supuestos y fuentes",
  "infraCost.assumptions.model": "Supuestos del modelo",
  "infraCost.assumptions.terraformSource": "Dimensionamiento leído de: {source}.",
  "infraCost.assumption.prices":
    "Precios públicos de lista de {region} (São Paulo, más cara que us-central1), revisados el {date}.",
  "infraCost.assumption.freeTiers":
    "Las cuotas gratuitas de la cuenta de facturación (Cloud Run, Scheduler, Secret Manager, API Gateway, Artifact Registry) no se descuentan, porque la cuenta también paga otros proyectos. Solo se descuentan los 50 GiB de logs por proyecto.",
  "infraCost.assumption.terraform":
    "Los tamaños fijos (CPU, memoria, instancias mínimas, tier de la base, VMs, programaciones) vienen de Terraform, modelo {version}. Una prueba falla cuando Terraform cambia y el modelo no.",
  "infraCost.assumption.ticks":
    "Cada disparo de Cloud Scheduler inicia una ejecución de job aunque no haya trabajo; suponemos de 15 a 20 s por ejecución vacía.",
  "infraCost.assumption.requests":
    "La app no registra solicitudes: el escenario típico supone {requests} por mes; alta carga, 2.000 usuarios simultáneos con una llamada cada 20 s, 10 h al día, 22 días hábiles.",
  "infraCost.assumption.ai":
    "La investigación web y la NF-e usan el costo en US$ que registra la app (Gemini 2.5 Flash). La investigación cobra cada búsqueda fundamentada a US$ 35 por 1.000, pero Vertex AI da 1.500 por día gratis: el valor registrado es un techo.",
  "infraCost.assumption.browserAgent":
    "Agente de navegador: {input} tokens de entrada y {output} de salida por paso (Gemini 2.5 Flash).",
  "infraCost.assumption.highSql":
    "Alta carga supone Cloud SQL con 4 vCPU, 16 GB y alta disponibilidad: el tier actual no soporta miles de usuarios.",
  "infraCost.assumption.storage":
    "Los volúmenes de almacenamiento, backups, imágenes, egress y logs son estimados; la exportación de facturación daría los valores reales.",
  "infraCost.assumption.gateway":
    "API Gateway corre en us-east1 (no existe en São Paulo); el tráfico entre regiones no está separado.",
  "infraCost.assumption.fx":
    "Tipo de cambio solo para mostrar: PTAX venta del Banco Central del {date}, US$ 1 = R$ {rate}. El modelo está en US$.",
  "infraCost.billing.title": "Valores reales de facturación",
  "infraCost.billing.NOT_CONFIGURED":
    "La exportación de Cloud Billing a BigQuery no está configurada en Terraform, así que esta página no usa la factura real.",
  "infraCost.billing.CONFIGURED": "La exportación de Cloud Billing a BigQuery está configurada.",
  "infraCost.billing.step1":
    "En la consola, abra Facturación → Exportación de facturación de la cuenta que paga backchannel-agent-dolphin (requiere Administrador de la cuenta de facturación).",
  "infraCost.billing.step2":
    "Active “Costo de uso detallado” hacia un dataset de BigQuery, por ejemplo billing_export en backchannel-agent-dolphin.",
  "infraCost.billing.step3":
    "Los datos empiezan a llegar en unas horas; el historial anterior no se rellena.",
  "infraCost.billing.step4":
    "Luego filtre por project.id = backchannel-agent-dolphin y compare con esta estimación.",
  "infraCost.billing.docs": "Cómo configurar la exportación (Google Cloud)",
  "infraCost.sources.title": "Precios unitarios y fuentes",
  "infraCost.sources.hint": "lista pública, en US$",
  "infraCost.sources.sku": "SKU",
  "infraCost.sources.price": "Precio",
  "infraCost.sources.scope": "Alcance",
  "infraCost.sources.source": "Fuente",
  "infraCost.sources.checked": "Revisado el",
  "infraCost.unit.vCPU-s": "vCPU-s",
  "infraCost.unit.requests": "solicitudes",
  "infraCost.unit.documents": "documentos",
  "infraCost.unit.executions": "ejecuciones",
  "infraCost.unit.rows": "filas",
  "infraCost.unit.hours": "horas",
  "infraCost.unit.GB-month": "GB-mes",
  "infraCost.unit.gateways": "gateways",
  "infraCost.unit.addresses": "direcciones",
  "infraCost.unit.GiB": "GiB",
  "infraCost.unit.calls": "llamadas",
  "infraCost.unit.jobs": "jobs",
  "infraCost.unit.versions": "versiones",
  "infraCost.unit.GB": "GB",
  "infraCost.unit.USD": "US$",
  "infraCost.unit.steps": "pasos",
  "infraCost.priceUnit.vCPU-second": "vCPU-segundo",
  "infraCost.priceUnit.GiB-second": "GiB-segundo",
  "infraCost.priceUnit.million requests": "millón de solicitudes",
  "infraCost.priceUnit.vCPU-hour": "vCPU-hora",
  "infraCost.priceUnit.GB-hour": "GB-hora",
  "infraCost.priceUnit.GB-month": "GB-mes",
  "infraCost.priceUnit.hour": "hora",
  "infraCost.priceUnit.VM-hour": "VM-hora",
  "infraCost.priceUnit.GiB": "GiB",
  "infraCost.priceUnit.million calls": "millón de llamadas",
  "infraCost.priceUnit.TiB": "TiB",
  "infraCost.priceUnit.job-month": "job-mes",
  "infraCost.priceUnit.version-month": "versión-mes",
  "infraCost.priceUnit.10,000 operations": "10.000 operaciones",
  "infraCost.priceUnit.GB": "GB",
  "infraCost.priceUnit.1M tokens": "1 millón de tokens",
  "infraCost.priceUnit.1,000 grounded prompts": "1.000 prompts con grounding",
  "infraCost.note.runCpuActive": "southamerica-east1 es una región Tier 2 de Cloud Run.",
  "infraCost.note.runCpuIdle":
    "Las instancias mínimas inactivas de servicios por solicitud pagan CPU a la tarifa inactiva reducida.",
  "infraCost.note.runJobCpu": "Los jobs cobran toda la ejecución, incluido el arranque.",
  "infraCost.note.runCpuInstance":
    "Los servicios con CPU siempre asignada pagan toda la vida de la instancia, inactiva u ocupada.",
  "infraCost.note.sqlVcpu": "HA (REGIONAL) duplica los precios de vCPU, memoria y almacenamiento.",
  "infraCost.note.externalIp": "Las IP internas (agente de navegador, Twingate) son gratuitas.",
  "infraCost.note.geminiFlashInput":
    "La app valora las investigaciones y las ejecuciones de NF-e con su propia tabla de precios, editable por el admin; cuando existen, se usan esos importes registrados.",
  "infraCost.note.groundedPrompt":
    "Vertex AI da 1.500 prompts con grounding al día gratis (familia 2.0/2.5 Flash, compartida). La app registra cada llamada con grounding a este precio, así que el gasto registrado en investigación es un techo.",
  "infraCost.scope.REGIONAL": "São Paulo",
  "infraCost.scope.GLOBAL": "Global",
  "infraCost.scope.OTHER_REGION": "Otra región",
  "ncmSearch.label": "Producto o NCM",
  "ncmSearch.placeholder": "Ej.: galleta o 8471.30.12",
  "ncmSearch.hint":
    "Escriba el nombre del producto, en portugués, español o inglés, o los 8 dígitos de la NCM.",
  "ncmSearch.searching": "Buscando en el catálogo oficial…",
  "ncmSearch.error": "No se pudo buscar ahora. Escriba el NCM o intente de nuevo.",
  "ncmSearch.empty": "No se encontró ningún NCM. Pruebe otro nombre, un sinónimo o el código.",
  "ncmSearch.catalogPending":
    "La tabla completa aún se está cargando; los resultados pueden ser parciales.",
  "ncmSearch.clear": "Borrar",
  "ncmSearch.count": "{count} sugerencias",
  "ncmSearch.results": "Sugerencias de NCM",
  "ncmSearch.group.catalog": "Tabla NCM oficial",
  "ncmSearch.group.history": "Productos parecidos ya clasificados",
  "ncmSearch.reference":
    "Referencia Siscomex/TIPI. Verifique la descripción oficial; no es una alícuota.",
  "ncmSearch.matched": "encontrado por “{term}”",
  "ncmSearch.cestOne": "CEST {cest}",
  "ncmSearch.cestMany": "CEST {cest} +{count}",
  "ncmSearch.spSt": "SP: ST en la regla publicada",
  "ncmSearch.spNoSt": "SP: sin ST en la regla publicada",
  "ncmSearch.unofficial": "traducción no oficial",
  "ncmSearch.officialText": "Texto oficial:",
  "ncmSearch.notInTable": "Fuera de la tabla oficial vigente",
  "ncmSearch.historySeen.one": "visto en {count} fila de sus lotes",
  "ncmSearch.historySeen.other": "visto en {count} filas de sus lotes",
  "ncmSearch.illustrative": "ilustrativo",
  "commandSearch.group.products": "Productos → NCM",
  "commandSearch.product.hint": "Calcular con este NCM",
  "repair.ncm.search": "¿Ninguno de estos? Busque el producto",
  "repair.ncm.searchHint":
    "Elija un NCM de la tabla oficial. Reemplaza el valor de la celda solo después de que aplique.",
  "repair.ncm.chosen": "NCM elegido en la tabla oficial",
  "ncmSearch.illustrativeHint":
    "Ilustrativo: imagen generada por IA para sugerir el tipo de mercancía. La identificación es el NCM y el texto oficial.",
  "rules.chapterDetail.illustration.illustrative":
    "Ilustrativo · imagen generada por IA. La identidad del capítulo es la tesela SH y el título oficial Siscomex.",
  "nav.sessions": "Sesiones",
  "sessions.replay.heading": "Sesión de {name}",
  "sessions.title": "Sesiones",
  "sessions.description":
    "Vea lo que hizo cada operador: la grabación de la pantalla y cada acción registrada.",
  "sessions.denied": "Solo un administrador de la plataforma puede ver las sesiones.",
  "sessions.configure": "Configurar grabación",
  "sessions.view.legend": "Qué mostrar",
  "sessions.view.sessions": "Sesiones",
  "sessions.view.activity": "Actividad",
  "sessions.filter.operator": "Operador",
  "sessions.filter.operatorPlaceholder": "Correo o identificador",
  "sessions.filter.from": "Desde",
  "sessions.filter.to": "Hasta",
  "sessions.filter.range": "Período",
  "sessions.filter.errors": "Errores",
  "sessions.filter.errors.all": "Todas",
  "sessions.filter.errors.with": "Con errores",
  "sessions.filter.errors.without": "Sin errores",
  "sessions.filter.kind": "Tipo de acción",
  "sessions.filter.anyKind": "Cualquier tipo",
  "sessions.filter.outcome": "Resultado",
  "sessions.filter.outcome.all": "Todos",
  "sessions.filter.outcome.ok": "OK",
  "sessions.filter.outcome.error": "Error",
  "sessions.filter.organization": "Organización",
  "sessions.filter.anyOrganization": "Todas las organizaciones",
  "sessions.column.operator": "Operador",
  "sessions.column.started": "Inicio",
  "sessions.column.duration": "Duración",
  "sessions.column.path": "Recorrido",
  "sessions.column.actions": "Acciones",
  "sessions.column.errors": "Errores",
  "sessions.column.size": "Tamaño",
  "sessions.column.when": "Cuándo",
  "sessions.column.kind": "Tipo",
  "sessions.column.action": "Acción",
  "sessions.column.result": "Resultado",
  "sessions.column.session": "Sesión",
  "sessions.column.requestId": "requestId",
  "sessions.errors.none": "Sin errores",
  "sessions.errors.api.one": "{count} error de la API",
  "sessions.errors.api.other": "{count} errores de la API",
  "sessions.errors.client.one": "{count} error en el navegador",
  "sessions.errors.client.other": "{count} errores en el navegador",
  "sessions.actions.one": "{count} acción",
  "sessions.actions.other": "{count} acciones",
  "sessions.summary.one": "{count} sesión",
  "sessions.summary.other": "{count} sesiones",
  "sessions.summaryMore.one": "{count} sesión · hay más",
  "sessions.summaryMore.other": "{count} sesiones · hay más",
  "sessions.activity.summary.one": "{count} registro",
  "sessions.activity.summary.other": "{count} registros",
  "sessions.activity.summaryMore.one": "{count} registro · hay más",
  "sessions.activity.summaryMore.other": "{count} registros · hay más",
  "sessions.kind.CALCULATION": "Cálculo individual",
  "sessions.kind.LOT": "Lote",
  "sessions.kind.SIMULATION": "Simulación de lote",
  "sessions.kind.RECALCULATION": "Recálculo",
  "sessions.kind.UPLOAD": "Envío de planilla",
  "sessions.kind.IMPORT": "Importación",
  "sessions.kind.PROFILE_CONFIRMATION": "Confirmación de perfil",
  "sessions.kind.PROPOSAL": "Propuesta",
  "sessions.kind.EVIDENCE": "Evidencia",
  "sessions.kind.API_ERROR": "Error de la API",
  "sessions.kind.CLIENT_ERROR": "Error en el navegador",
  "sessions.kind.NAVIGATION": "Navegación",
  "sessions.kind.OTHER": "Otra acción",
  "sessions.outcome.ok": "OK",
  "sessions.outcome.error": "Error",
  "sessions.empty.title": "Ninguna sesión en este filtro",
  "sessions.empty.body": "Ajuste el período o el operador para ver otras sesiones.",
  "sessions.activity.empty.title": "Ninguna actividad en este filtro",
  "sessions.activity.empty.body": "Ajuste el período, el tipo o el resultado.",
  "sessions.action.CALCULATION": "Calculó una operación",
  "sessions.action.LOT": "Procesó un lote",
  "sessions.action.SIMULATION": "Simuló un lote",
  "sessions.action.RECALCULATION": "Recalculó una operación",
  "sessions.action.UPLOAD": "Envió una planilla",
  "sessions.action.IMPORT": "Importó una planilla",
  "sessions.action.PROFILE_CONFIRMATION": "Confirmó el perfil fiscal",
  "sessions.action.PROPOSAL": "Registró una propuesta",
  "sessions.action.EVIDENCE": "Registró una evidencia",
  "sessions.action.API_ERROR": "Error de la API {status} · {code}",
  "sessions.action.CLIENT_ERROR": "Error en el navegador: {message}",
  "sessions.action.NAVIGATION": "Abrió {route}",
  "sessions.action.OTHER": "Realizó otra acción",
  "sessions.route.sessions": "Sesiones",
  "sessions.route.admin": "Administración",
  "sessions.route.calculations": "Calculadora",
  "sessions.route.lots": "Lotes",
  "sessions.route.rules": "Reglas",
  "sessions.route.evidence": "Evidencias",
  "sessions.route.proposals": "Propuestas",
  "sessions.route.invoices": "Facturas",
  "sessions.route.sources": "Fuentes",
  "sessions.route.overview": "Visión general",
  "sessions.route.unknown": "Recorrido desconocido",
  "sessions.path.none": "Sin recorrido",
  "sessions.settings.title": "Configurar grabación",
  "sessions.settings.status.deployOn": "La grabación está activada en este entorno.",
  "sessions.settings.status.deployOff":
    "La grabación está desactivada en este entorno. La preferencia de la organización sigue guardada.",
  "sessions.settings.status.storageOn": "El almacenamiento de las grabaciones está configurado.",
  "sessions.settings.status.storageOff":
    "El almacenamiento de las grabaciones no está configurado.",
  "sessions.settings.retention.one": "Los registros se conservan durante {count} día.",
  "sessions.settings.retention.other": "Los registros se conservan durante {count} días.",
  "sessions.settings.enabled": "Grabar sesiones en esta organización",
  "sessions.settings.enabledHint":
    "Cuando está desactivado, la pantalla no se graba. Las acciones y los errores siguen en el registro.",
  "sessions.settings.sample": "Muestra",
  "sessions.settings.sampleHint":
    "Porcentaje de las sesiones que graban la pantalla. 100 graba todas.",
  "sessions.settings.sampleInvalid": "Indique un porcentaje de 0 a 100.",
  "sessions.settings.excluded": "Operadores excluidos",
  "sessions.settings.excludedHint": "Estos operadores no tienen la pantalla grabada.",
  "sessions.settings.excludedPlaceholder": "Pegue un identificador o elija un correo",
  "sessions.settings.excludedAdd": "Agregar",
  "sessions.settings.excludedPick": "Elegir por correo",
  "sessions.settings.excludedInvalid": "Indique un identificador válido o un correo de la lista.",
  "sessions.settings.excludedEmpty": "Ningún operador excluido.",
  "sessions.settings.excludedRemove": "Quitar {name}",
  "sessions.settings.excludedFull": "La lista ya tiene 200 operadores.",
  "sessions.settings.save": "Guardar",
  "sessions.settings.saving": "Guardando…",
  "sessions.settings.saved": "Grabación actualizada",
  "sessions.settings.saveError": "No fue posible guardar la grabación.",
  "sessions.settings.note":
    "Los registros de actividad (acciones y errores) continúan aunque no haya grabación de pantalla.",
  "sessions.auditNote": "Su acceso a esta grabación queda registrado en la auditoría.",
  "sessions.expires": "Expira el {date}.",
  "sessions.expired": "Esta grabación expiró. La actividad sigue en la lista.",
  "sessions.notFound.title": "Sesión no encontrada",
  "sessions.notFound.body": "Esta sesión no existe o usted no tiene acceso a ella.",
  "sessions.back": "Volver a sesiones",
  "sessions.breadcrumb.admin": "Administración",
  "sessions.fact.operator": "Operador",
  "sessions.fact.started": "Inicio",
  "sessions.fact.duration": "Duración",
  "sessions.fact.browser": "Navegador",
  "sessions.fact.unknownBrowser": "Navegador desconocido",
  "sessions.fact.version": "Versión",
  "sessions.fact.screen": "Pantalla",
  "sessions.fact.screenValue": "{width} × {height}",
  "sessions.fact.expires": "Expira el",
  "sessions.player.loading": "Cargando la grabación… {loaded} de {total} partes",
  "sessions.player.empty.title": "Sin grabación de pantalla",
  "sessions.player.empty.body":
    "No hay imagen de esta sesión. La actividad sigue en la línea de tiempo.",
  "sessions.player.truncated": "La grabación se interrumpió después de 400 partes.",
  "sessions.player.play": "Reproducir",
  "sessions.player.pause": "Pausar",
  "sessions.player.back": "-5 s",
  "sessions.player.forward": "+5 s",
  "sessions.player.speed": "Velocidad",
  "sessions.player.skip": "Saltar inactividad",
  "sessions.player.elapsed": "{elapsed} de {total}",
  "sessions.player.fullscreen": "Pantalla completa",
  "sessions.player.exitFullscreen": "Salir de pantalla completa",
  "sessions.player.scrubber": "Posición de la grabación",
  "sessions.player.marker": "Ir a {label}",
  "sessions.timeline.legend": "Línea de tiempo",
  "sessions.timeline.all": "Todos",
  "sessions.timeline.errors": "Errores",
  "sessions.timeline.actions": "Acciones",
  "sessions.timeline.navigation": "Navegación",
  "sessions.timeline.empty": "Ninguna acción en este filtro.",
  "sessions.timeline.outside": "fuera de la grabación",
  "sessions.timeline.details": "Detalles técnicos",
  "sessions.timeline.method": "Método",
  "sessions.timeline.status": "Estado HTTP",
  "sessions.timeline.problem": "Código",
  "sessions.timeline.duration": "Duración",
  "sessions.timeline.requestId": "requestId",
  "sessions.timeline.correlationId": "correlationId",
  "sessions.timeline.audit": "Auditoría",
  "sessions.timeline.uploadFailure": "Ver planilla con error",
  "sessions.activityTruncated": "La línea de tiempo muestra las primeras 2.000 acciones.",
  "sessions.link.watch": "Ver sesión",
  "sessions.link.noRecording": "Sesión sin grabación de pantalla",
  "sessions.link.activity": "Ver actividad",
  "sessionReplay.notice.title": "Sesión grabada para soporte",
  "sessionReplay.notice.body":
    "Grabamos la pantalla y las acciones de esta sesión para soporte y calidad. Las contraseñas, claves y campos escritos quedan ocultos. Se conservan {days} días.",
  "sessionReplay.notice.ack": "Entendido",
  /* -- Autoaprovação (ADR 0020) ------------------------------------------- */
  "nav.autoApproval": "Autoaprobación",
  "autoApproval.title": "Autoaprobación",
  "autoApproval.description":
    "Aprobación automática gobernada: cada etapa tiene su interruptor, criterios y auditoría. Todo empieza apagado.",
  "autoApproval.denied": "Solo los administradores de la plataforma gestionan la autoaprobación.",
  "autoApproval.tabs": "Secciones de autoaprobación",
  "autoApproval.tab.stages": "Etapas",
  "autoApproval.tab.limits": "Límites",
  "autoApproval.tab.preview": "Vista previa",
  "autoApproval.tab.report": "Informe diario",
  "autoApproval.actorLine": "Actúa como {actor} · criterios {policy}",
  "autoApproval.status.allOff": "Apagada. Nada se aprueba ni publica automáticamente.",
  "autoApproval.status.killSwitch":
    "Interruptor general del entorno activo (AUTO_APPROVAL_KILL_SWITCH). Ninguna etapa se ejecuta.",
  "autoApproval.status.breaker": "Disyuntor abierto",
  "autoApproval.status.off": "Apagada",
  "autoApproval.status.on": "Encendida",
  "autoApproval.status.killed": "Bloqueada por el interruptor general",
  "autoApproval.status.breakerPill": "Disyuntor abierto",
  "autoApproval.stage.PACKAGE": "Importar paquete",
  "autoApproval.stage.PACKAGE.desc":
    "Crea propuestas pendientes desde el paquete de reglas versionado en el repositorio, cada una solo cuando su evidencia está aprobada y la regla actual no cambió.",
  "autoApproval.stage.PACKAGE.criteria":
    "Evidencia capturada|Evidencia aprobada|Regla actual sin cambio|Aún no importada|Dependencia lista|Grupo habilitado",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY": "Evidencia del paquete aprobada",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY.tip":
    "Toda la evidencia citada por el ítem está aprobada.",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED": "Evidencia capturada",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED.tip":
    "El documento citado ya existe en Documentos (captura la URL si falta).",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT": "Regla actual sin cambio",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT.tip":
    "La regla que el ítem sustituye sigue como el paquete espera.",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED": "Aún no importada",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED.tip": "El ítem no se creó antes (idempotente).",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY": "Dependencia lista",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY.tip":
    "El SUPERSEDE del par ya se creó antes del UPSERT.",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED": "Grupo habilitado",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED.tip":
    "Los grupos opcionales solo entran con la opción encendida.",
  "autoApproval.outcome.CREATE": "Se crearía",
  "autoApproval.done.CREATE": "Creada",
  "autoApproval.stage.EVIDENCE": "Evidencia",
  "autoApproval.stage.FACTS": "Hechos fiscales",
  "autoApproval.stage.PROPOSALS": "Propuestas de regla",
  "autoApproval.stage.POLICY_SWITCH": "Política del borrador",
  "autoApproval.stage.PUBLISH": "Publicación automática",
  "autoApproval.stage.EVIDENCE.desc":
    "Aprueba documentos nuevos de fuentes oficiales registradas y sanas, con digest estable y un tipo de acto admitido.",
  "autoApproval.stage.FACTS.desc":
    "Certifica hechos fiscales no verificados cuando la evidencia está aprobada, otra fuente independiente coincide y no hay conflicto ni divergencia.",
  "autoApproval.stage.PROPOSALS.desc":
    "Aprueba propuestas pendientes con evidencia aprobada, simulación válida, sin solapamiento y dentro de los límites.",
  "autoApproval.stage.POLICY_SWITCH.desc":
    "Cambia la política del borrador (p. ej. tax-family-v2) solo con readiness cero. Nunca ocurre por otra etapa.",
  "autoApproval.stage.PUBLISH.desc":
    "Publica el borrador cuando el canario pasa (golden + replay) y revierte solo si el canario posterior a la publicación falla.",
  "autoApproval.stage.POLICY_SWITCH.note":
    "Cambiar la política (p. ej. tax-family-v2) nunca es automático con esta etapa apagada.",
  "autoApproval.stage.EVIDENCE.criteria":
    "Fuente registrada|URL en el registro|Fuente sana|Fetch ok|Digest estable|Acto admitido",
  "autoApproval.stage.FACTS.criteria":
    "Evidencia aprobada|Concordancia independiente|Sin conflicto certificado|Sin drift",
  "autoApproval.stage.PROPOSALS.criteria":
    "Evidencia aprobada|Dry-run válido|Sin solapamiento|Dentro de los techos|Política sin cambios",
  "autoApproval.stage.POLICY_SWITCH.criteria": "Política objetivo con readiness cero",
  "autoApproval.stage.PUBLISH.criteria":
    "Borrador presente|Readiness cero|Diff en límites|Solo autoaprobadas|Enfriamiento|Canario ok",
  "autoApproval.switch.on": "Encendida",
  "autoApproval.switch.off": "Apagada",
  "autoApproval.lastChange": "Último cambio por {name} el {when} — “{reason}”",
  "autoApproval.neverChanged": "Nunca modificada (valor de fábrica).",
  "autoApproval.reason.label": "Motivo",
  "autoApproval.reason.help": "Obligatorio, entre 10 y 500 caracteres. Queda en la auditoría.",
  "autoApproval.reason.invalid": "Indique un motivo de al menos 10 caracteres.",
  "autoApproval.dialog.enable.title": "Encender {stage}",
  "autoApproval.dialog.disable.title": "Apagar {stage}",
  "autoApproval.dialog.enable.confirm": "Encender etapa",
  "autoApproval.dialog.disable.confirm": "Apagar etapa",
  "autoApproval.dialog.enable.body.EVIDENCE":
    "Con esta etapa encendida, los documentos NEW que pasen todos los criterios serán aprobados por el actor del sistema.",
  "autoApproval.dialog.enable.body.FACTS":
    "Con esta etapa encendida, los hechos UNVERIFIED que pasen todos los criterios serán certificados.",
  "autoApproval.dialog.enable.body.PROPOSALS":
    "Con esta etapa encendida, las propuestas PENDING_REVIEW que pasen todos los criterios serán aprobadas.",
  "autoApproval.dialog.enable.body.POLICY_SWITCH":
    "Con esta etapa encendida, el borrador puede cambiar a la política objetivo cuando la readiness sea cero.",
  "autoApproval.dialog.enable.body.PUBLISH":
    "Con esta etapa encendida, el borrador puede publicarse tras el canario. Un fallo post-publicación revierte y abre el disyuntor.",
  "autoApproval.dialog.disable.body":
    "La etapa deja de actuar en las siguientes ejecuciones. Lo ya aprobado no se deshace.",
  "autoApproval.dialog.enable.previewCount": "Hoy se aprobarían {count}",
  "autoApproval.run.now": "Ejecutar ahora",
  "autoApproval.run.hint": "Dispara una ejecución manual con las etapas efectivamente encendidas.",
  "autoApproval.run.disabledTip": "Ninguna etapa está efectivamente encendida.",
  "autoApproval.run.confirmTitle": "¿Ejecutar autoaprobación ahora?",
  "autoApproval.run.confirmBody":
    "La ejecución usa las etapas efectivas actuales, con clave de idempotencia. ¿Continuar?",
  "autoApproval.run.confirm": "Ejecutar",
  "autoApproval.run.resultTitle": "Resultado de la ejecución",
  "autoApproval.run.result.status": "Estado",
  "autoApproval.run.result.acted": "Actuados",
  "autoApproval.run.result.held": "Retenidos",
  "autoApproval.run.result.stageCounts": "{acted} actuados · {held} retenidos",
  "autoApproval.runStatus.DISABLED": "Apagada",
  "autoApproval.runStatus.LOCKED": "Bloqueada (otra ejecución)",
  "autoApproval.runStatus.RUNNING": "En ejecución",
  "autoApproval.runStatus.COMPLETED": "Completada",
  "autoApproval.runStatus.PARTIAL": "Parcial",
  "autoApproval.runStatus.FAILED": "Falló",
  "autoApproval.runStage.SKIPPED": "Omitida",
  "autoApproval.runStage.COMPLETED": "Completada",
  "autoApproval.runStage.FAILED": "Falló",
  "autoApproval.trigger.SCHEDULE": "Agenda",
  "autoApproval.trigger.MANUAL": "Manual",
  "autoApproval.toast.saved": "Configuración guardada",
  "autoApproval.toast.run": "Ejecución {status}",
  "autoApproval.error.conflict": "Alguien cambió la configuración. Recargue.",
  "autoApproval.error.save": "No se pudo guardar. Inténtelo de nuevo.",
  "autoApproval.done.APPROVE": "Aprobada",
  "autoApproval.done.CERTIFY": "Certificado",
  "autoApproval.done.PUBLISH": "Publicada",
  "autoApproval.done.SWITCH_POLICY": "Política cambiada",
  "autoApproval.done.ROLLBACK": "Revertida",
  "autoApproval.done.HOLD": "Retenida",
  "autoApproval.outcome.APPROVE": "Se aprobaría",
  "autoApproval.outcome.CERTIFY": "Se certificaría",
  "autoApproval.outcome.PUBLISH": "Se publicaría",
  "autoApproval.outcome.SWITCH_POLICY": "Cambiaría la política",
  "autoApproval.outcome.ROLLBACK": "Reversión",
  "autoApproval.outcome.HOLD": "Retenida",
  "autoApproval.limits.group.evidence": "Evidencia",
  "autoApproval.limits.group.package": "Paquete",
  "autoApproval.limits.group.facts": "Hechos",
  "autoApproval.limits.group.proposals": "Propuestas",
  "autoApproval.limits.group.publish": "Publicación",
  "autoApproval.limits.group.policy": "Política",
  "autoApproval.limits.package.packageId": "Identificador del paquete",
  "autoApproval.limits.package.packageId.help":
    "Paquete de reglas versionado enviado con la API (solo lectura).",
  "autoApproval.limits.package.includeOptionalGroups": "Incluir grupos opcionales (8 y 9)",
  "autoApproval.limits.package.includeOptionalGroups.help":
    "Apagado por defecto. Los grupos 8 y 9 solo se importan con este interruptor.",
  "autoApproval.limits.package.maxPerRun": "Máximo por ejecución",
  "autoApproval.limits.package.maxPerRun.help":
    "Ítems del paquete evaluados por ejecución en esta etapa.",
  "autoApproval.package.prerequisites": "Prerrequisitos humanos",
  "autoApproval.package.panel.wouldCreate": "{count} se crearían",
  "autoApproval.package.panel.held": "{count} retenidas",
  "autoApproval.preview.diagnostics": "Diagnóstico de {stage} (todos los candidatos)",
  "autoApproval.package.panel.title": "Paquete 2026-10-05",
  "autoApproval.package.panel.imported": "{imported} importados",
  "autoApproval.package.panel.total": "{total} ítems",
  "autoApproval.package.panel.optional": "Opcional",
  "autoApproval.package.panel.plans": "Planes",
  "autoApproval.limits.invalid":
    "Hay valores fuera de los límites del contrato. Corríjalos antes de guardar.",
  "autoApproval.limits.save": "Guardar límites",
  "autoApproval.limits.reset": "Restaurar valores",
  "autoApproval.limits.dirty": "Cambios locales aún no guardados.",
  "autoApproval.limits.confirmTitle": "¿Guardar límites?",
  "autoApproval.limits.confirmBody":
    "Los nuevos techos valen en la próxima ejecución. Indique un motivo para la auditoría.",
  "autoApproval.limits.evidence.minObservations": "Observaciones mínimas",
  "autoApproval.limits.evidence.minObservations.help":
    "Recibos con el mismo digest antes de aprobar.",
  "autoApproval.limits.evidence.minStableHours": "Horas mínimas estables",
  "autoApproval.limits.evidence.minStableHours.help":
    "O: visto por primera vez hace al menos estas horas, sin cambios.",
  "autoApproval.limits.evidence.maxPerRun": "Máximo por ejecución",
  "autoApproval.limits.evidence.maxPerRun.help":
    "Documentos evaluados por ejecución en esta etapa.",
  "autoApproval.limits.evidence.supportedActs": "Actos admitidos",
  "autoApproval.limits.evidence.supportedActs.help":
    "Tipos de acto oficial que la etapa puede aprobar.",
  "autoApproval.limits.facts.maxPerRun": "Máximo por ejecución",
  "autoApproval.limits.facts.maxPerRun.help": "Hechos evaluados por ejecución.",
  "autoApproval.limits.proposals.maxRateDeltaPp": "Delta máximo de alícuota",
  "autoApproval.limits.proposals.maxRateDeltaPp.help":
    "Mayor variación permitida en puntos porcentuales en alícuotas.",
  "autoApproval.limits.proposals.maxMvaDeltaPp": "Delta máximo de MVA",
  "autoApproval.limits.proposals.maxMvaDeltaPp.help":
    "Mayor variación permitida en puntos porcentuales en MVA.",
  "autoApproval.limits.proposals.maxAffectedRules": "Máximo de reglas afectadas",
  "autoApproval.limits.proposals.maxAffectedRules.help":
    "Reglas añadidas o cambiadas por una ejecución.",
  "autoApproval.limits.proposals.maxPerRun": "Máximo por ejecución",
  "autoApproval.limits.proposals.maxPerRun.help": "Propuestas evaluadas por ejecución.",
  "autoApproval.limits.proposals.allowDeletions": "Permitir exclusiones",
  "autoApproval.limits.proposals.allowDeletions.help":
    "Apagado por defecto. Un SUPERSEDE que quite familias o campos se retiene.",
  "autoApproval.limits.proposals.allowNewRules": "Permitir reglas nuevas",
  "autoApproval.limits.proposals.allowNewRules.help":
    "Si está apagado, los UPSERT nuevos se retienen.",
  "autoApproval.limits.publish.maxAddedRules": "Máximo de reglas añadidas",
  "autoApproval.limits.publish.maxAddedRules.help": "Techo del diff de publicación (añadidas).",
  "autoApproval.limits.publish.maxChangedRules": "Máximo de reglas cambiadas",
  "autoApproval.limits.publish.maxChangedRules.help": "Techo del diff de publicación (cambiadas).",
  "autoApproval.limits.publish.maxRemovedRules": "Máximo de reglas eliminadas",
  "autoApproval.limits.publish.maxRemovedRules.help":
    "Techo del diff de publicación (eliminadas). Por defecto 0.",
  "autoApproval.limits.publish.minDraftAgeMinutes": "Edad mínima del borrador",
  "autoApproval.limits.publish.minDraftAgeMinutes.help":
    "Minutos tras la aprobación más reciente antes de publicar.",
  "autoApproval.limits.publish.includeHumanApproved": "Incluir propuestas aprobadas por personas",
  "autoApproval.limits.publish.includeHumanApproved.help":
    "Apagado por defecto. Si se enciende, el borrador puede llevar aprobaciones humanas.",
  "autoApproval.limits.policy.targetPolicyVersion": "Política objetivo",
  "autoApproval.limits.policy.targetPolicyVersion.help":
    "Solo se usa cuando la etapa de política está encendida.",
  "autoApproval.unit.observations": "observaciones",
  "autoApproval.unit.hours": "horas",
  "autoApproval.unit.documents": "documentos",
  "autoApproval.unit.facts": "hechos",
  "autoApproval.unit.pp": "pp",
  "autoApproval.unit.rules": "reglas",
  "autoApproval.unit.proposals": "propuestas",
  "autoApproval.unit.minutes": "minutos",
  "autoApproval.preview.readonly": "Solo lectura: no se alteró nada.",
  "autoApproval.preview.run": "Vista previa ahora",
  "autoApproval.preview.generatedAt": "Generada el {when}",
  "autoApproval.preview.empty.title": "Aún no hay vista previa",
  "autoApproval.preview.empty.body":
    "Ejecute la vista previa para ver qué se aprobaría, certificaría o retendría ahora.",
  "autoApproval.preview.stats": "Resumen por etapa",
  "autoApproval.preview.stat.wouldAct": "se actuarían",
  "autoApproval.preview.stat.scope": "{held} retenidos · {candidates} candidatos",
  "autoApproval.preview.truncated": "Lista truncada por el techo de la ejecución",
  "autoApproval.preview.enabled.on": "Etapa encendida",
  "autoApproval.preview.enabled.off": "Etapa apagada",
  "autoApproval.preview.elapsed": "Tiempo {ms} ms",
  "autoApproval.preview.scenario.legend": "Escenario",
  "autoApproval.preview.scenario.current": "actual",
  "autoApproval.preview.scenario.all": "todo encendido (incluye la política)",
  "autoApproval.preview.canary.title": "Canario",
  "autoApproval.preview.canary.passed":
    "Canario aprobado: parity golden y replay sin regresiones inesperadas.",
  "autoApproval.preview.canary.failed": "Canario falló. Vea los fallos abajo.",
  "autoApproval.preview.canary.suites": "Suites golden",
  "autoApproval.preview.canary.suite": "Suite",
  "autoApproval.preview.canary.passedTotal": "Pasó / total",
  "autoApproval.preview.canary.replay":
    "Replay: {items} ítems · {unchanged} iguales · {expected} cambios esperados · {unexpected} regresiones",
  "autoApproval.preview.canary.failures": "Fallos del canario",
  "autoApproval.preview.canary.case": "Caso",
  "autoApproval.preview.canary.kind": "Tipo",
  "autoApproval.preview.canary.expectations": "Expectativas del dueño",
  "autoApproval.preview.canary.expectation.label": "Expectativa",
  "autoApproval.preview.canary.expectation.expected": "Esperado",
  "autoApproval.preview.canary.expectation.actual": "Calculado",
  "autoApproval.preview.canary.expectation.status": "Situación",
  "autoApproval.preview.canary.expectation.note": "Nota",
  "autoApproval.preview.canary.expectation.PASS": "Pasó",
  "autoApproval.preview.canary.expectation.FAIL": "Falló",
  "autoApproval.preview.canary.expectation.NOT_APPLICABLE": "No aplica",
  "autoApproval.canaryKind.GOLDEN_MISMATCH": "Divergencia golden",
  "autoApproval.canaryKind.UNEXPECTED_CHANGE": "Cambio inesperado",
  "autoApproval.canaryKind.STATUS_DOWNGRADE": "Bajada de estado",
  "autoApproval.canaryKind.REPLAY_MISMATCH": "Divergencia de replay",
  "autoApproval.preview.items.title": "Ítems evaluados",
  "autoApproval.preview.items.empty": "Ningún ítem en este filtro",
  "autoApproval.preview.items.emptyBody": "Ajuste el filtro de etapa o resultado.",
  "autoApproval.preview.filter.stage": "Etapa",
  "autoApproval.preview.filter.all": "Todas",
  "autoApproval.preview.filter.outcome": "Resultado",
  "autoApproval.preview.col.label": "Ítem",
  "autoApproval.preview.col.stage": "Etapa",
  "autoApproval.preview.col.outcome": "Resultado",
  "autoApproval.preview.col.reasons": "Criterios",
  "autoApproval.report.date": "Fecha",
  "autoApproval.report.timezone": "Zona America/Sao_Paulo",
  "autoApproval.report.stats": "Totales del día",
  "autoApproval.report.count.evidence": "Evidencias aprobadas",
  "autoApproval.report.count.facts": "Hechos certificados",
  "autoApproval.report.count.proposals": "Propuestas aprobadas",
  "autoApproval.report.count.policy": "Cambios de política",
  "autoApproval.report.count.published": "Versiones publicadas",
  "autoApproval.report.count.rollbacks": "Reversiones",
  "autoApproval.report.actions.title": "Acciones del día",
  "autoApproval.report.actions.empty": "Ninguna acción en este día.",
  "autoApproval.report.actions.time": "Hora",
  "autoApproval.report.actions.stage": "Etapa",
  "autoApproval.report.actions.outcome": "Resultado",
  "autoApproval.report.actions.label": "Ítem",
  "autoApproval.report.actions.criteria": "Criterios",
  "autoApproval.report.holds.title": "Retenidas (agrupadas)",
  "autoApproval.report.holds.empty": "Ninguna retención actual.",
  "autoApproval.report.holds.stage": "Etapa",
  "autoApproval.report.holds.reason": "Motivo",
  "autoApproval.report.holds.count": "Cant.",
  "autoApproval.report.holds.explanation": "Explicación",
  "autoApproval.report.breakers.title": "Disyuntores abiertos",
  "autoApproval.report.breakers.empty": "Ningún disyuntor abierto.",
  "autoApproval.report.runs.title": "Últimas ejecuciones",
  "autoApproval.report.runs.empty": "Ninguna ejecución registrada.",
  "autoApproval.report.runs.started": "Inicio",
  "autoApproval.report.runs.trigger": "Disparador",
  "autoApproval.report.runs.status": "Estado",
  "autoApproval.report.runs.acted": "Actuados",
  "autoApproval.report.runs.held": "Retenidos",
  "autoApproval.report.runs.errors": "Errores por etapa",
  "autoApproval.status.breakerNotice":
    "Publicación automática interrumpida: el canario post-publicación falló en {date} y se restauró la versión anterior. Para reanudar, encienda la etapa de nuevo con un motivo.",
  "autoApproval.criterion.STAGE_DISABLED": "Etapa apagada",
  "autoApproval.criterion.STAGE_DISABLED.tip": "La etapa está apagada en la configuración.",
  "autoApproval.criterion.KILL_SWITCH": "Interruptor general",
  "autoApproval.criterion.KILL_SWITCH.tip":
    "El interruptor general del entorno bloquea toda la pipeline.",
  "autoApproval.criterion.EVALUATION_FAILED": "Fallo de evaluación",
  "autoApproval.criterion.EVALUATION_FAILED.tip": "La evaluación falló por un error interno.",
  "autoApproval.criterion.LIMIT_REACHED": "Límite alcanzado",
  "autoApproval.criterion.LIMIT_REACHED.tip": "Se alcanzó el límite por ejecución.",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION": "Cambiado tras evaluación",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION.tip":
    "El recurso cambió después de la evaluación.",
  "autoApproval.criterion.SOURCE_REGISTERED": "Fuente registrada",
  "autoApproval.criterion.SOURCE_REGISTERED.tip": "La fuente está en el registro oficial revisado.",
  "autoApproval.criterion.URL_IN_REGISTRY": "URL en el registro",
  "autoApproval.criterion.URL_IN_REGISTRY.tip":
    "La URL canónica coincide con el host y el prefijo de la fuente.",
  "autoApproval.criterion.SOURCE_HEALTHY": "Fuente sana",
  "autoApproval.criterion.SOURCE_HEALTHY.tip": "La fuente está ACTIVE (no degradada).",
  "autoApproval.criterion.FETCH_OK": "Fetch ok",
  "autoApproval.criterion.FETCH_OK.tip": "Hay artefacto bruto y content_sha256.",
  "autoApproval.criterion.DIGEST_STABLE": "Digest estable",
  "autoApproval.criterion.DIGEST_STABLE.tip":
    "El digest se repitió lo suficiente o se mantuvo estable.",
  "autoApproval.criterion.ACT_SUPPORTED": "Acto admitido",
  "autoApproval.criterion.ACT_SUPPORTED.tip": "El tipo de acto está en la lista admitida.",
  "autoApproval.criterion.EVIDENCE_APPROVED": "Evidencia aprobada",
  "autoApproval.criterion.EVIDENCE_APPROVED.tip": "Toda evidencia vinculada está APPROVED.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT": "Concordancia independiente",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE": "Vigencia completa respaldada",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE.tip":
    "Las fuentes deben respaldar todo el período de vigencia propuesto.",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY": "Aplicabilidad verificada",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY.tip":
    "La evidencia guardada debe respaldar el producto, la ruta, las condiciones de la operación y los parámetros fiscales exactos. Un documento aprobado por sí solo no basta.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT.tip":
    "Hay concordancia de una fuente independiente.",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT": "Sin conflicto certificado",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT.tip": "No hay un hecho certificado en conflicto.",
  "autoApproval.criterion.NO_DRIFT": "Sin drift",
  "autoApproval.criterion.NO_DRIFT.tip": "No está en la lista de drift de Verificación.",
  "autoApproval.criterion.DRY_RUN_VALID": "Dry-run válido",
  "autoApproval.criterion.DRY_RUN_VALID.tip": "La simulación en el borrador valida bien.",
  "autoApproval.criterion.NO_PENDING_OVERLAP": "Sin solapamiento pendiente",
  "autoApproval.criterion.NO_PENDING_OVERLAP.tip": "No hay otra propuesta pendiente superpuesta.",
  "autoApproval.criterion.WITHIN_THRESHOLDS": "Dentro de los límites",
  "autoApproval.criterion.WITHIN_THRESHOLDS.tip": "Los deltas caben en los techos.",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP": "Delta de alícuota ok",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP.tip": "La variación de alícuota cabe en el techo.",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP": "Delta de MVA ok",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP.tip": "La variación de MVA cabe en el techo.",
  "autoApproval.criterion.NO_DELETION": "Sin exclusión",
  "autoApproval.criterion.NO_DELETION.tip": "Las exclusiones están apagadas en este límite.",
  "autoApproval.criterion.NEW_RULES_ALLOWED": "Reglas nuevas permitidas",
  "autoApproval.criterion.NEW_RULES_ALLOWED.tip": "Se permiten reglas nuevas (UPSERT).",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP": "Reglas afectadas ok",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP.tip":
    "Las reglas afectadas caben en el techo de la ejecución.",
  "autoApproval.criterion.POLICY_UNCHANGED": "Política sin cambios",
  "autoApproval.criterion.POLICY_UNCHANGED.tip":
    "La propuesta no exige otra política del borrador.",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY": "Esperando dependencia",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY.tip":
    "Espera un SUPERSEDE pendiente en la misma ejecución.",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN": "Política exige humano",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN.tip":
    "Cambiar la política exige la etapa 5 o una persona.",
  "autoApproval.criterion.TARGET_POLICY_READY": "Política objetivo lista",
  "autoApproval.criterion.TARGET_POLICY_READY.tip": "La política objetivo necesita readiness cero.",
  "autoApproval.criterion.DRAFT_PRESENT": "Borrador presente",
  "autoApproval.criterion.DRAFT_PRESENT.tip":
    "Hay borrador con propuestas aprobadas y base actual.",
  "autoApproval.criterion.BASE_CURRENT": "Base actual",
  "autoApproval.criterion.BASE_CURRENT.tip": "La base del borrador es la versión activa.",
  "autoApproval.criterion.READINESS_ZERO": "Readiness cero",
  "autoApproval.criterion.READINESS_ZERO.tip":
    "La readiness de la política del borrador tiene 0 violaciones.",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS": "Diff en los límites",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS.tip":
    "El diff del borrador cabe en los techos de publicación.",
  "autoApproval.criterion.ONLY_AUTO_APPROVED": "Solo autoaprobadas",
  "autoApproval.criterion.ONLY_AUTO_APPROVED.tip":
    "Solo entran propuestas aprobadas por el actor del sistema.",
  "autoApproval.criterion.COOLING_OFF": "Enfriamiento",
  "autoApproval.criterion.COOLING_OFF.tip":
    "Aún no pasó el tiempo mínimo tras la última aprobación.",
  "autoApproval.criterion.CANARY_PASSED": "Canario ok",
  "autoApproval.criterion.CANARY_PASSED.tip": "El canario (golden + replay) pasó.",
  "autoApproval.criterion.BREAKER_TRIPPED": "Disyuntor abierto",
  "autoApproval.criterion.BREAKER_TRIPPED.tip": "El disyuntor de publicación está abierto.",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED": "Canario post-publicación ok",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED.tip":
    "El canario post-publicación confirmó la versión activa.",
  "autoApproval.act.LEI": "LEI",
  "autoApproval.act.LEI_COMPLEMENTAR": "LEI COMPLEMENTAR",
  "autoApproval.act.DECRETO": "DECRETO",
  "autoApproval.act.RICMS": "RICMS",
  "autoApproval.act.PORTARIA": "PORTARIA",
  "autoApproval.act.RESOLUCAO": "RESOLUCAO",
  "autoApproval.act.INSTRUCAO_NORMATIVA": "INSTRUCAO NORMATIVA",
  "autoApproval.act.CONVENIO_ICMS": "CONVENIO ICMS",
  "autoApproval.act.PROTOCOLO_ICMS": "PROTOCOLO ICMS",
  "autoApproval.act.AJUSTE_SINIEF": "AJUSTE SINIEF",
  "autoApproval.act.ATO_COTEPE": "ATO COTEPE",
  "autoApproval.act.DECISAO_NORMATIVA": "DECISAO NORMATIVA",
  "autoApproval.act.COMUNICADO": "COMUNICADO",
  "autoApproval.act.TIPI": "TIPI",
  "driveWatch.title": "Monitor del Drive comercial",
  "driveWatch.summary": "Consulta versiones y cambios en la carpeta de referencia comercial.",
  "driveWatch.boundary":
    "Sólo metadatos. Este monitor no descarga planillas ni aprueba o publica reglas fiscales.",
  "driveWatch.disabled":
    "El monitor automático está desactivado. Esta carpeta aún no tiene seguimiento activo.",
  "driveWatch.scope":
    "Alcance: archivos directamente en la carpeta; se excluye el contenido de subcarpetas. El historial anterior al primer escaneo no está confirmado.",
  "driveWatch.schedule":
    "Verificación diaria mediante el horario de investigación. La conciliación mensual queda pendiente desde el día 1 a las 06:00 de Brasilia y se ejecuta en el siguiente disparo disponible.",
  "driveWatch.openFolder": "Abrir carpeta de referencia",
  "driveWatch.lastCompleted": "Último escaneo completo · Brasilia",
  "driveWatch.observed": "Archivos en el último escaneo completo",
  "driveWatch.nextCheck": "Próxima verificación elegible · Brasilia",
  "driveWatch.nextMonthly": "Conciliación mensual elegible · Brasilia",
  "driveWatch.lastAttempt": "Último intento: {date}",
  "driveWatch.retryAt": "Reanudar a partir de {date}",
  "driveWatch.noRun":
    "Aún no hay escaneos registrados. La ausencia de datos no significa cero archivos.",
  "driveWatch.files": "Metadatos del último escaneo completo",
  "driveWatch.comparison":
    "{added} nuevos · {changed} con cambios de metadatos · {absent} no observados. La ausencia no confirma eliminación. Contenido no descargado.",
  "driveWatch.file": "ID del archivo",
  "driveWatch.version": "Versión de Drive",
  "driveWatch.change": "Comparación",
  "driveWatch.observedAt": "Observado el · Brasilia",
  "driveWatch.status.DISABLED": "Desactivado",
  "driveWatch.status.FAILED": "Requiere atención",
  "driveWatch.status.RUNNING": "Escaneando",
  "driveWatch.status.PAUSED": "Esperando reanudación",
  "driveWatch.status.ACTIVE": "Monitoreando",
  "driveWatch.status.WAITING": "Esperando primer escaneo",
  "driveWatch.change.NEWLY_OBSERVED": "Nuevo observado",
  "driveWatch.change.METADATA_CHANGED": "Metadatos modificados",
  "driveWatch.change.UNCHANGED": "Sin cambios",
  "driveWatch.change.NOT_OBSERVED": "No observado",
  "driveWatch.run.RUNNING": "En ejecución",
  "driveWatch.run.RETRY_PENDING": "Reintento pendiente",
  "driveWatch.run.PAUSED": "Pausado",
  "driveWatch.run.COMPLETED": "Completado",
  "driveWatch.run.FAILED": "Falló",
  "driveWatch.run.SUPERSEDED": "Sustituido por otra configuración",
  "driveWatch.error.PAGE_TOKEN_REJECTED": "Cursor rechazado; se requiere un escaneo nuevo",
  "driveWatch.error.CAPACITY_EXCEEDED": "Se alcanzó el límite de páginas; requiere revisión",
  "driveWatch.error.AUTHENTICATION_FAILED": "Autenticación del proceso no disponible",
  "driveWatch.error.ACCESS_DENIED": "Sin permiso para listar la carpeta",
  "driveWatch.error.NOT_FOUND": "Carpeta no encontrada",
  "driveWatch.error.API_DISABLED": "API de Drive desactivada",
  "driveWatch.error.RATE_LIMITED": "Límite de Drive alcanzado",
  "driveWatch.error.NETWORK_ERROR": "Falló la conexión con Drive",
  "driveWatch.error.TIMEOUT": "Se agotó el tiempo de Drive",
  "driveWatch.error.INVALID_RESPONSE": "Respuesta de Drive inválida",
  "driveWatch.error.PAGINATION_CYCLE": "Paginación repetida; escaneo detenido",
  "driveWatch.error.INCOMPLETE_SEARCH": "Listado incompleto; comparación no completada",
  "driveWatch.error.LEASE_LOST": "Otro proceso controla la ejecución",
  "driveWatch.error.BUDGET_EXCEEDED": "Se alcanzó el límite de ejecución",
  "driveWatch.error.INTERNAL_ERROR": "Fallo interno; requiere revisión",
  "autonomousResearch.title": "Investigación autónoma",
  "autonomousResearch.summary":
    "En cada ciclo, la plataforma elige las brechas más importantes e investiga por su cuenta, dentro del presupuesto. Nada se aprueba ni se publica automáticamente.",
  "autonomousResearch.status.active": "Activa",
  "autonomousResearch.status.disabled": "Apagada",
  "autonomousResearch.status.failed": "Falló en la última ejecución",
  "autonomousResearch.kpi.lastRun": "Última ejecución",
  "autonomousResearch.kpi.nextRun": "Próxima ejecución",
  "autonomousResearch.kpi.spend": "Gasto estimado hoy",
  "autonomousResearch.kpi.spendOf": "de {cap}",
  "autonomousResearch.kpi.queued": "Elementos en cola",
  "autonomousResearch.kpi.noRun": "Ninguna ejecución todavía",
  "autonomousResearch.queuedSplit":
    "Brechas: {gaps} · Investigaciones web: {web} · Preguntas: {questions}",
  "autonomousResearch.rows": "{count} filas de cálculo",
  "autonomousResearch.forcedHint":
    "Investigado de nuevo dentro de la ventana de reutilización porque el último resultado fue vacío o no concluyente.",
  "autonomousResearch.brasiliaTime": "Hora de Brasilia",
  "autonomousResearch.nextUnknown": "La hora de la próxima ejecución no está disponible",
  "autonomousResearch.run.RUNNING": "En ejecución",
  "autonomousResearch.run.COMPLETED": "Concluida",
  "autonomousResearch.run.DISABLED": "No encoló",
  "autonomousResearch.run.FAILED": "Falló",
  "autonomousResearch.duration.seconds": "{seconds} s",
  "autonomousResearch.duration.minutes": "{minutes} min {seconds} s",
  "autonomousResearch.limits":
    "Hasta {max} elementos por ejecución · espera tras {after} resultados inconclusos, durante {days} días · reutiliza durante {reuse} días",
  "autonomousResearch.disabled":
    "La investigación autónoma está apagada por el interruptor. La ejecución diaria puede continuar, pero no pone nada en cola.",
  "autonomousResearch.empty": "Aún no hay ninguna ejecución. La primera ocurre el {when}.",
  "autonomousResearch.emptyNoWhen":
    "Aún no hay ninguna ejecución. La primera ocurre en el próximo horario programado.",
  "autonomousResearch.items.title": "Elementos de esta ejecución ({count})",
  "autonomousResearch.items.caption": "Elementos de la última ejecución",
  "autonomousResearch.items.empty": "Esta ejecución no registró elementos.",
  "autonomousResearch.items.tier": "Prioridad",
  "autonomousResearch.items.path": "Camino",
  "autonomousResearch.items.target": "Objetivo",
  "autonomousResearch.items.estimate": "Estimación",
  "autonomousResearch.items.outcome": "Resultado",
  "autonomousResearch.tier.PRIORITY_ROUTE": "Ruta prioritaria",
  "autonomousResearch.tier.LOT_GAP": "Lote real",
  "autonomousResearch.tier.NATIONAL_BASE": "Base nacional",
  "autonomousResearch.path.CALCULATOR_RESEARCH": "Brecha",
  "autonomousResearch.path.WEB_RESEARCH_SWEEP": "Investigación web",
  "autonomousResearch.path.AGENT_QUESTION": "Pregunta",
  "autonomousResearch.outcome.QUEUED": "En cola",
  "autonomousResearch.outcome.REUSED": "Reutilizado",
  "autonomousResearch.outcome.JOINED_ACTIVE": "Ya en curso",
  "autonomousResearch.outcome.SKIPPED_BUDGET": "Sin presupuesto",
  "autonomousResearch.outcome.SKIPPED_MAX_ITEMS": "Límite de elementos",
  "autonomousResearch.outcome.SKIPPED_BACKOFF": "En espera (hasta {date})",
  "autonomousResearch.outcome.SKIPPED_UNAVAILABLE": "No disponible",
  "autonomousResearch.outcome.FAILED": "Falló",
  "autonomousResearch.forced": "reforzado",
  "autonomousResearch.link.request": "Abrir solicitud",
  "autonomousResearch.link.sweep": "Abrir investigación",
  "autonomousResearch.link.task": "Abrir tarea",
  "autonomousResearch.history.title": "Ejecuciones recientes",
  "autonomousResearch.history.date": "Fecha",
  "autonomousResearch.history.queued": "En cola",
  "autonomousResearch.history.spend": "Gasto estimado",
  "autonomousResearch.meter": "Gasto estimado de hoy respecto del límite diario",
  "autonomousResearch.loading": "Cargando la investigación autónoma",
  "autonomousResearch.runSpend": "{amount} en esta ejecución",
  "autonomousResearch.route": "{origin} → {destination}",
  "acquisitionSettings.title": "Régimen fiscal de adquisición · SP",
  "acquisitionSettings.description":
    "Política de la entidad que compra para el centro de São Paulo. Confirma el régimen y los créditos con contabilidad; la clasificación y los beneficios de cada producto siguen vinculados a sus evidencias.",
  "acquisitionSettings.entity": "Entidad",
  "acquisitionSettings.chooseEntity": "Selecciona la entidad",
  "acquisitionSettings.warehouse": "Centro de compra",
  "acquisitionSettings.regime": "Régimen PIS/COFINS",
  "acquisitionSettings.regime.UNKNOWN": "Sin confirmar",
  "acquisitionSettings.regime.NON_CUMULATIVE": "No cumulativo",
  "acquisitionSettings.regime.CUMULATIVE": "Cumulativo",
  "acquisitionSettings.credit": "Crédito ordinario de adquisición",
  "acquisitionSettings.credit.UNCONFIRMED": "Sin confirmar",
  "acquisitionSettings.credit.ELIGIBLE": "Elegible, confirmado por contabilidad",
  "acquisitionSettings.credit.INELIGIBLE": "No elegible",
  "acquisitionSettings.creditHint":
    "El crédito ordinario exige el régimen no cumulativo. La aplicabilidad al producto también se verifica en el cálculo.",
  "acquisitionSettings.validFrom": "Válido desde",
  "acquisitionSettings.validTo": "Válido hasta",
  "acquisitionSettings.validToHint": "Opcional. En blanco: sin fecha final declarada.",
  "acquisitionSettings.reference": "Referencia de la confirmación contable",
  "acquisitionSettings.referenceHint":
    "Indica la referencia y la confirmación recibida de contabilidad (10 a 1.000 caracteres).",
  "acquisitionSettings.revision": "Revisión",
  "acquisitionSettings.confirmedAt": "Confirmado el",
  "acquisitionSettings.unconfigured":
    "Esta entidad aún no tiene una política fiscal confirmada. No se ha supuesto ningún régimen.",
  "acquisitionSettings.save": "Confirmar política fiscal",
  "acquisitionSettings.saved": "Política fiscal confirmada",
  "acquisitionSettings.reload": "Descartar edición y recargar",
  "acquisitionSettings.conflict":
    "La política cambió mientras editabas. Recarga la revisión actual antes de confirmar de nuevo.",
  "acquisitionSettings.invalidWindow": "La fecha final debe ser igual o posterior a la inicial.",
  "acquisitionSettings.historyHint":
    "Cada confirmación crea una revisión y una auditoría. Los cálculos guardados conservan sus datos y valores.",
  "publication.form.title": "Objetivo del cálculo",
  "publication.form.intent": "Calcular para",
  "publication.form.taxes": "Impuestos y escenario de venta",
  "publication.form.purchase": "Precio de publicación (compra)",
  "publication.form.takeRate": "Take rate de la oferta (%)",
  "publication.form.goodsOriginScope":
    "Completa solamente los productos sin este código en el Excel. Es el origen fiscal de la mercancía, distinto del estado del proveedor; se conservan los códigos por producto.",
  "publication.form.hint":
    "Desde 0% hasta menos del 100%, sin redondear. En esta oferta, los gastos adicionales de adquisición y de la base ST son cero.",
  "publication.form.source":
    "Take rate identificado en {cell}; confirma o modifica el valor antes de importar.",
  "publication.form.rateError":
    "Indica un take rate desde 0% hasta menos del 100%, con un máximo de 16 decimales.",
  "publication.form.unitRequired":
    "Declara el costo por unidad comercial o mapea la columna que indica la base del valor. El modo de publicación requiere UNIT en cada producto.",
  "publication.form.declarations":
    "Este modo declara una compra de mercancías para reventa por un establecimiento contribuyente de ICMS. Confirma abajo el proveedor, la composición del costo, la situación de ST y el régimen. El consumo propio y los activos fijos requieren otro cálculo.",
  "publication.form.saved":
    "Take rate: {rate}%. Compra hasta SP. Gastos adicionales: {charges}; adicionales de la base ST: {stBase}. El destino y los impuestos de la reventa se tratarán cuando haya un comprador.",
  "publication.title": "Adquisición y precio para publicación",
  "publication.scope":
    "Compra hasta SP. El precio de la oferta incluye el take rate informado. Los impuestos de reventa dependen del comprador y se calcularán cuando se conozca el destino.",
  "publication.supplierIpi.comparison": "Revisión del IPI informado",
  "publication.supplierIpi.incomplete":
    "Falta el origen del IPI informado. Para industria, indica la tasa y el importe unitario en N y O, conservando sus celdas de origen en el cálculo.",
  "publication.supplierIpi.source": "Origen del IPI",
  "publication.supplierIpi.rate": "Tasa informada",
  "publication.supplierIpi.amount": "Importe informado",
  "publication.supplierIpi.computed": "Importe según la tasa informada",
  "publication.supplierIpi.qualifiedRate": "Tasa fiscal de referencia",
  "publication.supplierIpi.rateCell": "Celda de la tasa",
  "publication.supplierIpi.amountCell": "Celda del importe",
  "publication.supplierIpi.delta": "Diferencia exacta",
  "publication.supplierIpi.tolerance": "Límite de representación numérica",
  "publication.supplierIpi.declared": "Informado por el proveedor",
  "publication.supplierIpi.amountFormula": "IPI unitario informado por el proveedor",
  "publication.supplierIpi.rateFormula": "Precio NF × tasa de IPI informada",
  "publication.supplierIpi.comparisonFormula":
    "Comparar el importe informado con precio NF × tasa, conservando el importe original",
  "publication.supplierIpi.conflict":
    "IPI Valor no coincide con el precio NF y la tasa informada. Corrige N y O antes de publicar el precio.",
  "publication.supplierIpi.distributorConflict":
    "El perfil de distribuidor común no admite cobrar IPI. Revisa el proveedor y los importes informados.",
  "publication.supplierIpi.exact": "Los valores coinciden",
  "publication.supplierIpi.representation":
    "Diferencia de representación de Excel; importe informado conservado",
  "publication.supplierIpi.savedTitle": "Declaración guardada de IPI",
  "publication.supplierIpi.savedPending":
    "IPI informado por el proveedor en la entrada guardada. La calificación fiscal sigue pendiente; estos valores no son impuesto calculado ni precio de publicación.",
  "publication.supplierIpi.savedPrecision":
    "Decimales de la entrada guardada, sin redondeo: alícuota en fracción y valor en BRL por unidad comercial.",
  "publication.supplierIpi.notice":
    "El IPI utilizado fue informado por el proveedor. Su tasa, importe y celdas de origen aparecen en el detalle; una tasa fiscal de referencia no sustituye esta declaración.",
  "publication.pending":
    "La calificación de la adquisición aún está incompleta. Los valores de publicación se mostrarán cuando se resuelvan los datos fiscales necesarios.",
  "publication.pending.ncm":
    "Todavía falta identificar el NCM de este producto. Es una etapa de clasificación, no una alícuota adicional.",
  "publication.pending.ipiPredicate":
    "Una característica de este modelo puede cambiar el IPI. Falta resolver la condición aplicable, sin asumir la alícuota genérica.",
  "publication.pending.purchaseRule":
    "Todavía falta una regla de ICMS/ST aplicable a esta compra. Una regla de otro estado de origen no sustituye la de esta ruta.",
  "publication.pending.goodsOrigin":
    "Confirma el código fiscal de origen de la mercancía (0–8, primer dígito del CST brasileño) para calcular el precio de publicación. Este código es distinto del estado de origen de la compra (UF), como MG.",
  "publication.principalUnit": "Precio negociado · unidad",
  "publication.acquisitionUnit": "Costo de adquisición · unidad",
  "publication.listingUnit": "Precio para publicación · unidad",
  "publication.listingLot": "Precio para publicación · lote",
  "publication.creditUnit": "Crédito PIS/COFINS · unidad",
  "publication.netAfterContributions": "Costo tras crédito PIS/COFINS · unidad",
  "publication.creditUnconfirmed": "Sin confirmar",
  "publication.creditUnconfirmedHint":
    "El crédito PIS/COFINS aún no está confirmado. Los importes de PIS y COFINS son referencias calculadas por el régimen y no acreditan un crédito recuperable. El precio de publicación usa el costo de adquisición y el take rate, sin descontar créditos.",
  "publication.precision":
    "{digits} cifras significativas, sin redondeo intermedio a centavos. Se muestran todos los dígitos guardados.",
  "publication.inputs": "Entradas de cada paso",
  "publication.evidence": "Evidencias de adquisición",
  "publication.distributorIpi": "Distribuidor ordinario: sin IPI separado",
  "publication.formula.fcpNotApplicableToResale":
    "No aplicable a la adquisición MG → SP para reventa sin ST.",
  "publication.treatment.NOT_APPLICABLE_TO_RESALE": "No aplicable a la reventa",
  "publication.supplier.INDUSTRY": "Industria",
  "publication.supplier.DISTRIBUTOR": "Distribuidor",
  "publication.step.ownIcms": "ICMS propio de la compra",
  "publication.step.pisCofinsBase": "Base de PIS/COFINS: principal menos ICMS",
  "publication.step.pis": "PIS de la compra",
  "publication.step.cofins": "COFINS de la compra",
  "publication.step.ipi": "IPI sobre el precio principal",
  "publication.step.mva": "MVA aplicada",
  "publication.step.stBase": "Base de ICMS-ST, con IPI",
  "publication.step.icmsSt": "ICMS-ST de la compra",
  "publication.step.fcpSt": "FCP-ST de la compra",
  "publication.step.fcp": "FCP de la compra",
  "publication.step.acquisitionCost": "Costo de adquisición",
  "publication.step.listingPrice": "Precio para publicación con take rate",
  "publication.input.intraRate": "Carga interna usada en el ajuste",
  "publication.input.nominalInternalRate": "Tasa interna nominal del débito ST",
  "publication.input.ignoredMaterializedMva": "MVA materializada no utilizada",
  "publication.input.acquisitionMvaMode": "Modo de cálculo de MVA",
  "publication.input.sourcePolicyVersion": "Política de la versión de reglas",
  "publication.input.intraSource": "Fuente de la carga interna",
  "publication.input.reason": "Motivo del ajuste",
  "publication.input.warning": "Aviso",
  "publication.mva.mode.EXACT_ACQUISITION": "Adquisición con precisión completa",
  "publication.mva.intraSource.RULE": "Carga efectiva publicada",
  "publication.mva.intraSource.NOMINAL_NOT_INFORMED": "Nominal: carga efectiva no informada",
  "publication.mva.intraSource.NOMINAL_OUT_OF_VALIDITY":
    "Nominal: carga efectiva fuera de vigencia",
  "publication.mva.reason.ADJUSTED": "Carga interna superior a la interestatal",
  "publication.mva.reason.NOT_INTERSTATE": "Operación interna",
  "publication.mva.reason.INTRA_NOT_GREATER_THAN_INTER":
    "La carga interna no supera la interestatal",
  "publication.mva.warning.nominalNotInformed":
    "Carga efectiva no informada; se usa la tasa interna nominal.",
  "publication.mva.warning.nominalOutOfValidity":
    "Carga efectiva fuera de vigencia; se usa la tasa interna nominal.",
  "publication.formula.mvaEffectiveIntra":
    "((1 + MVA original) × (1 − tasa interestatal) ÷ (1 − carga interna del ajuste)) − 1",
  "publication.formula.fcpNotApplicableToResaleRoute":
    "No aplicable a la adquisición {origin} → {destination} para reventa, sin ST.",
  "recalculateLot.change.SUPPLIER_IPI_PUBLICATION":
    "Adquisición interestatal hacia SP con IPI declarado y MVA según el tratamiento publicado, sin redondeo intermedio; sigue siendo necesaria la autoridad fiscal vigente.",
  "proposals.create.noAdditionalEvidence":
    "No hay otros documentos aprobados en esta página. Cambia la búsqueda o consulta las siguientes páginas.",
  "publication.input.principal": "Precio principal",
  "publication.input.ownIcmsRate": "Alícuota ICMS propio",
  "publication.input.ownIcms": "ICMS propio",
  "publication.input.pisCofinsBase": "Base PIS/COFINS",
  "publication.input.pisRate": "Alícuota PIS",
  "publication.input.cofinsRate": "Alícuota COFINS",
  "publication.input.ipiRate": "Alícuota IPI",
  "publication.input.ipi": "IPI",
  "publication.input.originalMva": "MVA original",
  "publication.input.interstateRate": "Alícuota interestatal",
  "publication.input.internalRate": "Alícuota interna",
  "publication.input.additionalStBase": "Otros importes de la base ST",
  "publication.input.appliedMva": "MVA aplicada",
  "publication.input.stBase": "Base ICMS-ST",
  "publication.input.fcpRate": "Alícuota FCP",
  "publication.input.acquisitionCharges": "Cargos de adquisición",
  "publication.input.acquisitionCost": "Costo de adquisición",
  "publication.input.takeRate": "Take rate",
  "publication.input.icmsSt": "ICMS-ST",
  "publication.input.fcp": "FCP",
  "publication.input.supplierType": "Tipo de proveedor",
  "publication.input.legalReference": "Fundamento legal",
  "publication.input.sourceUrl": "Fuente oficial",
  "publication.input.treatment": "Tratamiento fiscal",
  "recalculation.basis.RESEARCH":
    "Recalculado con los datos fiscales resueltos por la investigación",
  "publication.latestTask":
    "Hay un cálculo más reciente de esta planilla. Este registro conserva la versión anterior.",
  "publication.openLatest": "Ver cálculo actualizado",
  "lotOps.group.publication": "Precio para publicación",
  "publication.summary.title": "De la compra a la publicación",
  "publication.summary.cost": "Costo de adquisición del lote",
  "publication.summary.listing": "Precio de publicación con TR",
  "publication.summary.take": "Importe del take rate",
  "publication.summary.counts":
    "{confirmed} calculadas · {estimated} estimadas · {unpriced} sin cotización",
  "publication.summary.split": "Publicación: calculadas {confirmed} · estimadas {estimated}",
  "publication.summary.scope":
    "Cotización de la compra hasta SP, con take rate. Los valores estimados incluyen supuestos y no son impuestos confirmados. No se descuentan créditos sin confirmar ni impuestos de la futura venta al destino.",
  "publication.estimate.memory": "Memoria de cálculo del escenario estimado",
  "publication.estimate.title": "Cotización con supuestos",
  "publication.estimate.short": "Estimado",
  "publication.estimate.notice":
    "Precio estimado para cotización. Se seleccionó el mayor precio entre los escenarios evaluados. Los atributos indicados necesitan confirmación; el resultado fiscal sigue en revisión.",
  "publication.estimate.cost": "Costo unitario estimado",
  "publication.estimate.price": "Precio unitario estimado con take rate",
  "publication.estimate.range": "Rango de precios de los escenarios",
  "publication.estimate.selection": "Escenario utilizado",
  "publication.estimate.assumptions": "Supuestos e impacto en el precio",
  "publication.estimate.source": "Consultar fuente",
  "publication.estimate.scenarios": "Escenarios de la cotización",
  "publication.estimate.scenario": "Escenario",
  "publication.estimate.selected": "utilizado",
  "publication.estimate.tableHint":
    "Hay {count} productos con precio estimado y supuestos explícitos. Esos valores no integran los totales fiscales confirmados; abre el producto para comparar escenarios.",
};
